webpackJsonp([22],{

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var processNextTick = __webpack_require__(302);
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(269);
util.inherits = __webpack_require__(59);
/*</replacement>*/

var Readable = __webpack_require__(355);
var Writable = __webpack_require__(305);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Item = __webpack_require__(34);
var Seller = __webpack_require__(103);
var User = __webpack_require__(28);
var AnchorLists = __webpack_require__(120);
var Conversation = __webpack_require__(133);
var Deferred = __webpack_require__(29).Deferred;

module.exports = {
    loadItem: function loadItem(itemPk) {
        var item = new Item({ id: itemPk });
        return item.fetch({ data: { fields: 'full,sellerInfo,key' } }).then(function () {
            return {
                item: item,
                seller: item.get('seller')
            };
        });
    },
    loadSeller: function loadSeller(sellerPk, preloadedSeller) {
        if (preloadedSeller) {
            return Deferred().resolve({ seller: preloadedSeller });
        }
        var seller = new Seller({ id: sellerPk });
        return seller.fetch({ data: { fields: Seller.FIELD_PREFERENCE } }).then(function () {
            return { seller: seller };
        });
    },


    /**
     * returns {Object} Deferred resolving to user model if user is authenticated
     */
    loadUser: function loadUser() {
        // note: User.gotCurrentUser will return a user model with id='me' if none was found
        return User.gotCurrentUser().then(function (user) {
            return (/\d/.test(user.id) ? user : null
            );
        });
    },


    // save inserted name to user's profile if they don't already have one set
    saveName: function saveName(options) {
        var userProfile = options.userProfile,
            fullName = options.fullName;

        if (!userProfile.get('firstName') && !userProfile.get('lastName')) {
            return userProfile.setDisplayName(fullName).save();
        }
        return Deferred().resolve();
    },


    /**
     * returns {Object} Deferred resolving to true if the user is able to opt in to
     * sharing their email address
     */
    checkEmailOptIn: function checkEmailOptIn(options) {
        var dealerId = options.dealerId,
            itemId = options.itemId;

        var anchorLists = new AnchorLists();
        var conversation = new Conversation();
        return anchorLists.fetchSellerOnList(dealerId, AnchorLists.listNames.OPOP, 'SELLER_POLICY').then(function () {
            // do not show opt in if dealer is on new policy
            if (anchorLists.length > 0) {
                return false;
            }
            if (!User.getUserId()) {
                // buyer is logged out -- will not check conversation history
                return true;
            }
            // general inquiry
            if (!itemId) {
                return true;
            }
            return conversation.fetchConversationForBuyerAndItem({
                buyerId: User.getUserId(),
                itemId: itemId
            }).then(
            // conversation exists between this buyer/item - user cannot opt in
            function () {
                return false;
            },
            // if conversation is not found - user can opt in
            function (response) {
                return Deferred().resolve(response.status === 404);
            });
        }, function () {
            return Deferred().resolve(false);
        });
    },
    constructItemSubject: function constructItemSubject(options) {
        var prefix = options.prefix,
            item = options.item;

        return [prefix, item.get('title'), item.get('dibsReference')].join(' - ');
    }
};

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var PrivateTransaction = __webpack_require__(236);
var TransactionValidator = __webpack_require__(129);
var Party = __webpack_require__(8);

var ContactTransactionStore = function (_BaseStore) {
    _inherits(ContactTransactionStore, _BaseStore);

    function ContactTransactionStore() {
        _classCallCheck(this, ContactTransactionStore);

        return _possibleConstructorReturn(this, (ContactTransactionStore.__proto__ || Object.getPrototypeOf(ContactTransactionStore)).apply(this, arguments));
    }

    _createClass(ContactTransactionStore, [{
        key: 'doneLoading',
        value: function doneLoading(payload) {
            var user = payload.user,
                item = payload.item;

            if (!item) {
                return;
            }
            this.transaction = new PrivateTransaction({
                buyer: user,
                seller: item.get('seller'),
                item: item
            });
            this.offer = this.transaction.get('offers[0]');
            if (user) {
                this.offer.set('amountPerItem.currency', user.get('profile.currency'));
            } else {
                this.offer.set('initiatingParty', new Party({ role: Party.ROLE_BUYER }));
                this.offer.set('amountPerItem.currency', this.dispatcher.getStore('UserStore').getCurrency());
            }
            this.emitChange();
        }
    }, {
        key: 'editOffer',
        value: function editOffer(payload) {
            this.offer.set(payload.field, payload.value);
            this.emitChange();
        }
    }, {
        key: 'userAuth',
        value: function userAuth(_ref) {
            var user = _ref.user,
                _ref$isTransaction = _ref.isTransaction,
                isTransaction = _ref$isTransaction === undefined ? true : _ref$isTransaction;

            if (!this.transaction) {
                return;
            }
            if (isTransaction) {
                this.transaction.set('buyer', user);
                this.emitChange();
            }
        }
    }, {
        key: 'prepareToSave',
        value: function prepareToSave() {
            if (!this.transaction) {
                return;
            }
            this.offer.set('amountPerItem.amount', new TransactionValidator().parseOffer(this.transaction) + '');
            this.transaction.prepareToSaveBuyer();
        }
    }]);

    return ContactTransactionStore;
}(BaseStore);

ContactTransactionStore.storeName = 'ContactTransactionStore';
ContactTransactionStore.handlers = {
    'contact:loading:done': 'doneLoading',
    'contact:offer:fieldEdited': 'editOffer',
    'contact:auth:done': 'userAuth',
    'contact:form:offer:valid': 'prepareToSave',
    'pdp:contact:loading:done': 'doneLoading'
};

module.exports = ContactTransactionStore;

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 7/27/15.
 */



var _CartStore$handlers;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var ProxiedCartCollection = __webpack_require__(146);
var CartPortfolioModel = __webpack_require__(293);
var enabler = __webpack_require__(64);
var User = __webpack_require__(15);
var chatUtils = __webpack_require__(272);
var currencyActionConstants = __webpack_require__(292);

var MAX_CART_COUNT = 9;

var CartStore = function (_BaseStore) {
    _inherits(CartStore, _BaseStore);

    function CartStore(dispatcher) {
        _classCallCheck(this, CartStore);

        var _this = _possibleConstructorReturn(this, (CartStore.__proto__ || Object.getPrototypeOf(CartStore)).call(this, dispatcher));

        _this._errorMessage = null;
        /*  This should maybe be moved to an action for server-side rendering since it makes use of User */
        _this._cartItems = ProxiedCartCollection.getCartCollection();
        _this._recentItems = [];
        _this._portfolioModel = new CartPortfolioModel();
        _this._currency = 'USD';
        _this._isDisplayingNotification = false;

        /*
         Listen to any events on the backbone model. This could potentially cause
         a memory leak if these events never get unregistered, so might need to revisit this
          TODO:  make this an action that registers this event handler
         this will cause a memory leak if this store is used for server-side rendering
         */
        _this._cartItems.on('reset', function () {
            return _this._onCartUpdated();
        });
        _this._cartItems.on('sync', function () {
            return _this._onCartUpdated();
        });

        return _this;
    }

    _createClass(CartStore, [{
        key: 'isNotificationVisible',
        value: function isNotificationVisible() {
            return this._isDisplayingNotification;
        }

        /**
         * Returns the URL for the cart. This is a constant value for now.
         * @returns {string}
         */

    }, {
        key: 'getCartUrl',
        value: function getCartUrl() {
            return '/my/cart/';
        }
        /**
         * Returns the URL for checkout of an item.
         * @param {Item} item
         * @returns {string}
         */

    }, {
        key: 'getCheckoutUrl',
        value: function getCheckoutUrl(item) {
            return '/checkout' + item.getPDPURL(false);
        }
    }, {
        key: 'getCurrency',
        value: function getCurrency() {
            return this._currency;
        }

        /**
         * Returns the ProxiedCartCollection model for the cart.
         * @returns {*}
         */

    }, {
        key: 'getItemsCollection',
        value: function getItemsCollection() {
            return this._cartItems;
        }
    }, {
        key: 'getItemAtIndex',
        value: function getItemAtIndex(index) {
            return this.getItemsCollection().at(index);
        }
    }, {
        key: 'getItemById',
        value: function getItemById(id) {
            return this.getItemsCollection().findWhere({ 'item.id': id });
        }

        /**
         * Returns either a list of item models in the cart, or the recently added items,
         * depending on whether the cart is in notification state or not.
         * @returns {*}
         */

    }, {
        key: 'getItemsInMenu',
        value: function getItemsInMenu() {
            if (this._isDisplayingNotification) {
                return this._recentItems;
            } else {
                /*  Return the models sorted by create date, since in the hover menu
                 we want to show them that way but any new item that gets added goes to the end of
                 the list, screwing up the order if we already had items loaded from the fetch
                 */
                return this._cartItems.models.map(function (m) {
                    return m;
                }) // so we don't sort the original collection
                .sort(function (a, b) {
                    var date1 = a.get('createdDate');
                    var date2 = b.get('createdDate');
                    if (date1 > date2) {
                        return -1;
                    } else if (date1 < date2) {
                        return 1;
                    } else {
                        return 0;
                    }
                }).map(function (m) {
                    return m.get('item');
                });
            }
        }

        /**
         * Returns a PortfolioModel representing the items in the cart. This gets passed to
         * an ItemsView from CartWrapperView.
         * @returns {PortfolioModel|exports|module.exports|*}
         */

    }, {
        key: 'getPortfolioModel',
        value: function getPortfolioModel() {
            return this._portfolioModel;
        }

        /**
         * Returns the number of items in the cart.
         * @returns {*}
         */

    }, {
        key: 'getItemCount',
        value: function getItemCount() {
            return this._cartItems.length;
        }

        /**
         * Returns the number of items in the cart, or "<Max_Cart_Count>" if it's greater than that value
         * @returns {*}
         */

    }, {
        key: 'getItemCountFormatted',
        value: function getItemCountFormatted() {
            var length = this.getItemCount() || 0;
            return length > MAX_CART_COUNT ? MAX_CART_COUNT : length;
        }
    }, {
        key: 'getItemBeingUpdated',
        value: function getItemBeingUpdated() {
            return this._updatingItem;
        }

        /**
         * Returns a boolean if the user is a trade user
         * @returns {boolean}
         */

    }, {
        key: 'isTradeUser',
        value: function isTradeUser() {
            return User.loggedIn() && User.canRequestNetPrice() && enabler.isEnabled('enable_net_price');
        }

        /**
         * Returns true if the item is in the cart.
         * @param item {Backbone.Model} The item to check.
         * @returns {boolean}
         */

    }, {
        key: 'isItemInCart',
        value: function isItemInCart(item) {
            return this._cartItems.findWhere({ 'item.id': item.get('id') }) ? true : false;
        }

        /**
         * Handler for errors when performing cart actions
         * @param payload
         * @param payload.message {String} The error message
         */

    }, {
        key: 'onCartError',
        value: function onCartError(payload) {
            var message = payload.message;

            this._errorMessage = message;
            this._cartItems.trigger('cart:error', this._errorMessage);
            this.emitChange();
        }
    }, {
        key: 'onCartPortfolioLoaded',
        value: function onCartPortfolioLoaded(payload) {
            var itemCount = payload.itemCount;

            this._errorMessage = null;
            this._portfolioModel.set('itemCount', itemCount);
            this._cartItems.trigger('cart:loaded');
            this.emitChange();
        }
    }, {
        key: 'onItemAdded',
        value: function onItemAdded(payload) {
            var item = payload.item;

            this._cartItems.add(item);
            this._updateItemCount();

            this._cartItems.trigger('cart:itemAdded', { item: item });
            this.emitChange();
        }
    }, {
        key: 'onItemRemoved',
        value: function onItemRemoved(payload) {
            var item = payload.item;

            this._cartItems.remove(item);
            this._updateItemCount();

            this._cartItems.trigger('cart:itemRemoved', { item: item });
            this.emitChange();
        }
    }, {
        key: 'onItemRemovedAtIndex',
        value: function onItemRemovedAtIndex(payload) {
            var index = payload.index;

            var item = this._cartItems.at(index);
            this.onItemRemoved({ item: item });
        }
    }, {
        key: 'onCurrencyChanged',
        value: function onCurrencyChanged(payload) {
            var currency = payload.currency;

            this._currency = currency.toLowerCase();
            this.emitChange();
        }
    }, {
        key: 'onItemUpdating',
        value: function onItemUpdating(payload) {
            var item = payload.item;

            this._updatingItem = item;
            this.emitChange();
        }
    }, {
        key: 'onItemUpdated',
        value: function onItemUpdated() {
            this._updatingItem = null;
            this.emitChange();
        }
    }, {
        key: 'onItemUpdateFailed',
        value: function onItemUpdateFailed(payload) {
            this.onCartError({ message: payload.err });
        }
    }, {
        key: 'onShowNotification',
        value: function onShowNotification(payload) {
            var items = payload.items;

            this._isDisplayingNotification = true;
            this._recentItems = items;
            this.emitChange();
        }
    }, {
        key: 'onHideNotification',
        value: function onHideNotification() {
            this._isDisplayingNotification = false;
            this._recentItems = [];
            this.emitChange();
        }

        /**
         * Currently, the only function of this method is to trigger a change notification when the
         * backbone model is updated, so no payload is required.
         */

    }, {
        key: '_onCartUpdated',
        value: function _onCartUpdated() {
            this._updateItemCount();
            var itemCount = this.getItemCount();
            chatUtils.customAttribute.itemsInCart(itemCount);

            this.emitChange();
        }
    }, {
        key: '_updateItemCount',
        value: function _updateItemCount() {
            var itemCount = this.getItemCount();
            this._portfolioModel.set('itemCount', itemCount);
        }
    }]);

    return CartStore;
}(BaseStore);

CartStore.storeName = 'CartStore';

CartStore.handlers = (_CartStore$handlers = {
    'cart:itemAdded': 'onItemAdded',
    'cart:itemRemoved': 'onItemRemoved',
    'cart:itemRemoved:error': 'onCartError',
    'cart:portfolio:loaded': 'onCartPortfolioLoaded',
    'cart:portfolio:error': 'onCartError',
    'cart:notification:show': 'onShowNotification',
    'cart:notification:hide': 'onHideNotification'
}, _defineProperty(_CartStore$handlers, currencyActionConstants.CURRENCY_CHANGED, 'onCurrencyChanged'), _defineProperty(_CartStore$handlers, 'item:update:start', 'onItemUpdating'), _defineProperty(_CartStore$handlers, 'item:update:done', 'onItemUpdated'), _defineProperty(_CartStore$handlers, 'item:update:failed', 'onItemUpdateFailed'), _CartStore$handlers);

module.exports = CartStore;

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var PaymentMethod = SoaModel.extend();
module.exports = PaymentMethod;

var _ = __webpack_require__(0);
var paymentMethodTypes = {
    'WIRE_TRANSFER': 'WireTransfer',
    'CHECK': 'Check',
    'CREDIT_TO_USER_ACCOUNT': 'CreditToUserAccount',
    'DISCOUNT': 'Discount',
    'DIRECT_PAYMENT': 'DirectPayment',
    'CASH': 'Cash',
    'ACH': 'ACH',
    'NOT_AVAILABLE': 'NotAvailable',
    'PAYPAL_ACCOUNT': 'PayPalAccount',
    'CREDIT_CARD'   : 'CreditCard',
    'APPLE_PAY'     : 'ApplePay'
};

var isPaymentMethodType = function (type) {
    return this.get('paymentMethodType') === type;
};

// Service enums for card types
_.extend(PaymentMethod, {
    CARD_TYPE_VISA      : 'Visa',
    CARD_TYPE_MASTER    : 'MasterCard',
    CARD_TYPE_DISCOVER  : 'Discover',
    CARD_TYPE_AMEX      : 'American Express'
});

/**
 * @class PaymentMethod
 * @extends SoaModel
 * @property {string} idAttribute - "id"
 * @property {array} relations
 *      @property relations.type {Backbone.One}
 *      @property relations.key {string}- "item"
 *      @property relations.relatedModel {Backbone.Model}
 *      @property relations.collectionType {Backbone.Models}
 */
_.extend(PaymentMethod.prototype, {
    defaults : {
        apiType : 'defaultPaymentMethod'//This maps to a java interface
        // so, do a concrete version, and define apiType
        //`defaultPaymentMethod` is the placeholder for now, until we do actual concrete implementations
    }
});

_.each(paymentMethodTypes, function (description, type) {
    PaymentMethod['TYPE_' + type] = type;
    PaymentMethod.prototype['is' + description] = _.partial(isPaymentMethodType, type);
});


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseCallback = __webpack_require__(307),
    baseFor = __webpack_require__(130),
    keys = __webpack_require__(298);

/**
 * The base implementation of `_.forOwn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return baseFor(object, iteratee, keys);
}

/**
 * Creates a function for `_.mapKeys` or `_.mapValues`.
 *
 * @private
 * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
 * @returns {Function} Returns the new map function.
 */
function createObjectMapper(isMapKeys) {
  return function(object, iteratee, thisArg) {
    var result = {};
    iteratee = baseCallback(iteratee, thisArg, 3);

    baseForOwn(object, function(value, key, object) {
      var mapped = iteratee(value, key, object);
      key = isMapKeys ? mapped : key;
      value = isMapKeys ? value : mapped;
      result[key] = value;
    });
    return result;
  };
}

/**
 * Creates an object with the same keys as `object` and values generated by
 * running each own enumerable property of `object` through `iteratee`. The
 * iteratee function is bound to `thisArg` and invoked with three arguments:
 * (value, key, object).
 *
 * If a property name is provided for `iteratee` the created `_.property`
 * style callback returns the property value of the given element.
 *
 * If a value is also provided for `thisArg` the created `_.matchesProperty`
 * style callback returns `true` for elements that have a matching property
 * value, else `false`.
 *
 * If an object is provided for `iteratee` the created `_.matches` style
 * callback returns `true` for elements that have the properties of the given
 * object, else `false`.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
 *  per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Object} Returns the new mapped object.
 * @example
 *
 * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
 *   return n * 3;
 * });
 * // => { 'a': 3, 'b': 6 }
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * // using the `_.property` callback shorthand
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
var mapValues = createObjectMapper();

module.exports = mapValues;


/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);

var _require = __webpack_require__(1138),
    STORE = _require.STORE;

var _require2 = __webpack_require__(807),
    filterCollectionUniqueItems = _require2.filterCollectionUniqueItems;

var TrendingStore = function (_BaseStore) {
    _inherits(TrendingStore, _BaseStore);

    function TrendingStore(dispatcher) {
        _classCallCheck(this, TrendingStore);

        var _this = _possibleConstructorReturn(this, (TrendingStore.__proto__ || Object.getPrototypeOf(TrendingStore)).call(this, dispatcher));

        _this._collections = {};
        return _this;
    }

    _createClass(TrendingStore, [{
        key: 'getCollection',
        value: function getCollection(collectionKey) {
            return this._collections[collectionKey];
        }

        /**
         * Returns an array of filtered collections containing unique items.
         *
         * @param {array} collectionKeys - an array of Backbone collection keys.
         * @param {number} itemsPerPage - number of unique items to filter out.
         * @returns {array}
         */

    }, {
        key: 'getCollectionsFiltered',
        value: function getCollectionsFiltered(collectionKeys, itemsPerPage) {
            var _this2 = this;

            var collections = collectionKeys.map(function (key) {
                return _this2.getCollection(key).toJSON();
            });
            var flatCollections = Array.prototype.concat.apply([], collections);

            return filterCollectionUniqueItems(flatCollections, itemsPerPage);
        }
    }, {
        key: 'getTrend',
        value: function getTrend(collectionKey) {
            var rank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var collection = this._collections[collectionKey];

            if (collection) {
                return collection.findWhere({ rank: rank }) || collection.first();
            }

            return undefined;
        }

        /**
          * Returns trends title and url
          */

    }, {
        key: 'getTrends',
        value: function getTrends(collectionKey) {
            var collection = this._collections[collectionKey];

            if (collection) {
                return collection.map(function (trend) {
                    return {
                        modelId: trend.cid,
                        title: trend.get('displayName'),
                        url: trend.get('url')
                    };
                });
            }

            return [];
        }
    }, {
        key: 'getItems',
        value: function getItems(collectionKey) {
            var rank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var trend = this.getTrend(collectionKey, rank);
            return trend.get('items');
        }
    }, {
        key: 'getUrl',
        value: function getUrl(collectionKey) {
            var rank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var trend = this.getTrend(collectionKey, rank);
            return trend.get('url');
        }
    }, {
        key: 'getTitle',
        value: function getTitle(collectionKey, rank) {
            var trend = this.getTrend(collectionKey, rank);

            var _trend$get = trend.get('trendingElement'),
                name = _trend$get.name;

            return name;
        }
    }, {
        key: '_handleFetchSuccess',
        value: function _handleFetchSuccess(payload) {
            var collectionKey = payload.collectionKey,
                collection = payload.collection;


            this._collections[collectionKey] = collection;
            this.emitChange();
        }
    }]);

    return TrendingStore;
}(BaseStore);

TrendingStore.storeName = 'TrendingStore';

TrendingStore.handlers = _defineProperty({}, STORE.FETCH_SUCCESS, '_handleFetchSuccess');

module.exports = TrendingStore;

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var assign = __webpack_require__(60);
var forEach = __webpack_require__(58);
var isArray = __webpack_require__(65);
var omit = __webpack_require__(97);
var reduce = __webpack_require__(338);
var globaleval = eval; // eval called indirectly evaluates globally in es5+
var result = __webpack_require__(69);
var coreB3ndings = __webpack_require__(153);
var boundaryKey = '__b3nd-boundary';
var root = typeof global !== 'undefined' ? global : window;
var matches = __webpack_require__(37);
var iterateB3ndings = function (view, model, cb) {
    var boundElementSelector = "[data-model-bind]";
    var modelObj = result(model, 'toJSON');
    var stateObj = result(view.state, 'toJSON');
    var boundElements;
    var b3ndResult;
    var scopeObj;
    scopeObj = {
        testing: 'thomashallock',
        b3ndResult: undefined,
        view: view,
        state: stateObj,
        model: modelObj,
        computed: view.computeds && reduce(result(view, 'computeds'), function (memo, computed, key) {
            if (!(computed instanceof Function)) {
                computed = view[key];
            }
            memo[key] = computed.call(view, modelObj);
            return memo;
        }, {})
    };
    view.el[boundaryKey] = true; // prevents bound parent views from messing with us
    boundElements = Array.prototype.slice.call(view.el.querySelectorAll(boundElementSelector));
    if (matches(view.el, boundElementSelector)) {
        boundElements = [view.el].concat(boundElements);
    }
    boundElements.filter(function (el) {
        // filter out any elements that are on the other side of a b3nding boundary
        while (el && el !== view.el) {
            if (el[boundaryKey]) {
                return false;
            }
            el = el.parentNode;
        }
        return true;
    }).forEach(function (el) {
        var priorGlobalValues = {};
        var restoreGlobals = function () {
          forEach(priorGlobalValues, function (globalVarValue, globalVarName) {
              global[globalVarName] = priorGlobalValues[globalVarName];
          });
        };
        forEach(scopeObj, function (globalVarValue, globalVarName) {
            priorGlobalValues[globalVarName] = global[globalVarName];
            global[globalVarName] = globalVarValue;
        });
        try {
            b3ndResult = globaleval("({" + el.getAttribute('data-model-bind') + "});");
        } catch (e) {
            restoreGlobals();
            throw new EvalError("syntax error in b3nding: " + el.getAttribute('data-model-bind') + " : " + e.fileName + ":" + e.lineNumber + ": " + e.message);
        }
        restoreGlobals();
        forEach(b3ndResult, function (b3ndingValue, b3ndingName) {
            if (!this.b3ndings[b3ndingName]) {
                console.warn('undefined b3nding: ' + b3ndingName);
                return;
            }
            cb.call(view, this.b3ndings[b3ndingName], el, b3ndingValue);
        }, this);
    }.bind(this));
};

var initB3ndings = function (options) {
    iterateB3ndings.call(this, this.view, this.model, function (b3nding, el, value) {
        if (b3nding.init) {
            b3nding.init.call(el, value, this.model, this.view, options);
        }
    }.bind(this));
};
var updateB3ndings = function (view, model, options) {
    iterateB3ndings.call(this, view, model, function (b3nding, el, value) {
        if (b3nding.update) {
            b3nding.update.call(el, value, model, view, options);
        }
    });
};
var B3nd;
var B3ndContext;
B3ndContext = function () {};
B3ndContext.prototype = {
    on: function () {
        if (this.model) {
            this.model.on('change', this.forceUpdate, this);
        }
        if (this.options.nested) {
            this.model.on('nested-change', this.forceUpdate, this);
        }
        if (this.view.state) {
            this.view.state.on('change', this.forceUpdate, this);
        }
    },
    off: function () {
        if (this.model) {
            this.model.off('change', this.forceUpdate, this);
        }
        if (this.options.nested) {
            this.model.off('nested-change', this.forceUpdate, this);
        }
        if (this.view.state) {
            this.view.state.off('change', this.forceUpdate, this);
        }
    },
    forceUpdate: function () {
        B3nd._updateB3ndings.call(this, this.view, this.model);
    }
};

/**
 * signature:
 *   b3nd(view[, model][, options]); // context is not a Backbone.View
 *   view.b3nd([model][, options]); // context is a Backbone.View
 * @param model (required) - The model to which the view will be bound.
 * @param view (required) -  The view with the elements that will be bound to the model.
 */
B3nd = module.exports = function () {
    var options = {};
    var args = Array.prototype.slice.apply(arguments);
    var b3nd = new B3ndContext();
    if (result(this, 'el')) { // if it's a backbone view
        b3nd.view = this;
    } else {
        b3nd.view = args.shift();
    }
    b3nd.model = args.pop();
    if (b3nd.model) {
        if (!b3nd.model.toJSON) { // if it's not a backbone model
            options = b3nd.model || {};
            b3nd.model = args.pop();
        }
    }
    if (!b3nd.model) {
        b3nd.model = b3nd.view.model;
    }
    options = assign({
        using : [], // additional b3ndings
        nested : false
    }, options);
    if (!isArray(options.using)) {
        options.using = [options.using];
    }
    // finished parsing args
    options.using = options.using.concat(coreB3ndings);
    b3nd.b3ndings = options.using.reduce(function (b3ndings, b3nding) {
        b3ndings[b3nding.name] = b3nding;
        return b3ndings;
    }, {});
    b3nd.options = omit(options, 'using');
    initB3ndings.call(b3nd, b3nd.options);
    b3nd.on();
    b3nd.forceUpdate();
    return b3nd;
};
module.exports._updateB3ndings = updateB3ndings; // exported for test spec

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var Qs = __webpack_require__(41);
var result = __webpack_require__(69);
var pick = __webpack_require__(67);
var tracking = __webpack_require__(27);

var yesNo = function yesNo(predicate) {
    return predicate ? 'y' : 'n';
};
var SV = __webpack_require__(18);

var ContactGaStore = function (_BaseStore) {
    _inherits(ContactGaStore, _BaseStore);

    function ContactGaStore(dispatcher) {
        _classCallCheck(this, ContactGaStore);

        var _this = _possibleConstructorReturn(this, (ContactGaStore.__proto__ || Object.getPrototypeOf(ContactGaStore)).call(this, dispatcher));

        _this._reset();
        return _this;
    }

    _createClass(ContactGaStore, [{
        key: 'initialLoad',
        value: function initialLoad(_ref) {
            var linkLocation = _ref.linkLocation;

            this.data.linkLocation = linkLocation;
        }
    }, {
        key: 'constructVpvParams',
        value: function constructVpvParams(_ref2) {
            var item = _ref2.item,
                seller = _ref2.seller;

            this.data.vpvParams = {
                dd: seller.get('id'),
                dn: seller.get('sellerProfile.company')
            };
            this.data.purchaseStatus = '';
            if (item) {
                this.data.item = item;
                this.data.isItem = true;
                var hasPreQuoteShipping = false;
                if (item.get('shipmentQuotes')) {
                    hasPreQuoteShipping = item.get('shipmentQuotes').getNonLocalShipmentQuotes().length;
                }
                Object.assign(this.data.vpvParams, {
                    id: item.get('id'),
                    status: this._getStatus(item),
                    pur: yesNo(item.canMakePurchase()),
                    neg: yesNo(item.isNegotiablePrice()),
                    ship: yesNo(hasPreQuoteShipping),
                    ret: yesNo(result(item.get('returnPolicy'), 'acceptsReturns'))
                });
                this.data.purchaseStatus = Qs.stringify(pick(this.data.vpvParams, 'neg', 'ship', 'ret'), {
                    delimiter: '|'
                });
            }
            this.data.vpvParamsQuery = decodeURIComponent(Qs.stringify(this.data.vpvParams).toLowerCase());
        }
    }, {
        key: '_getStatus',
        value: function _getStatus(item) {
            var seller = item.get('seller');
            var status = 'Available-Price';
            if (seller.isStatusSuspended() || item.isItemDeleted()) {
                status = 'Suspended';
            } else if (item.isOnHold()) {
                status = 'Hold';
            } else if (item.isSold()) {
                status = 'Sold';
            } else if (item.hidingPrice()) {
                status = 'Available-No Price';
            }
            return 'PDP-' + status;
        }
    }, {
        key: '_reset',
        value: function _reset() {
            this.data = {};
        }
    }, {
        key: 'resetPage',
        value: function resetPage() {
            return tracking.addGTMMessage({
                pageType: SV.get('tracking.initialDataLayerInfo.pageType'),
                pageSubType: SV.get('tracking.initialDataLayerInfo.pageSubType')
            });
        }
    }]);

    return ContactGaStore;
}(BaseStore);

ContactGaStore.storeName = 'ContactGaStore';
ContactGaStore.handlers = {
    'contact:loading:start': 'initialLoad',
    'contact:loading:done': 'constructVpvParams',
    'contact:modal:close': 'resetPage'
};

module.exports = ContactGaStore;

/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ACTIONS: {
        TYPE: {
            CATEGORY: 'CATEGORY',
            ATTRIBUTE: 'ATTRIBUTE'
        },
        FIELDS: {
            IMAGES: 'IMAGES'
        }
    },
    STORE: {
        FETCH_SUCCESS: 'trending:fetch:success',
        FETCH_ERROR: 'trending:fetch:error'
    }
};

/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tracking = __webpack_require__(27);

var heroList = 'main hero carousel';
var promoImpressions = [];

function getProductData(item, index, list) {

    var product = {
        url: item.url,
        name: item.title,
        position: index + 1,
        list: list
    };

    return product;
}

function getPromoCreative(element) {
    var anchor = element.querySelector('a');
    var url = anchor ? anchor.href : '';
    var creative = url.split('.com');

    return creative.length > 1 ? creative[1] : url;
}

function addPromoClick(element, promo) {
    var anchors = Array.from(element.querySelectorAll('a'));

    anchors.forEach(function (anchor) {
        anchor.addEventListener('click', function () {
            tracking.trackEcommerce({
                type: 'promoClick',
                promotions: [promo]
            });
        });
    });
}

function buildImpressions(items, callback) {
    if (items.length) {
        items.forEach(function (item, index) {
            var position = index + 1;
            var promo = Object.assign({
                creative: getPromoCreative(item),
                position: position
            }, callback(item, position));

            addPromoClick(item, promo);
            promoImpressions.push(promo);
        });
    }
}

function getPersonalizationVariant(recommendable) {
    var variant = 'L3';

    // Nasty, but what can you do?
    if (recommendable.associatedCategory) {
        variant = 'attribute and L1';
    } else if (recommendable.trendingElement) {
        variant = 'trending';
    }

    return variant;
}

function getItems(selector) {
    return Array.from(document.querySelectorAll(selector));
}

function initPromoTracking() {
    var promoItems = getItems('.js-promo-item');
    var featuredItems = getItems('.js-featured-item');
    var editorialItems = getItems('.js-editorial-item');
    var shopByItems = getItems('.js-shop-by-pages-item');
    var locationsItems = getItems('.js-shop-by-locations-item');

    // Promos
    buildImpressions(promoItems, function (item, position) {
        return {
            id: 'promo-tile-' + position,
            name: 'Promo Tile #' + position
        };
    });

    // Featured
    buildImpressions(featuredItems, function () {
        return {
            id: 'five-brick-module',
            name: 'Five Brick Module'
        };
    });

    // Editorial
    buildImpressions(editorialItems, function (item, position) {
        return {
            id: 'content-promo-' + position,
            name: 'Content Promo'
        };
    });

    // Shop by products
    buildImpressions(shopByItems, function (item) {
        return {
            id: 'shop-by-' + item.getAttribute('data-ga-id'),
            name: 'Shop by ' + item.getAttribute('data-ga-name')
        };
    });

    // Dealer Locations
    if (locationsItems.length) {
        var promo = {
            id: 'shop-by-location',
            name: 'Shop by Location',
            creative: 'none',
            position: 1
        };

        locationsItems.forEach(function (locationsItem, index) {
            var itemPromo = Object.assign({}, promo, {
                creative: getPromoCreative(locationsItem),
                position: index + 1
            });

            addPromoClick(locationsItem, itemPromo);
        });

        promoImpressions.push(promo);
    }

    // Fire impression tracking
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: promoImpressions
    });
}

module.exports = {
    init: function init() {
        initPromoTracking();
    },
    trackHeroClick: function trackHeroClick(item, itemIndex) {
        tracking.trackEcommerce({
            type: 'productClick',
            actionField: { list: heroList },
            products: [getProductData(item, itemIndex)]
        });
    },
    trackHeroImpression: function trackHeroImpression(visibleItems, startIndex) {
        tracking.trackEcommerce({
            type: 'productImpression',
            products: visibleItems.map(function (item, index) {
                return getProductData(item, index + startIndex, 'main hero carousel');
            })
        });
    },
    trackCollectionsClick: function trackCollectionsClick(item, itemIndex) {
        tracking.trackEcommerce({
            type: 'promoClick',
            promotions: [{
                id: 'featured-circles',
                name: 'Featured Circles',
                creative: 'Featured Collections : ' + item.title,
                position: itemIndex + 1
            }]
        });
    },
    trackCollectionsArrows: function trackCollectionsArrows(page, variant) {
        if (variant.isNext() || variant.isPrevious()) {
            tracking.trackEvent({
                action: 'featured circles',
                category: 'promo interaction',
                label: variant.variant + ' arrow clicked'
            });
        }
    },
    trackCollectionsImpression: function trackCollectionsImpression(visibleItems, itemStartIndex) {
        tracking.trackEcommerce({
            type: 'promotionImpression',
            promotions: visibleItems.map(function (item, index) {
                return {
                    id: 'featured-circles',
                    name: 'Featured Circles',
                    creative: item.title,
                    position: index + itemStartIndex + 1
                };
            })
        });
    },


    // Personalization

    trackPersonalizationMount: function trackPersonalizationMount() {
        tracking.trackEcommerce({
            type: 'promotionImpression',
            promotions: [{
                id: 'personalized-items-categories-carousel',
                name: 'Personalized Items and Categories Carousel',
                creative: 'Personalized Items and Categories Carousel',
                position: 1
            }]
        });
    },
    trackPersonalizationPromoClick: function trackPersonalizationPromoClick() {
        tracking.trackEcommerce({
            type: 'promoClick',
            promotions: [{
                id: 'personalized-items-categories-carousel',
                name: 'Personalized Items and Categories Carousel',
                creative: 'Personalized Items and Categories Carousel',
                position: 1
            }]
        });
    },
    trackPersonalizationImpression: function trackPersonalizationImpression(visibleRecommendations, recommendationStartIndex) {
        // There can only be one visible recommendation at a time.
        var recommendation = visibleRecommendations[0];
        var visibleItems = recommendation.items;
        var startIndex = recommendationStartIndex * visibleItems.length;
        tracking.trackEcommerce({
            type: 'productImpression',
            products: visibleItems.map(function (item, index) {
                return {
                    id: item.id,
                    name: item.title,
                    category: recommendation.url.slice(1, -1),
                    brand: item.seller.id,
                    variant: 'homepage - ' + getPersonalizationVariant(recommendation),
                    position: index + startIndex + 1,
                    list: 'personalized-items-carousel'
                };
            })
        });
    },
    trackPersonalizationItemClick: function trackPersonalizationItemClick(item, _ref) {
        var variant = _ref.variant,
            category = _ref.category,
            position = _ref.position;

        tracking.trackEcommerce({
            type: 'productClick',
            actionField: {
                list: 'personalized-items-carousel'
            },
            products: [{
                id: item.pk,
                name: item.title,
                brand: item.seller.id,
                category: category.slice(1, -1),
                position: position + 1,
                variant: 'homepage - ' + variant
            }]
        });

        tracking.trackEvent({
            category: 'promo interaction',
            action: 'personalized items and categories carousel',
            label: 'product clicked-' + variant
        });
    },
    trackPersonalizationViewAll: function trackPersonalizationViewAll(variant) {
        tracking.trackEvent({
            category: 'promo interaction',
            action: 'personalized items and categories carousel',
            label: 'view all clicked-' + variant
        });
    },
    trackPersonalizationDotClick: function trackPersonalizationDotClick(variant) {
        tracking.trackEvent({
            category: 'promo interaction',
            action: 'personalized items and categories carousel',
            label: 'paginate clicked-' + variant
        });
    },


    getPersonalizationVariant: getPersonalizationVariant
};

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),

/***/ 116:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Common valiation regular expressions such as email, string, etc.
 */
var specialChars = /^[^!@#$%^&*()+=><?]*$/;
var _rules = {
    email : /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/, // http://www.w3.org/TR/html5/forms.html%23valid-e-mail-address
    password : /^.{5,128}$/,
    special_characters : specialChars,
    name: specialChars,
    digits: /\d/,
    numeric : /^[0-9]*$/,
    floating : /^[0-9\.]*$/,
    greater_than_one : /^[1-9][0-9]*$/,
    url : /^((http(?:s)?\:\/\/|)[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*\.[a-zA-Z]{2,6}(?:\/?|(?:\/[\w\-]+)*)(?:\/?|\/\w+\.[a-zA-Z]{2,4}(?:\?[\w]+\=[\w\-]+)?)?(?:\&[\w]+\=[\w\-]+)*)$/,
    price : /^(?=.*[1-9])\d*(?:(\.|\,)\d{1,2})?$/,
    itemPrice : /^[1-9]\d{0,2}(?:,?\d{3})*(?:\.\d{1,2})?$/,
    // Note* Month/Year pattern accepts either 2 or 4 digits for the year, and
    month_year : /^[0-9]{1}[1-2]{1}\s?\/\s?[0-9]{2}([0-9]{2})?$/,
    measurement : /^-?(?=.*[1-9])(\d*)(\.\d+)?$/,
    // currency string optionally delimited by commas without decimal amount
    currencyString: /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*?$/,
    // currency string optionally delimited by periods without decimal amount
    currencyStringEur: /^[+-]?[0-9]{1,3}(?:\.?[0-9]{3})*?$/,
    notAllCaps : function (val) {
        val = val.replace(/[^A-Za-z]+/g, '');
        var re = /[a-z]/;
        if (val === '') {
            return true;
        }
        return re.test(val);
    }
};

module.exports = _rules;


/***/ }),

/***/ 119:
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var fieldRegex  = /\[\d+\]/g;
var ErrorList = __webpack_require__(202);
var FieldValidation = __webpack_require__(75);
var DEFAULT_MESSAGE = 'Please correct this value : ';
var DEFAULTREQUIREDMESSAGE = 'This field is required';
var getDeferredMethods = __webpack_require__(299);
var assert = __webpack_require__(31);

var when = getDeferredMethods().when;

/**
 * @class Validator
 *
 * Validator Class constructor follows backbone JS style inheritance. An instance of validator class *requires that you
 * specify a modelConstructor, and a validationRules set. You may also add an initialize method, and of course, any
 * other public and private methods you choose to add.
 *
 *
 * Default methods / properties :
 *      - initialize - function
 *      - fieldValidations - object | function **
 *      - modelConstructor - constructor function
 *      - validate - function ***
 *
 * @property {string} EVENT_WILL_VALIDATE_FIELD validator:willValidateField
 * @property {string} EVENT_FIELD_PASSED_VALIDATION validator:fieldPassedValidation
 * @property {string} EVENT_FIELD_FAILED_VALIDATION validator:fieldFailedValidation
 * @property {string} EVENT_FIELD_FIXED_VALIDATION validator:fieldFixedValidation
 *
 * @example
 * // ** fieldValidations may be an object with the validation rules in the expected format, OR a function that returns such
 * // a rules set. Validator rules follow this format :
 *      {
 *          // each value must be {@link FieldValidation} or
 *          // extension instance
 *          key : new FieldValidation({
 *              field: 'foo', // model attribute key
 *              required: true, // make this field required
 *              fieldDisplayName: 'Foo', // combined with rule messageBody values to make a message ('"Foo" field must be bar')
 *              additionalRules: {  // Specify an object of additional rules not defined by the FieldValidation class
 *                  bar: new FieldRule({
 *                      messageBody: 'must be bar',
 *                      validate: function (model, value, fieldName) {
  *                         return value === 'bar';
  *                     }
 *                  })
 *              }
 *          })
 *      }
 *
 * @example
 * // *** By default the validate function invokes the validation logic. If you want to over-ride the validation function
 * // to do some setup then you should invoke the parent's validation method like so :
 * var EntityValidator = Validator.extend({
 *      validate : function (options) {
 *          // do something...
 *          return EntityValidator.__super__.validate.apply(this, arguments);
 *      }
 * });
 *
 *
 */
var Validator = function () {
    var self = this;
    /**
     * @memberOf Validator#
     * @private
     */
    this._childValidators = {};

    this.initialize.apply(this, arguments);
    when(this.getReadyPromise()).done(function () {
        /**
         * @memberOf Validator#
         * @type {boolean}
         * @private
         */
        self._isReady = true;
    });
};

Validator.EVENT_WILL_VALIDATE_FIELD = 'validator:willValidateField';
Validator.EVENT_FIELD_PASSED_VALIDATION = 'validator:fieldPassedValidation';
Validator.EVENT_FIELD_FAILED_VALIDATION = 'validator:fieldFailedValidation';
Validator.EVENT_FIELD_FIXED_VALIDATION = 'validator:fieldFixedValidation';

Validator.events = [
    Validator.EVENT_WILL_VALIDATE_FIELD, Validator.EVENT_FIELD_PASSED_VALIDATION,
    Validator.EVENT_FIELD_FAILED_VALIDATION, Validator.EVENT_FIELD_FIXED_VALIDATION
];

/**
 * Return true if the field contains a generic
 * collection index.
 * @public
 * @param {string} modelFieldName
 * @returns {boolean}
 */
Validator.isGenericFieldName = function (modelFieldName) {
    return modelFieldName.indexOf('[*]') > -1;
};

/**
 * Replace specific collection indicies with the
 * 'generic' index symbol '[*]'
 * @public
 * @param {string} modelFieldName
 * @returns {string}
 */
Validator.getGenericFieldName = function (modelFieldName) {
    return modelFieldName.replace(fieldRegex, '[*]');
};

/**
 * Return true if a field name has a specific collection
 * index (e.g. foo.bar[1].bam)
 * @public
 * @param {string} modelFieldName
 * @returns {boolean}
 */
Validator.hasCollectionIndex = function (modelFieldName) {
    return fieldRegex.test(modelFieldName);
};

Validator.prototype.initialize = function () {
    this.on(Validator.EVENT_WILL_VALIDATE_FIELD, this.onWillValidateField, this);
    this.on(Validator.EVENT_FIELD_PASSED_VALIDATION, this.onFieldPassed, this);
    this.on(Validator.EVENT_FIELD_FAILED_VALIDATION, this.onFieldFailed, this);
    this.on(Validator.EVENT_FIELD_FIXED_VALIDATION, this.onFieldFixed, this);
};

Validator.prototype.validationRules = null;

Validator.prototype.modelConstructor = null;

Validator.prototype.deferToChildValidators = true;

/**
 * Override this in an extension and
 * return a deferred promise if you want
 * to delay validation.
 * @public
 * @returns {null}
 */
Validator.prototype.getReadyPromise = function () {
    return null;
};

/**
 * @param {function} callback
 * @param {object} [context]
 * @public
 * @returns {Validator}
 */
Validator.prototype.onReady = function (callback, context) {
    when(this.getReadyPromise()).done(function () {
        callback.call(context);
    });
    return this;
};

/**
 * @param {function} callback
 * @param {object} [context]
 * @public
 * @returns {Validator}
 */
Validator.prototype.onReadyFailure = function (callback, context) {
    when(this.getReadyPromise()).fail(function () {
        callback.apply(context, arguments);
    });
    return this;
};

/**
 * @public
 * @returns {boolean}
 */
Validator.prototype.isReady = function () {
    //var readyProm = this.getReadyPromise();
    //return !readyProm || readyProm.state() === 'resolved';
    return !!this._isReady;
};

/**
 * @param {FieldValidation} fieldValidation
 * @returns {Object}
 */
Validator.prototype.getSchemaForField = function (fieldValidation) {
    return fieldValidation.outputSchema();
};

/**
 * Method to generate the full schema for a Validator. If your validator returns different schema
 * based on the values of a model, override this method so that documentation can be generated
 * @returns {Object}
 */
Validator.prototype.getFullSchema = function () {
    return { default: _.result(this, 'fieldValidations') };
};

/**
 * Add a "child" validator. The child validator can be used in
 * CollectionFieldValidation field validations or as a way to
 * delegate validation for a particular related model to another
 * validator. For example, if you have a "shipmentQuotes" child
 * validator to a parent validator, validating shipmentQuotes[0].foo
 * on the parent validator will simply defer to the child by
 * validating "foo" field with the first model in the shipment quotes
 * collection.
 * @public
 * @param {string} key
 *      A matching field name for a relation on the model
 * @param {Validator} childValidator
 */
Validator.prototype.setChildValidatorForKey = function (key, childValidator) {
    assert(childValidator instanceof Validator, 'childValidator must be an instance of Validator');
    this._childValidators[key] = childValidator;
    childValidator.parentValidator = this;
};

/**
 * @public
 * @param {string} key
 * @returns {FieldValidation}
 */
Validator.prototype.getChildValidator = function (key) {
    return this._childValidators[key];
};

/**
 * @public
 * @param {string} deferToChildValidators
 * @returns {Validator}
 */
Validator.prototype.setDeferToChildValidators = function (deferToChildValidators) {
    this.deferToChildValidators = deferToChildValidators;
    return this;
};

/**
 * @protected
 * @param {string} key
 */
Validator.prototype.removeChildValidator = function (key) {
    var childValidator = this._childValidators[key];
    if (!childValidator) {
        return;
    }
    childValidator.parentValidator = null;
    delete this._childValidators[key];
};

/**
 * @protected
 * Receives following params
 * - {string} fieldName
 * - {FieldValidation} fieldValidation
 */
Validator.prototype.onWillValidateField = function (fieldName) {
    this._lastValidatedFields.push(fieldName);
};

/**
 * Receives following params
 * - {string} fieldName
 * - {FieldValidation} fieldValidation
 * @protected
 */
Validator.prototype.onFieldPassed = function (fieldName, fieldValidation) {
    var errorIndex;
    this._lastPassedFields.push(fieldName);
    errorIndex = _.indexOf(this._fieldsWithErrors || [], fieldName);
    if (errorIndex > -1) {
        this._fieldsWithErrors.splice(errorIndex, 1);
        this.triggerFixedValidation(fieldName, fieldValidation);
    }
};

/**
 * Receives following params
 * - {string} fieldName
 * - {FieldValidation} fieldValidation
 * - {object[{ field: string, message: string }]} errors
 * @protected
 */
Validator.prototype.onFieldFailed = function (fieldName) {
    this._lastFailedFields.push(fieldName);
    if (_.indexOf(this._fieldsWithErrors, fieldName) < 0) {
        this._fieldsWithErrors.push(fieldName);
    }
};

/**
 * Receives following params
 * - {string} fieldName
 * - {FieldValidation} fieldValidation
 * @protected
 */
Validator.prototype.onFieldFixed = function (fieldName) {
    this._lastFixedFields.push(fieldName);
};

/**
 * Returns a list of the model fields that were
 * validated on the last 'validate' method call
 * @returns {string[]}
 * @public
 */
Validator.prototype.getLastValidatedFields = function () {
    return this._lastValidatedFields;
};

/**
 * Returns a list of the model fields that passed
 * validation on the last 'validate' method call
 * @returns {string[]}
 * @public
 */
Validator.prototype.getLastPassedFields = function () {
    return this._lastPassedFields;
};

/**
 * Returns a list of the model fields that failed
 * validation on the last 'validate' method call
 * @returns {string[]}
 * @public
 */
Validator.prototype.getLastFailedFields = function () {
    return this._lastFailedFields;
};

/**
 * Returns a list of the model fields that were fixed
 * on the last 'validate' method call
 * @returns {string[]}
 * @public
 */
Validator.prototype.getLastFixedFields = function () {
    return this._lastFixedFields;
};

/**
 * @param {string} modelFieldName
 * @returns {boolean}
 */
Validator.prototype.hasCollectionIndex = function (modelFieldName) {
    return Validator.hasCollectionIndex(modelFieldName);
};

/**
 * Return true if the field
 * @public
 * @param modelFieldName
 * @returns {boolean}
 */
Validator.prototype.isGenericFieldName = function (modelFieldName) {
    return Validator.isGenericFieldName(modelFieldName);
};

/**
 * @public
 * @param {string} modelFieldName
 * @returns {string}
 */
Validator.prototype.getGenericFieldName = function (modelFieldName) {
    return Validator.getGenericFieldName(modelFieldName);
};

/**
 * @param {string} genericModelFieldName
 * @returns {boolean}
 * @private
 */
Validator.prototype._genericFieldHasError = function (genericModelFieldName) {
    var i = 0;
    for (i; i < this._fieldsWithErrors.length; i++) {
        if (this.getGenericFieldName(this._fieldsWithErrors[i]) === genericModelFieldName) {
            return true;
        }
    }
    return false;
};

/**
 * If a field has an error, based on result of
 * last "validate" call, return true. Otherwise,
 * return false.
 * @public
 * @param {string} modelFieldName
 * @returns {boolean}
 */
Validator.prototype.fieldHasError = function (modelFieldName) {
    var i = 0;
    if (this.isGenericFieldName(modelFieldName)) {
        return this._genericFieldHasError(modelFieldName);
    }
    for (i; i < this._fieldsWithErrors.length; i++) {
        if (this._fieldsWithErrors[i] === modelFieldName) {
            return true;
        }
    }
    return false;
};

/**
 * Resets the arrays used to track the model fields
 * that were validated and passed or failed validation
 * the last time 'validate' was called.
 * @private
 */
Validator.prototype._resetValidationTrackers = function () {
    if (!this._fieldsWithErrors) {
        this._fieldsWithErrors = [];
    }
    this._lastValidatedFields = [];
    this._lastPassedFields = [];
    this._lastFailedFields = [];
    this._lastFixedFields = [];
    this._childValidatorsFieldBuffers = {};
};

/**
 * @param {string} modelFieldName
 * @param {FieldValidation} fieldValidation
 */
Validator.prototype.triggerWillValidateField = function (modelFieldName, fieldValidation) {
    this.trigger(Validator.EVENT_WILL_VALIDATE_FIELD, modelFieldName, fieldValidation);
};

/**
 * @param {string} modelFieldName
 * @param {FieldValidation} fieldValidation
 */
Validator.prototype.triggerFieldPassed = function (modelFieldName, fieldValidation) {
    this.trigger(Validator.EVENT_FIELD_PASSED_VALIDATION, modelFieldName, fieldValidation);
};

/**
 * @param {string} modelFieldName
 * @param {FieldValidation} fieldValidation
 */
Validator.prototype.triggerFixedValidation = function (modelFieldName, fieldValidation) {
    this.trigger(Validator.EVENT_FIELD_FIXED_VALIDATION, modelFieldName, fieldValidation);
};

/**
 * @param {string} modelFieldName
 * @param {FieldValidation} fieldValidation
 * @param {object[]} errors
 */
Validator.prototype.triggerFieldFailed = function (modelFieldName, fieldValidation, errors) {
    this.trigger(Validator.EVENT_FIELD_FAILED_VALIDATION, modelFieldName, fieldValidation, errors);
};

/**
 * @public
 * @param {string} fieldName The field being validated
 * @returns {string} The matching child validator if there is one
 */
Validator.prototype.fieldMatchesChildValidator = function (fieldName) {
    var children = this._childValidators;
    var childValidatorKey;
    for (childValidatorKey in children) {
        if (children.hasOwnProperty(childValidatorKey)) {
            if (fieldName.indexOf(childValidatorKey) === 0 &&
                    _.indexOf([".", "["], fieldName.charAt(childValidatorKey.length)) > -1) {
                return childValidatorKey;
            }
        }
    }
    return null;
};

/**
 * @param {string} modelFieldName
 * @param {string} childValidatorKey
 * @private
 */
Validator.prototype._shouldValidateFieldWithChildValidator = function (modelFieldName, childValidatorKey) {
    // converts 'foo.bar[1]' into 'foo\.bar\[1\]'
    var regexKeySeg = childValidatorKey.replace(/\[\.\]/g, function (val) {
        return '\\' + val;
    });
    // breaks foo.bar into ['foo.bar', undefined, 'bar'] and foo[0].bar into ['foo[0].bar', '[0]', 'bar']
    var fieldDataRegex = new RegExp('^' + regexKeySeg + '(?:(?:(\\[\\d+\\])\\.)|\\.)(.+)');
    var matches = modelFieldName.match(fieldDataRegex);
    var childValidatorBuffer;
    var modelPath;
    if (matches && matches.length) {
        modelPath = childValidatorKey + (matches[1] || '');
        // We need to know the path to the model, the full field path (including parent model),
        // and the field relative to the model
        if (!this._childValidatorsFieldBuffers[modelPath]) {
            this._childValidatorsFieldBuffers[modelPath] = {
                childValidatorKey: childValidatorKey,
                fields: [],
                fullFieldPaths: []
            };
        }
        childValidatorBuffer = this._childValidatorsFieldBuffers[modelPath];
        childValidatorBuffer.fields.push(matches[2]);
        childValidatorBuffer.fullFieldPaths.push(modelFieldName);
    }
};

/**
 * @param {ErrorList} errorsList
 * @private
 */
Validator.prototype._validateChildValidatorFields = function (errorsList) {
    _.each(this._childValidatorsFieldBuffers, function (buffer, pathToModel) {
        var validator = this.getChildValidator(buffer.childValidatorKey);
        var childValidatorOut;
        var childModel = pathToModel ? this.model.get(pathToModel) : this.model;
        var i = 0;
        var err;
        this._matchChildValidatorEvents(pathToModel);
        childValidatorOut = validator.validate(childModel, { fields: buffer.fields });
        this._matchChildValidatorEvents(pathToModel, true);
        for (i; i < childValidatorOut.errors.length; i++) {
            err = childValidatorOut.errors[i];
            errorsList.add(buffer.fullFieldPaths[_.indexOf(buffer.fields, err.field)], err.message, err.rule);
        }
    }, this);
    return errorsList;
};

/**
 * Set up / removes events on the validator instance that
 * mirror the same events on child validators.
 * @param {string} pathToModel
 * @param {boolean} [removeEvents=false]
 * @private
 */
Validator.prototype._matchChildValidatorEvents = function (pathToModel, removeEvents) {
    var self = this;
    var fieldPrefix = pathToModel ? pathToModel + '.' : '';
    var events = Validator.events;
    var getCallback = function (event) {
        return function () {
            arguments[0] = fieldPrefix + arguments[0];
            self.trigger.apply(self, [event].concat(_.toArray(arguments)));
        };
    };
    _.each(self._childValidators, function (childValidator) {
        var i = 0;
        for (i; i < events.length; i++) {
            childValidator.off(events[i], null, self);
            if (!removeEvents) {
                childValidator.on(events[i], getCallback(events[i]), self);
            }
        }
    });
};


/**
 * @param {boolean} requireNone
 * @protected
 */
Validator.prototype.setRequireNone = function (requireNone) {
    this._requireNone = requireNone;
    this._setChildrenRequireNone(requireNone);
};

/**
 * @param {boolean} requireNone
 * @private
 */
Validator.prototype._setChildrenRequireNone = function (requireNone) {
    _.each(this._childValidators, function (validator) {
        validator.setRequireNone(requireNone);
    });
};

/**
 * Extend the Validator class like you would a Backbone.Model
 * @function
 * @memberOf Validator
 * @param {object} [instanceProperties]
 * @param {object} [staticProperties]
 * @returns {function(new:Validator)} A new Validator constructor
 */
Validator.extend = Backbone.Model.extend;

// Give Validator instances the ability to listen to and fire events
_.extend(Validator.prototype, Backbone.Events);

Validator.prototype.validate = null;

/*eslint-disable*/
// Disabling eslint errors (var must be at top of file) as this is deprecated and shouldn't need to be maintained for much longer, (hopefully)

/**
 * Helper function does individual validations.
 * @param {object} rule
 * @param {boolean} [rule.noMatch=false]
 * @param {function|RegExp} [rule.validator]
 * @param {string} fieldName exp. creators[0].name
 *      - validator <RegExp | Function>
 * @param value
 * @returns {boolean}
 * @private
 */
var _validateSingle = function (rule, value, fieldName, required) {
    var self = this;
    var test = true;
    var func = rule.validator;

    // Throws an error if validator is improperly configured. Each rules property of a validaiton config must
    // have a validator property
    if (!func || !(func instanceof RegExp || func instanceof Function)) {
        throw new Error("Invalid validator configuration. Each validation config's rules property must have " +
            "a validator method which is an instance of RegExp or Function");
    }

    if (func instanceof RegExp) {
        test = func.test(value);
    } else if (typeof func === 'function') {
        test = func.call(self, value, fieldName, required);
    }

    // for nomatch rules, invert the answer :
    if (rule.noMatch) {
        test = !test;
    }

    // If the error is not either bool or instance of ErrorList then error out.
    if (!_.isBoolean(test) && !(test instanceof ErrorList)) {
        throw new Error("Validator for '" + fieldName + "' returned an invalid result.");
    }

    return test;
};

var _getNestedValue = function (model, string) {
    var obj = model.toJSON();
    string = string.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    string = string.replace(/^\./, ''); // strip a leading dot
    var arr = string.split('.');
    var n;
    while (arr.length) {
        n = arr.shift();
        if (obj.hasOwnProperty(n)) {
            obj = obj[n];
        } else {
            return;
        }
    }
    return obj;
};

/**
 * Helper function to do validations based on a validation schema.
 * @param {object} fieldValidations - validation schema object (rules)
 * @param {object} options - fields not to evaluate for required rule if passed
 * @returns {{ errors: { field:string, message: string }[] }}
 */
var _validate = function (fieldValidations, options) {
    options = options || {};

    this._resetValidationTrackers();

    var model = this.model;
    var out = {};
    var errorList = new ErrorList();
    var fieldsToValidate = [];
    var topLevelFields = [];
    var schema = {};
    var requireNone = _.isBoolean(options.requireNone) ? options.requireNone : this._requireNone;
    var specificFieldsToValidate = options.partial !== true && options.fields ? options.fields.slice(0) : null; // null out fields option if partial is true
    assert(specificFieldsToValidate === null || specificFieldsToValidate instanceof Array, 'options.fields must be an array');

    // Make a deep clone of the schema -- this way if we alter the schema rules during the course of this method, the
    // core set will not be affected :
    // schema = clone(schema);

    // Get the list of fields that to validate.
    // By default, the fields to validate is all auto-run fields :
    //fieldsToValidate = _.pluck(_.values(_.where(schema, {autoRun : true})), 'field');

    _.each(fieldValidations, function (fieldValidation, fieldValidationKey) {
        console.assert(fieldValidation instanceof FieldValidation, 'fieldValidation must be an instance of FieldValidation');
        var fieldSchema = schema[fieldValidationKey] = this.getSchemaForField(fieldValidation, fieldValidationKey);
        assert(typeof fieldSchema.field === 'string', 'The fieldValidation for key ' + fieldValidationKey + ' must define a "field"');
        if (!specificFieldsToValidate && fieldSchema.autoRun) {
            fieldsToValidate.push(fieldSchema.field);
        }
    }, this);
    if (specificFieldsToValidate) {
        fieldsToValidate = specificFieldsToValidate;
    }

    // Otherwise, if the client is asking to validate the partial object, over-write fields to validate with any
    // field where the top level attribute was passed in (1st segment in field name) :
    if (options.partial === true) {
        topLevelFields = _.keys(options.payload);
        var newFieldsToValidate = [];
        _.each(fieldsToValidate, function (fieldName) {
            var furstSegment = _.first(fieldName.split('.'));
            if (_.indexOf(topLevelFields, furstSegment) !== -1) {
                newFieldsToValidate.push(fieldName);
            }
        });
        fieldsToValidate = newFieldsToValidate;
    }

    // Next, apply the require none option. Toggle all required fields in the schema to not required. This will be
    // over-ridden below by individual field overrides.
    if (requireNone) {
        this._setChildrenRequireNone(true);
        _.each(schema, function (config) {
            config.required = false;
        });
    }

    // Loop over every field that you are going to validate. For each look up the associated validator from the
    // validation schema :
    _.each(fieldsToValidate, function (fieldName) {
        var fieldValidation;
        var fieldValidationKey;
        var fieldValidationSchema;
        var genericFieldName = fieldName;
        var fieldErrors = [];
        var childValidatorKey;
        var val;
        var required;
        var hasRealValue;
        var message;
        var override;

        // Throws an error if no field name is configured on validation config.
        if (!fieldName) {
            throw new Error('Invalid configuration. Each validation config item must have a field property.');
        }

        if (this.deferToChildValidators) {
            // If there is a child validator matching this field and
            // deferToChildValidators is true
            childValidatorKey = this.fieldMatchesChildValidator(fieldName);
            if (childValidatorKey) {
                this._shouldValidateFieldWithChildValidator(fieldName, childValidatorKey);
                return;
            }
        }

        // If the field regex detects a number (ie. "abc[1].def") -- then replace the number with a * to achieve a
        // generic field name.
        if (fieldRegex.test(fieldName)) {
            genericFieldName = fieldName.replace(fieldRegex, '[*]');
        }

        // Find validation onfigs -- the first config that matches the given field name :
        // Note *** If many validation configs are configured to match a given field, then only the first one will
        // run, you may not define many configs to match against a certain field name.
        for (fieldValidationKey in schema) {
            if (schema.hasOwnProperty(fieldValidationKey) && (genericFieldName === schema[fieldValidationKey].field)) {
                fieldValidation = fieldValidations[fieldValidationKey];
                fieldValidationSchema = schema[fieldValidationKey];
                break;
            }
        }
        if (!fieldValidationSchema) {
            return;
        }

        // If there are any over-rides for this validation config, then apply them now. Note* This reverses the blanket
        // rule of "requireNone" for specified fields.
        if (options.overrides) {
            override = _.find(options.overrides, function (o) {
                var field = o.field || o.fieldName;
                return (fieldValidationSchema.field === field);
            });
            if (override) {
                // TODO ::: ONLY EXTEND ON OVER-RIDES THAT WOULD NOT BREAK, ie. DO NOT APPLY OVER RIDES THAT ARE rules
                // TODO ::: BECAUSE IF PASSED IN AS STRING -- FUNCTIONS WOULD BLOW UP! (use pick / omit?)
                fieldValidationSchema = _.extend({}, fieldValidationSchema, override);
            }
        }

        // We know the specific model field and are about to validate it
        // so trigger an event so any listeners can handle it appropriately
        this.triggerWillValidateField(fieldName, fieldValidation);

        // Now get the value you are to evaluate :
        try {
            val = (fieldValidation.getModelValueForField) ?
                    fieldValidation.getModelValueForField(model, fieldName) : model.get(fieldName);
        } catch (e) {
            val = _getNestedValue(model, fieldName);
        }

        // If the value is an array, then check the length :
        if (_.isArray(val)) {
            val = val.length ? val : false;
        }

        if (_.isBoolean(fieldValidationSchema.required)) {
            required = fieldValidationSchema.required;
        } else if (_.isFunction(fieldValidationSchema.required)) {
            required = fieldValidationSchema.required(model, val, fieldName);
        } else {
            required = false;
        }

        // If the current field is required, then validate it has a value :
        hasRealValue = fieldValidation.hasRealValue ?
                fieldValidation.hasRealValue(model, val, fieldName) : (parseInt(val, 10) === 0 || !!val);

        if (required && !hasRealValue) {
            message = (fieldValidationSchema.messages && fieldValidationSchema.messages.required) ?
                    fieldValidationSchema.messages.required : DEFAULTREQUIREDMESSAGE;
            errorList.add(fieldValidationSchema.field, message, "required");

            this.triggerFieldFailed(fieldName, fieldValidation, [errorList.last()]);
            // Return from this case and do not run other validations, since the item is required and is NOT defined.
            return;
        }

        // Next, if the value is set to something AND there are rules defined...
        // apply each of the rules to the current field, getting the output of each :
        if (fieldValidationSchema.rules && hasRealValue) {
            _.each(fieldValidationSchema.rules, function (validator, key) {

                // Get the result for the current validator. Results can be boolean true | false OR they can be
                // objects describing an error.
                var result = _validateSingle.call(model, validator, val, fieldName, required);
                var currMessage = (fieldValidationSchema.messages && fieldValidationSchema.messages[key]) ? fieldValidationSchema.messages[key] : DEFAULT_MESSAGE + fieldName;

                // If the result is a boolean add the default error based on the field being validated. Otherwise
                // the result should be an array of errors from the ErrorList Class
                if (_.isBoolean(result) && !result) {
                    errorList.add(fieldName, currMessage, validator.validator);
                    fieldErrors.push(errorList.last());
                // If the result is an ErrorList -- then merge it with the overall error list.
                } else if (result instanceof ErrorList && result.getErrors().length) {
                    errorList.merge(result);
                    fieldErrors = fieldErrors.concat(errorList.getErrors());
                }

            }, this);

            if (fieldErrors.length) {
                this.triggerFieldFailed(fieldName, fieldValidation, fieldErrors);
            } else {
                this.triggerFieldPassed(fieldName, fieldValidation);
            }

        }
    }, this);

    this._validateChildValidatorFields(errorList);

    if (requireNone) {
        this._setChildrenRequireNone(false); // restore requireNone's default value (false);
    }

    out.errors = errorList.getErrors();

    return out;
};

/**
 * Do validation on a plain JS object, configured by options.
 *
 * @param {object|array} payload JSON object to be validated.
 * @param {object} [options] - Options to configure validation. May contain any of the following :
 * @param {boolean} [options.partial=false] Defaults to false. IF passed as true then only validate the fields passed in (present on the payload)
 * @param {string[]} [options.fields] Array of strings, if passed and not empty then ONLY the fields specified will be validated.
 * @param {boolean} [options.requireNone=false] Defaults to false. Don't evaluate any of the fields to be required. ***Note : you may set this to true, then toggle selected fields to be required by using the overrides array.
 * @param {object[]} [options.overrides] Over-ride the values for validations in the validation schema for this entity. This is an array of objects that mimics the structure of the vdalidation schemas.
 * @returns {{ errors: object[] }}
 */
Validator.prototype.validate = function (payload, options) {

    options = options || {};
    _.extend(options, {
        payload : payload
    });

    var self = this;
    var requiredArr = ['modelConstructor', 'fieldValidations'];
    var changeError = function () {
        throw new Error('Validator: model should not change during validation');
    };
    var validationRules;
    var output;

    assert(this.isReady(), 'Validator instance is not ready to validate yet.');

    // Check the required properties are set on the validation instance :
    _.each(requiredArr, function (required) {
        if (!self[required]) {
            throw new Error('Missing required property : ' + required);
        }
    });

    assert(payload instanceof this.modelConstructor || payload instanceof Backbone.Model === false,
        'Validator.validate payload must be instance of modelConstructor or toJSON output');
    this.model = (payload instanceof this.modelConstructor) ? payload : new this.modelConstructor(payload);

    this.model.on('nested-change', changeError).on('change', changeError);

    // If validation rules is a function, then execute that function to get the rules set :
    validationRules = this.fieldValidations;
    if (typeof this.fieldValidations === 'function') {
        validationRules = this.fieldValidations(this.model, options);
    }

    // run validations in the context of this validator instance, and return the results
    output = _validate.call(this, validationRules, options);

    // remove the event handler
    this.model.off('nested-change', changeError).off('change', changeError);

    return output;
};
/*eslint-enable*/
module.exports = Validator;


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var FieldValidation = __webpack_require__(75);
var RegexRule = __webpack_require__(85);
var _ = __webpack_require__(0);

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Module Definition and Instance Properties

/**
 * @class RegexFieldValidation
 * @extends FieldValidation
 */
var RegexFieldValidation = module.exports = FieldValidation.extend({
    autoRun: true,
    initialize: function (options) {
        options = options || {};
        this.regex = options.regex || this.regex;
        this.message = options.message || this.message;
        this.noMatch = _.isBoolean(options.noMatch) ? options.noMatch : this.noMatch;
        this.rule = this.createRule();
        RegexFieldValidation.__super__.initialize.call(this, options);
    },
    createRule: function () {
        return new RegexRule(_.pick(this, 'regex', 'noMatch', 'message'));
    }
});


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseIndexOf = __webpack_require__(334),
    cacheIndexOf = __webpack_require__(240),
    createCache = __webpack_require__(241);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.difference` which accepts a single array
 * of values to exclude.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values) {
  var length = array ? array.length : 0,
      result = [];

  if (!length) {
    return result;
  }
  var index = -1,
      indexOf = baseIndexOf,
      isCommon = true,
      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
      valuesLength = values.length;

  if (cache) {
    indexOf = cacheIndexOf;
    isCommon = false;
    values = cache;
  }
  outer:
  while (++index < length) {
    var value = array[index];

    if (isCommon && value === value) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === value) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (indexOf(values, value, 0) < 0) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

// shim for Node's 'util' package
// DO NOT REMOVE THIS! It is required for compatibility with EnderJS (http://enderjs.com/).
var util = {
  isArray: function (ar) {
    return Array.isArray(ar) || (typeof ar === 'object' && objectToString(ar) === '[object Array]');
  },
  isDate: function (d) {
    return typeof d === 'object' && objectToString(d) === '[object Date]';
  },
  isRegExp: function (re) {
    return typeof re === 'object' && objectToString(re) === '[object RegExp]';
  },
  getRegExpFlags: function (re) {
    var flags = '';
    re.global && (flags += 'g');
    re.ignoreCase && (flags += 'i');
    re.multiline && (flags += 'm');
    return flags;
  }
};


if (true)
  module.exports = clone;

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/

function clone(parent, circular, depth, prototype) {
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth == 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (util.isArray(parent)) {
      child = [];
    } else if (util.isRegExp(parent)) {
      child = new RegExp(parent.source, util.getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (util.isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      child = new Buffer(parent.length);
      parent.copy(child);
      return child;
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }
      
      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46).Buffer))

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Convert a number into a string and add commas every
 * 3 digits. If there are decimals, the number will be
 * treated as a currency unless 'notCurrency' param is
 * false.
 * @param {String|Number} number String representation of a number or a normal number
 * @param {Boolean} notCurrency If the number should not be treated like a currency for decimals
 * @param {String} delim Indicates what symbol should separate every 3 digits; Either a ',' or a '.'
 * @return {String}
 */

var DELIM_COMMA = ',';
var DELIM_PERIOD = '.';

function numAddCommas(number, notCurrency, delim) {

    var i = void 0;
    var len = void 0;
    var dec = '';
    var newNum = '';
    var decIndx = void 0;
    var decimalDelim = void 0;

    delim = delim || DELIM_COMMA;
    decimalDelim = delim === DELIM_COMMA ? DELIM_PERIOD : DELIM_COMMA;

    if (!number && number !== 0) {
        return '';
    }

    number = '' + number;

    if (number.indexOf(delim) !== -1) {
        number = number.replace(new RegExp(delim, 'g'), '');
    }

    decIndx = number.indexOf(decimalDelim);
    if (decIndx !== -1) {
        len = number.length;
        if (notCurrency) {
            dec = number.substring(decIndx, len);
        } else {
            var numSubstring = delim === DELIM_PERIOD ? delim + number.substring(decIndx + 1) : number.substring(decIndx);
            dec = ('' + Math.round(Number(numSubstring) * 100) / 100).substring(1);
            dec = delim === DELIM_PERIOD ? dec.replace(DELIM_PERIOD, DELIM_COMMA) : dec;
            if (dec.length > 3) {
                dec = dec.substring(0, 3);
            } else if (dec.length === 2) {
                dec = dec + '0';
            }
        }
        number = number.substring(0, decIndx);
    }

    len = number.length;
    i = len - 1;

    while (i >= 0) {
        newNum = number.charAt(i) + newNum;

        if ((len - i) % 3 === 0 && len - 1 !== i && i > 0) {
            newNum = delim + newNum;
        }

        i = i - 1;
    }

    return newNum + dec;
}

module.exports = numAddCommas;

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);

var UserToUserMessageStore = function (_BaseStore) {
    _inherits(UserToUserMessageStore, _BaseStore);

    function UserToUserMessageStore(dispatcher) {
        _classCallCheck(this, UserToUserMessageStore);

        var _this = _possibleConstructorReturn(this, (UserToUserMessageStore.__proto__ || Object.getPrototypeOf(UserToUserMessageStore)).call(this, dispatcher));

        _this._init();
        return _this;
    }

    _createClass(UserToUserMessageStore, [{
        key: '_init',
        value: function _init() {
            this.message = {
                fromName: '',
                fromEmail: '',
                fromUserId: '',
                toName: '',
                toEmail: '',
                toUserId: '',
                bcc: '',
                subject: '',
                body: '',
                templateFolder: '',
                template: ''
            };
        }
    }, {
        key: 'doneLoading',
        value: function doneLoading(payload) {
            var user = payload.user,
                copyText = payload.copyText,
                contactName = payload.contactName,
                contactEmail = payload.contactEmail;


            if (user) {
                this.message.fromUserId = user.pick('id');
                this.message.fromName = [user.get('profile.firstName') || '', user.get('profile.lastName') || ''].join(' ').trim();
                this.message.fromEmail = user.get('profile.email');
            }

            this.message.toName = contactName;
            this.message.toEmail = contactEmail;

            this.message.subject = copyText.get('subject');
            this.message.templateFolder = copyText.get('templateFolder');
            this.message.template = copyText.get('template');

            this.emitChange();
        }
    }, {
        key: 'editField',
        value: function editField(payload) {
            this.message[payload.field] = payload.value;
            this.emitChange();
        }
    }]);

    return UserToUserMessageStore;
}(BaseStore);

UserToUserMessageStore.storeName = 'UserToUserMessageStore';

UserToUserMessageStore.handlers = {
    'contact:userToUser:message:fieldEdited': 'editField',
    'contact:userToUser:loading:done': 'doneLoading'
};

module.exports = UserToUserMessageStore;

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Validator = __webpack_require__(121);
var Transaction = __webpack_require__(20);
var LocalizedCurrencyValidation = __webpack_require__(239);
var FieldRule = __webpack_require__(45);
var FinancialAmount = __webpack_require__(10);
var numberConversions = __webpack_require__(323);
var assert = __webpack_require__(31);

var TransactionValidator = module.exports = Validator.extend({

    modelConstructor: Transaction,

    initialize: function initialize() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this._copy = options.copyText;
        this._compareItemPrice = typeof options.compareItemPrice === 'boolean' ? options.compareItemPrice : true;
        TransactionValidator.__super__.initialize.apply(this, arguments);
    },
    fieldValidations: function fieldValidations() {
        var _this = this;

        var currency = this._getCurrency(this.model);
        var isEur = currency === FinancialAmount.CURRENCY_EUR;
        var additionalRules = {
            positive: new FieldRule({
                message: this._copy.get('errorPositiveNumber'),
                validate: function validate() {
                    return _this.parseOffer(_this.model) > 0;
                }
            })
        };
        if (this._compareItemPrice) {
            additionalRules.lowerThanItemPrice = new FieldRule({
                message: this._copy.get('errorUnderListPrice'),
                validate: function validate() {
                    return Math.floor(_this.parseOffer(_this.model) * 100) < Math.floor(_this._getItemPrice(_this.model) * 100);
                }
            });
        }
        return {
            offerAmount: new LocalizedCurrencyValidation({
                currency: currency,
                additionalRules: additionalRules,
                message: isEur ? this._copy.get('errorPriceFormatEur') : this._copy.get('errorPriceFormat'),
                required: true,
                field: 'amountPerItem.amount',
                getModelValueForField: function getModelValueForField(model, field) {
                    return _this._getOffer(model).get(field);
                }
            })
        };
    },
    validateLowball: function validateLowball(model, options) {
        model = model instanceof this.modelConstructor ? model : new this.modelConstructor(model);
        return this.parseOffer(model) < this._getItemPrice(model, options) * 0.6;
    },
    validateEqualItemPrice: function validateEqualItemPrice(model) {
        model = model instanceof this.modelConstructor ? model : new this.modelConstructor(model);
        return this.parseOffer(model) === this._getItemPrice(model);
    },
    validateHigherItemPrice: function validateHigherItemPrice(model) {
        model = model instanceof this.modelConstructor ? model : new this.modelConstructor(model);
        return this.parseOffer(model) > this._getItemPrice(model);
    },
    parseOffer: function parseOffer(model) {
        var offer = this._getOffer(model);
        var delimiter = this._getCurrency(model) === FinancialAmount.CURRENCY_EUR ? '.' : ',';
        var amount = offer.get('amountPerItem.amount') || '0';
        return numberConversions.removeThousandsDelim(amount.trim(), delimiter);
    },
    _getCurrency: function _getCurrency(model) {
        var offer = this._getOffer(model);
        return offer.get('amountPerItem.currency') || FinancialAmount.CURRENCY_USD;
    },
    _getItemPrice: function _getItemPrice(model, options) {
        options = options || {};
        var item = model.get('item');
        var pricing = item ? item.get('pricing') : undefined;
        if (pricing) {
            return pricing.getMostRelevantPrice(this._getCurrency(model), options.isTrade);
        }
        return 0;
    },


    // only validate most recent offer
    _getOffer: function _getOffer(model) {
        return model.getMostRecentOffer();
    }
});

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var extendCompose = __webpack_require__(43);
var Conversation = module.exports = extendCompose.call(SoaModel, {});
var Anchors = __webpack_require__(330);
var AnchorLists = __webpack_require__(120);
var Messages = __webpack_require__(167);
var Item = __webpack_require__(34);
var Transaction = __webpack_require__(20);
var BuyerProfile = __webpack_require__(234);
var Party = __webpack_require__(8);
var User = __webpack_require__(28);
var endpoints = __webpack_require__(6);
var Clump = __webpack_require__(22);
var bunsen = __webpack_require__(21);
var newsy = __webpack_require__(40);
var globalDataLogger = __webpack_require__(49);
var Deferred = __webpack_require__(29).Deferred;
var Qs = __webpack_require__(41);
var assign = __webpack_require__(60);
var copyText = __webpack_require__(38)();
/**
 * @attribute unreadMessagesCount - total number of unread messages in this conversation
 * @attribute numberOfAttachments
 */
Conversation.extendSelf({
    url: function (options) {
        options = options || {};
        if (this._asUser) {
            options.params = assign({}, options.params, {userId: this._asUser});
        }
        options.params = assign({}, options.params, {showExternalMembers: 'Y'});

        if (undefined === this.id || 'undefined' === this.id) {
            globalDataLogger.event({'conversation id is undefined': this.toJSON()});
            globalDataLogger.flush();
        }
        return endpoints.conversation(this.id, options);
    },
    sync: function (method, context, options) {
        var fields;
        if (method !== 'read') {
            return Conversation.__super__.sync.apply(this, arguments);
        }
        // make sure that conversation is always requested with at least baseFields
        options = _.extend({}, options);
        if (!options.data) {
            options.data = {};
        }
        fields = _.result(options.data, 'fields');
        if ("string" === typeof fields) {
            fields = fields.split(',');
        }
        if (!_.isArray(fields)) {
            fields = [];
        }
        options.data = _.extend({}, options.data, {fields: _.uniq(fields.concat(Conversation.baseFields)).join(',')});
        return Conversation.__super__.sync.call(this, method, context, options);
    },
    initialize : function (attributes, options) {
        options = assign({
            asUser: undefined
        }, options);
        this.on('sync', function (model, data) {
            globalDataLogger.event({'conversation model sync': data});
        });
        this._asUser = options.asUser;
    },
    _getLatestMessageSenderId: function () {
        return parseInt(this.get('latestMessageSenderId'), 10); // TODO: get services to be consistent between types in their ids, then remove the parseInt (and this method);
    },
    getLatestMessageRecipientDisplayName: function () {
        var latestMessageRecipient = _.last(this.get('members').filter(function (recipient) {
            if ('N' === recipient.get('isActive')) {
                return false;
            }
            if (recipient.isExternal()) {
                return false;
            }
            return recipient.id !== this._getLatestMessageSenderId();
        }, this));
        if (latestMessageRecipient) {
            return latestMessageRecipient.getDisplayName();
        }
        return copyText.get('unknownRecipient');
    },
    getOtherMemberDisplayName: function () {
        var displayName = '';
        if (this.getOtherMember) {
            displayName = _.result(this.getOtherMember(), 'getDisplayName');
        }
        return displayName;
    },
    parse : function () {
        var data = Conversation.__super__.parse.apply(this, arguments);
        if ("string" === typeof data.isLatestMessageSender) {
            data.isLatestMessageSender = data.isLatestMessageSender === 'Y';
        }
        return data;
    },
    idAttribute : "id",
    defaults : {
        members : [],
        anchors : []
    },
    relations: [
        {
            key: 'reviewedBy',
            relatedModel: User,
            type: Backbone.One
        },
        {
            key: 'messagePointers',
            relatedModel: SoaModel,
            type: Backbone.One
        },
        {
            key : 'anchors',
            collectionType: Anchors,
            type : Backbone.Many
        },
        {
            key : 'members',
            relatedModel: newsy.getConstructor.bind(newsy, 'ConversationMember'),
            type : Backbone.Many
        },
        {
            key : 'messages',
            omitFromSave: true,
            collectionType: Messages,
            type : Backbone.Many
        },
        {
            key: 'item',
            omitFromSave: true,
            relatedModel: Item,
            type: Backbone.One
        },
        {
            key: 'transaction',
            relatedModel: Transaction,
            type: Backbone.One
        },
        {
            key: 'buyerProfile',
            relatedModel: BuyerProfile,
            type: Backbone.One
        }
    ],
    fetchMessages : function () {
        var messages = this.get('messages') || new Messages();
        var dummyConversation = newsy('ConversationModel', _.pick(this, 'id'));
        this.set('messages', messages);
        globalDataLogger.event({'created dummy conversation': dummyConversation.toJSON()});
        return dummyConversation.fetch({data: {fields: ['message', 'attachment'].join(',')}}).then(function (data) {
            var newMessages;
            globalDataLogger.event({'fetched dummy conversation': data});
            newMessages = dummyConversation.get('messages');
            if (!newMessages) {
                return Deferred().reject();
            }
            messages.reset(newMessages.models);
        });
    },
    markReadUnread : function (isRead) {
        if (undefined === isRead) {
            isRead = true;
        }
        _.result(this._lastMarkReadUnreadRequest, 'abort');
        this._lastMarkReadUnreadRequest = Clump.ajax({
            type : "PUT",
            url : endpoints.markReadUnread + '?' + Qs.stringify(_.extend({
                isRead : isRead === true || isRead === 'Y' ? 'Y' : 'N',
                conversationIds : this.id
            }, bunsen.getToken()))
        });
        return this._lastMarkReadUnreadRequest;
    },
    getMemberForUser: function (options) {
        options = _.extend({
            userId: undefined
        }, options);
        if (!options.userId) {
            throw new Error('getMemberForUser expects options.userId');
        }
        return _.first(this.get('members').filter(function (member) {
            return member.get('user').id === options.userId;
        }));
    },
    getMostRecentMessage: function () {
        return _.result(this.get('messages'), 'last');
    },
    getOriginalBuyer: function () {
        return this.getOriginalMemberByType(Party.ROLE_BUYER);
    },
    getOriginalSeller: function () {
        return this.getOriginalMemberByType(Party.ROLE_SELLER);
    },
    getOriginalMemberByType: function (type) {
        return this.get('members').findWhere({
            userType: type,
            isOriginal: 'Y'
        });
    },
    isUnavailable: function () {
        return this.get('status') !== 'ACTIVE';
    },
    isContentRedacted: function () {
        return this.get('messageContentRedacted') === 'Y';
    },
    getUrlForBuyerAndItemEndpoint: function (options) {
        return endpoints.conversationsForBuyerAndItemUrl({
            buyerId: options.buyerId,
            itemId: options.itemId
        });
    },
    fetchConversationForBuyerAndItem: function (options) {
        return this.fetch({url: this.getUrlForBuyerAndItemEndpoint(options)});
    },
    getLatestDealerOffer: function () {
        var offers = this.get('transaction.offers');
        if (offers) {
            return _.last(offers.filter(function (offer) {
                return offer.get('initiatingParty.role') === Party.ROLE_SELLER;
            }));
        }
    },
    getReviewReasons: function () {
        if (!this.get('reviewReason')) {
            return [];
        }
        return this.get('reviewReason').split(',').map(function (reason) {
            return reason.trim();
        });
    },
    isSellerOnNewPolicy: function () {
        var seller = this.getOriginalSeller();
        var sellerId = seller.get('user').id;
        var anchorLists = new AnchorLists();

        return anchorLists.fetchListForSellerPolicy(sellerId).then(function (data) {
            if (data.result.length) {
                return !!_.findWhere(data.result, {name: AnchorLists.listNames.OPOP});
            }
        });
    }
});
Conversation.reviewStatuses = [
    'OPEN',
    'MONITORING',
    'IN_PROGRESS',
    'CLOSED'
];
Conversation.baseFields = [
    'conv_trans_full', // transaction in conversation will return the most relevant transaction
    'OFFER' // offers in messages
];
Conversation.newsy = {
    builds: ['ConversationMember'],
    name: 'ConversationModel'
};


/***/ }),

/***/ 134:
/***/ (function(module, exports) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array ? array.length : 0;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Rob Richard
 * Date: 3/17/15
 * Time: 10:56 AM
 */



var SoaModel = __webpack_require__(2);
var Token = module.exports = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;

root.bunsen = root.bunsen || {};
module.exports = root.bunsen.Token = Token;

var _ = __webpack_require__(0);
var ends = __webpack_require__(6);

_.extend(Token.prototype, {
    fetchClientToken: function () {
        return this.fetch({
            url: ends.paymentProviderClientToken()
        });
    }
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var get = __webpack_require__(14);

function getDisplayName(_ref) {
    var firstName = _ref.firstName,
        lastName = _ref.lastName,
        email = _ref.email;

    if (firstName && lastName) {
        return firstName + ' ' + lastName;
    } else if (lastName) {
        return lastName;
    } else if (firstName) {
        return firstName;
    } else if (email) {
        return email.split('@')[0];
    }
    return '';
}

var ContactDealerStore = {
    storeName: 'ContactDealerStore',
    initialState: {
        errors: [],
        hasTrackingFired: false,
        isMessageSending: false,
        isMessageSent: false,
        messageBody: {
            action: { name: 'CONTACT_DEALER' },
            from: {},
            item: {},
            recipients: [],
            textBody: ''
        },
        optimizelyVariant: ''
    },
    reducers: {
        BOOTSTRAP_ITEM_STORE: function BOOTSTRAP_ITEM_STORE(state, payload) {
            var _payload$rawResult = payload.rawResult,
                item = _payload$rawResult === undefined ? {} : _payload$rawResult;

            var apiType = item.vertical + 'Item'; // Need to format V2 apiType for MC endpoint
            return _extends({}, state, {
                messageBody: _extends({}, state.messageBody, {
                    item: { apiType: apiType, id: item.id },
                    recipients: [{
                        recipientDetails: {
                            displayName: get(item, 'seller.sellerProfile.company', ''),
                            user: { id: get(item, 'seller.id') },
                            userType: 'SELLER'
                        },
                        recipientType: 'TO'
                    }],
                    subject: '1stdibs Item Inquiry - ' + get(item, 'title')
                })
            });
        },
        ENTER_MESSAGE: function ENTER_MESSAGE(state, payload) {
            var value = payload.value;

            return _extends({}, state, { messageBody: _extends({}, state.messageBody, { textBody: value }) });
        },
        ENTER_NAME: function ENTER_NAME(state, payload) {
            var value = payload.value;

            return _extends({}, state, { messageBody: _extends({}, state.messageBody, { from: { displayName: value } }) });
        },
        SET_USER_VALUES: function SET_USER_VALUES(state, payload) {
            var displayName = payload.displayName,
                user = payload.user;

            return _extends({}, state, {
                messageBody: _extends({}, state.messageBody, {
                    from: {
                        displayName: displayName || getDisplayName(user.profile || {}),
                        user: { id: user.userId || user.id },
                        userEmail: get(user, 'profile.email'),
                        userType: 'BUYER'
                    }
                })
            });
        },
        SET_OPTIMIZELY_VARIANT: function SET_OPTIMIZELY_VARIANT(state, payload) {
            var optimizely = payload.optimizely;

            return _extends({}, state, { optimizelyVariant: optimizely });
        },
        MESSAGE_SEND_END: function MESSAGE_SEND_END(state) {
            return _extends({}, state, { isMessageSent: true, isMessageSending: false });
        },
        MESSAGE_SEND_BEGIN: function MESSAGE_SEND_BEGIN(state) {
            return _extends({}, state, { isMessageSending: true });
        },
        PDP_CONTACT_FORM_ERRORS: function PDP_CONTACT_FORM_ERRORS(state, payload) {
            var errors = payload.errors;

            return _extends({}, state, { errors: errors });
        },
        TRACKING_FIRED: function TRACKING_FIRED(state) {
            return _extends({}, state, { hasTrackingFired: true });
        }
    },
    getters: {
        getErrors: function getErrors(state) {
            return state.errors;
        },
        getMessage: function getMessage(state) {
            return state.messageBody.textBody;
        },
        getMessageSending: function getMessageSending(state) {
            return state.isMessageSending;
        },
        getMessageSent: function getMessageSent(state) {
            return state.isMessageSent;
        },
        getName: function getName(state) {
            return state.messageBody.from.displayName;
        },
        getVariant: function getVariant(state) {
            return state.optimizelyVariant;
        },
        getTrackingFired: function getTrackingFired(state) {
            return state.hasTrackingFired;
        }
    }
};

module.exports = ContactDealerStore;

/***/ }),

/***/ 139:
/***/ (function(module, exports) {

/* eslint-env browser */
module.exports = window.FormData;


/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var moment = __webpack_require__(30);
var zipObject = __webpack_require__(248);
var map = __webpack_require__(337);
var uuid = __webpack_require__(266);
var buildMomentLocale = function (localeConfig, passedMoment) {
    var localeName = "-module-locale-" + uuid.v4();
    var theMoment = passedMoment || moment;
    moment.locale(localeName, localeConfig);
    return (function () {
        return theMoment.apply(theMoment, arguments).locale(localeName);
    });
};
module.exports = function (localeConfigs) {
    return zipObject(map(localeConfigs, function (localeConfig, localeName) {
        return [localeName, buildMomentLocale(localeConfig)]
    }));
}


/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Created by john on 7/16/15.
 */



var _NavBarUIStateStore$h;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var User = __webpack_require__(15);
var BaseStore = __webpack_require__(13);
var NavActions = __webpack_require__(35).NAV;
var get = __webpack_require__(14);
var root = typeof document === 'undefined' ? global : document;

/**
 * Stores the state of the nav bar UI. For example, whether the search bar is expanded, menu shown,
 * user logged in, etc.
 */

var NavBarUIStateStore = function (_BaseStore) {
    _inherits(NavBarUIStateStore, _BaseStore);

    function NavBarUIStateStore(dispatcher) {
        _classCallCheck(this, NavBarUIStateStore);

        var _this = _possibleConstructorReturn(this, (NavBarUIStateStore.__proto__ || Object.getPrototypeOf(NavBarUIStateStore)).call(this, dispatcher));

        _this.state = {
            showNavMenu: false,
            showSearchBar: false,
            showTrade: _this._canShowTrade()
        };

        // set up listener on User Model
        User.getCurrentUser().on('login:change', _this.updateUserStates, _this);
        User.getCurrentUser().on('change:profile', _this.updateUserStates, _this);
        return _this;
    }

    _createClass(NavBarUIStateStore, [{
        key: '_canShowTrade',
        value: function _canShowTrade() {
            var bodyEl = root.querySelector('body');
            return get(bodyEl, 'className', '').indexOf('is-trade') >= 0;
        }
    }, {
        key: 'getState',
        value: function getState() {
            return this.state;
        }
    }, {
        key: 'updateUserStates',
        value: function updateUserStates() {
            var _this2 = this;

            var loggedIn = User.loggedIn();

            if (loggedIn) {
                User.load().always(function () {
                    _this2.state.showTrade = _this2._canShowTrade();
                    _this2.emitChange();
                });
            }
        }

        /**
         * Handler for when the navigation menu state changes.
         * @param payload
         * @param payload.visible {boolean}
         */

    }, {
        key: 'onToggleNavMenu',
        value: function onToggleNavMenu(payload) {
            this.state.showNavMenu = !!payload.visible;
            this.emitChange();
        }

        /**
         * Handles showing and hiding the search bar.
         * @param payload
         * @param payload.visible {boolean}
         */

    }, {
        key: 'onToggleSearchBar',
        value: function onToggleSearchBar(payload) {
            this.state.showSearchBar = !!payload.visible;
            this.emitChange();
        }
    }]);

    return NavBarUIStateStore;
}(BaseStore);

NavBarUIStateStore.storeName = 'NavBarUIStateStore';

NavBarUIStateStore.handlers = (_NavBarUIStateStore$h = {}, _defineProperty(_NavBarUIStateStore$h, NavActions.TOGGLE_MENU, 'onToggleNavMenu'), _defineProperty(_NavBarUIStateStore$h, NavActions.TOGGLE_SEARCH, 'onToggleSearchBar'), _NavBarUIStateStore$h);

module.exports = NavBarUIStateStore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by caroline on 7/21/15.
 */



var _handlers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var $ = __webpack_require__(5);
var User = __webpack_require__(15);
var createStore = __webpack_require__(50);
var ActionConstants = __webpack_require__(35);
var NavActions = ActionConstants.NAV;

var DEFAULT_USER_INITIALS = null;
var DEFAULT_MESSAGE_COUNT = 0;
var DEFAULT_REDIRECT_URL = null;

/**
 * Stores the list of components that are displayed in the nav bar.
 */
module.exports = createStore({

    storeName: 'NavBarHamburgerStateStore',

    handlers: (_handlers = {}, _defineProperty(_handlers, ActionConstants.HAMBURGER.UPDATE_USER_STATES, '_onUpdateUserStates'), _defineProperty(_handlers, NavActions.ACTIVE_GROUP_CHANGED, 'onActiveGroupChange'), _defineProperty(_handlers, NavActions.RECEIVED_LIST_DATA, 'setLists'), _handlers),

    initialize: function initialize() {
        this.state = this._getDefaultState();
        this.lists = [];

        // set up listener on User Model
        User.getCurrentUser().on('login:change', this.updateUserStates, this);
        User.getCurrentUser().on('change:profile', this.updateUserStates, this);
    },
    getRedirectURL: function getRedirectURL() {
        return this.redirectURL || DEFAULT_REDIRECT_URL;
    },
    getState: function getState() {
        return this.state;
    },
    getLists: function getLists() {
        return this.lists;
    },
    setLists: function setLists(payload) {
        this.lists = this._getFormattedListsData(payload);
        this.emitChange();
    },
    onActiveGroupChange: function onActiveGroupChange(payload) {
        this.redirectURL = payload.redirectURL;
        this.emitChange();
    },


    /**
     * checks the user model, updates state.user and emits change
     * @param {promise} [payload.promise]
     */
    updateUserStates: function updateUserStates() {
        var _this = this;

        var loggedIn = User.loggedIn();

        if (loggedIn) {
            User.load().always(function () {
                _this.state = {
                    loggedIn: loggedIn,
                    userInitials: User.getInitials() || DEFAULT_USER_INITIALS,
                    messageCount: User.getCurrentUser().get('conversationSummary.totalUnreadMessageCount')
                };
                _this.emitChange();
            });
        } else {
            this.state = this._getDefaultState();
            this.emitChange();
        }
    },
    _onUpdateUserStates: function _onUpdateUserStates() {
        var _this2 = this;

        this.updateUserStates();

        //todo: revisit this and try to see if there is a better way to do this
        $.subscribe('reloadUserNav', function (obj, data) {
            _this2.state.messageCount = data.totalUnreadMessageCount;
            _this2.emitChange();
        });
    },
    _getDefaultState: function _getDefaultState() {
        return {
            loggedIn: false,
            userInitials: DEFAULT_USER_INITIALS,
            messageCount: DEFAULT_MESSAGE_COUNT
        };
    },
    _getFormattedListsData: function _getFormattedListsData(_ref) {
        var modules = _ref.modules;

        // Group the global nav items based on their is_vertical flags.
        return [{
            'label': 'Explore',
            'items': modules.filter(function (item) {
                return item.isVertical === true;
            }).map(function (item) {
                return {
                    'url': item.url,
                    'name': item.name
                };
            })
        }, {
            'label': 'Discover',
            'items': modules.filter(function (item) {
                return item.isVertical !== true;
            }).map(function (item) {
                return {
                    'url': item.url,
                    'name': item.name
                };
            })
        }];
    }
});

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 7/16/15.
 */



var _NavBarItemStore$hand;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var NavActions = __webpack_require__(35).NAV;

/**
 * Stores the list of components that are displayed in the nav bar.
 */

var NavBarItemStore = function (_BaseStore) {
    _inherits(NavBarItemStore, _BaseStore);

    function NavBarItemStore(dispatcher) {
        _classCallCheck(this, NavBarItemStore);

        var _this = _possibleConstructorReturn(this, (NavBarItemStore.__proto__ || Object.getPrototypeOf(NavBarItemStore)).call(this, dispatcher));

        _this.currentGroup = 'default';
        _this.componentGroups = {
            'default': []
        };
        _this.components = [];
        return _this;
    }

    _createClass(NavBarItemStore, [{
        key: 'getState',
        value: function getState() {
            return {
                components: this.getItems()
            };
        }
    }, {
        key: 'getItems',
        value: function getItems(group) {
            var groupKey = group || this.currentGroup || 'default';
            return this.componentGroups[groupKey];
        }

        /**
         * Changes the list of components that is currently rendered.
         * @param payload
         * @param payload.group
         */

    }, {
        key: 'onActiveGroupChanged',
        value: function onActiveGroupChanged(payload) {
            this.currentGroup = payload.group;
            this.emitChange();
        }

        /**
         * Adds a component to the list.
         * @param payload
         * @param payload.group      {string}    A key representing the list to add these components to.
         * @param payload.components {Array}     An array of react components representing items to be shown in the nav bar.
         * @param payload.index      {number}    The location in which the components should be inserted into the nav bar.
         */

    }, {
        key: 'onComponentsAdded',
        value: function onComponentsAdded(payload) {
            var components = payload.components,
                index = payload.index;

            var groupKey = payload.group || 'default';
            var componentGroup;
            if (components && components.length) {
                componentGroup = this.componentGroups[groupKey];
                if (!componentGroup) {
                    componentGroup = this.componentGroups[groupKey] = [];
                }
                Array.prototype.splice.apply(componentGroup, [index, 0].concat(components));
                this.emitChange();
            }
        }

        /**
         * Removes a component from the list.
         * @param payload
         * @param payload.key   {Component} A react component to remove from the nav bar.
         * @param payload.group {string}    The group to remove the component from. 'default' if not provided.
         */

    }, {
        key: 'onComponentsRemoved',
        value: function onComponentsRemoved(payload) {
            var component = payload.component,
                group = payload.group;

            var componentGroup = this.componentGroups[group || 'default'];
            if (componentGroup && component) {
                // TODO: actually remove the component
                this.emitChange();
            }
        }

        /**
         *
         * @param payload
         */

    }, {
        key: 'onNavigate',
        value: function onNavigate(payload) {
            console.log(payload);
            this.emitChange();
        }
    }]);

    return NavBarItemStore;
}(BaseStore);

NavBarItemStore.storeName = 'NavBarItemStore';

NavBarItemStore.handlers = (_NavBarItemStore$hand = {}, _defineProperty(_NavBarItemStore$hand, NavActions.NAVIGATED, 'onNavigate'), _defineProperty(_NavBarItemStore$hand, NavActions.ITEMS_ADDED, 'onComponentsAdded'), _defineProperty(_NavBarItemStore$hand, NavActions.ITEMS_REMOVED, 'onComponentsRemoved'), _defineProperty(_NavBarItemStore$hand, NavActions.ACTIVE_GROUP_CHANGED, 'onActiveGroupChanged'), _NavBarItemStore$hand);

module.exports = NavBarItemStore;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _handlers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ = __webpack_require__(26);
var createStore = __webpack_require__(50);
var ActionConstants = __webpack_require__(35);

var SearchStore = createStore({
    storeName: 'SearchStore',
    handlers: (_handlers = {}, _defineProperty(_handlers, ActionConstants.SEARCH.SEARCH_TERM_CHANGED, 'onSearchTermChanged'), _defineProperty(_handlers, ActionConstants.SEARCH.SEARCH_RESULT_RETURNED, 'onSearchResultReturned'), _handlers),
    initialize: function initialize() {
        this.term = '';

        // Default to the search term, if it exists
        if (window.location.search) {
            // .substring(1) to remove the leading '?'
            _.forEach(window.location.search.substring(1).split('&'), function (pair) {
                var split = pair.split('=');
                if (split[0] === 'q') {
                    this.term = split[1].replace(/\+/g, ' ');
                }
            }, this);
        }
        this.results = [];
    },
    getTerm: function getTerm() {
        return this.term;
    },
    getResults: function getResults() {
        return this.results;
    },
    getState: function getState() {
        return {
            term: this.term,
            results: this.results
        };
    },
    onSearchTermChanged: function onSearchTermChanged(payload) {
        // If the term is empty, clear the results as well
        if (this.term === '') {
            this.results = [];
        }

        this.term = payload.term;
        this.emit('change');
    },
    onSearchResultReturned: function onSearchResultReturned(payload) {
        this.results = payload.results;
        this.emit('change');
    }
});

module.exports = SearchStore;

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var inherits = __webpack_require__(59);
var BaseStore = __webpack_require__(329);
var IGNORE_ON_PROTOTYPE = ['statics', 'storeName', 'handlers', 'mixins'];

function createChainedFunction(one, two) {
    return function chainedFunction() {
        one.apply(this, arguments);
        two.apply(this, arguments);
    };
}

function mixInto(dest, src) {
    Object.keys(src).forEach(function (prop) {
        if (-1 !== IGNORE_ON_PROTOTYPE.indexOf(prop)) {
            return;
        }
        if ('initialize' === prop) {
            if (!dest[prop]) {
                dest[prop] = src[prop];
            } else {
                dest[prop] = createChainedFunction(dest[prop], src[prop]);
            }
        } else {
            if (dest.hasOwnProperty(prop)) {
                throw new Error('Mixin property collision for property "' + prop + '"');
            }
            dest[prop] = src[prop];
        }
    });
}

/**
 * Helper for creating a store class
 * @method createStore
 * @param {Object} spec
 * @param {String} spec.storeName The name of the store
 * @param {Object} spec.handlers Hash of action name to method name of action handlers
 * @param {Function} spec.initialize Function called during construction for setting the default state
 * @param {Function} spec.dehydrate Function that returns serializable data to send to the client
 * @param {Function} spec.rehydrate Function that takes in serializable data to rehydrate the store
 */
module.exports = function createStore(spec) {
    spec.statics = spec.statics || {};
    if (!spec.storeName && !spec.statics.storeName) {
        throw new Error('createStore called without a storeName');
    }
    var Store = function (dispatcher) {
        BaseStore.call(this, dispatcher);
    };

    inherits(Store, BaseStore);

    Object.keys(spec.statics).forEach(function (prop) {
        Store[prop] = spec.statics[prop];
    });

    Store.storeName = spec.storeName || Store.storeName;
    Store.handlers = spec.handlers || Store.handlers;
    Store.mixins = spec.mixins || Store.mixins;

    if (Store.mixins) {
        Store.mixins.forEach(function(mixin) {
            mixInto(Store.prototype, mixin);
        });
    }
    mixInto(Store.prototype, spec);

    return Store;
};


/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This module was originally in bunsen and created by PeteJodo
 * Modified and relocated by Liliana on 12/22/15
 */



var $ = __webpack_require__(5);
var Proxier = __webpack_require__(149);
var LocalCartCollection = __webpack_require__(147);
var ServiceCartCollection = __webpack_require__(148);
var CartPortfolioItem = __webpack_require__(53);
var User = __webpack_require__(15);
var Clump = __webpack_require__(22);

var proxiedCart = void 0;
var localCart = void 0;
var serviceCart = void 0;

function saveLocalCartItems() {
    var saveComplete = $.Deferred();
    var clump = new Clump({ auto: true });
    $.when.apply($, localCart.models.reverse().map(function (cartItem) {
        return cartItem.save(null, { clump: clump });
    })).then(saveComplete.resolve, function (resp) {
        // saving duplicate returns 409
        if (resp.status === 409) {
            saveComplete.resolve();
        } else {
            localCart.trigger('cart:error', 'error merging cart data');
            saveComplete.reject();
        }
    });
    return saveComplete;
}

function setToServiceCart() {
    return User.load().done(function (userData) {
        var portfolioItems = userData.cart.items || [];
        var models = [];
        var saveComplete = void 0;
        portfolioItems.forEach(function (portfolioItem) {
            return models.push(new CartPortfolioItem(portfolioItem));
        });
        if (localCart.length > 0) {
            models.push.apply(models, localCart.models);
            saveComplete = saveLocalCartItems();
        } else {
            saveComplete = $.Deferred().resolve();
        }
        saveComplete.done(function () {
            if (localCart.length > 0) {
                localCart.reset();
            }
            proxiedCart.__proxySwitch(serviceCart);
            serviceCart.reset(models);
            serviceCart.checkStaleData();
            proxiedCart.trigger('cart:ready');
        });
    });
}

function initCartCollection() {
    localCart = new LocalCartCollection();
    serviceCart = new ServiceCartCollection();
    proxiedCart = new Proxier(localCart, { preserveEvents: true });
    setToServiceCart();
    if (!User.loggedIn()) {
        $.subscribe('login:change', function (e, data) {
            if (data.loggedIn) {
                setToServiceCart();
            }
        });
    }
}

module.exports.getCartCollection = function () {
    if (!proxiedCart) {
        initCartCollection();
    }
    return proxiedCart;
};

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var PortfolioItemCollection = __webpack_require__(125);
var CartPortfolioItem = __webpack_require__(53);
var Items = __webpack_require__(131);
var Storage = __webpack_require__(76);
var cartStorage = Storage.localStorage;

var LOCAL_STORAGE_ID = 'cart';

var LocalCartCollection = module.exports = PortfolioItemCollection.extend({
    model: CartPortfolioItem,

    comparator: function comparator(modelOne, modelTwo) {
        var localCart = cartStorage.getItem(LOCAL_STORAGE_ID);
        var localCartIdsArr = _.map(localCart, function (item) {
            return item.id;
        });
        return _.indexOf(localCartIdsArr, modelTwo.get('item.id')) - _.indexOf(localCartIdsArr, modelOne.get('item.id'));
    },
    fetch: function fetch(options) {
        var _this = this;

        var cartItems = cartStorage.getItem(LOCAL_STORAGE_ID);
        var numItems = options ? options.numberOfItems : false;
        var items;
        var itemIdsArr;
        var appendItemIdsArr = [];

        if (!cartItems || !cartItems.length || this.length === cartItems.length) {
            return $.Deferred().resolve();
        }
        itemIdsArr = cartItems.map(function (item) {
            return item.id;
        });
        items = new Items();
        if (numItems) {
            appendItemIdsArr = itemIdsArr.slice(0, -numItems);
            itemIdsArr = itemIdsArr.slice(-numItems);
        }
        items.setParam('pk', itemIdsArr.join(' '), { filterQuery: true });
        return items.fetchWithParameters().done(function (data) {
            _this.reset(data.result.items.map(function (item) {
                return new CartPortfolioItem({ item: item });
            }).concat(appendItemIdsArr.map(function (itemId) {
                return new CartPortfolioItem({ item: { id: itemId } });
            })));
        });
    },
    add: function add(model, options) {
        var _this2 = this;

        var cartPortfolioItem = new CartPortfolioItem();
        var localCart;
        var itemExists;
        var duplicate;

        if (_.isUndefined(model)) {
            return;
        }

        if (_.isArray(model)) {
            model.forEach(function (singleModel) {
                return _this2.add(singleModel, options);
            });
            return;
        }

        if (model instanceof CartPortfolioItem) {
            cartPortfolioItem = model;
        } else {
            cartPortfolioItem = new CartPortfolioItem();
            cartPortfolioItem.set({ item: model });
        }

        localCart = cartStorage.getItem(LOCAL_STORAGE_ID);
        if (localCart) {
            // check local storage for dupe
            itemExists = localCart.some(function (item) {
                return item.id === cartPortfolioItem.get('item.id');
            });
            if (!itemExists) {
                localCart.push({ id: cartPortfolioItem.get('item.id') });
                cartStorage.setItem(LOCAL_STORAGE_ID, JSON.stringify(localCart));
            }
        } else {
            localCart = [{ id: cartPortfolioItem.get('item.id') }];
            cartStorage.setItem(LOCAL_STORAGE_ID, JSON.stringify(localCart));
        }

        // check collection for dupe
        duplicate = this.find(function (existingModel) {
            return existingModel.get('item.id') === cartPortfolioItem.get('item.id');
        });
        if (duplicate) {
            // may not be necessary, but in case the newer model is inflated
            duplicate.set('item', cartPortfolioItem.get('item'));
            return;
        }

        return LocalCartCollection.__super__.add.call(this, cartPortfolioItem, options);
    },
    remove: function remove(model, options) {
        var _this3 = this;

        var localCart = cartStorage.getItem(LOCAL_STORAGE_ID);
        var updatedCart;

        if (_.isArray(model)) {
            model.forEach(function (singleModel) {
                return _this3.remove(singleModel, options);
            });
            return;
        }
        updatedCart = localCart ? localCart.filter(function (item) {
            return item.id !== model.get('item.id');
        }) : undefined;
        if (updatedCart) {
            cartStorage.setItem(LOCAL_STORAGE_ID, JSON.stringify(updatedCart));
        }
        return LocalCartCollection.__super__.remove.call(this, model, options);
    },
    reset: function reset(models, options) {
        if (_.isUndefined(models)) {
            cartStorage.deleteItem(LOCAL_STORAGE_ID);
        }
        return LocalCartCollection.__super__.reset.call(this, models, options);
    }
});

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var PortfolioItemCollection = __webpack_require__(125);
var CartPortfolioItem = __webpack_require__(53);
var Items = __webpack_require__(131);
var Storage = __webpack_require__(76);
var User = __webpack_require__(28);
var bunsen = __webpack_require__(21);
var endpoints = __webpack_require__(6);
var countStorage = Storage.sessionStorage;

var ServiceCartCollection = module.exports = PortfolioItemCollection.extend({
    model: CartPortfolioItem,
    url: function url() {
        return bunsen.extendURL(endpoints.cartPortfolio(User.getUserId()), { type: 'CART', loadItems: 'Y' });
    },
    comparator: function comparator(modelOne, modelTwo) {
        return modelTwo.get('id') - modelOne.get('id');
    },
    fetch: function fetch(options) {
        var _this = this;

        var numItems = options ? options.numberOfItems : false;
        var fetchPromise = void 0;
        if (numItems && numItems < this.length) {
            fetchPromise = this._fetchSome(numItems);
        } else {
            fetchPromise = ServiceCartCollection.__super__.fetch.call(this, Object.assign({ silent: true }, options));
        }
        // Make this a feature for other collections to make use of?
        return fetchPromise.then(function () {
            return _this.checkStaleData.call(_this, options) || fetchPromise;
        });
    },
    _fetchSome: function _fetchSome(numItems) {
        var _this2 = this;

        var itemIdsArr = void 0;
        var appendItemIdsArr = void 0;
        var items = void 0;

        if (!this.length) {
            return $.Deferred().resolve();
        }
        itemIdsArr = this.map(function (item) {
            return item.get('item.id');
        });
        items = new Items();
        itemIdsArr = itemIdsArr.slice(-numItems);
        appendItemIdsArr = itemIdsArr.slice(0, -numItems);
        items.setParam('pk', itemIdsArr.join(' '), { filterQuery: true });
        return items.fetchWithParameters().done(function (data) {
            _this2.reset(data.result.items.map(function (item) {
                return new CartPortfolioItem({ item: item });
            }).concat(appendItemIdsArr.map(function (itemId) {
                return new CartPortfolioItem({ item: { id: itemId } });
            })));
        });
    },
    checkStaleData: function checkStaleData(options) {
        // Necessary to handle stale data caused by bfcache in firefox/safari
        var storedCount = countStorage.getItem('cartCount');
        options = options || {};
        if (!(typeof storedCount === 'number') || options.numberOfItems < this.length) {
            return false;
        }
        if (storedCount !== this.length) {
            countStorage.deleteItem('cartCount');
            return this.fetch(options);
        }
        return false;
    },
    add: function add(model, options) {
        var _this3 = this;

        var cartPortfolioItem = void 0;
        var ret = void 0;

        if (Array.isArray(model)) {
            model.forEach(function (singleModel) {
                return _this3.add(singleModel, options);
            });
            return true;
        }
        if (model instanceof CartPortfolioItem) {
            cartPortfolioItem = model;
        } else {
            cartPortfolioItem = new CartPortfolioItem();
            cartPortfolioItem.set({ item: model });
            cartPortfolioItem.save({ 'item.id': model.get('id') });
        }
        ret = ServiceCartCollection.__super__.add.call(this, cartPortfolioItem, options);
        countStorage.setItem('cartCount', this.length);
        return ret;
    },
    remove: function remove(model, options) {
        var _this4 = this;

        var ret = void 0;
        if (Array.isArray(model)) {
            model.forEach(function (singleModel) {
                return _this4.remove(singleModel, options);
            });
            return false;
        }
        ret = ServiceCartCollection.__super__.remove.call(this, model, options);
        countStorage.setItem('cartCount', this.length);
        return ret;
    }
});

/***/ }),

/***/ 1486:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flexItem":"personalizationStyle__flexItem__uArjt","indexBump":"personalizationStyle__indexBump__3IxCV","container":"personalizationStyle__container___Kw0i","buttonGroupContainer":"personalizationStyle__buttonGroupContainer__bgujG","itemPageContainer":"personalizationStyle__itemPageContainer__3ZrXm","smallItemListContainer":"personalizationStyle__smallItemListContainer__3k1yW","smallItemWrapper":"personalizationStyle__smallItemWrapper__38p5_","itemContainer":"personalizationStyle__itemContainer__28Sy1","isMain":"personalizationStyle__isMain__3yxvN","mainImageContainer":"personalizationStyle__mainImageContainer__3xuO0 personalizationStyle__indexBump__3IxCV","smallItemImage":"personalizationStyle__smallItemImage__H9wys","itemTitle":"personalizationStyle__itemTitle__NbZ4o","viewAll":"personalizationStyle__viewAll__3Vdc8 personalizationStyle__indexBump__3IxCV","categoryTitle":"personalizationStyle__categoryTitle__nW8dt personalizationStyle__indexBump__3IxCV","mainItemImage":"personalizationStyle__mainItemImage__18krY","carouselDotControls":"personalizationStyle__carouselDotControls__7K35k","carouselItem":"personalizationStyle__carouselItem__Ox3hB","isMobile":"personalizationStyle__isMobile__BHM62","carouselListContainer":"personalizationStyle__carouselListContainer__3qiT_","carouselWrapper":"personalizationStyle__carouselWrapper__2sO2z","dotCarouselWrapper":"personalizationStyle__dotCarouselWrapper__1rBIC"};

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var _ = __webpack_require__(0);

/**
 * @class Proxier is a class that takes a target object as a parameter and returns another object
 *        that proxies/delegates any references to it to the target object. This is useful for
 *        instances like the cart that has an implementation for when a user is logged off and
 *        another for when they are logged in (see ProxiedCartCollection).
 *
 *  Sample Usage:
 *      var someModel = new Backbone.Model({ text: 'this belongs to someModel' });
 *      var anotherModel = new Backbone.Model({ text: 'this is anotherModel'});
 *      var proxiedObj = new Proxier(someModel);
 *      proxiedObj.get('text'); // "this belongs to someModel"
 *      proxiedObj.__proxySwitch(anotherModel);
 *      proxiedObj.get('text'); // "this is anotherModel"
 */

var PROXIER_PROPERTIES = ['__proxySwitch', '__preserveEvents', '__forcePrototype'];
var FORCE_PROXY_PROPS = ['_events', '_listenerId', '_listenId']; // These are not necessarily defined at proxy time

// only in underscore 1.8
var allKeys = function allKeys(obj) {
    var keys = [];
    if (!_.isObject(obj)) {
        return [];
    }
    for (var key in obj) {
        // eslint-disable-line
        keys.push(key);
    }
    return keys;
};

function bindProxy(obj, target, forcePrototype) {
    var proxy;
    var proxiedKeys = _.union(allKeys(target), FORCE_PROXY_PROPS);
    if (obj) {
        proxy = obj;
        _.each(allKeys(proxy), function (key) {
            if (!_.contains(PROXIER_PROPERTIES, key)) {
                delete proxy[key];
            }
        });
        // Computationally expensive, has to be forced
        if (Object.setPrototypeOf && forcePrototype) {
            Object.setPrototypeOf(proxy, Object.getPrototypeOf(target));
        }
    } else {
        proxy = Object.create(Object.getPrototypeOf(target)); // JS optimizer friendly
    }
    _.each(proxiedKeys, function (key) {
        Object.defineProperty(proxy, key, {
            configurable: true,
            get: function get() {
                return _.isFunction(target[key]) ? $.proxy(target[key], target) : target[key];
            },
            set: function set(val) {
                return target[key] = val;
            }
        });
    });
    return proxy;
}

/**
 * @param {object} target - the target object to proxy
 * @param {object} options - options object for Proxier
 * @param {boolean} options.preserveEvents - (optional) events on all objects are shared and handlers will
 *      only execute on the proxied object
 * @param {boolean} options.forcePrototype - (optional) force the prototype of the proxy to any new target
 *      so `instanceof` of the proxy will always match the object being proxied.
 *      NOTE: only do when necessary because it is computationally expensive to do.
 */
var Proxier = function Proxier(target, options) {
    options = options || {};
    this.__preserveEvents = options.preserveEvents;
    this.__forcePrototype = options.forcePrototype;
    this.__proxySwitch(target);
};

_.extend(Proxier.prototype, {
    __proxySwitch: function __proxySwitch(target) {
        var prevEvents;
        var listenId;
        var listenKey;
        if (this.__preserveEvents) {
            prevEvents = this._events || undefined;
            if (this._listenerId) {
                listenKey = '_listenerId';
                listenId = this._listenerId;
            } else if (this._listenId) {
                listenKey = '_listenId';
                listenId = this._listenId;
            }
        }
        bindProxy(this, target, this.__forcePrototype);
        this._events = prevEvents;
        if (listenKey && listenId) {
            this[listenKey] = listenId;
        }
        return this;
    }
});

module.exports = Proxier;

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.

var _ = __webpack_require__(155);
var Events = __webpack_require__(226).Events;

var urlError = __webpack_require__(54).urlError;
var wrapError = __webpack_require__(54).wrapError;

var array = [];
var push = array.push;
var slice = array.slice;
var splice = array.splice;

var Model = module.exports.Model = function(attributes, options) {
  var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    attrs = _.defaults({}, attrs, _.result(this, 'defaults'));
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    sync : function(){

      throw new Error("Sync component not used");

    },
    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true}, options);

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !options.wait) {
        if (!this.set(attrs, options)) return false;
      } else {
        if (!this._validate(attrs, options)) return false;
      }

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

Model.extend = __webpack_require__(54).extend;

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

const assign = __webpack_require__(156);
const CustomEvent = __webpack_require__(207);
module.exports = function (node, name, detail, options) {
    options = assign({
        bubbles: true,
        detail: detail
    }, options);
    return node.dispatchEvent(new CustomEvent(name, options));
};


/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var assign = __webpack_require__(213);
var contentKey = '__ellipsis-original-content';
var canscroll = function (el, tolerance) {
    var scrollRoom = 0,
        ost = 0, // old scroll top
        nst, // new scroll top
        origScrolltop;
    // Determine if $el can be scrolled by modifying scrollTop and checking if the change has stuck
    // Note: browsers have different tolerances.
    origScrolltop = el.scrollTop;
    el.scrollTop = 0;
    el.scrollTop = 1;
    nst = el.scrollTop; // new scroll top
    while (ost !== nst) {
        ost = el.scrollTop;
        el.scrollTop = ost + 1;
        nst = el.scrollTop;
        ++scrollRoom;
        if (scrollRoom > tolerance) { // break early if we can
            break;
        }
    }
    el.scrollTop = origScrolltop; // put it back so nobody suspects nothin'
    return scrollRoom > tolerance;
};
module.exports = function (el, config) {
    config = config || {};
    var _canscroll;
    var low = 0;
    var high;
    var test;
    var try_this;
    var truncated;
    var ellipsis;
    var after_ellipsis;
    var breakables;
    var content;
    config = assign({
        async: true,
        skip_slow_browsers: false,
        tolerance: 1, // maximum amount the element can scroll before triggering the truncation
        content: false, // if not supplied here, content will be scraped from the element itself using $.fn.html()
        ellipsis: " &hellip; " // will be concatenated to the end of the content if it is truncated
    }, config);
    _canscroll = canscroll.bind(null, el, config.tolerance);
    content = config.content;
    if (false === content) {
        content = el[contentKey];
        if (undefined === content) {
            content = el.innerHTML;
            el[content] = content;
        } else {
            el.innerHTML = content;
        }
    }
    if (!content) {
        return;
    }
    breakables = content.split(/\s/);
    if (!_canscroll()) {
        return;
    }
    el.innerHTML = "";
    breakables.push(" ");
    breakables.push(" ");
    low = 0;
    high = breakables.length;
    while (high > low + 1) { // binary search to find the scrolling point
        test = Math.floor((low + high) / 2);
        el.innerHTML = breakables.slice(0, test).join(" ") + " ";
        if (_canscroll()) {
            high = test;
        } else {
            low = test;
        }
    }
    var last = breakables.slice(0, high - 1).join(' ') + " ";
    after_ellipsis = document.createElement('span');
    after_ellipsis.style.display = 'none';
    after_ellipsis.classList.add('ellipsised-content');
    ellipsis = document.createElement('span');
    ellipsis.classList.add('ellipsis');
    ellipsis.innerHTML = config.ellipsis;
    truncated = document.createElement('span');
    truncated.classList.add('truncated-content');
    truncated.innerHTML = last;
    el.innerHTML = '';
    el.appendChild(truncated);
    el.appendChild(ellipsis);
    el.appendChild(after_ellipsis);
    try_this = last;
    // if the ellipsis has made the element scroll again, back off character by character until it doesnt
    while (try_this) {
        if (try_this.substr(-1).match(/\s/) && !_canscroll()) { // if we are at a space and cannot scroll
            break;
        }
        try_this = try_this.substr(0, try_this.length - 1);
        truncated.innerHTML = try_this;
    }
    if (try_this.length !== last.length) {
        after_ellipsis.innerHTML = last.substr(try_this.length - last.length);
    }
    after_ellipsis.innerHTML += breakables.slice(high - 1).join(" ");
    el.innerHTML = el.innerHTML.trim();
}


/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var forEach = __webpack_require__(58);
var debounce = __webpack_require__(111);
var classList = __webpack_require__(205);
var matches = __webpack_require__(37);

module.exports = [
    {
        name: 'click',
        init : function (bindingData, model, view) {
            this.addEventListener('click', function () {
                bindingData.apply(view, arguments);
            });
        }
    }, {
        // binds to object attributes. Attributes should be specified as a map from key (attribute name) to value (attribute value) in the binding expression. Attributes are set using Element.prototype.setAttribute
        name: 'prop',
        update : function () {
            forEach(arguments[0], function (attrValue, attrName) {
                if (!attrValue) {
                    this.removeAttribute(attrName);
                } else {
                    this.setAttribute(attrName, true);
                }
            }.bind(this));
        }
    }, {
        name: 'attr',
        update : function () {
            forEach(arguments[0], function (attrValue, attrName) {
                this.setAttribute(attrName, attrValue);
            }.bind(this));
        }
    }, {
        name: 'style',
        update : function () {
            forEach(arguments[0], function (attrValue, attrName) {
                this.setAttribute(attrName, attrValue);
            }.bind(this));
        }
    }, {
        name: 'css',
        update : function (bindingData) {
            var nodeClassList = classList(this);
            forEach(bindingData, function (v, k) {
                nodeClassList[v ? 'add' : 'remove'].apply(nodeClassList, k.split(' '));
            });
        }
    }, {
        // if the binding expression is false, the element is hidden, otherwise the element is shown.
        name: 'visible',
        update : function (bindingData) {
            if (bindingData) {
                this.style.display = '';
            } else {
                this.style.display = 'none';
            }
        }
    }, {
        name: 'hidden',
        update : function (bindingData) {
            this.style.visibility = bindingData ? 'visible' : 'hidden';
        }
    },
    {
        name: 'textarea',
        init : function (bindingData, model) {
            this.addEventListener('keyup', debounce(function () {
                model.set(bindingData, this.value);
            }.bind(this), 200));
        }
    }, {
        // binds the text of an element (using textContent property of element instance) to the binding expression
        name: 'text',
        update : function (bindingData) {
            this.textContent = bindingData;
        }
    }, {
        // binds the html of an element (using innerHTML property of element instance) to the binding expression
        name: 'html',
        update : function (bindingData) {
            this.innerHTML = bindingData;
        }
    }, {
        // binds the value of an input field to the value of the binding expression
        name: 'val',
        update: function (bindingData) {
            if (this.matches(':radio,:checkbox') && !matches(this, ':checked')) { // TODO: handle this case when the need arises
                console.warn("val binding for checkable elements is not yet supported");
                return;
            }
            this.value = bindingData;
        }
    }, {
        name: 'contenteditable',
        init : function (bindingData, model) {
            var contenteditable = this.getAttribute('contenteditable');
            var property = contenteditable.match(/^plaintext/) ? 'textContent' : 'innerHTML';
            var handler = function () {
                model.set(bindingData, this[property]());
            }.bind(this);
            ['change', 'keyup', 'keydown'].forEach(function (eventName) {
                this.addEventListener(eventName, handler);
            }.bind(this));
        }
    }, {
        name: 'contenteditablePlaintext',
        init : function (bindingData, model) {
            var handler = function () {
                model.set(bindingData, this.textContent);
            }.bind(this);
            ['change', 'keyup', 'keydown'].forEach(function (eventName) {
                this.addEventListener(eventName, handler);
            }.bind(this));
        }
    }, {
        name: 'modelval',
        init : function (bindingData, model) {
            this.addEventListener('change', function () {
                model.set(bindingData, this.value);
            }.bind(this));
        }
    }
];


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),

/***/ 156:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var Actions = SoaCollection.extend();

var Action = __webpack_require__(51);

_.extend(Actions.prototype, {
    model : Action,
    hasCode : function (code) {
        return this.any(function (action) {
            return action.isCode(code);
        });
    },
    getActionStartDate : function (code) {
        var action = this.findWhere({code: code});
        return action && action.get('startDate');
    }
});

module.exports = Actions;


/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/21/14
 * Time: 5:57 PM
 */



var SoaCollection = __webpack_require__(9);
var Disbursement = __webpack_require__(173);

module.exports = SoaCollection.extend({
    model: Disbursement,
    getDealerDisbursement: function () {
        return this.find(function (disbursement) {
            return disbursement.isDealerDisbursement();
        });
    },
    getShipperDisbursement: function () {
        return this.find(function (disbursement) {
            return disbursement.isShipperDisbursement();
        });
    }
});

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var EcomCharges = SoaCollection.extend();

var EcomCharge = __webpack_require__(174);

_.extend(EcomCharges.prototype, {
    model : EcomCharge
});

module.exports = EcomCharges;


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Lior Elrom
 * Date: 12/1/15
 * Time: 9:31 AM
 */



var SoaCollection = __webpack_require__(9);
var InvoiceItems = SoaCollection.extend();

var _ = __webpack_require__(0);
var InvoiceItem = __webpack_require__(175);

var getInvoiceItemAmountByType = function (type, currency) {
    var invoiceItems = this.filter(function (item) {
        return item.get('code') === type;
    });

    if (invoiceItems) {
        return _.reduce(invoiceItems, function (memo, item) {
            return memo + (parseFloat(item.getTotalAmount(currency)) || 0);
        }, 0);
    }
    return 0;
};

_.extend(InvoiceItems, {
    TYPE_OFFER_COST: 'OFFER_COST',
    TYPE_OFFER_SALES_TAX: 'OFFER_SALES_TAX',
    TYPE_OFFER_PROMOTION: 'OFFER_PROMOTION',
    TYPE_SHIPMENT_COST: 'SHIPMENT_COST',
    TYPE_SHIPMENT_SALES_TAX: 'SHIPMENT_SALES_TAX',
    TYPE_SHIPMENT_TOTAL_COST: 'SHIPMENT_TOTAL_COST',
    TYPE_DEALER_SHIPMENT_SALES_TAX: 'DEALER_SHIPMENT_SALES_TAX',
    TYPE_FIRSTDIBS_SHIPMENT_SALES_TAX: 'FIRSTDIBS_SHIPMENT_SALES_TAX',
    TYPE_ITEM_PRICE: 'ITEM_PRICE',
    TYPE_PRODUCT_CUSTOMIZATION: 'PRODUCT_CUSTOMIZATION',
    TYPE_ADJUSTMENT_SALES_TAX: 'ADJUSTMENT_SALES_TAX',
    TYPE_CUSTOMER_CHARGE: 'CUSTOMER_CHARGE',
    TYPE_DEALER_SHIPMENT_REFUND: 'DEALER_SHIPMENT_REFUND',
    TYPE_FIRSTDIBS_SHIPMENT_REFUND: 'FIRSTDIBS_SHIPMENT_REFUND',
    TYPE_ITEM_REFUND: 'ITEM_REFUND',
    TYPE_DEALER_REFUND: 'DEALER_REFUND'
});

_.extend(InvoiceItems.prototype, {
    model: InvoiceItem,
    getOfferCost             : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_OFFER_COST),
    getAdjustmentSalesTax    : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_ADJUSTMENT_SALES_TAX),
    getOfferSalesTax         : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_OFFER_SALES_TAX),
    getOfferPromotion        : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_OFFER_PROMOTION),
    getShipmentCost          : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_SHIPMENT_COST),
    getShipmentSalesTax      : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_SHIPMENT_SALES_TAX),
    getShipmentTotalCost     : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_SHIPMENT_TOTAL_COST),
    getItemPriceModification : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_ITEM_PRICE),
    getProductCustomization  : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_PRODUCT_CUSTOMIZATION),
    getCustomerCharge        : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_CUSTOMER_CHARGE),
    getDealerShipmentRefund  : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_DEALER_SHIPMENT_REFUND),
    getFirstDibsShipmentRefund  : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_FIRSTDIBS_SHIPMENT_REFUND),
    getItemRefund            : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_ITEM_REFUND),
    getDealerRefund          : _.partial(getInvoiceItemAmountByType, InvoiceItems.TYPE_DEALER_REFUND)
});

module.exports = InvoiceItems;


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/21/14
 * Time: 5:57 PM
 */



var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var Invoice = __webpack_require__(81);
var getInvoiceByFn = function (fn) {
    return this.find(function (invoice) {
        return invoice[fn]() && invoice.get("status") !== Invoice.STATUS_CANCELED;
    });
};

module.exports = SoaCollection.extend({
    model: Invoice,
    getDealerInvoice: _.partial(getInvoiceByFn, 'isDealerInvoice'),
    getBuyerInvoice: _.partial(getInvoiceByFn, 'isBuyerInvoice'),
    getShipperInvoice: _.partial(getInvoiceByFn, 'isShipperInvoice')
});


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var Offer = __webpack_require__(25);
var endpoints = __webpack_require__(6);
var moment = __webpack_require__(30);
var root = typeof window === 'undefined' ? global : window;

root.bunsen = root.bunsen || {};

/**
 * @mixes bunsen.SoaCollection
 * @class
 * @property {bunsen.Offer} model - {@link bunsen.Offer}
 * @property {bunsen.endpoints.offers} url -
 */
module.exports = root.bunsen.Offers = SoaCollection.extend({
    url: endpoints,
    model: Offer,
    comparator: function (offer) {
        return parseInt(moment(offer.get("createdDate")).format("X"), 10) || -1;
    },
    // Use getters in case this changes
    getMostRecent: function () {
        return this.last();
    },
    getMostRecentBuyerOffer: function () {
        return _.find(this.toArray().reverse(), function (o) {
            return o.isBuyerInitiatedOffer();
        });
    },
    getMostRecentDealerOffer: function () {
        return _.find(this.toArray().reverse(), function (o) {
            return o.isDealerInitiatedOffer();
        });
    },
    getFirst: function () {
        return this.first();
    }

});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/4/14
 * Time: 11:04 AM
 */



var SoaCollection = __webpack_require__(9);
var PaymentAuthorization = __webpack_require__(24);

module.exports = SoaCollection.extend({
    model: PaymentAuthorization,
    getOfferPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isOfferPaymentAuthorization();
        }, this);
    },
    getShippingPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isShippingPaymentAuthorization();
        }, this);
    },
    getActiveOfferPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isActive() && paymentAuth.isOfferPaymentAuthorization();
        }, this);
    },
    getActiveShippingPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isActive() && paymentAuth.isShippingPaymentAuthorization();
        }, this);
    },
    getDeniedCheckoutPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isDenied() && paymentAuth.isCheckoutPaymentAuthorization();
        }, this);
    },
    getCurrentCheckoutPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isCurrentCheckout() && paymentAuth.isCheckoutPaymentAuthorization();
        }, this);
    },
    getCurrentBalanceDuePaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isCurrentBalanceDue();
        }, this);
    },
    getBalanceDuePaymentAuthorizationForProcessing: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isReadyForProcessing() && paymentAuth.isBalanceDuePaymentAuthorization();
        }, this);
    },
    getCheckoutPaymentAuthorizationForProcessing: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isReadyForProcessing() && paymentAuth.isCheckoutPaymentAuthorization();
        }, this);
    },
    getStagedPaymentAuthorization: function () {
        return this.find(function (paymentAuth) {
            return paymentAuth.isStagedPaymentAuth();
        }, this);
    }
});

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 12/3/14
 * Time: 6:30 PM
 */



var SoaCollection = __webpack_require__(9);
var Promotions = module.exports = SoaCollection.extend();

var _ = __webpack_require__(0);
var Promotion = __webpack_require__(177);
var findByFn = function (fn) {
    return this.find(function (promo) {
        return promo[fn]();
    });
};

_.extend(Promotions.prototype, {
    model: Promotion,
    getActivePromo: _.partial(findByFn, 'isActive'),
    getInvalidPromo: _.partial(findByFn, 'isInvalid')
});


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var SoaCollection = __webpack_require__(9);
var Refunds = SoaCollection.extend();

var Refund = __webpack_require__(178);

_.extend(Refunds.prototype, {
    model : Refund
});

module.exports = Refunds;

/***/ }),

/***/ 1656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-cart'].join(' '), 'data-tn': 'cart', viewBox: '0 0 250 250' },
                React.createElement(
                    'g',
                    null,
                    React.createElement('path', { fill: 'none', d: 'M193.6,211.8c-4.7,0-8.6,3.9-8.6,8.7s3.9,8.7,8.6,8.7s8.6-3.9,8.6-8.7S198.3,211.8,193.6,211.8z' }),
                    React.createElement('path', { fill: 'none', d: 'M100.4,211.8c-4.7,0-8.6,3.9-8.6,8.7s3.9,8.7,8.6,8.7c4.7,0,8.6-3.9,8.6-8.7S105.1,211.8,100.4,211.8z' }),
                    React.createElement('path', { d: 'M61.6,53L50.8,7H0v11h42.2l9.5,40.4L74.1,181h149.5l25.1-128H61.6z M214.7,170H83.1L63.7,64h171.7L214.7,170z' }),
                    React.createElement('path', { d: 'M100.4,199.8c-11.3,0-20.4,9.3-20.4,20.7s9.2,20.7,20.4,20.7s20.4-9.3,20.4-20.7S111.7,199.8,100.4,199.8z M100.4,229.1 c-4.7,0-8.6-3.9-8.6-8.7s3.9-8.7,8.6-8.7c4.7,0,8.6,3.9,8.6,8.7S105.1,229.1,100.4,229.1z' }),
                    React.createElement('path', { d: 'M193.6,199.8c-11.3,0-20.4,9.3-20.4,20.7s9.2,20.7,20.4,20.7s20.4-9.3,20.4-20.7S204.9,199.8,193.6,199.8z M193.6,229.1 c-4.7,0-8.6-3.9-8.6-8.7s3.9-8.7,8.6-8.7s8.6,3.9,8.6,8.7S198.3,229.1,193.6,229.1z' }),
                    React.createElement('polygon', { fill: 'none', points: '63.7,64 83.1,170 214.7,170 235.5,64    ' })
                )
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by dev on 10/13/15.
 */


var SoaCollection = __webpack_require__(9);
var Review = __webpack_require__(82);
var Reviews = module.exports = SoaCollection.extend();

module.exports = SoaCollection.extend({
    model: Review,
    getShippingRequest: function () {
        return this.findWhere({'type': Review.TYPE_SHIPPING_REQUEST});
    },
    removeShippingRequestReview: function () {
        this.remove(this.getShippingRequest());
    }
});

/***/ }),

/***/ 1667:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-message'].join(' '), 'data-tn': 'message', viewBox: '0 0 250 250' },
                React.createElement(
                    'g',
                    null,
                    React.createElement('path', { d: 'M189,249.6L119.6,183H0V11h250v172h-61V249.6z M8,175h114.8l58.2,55.8V175h61V19H8V175z' })
                )
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SoaCollection = __webpack_require__(9);
var Message = __webpack_require__(73);
var moment = __webpack_require__(30);
module.exports = SoaCollection.extend({
    model: Message,
    comparator: function (modelOne, modelTwo) {
        // if a model isn't from server, it should come last
        if (!modelOne.id) {
            return 1;
        }
        if (!modelTwo.id) {
            return -1;
        }
        return moment(modelOne.get('createdDate')).format('X') - moment(modelTwo.get('createdDate')).format('X');
    },
    initialize : function (models, options) {
        this.conversationId = options.conversationId;
    }
});


/***/ }),

/***/ 1674:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-storefront'].join(' '), 'data-tn': 'storefront', viewBox: '0 0 250 250' },
                React.createElement(
                    'g',
                    null,
                    React.createElement('rect', { x: '45', y: '23', width: '160', height: '8' }),
                    React.createElement('rect', { x: '133.8', y: '135.3', transform: 'matrix(0.7012 -0.713 0.713 0.7012 -55.6632 145.7103)', width: '24.3', height: '8' }),
                    React.createElement('rect', { x: '136.4', y: '147.9', transform: 'matrix(0.7058 -0.7084 0.7084 0.7058 -59.9895 159.4118)', width: '51', height: '8' }),
                    React.createElement('rect', { x: '172.5', y: '153.8', transform: 'matrix(-0.7033 -0.7109 0.7109 -0.7033 182.7199 407.7907)', width: '8', height: '24' }),
                    React.createElement('path', { d: 'M65,175h20v-39H65V175z M73,144h4v23h-4V144z' }),
                    React.createElement('path', { d: 'M224,117.5c7.1-1.5,18.7-6.7,20.6-24.5h5.9L215.4,7H35.6L0,93h5.5C7.5,111.6,20,116.5,27,117.7V210H5v32h242v-32h-23V117.5 M105,210v-99.8c4.4,4.6,10.5,8,18.6,8c1.9,0,17.6-0.4,23.8-15.8c4.2,7.8,11.9,15.6,24.2,15.6c0,0,0.1,0,0.1,0 c2.2,0,16.8-0.5,23.2-14.6c4,6.9,10.7,13.6,21.1,14.6v92H105z M59.3,93h36.1c-2.2,17.2-16.1,17.2-17.7,17.2l-0.2,0 c-11.3,0-16.6-9.3-18.8-15C59,94.4,59.2,93.7,59.3,93z M104.1,93h37.4c-2.2,17.2-16.1,17.2-17.7,17.2l-0.2,0 C110.7,110.2,105.7,98,104.1,93z M152.1,93h37.4c-2.2,17.2-16.1,17.2-17.7,17.2l-0.2,0C158.7,110.1,153.7,98.1,152.1,93z M218.8,110.2l-0.2,0c-12.9,0-18-12.1-19.5-17.2h37.4C234.3,110.2,220.4,110.2,218.8,110.2z M41,15h169l28.6,70H12L41,15z M13.6,93 h36.1c0.1,0.7,0.3,1.4,0.6,2.2c-2.2,5.7-7.5,15-18.7,15l-0.2,0C30.7,110.2,15.9,110.6,13.6,93z M35,117.9c9.3-1.2,15.6-7,19.5-13.3 c4.4,7.1,11.8,13.6,23,13.6c1.5,0,12.2-0.2,19.5-8.7V210H35V117.9z M239,234H13v-16h226V234z' })
                )
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);

// ---------------------------------------------------
// Module Definition

// This makes the function do nothing on prod/testing environments
// So that we don't generate errors.
var checkProps = module.exports = function () {};

// The block below re-defining the checkProps module gets
// removed on prod/testing environments
/* develblock:start */
/**
 * @module checkProps
 * @type {function}
 * @param {object} propsConfig
 *      An object with keys being the allowed
 *      keys of the 'values' parameter, and the
 *      values being type or constructor function
 * @param {object} values
 *      An object with keys and values being of the
 *      name/type combination specified in the
 *      propsConfig parameter
 * @param {object} errorMessageCallbacks
 *      If you want to replace any of the callbacks
 *      for specific kinds of errors.
 *
 * @property {PropsChecker} PropsChecker
 */
checkProps = module.exports = function (propsConfig, values, errorMessageCallbacks) {
    return new checkProps.PropsChecker(propsConfig, errorMessageCallbacks).checkValues(values);
};
/* develblock:end */

// ---------------------------------------------------
// Define Module Static Properties

/**
 * @class PropsChecker
 * @memberOf module:checkProps
 * @param {object} propsConfig
 * @param {object} options
 * @constructor
 */
var PropsChecker = function (propsConfig, options) {
    options = options || {};
    this.propsConfig = propsConfig || this.propsConfig;
    this.handleTypeErrors = options.handleTypeErrors || this.handleTypeErrors;
    this.supportedError = options.supportedError || this.supportedError;
    this.parentProp = options.parentProp || this.parentProp;
    this._options = options;
};

checkProps.PropsChecker = PropsChecker;

_.extend(PropsChecker.prototype, {

    /**
     * @param {object} errorMessageCallbacks
     * @returns {PropsChecker}
     */
    setErrorMessageCallbacks: function (errorMessageCallbacks) {
        errorMessageCallbacks = errorMessageCallbacks || {};
        return this;
    },

    /**
     * @param {object} values
     * @returns {PropsChecker}
     */
    checkValues: function (values) {
        var propName;

        if (values === null || values === undefined) {
            return this;
        }

        if (typeof values !== 'object') {
            return this.valuesIsObjectError();
        }

        for (propName in values) {
            if (values.hasOwnProperty(propName)) {
                this.checkValueForProp(propName, values);
            }
        }

        return this;
    },

    /**
     * If you want to evaluate a specific property
     * and test it for type errors
     * @param {string} propName
     * @param {object} values
     * @returns {PropsChecker}
     */
    checkValueForProp: function (propName, values) {
        var propsConfig = this.propsConfig;
        var isArray;
        var typeErrors;
        var types;
        var value;

        if (!propsConfig.hasOwnProperty(propName)) {

            this.handleSupportedError(propName);

        } else {

            value = values[propName];
            types = propsConfig[propName];
            isArray = _.isArray(types);

            if (!isArray && typeof types === 'object') {
                new checkProps.PropsChecker(types, this._getOptionsClone(propName)).checkValues(value);
                return this;
            }

            types = isArray ? types : [types];

            if (_.first(types) === '*' || value === null || value === undefined) {
                return this;
            }

            typeErrors = this.findErrorsForEachType(types, value);
            if (typeErrors && typeErrors.length) {
                this.handleTypeErrors(propName, typeErrors);
            }

        }
        return this;
    },

    findErrorsForEachType: function (types, value) {
        var errors = [];
        var i = 0;
        var hasValidType;
        for (i; i < types.length; i++) {
            errors.push(this.findErrorsForType(types[i], value));
        }
        hasValidType = _.any(errors, function (error) {
            return error === null;
        });
        if (!hasValidType) {
            return errors;
        }
        return null;
    },

    findErrorsForType: function (type, value) {
        if (typeof type === 'string') {
            if (type === 'array' && !this.checkIsArray(value)) {
                return {
                    key: 'array',
                    typeVal: 'array'
                };
            } else if (!this.checkTypeof(type, value))  {
                return {
                    key: 'type',
                    typeVal: type
                };
            }
        } else if (typeof type === 'function' && !this.checkIsInstanceOf(type, value)) {
            return {
                key: 'instanceof',
                typeVal: type
            };
        }
        return null;
    },

    checkTypeof: function (type, value) {
        return typeof value === type;
    },

    checkIsArray: function (value) {
        return _.isArray(value);
    },

    checkIsInstanceOf: function (type, value) {
        return value instanceof type;
    },

    handleTypeErrors: function (propName, typeErrors) {
        console.error('Property ' + this._getFormatedPropName(propName) + ' is not of the correct ' +
            'type: must be one of the following: ', _.pluck(typeErrors, 'typeVal'));
        return this;
    },

    handleSupportedError: function (propName) {
        console.error(this.supportedError(propName));
        return this;
    },

    /**
     * @param {string} propName
     * @returns {string}
     */
    supportedError: function (propName) {
        return "Property name '" + this._getFormatedPropName(propName) + "' not supported";
    },

    setIsSubPropForName: function (propName) {
        this.subPropName = propName;
        return this;
    },

    valuesIsObjectError: function () {
        if (this.subPropName) {
            console.error('Property ' + this.subPropName + ' must have an object for it\'s value');
        } else {
            console.error('Values must be an object');
        }
        return this;
    },

    _getFormatedPropName: function (propName) {
        if (this.parentProp) {
            propName = this.parentProp + '.' + propName;
        }
        return propName;
    },

    _getOptionsClone : function (parentProperty) {
        return _.extend({}, this._options, { parentProp: parentProperty });
    }

});


/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(5);
var _ = __webpack_require__(0);

var deferredHelpers = module.exports = {
    /**
     * Returns a promise that resolves after a delay
     * @param timeout in ms
     * @returns Promise
     */
    wait: function (timeout) {
        return $.Deferred(function (dfd) {
            setTimeout(dfd.resolve, timeout);
        }).promise();
    },
    /**
     * Wraps a promise in a deferred so we can cancel it
     * @private
     */
    wrapDeferred: function (jqXHR) {
        var dfd = new $.Deferred();
        jqXHR.then(dfd.resolve, dfd.reject);
        return dfd;
    },
    /**
     * Cancels an unresolved deferred after timeout has elapsed
     * @param dfd
     * @param timeout
     */
    cancelAfter: function (dfd, timeout) {
        var id = setTimeout(function () {
            if (dfd.state() === 'pending') {
                dfd.reject({status: 'timeout'});
            }
        }, timeout);

        dfd.done(function () {
            clearTimeout(id);
        });
    },
    /**
     * Run the provided function over and over until it works!
     * @param fn a function that returns a promise
     * @param maxTries number of times to retry
     * @param {Function} [condition] only retry if condition is true
     */


    retry: function (fn, maxTries, condition) {
        return fn().then(null, function (result) {
            if (maxTries > 1) {
                if (_.isFunction(condition) && !condition(result)) {
                    return result;
                }
                return deferredHelpers.retry(fn, maxTries - 1, condition);
            }
            return result;
        });
    },
    /**
     * Retry the jqXhr returning function over and over until it's not a 500
     * @param fn
     * @param maxTries
     * @returns {*}
     */
    retry500: function (fn, maxTries) {
        return deferredHelpers.retry(fn, maxTries, function (jq) {
            return jq.status >= 500;
        });
    }
};

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/5/15
 * Time: 7:20 PM
 */



var braintree;
if (typeof window !== 'undefined') {
    braintree = window.braintree;
}

module.exports = {
    checkout: function (clientToken, options) {
        return braintree.setup(clientToken, 'paypal', options);
    },
    /**
     * Takes a paypalData object from braintree and transforms it into an object
     * representing a backend PayPalAccount model
     * @param paypalData
     * @returns {{nonce: *, firstName: *, lastName: *, email: *, billingAddress: {city: *, country: (exports.displayLabels.countryCode|*|exports.displayTransforms.countryCode), line1: (*|mockUS.line1|mockNonUS.line1|UserProfile.displayLabels.line1|exports.displayLabels.line1|line1), line2: (*|mockUS.line2|mockNonUS.line2|UserProfile.displayLabels.line2|exports.displayLabels.line2|line2), zipCode: (.billingAddress.postalCode|*), state: *}}}
     */
    getPayPalModelData: function (paypalData) {
        var details;
        var billingAddress;
        paypalData = paypalData || {};
        details = paypalData.details || {};
        billingAddress = details.billingAddress || {};
        return {
            nonce: paypalData.nonce,
            firstName: details.firstName,
            lastName: details.lastName,
            email: details.email,
            billingAddress: {
                city: billingAddress.locality,
                country: billingAddress.countryCodeAlpha2,
                line1: billingAddress.streetAddress,
                line2: billingAddress.extendedAddress,
                zipCode: billingAddress.postalCode,
                state: billingAddress.region
            }
        };
    }
};


/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/***
 * abstracts a file object into an attachment that can be uploaded to the boss service
 * options.uploadType : "image", "csv", or "message_center"
 * options.allowedFileType {array} - MIME types to support
 */

var SoaModel = __webpack_require__(2);
var Deferred = __webpack_require__(29).Deferred;
var bunsen = __webpack_require__(21);
var endpoints = __webpack_require__(6);
var filesize = __webpack_require__(199);
var Qs = __webpack_require__(41);
var assign = __webpack_require__(60);
var last = __webpack_require__(134);
var flow = __webpack_require__(200);
var FormData = __webpack_require__(139);

var Attachment = module.exports = SoaModel.extend({
    url : function (method) {
        if (this.uploadType === 'itemImage') {
            return endpoints.itemImageUpload();
        } else {
            return endpoints.cmsUpload(this.uploadType, method === 'create' ? this.get('dir') : undefined);
        }
    },
    sync : function (method, model, passedOptions) {
        // custom sync function so we can perform a multipart upload per the spec here: https://sites.google.com/a/1stdibs.com/wiki/home/engineering/services-documentation/boss-service/generic-file-uploader?pli=1
        var lastSave = Deferred();
        //always include user token in param
        var params = bunsen.getToken();
        var isDelete = method === 'delete';
        var defaultOptions;
        var options;
        var sank;

        if (passedOptions.itemId) {
            params.itemId = passedOptions.itemId;
        }

        if (isDelete) {
            params.keys = this.get('key');
            defaultOptions = {
                type: 'DELETE'
            };
        } else {
            defaultOptions = {
                xhr : function () { // make our own xhr so we can notify lastSave of its progress events
                    var xhr = new XMLHttpRequest();
                    xhr.upload.addEventListener("progress", function (e) {
                        this.set('upload-sent', e.loaded);
                        this.set('upload-total', e.total);
                        this.set('bitrate', e.bitrate);
                        lastSave.notify(e);
                    }.bind(this));
                    return xhr;
                }.bind(this),
                clump: false, // prevents autoclump from handing this
                type: 'POST',
                contentType: false, // forces multipart
                processData: false,
                data : new FormData(),
                cache : false
            };

            this.set('uploadStatus', 'pending');
        }

        defaultOptions.url = this.url(method) + "?" + Qs.stringify(params);
        options = assign(defaultOptions, passedOptions);

        sank = this.loaded.then(function (file) {
            var _sank;
            if (!isDelete && file) {
                defaultOptions.data.append('files', file, file.name);
            }
            _sank = Attachment.__super__.sync.call(this, method, model, options)
                .done(lastSave.resolve.bind(lastSave))
                .fail(lastSave.reject.bind(lastSave));
            lastSave.abort = _sank.abort.bind(_sank);
            return _sank;
        }.bind(this));

        //set lastSave promise if it has not been attached to the model
        if (!this.lastSave) {
            lastSave.always(flow(lastSave.state.bind(lastSave), this.set.bind(this, 'uploadStatus')));
            this.lastSave = lastSave;
        }
        return lastSave;
    },
    parseFile : function () {
        var file = this.get('file');
        var parsedFile = Deferred();
        var arrayBufferReader;
        var dataUrlReader;
        // TODO: fileBlob should be unset here, but is currently causing parseFile() to be called repeatedly due to 'change:fileBlob'
        //this.set('fileBlob', undefined);
        if (undefined === file) {
            return; // file not set yet
        }
        this.set('fileName', file.name);
        this.set('fileSize', file.size);
        this.set('displaySize', filesize(file.size));
        // update data-uri attribute
        if (!window.FileReader) {
            return;
        }
        arrayBufferReader = new window.FileReader();
        arrayBufferReader.onloadend = function () {
            var type = file.type;
            // workaround for chrome bug where mime type was not read correctly for xls files
            if (!type && last(file.name.split('.')) === 'xls') {
                type = 'application/vnd.ms-excel';
            }
            this.set('fileBlob', new Blob([arrayBufferReader.result], { type : type }));
            this.get('fileBlob').name = file.name;
            this.set('attachmentType', type);
            parsedFile.resolve(this.get('fileBlob'));
        }.bind(this);
        try {
            arrayBufferReader.readAsArrayBuffer(file);
        } catch (e) {
            parsedFile.reject();
            if (!(e instanceof TypeError)) {
                throw e;
            }
        }
        // need separate reader to avoid 'busy' error
        dataUrlReader = new window.FileReader();
        dataUrlReader.onloadend = function () {
            this.set('dataURI', dataUrlReader.result);
        }.bind(this);
        try {
            dataUrlReader.readAsDataURL(file);
        } catch (e) { /* do nothing if error occurs when reading data url */ }
        return parsedFile.promise();
    },
    parseAttachment: function () {
        this.set({
            'displayName': this.toDisplayName(this.get('sharedPath')),
            'displaySize': filesize(this.get('fileSize')),
            'thumbnailPath': this.getThumbnailPath(),
            'originalPath': this.isImageType() ? this.getOriginalPath() : this.getFullPath()
        });
    },
    toDisplayName: function (fileName) {
        return fileName && last(fileName.split('\\'));
    },
    getThumbnailPath: function () {
        return this.getFullPath('thumbnail');
    },
    getOriginalPath: function () {
        return this.getFullPath('original');
    },
    getFullPath: function (variantValue) {
        var sharedPath = this.get('sharedPath');

        if (variantValue) {
            sharedPath = this.replaceVariant(sharedPath, variantValue);
        }

        return [this.get('webPath'), this.get('webPathSuffix'), sharedPath].join('');
    },
    replaceVariant: function (path, value) {
        return path && path.replace('{variant}', value);
    },
    isImageType: function () {
        var type = this.get('attachmentType');
        return type && type.toLowerCase().indexOf('image') > -1;
    },
    initialize : function (attributes, options) {
        options = assign({
            allowedFileTypes: undefined,
            uploadType : 'image'
        }, options);
        this.uploadType = options.uploadType;

        //user uploaded file
        if (this.get('file')) {
            this.loaded = this.parseFile();
            //attachment coming from mc service
        } else if (this.get('sharedPath') && this.get('webPath')) {
            this.parseAttachment();
            this.loaded = Deferred().resolve().promise();
        }

        this.on('request', function (attachment, XHR) {
            this._xhr = XHR;
        });
    },
    // file failed to upload for some reason, abort request
    abort : function () {
        if (this._xhr.readyState !== 0 && this._xhr.readyState !== 4) {
            this._xhr.abort();
        }
    },
    defaults: {
        attachmentType: ''
    }
});


/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by augustocorvalan on 7/17/15.
 */


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var AnchorList = __webpack_require__(331);
var AnchorMember = __webpack_require__(80);

var PromoAnchorList = module.exports = AnchorList.extend();

_.extend(PromoAnchorList, {
    createAnchorList: function (sourceType, ids, note) {
        return new PromoAnchorList({ members: AnchorMember.createAnchorMembers(sourceType, ids, note) });
    }
});

_.extend(PromoAnchorList.prototype, {
    relations: SoaModel.createRelations([
        {
            key:          'members',
            type:         Backbone.Many,
            relatedModel: AnchorMember
        }
    ]),
    getIds: function () {
        var members = this.get('members') || [];
        return members.map(function (member) {
            return member.get('anchor.sourceId');
        });
    }
});


/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Rob
 * Date: 8/20/13
 */


var SoaModel = __webpack_require__(2);
var Disbursement = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

// Attaching to bunsen until bOMT and checkout are commonJS
module.exports = root.bunsen.Disbursement = Disbursement;

var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var PaymentMethod = __webpack_require__(56);
var endpoints = __webpack_require__(6);
var Party = __webpack_require__(8);
var FinancialAmount = __webpack_require__(10);
var transitionMixin = __webpack_require__(19);

_.extend(Disbursement, {
    STATUS_NEW: 'NEW',
    STATUS_PAID: 'PAID'
});

_.extend(Disbursement.prototype, {
    idAttribute: "id",
    defaults: {
        paymentMethod: {}
    },
    url : function () {
        return endpoints.disbursement(this.get(this.idAttribute));
    },
    relations: [
        {
            key: 'paymentMethod',
            relatedModel: PaymentMethod,
            type: Backbone.One,
            saveJSONFields: ['paymentMethodType', 'apiType']
        },
        {
            key: 'payTo',
            relatedModel: Party,
            type: Backbone.One
        },
        {
            key: 'totalAmount',
            relatedModel: FinancialAmount,
            type: Backbone.One
        }
    ],
    isDealerDisbursement: function () {
        return this.get('payTo').isSeller();
    },
    isShipperDisbursement: function () {
        return this.get('payTo').isShipper();
    },
    isPaid: function () {
        return this.get('status') === Disbursement.STATUS_PAID;
    },
    isNewStatus: function () {
        return this.get('status') === Disbursement.STATUS_NEW;
    }
}, transitionMixin);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var EcomCharge = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Backbone = __webpack_require__(3);

var Party = __webpack_require__(8);
var FinancialAmount = __webpack_require__(10);

_.extend(EcomCharge, {

});

_.extend(EcomCharge.prototype, {
    relations : SoaModel.createRelations([
        {
            key : 'chargeParty',
            relatedModel : Party,
            type : Backbone.One
        },
        {
            key : 'amount',
            relatedModel : FinancialAmount,
            type : Backbone.One
        }

    ])
});



/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Lior Elrom
 * Date: 12/1/15
 * Time: 10:32 AM
 */



var SoaModel = __webpack_require__(2);
var InvoiceItem = SoaModel.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var financialAmountMixin = __webpack_require__(48);
var FinancialAmount = __webpack_require__(10);

_.extend(InvoiceItem.prototype, {
    relations: [
        {
            type: Backbone.One,
            key: 'subTotalAmount',
            relatedModel: FinancialAmount
        },
        {
            type: Backbone.One,
            key: 'totalAmount',
            relatedModel: FinancialAmount
        }
    ]
}, financialAmountMixin);

module.exports = InvoiceItem;


/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by lior on 12/4/14.
 */



var _ = __webpack_require__(0);
var SoaModel = __webpack_require__(2);
var PaymentProviderResponse = module.exports = SoaModel.extend();

var propEquals = function (propName, value) {
    return this.get(propName) === value;
};

_.extend(PaymentProviderResponse, {
    STATUS_SUCCESS: 'SUCCESS',
    STATUS_DATA_ERROR: 'DATA_ERROR',
    STATUS_PROCESSOR_ERROR: 'PROCESSOR_ERROR',
    ACTION_RESERVE: 'RESERVE',
    ACTION_CAPTURE: 'CAPTURE',
    ACTION_VAULT: 'VAULT_TRANSACTION'
});

_.extend(PaymentProviderResponse.prototype, {
    getErrorStatus: function () {
        return this.get('status');
    },
    isDataError: _.partial(propEquals, 'status', PaymentProviderResponse.STATUS_DATA_ERROR),
    isProcessorError: _.partial(propEquals, 'status', PaymentProviderResponse.STATUS_PROCESSOR_ERROR),
    isSuccess: _.partial(propEquals, 'status', PaymentProviderResponse.STATUS_SUCCESS),
    isReserveTransaction: _.partial(propEquals, 'requestAction', PaymentProviderResponse.ACTION_RESERVE),
    isCaptureTransaction: _.partial(propEquals, 'requestAction', PaymentProviderResponse.ACTION_CAPTURE),
    isVaultTransaction: _.partial(propEquals, 'requestAction', PaymentProviderResponse.ACTION_VAULT)
});



/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 12/3/14
 * Time: 6:33 PM
 */



var SoaModel = __webpack_require__(2);
var Promotion = module.exports = SoaModel.extend();

var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Backbone = __webpack_require__(3);
var Adjustment = __webpack_require__(132);
var Rule = __webpack_require__(179);
var Anchor = __webpack_require__(12);
var ruleTypes = ['ItemList', 'DealerList', 'BuyerList', 'PurchaseHistory', 'VerticalList', 'PriceRange', 'UsesPerBuyer', 'UsesPerCode'];
var ruleTypeMap = {
    'ItemList': [Rule.TYPE_ITEM_WHITE, Rule.TYPE_ITEM_BLACK],
    'DealerList': [Rule.TYPE_DEALER_WHITE, Rule.TYPE_DEALER_BLACK],
    'BuyerList': [Rule.TYPE_BUYER_WHITE, Rule.TYPE_BUYER_BLACK],
    'PurchaseHistory': [Rule.TYPE_PURCHASE_HISTORY],
    'VerticalList': [Rule.TYPE_VERTICAL_WHITE],
    'PriceRange': [Rule.TYPE_PRICE_RANGE],
    'UsesPerBuyer': [Rule.TYPE_USES_PER_BUYER],
    'UsesPerCode': [Rule.TYPE_USES_PER_CODE],
    'VerifiedTradeBuyer': [Rule.TYPE_VERIFIED_TRADE]
};
var buyerErrors = ["USES_PER_BUYER_EXCEEDED_ERROR", "BUYER_BLACKLIST_ERROR", "BUYER_WHITELIST_ERROR", "PURCHASE_HISTORY_ERROR"];

// ---------------------------------------------------
// Factory Methods
var getAdjustmentRateByApiType = function (apiType) {
    var adjustmentRateList = this.get('adjustmentRateList');
    if (adjustmentRateList) {
        return adjustmentRateList.findWhere({apiType: apiType});
    }
};

var hasAdjustmentRateApiType = function () {
    return !!getAdjustmentRateByApiType.apply(this, arguments);
};

var setAdjustment = function (apiType, rate, eligibleAmount) {
    // you can only have one adjustment for now
    this.set('adjustmentRateList', [{
        apiType: apiType,
        reference: Adjustment.REFERENCE_FIRSTDIBS_PROMOTION_OFFER_DISCOUNT,
        rate: rate,
        eligibleAmount: eligibleAmount,
        calculationTarget: {
            documentType : 'OFFER'
        }
    }]);
};

/**
 * @param {array} apiTypes
 */
var getRule = function (apiTypes) {
    var self = this;
    var rule;

    _.find(apiTypes, function (apiType) {
        rule = self.get('ruleList').findWhere({ apiType: apiType });
        return rule;
    });

    return rule;
};

/**
 * @param {array} apiTypes
 */
var removeRule = function (apiTypes) {
    var ruleList = this.get('ruleList');

    _.each(apiTypes, function (apiType) {
        return ruleList.remove(ruleList.where({ apiType: apiType }));
    });

    return this;
};

var addRule = function (apiType, name, sourceType, ids, note) {
    return this._addSingletonRule(apiType, Rule.createRule(apiType, name, sourceType, ids, note));
};

var addBlackWhiteRule = function (apiType, name, sourceType, conflictingRuleName, ids, note) {
    var conflictingRule = getRule.call(this, [conflictingRuleName]);

    if (conflictingRule) {
        removeRule.call(this, [conflictingRuleName]);
    }

    addRule.call(this, apiType, name, sourceType, ids, note);
};

var getRuleTypeFunctions = function (functionPrefix, baseFunction) {
    var ret = {};

    _.each(ruleTypes, function (ruleType) {
        ret[functionPrefix + ruleType + 'Rule'] = _.partial(baseFunction, ruleTypeMap[ruleType]);
    });

    return ret;
};
var getRuleGetters = _.partial(getRuleTypeFunctions, 'get', getRule);
var getRuleRemovers = _.partial(getRuleTypeFunctions, 'remove', removeRule);

// ---------------------------------------------------
// Instance Properties
_.extend(Promotion.prototype, {
    url: function () {
        return endpoints.promotion(this.id);
    },
    defaults: {
        'ruleList': [],
        'source': {
            'role': 'INTERNAL'
        }
    },
    relations: SoaModel.createRelations([
        'validationResult',
        {
            key: 'adjustmentRateList',
            type: Backbone.Many,
            relatedModel: Adjustment
        },
        {
            key: 'ruleList',
            type: Backbone.Many,
            relatedModel: Rule
        }
    ]),
    activate: function () {
        return this.set('status', 'ENABLED').save();
    },
    isDraft: function () {
        return this.get('status') === 'DRAFT';
    },
    isInvalid: function () {
        var validationSuccess = this.get('validationResult.success');
        return _.isBoolean(validationSuccess) ? !validationSuccess : false;
    },
    isActive: function () {
        return !this.isNew() && !this.isInvalid();
    },
    getDiscountRate: function () {
        var adjustmentRate = this.get('adjustmentRateList[0]');
        return adjustmentRate && adjustmentRate.get('rate');
    },
    getEligibleAmount: function (currency) {
        var adjustmentRate = this.get('adjustmentRateList[0]');
        return adjustmentRate && adjustmentRate.getEligibleAmount(currency);
    },
    getEligibleAmountCurrency: function () {
        var eligibleAmount = this.get('adjustmentRateList[0].eligibleAmount');
        return eligibleAmount && eligibleAmount.get('currency');
    },
    hasEligibleAmount: function () {
        var eligibleAmount = this.get('adjustmentRateList[0].eligibleAmount');
        var amount = eligibleAmount && eligibleAmount.get('amount');
        return $.isNumeric(amount) && Number(amount) !== 0;
    },
    hasBuyerError: function () {
        return _.contains(buyerErrors, this.get('validationResult.code'));
    },
    getDiscountCurrency: function () {
        return this.getFlatDiscountCurrency() || this.getEligibleAmountCurrency();
    },
    isPercentDiscount: _.partial(hasAdjustmentRateApiType, Adjustment.APITYPE_PERCENT),
    isFlatDiscount: _.partial(hasAdjustmentRateApiType, Adjustment.APITYPE_FLAT),
    getFlatDiscountCurrency: function () {
        return this.isFlatDiscount() && this.get('adjustmentRateList[0].rate.currency');
    },
    setFlatAdjustment: function (amount, currency) {
        setAdjustment.call(this, Adjustment.APITYPE_FLAT, {amount: amount, currency: currency});
    },
    setPercentAdjustment: function (rate, eligibleAmount, eligibleAmountCurrency) {
        var eligibleAmountObj;

        if (eligibleAmount) {
            eligibleAmountObj = {amount: eligibleAmount, currency: eligibleAmountCurrency};
        }

        setAdjustment.call(this, Adjustment.APITYPE_PERCENT, rate, eligibleAmountObj);
    },
    _addSingletonRule: function (apiType, rule) {
        //only one rule of each kind can exist at a time
        removeRule.call(this, [apiType]);

        if (rule) {
            return this.get('ruleList').add(rule);
        }
    },
    addPriceRangeRule: function (currency, minAmount, maxAmount) {
        this._addSingletonRule(Rule.TYPE_PRICE_RANGE, Rule.createPriceRangeRule(currency, minAmount, maxAmount));
    },
    addHistoryTimePeriodRule: function (days) {
        return this._addSingletonRule(Rule.TYPE_PURCHASE_HISTORY, Rule.createHistoryTimePeriodRule(days));
    },
    addPurchaseHistoryRule: function (startDate, endDate) {
        return this._addSingletonRule(Rule.TYPE_PURCHASE_HISTORY, Rule.createPurchaseHistoryRule(startDate, endDate));
    },
    addVerifiedTradeRule: function () {
        return this._addSingletonRule(Rule.TYPE_VERIFIED_TRADE, Rule.createVerifiedTradeRule());
    },
    removeVerifiedTradeRule : function () {
        return removeRule.call(this, [Rule.TYPE_VERIFIED_TRADE]);
    },
    addUsesPerBuyerRule: function (numberOfUses) {
        return this._addSingletonRule(Rule.TYPE_USES_PER_BUYER, Rule.createUsesPerBuyerRule(numberOfUses));
    },
    addUsesPerCodeRule: function (numberOfUses) {
        return this._addSingletonRule(Rule.TYPE_USES_PER_CODE, Rule.createUsesPerCodeRule(numberOfUses));
    },
    addIdsToCustomerList: function (ids, note) {
        var rule = this.getBuyerListRule();
        return rule.addIdsToCustomerList(ids, note);
    },

    addItemWhitelistRule:        _.partial(addBlackWhiteRule, Rule.TYPE_ITEM_WHITE, 'Item Whitelist', Anchor.TYPE_ITEM, 'itemBlacklistRule'),
    addItemBlacklistRule:        _.partial(addBlackWhiteRule, Rule.TYPE_ITEM_BLACK, 'Item Blacklist', Anchor.TYPE_ITEM, 'itemWhitelistRule'),
    addDealerWhitelistRule:      _.partial(addBlackWhiteRule, Rule.TYPE_DEALER_WHITE, 'Dealer Whitelist', Anchor.TYPE_SELLER, 'dealerBlacklistRule'),
    addDealerBlacklistRule:      _.partial(addBlackWhiteRule, Rule.TYPE_DEALER_BLACK, 'Dealer Blacklist', Anchor.TYPE_SELLER, 'dealerWhitelistRule'),
    addBuyerWhitelistRule:       _.partial(addBlackWhiteRule, Rule.TYPE_BUYER_WHITE, 'Buyer Whitelist', Anchor.TYPE_USER, 'buyerBlacklistRule'),
    addBuyerBlacklistRule:       _.partial(addBlackWhiteRule, Rule.TYPE_BUYER_BLACK, 'Buyer Blacklist', Anchor.TYPE_USER, 'buyerWhitelistRule'),
    addVerticalWhitelistRule:    _.partial(addBlackWhiteRule, Rule.TYPE_VERTICAL_WHITE, 'Vertical Whitelist', Anchor.TYPE_VERTICAL, 'verticalWhitelistRule')
}, getRuleGetters(), getRuleRemovers());


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var Refund = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Backbone = __webpack_require__(3);

var EcomCharges = __webpack_require__(159);
var Notes = __webpack_require__(23);

_.extend(Refund, {
    REASON_DEALER_CANCEL_BEFORE_SHIP : "DEALER_CANCEL_BEFORE_SHIP",
    REASON_CUSTOMER_CANCEL_BEFORE_SHIP_IN_POLICY : "CUSTOMER_CANCEL_BEFORE_SHIP_IN_POLICY",
    REASON_CUSTOMER_CANCEL_BEFORE_SHIP_OUTSIDE_POLICY : "CUSTOMER_CANCEL_BEFORE_SHIP_OUTSIDE_POLICY",
    REASON_ITEM_NOT_RECEIVED : "ITEM_NOT_RECEIVED",
    REASON_ITEM_ARRIVED_DAMAGED : "ITEM_ARRIVED_DAMAGED",
    REASON_ITEM_NOT_AS_DESCRIBED : "ITEM_NOT_AS_DESCRIBED",
    REASON_ITEM_NO_LONGER_DESIRED_IN_POLICY : "ITEM_NO_LONGER_DESIRED_IN_POLICY",
    REASON_ITEM_NO_LONGER_DESIRED_OUTSIDE_POLICY : "ITEM_NO_LONGER_DESIRED_OUTSIDE_POLICY",
    REASON_ITEM_AND_SHIPPING_COST_REDUCTION : "ITEM_AND_SHIPPING_COST_REDUCTION",
    REASON_ITEM_COST_REDUCTION : "ITEM_COST_REDUCTION",
    REASON_SHIPPING_COST_REDUCTION : "SHIPPING_COST_REDUCTION",
    REASON_OTHER : "OTHER",

    STATE_NEW : "NEW"
});

_.extend(Refund.prototype, {
    url: function () {
        return endpoints.refund(this.id);
    },
    relations : SoaModel.createRelations([
        {
            key : 'charges',
            collectionType : EcomCharges,
            type : Backbone.Many
        },
        {
            key : 'notes',
            collectionType : Notes,
            type : Backbone.Many
        }
    ])
});



/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by augustocorvalan on 1/28/15.
 */


// ---------------------------------------------------
// Dependencies
var SoaModel = __webpack_require__(2);
var Anchor = __webpack_require__(12);
var AnchorMember = __webpack_require__(80);
var Rule = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var PromotionAnchorList = __webpack_require__(172);
var FinancialAmount = __webpack_require__(10);
var endpoints = __webpack_require__(6);
//Local Vars
var types;
var _matchApiType;

// ---------------------------------------------------
// Factory Methods
_matchApiType = function (arr) {
    return _.contains(arr, this.get('apiType'));
};

// ---------------------------------------------------
// Static Properties and Methods
types = {
    TYPE_BUYER_WHITE:       'buyerWhitelistRule',
    TYPE_BUYER_BLACK:       'buyerBlacklistRule',
    TYPE_DEALER_WHITE:      'dealerWhitelistRule',
    TYPE_DEALER_BLACK:      'dealerBlacklistRule',
    TYPE_ITEM_WHITE:        'itemWhitelistRule',
    TYPE_ITEM_BLACK:        'itemBlacklistRule',
    TYPE_VERTICAL_WHITE:    'verticalWhitelistRule',
    TYPE_PRICE_RANGE:       'priceRangeRule',
    TYPE_PURCHASE_HISTORY:  'purchaseHistoryRule',
    TYPE_VERIFIED_TRADE:    'verifiedTradeBuyerRule',
    TYPE_USES_PER_BUYER:    'usesPerBuyerRule',
    TYPE_USES_PER_CODE:     'usesPerCodeRule'
};

_.extend(Rule, types, {
    TYPE_WHITELIST:         [types.TYPE_DEALER_WHITE, types.TYPE_BUYER_WHITE, types.TYPE_ITEM_WHITE, types.TYPE_VERTICAL_WHITE],
    TYPE_BLACKLIST:         [types.TYPE_DEALER_BLACK, types.TYPE_BUYER_BLACK, types.TYPE_ITEM_BLACK],
    /**
     * @param {string} apiType
     * @param {string} name
     * @param {string} sourceType
     * @param {array} ids
     * @returns {object}
     */
    createRule: function (apiType, name, sourceType, ids, note) {
        return new Rule ({
            apiType: apiType,
            name: name,
            anchorList: PromotionAnchorList.createAnchorList(sourceType, ids, note)
        });
    },
    /**
     * @param {number} numberOfUses
     * @returns {Rule}
     */
    createUsesPerBuyerRule: function (numberOfUses) {
        return new Rule({
            apiType: Rule.TYPE_USES_PER_BUYER,
            usesPerBuyer: numberOfUses
        });
    },

    createUsesPerCodeRule: function (numberOfUses) {
        return new Rule({
            apiType: Rule.TYPE_USES_PER_CODE,
            usesPerCode: numberOfUses
        });
    },
    /**
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @returns {Rule}
     */
    createPurchaseHistoryRule: function (startDate, endDate) {
        var rule = new Rule({
            apiType: Rule.TYPE_PURCHASE_HISTORY
        });

        if (startDate) {
            rule.set('historyStartDate', startDate);
        }

        if (endDate) {
            rule.set('historyEndDate', endDate);
        }

        return rule;
    },
    /**
     * @returns {Rule}
     */
    createVerifiedTradeRule: function () {
        return new Rule({ apiType : Rule.TYPE_VERIFIED_TRADE })
    },
    /**
     * @param {number} days
     * @returns {Rule}
     */
    createHistoryTimePeriodRule: function (days) {
        return new Rule({
            apiType: Rule.TYPE_PURCHASE_HISTORY,
            historyTimePeriod: {
                numberOfUnits: days,
                timeUnit: 'DAY',
                calendarType: 'BASIC'
            }
        });
    },
    /**
     * @param {string} currency
     * @param {number} [minAmount]
     * @param {number} [maxAmount]
     * @returns {Rule}
     */
    createPriceRangeRule: function (currency, minAmount, maxAmount) {
        var rule = new Rule({
            apiType: Rule.TYPE_PRICE_RANGE
        });

        if (minAmount) {
            rule.set('minAmount', { currency: currency, amount: minAmount });
        }

        if (maxAmount) {
            rule.set('maxAmount', { currency: currency, amount: maxAmount });
        }

        return rule;
    }
});

// ---------------------------------------------------
// Instance Methods and Properties
_.extend(Rule.prototype, {
    relations: SoaModel.createRelations([
        {
            type: Backbone.One,
            key: 'anchorList',
            relatedModel: PromotionAnchorList
        },
        {
            type: Backbone.One,
            key: 'minAmount',
            relatedModel: FinancialAmount
        },
        {
            type: Backbone.One,
            key: 'maxAmount',
            relatedModel: FinancialAmount
        }
    ]),
    getIds: function () {
        var anchorList = this.get('anchorList');
        return anchorList && anchorList.getIds();
    },
    getIdTotalCount: function () {
        var anchorList = this.get('anchorList');
        return anchorList && anchorList.get('totalSize');
    },
    getPriceRangeCurrency: function () {
        var min = this.get('minAmount');
        var max = this.get('maxAmount');

        return min && min.getCurrency() || max && max.getCurrency();
    },
    isPriceRangeCurrency: function (currency) {
        return this.getPriceRangeCurrency() === currency;
    },
    addIdsToCustomerList: function (ids, note) {
        var self = this;
        var members = AnchorMember.createAnchorMembers(Anchor.TYPE_USER, ids, note);

        return members.sync("create", members, {
            url: endpoints.promotionRuleAnchor(self.get('id'))
        });
    },
    isWhitelist:            _.partial(_matchApiType, Rule.TYPE_WHITELIST),
    isBlacklist:            _.partial(_matchApiType, Rule.TYPE_BLACKLIST),
    isItemListRule:         _.partial(_matchApiType, [Rule.TYPE_ITEM_WHITE, Rule.TYPE_ITEM_BLACK]),
    isDealerListRule:       _.partial(_matchApiType, [Rule.TYPE_DEALER_BLACK, Rule.TYPE_DEALER_WHITE]),
    isBuyerListRule:        _.partial(_matchApiType, [Rule.TYPE_BUYER_WHITE, Rule.TYPE_BUYER_BLACK]),
    isPriceRangeRule:       _.partial(_matchApiType, [Rule.TYPE_PRICE_RANGE]),
    isVerticalRule:         _.partial(_matchApiType, [Rule.TYPE_VERTICAL_WHITE]),
    isPurchaseHistoryRule:  _.partial(_matchApiType, [Rule.TYPE_PURCHASE_HISTORY]),
    isUsesPerBuyerRule:     _.partial(_matchApiType, [Rule.TYPE_USES_PER_BUYER]),
    isUsesPerCodeRule:      _.partial(_matchApiType, [Rule.TYPE_USES_PER_CODE])
});


/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/20/13
 */

var SoaModel = __webpack_require__(2);
var ShipmentContent = SoaModel.extend();

module.exports = ShipmentContent;

var Backbone = __webpack_require__(3);
var Item = __webpack_require__(34);
var _ = __webpack_require__(0);

/**
 * @class ShipmentContent
 * @extends SoaModel
 * @property {array} relations
 *      @property relations.type {Backbone.One}
 *      @property relations.key {string}- "item"
 *      @property relations.relatedModel {Backbone.Model}
 *      @property relations.collectionType {Backbone.Models}
 */
_.extend(ShipmentContent.prototype, {
    relations : SoaModel.createRelations([
        {
            type: Backbone.One,
            key: 'item',
            relatedModel: Item,
            saveJSONFields : ['id', 'apiType', 'vertical']
        }
    ])
});

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Joe Forzano
 * Date: January 7th, 2015
 */



// ---------------------------------------------------
// Load Super Class

var SoaModel = __webpack_require__(2);
var Carrier = __webpack_require__(319);
var Backbone = __webpack_require__(3);


// ---------------------------------------------------
// Module Definition

var ShipmentTracking = module.exports = SoaModel.extend();


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);


// ---------------------------------------------------
// Local Vars


// ---------------------------------------------------
// Define Module Instance Properties

_.extend(ShipmentTracking.prototype, {
    defaults: {
        trackingNumber : '',
        carrier: {}
    },

    relations: function () {
        return SoaModel.createRelations([
            {
                type: Backbone.One,
                key: 'carrier',
                relatedModel: Carrier
            }
        ]);
    }
});

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 10/8/13
 * Time: 5:54 PM
 */


var PaymentMethod = __webpack_require__(11);
var ACH = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

/**
 * @mixes bunsen.PaymentMethod
 * @class
 */
_.extend(ACH.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'ACH';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'ACH'
        };
    }
});


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Lior Elrom
 * Date: 6/30/15
 * Time: 3:55 PM
 */



var _ = __webpack_require__(0);
var PaymentMethod = __webpack_require__(11);
var creditCardMixin = __webpack_require__(84);
var ApplePay = PaymentMethod.extend();

module.exports = ApplePay;

_.extend(ApplePay.prototype, {
    defaults : {
        apiType: 'applePay',
        paymentMethodType: PaymentMethod.TYPE_APPLE_PAY
    },
    getDisplayVal: function () {
        return 'Apple Pay';
    },
    getLastNumbers: function () {
        return this.get('cardLastNumbers');
    },
    getCardType: function () {
        return this.get('cardType');
    }
}, creditCardMixin);


/***/ }),

/***/ 1830:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TrendingItems = __webpack_require__(1889);

var _require = __webpack_require__(1138),
    ACTIONS = _require.ACTIONS,
    STORE = _require.STORE;

var User = __webpack_require__(15);

// NOTE: Contract can be found in GROWTH-700
var trendingActions = {
    fetch: function fetch(actionContext, payload, done) {
        var collection = new TrendingItems();
        var type = payload.type,
            categoryLevels = payload.categoryLevels,
            parentCategoryKey = payload.parentCategoryKey,
            query = payload.query,
            _payload$pageSize = payload.pageSize,
            pageSize = _payload$pageSize === undefined ? 1 : _payload$pageSize,
            collectionKey = payload.collectionKey;


        collection.setParam('trendType', type).setParam('categoryLevels', categoryLevels).setParam('parentCategoryKey', parentCategoryKey).setParam('userIds', User.getUserId()).setParam('query', query).setParam('pageSize', pageSize);

        Promise.resolve(collection.fetchWithParameters()).then(function () {
            actionContext.dispatch(STORE.FETCH_SUCCESS, { collectionKey: collectionKey, collection: collection });
            done();
        }).catch(function () {
            done();
        });
    },
    fetchByCategory: function fetchByCategory(actionContext, payload, done) {
        var _payload$categoryLeve = payload.categoryLevel,
            categoryLevel = _payload$categoryLeve === undefined ? 3 : _payload$categoryLeve,
            _payload$itemsPageSiz = payload.itemsPageSize,
            itemsPageSize = _payload$itemsPageSiz === undefined ? 30 : _payload$itemsPageSiz,
            collectionKey = payload.collectionKey,
            pageSize = payload.pageSize,
            fields = payload.fields;


        var fieldsQuery = fields ? '&fields=' + fields : '';

        actionContext.executeAction(trendingActions.fetch, {
            type: ACTIONS.TYPE.CATEGORY,
            categoryLevels: categoryLevel,
            collectionKey: collectionKey,
            pageSize: pageSize,
            query: 'pageSize=' + itemsPageSize + fieldsQuery + '&filterQuery=category_search:1,vertical:{vertical},l2_url_label:{l2_url_label},l3_url_label:{l3_url_label},l4_url_label:{l4_url_label}&sort=releasedate desc,sort_cs_status asc,priority asc'
        }).then(function () {
            return done();
        });
    }
};

module.exports = trendingActions;

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */


var PaymentMethod = __webpack_require__(11);
var Cash = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

/**
 * @mixes bunsen.PaymentMethod
 * @class
 */
_.extend(Cash.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Cash';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'CASH'
        };
    }
});


/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */


var PaymentMethod = __webpack_require__(11);
var Check = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

module.exports = Check;

/**
 * @mixes bunsen.PaymentMethod
 * @class
 */
_.extend(Check.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Check';
    },
    defaults : function () {
        return {
            apiType : 'check',
            paymentMethodType : 'CHECK'
        };
    }
});


/***/ }),

/***/ 186:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PaymentMethodModel = __webpack_require__(11);
var CreditCard = module.exports = PaymentMethodModel.extend();
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var Address = __webpack_require__(32);
var creditCardMixin = __webpack_require__(84);
var ends = __webpack_require__(6);
var Token = __webpack_require__(135);
var braintree;
var cardTypeMap;

__webpack_require__(79);

// braintree can only be used in a browser
if (typeof window !== 'undefined') {
    braintree = window.braintree;
}


// jquery-payment card types mapped to service types
cardTypeMap = {
    visa:  PaymentMethodModel.CARD_TYPE_VISA,
    mastercard:  PaymentMethodModel.CARD_TYPE_MASTER,
    discover:  PaymentMethodModel.CARD_TYPE_DISCOVER,
    amex:  PaymentMethodModel.CARD_TYPE_AMEX
};

_.extend(CreditCard.prototype, {
    idAttribute: "token",
    defaults : {
        apiType : 'creditCard',
        paymentMethodType : PaymentMethodModel.TYPE_CREDIT_CARD,
        billingAddress: {}
    },
    url: function () {
        return ends.savedCard(this.getUserId(), this.get('hashedCardNumber'));
    },
    relations: [
        {
            type: Backbone.One,
            key: 'billingAddress',
            relatedModel: Address
        }
    ],
    getDisplayVal: function () {
        return 'Credit Card';
    },
    getLastNumbers: function () {
        var maskedCardNumber = this.get('maskedCardNumber');
        return maskedCardNumber.substr(-4);
    },
    getCardType: function () {
        var maskedCardNumber = this.get('maskedCardNumber');
        var jqueryPaymentCardType = maskedCardNumber && $.payment.cardType(maskedCardNumber);
        return cardTypeMap[jqueryPaymentCardType];
    },
    updateMaskedCardNumber : function () {
        var ccN = this.get('creditCardNumber') || '';
        this.set('maskedCardNumber', ccN.replace(/[^0-9]/g, '').replace(/^(\d{6})\d+(\d{4})$/, '$1******$2'));
    },
    makeNewCard: function () {
        return new CreditCard(this.omit('id', 'token', 'cardType'));
    },
    removeSpacesFromCreditCard: function () {
        var number = this.get('creditCardNumber');
        this.set('creditCardNumber', number.replace(/ /g, ''));
    },
    deleteFromWallet: function (userId, options) {
        var url = ends.savedCard(userId, this.get('hashedCardNumber'));
        options = _.extend({url: url}, options);
        return this.destroy(options);
    },
    saveToVault: function (userId, options) {
        var vaultRequest;
        options = _.extend({
            url: ends.vault(userId)
        }, options);

        options.queries = _.extend({
            paymentMethodNonce: this.get('nonce')
        }, options.queries);

        vaultRequest = new SoaModel();
        return vaultRequest.save({}, options);
    },
    saveToSellerVault : function (sellerId, options) {
      var vaultRequest;
      options = _.extend({
          url: ends.sellerVault(sellerId)
      }, options);

      options.queries = _.extend({
          paymentMethodNonce: this.get('nonce')
      }, options.queries);

      vaultRequest = new SoaModel();
      return vaultRequest.save({}, options);
    },
    setNonce: function (options) {
    // this method only works in the browser due to braintree-web limitations
        var clientToken = new Token();
        options = options || { validate : true };
        return clientToken.fetchClientToken().then(function () {
            var def = $.Deferred();
            var client = new braintree.api.Client({clientToken: clientToken.get('value')});
            var tokenizeObject = {
                number: this.get('creditCardNumber'),
                cardholderName: this.get('cardHolderName'),
                expirationMonth: this.get('cardExpiryMonth'),
                expirationYear: this.get('cardExpiryYear'),
                // Address if AVS is on
                billingAddress: {
                    firstName: this.get('billingAddress.firstName') || null,
                    lastName: this.get('billingAddress.lastName') || null,
                    company: this.get('billingAddress.company') || null,
                    streetAddress: this.get('billingAddress.line1'),
                    extendedAddress: this.get('billingAddress.line2') || null,
                    locality: this.get('billingAddress.city'),
                    region: this.get('billingAddress.state'),
                    postalCode: this.get('billingAddress.zipCode'),
                    countryCodeAlpha2: this.get('billingAddress.country')
                }
            };

            if (options.validate) {
                tokenizeObject.cvv = this.get('securityCode')
            }

            client.tokenizeCard(tokenizeObject, function (err, nonce) {
                if (err) {
                    def.reject(err);
                    return;
                }
                this.set('nonce', nonce);
                def.resolve(nonce);
            }.bind(this));

            return def.promise();
        }.bind(this));

    }
}, creditCardMixin);


/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */

var PaymentMethod = __webpack_require__(11);
var CreditToUserAccount = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

_.extend(CreditToUserAccount.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Credit to dealer account';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'CREDIT_TO_USER_ACCOUNT'
        };
    }
});


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */


var PaymentMethod = __webpack_require__(11);
var DirectPayment = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

_.extend(DirectPayment.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Direct Payment';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'DIRECT_PAYMENT'
        };
    }
});


/***/ }),

/***/ 1889:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);

var TrendingItem = __webpack_require__(1892);
var endpoints = __webpack_require__(6);

var TrendingItems = SoaCollection.extend({
    url: endpoints.trending(),
    model: TrendingItem,

    TYPE_CATEGORY: 'CATEGORY',
    TYPE_ATTRIBUTE: 'ATTRIBUTE',
    TYPE_ITEM: 'ITEM'
});

module.exports = TrendingItems;

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */


var PaymentMethod = __webpack_require__(11);
var Discount = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

_.extend(Discount.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Discount';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'DISCOUNT'
        };
    }
});


/***/ }),

/***/ 1892:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var endpoints = __webpack_require__(6);

var TrendingItems = SoaModel.extend({
    url: endpoints.recommendations()
});

module.exports = TrendingItems;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/30/14
 * Time: 2:39 PM
 */


var _ = __webpack_require__(0);
var $ = __webpack_require__(5);
var Clump = __webpack_require__(22);
var Party = __webpack_require__(8);
var Note = __webpack_require__(33);
var baseTransitionMixin = __webpack_require__(312);



module.exports = {
    transition: function (status, passedOptions) {
        this.set('status', status);
        return baseTransitionMixin.transition.call(this, passedOptions);
    },
    updateAndTransition: function (status, passedOptions) {
        this.set('status', status);
        return baseTransitionMixin.updateAndTransition.call(this, passedOptions);
    },
    update: function (status, passedOptions) {
        return baseTransitionMixin.update.call(this, passedOptions);
    },
    /**
     * Transitions the document and anchors a note
     * @param {string} status to transition to
     * @param {object} passedOptions
     * @param passedOptions.noteContent
     * @param passedOptions.noteRole The note role
     * @param passedOptions.noteType The note type
     * @returns {$.Deferred.promise}
     */
    transitionWithNote: function (status, passedOptions) {
        var clump = new Clump();
        var saves = this._clumpTransitionWithNote(clump, status, passedOptions);
        clump.run({dynaOptions: {
            open: '___',
            close: '___',
            params: {
                anchorId: {
                    clumpElement: "transition",
                    expression: "$.result.id"
                }
            }
        }});
        return $.when.apply($, saves);
    },
    /**
     * @private
     * @param {Clump} clump
     * @param {string} status
     * @param {object} passedOptions Options representing new note attributes
     * @returns {$.deferred.promise[]}
     */
    _clumpTransitionWithNote: function (clump, status, passedOptions) {
        var saves = [];
        var note;
        var saveNote = false;
        var options = _.extend({
            clump: clump,
            clumpName: 'transition',
            clumpProfile: 'transition',
            transitionFunction: 'transition'
        }, passedOptions);

        // Save Note
        if (options.noteContent) {
            note = this.newNote({
                content: options.noteContent,
                role: options.noteRole,
                type: options.noteType
            });
            if (this.isNew()) {
                note.setAnchorId(this.anchorType, '___anchorId___');
            }
            if (options.saveNoteFirst) {
                saves.push(note.save(null, { clump: clump }));
            } else {
                saveNote = true;
            }
        }

        // Transition self
        saves.push(this[options.transitionFunction](status, options));

        // the note MUST be saved after the transition for the dynaparam anchor id
        // to work
        if (saveNote && !options.saveNoteFirst) {
            saves.push(note.save(null, { clump: clump }));
        }
        return saves;
    },
    /**
     * Transition this model while taking action on an offer at the same time
     * @param status {String} status to transition this model to
     * @param passedOptions options for this function described below
     * @param passedOptions.offer {Object} offer to accept or counter
     * @param passedOptions.counterOffer {Object} offer to counter with, null if accepting
     * @param passedOptions.noteContent {Object} note to anchor to the counter offer
     * @param passedOptions.noteRole {Object} note to anchor to the counter offer
     * @param passedOptions.noteType {Object} note to anchor to the counter offer
     */
    transitionWithOfferNote: function (status, passedOptions) {
        var saves = [];
        var options = passedOptions || {};
        var dynaOptions;
        var clump = new Clump();

        if (!!options.noteContent) {
            dynaOptions = {
                open: '___',
                close: '___',
                params: {
                    anchorId: {
                        clumpElement: "transition",
                        expression: "$.result.id"
                    },
                    counterOfferId: {
                        clumpElement: "counterOffer",
                        expression: "$.result.counterOfferId"
                    }
                }
            };
        }

        if (options.counterOffer) {
            saves = options.offer.clumpCounterOfferNote(clump, options);
            // Note has been saved, remove it so it is not saved when this is transitioned
            options.noteContent = undefined;
        } else {
            if (!passedOptions.offer.isAccepted()) {
                saves = [options.offer.accept({clump: clump})];
            }
        }
        saves.push(this._clumpTransitionWithNote(clump, status, options));
        clump.run({dynaOptions: dynaOptions});
        return $.when.apply($, _.flatten(saves));
    },
    dealerTransitionWithOfferNote: function (status, offer, counterOffer, passedOptions) {
        var options = _.extend({
            offer: offer,
            counterOffer: counterOffer,
            noteRole: Party.ROLE_SELLER,
            noteType: Note.TYPE_BUYER_SELLER
        }, passedOptions);
        return this.transitionWithOfferNote(status, options);
    }
};


/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */


var PaymentMethod = __webpack_require__(11);
var NotAvailable = module.exports = PaymentMethod.extend();
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

_.extend(NotAvailable.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    getDisplayVal: function () {
        return 'Not Available';
    },
    defaults : function () {
        return {
            apiType : PaymentMethod.prototype.defaults.apiType, //Only For Now
            paymentMethodType : 'NOT_AVAILABLE'
        };
    }
});


/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/11/15
 * Time: 4:41 PM
 */



var PaymentMethod = __webpack_require__(11);
var PayPalAccount = module.exports = PaymentMethod.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var WalletPaymentMethod = __webpack_require__(193);
var Address = __webpack_require__(32);
var paypal = __webpack_require__(170);
var ends = __webpack_require__(6);

_.extend(PayPalAccount.prototype, {
    defaults: {
        apiType : 'payPalAccount',
        paymentMethodType : 'PAYPAL_ACCOUNT',
        billingAddress: {}
    },
    relations: [
        {
            type: Backbone.One,
            key: 'billingAddress',
            relatedModel: Address
        }
    ],
    getDisplayVal: function () {
        return 'PayPal';
    },
    setFromBraintree: function (paypalData) {
        this.set(paypal.getPayPalModelData(paypalData));
    },
    saveToVault: function (userId, options) {
        var vaultRequest;
        options = _.extend({
            url: ends.vault(userId)
        }, options);

        options.queries = _.extend({
            paymentMethodNonce: this.get('nonce')
        }, options.queries);

        vaultRequest = new WalletPaymentMethod();
        return vaultRequest.save({}, options)
            .then(function () {
                var paymentMethod = vaultRequest.get('paymentMethod');
                this.clear();
                if (paymentMethod) {
                    this.set(paymentMethod.toJSON());
                }
            }.bind(this));
    }
});

_.extend(PayPalAccount, {
    createFromBraintree: function (paypalData) {
        return new PayPalAccount(paypal.getPayPalModelData(paypalData));
    }
});


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/27/13
 */

var PaymentMethod = __webpack_require__(11);
var WireTransfer = PaymentMethod.extend();

module.exports = WireTransfer;

var ends = __webpack_require__(6);
var SoaModel = __webpack_require__(2);
var _ = __webpack_require__(0);

_.extend(WireTransfer.prototype, {
    constructor : function () {
        SoaModel.prototype.constructor.apply(this, arguments);
    },
    url: function () {
        return ends.paymentMethod();
    },
    getDisplayVal: function () {
        return 'Wire Transfer';
    },
    getNumber: function () {
        return this.getNumberType() ? this.get(this.getNumberType()) : null;
    },
    getNumberType: function () {
        if (this.get('confirmationNumber')) {
            return 'confirmationNumber';
        }
        if (this.get('transactionNumber')) {
            return 'transactionNumber';
        }
        if (this.get('referenceNumber')) {
            return 'referenceNumber';
        }
        return null;
    },
    getName: function () {
        return this.get('accountHolderName');
    },
    defaults : function () {
        return {
            apiType : 'wireTransfer',
            paymentMethodType : 'WIRE_TRANSFER'
        };
    }
});


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var WalletPaymentMethod = module.exports = SoaModel.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var PaymentMethod = __webpack_require__(56);

_.extend(WalletPaymentMethod.prototype, {
    relations : SoaModel.createRelations([{
        key : 'paymentMethod',
        relatedModel : PaymentMethod,
        type : Backbone.One
    }])
});



/***/ }),

/***/ 194:
/***/ (function(module, exports) {

module.exports = {
    hasAction : function (code) {
        var actions = this.get('actions');
        return !!actions && actions.hasCode(code);
    }
};


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 9/3/14
 * Time: 6:56 PM
 */



var _ = __webpack_require__(0);
var Party = __webpack_require__(8);
var Offer = __webpack_require__(25);
var PaymentAuthorization = __webpack_require__(24);
var FinancialAmount = __webpack_require__(10);

var getFromWallet = function (fn) {
    var shippingAddress = this.get('shipment.shippingAddress');
    var wallet = this.get('buyer.wallet');
    if (!wallet) {
        throw new Error('Must have buyer.wallet for getPermissibleCards to work');
    }
    return wallet[fn](shippingAddress);
};

module.exports = {
    /**
     * Saves the transaction, note, and sends the entire page to braintree
     */
    submitForCheckout: function () {
        this.addCheckoutNote();

        return this.save(null, {
            queries: {
                autoAuthorize: true,
                deepUpdate: true,
                workflowAction: 'update'
            }
        });
    },
    /**
     * Saves the payment auth and sends the entire page to braintree
     */
    submitForBalanceDue: function () {
        var paymentAuth = this.getCurrentBalanceDuePaymentAuthorization();
        return paymentAuth.save(null, {
            queries: { autoAuthorize: true }
        });
    },
    addCheckoutNote: function () {
        var offer;
        var note;

        if (!this.checkoutNote) {
            return;
        }

        offer = this.getFirstOffer();
        note = offer.newBuyerSellerNote({
            role: Party.ROLE_BUYER,
            creatorId: this.get('buyer.id')
        });

        note.set('anchors', []);
        note.set('content', this.checkoutNote);
        offer.set('notes', [note]);
    },
    isCheckoutComplete: function () {
        // checkout is complete when the transaction is saved and we have an offer payment auth
        return !this.isNew() &&
            (this.getCurrentCheckoutPaymentAuthorization() || this.getOfferPaymentAuthorization());
    },
    isBalanceDueProcessed: function () {
        // balance due is processed when we have a shipment quote payment auth
        return !!this.getShippingPaymentAuthorization();
    },

    needsToTransitionCheckoutPaymentAuth: function () {
        return !!this.getCheckoutPaymentAuthorizationForProcessing();
    },
    needsToTransitionBalanceDuePaymentAuth: function () {
        return !!this.getBalanceDuePaymentAuthorizationForProcessing();
    },
    getPermissibleCards: _.partial(getFromWallet, 'getPermissibleCards'),
    getValidPermissibleCards: _.partial(getFromWallet, 'getValidPermissibleCards'),
    // TODO combine with methods on offer model
    newBuyerOffer: function (amountPerItem, quantity) {
        var offers = this.get('offers');
        var offer = new Offer({
            quantity: quantity,
            amountPerItem: amountPerItem,
            subTotalAmount: {
                amount: Number(amountPerItem.get('amount') * quantity),
                currency: amountPerItem.get('currency')
            },
            forCompleteLot: !this.get('item').isSoldIndividually(),
            counterParty: {
                id: this.get('item.seller.id'),
                role: Party.ROLE_SELLER
            },
            initiatingParty: {
                id: this.get('buyer.id'),
                role: Party.ROLE_BUYER
            }
        });
        offers.reset([offer]);
        return offer;
    },
    lockConversionRates: function () {
        this.set('currencyConversionRateEvent', this.get('item.pricing.totalAmount.conversionRateEvent'));
    },
    _setFirstValidPermissibleCard: function (paymentAuth) {
        var cards = this.getValidPermissibleCards();
        if (cards && !cards.isEmpty()) {
            paymentAuth.set('paymentMethod', cards.first());
        }
        return paymentAuth;
    },
    /**
     * Creates a payment auth for checkout
     * @param [setCard] - defaults to true
     */
    createCheckoutPaymentAuthorization: function () {
        var currency = FinancialAmount.CURRENCY_USD;
        var paymentAuth = PaymentAuthorization.newOfferPaymentAuthorization();
        var amount = this.get('item').getAmountIn(currency);
        paymentAuth.set('amount', {amount: amount, currency: currency});
        this._setFirstValidPermissibleCard(paymentAuth);
        this.set('paymentAuthorizations', [paymentAuth]);
    },
    createBalanceDuePaymentAuthorization: function () {
        var quote = this.getPaymentRequiredQuote();
        var paymentAuth;

        if (!quote) {
            return;
        }

        paymentAuth = PaymentAuthorization.newShipmentQuotePaymentAuthorization(quote);
        paymentAuth.set('transaction', {id: this.id});
        this._setFirstValidPermissibleCard(paymentAuth);
        this.get('paymentAuthorizations').add(paymentAuth);
        return paymentAuth;
    },
    /**
     *
     * @param [id] optional address id to use
     */
    setInitialShippingAddress: function (id) {
        var addressBook = this.get('buyer.addressBook');
        var savedAddress = addressBook && addressBook.getAddressById(id);
        var firstShippingAddresses = this.getFirstShippingAddress();
        var address = savedAddress || firstShippingAddresses;
        if (address) {
            this.get('shipment').set('shippingAddress', address);
        }
    },
    addPromo: function (promoCode) {
        this.set('promotions', [{
            code: promoCode
        }]);
        this.trigger('promoChanged');
    },
    removePromo: function () {
        this.set('promotions', []);
        this.trigger('promoChanged');
    },
    /**
     * Invoke this function when a checkout has failed. Will clear the id
     * and payment auth so it can be submitted again
     */
    clearForCheckoutRetry: function () {
        this.unset('id');
        if (!this.isReadyForBalanceDue()) {
            this.selectFirstAvailableOption();
        }
        // remove status from sub documents
        this.unset('shipment.status');
        _.each(['invoices', 'offers'], function (collection) {
            this.get(collection).each(function (model) {
                model.unset('status');
            });
        }, this);
    },
    clearForDeniedPaymentAuth: function () {
        var paymentAuthorizations = this.get('paymentAuthorizations');
        var paymentAuth = paymentAuthorizations && paymentAuthorizations.last();
        var paymentMethod = paymentAuth && paymentAuth.get('paymentMethod');
        var newPaymentAuth;
        if (paymentAuth) {
            newPaymentAuth = new PaymentAuthorization(paymentAuth.pick('amount', 'anchor', 'transaction'));
            if (paymentMethod) {
                this.previousPaymentMethod = paymentMethod.makeNewCard();
                newPaymentAuth.set('paymentMethod', this.previousPaymentMethod);
            }
        }
        this.set('paymentAuthorizations', [newPaymentAuth]);
    }
};


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/6/14
 * Time: 12:20 PM
 */



var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var FinancialAmount = __webpack_require__(10);
var Transaction = __webpack_require__(20);
var TransactionShipmentQuote = __webpack_require__(36);
var deferredHelpers = __webpack_require__(169);
var getFromInvoice;
var getPriceAmount;
var getFromDealerInvoice;
var getFromBuyerInvoice;
var hasAmount;

__webpack_require__(317);

getPriceAmount = function (type, currency) {
    var price = this.getPriceType(type);
    return price && Number(price.get('amount').getAmountIn(currency));
};

getFromInvoice = function (invoiceAccessor, fn, currency) {
    var invoice = this[invoiceAccessor]();
    if (invoice) {
        return invoice[fn](currency);
    }
};

hasAmount = function (fn) {
    var amount = this[fn](FinancialAmount.CURRENCY_USD);
    return $.isNumeric(amount) && Number(amount) !== 0;
};

getFromDealerInvoice = _.partial(getFromInvoice, 'getDealerInvoice');
getFromBuyerInvoice = _.partial(getFromInvoice, 'getBuyerInvoice');

module.exports = {
    getShippingSubtotal : function (currency) {
        var quote = this.getCurrentShippingQuote();
        if (!quote) {
            return 0;
        }
        return quote.getSubTotal(currency) || 0;
    },
    getShippingTotal: function (currency) {
        var quote = this.getCurrentShippingQuote();
        if (!quote) {
            return null;
        }
        return quote.getTotalAmount(currency) || 0;
    },
    getShippingTaxAmount : function (currency) {
        var buyerInvoice = this.getBuyerInvoice();
        var invoiceItems = buyerInvoice && buyerInvoice.get('invoiceItems');
        if (invoiceItems) {
            return invoiceItems.getShipmentSalesTax(currency);
        }
        return 0;
    },
    getAvailablePrices: function () {
        return this.get('summary.availablePrices');
    },
    getCheckoutPriceAmount: function (currency) {
        var itemPriceAmount = this.get('summary.itemPrice.amount');
        return itemPriceAmount && itemPriceAmount.getAmountIn(currency);
    },
    getCheckoutPriceType: function () {
        return this.get('summary.itemPrice.type');
    },
    getPriceType: function (type) {
        var availablePrices = this.getAvailablePrices();
        return availablePrices && availablePrices.find(function (price) {
            return price.get('type') === type;
        });
    },
    isOnSale: function () {
        return !!this.getPriceType('WEEKLY_SALE');
    },
    hasNetPrice: function () {
        return !!this.getPriceType('NET');
    },
    getRetailAmount: _.partial(getPriceAmount, 'RETAIL'),
    getSaleAmount: _.partial(getPriceAmount, 'WEEKLY_SALE'),
    getNetPriceAmount: _.partial(getPriceAmount, 'NET'),
    getOfferSubtotal : function (currency) {
        var offer = this.getMostRecentOffer();
        if (!offer) {
            return 0;
        }
        return offer.getSubTotal(currency);
    },
    getOfferTotal: function (currency, offer) {
        offer = offer || this.getMostRecentOffer();
        if (!offer) {
            return 0;
        }
        return offer.getTotalAmount(currency);
    },
    getOfferTaxAmount: function (currency) {
        var buyerInvoice = this.getBuyerInvoice();
        var invoiceItems = buyerInvoice && buyerInvoice.get('invoiceItems');
        if (invoiceItems) {
            return invoiceItems.getOfferSalesTax(currency);
        }
        return 0;
    },
    getAdjustmentTaxAmount: function (currency) {
        var buyerInvoice = this.getBuyerInvoice();
        var invoiceItems = buyerInvoice && buyerInvoice.get('invoiceItems');
        if (invoiceItems) {
            return invoiceItems.getAdjustmentSalesTax(currency);
        }
        return 0;
    },
    hasSalesTax: _.partial(hasAmount, 'getOfferTaxAmount'),
    hasShippingSalesTax: _.partial(hasAmount, 'getShippingTaxAmount'),
    getSalesTax : function (currency) {
        return this.getShippingTaxAmount(currency) +
            this.getOfferTaxAmount(currency) +
            this.getAdjustmentTaxAmount(currency);
    },
    getSalesTaxState: function () {
        if (this.isLocalPickup()) {
            return this.get('item.seller.shippingAddress.state');
        } else {
            return this.get('shipment.shippingAddress.state');
        }
    },
    getBuyerTotalFromOffers : function (currency, passedOffer) {
        var offer = passedOffer || this.getMostRecentOffer();
        var offerTotal = this.getOfferTotal(currency, offer) || 0;
        var quote = this.getCurrentShippingQuote();

        // Only include the shipping total when it is not free shipping for the buyer.
        if (quote && quote.get('complimentaryShipping') !== 'Y') {
            return offerTotal + this.getShippingTotal(currency);
        }
        return offerTotal;
    },
    getBuyerTotal: _.partial(getFromBuyerInvoice, 'getTotalAmount'),
    getItemCurrency: function () {
        return this.get('item.pricing.totalAmount.currency');
    },

    getAmountPerItem: function (currency) {
        var item = this.get('item');
        if (item) {
            return item.getAmountPerItem(currency);
        }
    },
    getCommission: _.partial(getFromDealerInvoice, 'calculateCommission'),
    getProcessingFee: _.partial(getFromDealerInvoice, 'calculateProcessingFee'),
    getListingCredit: _.partial(getFromDealerInvoice, 'calculateListingCredit'),
    getComplimentaryShippingAdjustment: _.partial(getFromDealerInvoice, 'calculateComplimentaryShipping'),
    getDealerTotal: _.partial(getFromDealerInvoice, 'getTotalAmount'),
    getDealerSubTotal: _.partial(getFromDealerInvoice, 'getSubTotal'),
    getPromotionAmount: _.partial(getFromBuyerInvoice, 'calculatePromotion'),
    getItemPriceModification: _.partial(getFromBuyerInvoice, 'calculateItemPriceModification'),
    getProductCustomization: _.partial(getFromBuyerInvoice, 'calculateProductCustomization'),
    getCustomerCharge: _.partial(getFromBuyerInvoice, 'calculateCustomerCharge'),
    getDealerCharge: _.partial(getFromDealerInvoice, 'calculateDealerCharge'),
    hasListingCredit: _.partial(hasAmount, 'getListingCredit'),
    hasComplimentaryShippingAdjustment: _.partial(hasAmount, 'getComplimentaryShippingAdjustment'),
    hasPromotion: function () {
        var adjustments = this.getBuyerInvoice() && this.getBuyerInvoice().get('adjustments');
        return adjustments && adjustments.hasPromotion();
    },
    hasItemPriceModification: _.partial(hasAmount, 'getItemPriceModification'),
    hasProductCustomization: _.partial(hasAmount, 'getProductCustomization'),
    hasCustomerCharge: _.partial(hasAmount, 'getCustomerCharge'),
    hasDealerCharge: _.partial(hasAmount, 'getDealerCharge'),
    hasBuyerOrderMod: function () {
        return this.hasItemPriceModification() || this.hasProductCustomization() || this.hasCustomerCharge();
    },
    hasDealerOrderMod: function () {
        return this.hasDealerCharge();
    },
    getBuyerBalanceDueAmount: function (currency) {
        var balanceDueAmount = this.get('summary.balanceDueAmount');
        return balanceDueAmount && balanceDueAmount.getAmountIn(currency) || 0;
    },
    getFinalCaptureAmount: function (currency) {

        var rawAmountToCapture = this.getBuyerTotal(currency);
        var paymentAuthOnShipping = this.getShippingPaymentAuthorization();
        if (paymentAuthOnShipping) {
            rawAmountToCapture -= paymentAuthOnShipping.get('amount').getAmountIn(currency);
        }
        return rawAmountToCapture;
    },
    getMostRecentOfferAmountPerItem: function (currency) {
        var offer = this.getMostRecentOffer();
        if (offer) {
            return offer.getAmountPerItem(currency);
        }
    },
    getAcceptedQuoteSubTotal: function (currency) {
        var sq = this.getAcceptedQuote();
        if (sq) {
            return sq.getSubTotal(currency);
        }
    },
    getOfferPaymentAuthorizationAmount: function (currency) {
        var pa = this.get('paymentAuthorizations').getOfferPaymentAuthorization();
        if (pa) {
            return pa.getAmount(currency);
        }
    },
    getOfferPaymentAuthorizationCapturedAmount: function (currency) {
        var pa = this.get('paymentAuthorizations').getOfferPaymentAuthorization();
        if (pa) {
            return pa.getCapturedAmount(currency);
        }
    },
    getOfferPaymentAuthorizationAuthorizationAmount: function (currency) {
        var pa = this.get('paymentAuthorizations').getOfferPaymentAuthorization();
        if (pa) {
            return pa.getAuthorizationAmount(currency);
        }
    },
    getShippingPaymentAuthorizationAmount: function (currency) {
        var pa = this.get('paymentAuthorizations').getShippingPaymentAuthorization();
        if (pa) {
            return pa.getAmount(currency);
        }
    },
    getBuyerCurrency: function () {
        return this.get('buyer.profile.currency') || FinancialAmount.CURRENCY_USD;
    },
    getBuyerOriginalPayment: function (currency) {
        var offer = this.getMostRecentOffer();
        var offerAmount = offer && offer.getTotalAmount(currency);
        var promotionAmount = this.getPromotionAmount(currency) || 0;
        return offerAmount + promotionAmount;
    },

    hasCurrencyConversionFor: function (currency) {
        var rates = this.get('currencyConversionRateEvent.conversionRates');
        var itemCurrency = this.getItemCurrency();

        return rates &&
            !!rates.findWhere({
                sourceCurrency: FinancialAmount.CURRENCY_USD,
                targetCurrency: currency
            }) &&
            !!rates.findWhere({
                sourceCurrency: itemCurrency,
                targetCurrency: currency
            });
    },

    hasBuyerCurrencyConversion: function () {
        return this.hasCurrencyConversionFor(this.getBuyerCurrency());
    },

    getBuyerLocalizedCurrency: function () {
        var itemHasSameCurrencyAsBuyer = this.getItemCurrency() === this.getBuyerCurrency();
        return itemHasSameCurrencyAsBuyer || this.hasBuyerCurrencyConversion() ? this.getBuyerCurrency() : FinancialAmount.CURRENCY_USD;
    },

    /**
     * @deprecated
     * @returns {*}
     */
    calculateTotals: function () {
        return this.computeAdjustments.apply(this, arguments);
    },
    computeCheckoutAdjustments: function () {
        // we need to preserve paymentAuth payment method since
        // ecom does not get the credit card info
        var paymentAuths = this.get('paymentAuthorizations').toJSON();
        var buyer = this.get('buyer').toJSON();
        var jqXhr;

        // cancel any outstanding calls
        if (this._checkoutAdjustmentsDeferred) {
            this._checkoutAdjustmentsDeferred.reject();
        }

        // compute adjustments starts
        this.trigger('computingAdjustments');

        jqXhr = this.save(null, {url: endpoints.computeAdjustments(), type: 'post'});

        this._checkoutAdjustmentsDeferred = deferredHelpers.wrapDeferred(jqXhr);
        this._checkoutAdjustmentsDeferred.then(_.bind(function () {
            _.each(paymentAuths, function (paymentAuth, i) {
                this.get('paymentAuthorizations[' + i + ']').set('paymentMethod', paymentAuth.paymentMethod, {computeAdjustments: true});
            }, this);
            // need to preserve the buyer or backbone will overwrite it if there's no id
            this.set('buyer', buyer);
            // compute adjustments ends
            this.trigger('computedAdjustments');
        }, this));

        return this._checkoutAdjustmentsDeferred.promise();
    },
    isAdjusted: function () {
        var offer = this.getFirstOffer();
        return offer && offer.has('adjustments.signature');
    },
    removeAdjustments: function () {
        this.get('offers').each(function (offer) {
            offer.unset('adjustments');
        });
        this.get('shipmentQuotes').each(function (shipmentQuote) {
            shipmentQuote.unset('adjustments');
        });
        this.trigger('removedAdjustments');
    },
    setEachModel: function (type, transaction) {
        var collection = this.get(type);
        if (collection) {
            collection.each(function (model, i) {
                if (i < transaction.get(type).length) {
                    model.set(transaction.get(type).at(i).toJSON());
                }
            });
            transaction.get(type).each(function (model) {
                if (!collection.findWhere({ id: model.id })) {
                    collection.push(model);
                }
            });
        }
    },
    setInvoiceModel: function (transaction) {
        var collection = this.get('invoices');
        var model;
        var invoices;
        if (collection) {
            invoices = transaction.get('invoices');
            invoices.each(function (invoice) {
                if (invoice.isBuyerInvoice()) {
                    model = collection.getBuyerInvoice();
                } else {
                    model = collection.getDealerInvoice();
                }

                if (model) {
                    model.set(invoice.toJSON());
                } else {
                    collection.push(invoice);
                }
            });
        }
    },
    _defaultZero: function (model, field) {
        var financialAmount = model.get(field);
        var currency;
        if (financialAmount && !financialAmount.get('amount')) {
            currency = financialAmount.get('currency');
            financialAmount.set({
                amount: 0,
                currency: currency
            });
        }
    },

    /**
     * @memberOf Transaction#
     * @param [shipmentQuote] - update totals/adjustments on this shipmentQuote
     * @return {$.Deferred.promise}
     */
    computeAdjustments: function (shipmentQuote) {
        var transaction = new Transaction(this.toJSON());
        var self = this;
        var newShipmentQuote;
        var transactionShipmentQuote;

        if (shipmentQuote && shipmentQuote.toJSON()) {
            transactionShipmentQuote = new TransactionShipmentQuote(shipmentQuote.toJSON());
        }

        newShipmentQuote = transactionShipmentQuote || transaction.get('shipment.acceptedQuote');
        if (newShipmentQuote) {
            transaction.get('shipment').set('acceptedQuote', newShipmentQuote);
            this._defaultZero(newShipmentQuote, 'subTotalAmount');
            this._defaultZero(newShipmentQuote, 'totalAmount');
        }
        this._defaultZero(transaction.get('offers').last(), 'subTotalAmount');
        this._defaultZero(transaction.get('offers').last(), 'amountPerItem');
        return transaction.save(null, {url: endpoints.computeAdjustments(), type: 'post'}).then(function () {
            var rateEvent;
            /*
             * IMPORTANT
             * form view holds on to sub-model references. we need to actually set each submodel or else
             * they will be replaced with a new model and the views will not have references to them
             */
            _.each(['offers', 'paymentAuthorizations'], function (type) {
                self.setEachModel(type, transaction);
            });
            /*
             * Had to break out 'invoices' from above call to "setEachModel" since invoice is
             * implementation dependent
             */
            self.setInvoiceModel(transaction);
            rateEvent = transaction.get('currencyConversionRateEvent');
            if (rateEvent) {
                self.set('currencyConversionRateEvent', rateEvent.toJSON());
            }
            if (shipmentQuote) {
                self.setAttributeOnShipmentQuote(shipmentQuote, transaction, 'shipment.acceptedQuote.totalAmount');
                self.setAttributeOnShipmentQuote(shipmentQuote, transaction, 'shipment.acceptedQuote.adjustments');
            }
        });
    },

    setAttributeOnShipmentQuote: function (on, from, what) {
        if (!on) {
            return;
        }
        if (what && from.get(what)) {
            on.set(_.last(what.split('.')), from.get(what));
        }
        return this; // eslint-disable-line
    }
};


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/6/14
 * Time: 11:26 AM
 */



var _ = __webpack_require__(0);
var TransactionShipmentQuote = __webpack_require__(36);
var getFromCollection;

getFromCollection = function (collectionProperty, fn) {
    var args = Array.prototype.slice.call(arguments, 2);
    var collection = this.get(collectionProperty);
    if (collection) {
        return collection[fn].apply(collection, args);
    }
};

/**
 * Transaction mixin for accessing sub-documents
 * @type {{}}
 */
module.exports = {
    /******************************
        Payment Authorizations
    ******************************/
    /**
     * Get the active payment auth that is anchored to an offer. This includes fraudulent payment auths
     */
    getOfferPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getActiveOfferPaymentAuthorization'),
    /**
     * Get the active payment auth that is anchored to a shipment quote. This includes fraudulent payment auths
     */
    getShippingPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getActiveShippingPaymentAuthorization'),
    /**
     * Get the current payment auth that is anchored to an offer and has not yet been processed
     */
    getCurrentCheckoutPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getCurrentCheckoutPaymentAuthorization'),
    /**
     * Get the active payment auth that is anchored to a shipment quote and has not yet been processed
     */
    getCurrentBalanceDuePaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getCurrentBalanceDuePaymentAuthorization'),
    /**
     * Get a denied payment auth that is anchored to an offer
     */
    getDeniedCheckoutPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getDeniedCheckoutPaymentAuthorization'),
    /**
     * Get a statged payment auth ready to send to braintree
     */
    getStagedPaymentAuthorization: _.partial(getFromCollection, 'paymentAuthorizations', 'getStagedPaymentAuthorization'),
    getCheckoutPaymentAuthorizationForProcessing: _.partial(getFromCollection, 'paymentAuthorizations', 'getCheckoutPaymentAuthorizationForProcessing'),
    getBalanceDuePaymentAuthorizationForProcessing: _.partial(getFromCollection, 'paymentAuthorizations', 'getBalanceDuePaymentAuthorizationForProcessing'),

    /******************************
        Offers
     ******************************/
    getMostRecentOffer: _.partial(getFromCollection, 'offers', 'getMostRecent'),
    getFirstOffer: _.partial(getFromCollection, 'offers', 'getFirst'),
    getMostRecentBuyerOffer: _.partial(getFromCollection, 'offers', 'getMostRecentBuyerOffer'),
    getMostRecentDealerOffer: _.partial(getFromCollection, 'offers', 'getMostRecentDealerOffer'),

    /******************************
        Shipment Quotes
     ******************************/
    getPaymentRequiredQuote: function () {
        var quotes = this.get('shipmentQuotes');
        return quotes && quotes.findWhere({status: 'PAYMENT_REQUIRED'});
    },
    getCurrentShippingQuote : function () {
        var acceptedQuote = this.getAcceptedQuote();
        var dibsQuote = this.get1stdibsShipmentQuote();
        var dealerQuote = this.getDealerShipmentQuote();
        var activeQuote;

        if (acceptedQuote) {
            activeQuote = acceptedQuote;
        } else if (dealerQuote) {
            activeQuote = dealerQuote;
        } else if (dibsQuote
            && dibsQuote.get('status') !== TransactionShipmentQuote.STATUS_NEW
            && dibsQuote.get('status') !== TransactionShipmentQuote.STATUS_SUBMITTED
        ) {
            activeQuote = dibsQuote;
        }
        return activeQuote;
    },
    getCurrentOrSubmittedShipmentQuote: function () {
        var currentShippingQuote = this.getCurrentShippingQuote();
        var dibsQuote = this.get1stdibsShipmentQuote();

        if (currentShippingQuote) {
            return currentShippingQuote;
        } else if (dibsQuote && dibsQuote.isQuoteSubmitted()) {
            return dibsQuote;
        }

        return null;
    },
    getDealerAcceptedQuote : function () {
        return this.get('shipmentQuotes').find(function (quote) {
            return _.contains(['PAYMENT_REQUIRED', 'BUYER_ACCEPTED'], quote.get('status'));
        });
    },
    getAcceptedQuote : function () {
        var acceptedQuote = this.get('shipment.acceptedQuote');
        if (!acceptedQuote || acceptedQuote.isLocalPickup()) {
            return undefined;
        }
        return acceptedQuote;
    },
    /**
     * Gets the current active accounting shipment quote.
     * This is the shipment quote on a transaction that is
     * not 'DEALER_REJECTED'. At this point in time, there
     * should not be more than on of these on an order.
     * @function
     * @returns {TransactionShipmentQuote}
     */
    getActiveAccountingShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'getActiveAccountingQuote'),
    /**
     * @function
     * @returns {TransactionShipmentQuote}
     */
    getRejectedAccountingShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'getRejectedAccountingQuote'),
    /**
     * @function
     * @param {string} currency
     * @returns {number}
     */
    getActiveAccountingShipmentQuoteSubTotal: function (currency) { // _.partial(getFromCollection, 'shipmentQuotes', 'getActiveAccountingQuoteSubTotal'),
        var quote = this.getActiveAccountingShipmentQuote();
        if (quote) {
            return quote.getSubTotal(currency);
        }
        return null;
    },
    /**
     * @function
     * @param {string} currency
     * @returns {number}
     */
    getActiveAccountingShipmentQuoteTotal: function (currency) { // _.partial(getFromCollection, 'shipmentQuotes', 'getActiveAccountingQuoteTotal'),
        var quote = this.getActiveAccountingShipmentQuote();
        if (quote) {
            return quote.getTotalAmount(currency);
        }
        return null;
    },
    get1stdibsShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'get1stdibsQuote'),
    getDealerShipmentQuote: _.partial(getFromCollection, 'shipmentQuotes', 'getDealerQuote'),
    getBuyerShipmentQuote: function () {
        var quote = this.getCurrentShippingQuote();

        if (quote && quote.get("status") !== "SUBMITTED") {
            return quote;
        }
    },

    /******************************
        Invoices
     ******************************/
    getDealerInvoice: _.partial(getFromCollection, 'invoices', 'getDealerInvoice'),
    getShipperInvoice: _.partial(getFromCollection, 'invoices', 'getShipperInvoice'),
    getBuyerInvoice: _.partial(getFromCollection, 'invoices', 'getBuyerInvoice'),
    getBuyerInvoiceItems: function () {
        var buyerInvoice = this.getBuyerInvoice();
        return buyerInvoice && buyerInvoice.get('invoiceItems');
    },

    /******************************
        Disbursements
     ******************************/
    getShipperDisbursement: _.partial(getFromCollection, 'disbursements', 'getShipperDisbursement'),
    getDealerDisbursement: _.partial(getFromCollection, 'disbursements', 'getDealerDisbursement'),

    /******************************
        Promotions
     ******************************/
    getActivePromo: _.partial(getFromCollection, 'promotions', 'getActivePromo'),
    getInvalidPromo: _.partial(getFromCollection, 'promotions', 'getInvalidPromo'),

    /******************************
        Notes
     ******************************/
    getReadyForPickupNote: function () {
        var shipment = this.get('shipment');
        if (shipment && !this.isDealerAuthoredShipping()) {
            return shipment.get('notes').getByCreatorRole('SELLER');
        }
    },
    getShippedNote: function () {
        var shipment = this.get('shipment');
        if (shipment && this.isDealerShipping()) {
            return shipment.get('notes').getByCreatorRole('SELLER');
        } else if (shipment && this.is1stdibsShipping()) {
            return shipment.get('notes').getByCreatorRole('INTERNAL');
        }
    },
    getBuyerSellerNotes: _.partial(getFromCollection, 'notes', 'getBuyerSellerNotes'),
    getUnanchoredBuyerSellerNotes: _.partial(getFromCollection, 'notes', 'getUnanchoredBuyerSellerNotes'),

    /******************************
        Item
     ******************************/
    getVertical: function () {
        return this.get('item.vertical');
    },

    /******************************
     Adjustments
     ******************************/
    getListingCreditAdjustment: function () {
        var invoice = this.getDealerInvoice();
        if (invoice) {
            return invoice.getListingCreditAdjustment();
        }
    },

    /******************************
        DisplayMetadata
     ******************************/
    getSlaStartDate: function () {
        return this.get('displayMetadata.sla.startDate');
    },

    /******************************
     Addresses
     ******************************/
    getShippingAddresses: function () {
        var addressBook = this.get('buyer.addressBook');
        var shippingAddresses = addressBook.getShippingAddresses() || [];
        return shippingAddresses;
    },
    getFirstShippingAddress: function () {
        var addresses = this.getShippingAddresses();
        return addresses && addresses[0];
    },

    /******************************
     Reviews
     ******************************/
    getFraudReview: function () {
        var paymentAuth = this.getOfferPaymentAuthorization();
        return paymentAuth && paymentAuth.getFraudReview();
    },

    getPaymentReview: function () {
        var paymentAuth = this.getOfferPaymentAuthorization();
        return paymentAuth && paymentAuth.getPaymentReview();
    },

    /******************************
     Actions
     ******************************/
    getActionStartDate: _.partial(getFromCollection, 'actions', 'getActionStartDate')

};


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/21/14
 * Time: 5:05 PM
 */



var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var Party = __webpack_require__(8);
var Anchor = __webpack_require__(12);
var ShipmentQuote = __webpack_require__(74);
var Shipment = __webpack_require__(83);
var TransactionShipmentQuotes = __webpack_require__(78);
var Address = __webpack_require__(32);

/**
 * @mixin transactionShippingMixin
 */
module.exports = {
    getNumberOfPieces: function () {
        var item = this.get('item');
        var offer = this.getMostRecentOffer();

        if (!item || !offer) {
            // things are bad
            return 1;
        }

        if (item.soldIndividually()) {
            return offer.get('quantity');
        } else {
            return item.getNumberOfPieces();
        }
    },
    isEligibleFor1stdibsShipping: function () {
        return true;
    },
    /**
     * Returns true if shipping was known at checkout
     * @returns {Boolean}
     */
    isShippingKnownAtCheckout: function () {
        var isBuyerArrangedShipping = this.isBuyerShipping();
        var hasPreQuote = this.get('shipmentQuotes').hasPreQuoteIncludingCanceled();
        return hasPreQuote || isBuyerArrangedShipping;
    },
    /**
     * Returns true if buyer arranged shipping
     * @returns {Boolean}
     */
    isBuyerShipping: function () {
        return this.get('shipment').isBuyerArrangedShipping();
    },
    /**
     * Returns true if buyer arranged shipping
     * @deprecated Use isBuyerShipping instead
     * @returns {Boolean}
     */
    isBuyerArrangedShipping: function () {
        return this.isBuyerShipping();
    },

    /**
     * Returns true if dealer is shipping
     * @returns {Boolean}
     */
    isDealerShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && (acceptedQuote.isDealerBilledQuote() || this.is1stdibsSubsidizedDealerShipping());
    },

    /**
     * Returns true if dealer authored
     * the accepted quote
     * @returns {Boolean}
     */
    isDealerAuthoredShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.isDealerAuthoredQuote();
    },

    isDealerBilledShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.isDealerBilledQuote();
    },

    is1stdibsBilledShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsBilledQuote();
    },

    /**
     * Return true if 1stdibs authored the quote
     * @returns {boolean}
     */
    is1stdibsAuthoredShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return !!acceptedQuote && acceptedQuote.is1stdibsAuthoredQuote();
    },

    getShippingCostForTypeIn: function (costType, currency) {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote ? acceptedQuote.getSubTotalAmountForCostTypeIn(costType, currency) : null;
    },

    getCurrentShippingCostForTypeIn: function (costType, currency) {
        var quote = this.getCurrentShippingQuote();
        return quote ? quote.getSubTotalAmountForCostTypeIn(costType, currency) : null;
    },

    getShippingRequestReviewNoteContent: function () {
        var shipment = this.get('shipment');
        if (shipment) {
            return shipment.getShippingRequestReviewNoteContent();
        }
    },

    /**
     * Return true if the dealer needs to provide a shipment quote
     * @returns {boolean}
     */
    dealerQuoteNeeded: function () {
        var quotes = this.get('shipmentQuotes');
        return this.isShippingKnownAtCheckout() && !!quotes && !!quotes.noLocalPickupQuotes().length;
    },

    /**
     * Returns true if the item is shipped under the 1stdibs parcel
     * program (parcel shipping with a 1stdibs authored quote)
     * @returns {Boolean}
     */
    is1stdibsParcelShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsParcelQuote();
    },

    /**
     * Returns true if the item's shipping quote is authored by 1stdibs
     * and has white glove service method type
     * @returns {Boolean}
     */
    is1stdibsWhiteGloveShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsWhiteGloveQuote();
    },

    /**
     * Returns true if 1stdibs subsidizes the shipment
     * quote for the dealer. Right now this is true
     * only for 1sdibs parcel quotes and not for anything
     * else.
     * @returns {Boolean}
     */
    is1stdibsSubsidizedDealerShipping: function () {
        var accepted = this.getAcceptedQuote();
        return !!this.getAcceptedQuote() && accepted.is1stdibsSubsidizedDealerQuote();
    },

    /**
     * @returns {boolean}
     */
    isReadyToShip: function () {
        var shipment = this.get('shipment');
        return !!this.getAcceptedQuote() && this.isPending() && !shipment.hasBeenShipped();
    },

    /**
     * Returns true of an admin user has entered shipping info
     * for a transaction that has failed easy post address
     * registration. Currenlty, we know this is true when we
     * have a 1stdibs subsidized dealer shipping transaction
     * with an accepted, 1stdibs billed quote but no easypost-
     * supplied shipping label
     * @returns {boolean}
     */
    hasEnteredShippingInfo: function () {
        var activeQuote = this.getActiveAccountingShipmentQuote();
        return activeQuote &&
            this.is1stdibsSubsidizedDealerShipping() &&
            activeQuote.is1stdibsBilledQuote() &&
            activeQuote.wasAcceptedForAccounting() &&
            !this.getShipmentLabelURL();
    },

    /**
     * Returns true if 1stdibs (INTERNAL) is shipping
     * @returns {Boolean}
     */
    is1stdibsShipping: function () {
        var acceptedQuote = this.getAcceptedQuote();
        return acceptedQuote && acceptedQuote.is1stdibsBilledQuote() && !acceptedQuote.is1stdibsSubsidizedDealerQuote();
    },

    isPreQuote: function () {
        return this.get('shipmentQuotes').hasPreQuote();
    },
    isDealerPreQuote: function () {
        return this.isPreQuote() && this.isDealerBilledShipping();
    },
    is1stdibsPreQuote: function () {
        return this.isPreQuote() && this.is1stdibsShipping();
    },
    isLocalPickup: function () {
        return this.get('shipment').isLocalPickup();
    },
    isExternallyArranged: function () {
        return this.get('shipment').isExternallyArranged();
    },
    hasDealerRejectedQuote: function () {
        return !!this.getRejectedAccountingShipmentQuote();
    },
    /**
     * Get seller display val from the accepted shipment quote service method
     * @param [quote] Use this shipment quote instead of the accepted quote
     * @returns {*|string}
     */
    getSellerMethodDisplayVal: function (quote) {
        var serviceMethod;
        if (!quote) {
            quote = this.getAcceptedQuote();
        }
        serviceMethod = quote && quote.get('serviceMethod');
        if (serviceMethod) {
            return serviceMethod.getSellerMethodDisplayVal(this.getVertical());
        }
        return null;
    },
    /**
     * @deprecated Use isBuyerArrangedShipping, isDealerAuthoredShipping, and is1stdibsShipping instead;
     * @returns {String}
     */
    getShipper: function () {
        if (this.isBuyerShipping()) {
            return Party.ROLE_BUYER;
        } else if (this.isDealerShipping()) {
            return Party.ROLE_SELLER;
        } else if (this.is1stdibsShipping()) {
            return Party.ROLE_INTERNAL;
        }
        return null;
    },
    getBuyerShipmentMethodName: function () {
        var quote = this.getBuyerShipmentQuote();
        var method;

        if (quote.isLocalPickup()) {
            method = "Customer will pick up from dealer";
        } else if (quote) {
            method = quote.getBuyerServiceMethodDisplayValue();
        } else if (this.isBuyerShipping()) {
            method = "Customer Will Handle Shipping";
        } else {
            method = "TBD";
        }
        return method;
    },
    getShipmentAddresseeDisplayName: function () {
        return this.get('shipment').getAddresseeDisplayName();
    },
    getShipmentCountry: function () {
        return this.get('shipment.shippingAddress.country');
    },
    getShipmentType : function () {
        return this.get('shipment.shipmentType') || null;
    },
    getShipmentTypeDisplayVal: function () {
        if (this.isLocalPickup()) {
            return 'Customer Pickup';
        } else if (this.isBuyerShipping()) {
            return 'Customer Will Handle Shipping';
        } else if (this.isDealerPreQuote()) {
            return 'Dealer Flat Rate';
        } else if (this.is1stdibsSubsidizedDealerShipping() && this.is1stdibsParcelShipping()) {
            return '1stdibs Parcel Shipping';
        } else if (this.is1stdibsShipping()) {
            return '1stdibs Shipping';
        } else if (this.isDealerShipping()) {
            return 'Dealer Shipping';
        } else {
            return 'Customer Needs Item Shipped';
        }
    },

    /**
     * Get the shipment label
     * @returns {string}
     */
    getShipmentLabelURL: function () {
        var shipment = this.get('shipment');
        return shipment ? shipment.getTrackingLabelURL() : null;
    },

    /**
     * @returns {string}
     */
    getShipmentTrackingNumber: function () {
        var shipment = this.get('shipment');
        return shipment ? shipment.getTrackingNumber() : null;
    },

    /**
     * Get a new Note anchored to the shipment (and
     * other standard transactions)
     * @param {object} noteOptions
     * @returns {Note}
     */
    newNoteForShipment: function (noteOptions) {
        return this.newNote(noteOptions, [this._getShipmentAnchorAttrs()]);
    },
    /**
     * Get a new note of type BUYER_SELLER anchored
     * to the shipment;
     * @param noteOptions
     * @returns {Note}
     */
    newBuyerSellerNoteForShipment: function (noteOptions) {
        return this.newBuyerSellerNote(noteOptions, [this._getShipmentAnchorAttrs()]);
    },
    /**
     * @param {ShipmentQuote} shipmentQuote
     * @param {object} [noteOptions]
     * @returns {Note}
     */
    newBuyerSellerNoteForShipmentQuote: function (shipmentQuote, noteOptions) {
        console.assert(shipmentQuote instanceof ShipmentQuote, 'shipmentQuote must be a ShipmentQuote');
        return this.newBuyerSellerNote(noteOptions, [this._getShipmentQuoteAnchorAttrs(shipmentQuote)]);
    },
    /**
     * @param {ShipmentQuote} shipmentQuote
     * @param {object} [noteOptions]
     * @returns {Note}
     */
    newNoteForShipmentQuote: function (shipmentQuote, noteOptions) {
        console.assert(shipmentQuote instanceof ShipmentQuote, 'shipmentQuote must be a ShipmentQuote');
        return this.newNote(noteOptions, [this._getShipmentQuoteAnchorAttrs(shipmentQuote)]);
    },
    _getShipmentQuoteAnchorAttrs: function (shipmentQuote) {
        return {
            sourceId: shipmentQuote.id,
            sourceType: Anchor.TYPE_SHIPMENT_QUOTE
        };
    },
    _getShipmentAnchorAttrs: function () {
        return {
            sourceType: Anchor.TYPE_SHIPMENT,
            sourceId: this.get('shipment').id
        };
    },
    /**
     * sets the shipping address with a unified event
     * @param address
     */
    setShippingAddress: function (address) {
        this.get('shipment').set('shippingAddress', address);
        this.trigger('shippingAddressChanged');
    },
    /**
     * Used before checkout to make a transaction use a shipment quote
     */
    setShipmentQuote: function (shipmentQuote) {
        if (shipmentQuote.isLocalPickup()) {
            this.get('shipment').set('shipmentType', Shipment.TYPE_LOCAL_PICKUP);
        } else {
            this.get('shipment').set('shipmentType', Shipment.TYPE_FIRSTDIBS_FACILITATED);
        }
        this.get('shipmentQuotes').reset([shipmentQuote]);
        this.get('shipment').set('acceptedQuote', shipmentQuote);
        this.trigger('shippingChanged');
    },
    /**
     * Used before checkout to make a transaction externally arranged
     */
    setExternallyArranged: function () {
        this.get('shipmentQuotes').reset(); // remove all shipment quotes
        this.get('shipment').unset('acceptedQuote');
        this.get('shipment').set('shipmentType', Shipment.TYPE_EXTERNALLY_ARRANGED);
        this.trigger('shippingChanged');
    },
    /**
     * Used before checkout to make a transaction "quote needed"
     */
    setQuoteNeeded: function () {
        this.get('shipmentQuotes').reset(); // remove all shipment quotes
        this.get('shipment').unset('acceptedQuote');
        this.get('shipment').set('shipmentType', Shipment.TYPE_FIRSTDIBS_FACILITATED);
        this.trigger('shippingChanged');
    },
    fetchAvailableOptions: function (address) {
        var availableOptions = new TransactionShipmentQuotes();
        var currencyConversionRateEventId = this.get('currencyConversionRateEvent.id');
        var item = this.get('item');

        address = address || this.get('shipment.shippingAddress');

        if (!(address && address.get('country'))) {
            address = new Address({country: 'US'});
        }

        // Cancel any outstanding requests
        if (this._availableOptionsDeferred) {
            this._availableOptionsDeferred.reject();
        }

        this._availableOptionsDeferred = new $.Deferred();
        availableOptions.fetchAvailableOptions(item, address, currencyConversionRateEventId).done(_.bind(function () {
            this.availableOptions = availableOptions;
            this.selectFirstAvailableOption();
            this._availableOptionsDeferred.resolve(availableOptions);
        }, this)).fail(_.bind(function () {
            this._availableOptionsDeferred.reject();
        }, this));
        return this._availableOptionsDeferred.promise();
    },
    /**
     * Returns a promise that resolves with the available options.
     * Only fetches if they have not already been fetched
     */
    getAvailableOptionsPromise: function () {
        if (this._availableOptionsDeferred && this._availableOptionsDeferred.promise()) {
            return this._availableOptionsDeferred.promise();
        } else {
            return this.fetchAvailableOptions();
        }
    },
    selectFirstAvailableOption: function () {
        var quote = this.availableOptions.getNonLocalShipmentQuotes()[0];
        if (quote) {
            this.setShipmentQuote(quote);
        } else {
            this.setQuoteNeeded();
        }
    },
    showOverrideUpsLabel: function () {
        var shipment = this.get('shipment');
        var hasBeenShipped = shipment.hasBeenShipped();
        var hasFailedAddressRegistration = shipment.hasFailedAddressRegistration();
        return !!(this.isConfirmed() && this.is1stdibsParcelShipping() && hasBeenShipped === false && hasFailedAddressRegistration === false);
    },
    /**
     * Returns true or false depending on whether UPS label override was successful.
     * Checks that there are two accounting quotes: one canceled and one accepted.
     */
    wasOverrideUpsLabelSuccessful: function () {
        var shipmentQuotes = this.get('shipmentQuotes');
        var canceledQuote = shipmentQuotes.find(function (quote) {
            return quote.get('pricingType') === "ACCOUNTING" && quote.get('status') === "CANCELED";
        });
        var acceptedQuote = shipmentQuotes.find(function (quote) {
            return quote.get('pricingType') === "ACCOUNTING" && quote.get('status') === "ACCEPTED";
        });
        return !!(canceledQuote && acceptedQuote);
    }
};


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/**
 * filesize
 *
 * @copyright 2016 Jason Mulligan <jason.mulligan@avoidwork.com>
 * @license BSD-3-Clause
 * @version 3.1.6
 */
(function (global) {
	var b = /^(b|B)$/;
	var si = {
		bits: ["b", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"],
		bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
	};

	/**
  * filesize
  *
  * @method filesize
  * @param  {Mixed}   arg        String, Int or Float to transform
  * @param  {Object}  descriptor [Optional] Flags
  * @return {String}             Readable file size String
  */
	function filesize(arg) {
		var descriptor = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

		var result = [],
		    skip = false,
		    val = 0,
		    e = undefined,
		    base = undefined,
		    bits = undefined,
		    ceil = undefined,
		    neg = undefined,
		    num = undefined,
		    output = undefined,
		    round = undefined,
		    unix = undefined,
		    spacer = undefined,
		    suffixes = undefined;

		if (isNaN(arg)) {
			throw new Error("Invalid arguments");
		}

		bits = descriptor.bits === true;
		unix = descriptor.unix === true;
		base = descriptor.base !== undefined ? descriptor.base : 2;
		round = descriptor.round !== undefined ? descriptor.round : unix ? 1 : 2;
		spacer = descriptor.spacer !== undefined ? descriptor.spacer : unix ? "" : " ";
		suffixes = descriptor.suffixes !== undefined ? descriptor.suffixes : {};
		output = descriptor.output !== undefined ? descriptor.output : "string";
		e = descriptor.exponent !== undefined ? descriptor.exponent : -1;
		num = Number(arg);
		neg = num < 0;
		ceil = base > 2 ? 1000 : 1024;

		// Flipping a negative number to determine the size
		if (neg) {
			num = -num;
		}

		// Zero is now a special case because bytes divide by 1
		if (num === 0) {
			result[0] = 0;
			result[1] = unix ? "" : !bits ? "B" : "b";
		} else {
			// Determining the exponent
			if (e === -1 || isNaN(e)) {
				e = Math.floor(Math.log(num) / Math.log(ceil));
			}

			// Exceeding supported length, time to reduce & multiply
			if (e > 8) {
				e = 8;
			}

			val = base === 2 ? num / Math.pow(2, e * 10) : num / Math.pow(1000, e);

			if (bits) {
				val = val * 8;

				if (val > ceil) {
					val = val / ceil;
					e++;
				}
			}

			result[0] = Number(val.toFixed(e > 0 ? round : 0));
			result[1] = base === 10 && e === 1 ? bits ? "kb" : "kB" : si[bits ? "bits" : "bytes"][e];

			if (!skip && unix) {
				result[1] = result[1].charAt(0);

				if (b.test(result[1])) {
					result[0] = Math.floor(result[0]);
					result[1] = "";
				}
			}
		}

		// Decorating a 'diff'
		if (neg) {
			result[0] = -result[0];
		}

		// Applying custom suffix
		result[1] = suffixes[result[1]] || result[1];

		// Returning Array, Object, or String (default)
		if (output === "array") {
			return result;
		}

		if (output === "exponent") {
			return e;
		}

		if (output === "object") {
			return { value: result[0], suffix: result[1] };
		}

		return result.join(spacer);
	}

	// CommonJS, AMD, script tag
	if (true) {
		module.exports = filesize;
	} else if (typeof define === "function" && define.amd) {
		define(function () {
			return filesize;
		});
	} else {
		global.filesize = filesize;
	}
})(typeof window !== "undefined" ? window : global);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: ronald
 * Date: 1/7/13
 * Time: 7:10 PM
 */


var SoaModel = __webpack_require__(2);
var Transaction = module.exports = SoaModel.extend({}, {
    STATUS_NEW: 'NEW',
    STATUS_NEGOTIATING: 'NEGOTIATING',
    STATUS_NOT_AVAILABLE: 'NOT_AVAILABLE',
    STATUS_PENDING: 'PENDING',
    STATUS_CANCELED: 'CANCELED',
    STATUS_REFUNDED: 'REFUNDED',
    STATUS_CLOSED: 'CLOSED',
    TYPE_NEGOTIABLE: 'NEGOTIABLE',
    TYPE_NON_NEGOTIABLE: 'NON_NEGOTIABLE',
    TYPE_PRE_AUTH_NEGOTIATION: 'PRE_AUTH_NEGOTIATION',
    CANCELLATION_REASON_FRAUD: 'FRAUD',
    CANCELLATION_REASON_CANCELED_BEFORE_APPROVED: 'CANCELED_BEFORE_APPROVED',
    CANCELLATION_REASON_BUYER_NOT_RESPONDING_SHIPPING: 'BUYER_NOT_RESPONDING_SHIPPING',
    CANCELLATION_REASON_BUYER_NOT_RESPONDING_OFFER: 'BUYER_NOT_RESPONDING_OFFER',
    CANCELLATION_REASON_BUYER_NO_LONGER_INTERESTED_PRE_CHECKOUT: 'BUYER_NO_LONGER_INTERESTED_PRE_CHECKOUT',
    CANCELLATION_REASON_BUYER_PASSED_ON_OFFER_PRE_CHECKOUT: 'BUYER_PASSED_ON_OFFER_PRE_CHECKOUT',
    CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_DEALER_INACTION: 'OFFER_EXPIRED_PRE_CHECKOUT_DEALER_INACTION',
    CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_BUYER_INACTION: 'OFFER_EXPIRED_PRE_CHECKOUT_BUYER_INACTION',
    ERROR_EXISTING_TRANSACTION: 'EXISTING_TRANSACTION',
    ERROR_DUPLICATE_ORDER: 'DUPLICATE_ORDER'
});

var endpoints = __webpack_require__(6);
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var bunsen = __webpack_require__(21);
var Offers = __webpack_require__(162);
var Offer = __webpack_require__(25);
var CurrencyConversionRateEvent = __webpack_require__(332);
var Item = __webpack_require__(34);
var Shipment = __webpack_require__(83);
var TransactionShipmentQuotes = __webpack_require__(78);
var Seller = __webpack_require__(103);
var PaymentAuthorizations = __webpack_require__(163);
var PaymentAuthorization = __webpack_require__(24);
var Invoices = __webpack_require__(161);
var Disbursements = __webpack_require__(158);
var Notes = __webpack_require__(23);
var Note = __webpack_require__(33);
var User = __webpack_require__(28);
var Anchor = __webpack_require__(12);
var ReturnPolicy = __webpack_require__(318);
var Promotions = __webpack_require__(164);
var Price = __webpack_require__(66);
var FinancialAmount = __webpack_require__(10);
var Actions = __webpack_require__(157);
var Refunds = __webpack_require__(165);
var InvoiceSummary = __webpack_require__(235);
var simplyDeferred = __webpack_require__(29);

// Mixins
var actionMixin = __webpack_require__(194);
var documentAccessMixin = __webpack_require__(197);
var statusMixin = __webpack_require__(237);
var currencyMixin = __webpack_require__(196);
var shippingMixin = __webpack_require__(198);
var checkoutMixin = __webpack_require__(195);
var transitionMixin = __webpack_require__(19);

var root = typeof window === 'undefined' ? global : window;

function warn(prop) {

    Object.defineProperty(Transaction, 'STATUS_' + prop, {
        get: function () {
            console.warn('Attempting to access pre-N2.0 transaction status!', prop);
            return prop;
        }
    });
}

warn('SECURING_PAYMENT');
warn('AWAITING_MANUAL_REVIEW');
warn('PENDING_INVENTORY_CHECK');
warn('INVENTORY_CONFIRMED');

root.bunsen = root.bunsen || {};

// root.bunsen for console debugging
root.bunsen.Transaction = Transaction;

_.extend(Transaction.prototype, {
    idAttribute: "id",
    defaults: {
        buyer: {},
        offers: [],
        shipmentQuotes: [],
        notes: [],
        invoices: [],
        shipment: {},
        disbursements: []
    },
    initialize: function () {
        this.urlRoot = endpoints.transaction();
        this.url = Backbone.Model.prototype.url;
    },
    relations: function () {
        return [
            {
                type: Backbone.Many,
                key: 'offers',
                collectionType: Offers
            },
            {
                type: Backbone.One,
                key: 'currencyConversionRateEvent',
                relatedModel: CurrencyConversionRateEvent
            },
            {
                type: Backbone.One,
                key: 'displayMetadata',
                relatedModel: SoaModel.extend({
                    relations: [{
                        type: Backbone.One,
                        key: 'sla',
                        relatedModel: SoaModel
                    }]
                })
            },
            {
                type: Backbone.One,
                key: 'item',
                relatedModel: Item,
                saveJSONFields: ['id', 'apiType']
            },
            {
                type: Backbone.One,
                key: 'shipment',
                relatedModel: Shipment
            },
            {
                type: Backbone.Many,
                key: 'shipmentQuotes',
                collectionType: TransactionShipmentQuotes
            },
            {
                type: Backbone.One,
                key: 'buyer',
                relatedModel: User,
                saveJSONFields: ['id']
            },
            {
                type: Backbone.One,
                key: 'seller',
                relatedModel: Seller,
                saveJSONFields: ['id']
            },
            {
                type: Backbone.Many,
                key: 'paymentAuthorizations',
                collectionType: PaymentAuthorizations
            },
            {
                type: Backbone.Many,
                key: 'invoices',
                collectionType: Invoices
            },
            {
                type: Backbone.Many,
                key: 'disbursements',
                collectionType: Disbursements
            },
            {
                type: Backbone.Many,
                key: 'notes',
                collectionType: Notes,
                omitFromSave: true
            },
            {
                type: Backbone.One,
                key: 'supportRep',
                relatedModel: User
            },
            {
                type: Backbone.One,
                key: 'salesRep',
                relatedModel: User
            },
            {
                type: Backbone.One,
                key: 'shippingRep',
                relatedModel: User
            },
            {
                key: 'returnPolicy',
                relatedModel: ReturnPolicy,
                type: Backbone.One
            },
            {
                key: 'promotions',
                collectionType: Promotions,
                type: Backbone.Many
            },
            {
                key: 'actions',
                collectionType: Actions,
                type: Backbone.Many
            },
            {
                key: 'refunds',
                collectionType: Refunds,
                type: Backbone.Many
            },
            {
                key: 'summary',
                relatedModel: SoaModel.extend({
                    relations: [
                        {
                            key: 'availablePrices',
                            relatedModel: Price,
                            type: Backbone.Many
                        },
                        {
                            key: 'acceptedOffer',
                            relatedModel: Offer,
                            type: Backbone.One
                        },
                        {
                            key : 'balanceDueAmount',
                            relatedModel : FinancialAmount,
                            type : Backbone.One
                        },
                        {
                            key : 'settlingAmount',
                            relatedModel : FinancialAmount,
                            type : Backbone.One
                        },
                        {
                            key : 'itemPrice',
                            relatedModel : Price,
                            type : Backbone.One
                        },
                        {
                            key : 'checkoutPaymentAuthorization',
                            relatedModel : PaymentAuthorization,
                            type : Backbone.One
                        },
                        {
                            key : 'balanceDuePaymentAuthorization',
                            relatedModel : PaymentAuthorization,
                            type : Backbone.One
                        },
                        {
                            key: 'checkoutOffer',
                            relatedModel: Offer,
                            type: Backbone.One
                        },
                        {
                            key : 'totalCapturedAmount',
                            relatedModel : FinancialAmount,
                            type : Backbone.One
                        },
                        {
                            key: 'invoiceSummary',
                            relatedModel: InvoiceSummary,
                            type: Backbone.One
                        }
                    ]
                }),
                type: Backbone.One
            }
        ];
    },
    parse: function (response) {
        var transaction;
        if (response.result) {
            transaction = response.result;
        } else {
            transaction = response;
        }
        return SoaModel.prototype.parse.call(this, transaction);
    },
    getCancellationReason: function () {
        return this.get('cancellationReason');
    },
    canMultipleQuantityBePurchased: function () {
        var item = this.get('item');
        return item && item.canMultipleQuantityBePurchased();
    },
    savePrivateOffers: function () {
        if (this.isNew()) {
            // for new transactions, the entire transaction is saved
            // compute adjustments must be called before saving a transaction
            return this.computeAdjustments().then(this.save.bind(this));
        } else {
            // if adding offer to an existing transaction, save the offer
            return simplyDeferred.when.apply(simplyDeferred,
                _(this.get('offers').filter(bunsen.callon('isNew'))).invoke('save'));
        }
    },
    /**
     * @param {object} [newNoteOptions]
     * @param {object[]} [additionalAnchors]
     * @returns {Note}
     */
    newNote: function (newNoteOptions, additionalAnchors) {
        return this.get('notes').newNote(this._getOptionsForNewNote(newNoteOptions, additionalAnchors));
    },
    /**
     * Returns a new note with type BUYER_SELLER,
     * and defaults the createdBy to have the role
     * "SELLER" and the id to be the transaction
     * seller id
     * @param {object} [newNoteOptions]
     * @param {object[]} [additionalAnchors]
     * @returns {Note}
     */
    newBuyerSellerNote: function (newNoteOptions, additionalAnchors) {
        newNoteOptions = _.extend({ creatorId: this.get('seller.id') }, newNoteOptions || {});
        return this.get('notes').newBuyerSellerNote(this._getOptionsForNewNote(newNoteOptions, additionalAnchors));
    },
    /**
     * @param {object} [noteOptions]
     * @param {object} [syncOptions]
     * @returns {$.Deferred.promise}
     */
    addNewNote : function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        return this.addAndSaveNote(note, syncOptions);
    },
    /**
     * @param {Note} note
     * @param {object} [syncOptions]
     * @returns {$.Deferred.promise}
     */
    addAndSaveNote: function (note, syncOptions) {
        console.assert(note instanceof Note, 'Note must be instance of note');
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },

    _getOptionsForNewNote: function (newNoteOptions, additionalAnchors) {
        var anchors;
        newNoteOptions = newNoteOptions || {};
        anchors = newNoteOptions.anchors || this._getDefaultNoteAnchors() || [];
        anchors = additionalAnchors ? anchors.concat(additionalAnchors) : anchors;
        return _.extend({ anchors: anchors }, newNoteOptions);
    },
    _getDefaultNoteAnchors: function () {
        return [{
            sourceId : this.get('id'),
            sourceType : Anchor.TYPE_TRANSACTION
        }, {
            sourceId: this.get('seller.id'),
            sourceType : Anchor.TYPE_SELLER
        }];
    },
    /**
     * used for OMT reloading after changes to sub models.
     */
    refetch: function () {
        var self = this;
        var actions = this.get('actions');

        // remove all actions before fetching to make sure stale actions are removed
        if (actions) {
            actions.reset();
        }

        this.trigger('refetching');
        return this.fetch({
            refetching: true
        }).always(function () {
            self.trigger('refetched');
        });
    }
}, actionMixin, documentAccessMixin, statusMixin, currencyMixin, shippingMixin, checkoutMixin, transitionMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

/**
 * lodash 3.2.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return function() {
    var length = arguments.length,
        index = fromRight ? length : -1,
        leftIndex = 0,
        funcs = Array(length);

    while ((fromRight ? index-- : ++index < length)) {
      var func = funcs[leftIndex++] = arguments[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
    }
    return function() {
      var index = 0,
          result = length ? funcs[index].apply(this, arguments) : arguments[0];

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  };
}

/**
 * Creates a function that returns the result of invoking the provided
 * functions with the `this` binding of the created function, where each
 * successive invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {...Function} [funcs] Functions to invoke.
 * @returns {Function} Returns the new function.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow(_.add, square);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 43);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

module.exports = __webpack_require__(77);

/***/ },
/* 1 */
/***/ function(module, exports) {

module.exports = __webpack_require__(112);

/***/ },
/* 2 */
/***/ function(module, exports) {

module.exports = __webpack_require__(0);

/***/ },
/* 3 */
/***/ function(module, exports) {

module.exports = __webpack_require__(104);

/***/ },
/* 4 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"badgeTrade":"src-views-MessageSummary-style---badgeTrade---3_OuL","mcMessageSummary":"src-views-MessageSummary-style---mcMessageSummary---kNbyt","mcMessage":"src-views-MessageSummary-style---mcMessage---1oiTz","mcMessageBodyWrapper":"src-views-MessageSummary-style---mcMessageBodyWrapper---2WSIw","mcMessageHeader":"src-views-MessageSummary-style---mcMessageHeader---2uvej","attachmentErrorList":"src-views-MessageSummary-style---attachmentErrorList---1xm88","mcDisplayName":"src-views-MessageSummary-style---mcDisplayName---vfQDh","mcMessageBody":"src-views-MessageSummary-style---mcMessageBody---1GvUw","mcComposeControls":"src-views-MessageSummary-style---mcComposeControls---1hK4F","mcHasAttachment":"src-views-MessageSummary-style---mcHasAttachment---2exkf","mcMessageAttachIcon":"src-views-MessageSummary-style---mcMessageAttachIcon---1w0sl","showFlaggedMessage":"src-views-MessageSummary-style---showFlaggedMessage---2uqiX","mcAttachmentList":"src-views-MessageSummary-style---mcAttachmentList---2pPdO","numCollapsedIndicator":"src-views-MessageSummary-style---numCollapsedIndicator---2iis9","mcSentByCurrentUser":"src-views-MessageSummary-style---mcSentByCurrentUser---1l1CG","numCollapsedIndicatorTextWrapper":"src-views-MessageSummary-style---numCollapsedIndicatorTextWrapper---16Cj2","mcMessageBodyPlaceholder":"src-views-MessageSummary-style---mcMessageBodyPlaceholder---18NZ0","mcAttachmentFilename":"src-views-MessageSummary-style---mcAttachmentFilename---2gCw8","mcAttachmentImage":"src-views-MessageSummary-style---mcAttachmentImage---3ijZC","mcAttachmentLoading":"src-views-MessageSummary-style---mcAttachmentLoading---3IxqZ","mcAttachmentFileSize":"src-views-MessageSummary-style---mcAttachmentFileSize---3z4_i","mcAttachmentIcon":"src-views-MessageSummary-style---mcAttachmentIcon---2LpFf","attachmentListDisplay":"src-views-MessageSummary-style---attachmentListDisplay---2JMWZ","mcAttachmentListUgc":"src-views-MessageSummary-style---mcAttachmentListUgc---3hn19","mcAttachmentRow":"src-views-MessageSummary-style---mcAttachmentRow---JzKZX","mcAttachmentItem":"src-views-MessageSummary-style---mcAttachmentItem---2FPfP","mcAttachmentFileName":"src-views-MessageSummary-style---mcAttachmentFileName---1Xh6n","mcComposeAttachButton":"src-views-MessageSummary-style---mcComposeAttachButton---1V3qu","mcComposeAttachIcon":"src-views-MessageSummary-style---mcComposeAttachIcon---3Nr4u","mcComposeSend":"src-views-MessageSummary-style---mcComposeSend---3_D07","mcComposeSendContainer":"src-views-MessageSummary-style---mcComposeSendContainer---Rzndb","privateOfferIndicator":"src-views-MessageSummary-style---privateOfferIndicator---3Csxe","mcAttachmentListDisplay":"src-views-MessageSummary-style---mcAttachmentListDisplay---2YGRw","mcDisplayDate":"src-views-MessageSummary-style---mcDisplayDate---CZzq4","semiCollapsedOnly":"src-views-MessageSummary-style---semiCollapsedOnly---3Ydnp","privateOfferIcon":"src-views-MessageSummary-style---privateOfferIcon---2Ifnc","privateOfferPrice":"src-views-MessageSummary-style---privateOfferPrice---3vEKL","messageFlaggedIcon":"src-views-MessageSummary-style---messageFlaggedIcon---qJfoV"};

/***/ },
/* 5 */
/***/ function(module, exports) {

module.exports = __webpack_require__(38);

/***/ },
/* 6 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"badgeTrade":"src-views-Conversation-style---badgeTrade---1XAW5","mcAllConversationsBlock":"src-views-Conversation-style---mcAllConversationsBlock---11C93","mcConversationAlertContainer":"src-views-Conversation-style---mcConversationAlertContainer---1k0K-","alert":"src-views-Conversation-style---alert---1MLIK","mcBodyContainer":"src-views-Conversation-style---mcBodyContainer---1IPwx","mcUnavailableContainer":"src-views-Conversation-style---mcUnavailableContainer---2KAJu","mcUnvailableMessageSub":"src-views-Conversation-style---mcUnvailableMessageSub---wQTc0","cantShowConversationMessage":"src-views-Conversation-style---cantShowConversationMessage---1MmZx","mcConversationWrapper":"src-views-Conversation-style---mcConversationWrapper---1yBOA","mcConversationFooter":"src-views-Conversation-style---mcConversationFooter---19m1Y","mcConversationFilterAlert":"src-views-Conversation-style---mcConversationFilterAlert---tGRPM","mcConversationToolbar":"src-views-Conversation-style---mcConversationToolbar---1w7eM","mcConversationToolbarItemDisabled":"src-views-Conversation-style---mcConversationToolbarItemDisabled---npgNA","mcConversationReported":"src-views-Conversation-style---mcConversationReported---3fKZG","fa":"src-views-Conversation-style---fa----E6a4","mcBuyerConversation":"src-views-Conversation-style---mcBuyerConversation---UdSl0","alertAction":"src-views-Conversation-style---alertAction---21J4Z","conversationHeadsUp":"src-views-Conversation-style---conversationHeadsUp---286Ej","expandCollapseAll":"src-views-Conversation-style---expandCollapseAll---dqWF1","underneathConversation":"src-views-Conversation-style---underneathConversation---3udfU","alertContainer":"src-views-Conversation-style---alertContainer---OAGYl","exclamationIcon":"src-views-Conversation-style---exclamationIcon---M0DQV","circleIcon":"src-views-Conversation-style---circleIcon---K3Yzq"};

/***/ },
/* 7 */
/***/ function(module, exports) {

module.exports = __webpack_require__(150);

/***/ },
/* 8 */
/***/ function(module, exports) {

module.exports = __webpack_require__(151);

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var momentLocaleBuilder = __webpack_require__(42);
var moment = __webpack_require__(41);
var locales = {};
locales.en = {};
locales.inlineDatesAdverb = Object.assign({}, locales.inlineDates, {
    calendar: {
        sameDay: '[at] h:mmA',
        lastDay: '[on] MMMM D',
        nextDay: '[on] MMMM D',
        lastWeek: '[on] MMMM D',
        nextWeek: '[on] MMMM D',
        sameElse: function sameElse(now) {
            return '[on] MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    },
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    }
});
locales.inlineDates = {
    calendar: {
        sameDay: 'h:mmA',
        lastDay: 'MMMM D',
        nextDay: 'MMMM D',
        lastWeek: 'MMMM D',
        nextWeek: 'MMMM D',
        sameElse: function sameElse(now) {
            return 'MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    },
    relativeTime: Object.assign({}, locales.inlineDatesAdverb.relativeTime, {
        future: "%s",
        past: "%s"
    })
};
locales.inbox = {
    calendar: {
        sameDay: 'h:mmA',
        lastDay: 'dddd',
        nextDay: 'dddd',
        lastWeek: 'MMMM D',
        nextWeek: 'MMMM D',
        sameElse: function sameElse(now) {
            return 'MMMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    }
};
locales.inboxMobile = Object.assign({}, locales.inbox, {
    calendar: Object.assign({}, locales.inbox.calendar, {
        lastDay: 'ddd',
        nextDay: 'ddd',
        lastWeek: 'MMM D',
        nextWeek: 'MMM D',
        sameElse: function sameElse(now) {
            return 'MMM D' + (moment(now).diff(this, 'months') >= 6 ? ' YYYY' : '');
        }
    })
});
module.exports = momentLocaleBuilder(locales);

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var composeClassNames = __webpack_require__(3);
var css = composeClassNames(__webpack_require__(26), __webpack_require__(4));
var AttachmentView = module.exports = {};
var TemplateView = __webpack_require__(0);
var template = __webpack_require__(32);
var defaultIconClass = 'fa-file-o';
var bind = __webpack_require__(1);
var fileTypeToIconClassMap = {
    'application/pdf': 'fa-file-pdf-o',
    "application/msword": 'fa-file-word-o',
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": 'fa-file-word-o',
    "application/vnd.ms-excel": 'fa-file-excel-o',
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": 'fa-file-excel-o',
    //TODO: remove these duplicate mappings once services return MIME types for attachments
    'PDF': 'fa-file-pdf-o',
    'DOC': 'fa-file-word-o',
    'SPREADSHEET': 'fa-file-excel-o'
};

AttachmentView.Thumbnail = TemplateView.extend({
    initialize__: function initialize__(options) {
        bind(this);
        this.el.classList.add(css.attachmentImageWrapper);
        return options;
    },

    template: {
        local: css,
        src: template.thumbnail
    }
});
AttachmentView.Document = TemplateView.extend({
    template: {
        local: css,
        src: template.normal
    },
    initialize__: function initialize__(options) {
        bind(this);
        return options;
    },
    fileTypeToIconClass: function fileTypeToIconClass(fileType) {
        return fileTypeToIconClassMap[fileType] || defaultIconClass;
    },
    templateVars__: function templateVars__(obj) {
        return Object.assign({
            iconClass: this.fileTypeToIconClass(this.model.get('attachmentType'))
        }, obj);
    }
});
AttachmentView.Loading = TemplateView.extend({
    template: {
        local: css,
        src: template.loading
    }
});
AttachmentView.buildAttachmentByModel = function (attachmentModel) {
    var Constructor = AttachmentView.Loading;
    var attachmentType = attachmentModel.get('attachmentType');
    if ('IMAGE' === attachmentType) {
        Constructor = AttachmentView.Thumbnail;
    } else if (attachmentType) {
        Constructor = AttachmentView.Document;
    }
    return new Constructor({ model: attachmentModel });
};

/***/ },
/* 11 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"src-views-InboxWrapper-style---verticallyCentered---2E4xh","horizontallyRight":"src-views-InboxWrapper-style---horizontallyRight---3ID5-","horizontallyCentered":"src-views-InboxWrapper-style---horizontallyCentered---nMmCz","verticallyHorizontallyCentered":"src-views-InboxWrapper-style---verticallyHorizontallyCentered---11cGH","inbox":"src-views-InboxWrapper-style---inbox---U_kT8","mcUnreadMessage":"src-views-InboxWrapper-style---mcUnreadMessage---1SEGx","mcHeader":"src-views-InboxWrapper-style---mcHeader---1k5zB","mcFilterLabel":"src-views-InboxWrapper-style---mcFilterLabel---3e2zN","alertContainer":"src-views-InboxWrapper-style---alertContainer---3S1pv node_modules-scss-alignment-transforms-index---horizontallyCentered---OykGB","close":"src-views-InboxWrapper-style---close---3z2W0","alertAction":"src-views-InboxWrapper-style---alertAction---2g0RC","heading":"src-views-InboxWrapper-style---heading---1KHIE","inboxPanel":"src-views-InboxWrapper-style---inboxPanel---3osEQ","mcInboxEmptyContainer":"src-views-InboxWrapper-style---mcInboxEmptyContainer---W6jaB","mcInboxEmptyMessage":"src-views-InboxWrapper-style---mcInboxEmptyMessage---19k3K","mcInboxEmptyDivider":"src-views-InboxWrapper-style---mcInboxEmptyDivider---3Iyfe","mcInboxEmptyLinkContainer":"src-views-InboxWrapper-style---mcInboxEmptyLinkContainer---22wCz","mcInboxEmptyLink":"src-views-InboxWrapper-style---mcInboxEmptyLink---15xOp","mcItemsContainer":"src-views-InboxWrapper-style---mcItemsContainer---1SqYs"};

/***/ },
/* 12 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcBrowseHeader":"src-views-MessageCenter-style---mcBrowseHeader---2TEMQ","totalUnreadConversationCount":"src-views-MessageCenter-style---totalUnreadConversationCount---1fqcH"};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "template": function(obj) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="' +
((__t = ( obj.local.mcConversationWrapper )) == null ? '' : __t) +
' wrapper' +
((__t = ( obj.isUnavailable ? ' is-unavailable' : '' )) == null ? '' : __t) +
'">\n        <div class="' +
((__t = ( obj.messageLocation )) == null ? '' : __t) +
'"></div>\n        <div data-append=\'conversationHeader\'></div>\n        <div class="' +
((__t = ( obj.local.mcBodyContainer )) == null ? '' : __t) +
'">\n            <div class="row">\n                <div class="col-xs-12 col-md-8 col-md-push-2" data-append=\'notificationMsg\'></div>\n                <div class="' +
((__t = ( obj.local.mcMessagesColumn )) == null ? '' : __t) +
' col-xs-12 col-md-8 col-md-push-4">\n                    ';
 if (obj.isUnavailable) { ;
__p += '\n                        <div class="' +
((__t = ( obj.local.mcUnavailableContainer )) == null ? '' : __t) +
'">\n                            <div class="' +
((__t = ( obj.local.mcUnvailableMessage )) == null ? '' : __t) +
'">' +
((__t = ( obj.copy('unavailableMessage') )) == null ? '' : __t) +
'</div>\n                            <div class="' +
((__t = ( obj.local.mcUnvailableMessageSub )) == null ? '' : __t) +
'">' +
((__t = ( obj.copy('unavailableMessageSub') )) == null ? '' : __t) +
'</div>\n                        </div>\n                    ';
 } ;
__p += '\n                    <div data-append=\'headsUps\' class=\'gtm-message-detail-header\'></div>\n                    <div class=\'' +
((__t = ( obj.local.expandCollapseAll )) == null ? '' : __t) +
'\' data-model-bind=\'text: model.expandCollapseText, click: view.toggleExpandCollapse\'></div>\n                    <div data-append=\'messages\'></div>\n                    <div class=\'' +
((__t = ( obj.local.mcConversationFooter )) == null ? '' : __t) +
'\'>\n                        <span class="' +
__e( obj.local.alertContainer ) +
'" data-append=\'alertIcon\'></span>\n                        <span class="' +
((__t = ( obj.local.mcConversationFilterAlert )) == null ? '' : __t) +
'">\n                            <span class=\'' +
((__t = ( obj.local.underneathConversation )) == null ? '' : __t) +
'\' data-append=\'underneath\'></span>\n                        </span>\n                        <span class=\'' +
((__t = ( obj.local.mcConversationToolbar )) == null ? '' : __t) +
'\'>\n                            ';
 if (obj.messages) { ;
__p += '\n                            <span data-modal=\'flagConversation\' class=\'gtm-modal-trigger\' data-modal-name=\'report conversation\' data-modal-trigger=\'hyperlink\' data-model-bind=\'css: {"' +
((__t = ( obj.local.mcConversationReported )) == null ? '' : __t) +
'": computed.userHasReportedConversation}, attr: {"data-modal": computed.userHasReportedConversation ? "alreadyReportedConversation" : "flagConversation"}\'>\n                                <span data-model-bind=\'text: (computed.userHasReportedConversation ? "reported" : "report") + " conversation"\'></span>\n                            </span>\n                            ';
 } ;
__p += '\n                        </span>\n                    </div>\n                </div>\n                <div class="col-xs-12 col-md-4 col-md-pull-8" data-append="sidePiece"></div>\n            </div>\n        </div>\n    </div>\n    <div data-append="bottomSection"></div>\n';
return __p
}
};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _bubbleEvent = __webpack_require__(8);

var _bubbleEvent2 = _interopRequireDefault(_bubbleEvent);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = (0, _composeClassNames2.default)(__webpack_require__(27), __webpack_require__(4));
var bind = __webpack_require__(1);
var MessageAttachmentView = __webpack_require__(10);
var template = __webpack_require__(33).attachmentIndicator;
module.exports = MessageAttachmentView.Document.extend({
    events: {
        'click [data-name=try-again]': function clickDataNameTryAgain() {
            this.model.save();
        },
        'click [data-name=remove-attachment]': function clickDataNameRemoveAttachment() {
            this.removeAttachment();
        }
    },
    template__: {
        src: template,
        local__: css
    },
    updateProgress: function updateProgress() {
        var uploadProgress = '';
        var uploadTotal = this.model.get('upload-total');
        if (!uploadTotal) {
            return;
        }
        uploadProgress += Math.floor(this.model.get('upload-sent') * 100 / uploadTotal);
        uploadProgress += '%';
        this.el.querySelector('[name=upload-progress]').textContent = uploadProgress;
    },
    removeAttachment: function removeAttachment() {
        return (0, _bubbleEvent2.default)(this.el, 'remove-attachment', this.model);
    },
    initialize__: function initialize__(options) {
        this.model.on('change:upload-sent', this.updateProgress, this); // TODO: handle this with bindings
        bind(this);
        return options;
    }
}, {
    newsy: 'AttachmentIndicator'
});

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

var _style = __webpack_require__(4);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(28);

var _style4 = _interopRequireDefault(_style3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: (0, _composeClassNames2.default)(_style2.default, _style4.default)
    }
});

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _template = __webpack_require__(13);

var _style = __webpack_require__(6);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        src: _template.template,
        local: _style2.default,
        messageLocation: '.' + _style2.default.mcConversationAlertContainer
    }
});

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(12);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(6);

var _style4 = _interopRequireDefault(_style3);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

var _template = __webpack_require__(13);

var _backboneModel = __webpack_require__(7);

var _b3nd = __webpack_require__(1);

var _b3nd2 = _interopRequireDefault(_b3nd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    initialize__: function initialize__(options) {
        this.model = new _backboneModel.Model();
        // b3nd this view here because its template declares b3ndings.
        // Otherwise, the parent view will try to evaluate the b3ndings and get very confused.
        (0, _b3nd2.default)(this);
        return options;
    },

    template: {
        src: _template.template,
        local: (0, _composeClassNames2.default)(_style2.default, _style4.default)
    }
});

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _template = __webpack_require__(34);

var TemplateView = __webpack_require__(0);
var css = __webpack_require__(29);
var copyText = __webpack_require__(5)();
var bind = __webpack_require__(1);
var OfferDiscountAmounts = __webpack_require__(25);

var PRIVATE_OFFER_NOTIFICATION_TYPE = 'newDealerOffer';
var SHOW_DISCOUNT_NOTIFICATION_TYPE = 'newDealerOfferDiscount';
var MARK_SHIPPED_NOTIFICATION_TYPE = 'markShippedNotification';
var PRICE_TYPE_RETAIL = 'RETAIL';
var PRICE_TYPE_SALE = 'WEEKLY_SALE';
var PRICE_TYPE_NET = 'NET';
var ITEM_PUR = 'Price Upon Request';
var ITEM_SOLD = 'Sold';

var ConversationHeadsUpView = module.exports = TemplateView.extend({
    template: {
        local: css,
        src: _template.template
    },
    initialize: function initialize(options) {
        var _this = this;

        if (!this.model) {
            throw new Error("ConversationHeadsUpView must be constructed with a model");
        }
        this.context = options.context;
        this.props = Object.assign({}, options.props);
        if (!this.context) {
            throw new Error('ConversationHeadsUpView view requires options.context');
        }
        this._copyText = (options.copyText || copyText).extend({
            netPriceLabel: 'Net Price',
            salePriceLabel: 'Sale Price',
            listPriceLabel: 'List Price',
            netLabel: 'net',
            listLabel: 'list'
        });
        this._messageCenter = options.messageCenter;
        this._item = this.model.get('item');
        this._itemStatus = this._item && this._item.getItemHidePriceStatus();
        this._buyerIsTrade = Boolean(this.model.get('members').find(function (member) {
            var roles = member.get('user').get('roles');
            if (!roles) {
                return undefined;
            }
            return Boolean(roles.find(function (role) {
                return role.get('name') === 'B_TRADE_BUYER';
            }));
        }));

        ConversationHeadsUpView.__super__.initialize.apply(this, arguments);
        this._bindApi = bind(this);
        this._bindApi.off(); // MCPERSON-2486: opt in to model change binding via .on()
        this.model.on('change:transaction', function () {
            return _this._bindApi.forceUpdate();
        });
        return options;
    },
    templateVars__: function templateVars__(obj) {
        return Object.assign({
            isSoldIndividually: this.props.isSoldIndividually,
            thumbnail: this.props.thumbnail,
            pdpUrl: this.props.pdpUrl,
            prices: this._getPricesArray()
        }, obj);
    },
    _getOfferDisplayVars: function _getOfferDisplayVars() {
        var notificationDetails = { notificationMsg: '', offerExpDateTxt: '' };
        var transaction = this.model.get('transaction');
        var offerDetails = transaction ? transaction.getOfferDetails() : {};
        var offer = offerDetails.offer;
        var offerAmounts = offerDetails.offerAmounts;

        if (!offer || !offerAmounts) {
            return notificationDetails;
        }

        var transactionSummary = transaction.get('summary');
        /* istanbul ignore next */
        var transactionItemPriceType = transactionSummary ? transactionSummary.get('itemPrice.type') : undefined;
        var copyKeyPrefix = transaction.isBuyerInitiatedTx() ? 'buyer' : 'dealer';
        var offerExpiredOrCanceledOtherOverride = this._copyText.get(copyKeyPrefix + 'OfferExpiredOrCanceledOtherOverride');
        var offerPassedOverride = this._copyText.get(copyKeyPrefix + 'OfferPassedOverride');
        var showPrice = !this._itemStatus;

        var notificationType = offer.offerDisplayStatus({ transaction: transaction });
        var displayOffer = this._getFormattedPrice({ financialAmount: offerAmounts, className: 'item-offer-price' });
        var displayDiscount = void 0;
        var pcsNotification = void 0;
        var priceType = void 0;
        var discountOffMultiplier = void 0;
        var displayDiscountPercent = void 0;

        if (!notificationType) {
            return notificationDetails;
        }

        if (showPrice && notificationType === PRIVATE_OFFER_NOTIFICATION_TYPE) {
            displayDiscount = this._getFormattedPrice({
                financialAmount: new OfferDiscountAmounts(transactionSummary.get('offerDiscountAmount')),
                className: 'item-offer-price'
            });
            discountOffMultiplier = parseFloat(transactionSummary.get('offerDiscountPercentage'));
            displayDiscountPercent = Math.floor(discountOffMultiplier * 100) + '%';
        }

        if (displayDiscount) {
            /* istanbul ignore next */
            priceType = this._copyText.get(transactionItemPriceType === PRICE_TYPE_NET ? 'netLabel' : 'listLabel');
            if (discountOffMultiplier > 0) {
                notificationType = SHOW_DISCOUNT_NOTIFICATION_TYPE;
            }
            if (offerAmounts.getAmountIn('USD') > 5000 && !this._buyerIsTrade) {
                pcsNotification = this._copyText.get('pcsNotification');
            }
        }

        if (this._canMarkOrderShipped) {
            notificationType = MARK_SHIPPED_NOTIFICATION_TYPE;
        }

        /* istanbul ignore next */
        if (this.props.isSoldIndividually) {
            var perItem = this._copyText.get('per item');
            displayOffer = displayOffer + ' ' + perItem;
            displayDiscount = displayDiscount ? displayDiscount + ' ' + perItem : undefined;
            displayDiscountPercent = displayDiscountPercent ? displayDiscountPercent + ' ' + perItem : undefined;
        }

        notificationDetails.pcsNotification = pcsNotification;
        notificationDetails.offerExpDateTxt = offerDetails.offerExpDateTxt;
        notificationDetails.notificationMsg = this._copyText.get(notificationType, { obj: {
                txId: transaction.get('id'),
                displayOffer: displayOffer,
                displayDiscount: displayDiscount,
                displayDiscountPercent: displayDiscountPercent,
                offerExpiredOrCanceledOtherOverride: offerExpiredOrCanceledOtherOverride,
                offerPassedOverride: offerPassedOverride,
                priceType: priceType,
                detailsLinkClassName: css.headsUpViewDOMT
            } });

        return notificationDetails;
    },
    _getPricesArray: function _getPricesArray() {
        var prices = [];
        var showPrice = !this._itemStatus;
        if (!this._item) {
            return prices;
        }

        var salePrice = this._item.getPriceByType(PRICE_TYPE_SALE);
        var retailPrice = this._item.getPriceByType(PRICE_TYPE_RETAIL);
        var netPrice = this._item.getPriceByType(PRICE_TYPE_NET);

        var initialPrice = void 0;
        if (salePrice) {
            initialPrice = {
                label: this._copyText.get('salePriceLabel'),
                value: this._getFormattedPrice({ financialAmount: salePrice.get('amount') }),
                type: PRICE_TYPE_SALE
            };
        } else if (showPrice) {
            initialPrice = {
                label: this._copyText.get('listPriceLabel'),
                value: this._getFormattedPrice({ financialAmount: retailPrice.get('amount') }),
                type: PRICE_TYPE_RETAIL
            };
        } else {
            initialPrice = { label: this._itemStatus };
        }

        var isTrade = this._buyerIsTrade && this._item.isFurniture();
        var transaction = this.model.get('transaction');
        var offerDetails = transaction ? transaction.getOfferDetails() : {};
        var offer = offerDetails.offer;
        var offerAmounts = offerDetails.offerAmounts;

        if (initialPrice.label === ITEM_SOLD) {
            prices.push(initialPrice);
            return prices;
        }

        if (isTrade && netPrice && this._isNetPriceEnabled() && initialPrice.type !== PRICE_TYPE_SALE) {
            // Don't show "Price Upon Request" if net price was uploaded
            if (initialPrice.label !== ITEM_PUR) {
                prices.push(initialPrice);
            }

            prices.push({
                label: this._copyText.get('netPriceLabel'),
                value: this._getFormattedPrice({ financialAmount: netPrice.get('amount') }),
                type: PRICE_TYPE_NET,
                callout: 'listedNetPriceCallout'
            });
        } else {
            prices.push(initialPrice);
        }

        if (offer && offerAmounts && transaction.buyerCanAcceptPrivateOffer()) {
            prices.push({
                label: this._copyText.get(isTrade ? 'offerPriceTradeLabel' : 'offerPriceLabel'),
                value: this._getFormattedPrice({ financialAmount: offerAmounts })
            });
        }

        return prices;
    },
    _isNetPriceEnabled: function _isNetPriceEnabled() {
        return true;
    },

    computeds: {
        offerDisplay: function offerDisplay() {
            return this._getOfferDisplayVars();
        }
    }
});
module.exports.priceTypes = {
    PRICE_TYPE_RETAIL: PRICE_TYPE_RETAIL,
    PRICE_TYPE_SALE: PRICE_TYPE_SALE,
    PRICE_TYPE_NET: PRICE_TYPE_NET
};
module.exports.constants = {
    PRIVATE_OFFER_NOTIFICATION_TYPE: PRIVATE_OFFER_NOTIFICATION_TYPE,
    SHOW_DISCOUNT_NOTIFICATION_TYPE: SHOW_DISCOUNT_NOTIFICATION_TYPE,
    MARK_SHIPPED_NOTIFICATION_TYPE: MARK_SHIPPED_NOTIFICATION_TYPE,
    PRICE_TYPE_RETAIL: PRICE_TYPE_RETAIL,
    PRICE_TYPE_SALE: PRICE_TYPE_SALE,
    PRICE_TYPE_NET: PRICE_TYPE_NET,
    ITEM_PUR: ITEM_PUR,
    ITEM_SOLD: ITEM_SOLD
};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var css = __webpack_require__(30);
var momentLocales = __webpack_require__(9);
var template = __webpack_require__(35);
var TemplateView = __webpack_require__(0);
var bind = __webpack_require__(1);
var copyText = __webpack_require__(5)();
var ellipsis = __webpack_require__(38);
var bubble = __webpack_require__(8);

var ConversationSummary = module.exports = TemplateView.extend({
    events: {
        "click": function click() {
            bubble(this.el, "showConversation", this.model.id);
        }
    },
    template: {
        local: css,
        src: template.conversationSummary
    },
    initialize: function initialize(options) {
        var _this = this;

        this.on('parentResized', function () {
            return ellipsis(_this._conversationBodySummary);
        });
        this._copyText = options.copyText || copyText;
        this._imagesHosts = options.imagesHosts;
        this._transaction = this.model.get('transaction');
        if (this._transaction) {
            this._offer = this._transaction.getMostRecentOffer();
        }
        ConversationSummary.__super__.initialize.call(this, options);
        this._conversationBodySummary = this.$('.' + css.mcConversationBodySummary);
        this.trigger('parentResized');
        bind(this);
        return options;
    },
    indicators: function indicators() {
        return [{
            template: template.indicators
        }];
    },
    scope: function scope() {
        return {
            indicatorsMobile: this.indicators(),
            indicatorsDesktop: this.indicators()
        };
    },

    templateVars__: function templateVars__(obj) {
        var seller = this.model.getOriginalSeller();
        var item = this.model.get('item');
        var templateData = Object.assign(this._getStatusMessage(), {
            displayDate: momentLocales.inbox(obj.latestMessageReceivedAt).calendar(),
            displayDateMobile: momentLocales.inboxMobile(obj.latestMessageReceivedAt).calendar(),
            countUpClockDays: 0
        });

        if (item) {
            templateData.thumbnail = item.getImageUrl({ position: 1, size: 'small' });
            templateData.itemDealerReference = item.get('dealerReference');
        } else if (seller) {
            var preferences = seller.get('user.sellerPreferences');
            if (preferences && preferences.scrollLogo) {
                templateData.thumbnail = preferences.scrollLogo;
            }
        }
        return Object.assign({}, obj, templateData, {
            otherMemberDisplayName: this.model.getOtherMemberDisplayName(),
            copy: this._copyText.get.bind(this._copyText)
        });
    },

    _getStatusMessage: function _getStatusMessage() {
        if (!this._transaction) {
            return {};
        }
        if (this._transaction.isCanceled()) {
            return {};
        }
        // Order is important here since a confirmed transaction has also completed checkout
        if (this._transaction.isConfirmed()) {
            return {
                statusMessage: copyText.get('order complete'),
                statusComplete: true
            };
        }
        if (this._transaction.isCheckoutComplete()) {
            return { statusMessage: copyText.get('order pending') };
        }
        if (!this._offer) {
            return {};
        }
        if (!this._offer.isExpired()) {
            return {
                statusMessage: copyText.get('offer pending')
            };
        }
        return {};
    }
}, {
    newsy: 'ConversationSummary'
});

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(31);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: _style2.default
    }
});

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var _bubbleEvent = __webpack_require__(8);

var _bubbleEvent2 = _interopRequireDefault(_bubbleEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var forEach = __webpack_require__(39);
var invert = __webpack_require__(40);
var TemplateView = __webpack_require__(0);
var b3nd = __webpack_require__(1);
var copyText = __webpack_require__(5)();
var templates = __webpack_require__(36);
var allValue = 'all';
var unreadValue = 'showUnreadOnly';

var trackingValueMap = {
    'all': 'all',
    'showUnreadOnly': 'unread'
};

var InboxFilterView = module.exports = TemplateView.extend({
    events: {
        'change #conversationFilter': function changeConversationFilter(event) {
            var val = event.target.value;
            var prefix = trackingValueMap[val] || '';
            var label = prefix + ' clicked - dropdown';
            this.filter(val);
            // todo: remove once we're using native click event bubbling to track events
            (0, _bubbleEvent2.default)(this.el, 'changeConversationFilter', label);
        },
        'click .mc-filter-button-value': function clickMcFilterButtonValue(event) {
            var target = event.target;
            event.preventDefault();
            this.filter(target.getAttribute('data-value'));
        },
        'filter': function filter(event) {
            this.model.set(event.detail);
        }
    },

    tagName: 'span',

    initialize: function initialize(options) {
        this._isBuyer = options.isBuyer;
        // TODO: set template in admin / dotcom subclasses
        this.template = templates['conversationFilter' + (this._isBuyer ? 'Select' : 'Dropdown')];
        this.filters = {};
        this.filters[allValue] = copyText.get('filterAll');
        this.filters[unreadValue] = copyText.get('filterUnread');
        if (!this._isBuyer) {
            this.filters.showNeverRespondedOnly = copyText.get('filterNeedsResponse');
        }
        InboxFilterView.__super__.initialize.apply(this, arguments);
        b3nd(this);
    },
    computeds: {
        selectedfilterLabel: function selectedfilterLabel() {
            return this.mapSelectedFilter().label;
        },
        selectedfilterValue: function selectedfilterValue() {
            return this.mapSelectedFilter().value;
        }
    },
    filter: function filter(selectedFilter) {
        var params = {
            params: {},
            pageStart: 0
        };
        forEach(this.filters, function (label, value) {
            if (value !== allValue) {
                params.params[value] = 'N';
            }
        });
        if (selectedFilter !== allValue) {
            params.params[selectedFilter] = 'Y';
        }
        (0, _bubbleEvent2.default)(this.el, 'filter', params);
    },

    mapSelectedFilter: function mapSelectedFilter() {
        var pagerParams = this.model.get('params');
        var selectedFilterObj = {};
        selectedFilterObj.value = invert(pagerParams).Y || allValue;
        selectedFilterObj.label = this.filters[selectedFilterObj.value];
        return selectedFilterObj;
    },

    templateVars__: function templateVars__(obj) {
        return Object.assign({}, obj, {
            filters: this.filters,
            selectedFilter: this.mapSelectedFilter()
        });
    }
});

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(11);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: _style2.default
    }
});

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(12);

var _style2 = _interopRequireDefault(_style);

var _style3 = __webpack_require__(11);

var _style4 = _interopRequireDefault(_style3);

var _style5 = __webpack_require__(6);

var _style6 = _interopRequireDefault(_style5);

var _composeClassNames = __webpack_require__(3);

var _composeClassNames2 = _interopRequireDefault(_composeClassNames);

var _template = __webpack_require__(37);

var _backboneModel = __webpack_require__(7);

var _b3nd = __webpack_require__(1);

var _b3nd2 = _interopRequireDefault(_b3nd);

var _copyText = __webpack_require__(5);

var _copyText2 = _interopRequireDefault(_copyText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var copyText = (0, _copyText2.default)();

var MessageCenterView = _templateView2.default.extend({
    initialize: function initialize() {
        this.state = new _backboneModel.Model();
        MessageCenterView.__super__.initialize.apply(this, arguments);
        (0, _b3nd2.default)(this);
    },

    template: {
        src: _template.messageCenter,
        local: (0, _composeClassNames2.default)(_style2.default, (0, _composeClassNames2.default)(_style4.default, _style6.default))
    },
    templateVars: function templateVars(obj) {
        return Object.assign({}, obj, {
            copy: copyText.get.bind(copyText)
        });
    }
});
exports.default = MessageCenterView;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateView = __webpack_require__(0);

var _templateView2 = _interopRequireDefault(_templateView);

var _style = __webpack_require__(4);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _templateView2.default.extend({
    template: {
        local: _style2.default
    }
});

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

var Model = __webpack_require__(7).Model;

module.exports = Model.extend({
    initialize: function initialize(attrs) {
        this.set('convertedAmounts', new Model(attrs.convertedAmounts));
    },

    getCurrency: function getCurrency() {
        return this.get('currency');
    },
    localizedAmount: function localizedAmount() {
        // admin function stubbed to prevent errors
        return false;
    }
});

/***/ },
/* 26 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"attachmentImageWrapper":"src-views-Attachment-style---attachmentImageWrapper---2BKtR"};

/***/ },
/* 27 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcAttachmentRemove":"src-views-AttachmentIndicator-style---mcAttachmentRemove---krgow","mcAttachmentThumbnail":"src-views-AttachmentIndicator-style---mcAttachmentThumbnail---3MMjx","attachmentErrorList":"src-views-AttachmentIndicator-style---attachmentErrorList---2aUPe","mcAttachmentUploadProgress":"src-views-AttachmentIndicator-style---mcAttachmentUploadProgress---2kblJ"};

/***/ },
/* 28 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcMessageSummary":"src-views-ComposeMessage-style---mcMessageSummary---2F1it","mcComposing":"src-views-ComposeMessage-style---mcComposing---1UBth","mcComposeControls":"src-views-ComposeMessage-style---mcComposeControls---3-N2n","mcMessage":"src-views-ComposeMessage-style---mcMessage---2FrEm","attachmentErrorList":"src-views-ComposeMessage-style---attachmentErrorList---2AvXz","mcMessageHeader":"src-views-ComposeMessage-style---mcMessageHeader---1b81d","mcMessageBodyWrapper":"src-views-ComposeMessage-style---mcMessageBodyWrapper---13Mm3","mcMessageBody":"src-views-ComposeMessage-style---mcMessageBody---zND6J"};

/***/ },
/* 29 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"mcHeadsUp":"src-views-ConversationHeadsUp-style---mcHeadsUp---Jw6Cn","headsUpTopline":"src-views-ConversationHeadsUp-style---headsUpTopline---11iNC","headsUpExpDate":"src-views-ConversationHeadsUp-style---headsUpExpDate---2Glo1","headsUpNotif":"src-views-ConversationHeadsUp-style---headsUpNotif---1JoIX","itemOfferPrice":"src-views-ConversationHeadsUp-style---itemOfferPrice---i6klC","headsUpPCS":"src-views-ConversationHeadsUp-style---headsUpPCS---28AEW","headsUpPcs":"src-views-ConversationHeadsUp-style---headsUpPCS---28AEW","headsUpContent":"src-views-ConversationHeadsUp-style---headsUpContent---2lfEI","headsUpThumbnail":"src-views-ConversationHeadsUp-style---headsUpThumbnail---1WnGf","headsUpInfo":"src-views-ConversationHeadsUp-style---headsUpInfo---TqZZq","headsUpTitle":"src-views-ConversationHeadsUp-style---headsUpTitle---2X_Zs","headsUpPrice":"src-views-ConversationHeadsUp-style---headsUpPrice---1h-1F","itemAskingPrice":"src-views-ConversationHeadsUp-style---itemAskingPrice---1uCBV","priceLabel":"src-views-ConversationHeadsUp-style---priceLabel---hW_B7","headsUpCta":"src-views-ConversationHeadsUp-style---headsUpCta---3qt5d","headsUpHasExp":"src-views-ConversationHeadsUp-style---headsUpHasExp---2Pmyd","headsUpViewDOMT":"src-views-ConversationHeadsUp-style---headsUpViewDOMT---1aRyG","headsUpViewDomt":"src-views-ConversationHeadsUp-style---headsUpViewDOMT---1aRyG","shippingCopy":"src-views-ConversationHeadsUp-style---shippingCopy---SUGbu"};

/***/ },
/* 30 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"verticallyCentered":"src-views-ConversationSummary-style---verticallyCentered---3qBbz","horizontallyRight":"src-views-ConversationSummary-style---horizontallyRight---3KH2y","horizontallyCentered":"src-views-ConversationSummary-style---horizontallyCentered---Rjckx","verticallyHorizontallyCentered":"src-views-ConversationSummary-style---verticallyHorizontallyCentered---30Gww","statusMessage":"src-views-ConversationSummary-style---statusMessage---7LmVL","mcToFromLine":"src-views-ConversationSummary-style---mcToFromLine---31Vqd","mcConversationSummary":"src-views-ConversationSummary-style---mcConversationSummary---2QrRq","bgColorReadMessage":"src-views-ConversationSummary-style---bgColorReadMessage---2tfkp","mcConversationSummaryOverlay":"src-views-ConversationSummary-style---mcConversationSummaryOverlay---3-7Hf","mcInboxCol":"src-views-ConversationSummary-style---mcInboxCol---3WHpv","mcInboxRightColContents":"src-views-ConversationSummary-style---mcInboxRightColContents---2KEV9","otherPersonsName":"src-views-ConversationSummary-style---otherPersonsName---3svrN","messagePreviewRow":"src-views-ConversationSummary-style---messagePreviewRow---20SZF","thumbnail":"src-views-ConversationSummary-style---thumbnail---2w5NI","mcSummaryIndicator":"src-views-ConversationSummary-style---mcSummaryIndicator---fH1R-","messageIndicators":"src-views-ConversationSummary-style---messageIndicators---1I3ZB","offerLabel":"src-views-ConversationSummary-style---offerLabel---37QFa","statusColumn":"src-views-ConversationSummary-style---statusColumn---1YLnR","statusWrapper":"src-views-ConversationSummary-style---statusWrapper---251JY","statusPending":"src-views-ConversationSummary-style---statusPending---n9jGw","statusComplete":"src-views-ConversationSummary-style---statusComplete---2C2B2","replyIndicator":"src-views-ConversationSummary-style---replyIndicator---13UDa","unreadIndicator":"src-views-ConversationSummary-style---unreadIndicator---3uAyu"};

/***/ },
/* 31 */
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"flagConversation":"src-views-FlagConversation-style---flagConversation---21V_K","mcRcReason":"src-views-FlagConversation-style---mcRcReason---1akp4","mcRcExplanation":"src-views-FlagConversation-style---mcRcExplanation---R-wWc"};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "thumbnail": function(obj) {
var __t, __p = '', __e = _.escape;
__p += '\n    <div>\n        <span data-model-bind="visible: model.processed === \'N\'">\n           <span class="' +
((__t = ( obj.local.mcAttachmentImage )) == null ? '' : __t) +
' ' +
((__t = ( obj.local.mcAttachmentLoading )) == null ? '' : __t) +
' text-center">\n               <i class="fa fa-spinner fa-pulse fa-2x"></i>\n            </span>\n        </span>\n        <span data-model-bind="visible: model.processed === \'Y\'">\n           <a href="' +
__e( obj.originalPath ) +
'" target="_blank">\n               <img class="' +
((__t = ( obj.local.mcAttachmentImage )) == null ? '' : __t) +
'" data-model-bind="\n                   attr:{ src: model.processed === \'Y\' ? model.thumbnailPath : \'\'}\n               ">\n           </a>\n        </span>\n    </div>\n';
return __p
},
    "normal": function(obj) {
var __t, __p = '', __e = _.escape;
__p += '\n    <div class="' +
((__t = ( obj.local.mcAttachmentRow )) == null ? '' : __t) +
'">\n        <a class=\'' +
((__t = ( obj.local.mcAttachmentFilename )) == null ? '' : __t) +
'\' href="' +
__e( obj.originalPath ) +
'" target="_blank">\n            <strong>' +
__e( obj.displayName ) +
'</strong>\n        </a>\n        <span class="' +
((__t = ( obj.local.mcAttachmentFileSize )) == null ? '' : __t) +
'">' +
__e( obj.displaySize ) +
'</span>\n        <span><i class="' +
((__t = ( obj.local.mcAttachmentIcon )) == null ? '' : __t) +
' fa fa-lg ' +
__e( obj.iconClass ) +
'"></i></span>\n    </div>\n';
return __p
},
    "loading": function(obj) {
var __t, __p = '', __e = _.escape;
__p += '\n    <div class="' +
((__t = ( obj.local.mcAttachmentRow )) == null ? '' : __t) +
'">\n        <span class="' +
((__t = ( obj.local.mcAttachmentFilename )) == null ? '' : __t) +
'">\n            ' +
__e( obj.displayName ) +
'\n        </span>\n        <span><i class="' +
((__t = ( obj.local.mcAttachmentIcon )) == null ? '' : __t) +
' fa fa-spinner fa-pulse"></i></span>\n    </div>\n';
return __p
}
};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "attachmentIndicator": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class=\'' +
((__t = ( obj.local.mcAttachmentItem )) == null ? '' : __t) +
' row cf neue\'>\n        <div class=\'col-xs-7\'>\n            <strong class=\'' +
((__t = ( obj.local.mcAttachmentFileName )) == null ? '' : __t) +
'\' data-model-bind="text : model.fileName"></strong>\n            <span class=\'' +
((__t = ( obj.local.mcAttachmentFileSize )) == null ? '' : __t) +
' text-muted\' data-model-bind="text : model.displaySize"></span>\n        </div>\n        <div class=\'col-xs-5\'>\n            <div class="pull-right">\n                <span data-model-bind="visible : model.uploadStatus === \'pending\' || undefined === model.dir">\n                    <progress class=\'' +
((__t = ( obj.local.mcAttachmentUploadProgress )) == null ? '' : __t) +
'\'\n                              name=\'upload-progress\'\n                              data-model-bind="attr : {max : model[\'upload-total\'], value : model[\'upload-sent\']}">\n                        sent <span name=\'upload-sent\'></span> bytes\n                    </progress> <!-- TODO: use this polyfill if people complain about this: http://lea.verou.me/2011/07/a-polyfill-for-html5-progress-element-the-obsessive-perfectionist-way/ -->\n                </span>\n                <span data-model-bind="visible : model.uploadStatus === \'rejected\'">\n                    <i class="fa fa-exclamation-triangle"></i> upload failed <span data-name=\'try-again\' class=\'' +
((__t = ( obj.local.tryAgain )) == null ? '' : __t) +
'\'>try again</span>\n                </span>\n                <span data-model-bind="visible : model.uploadStatus === \'resolved\'">\n                    ';
 if (obj.showThumbnail) { ;
__p += '\n                        <img class="' +
((__t = ( obj.local.mcAttachmentThumbnail )) == null ? '' : __t) +
'" data-model-bind="attr : {src : model.dataURI}">\n                    ';
 } else { ;
__p += '\n                        <i class="' +
((__t = ( obj.local.mcAttachmentIcon )) == null ? '' : __t) +
' fa ' +
((__t = ( obj.iconClass )) == null ? '' : __t) +
'"></i>\n                    ';
 } ;
__p += '\n                </span>\n                <i data-name=\'remove-attachment\' class="fa fa-times ' +
((__t = ( obj.local.mcAttachmentRemove )) == null ? '' : __t) +
' text-muted"></i>\n            </div>\n        </div>\n    </div>\n';
return __p
}
};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "template": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class="' +
((__t = ( obj.local.mcHeadsUp )) == null ? '' : __t) +
'">\n        <div class="' +
((__t = ( obj.local.headsUpTopline )) == null ? '' : __t) +
'" data-model-bind="css: {\'' +
((__t = ( obj.local.headsUpHasExp )) == null ? '' : __t) +
'\': computed.offerDisplay.offerExpDateTxt}">\n            <span class="' +
((__t = ( obj.local.headsUpExpDate )) == null ? '' : __t) +
'" data-model-bind="visible: computed.offerDisplay.offerExpDateTxt">\n                Expires <span data-model-bind="text: computed.offerDisplay.offerExpDateTxt"></span>\n            </span>\n        </div>\n        <div class="' +
((__t = ( obj.local.headsUpNotif )) == null ? '' : __t) +
'" data-model-bind="\n                html: computed.offerDisplay.notificationMsg,\n                visible: computed.offerDisplay.notificationMsg\n            "></div>\n        <div class="' +
((__t = ( obj.local.headsUpPCS )) == null ? '' : __t) +
'" data-model-bind="\n            html: computed.offerDisplay.pcsNotification,\n            visible: computed.offerDisplay.pcsNotification\n        "></div>\n        <div class="' +
((__t = ( obj.local.headsUpContent )) == null ? '' : __t) +
'">\n            <div class="' +
((__t = ( obj.local.headsUpThumbnail )) == null ? '' : __t) +
'">\n                <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" target="_blank">\n                    <img src="' +
((__t = ( obj.thumbnail )) == null ? '' : __t) +
'" />\n                </a>\n            </div>\n\n            <div class="' +
((__t = ( obj.local.headsUpInfo )) == null ? '' : __t) +
'">\n                <div class="' +
((__t = ( obj.local.headsUpTitle )) == null ? '' : __t) +
'">\n                    <a href="' +
((__t = ( obj.pdpUrl )) == null ? '' : __t) +
'" target="_blank">' +
((__t = ( obj.item.title )) == null ? '' : __t) +
'</a>\n                </div>\n                <div>\n                    ';
 obj.prices.map(function (price) { ;
__p += '\n                        <div class="' +
((__t = ( obj.local.headsUpPrice )) == null ? '' : __t) +
'">\n                            <span class="' +
((__t = ( obj.local.priceLabel )) == null ? '' : __t) +
'">\n                                ' +
((__t = ( price.label )) == null ? '' : __t) +
'\n                            </span>\n                            ';
 if (price.callout) { ;
__p += '\n                                <span class="' +
((__t = ( obj.local.headsUpCallout )) == null ? '' : __t) +
'" data-append="' +
((__t = ( price.callout )) == null ? '' : __t) +
'"></span>\n                            ';
 } ;
__p += '\n                            ';
 if (price.value) { ;
__p += '\n                                ' +
((__t = ( price.value )) == null ? '' : __t) +
'\n                                ';
 if (obj.isSoldIndividually) { ;
__p += '\n                                    <span class="' +
((__t = ( obj.local.headsUpPerItem )) == null ? '' : __t) +
'">\n                                        / item\n                                    </span>\n                                ';
 } ;
__p += '\n                            ';
 } ;
__p += '\n                        </div>\n                    ';
 }) ;
__p += '\n                </div>\n                <div class="' +
((__t = ( obj.local.shippingCopy )) == null ? '' : __t) +
'" data-append="shippingCopy"></div>\n            </div>\n\n            <div class="' +
((__t = ( obj.local.headsUpCta )) == null ? '' : __t) +
'" data-append="headsUpCta"></div>\n        </div>\n    </div>\n';
return __p
}
};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "conversationSummary": function(obj) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div class=\'list-group-item ' +
((__t = ( obj.local.mcConversationSummary )) == null ? '' : __t) +
'\' data-model-bind=\'css : {"' +
((__t = ( obj.local.bgColorReadMessage )) == null ? '' : __t) +
'" : !model.unreadMessagesCount}\'>\n        <div class=\'row\'>\n            <div class=\'col-xs-2 ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
' text-center\'><!-- thumbnail -->\n                ';
 if (!obj.isBuyer && !obj.item) { ;
__p += '\n                    <strong class="' +
((__t = ( obj.local.mcInboxStorefront )) == null ? '' : __t) +
' vertically-horizontally-centered" data-tn="mc-message-category">General Inquiry</strong>\n                ';
 } else if (obj.thumbnail) { ;
__p += '\n                    <img data-name=\'item-thumbnail\' class=\'vertically-horizontally-centered ' +
((__t = ( obj.local.thumbnail )) == null ? '' : __t) +
'\' src="' +
((__t = ( obj.thumbnail )) == null ? '' : __t) +
'"/>\n                ';
 } ;
__p += '\n                ';
 if (!obj.isBuyer && obj.item && obj.itemDealerReference) { ;
__p += '\n                    <div class="' +
((__t = ( obj.local.mcItemRefNum )) == null ? '' : __t) +
' horizontally-centered">\n                        REF # ' +
((__t = ( obj.itemDealerReference )) == null ? '' : __t) +
'\n                    </div>\n                ';
 } ;
__p += '\n            </div>\n            <div class="col-xs-2 ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
' hidden-xs">\n                <div class="' +
((__t = ( obj.local.otherPersonsName )) == null ? '' : __t) +
'"><!-- other persons name -->\n                    <div class="' +
((__t = ( obj.local.mcDealerToFromLine )) == null ? '' : __t) +
'" data-tn="mc-message-dealer">\n                        ' +
__e( obj.otherMemberDisplayName ) +
'\n                    </div>\n                    ';
 if (obj.isTrade) { ;
__p += '\n                        <span class="label ' +
((__t = ( obj.local.badgeTrade )) == null ? '' : __t) +
'">TRADE</span>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n            <div class="col-sm-4 col-xs-10 ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
'"><!-- message preview -->\n                <div class="' +
((__t = ( obj.local.mcToFromLine )) == null ? '' : __t) +
' visible-xs">\n                    ' +
__e( obj.otherMemberDisplayName ) +
'\n                    ';
 if (obj.isTrade) { ;
__p += '\n                        <span class="label ' +
((__t = ( obj.local.badgeTrade )) == null ? '' : __t) +
'">TRADE</span>\n                    ';
 } ;
__p += '\n                </div>\n                <div class=\'' +
((__t = ( obj.local.messageIndicators )) == null ? '' : __t) +
' visible-xs\' data-append=\'indicatorsMobile\'></div>\n                <div class="' +
((__t = ( obj.local.messagePreviewRow )) == null ? '' : __t) +
' ' +
((__t = ( obj.local.mcConversationBodySummary )) == null ? '' : __t) +
'\n                    ' +
((__t = ( obj.unreadMessagesCount ? obj.local.unreadIndicator : '')) == null ? '' : __t) +
'\n                    ' +
((__t = ( obj.isLatestMessageSender ? obj.local.replyIndicator : '' )) == null ? '' : __t) +
'\n                    " data-tn="mc-conversation-body">' +
__e( obj.latestMessage ) +
'\n                </div>\n                <div class="visible-xs ' +
((__t = ( obj.statusComplete ? obj.local.statusComplete : obj.local.statusPending )) == null ? '' : __t) +
'">\n                    ';
 if (obj.statusMessage) { ;
__p += '\n                        <div data-name=\'status-message\' class=\'' +
((__t = ( obj.local.statusMessage )) == null ? '' : __t) +
'\'>\n                            ' +
((__t = ( obj.statusMessage )) == null ? '' : __t) +
'\n                        </div>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n            <div class=\'col-xs-2 hidden-xs ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
' ' +
((__t = ( obj.local.statusColumn )) == null ? '' : __t) +
' ' +
((__t = ( obj.statusComplete ? obj.local.statusComplete : obj.local.statusPending )) == null ? '' : __t) +
'\'><!-- offer -->\n                    ';
 if (obj.statusMessage) { ;
__p += '\n                        <div class="' +
((__t = ( obj.local.statusWrapper )) == null ? '' : __t) +
'">\n                            <div class=\'hidden-xs ' +
((__t = ( obj.local.statusMessage )) == null ? '' : __t) +
'\'>' +
((__t = ( obj.statusMessage )) == null ? '' : __t) +
'</div>\n                        </div>\n                    ';
 } ;
__p += '\n            </div>\n            <div class=\'col-xs-2 hidden-xs ' +
((__t = ( obj.local.mcInboxCol )) == null ? '' : __t) +
'\'><!-- spacer for free-floating date column -->\n            </div>\n            <div class=\'' +
((__t = ( obj.local.mcInboxRightColContents )) == null ? '' : __t) +
'\' data-tn="mc-message-date">\n                <span class="hidden-xs">' +
__e( obj.displayDate ) +
'</span>\n                <span class="visible-xs">' +
__e( obj.displayDateMobile ) +
'</span>\n                <div class=\'hidden-xs\' data-append=\'indicatorsDesktop\'></div>\n            </div>\n        </div>\n        <div class=\'' +
((__t = ( obj.local.mcConversationSummaryOverlay )) == null ? '' : __t) +
'\'></div>\n    </div>\n';
return __p
},
    "indicators": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    ';
 if (obj.numberOfAttachments) { ;
__p += '\n        <span><i class="fa fa-paperclip"></i><span>\n    ';
 } ;
__p += '\n';
return __p
}
};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "conversationFilterSelect": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <select id="conversationFilter">\n        ';
 _.each(obj.filters, function (label, value) { ;
__p += '\n            <option value="' +
((__t = ( value )) == null ? '' : __t) +
'" ' +
((__t = ( obj.selectedFilter.value === value ? 'selected' : '' )) == null ? '' : __t) +
' > ' +
((__t = ( label )) == null ? '' : __t) +
'</option>\n        ';
 }); ;
__p += '\n    </select>\n';
return __p
},
    "conversationFilterDropdown": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <div id="filterDropdownContainer" class="bs dropdown mc-filter-button-container">\n        <button type="button" class="btn btn-default btn-sm dropdown-toggle mc-filter-button" data-toggle="dropdown">\n            <span class="pull-left mc-filter-button-selected" data-model-bind="text: computed.selectedfilterLabel"></span>\n            <span class="pull-right caret"></span>\n        </button>\n        <ul class="dropdown-menu gtm-message-inbox-view-selector">\n            ';
 _.each(obj.filters, function (label, value) { ;
__p += '\n                <li data-model-bind="visible: computed.selectedfilterValue !== \'' +
((__t = ( value )) == null ? '' : __t) +
'\'">\n                    <a\n                        href="#filter-inbox"\n                        class="mc-filter-button-value"\n                        data-value="' +
((__t = ( value )) == null ? '' : __t) +
'"\n                    >' +
((__t = ( label )) == null ? '' : __t) +
'</a>\n                </li>\n            ';
 }); ;
__p += '\n        </ul>\n    </div>\n';
return __p
}
};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

_ = __webpack_require__(2);
module.exports = {
    "messageCenter": function(obj) {
var __t, __p = '';
__p += '\n    <div data-model-bind=\'visible: state.activeViewKey === "inbox"\'>\n        <div class=\'row\'>\n            <div class=\'col-xs-3\'>\n                <div class=\'' +
((__t = ( obj.local.refreshClock )) == null ? '' : __t) +
'\' data-append=\'refreshClock\'></div>\n            </div>\n            <div class=\'col-xs-9\'>\n                <div data-append=\'search\'></div>\n                <div data-append=\'searchParamsIndicator\'></div>\n            </div>\n        </div>\n        <h1 class=\'' +
((__t = ( obj.local.mcHeader )) == null ? '' : __t) +
'\' data-tn="mc-inbox-header" data-append=\'inboxHeader\'></h1>\n        <div data-append=\'inbox\'></div>\n    </div>\n    <div class=\'' +
((__t = ( obj.local.mcConversationWrapper )) == null ? '' : __t) +
' row\'>\n        <div class=\'col-xs-12\' data-model-bind=\'visible: state.activeViewKey !== "inbox" && state.pendingViewKey !== "inbox"\'>\n            <div class=\'' +
((__t = ( obj.local.mcAllConversationsBlock )) == null ? '' : __t) +
'\'>\n                <span\n                    data-mc-route-action=\'showIndex\'\n                    class=\'' +
((__t = ( obj.local.mcAllConversationsLink )) == null ? '' : __t) +
'\'\n                ><i class="fa fa-angle-left"></i>&nbsp;&nbsp;' +
((__t = ( obj.copy('all conversations') )) == null ? '' : __t) +
'</span>\n                <span\n                    data-mc-route-action=\'showIndexUnread\'\n                    data-model-bind=\'visible: state.totalUnreadConversationCount > 0\'\n                    class="' +
((__t = ( obj.local.totalUnreadConversationCount )) == null ? '' : __t) +
'"\n                >( <span data-model-bind=\'text: state.totalUnreadConversationCount\'></span> ' +
((__t = ( obj.copy('new') )) == null ? '' : __t) +
' )</span>\n            </div>\n        </div>\n        <div data-append=\'error\' data-model-bind=\'visible: state.activeViewKey==="error"\'></div>\n        <div data-append=\'conversation\' data-model-bind=\'visible: state.activeViewKey==="conversation"\'></div>\n    </div>\n    <div data-append=\'loading\' data-model-bind=\'visible: state.activeViewKey==="loading"\'></div>\n';
return __p
}
};

/***/ },
/* 38 */
/***/ function(module, exports) {

module.exports = __webpack_require__(152);

/***/ },
/* 39 */
/***/ function(module, exports) {

module.exports = __webpack_require__(58);

/***/ },
/* 40 */
/***/ function(module, exports) {

module.exports = __webpack_require__(244);

/***/ },
/* 41 */
/***/ function(module, exports) {

module.exports = __webpack_require__(30);

/***/ },
/* 42 */
/***/ function(module, exports) {

module.exports = __webpack_require__(140);

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _view = __webpack_require__(10);

Object.defineProperty(exports, 'Attachment', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view).default;
  }
});

var _view2 = __webpack_require__(14);

Object.defineProperty(exports, 'AttachmentIndicator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view2).default;
  }
});

var _ComposeMessage = __webpack_require__(15);

Object.defineProperty(exports, 'ComposeMessage', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ComposeMessage).default;
  }
});

var _Conversation = __webpack_require__(16);

Object.defineProperty(exports, 'Conversation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Conversation).default;
  }
});

var _ConversationError = __webpack_require__(17);

Object.defineProperty(exports, 'ConversationError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ConversationError).default;
  }
});

var _view3 = __webpack_require__(18);

Object.defineProperty(exports, 'ConversationHeadsUp', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view3).default;
  }
});

var _view4 = __webpack_require__(19);

Object.defineProperty(exports, 'ConversationSummary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view4).default;
  }
});

var _FlagConversation = __webpack_require__(20);

Object.defineProperty(exports, 'FlagConversation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FlagConversation).default;
  }
});

var _view5 = __webpack_require__(21);

Object.defineProperty(exports, 'InboxFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_view5).default;
  }
});

var _InboxWrapper = __webpack_require__(22);

Object.defineProperty(exports, 'InboxWrapper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InboxWrapper).default;
  }
});

var _MessageCenter = __webpack_require__(23);

Object.defineProperty(exports, 'MessageCenter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessageCenter).default;
  }
});

var _MessageSummary = __webpack_require__(24);

Object.defineProperty(exports, 'MessageSummary', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MessageSummary).default;
  }
});

var _momentLocales = __webpack_require__(9);

Object.defineProperty(exports, 'momentLocales', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_momentLocales).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }
/******/ ]);
//# sourceMappingURL=bundle.js.map

/***/ }),

/***/ 2017:
/***/ (function(module, exports) {

module.exports = {
	"header": "Welcome to 1stdibs",
	"subheader": "The Most Beautiful Things on Earth from the World's Top Dealers - Now for Sale Online.",
	"cta": "how it works",
	"background": "/static/images/introduction/brand-intro-banner.jpg",
	"modal": {
		"header": "How it Works",
		"subheader": "On 1stdibs, you can purchase the one-of-a-kind pieces you love as soon as you find them.",
		"background": "/static/images/introduction/brand-intro-bg.jpg",
		"highlights": [
			{
				"icon": "storefront",
				"title": "Shop 2,500+ Hand-picked Dealers",
				"text": "We carefully select rare pieces from the world's most prestigious dealers and galleries. New listings are added weekly."
			},
			{
				"icon": "message",
				"title": "Easily Communicate With Dealers",
				"text": "By message or phone, getting questions answered and negotiating is simple."
			},
			{
				"icon": "cart",
				"title": "Purchase Online Securely",
				"text": "We offer multiple payment options, global shipping and our buyer protection guarantee to ensure that your order goes smoothly."
			}
		]
	}
};

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

/**
 * Constructs an array of errors in the correct format to be consumed by the Validator class. Proper usage :
 *      var errors = new ErrorList();
 *      errors.add('creators[0].role');
 *      errors.add('creators[1].attribution', 'The attribution is super wrong');
 *      return errors.getErrors();
 *
 * Chaining also enabled :
 *      return errors.add('creators[0].role').getErrors();
 *
 * @returns {ErrorList}
 * @constructor
 */
var ErrorList = function () {
    this._errors = [];
    return this;
};

/**
 * Get array of all error objects
 * @returns {object[]}
 */
ErrorList.prototype.getErrors = function () {
    return this._errors;
};

/**
 * Add 1 error to the error list
 * @param {String} fieldName
 * @param {String} message
 * @param {function|regex} rule
 * @param {string} viewKey
 * @returns {ErrorList}
 */
ErrorList.prototype.add = function (fieldName, message, rule) {
    if (!fieldName || typeof fieldName !== 'string') {
        throw new Error("Field name is required to use error constructor's add method. '" + fieldName + "' provided");
    }

    var obj = { field : fieldName };
    if (message) {
        obj.message = message;
    }
    if (rule) {
        obj.rule = rule.toString();
        if (typeof obj.rule === 'function') {
            obj.rule = obj.rule.replace(/  /g, '').replace(/\n/g, '');
        }
    }

    this._errors.push(obj);
    return this;
};

/**
 * Merge another error list into this error list as in :
 *  var errors = new ErrorList().add('shipmentQuotes');
 *  var mergedErrors = errors.merge(otherErrorList).getErrors();
 *
 * @param {ErrorList} errorList
 * @returns {ErrorList}
 */
ErrorList.prototype.merge = function (errorList) {
    var self = this;
    if (!(errorList instanceof ErrorList)) {
        throw new Error("Only ErrorList instances may be merged by ErrorList.merge. ");
    }

    var array = errorList.getErrors();
    _.each(array, function (error) {
        var args = [error.field];
        if (error.message) {
            args.push(error.message);
        }
        self.add.apply(self, args);
    });

    return this;
};

/**
 * Get a count of the number of errors;
 * @returns {number}
 */
ErrorList.prototype.count = function () {
    return this._errors.length;
};

/**
 * Get the last error
 * @returns {object}
 */
ErrorList.prototype.last = function () {
    return _.last(this._errors);
};

/**
 * WARNING -- THIS HAS NOT BEEN TESTED!!!!!!!!!
 * WARNING -- THIS HAS NOT BEEN TESTED!!!!!!!!!
 * WARNING -- THIS HAS NOT BEEN TESTED!!!!!!!!!
 * @param {*} newValue
 * @param {String} propName
 * @param {Object} searchObj
 * @returns {ErrorList}
 */
/* eslint-disable */
ErrorList.prototype.modifyWhere = function (newValue, propName, searchObj) {
    throw new Error('THIS METHOD HAS NOT BEEN TESTED. ');
    if (_.isUndefined(newValue) || _.isUndefined(propName)) {
        throw new Error("You must specify a new value and a property name to use ErrorList.modifyWhere");
    }
    var errorSet = this._errors;

    // If searchObj was passed then require that it has one of the 3 properties assigned to each error object.
    // If it does then use that search object as a predicate to search this._errors
    if (!_.isUndefined(searchObj)) {
        var requiredProps = ['field', 'message', 'rule'];
        var hasQualifiedProp = false;
        _.each(requiredProps, function (prop) {
            if (searchObj.hasOwnProperty(prop)) {
                hasQualifiedProp = true;
            }
        });

        if (!hasQualifiedProp) {
            var msg = "Search object used in ErrorList.modifyWhere must contain one of the following : [ " +
                requiredProps.join(' | ') + " ]";
            throw new Error(msg);
        }

        errorSet = _.where(this._errors, searchObj);
    }

    _.each(errorSet, function (error) {
        error[propName] = newValue;
    });

    return this;
};
/* eslint-enable */

module.exports = ErrorList;


/***/ }),

/***/ 2027:
/***/ (function(module, exports) {

module.exports = {
	"title": "New Arrivals for You",
	"viewAll": "View All"
};

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var objectAssign = __webpack_require__(204);
var hasOwnProp = Object.prototype.hasOwnProperty;

var Base = module.exports = function () {};
Base.extend = extend;

/**
 * Extend this Class to create a new one inherithing this one.
 * Also add a helper __super__ object poiting to the parent prototypes methods
 * @param  {Object} protoProps  Prototype properties (available on the instances)
 * @param  {Object} staticProps Static properties (available on the contructor)
 * @return {Object}             New sub class
 */
function extend(protoProps, staticProps) {
  var parent = this;
  var child;

  // The constructor function for the new subclass is either defined by you
  // (the "constructor" property in your `extend` definition), or defaulted
  // by us to simply call the parent's constructor.
  if (protoProps && hasOwnProp.call(protoProps, 'constructor')) {
    child = protoProps.constructor;
  } else {
    child = function () { return parent.apply(this, arguments); };
  }

  // Add static properties to the constructor function, if supplied.
  objectAssign(child, parent, staticProps);

  // Set the prototype chain to inherit from `parent`
  child.prototype = Object.create(parent.prototype, {
    constructor: {
      value: child,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  // Add prototype properties (instance properties) to the subclass,
  // if supplied.
  if (protoProps) objectAssign(child.prototype, protoProps);

  // Set a convenience property in case the parent's prototype is needed
  // later.
  child.__super__ = parent.prototype;

  return child;
};


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ToObject(val) {
	if (val == null) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

module.exports = Object.assign || function (target, source) {
	var from;
	var keys;
	var to = ToObject(target);

	for (var s = 1; s < arguments.length; s++) {
		from = arguments[s];
		keys = Object.keys(Object(from));

		for (var i = 0; i < keys.length; i++) {
			to[keys[i]] = from[keys[i]];
		}
	}

	return to;
};


/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ClassList

var indexOf = __webpack_require__(206),
    trim = __webpack_require__(264),
    arr = Array.prototype

/**
 * ClassList(elem) is kind of like Element#classList.
 *
 * @param {Element} elem
 * @return {ClassList}
 */
function ClassList (elem) {
  if (!(this instanceof ClassList))
    return new ClassList(elem)

  var classes = trim(elem.className).split(/\s+/),
      i

  this._elem = elem

  this.length = 0

  for (i = 0; i < classes.length; i += 1) {
    if (classes[i])
      arr.push.call(this, classes[i])
  }
}

/**
 * add(class1 [, class2 [, ...]]) adds the given class(es) to the
 * element.
 *
 * @param {String} ...
 * @return {Context}
 */
ClassList.prototype.add = function () {
  var name,
      i

  for (i = 0; i < arguments.length; i += 1) {
    name = '' + arguments[i]

    if (indexOf(this, name) >= 0)
      continue

    arr.push.call(this, name)
  }

  this._elem.className = this.toString()

  return this
}

/**
 * remove(class1 [, class2 [, ...]]) removes the given class(es) from
 * the element.
 *
 * @param {String} ...
 * @return {Context}
 */
ClassList.prototype.remove = function () {
  var index,
      name,
      i

  for (i = 0; i < arguments.length; i += 1) {
    name = '' + arguments[i]
    index = indexOf(this, name)

    if (index < 0) continue

    arr.splice.call(this, index, 1)
  }

  this._elem.className = this.toString()

  return this
}

/**
 * contains(name) determines if the element has a given class.
 *
 * @param {String} name
 * @return {Boolean}
 */
ClassList.prototype.contains = function (name) {
  name += ''
  return indexOf(this, name) >= 0
}

/**
 * toggle(name [, force]) toggles a class. If force is a boolean,
 * this method is basically just an alias for add/remove.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {Context}
 */
ClassList.prototype.toggle = function (name, force) {
  name += ''

  if (force === true) return this.add(name)
  if (force === false) return this.remove(name)

  return this[this.contains(name) ? 'remove' : 'add'](name)
}

/**
 * toString() returns the className of the element.
 *
 * @return {String}
 */
ClassList.prototype.toString = function () {
  return arr.join.call(this, ' ')
}


/***/ }),

/***/ 206:
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

var globalObject = __webpack_require__(92);
var NativeCustomEvent = globalObject.CustomEvent;

function useNative () {
  try {
    var p = new NativeCustomEvent('cat', { detail: { foo: 'bar' } });
    return  'cat' === p.type && 'bar' === p.detail.foo;
  } catch (e) {
  }
  return false;
}

/**
 * Cross-browser `CustomEvent` constructor.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent.CustomEvent
 *
 * @public
 */

var CustomEvent;
if (useNative()) {
  CustomEvent = NativeCustomEvent;
} else if (!globalObject.document) {
  CustomEvent = undefined;
} else if ('function' === typeof globalObject.document.createEvent) {
  // IE >= 9
  CustomEvent = function (type, params) {
    var e = globalObject.document.createEvent('CustomEvent');
    if (params) {
      e.initCustomEvent(type, params.bubbles, params.cancelable, params.detail);
    } else {
      e.initCustomEvent(type, false, false, void 0);
    }
    return e;
  }
} else {
  // IE <= 8
  CustomEvent = function (type, params) {
    var e = globalObject.document.createEventObject();
    e.type = type;
    if (params) {
      e.bubbles = Boolean(params.bubbles);
      e.cancelable = Boolean(params.cancelable);
      e.detail = params.detail;
    } else {
      e.bubbles = false;
      e.cancelable = false;
      e.detail = void 0;
    }
    return e;
  }
}
module.exports = CustomEvent;


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
module.exports = __webpack_require__(209);


/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var Action = __webpack_require__(88);
var DEFAULT = 'default';
var DispatcherContext = __webpack_require__(210);

/**
 * @class Dispatcher
 * @param {Object} options Dispatcher options
 * @param {Array} options.stores Array of stores to register
 * @constructor
 */
function Dispatcher (options) {
    options = options || {};
    options.stores = options.stores || [];
    this.stores = {};
    this.handlers = {};
    this.handlers[DEFAULT] = [];
    this.hasWarnedAboutNameProperty = false;
    options.stores.forEach(function (store) {
        this.registerStore(store);
    }, this);

}

Dispatcher.prototype.createContext = function createContext(context) {
    return new DispatcherContext(this, context);
};

/**
 * Registers a store so that it can handle actions.
 * @method registerStore
 * @static
 * @param {Object} store A store class to be registered. The store should have a static
 *      `name` property so that it can be loaded later.
 * @throws {Error} if store is invalid
 * @throws {Error} if store is already registered
 */
Dispatcher.prototype.registerStore = function registerStore(store) {
    if ('function' !== typeof store) {
        throw new Error('registerStore requires a constructor as first parameter');
    }
    var storeName = this.getStoreName(store);
    if (!storeName) {
        throw new Error('Store is required to have a `storeName` property.');
    }
    if (this.stores[storeName]) {
        if (this.stores[storeName] === store) {
            // Store is already registered, nothing to do
            return;
        }
        throw new Error('Store with name `' + storeName + '` has already been registered.');
    }
    this.stores[storeName] = store;
    if (store.handlers) {
        Object.keys(store.handlers).forEach(function storeHandlersEach(action) {
            var handler = store.handlers[action];
            this._registerHandler(action, storeName, handler);
        }, this);
    }
};

/**
 * Method to discover if a storeName has been registered
 * @method isRegistered
 * @static
 * @param {Object|String} store The store to check
 * @returns {boolean}
 */
Dispatcher.prototype.isRegistered = function isRegistered(store) {
    var storeName = this.getStoreName(store),
        storeInstance = this.stores[storeName];

    if (!storeInstance) {
        return false;
    }

    if ('function' === typeof store) {
        if (store !== storeInstance) {
            return false;
        }
    }
    return true;
};

/**
 * Gets a name from a store
 * @method getStoreName
 * @static
 * @param {String|Object} store The store name or class from which to extract
 *      the name
 * @returns {String}
 */
Dispatcher.prototype.getStoreName = function getStoreName(store) {
    if ('string' === typeof store) {
        return store;
    }
    if (store.storeName) {
        return store.storeName;
    }

    if (false) {
        if (store.name && !this.hasWarnedAboutNameProperty) {
            console.warn('A store has been registered that relies on the ' +
                'constructor\'s name property. This name may change when you ' +
                'minify your stores during build time and could break string ' +
                'references to your store. It is advised that you add a ' +
                'static `storeName` property to your store to ensure the ' +
                'store name does not change during your build.');
            this.hasWarnedAboutNameProperty = true;
        }
    }
    return store.name;
};

/**
 * Adds a handler function to be called for the given action
 * @method registerHandler
 * @private
 * @static
 * @param {String} action Name of the action
 * @param {String} name Name of the store that handles the action
 * @param {String|Function} handler The function or name of the method that handles the action
 * @returns {number}
 */
Dispatcher.prototype._registerHandler = function registerHandler(action, name, handler) {
    this.handlers[action] = this.handlers[action] || [];
    this.handlers[action].push({
        name: this.getStoreName(name),
        handler: handler
    });
    return this.handlers.length - 1;
};

module.exports = {
    createDispatcher: function (options) {
        return new Dispatcher(options);
    }
};


/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var Action = __webpack_require__(88);
var DEFAULT = 'default';
var debug = __webpack_require__(89)('Dispatchr:DispatcherContext');

/**
 * @class Dispatcher
 * @param {Object} context The context to be used for store instances
 * @constructor
 */
function DispatcherContext (dispatcher, context) {
    this.dispatcher = dispatcher;
    this.storeInstances = {};
    this.currentAction = null;
    this.dispatcherInterface = {
        getContext: function getContext() { return context; },
        getStore: this.getStore.bind(this),
        waitFor: this.waitFor.bind(this)
    };
}

/**
 * Returns a single store instance and creates one if it doesn't already exist
 * @method getStore
 * @param {String} name The name of the instance
 * @returns {Object} The store instance
 * @throws {Error} if store is not registered
 */
DispatcherContext.prototype.getStore = function getStore(name) {
    var storeName = this.dispatcher.getStoreName(name);
    if (!this.storeInstances[storeName]) {
        var Store = this.dispatcher.stores[storeName];
        if (!Store) {
            throw new Error('Store ' + storeName + ' was not registered.');
        }
        this.storeInstances[storeName] = new (this.dispatcher.stores[storeName])(this.dispatcherInterface);
    }
    return this.storeInstances[storeName];
};

/**
 * Dispatches a new action or queues it up if one is already in progress
 * @method dispatch
 * @param {String} actionName Name of the action to be dispatched
 * @param {Object} payload Parameters to describe the action
 * @throws {Error} if store has handler registered that does not exist
 */
DispatcherContext.prototype.dispatch = function dispatch(actionName, payload) {
    if (!actionName) {
        throw new Error('actionName parameter `' + actionName + '` is invalid.');
    }
    if (this.currentAction) {
        throw new Error('Cannot call dispatch while another dispatch is executing. Attempted to execute \'' + actionName + '\' but \'' + this.currentAction.name + '\' is already executing.');
    }
    var actionHandlers = this.dispatcher.handlers[actionName] || [],
        defaultHandlers = this.dispatcher.handlers[DEFAULT] || [];
    if (!actionHandlers.length && !defaultHandlers.length) {
        debug(actionName + ' does not have any registered handlers');
        return;
    }
    debug('dispatching ' + actionName, payload);
    this.currentAction = new Action(actionName, payload);
    var self = this,
        allHandlers = actionHandlers.concat(defaultHandlers),
        handlerFns = {};

    try {
        allHandlers.forEach(function actionHandlersEach(store) {
            if (handlerFns[store.name]) {
                // Don't call the default if the store has an explicit action handler
                return;
            }
            var storeInstance = self.getStore(store.name);
            if ('function' === typeof store.handler) {
                handlerFns[store.name] = store.handler.bind(storeInstance);
            } else {
                if (!storeInstance[store.handler]) {
                    throw new Error(store.name + ' does not have a method called ' + store.handler);
                }
                handlerFns[store.name] = storeInstance[store.handler].bind(storeInstance);
            }
        });
        this.currentAction.execute(handlerFns);
    } catch (e) {
        throw e;
    } finally {
        debug('finished ' + actionName);
        this.currentAction = null;
    }
};

/**
 * Returns a raw data object representation of the current state of the
 * dispatcher and all store instances. If the store implements a shouldDehdyrate
 * function, then it will be called and only dehydrate if the method returns `true`
 * @method dehydrate
 * @returns {Object} dehydrated dispatcher data
 */
DispatcherContext.prototype.dehydrate = function dehydrate() {
    var self = this,
        stores = {};
    Object.keys(self.storeInstances).forEach(function storeInstancesEach(storeName) {
        var store = self.storeInstances[storeName];
        if (!store.dehydrate || (store.shouldDehydrate && !store.shouldDehydrate())) {
            return;
        }
        stores[storeName] = store.dehydrate();
    });
    return {
        stores: stores
    };
};

/**
 * Takes a raw data object and rehydrates the dispatcher and store instances
 * @method rehydrate
 * @param {Object} dispatcherState raw state typically retrieved from `dehydrate`
 *      method
 */
DispatcherContext.prototype.rehydrate = function rehydrate(dispatcherState) {
    var self = this;
    if (dispatcherState.stores) {
        Object.keys(dispatcherState.stores).forEach(function storeStateEach(storeName) {
            var state = dispatcherState.stores[storeName],
                store = self.getStore(storeName);
            if (store.rehydrate) {
                store.rehydrate(state);
            }
        });
    }
};

/**
 * Waits until all stores have finished handling an action and then calls
 * the callback
 * @method waitFor
 * @param {String|String[]} stores An array of stores as strings to wait for
 * @param {Function} callback Called after all stores have completed handling their actions
 * @throws {Error} if there is no action dispatching
 */
DispatcherContext.prototype.waitFor = function waitFor(stores, callback) {
    if (!this.currentAction) {
        throw new Error('waitFor called even though there is no action dispatching');
    }
    this.currentAction.waitFor(stores, callback);
};

module.exports = DispatcherContext;


/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(212);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 212:
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 213:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(217);
var assign = __webpack_require__(215);
var forEach = __webpack_require__(216);
var Base = __webpack_require__(203);
var extend = Base.extend;
var ExtendCompose;
var composeWith;
composeWith = function (parent, sub, newproperties, staticProperties) {
    assign(sub, staticProperties);
    assign(sub.prototype, newproperties);
    forEach(sub.prototype, function (method, name) {
        var composed;
        if (undefined === method) {
            return; // already handled
        }
        if ("__" === name.substr(-2)) {
            sub.prototype[name] = undefined;
            name = name.slice(0, -2);
            if (isArray(method)) {
                composed = sub.prototype[name].concat(method);
            } else if ("object" === typeof method) {
                composed = assign({}, sub.prototype[name], method);
            } else {
                composed = function () {
                    var preMethod;
                    var postMethod;
                    var preValue;
                    if (parent.prototype[name]) {
                        preMethod = parent.prototype[name];
                    }
                    postMethod = method;
                    if (preMethod) {
                        preValue = preMethod.apply(this, arguments);
                    }
                    return postMethod.call(this, preValue);
                };
            }
        } else if ("__" === name.substr(0, 2)) {
            sub.prototype[name] = undefined;
            name = name.slice(2);
            if (isArray(method)) {
                composed = method.concat(sub.prototype[name]);
            } else if ("object" === typeof method) {
                composed = assign({}, method, sub.prototype[name]);
            } else {
                composed = function () {
                    var preMethod = method;
                    var methodReturnVal = preMethod.apply(this, arguments);
                    var postMethod;
                    if (parent.prototype[name]) {
                        postMethod = parent.prototype[name];
                    } else {
                        return methodReturnVal;
                    }
                    return postMethod.call(this, methodReturnVal);
                };
            }
        } else {
            return;
        }
        sub.prototype[name] = composed;
    });
};
ExtendCompose = function () {};
ExtendCompose.prototype.middleware = {
    afterPrototype: function () {} // noop
};
ExtendCompose.prototype.exportBuilder = function () {
    var self = this;
    var ecExport = assign(function (protos, statics) {
        var parent = this;
        var sub;
        if (protos instanceof Array) {
            protos = assign.apply(null, [{}].concat(protos));
        }
        sub = extend.call(parent, protos, statics);
        sub.extend = ecExport;
        sub.extendSelf = function () {
            composeWith.apply(this, [
                parent,
                sub
            ].concat(Array.prototype.slice.apply(arguments))); // mutates sub
            self.middleware.afterPrototype(
                parent.prototype,
                protos,
                sub.prototype
            );
            return sub;
        };
        sub.extendSelf(sub.prototype);
        return sub;
    }, {
        withMiddleware: this.withMiddleware.bind(this)
    });
    return ecExport;
};
ExtendCompose.prototype.withMiddleware = function (middleware) {
    var parentEc = this;
    var NewExtendCompose = assign(function () {}, {
        prototype: this
    });
    var newEc = new NewExtendCompose();
    if (middleware.afterPrototype) {
        newEc.middleware = assign({}, assign({}, parentEc.middleware, {
            afterPrototype: function (parentPrototype, childPrototypeBefore, childPrototypeAfter) {
                parentEc.middleware.afterPrototype( // may mutate childPrototypeAfter
                    parentPrototype,
                    childPrototypeBefore,
                    childPrototypeAfter
                );
                middleware.afterPrototype( // may mutate childPrototypeAfter again
                    parentPrototype,
                    childPrototypeBefore,
                    childPrototypeAfter
                );
            }
        }));
    }
    return newEc.exportBuilder();
};
module.exports = new ExtendCompose().exportBuilder();


/***/ }),

/***/ 2144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tracking = __webpack_require__(27);

var _require = __webpack_require__(3385),
    trackingCategory = _require.category,
    trackingActions = _require.actions,
    trackingLabels = _require.labels,
    trackingEcommerce = _require.ecommerce;

var copy = __webpack_require__(2017);
var impressions = [{
    id: trackingEcommerce.id,
    name: trackingEcommerce.name,
    creative: trackingEcommerce.creative + copy.cta,
    position: 1
}];

var introductionTrackingActions = {
    /**
     * Tracking when user clicks on banner cta button
     */

    trackEcommerceClick: function trackEcommerceClick(actionContext, payload, done) {
        tracking.trackEvent({
            category: trackingCategory.click,
            action: trackingActions.click,
            label: trackingLabels.click
        });

        tracking.trackEcommerce({
            type: 'promoClick',
            promotions: impressions
        });

        done();
    },


    /**
     * Tracking Ecommerce promo impression when banner is presented on page
     */
    trackBannerEcommerce: function trackBannerEcommerce(actionContext, payload, done) {
        tracking.trackEcommerce({
            type: 'promotionImpression',
            promotions: impressions
        });

        done();
    }
};

module.exports = introductionTrackingActions;

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),

/***/ 216:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _([1, 2]).forEach(function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, typeof iteratee == 'function' ? iteratee : identity);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forEach;


/***/ }),

/***/ 217:
/***/ (function(module, exports) {

/**
 * lodash 4.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 2176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ArrowCarousel = __webpack_require__(596);
var SwipeCarousel = __webpack_require__(546);

var HomepageCarousel = function (_React$Component) {
    _inherits(HomepageCarousel, _React$Component);

    function HomepageCarousel() {
        _classCallCheck(this, HomepageCarousel);

        var _this = _possibleConstructorReturn(this, (HomepageCarousel.__proto__ || Object.getPrototypeOf(HomepageCarousel)).call(this));

        _this.trackImpressions = _this.trackImpressions.bind(_this);
        _this.onPageChange = _this.onPageChange.bind(_this);

        _this.state = {
            hasTrackingFired: {}
        };
        return _this;
    }

    _createClass(HomepageCarousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.trackImpressions(0);
        }
    }, {
        key: 'onPageChange',
        value: function onPageChange(page, variant) {
            this.props.onPageChange(page, variant);
            this.trackImpressions(page);
        }
    }, {
        key: 'trackImpressions',
        value: function trackImpressions(page) {
            var hasTrackingFired = this.state.hasTrackingFired;
            var itemsPerPage = this.props.itemsPerPage;


            if (!hasTrackingFired[page]) {

                var startIndex = page * itemsPerPage;
                var visibleItems = this.props.items.slice(startIndex, startIndex + itemsPerPage);

                this.props.onImpression(visibleItems, startIndex);

                hasTrackingFired[page] = true;

                this.setState({
                    hasTrackingFired: hasTrackingFired
                });
            }
        }
    }, {
        key: 'buildChildren',
        value: function buildChildren() {
            var _this2 = this;

            return this.props.items.map(function (item, index) {
                return React.cloneElement(_this2.props.children, {
                    key: item.id || item.url,
                    item: item,
                    index: index
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var carouselProps = {
                auto: this.props.auto,
                ref: this.props.carouselRef,
                transitionEffect: this.props.transitionEffect,
                customTransformItemStyle: this.props.customTransformItemStyle,
                autoDuration: this.props.autoDuration,
                useDotsNav: this.props.useDotsNav,
                dotsColorType: this.props.dotsColorType,
                itemsPerPage: this.props.itemsPerPage,
                itemWidth: this.props.itemWidth,
                isCentered: this.props.isCentered,
                children: this.buildChildren(),
                classNames: this.props.classNames,
                onDotClick: this.props.onDotClick,
                onPageChange: this.onPageChange
            };

            if (this.props.isMobile) {
                return React.createElement(SwipeCarousel, carouselProps);
            }

            return React.createElement(ArrowCarousel, carouselProps);
        }
    }]);

    return HomepageCarousel;
}(React.Component);

HomepageCarousel.defaultProps = {
    auto: false,
    autoDuration: 5000,
    useDotsNav: false,
    dotsColorType: 'buyer',
    itemsPerPage: 1,
    isCentered: false,
    onPageChange: function onPageChange() {},
    carouselRef: function carouselRef() {},
    onImpression: function onImpression() {},
    classNames: {
        list: 'hero-carousel-list',
        item: 'hero-carousel-panel',
        dot: 'hero-carousel-dot'
    }
};

HomepageCarousel.propTypes = {
    auto: PropTypes.bool,
    autoDuration: PropTypes.number,
    useDotsNav: PropTypes.bool,
    dotsColorType: PropTypes.oneOf(['buyer', 'trade']),
    itemsPerPage: PropTypes.number,
    itemWidth: PropTypes.number,
    isCentered: PropTypes.bool,
    classNames: PropTypes.object,
    items: PropTypes.array,
    children: PropTypes.object,
    onImpression: PropTypes.func,
    onPageChange: PropTypes.func,
    carouselRef: PropTypes.func,
    onDotClick: PropTypes.func,
    isMobile: PropTypes.bool,
    transitionEffect: PropTypes.string,
    customTransformItemStyle: PropTypes.func
};

module.exports = HomepageCarousel;

/***/ }),

/***/ 2177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'use strcit';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var MediaQuery = __webpack_require__(387);
var HomepageCarousel = __webpack_require__(2176);
var HeroItem = __webpack_require__(3644);
var Personalization = __webpack_require__(3649);
var CollectionsItem = __webpack_require__(3643);

var _require = __webpack_require__(371),
    queries = _require.queries;

var tracking = __webpack_require__(1139);

function Hero(props) {
    var carouselProps = {
        auto: true,
        useDotsNav: true,
        onImpression: tracking.trackHeroImpression
    };
    return React.createElement(
        HomepageCarousel,
        _extends({}, carouselProps, props),
        React.createElement(HeroItem, { onClick: tracking.trackHeroClick })
    );
}

function Collections(props) {
    var carouselProps = {
        transitionEffect: 'slide',
        onPageChange: tracking.trackCollectionsArrows,
        onImpression: tracking.trackCollectionsImpression,
        classNames: {
            list: 'collections-carousel-list',
            item: 'collections-carousel-item'
        }
    };
    return React.createElement(
        HomepageCarousel,
        _extends({}, carouselProps, props),
        React.createElement(CollectionsItem, { onClick: tracking.trackCollectionsClick })
    );
}

function ResponsiveCollection(props) {
    return React.createElement(
        'div',
        null,
        React.createElement(
            MediaQuery,
            { query: [queries.lg, queries.xl] },
            React.createElement(Collections, _extends({ itemsPerPage: 5 }, props))
        ),
        React.createElement(
            MediaQuery,
            { query: queries.md },
            React.createElement(Collections, _extends({ itemsPerPage: 4 }, props))
        ),
        React.createElement(
            MediaQuery,
            { query: [queries.xs, queries.sm] },
            React.createElement(Collections, _extends({ itemsPerPage: 3.5, isMobile: true }, props))
        )
    );
}

ResponsiveCollection.propTypes = {
    items: PropTypes.array.isRequired
};

function ResponsiveHero(props) {
    return React.createElement(
        'div',
        null,
        React.createElement(
            MediaQuery,
            { query: [queries.xl] },
            React.createElement(Hero, _extends({ itemsPerPage: 4 }, props))
        ),
        React.createElement(
            MediaQuery,
            { query: [queries.lg] },
            React.createElement(Hero, _extends({ itemsPerPage: 3 }, props, { items: props.items.slice(0, -1) }))
        ),
        React.createElement(
            MediaQuery,
            { query: [queries.md] },
            React.createElement(Hero, _extends({ itemsPerPage: 2 }, props))
        ),
        React.createElement(
            MediaQuery,
            { query: [queries.xs, queries.sm] },
            React.createElement(Hero, _extends({ itemsPerPage: 1.5 }, props, { useDotsNav: false, isMobile: true }))
        )
    );
}

ResponsiveHero.propTypes = {
    items: PropTypes.array.isRequired
};

module.exports = {
    ResponsiveHero: ResponsiveHero,
    ResponsiveCollection: ResponsiveCollection,
    Personalization: Personalization
};

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var createStore = __webpack_require__(219).createStore;
var __DEV__ = 'production' !== 'production';

function stateIdentity(state) { return state; }

module.exports = function createReducerStore(spec) {
    spec = spec || {};
    var ReducerStore = createStore({
        storeName: spec.storeName,
        handlers: {},
        initialize: function () {
            this.state = spec.initialState;
        },
        getState: function () {
            return this.state;
        },
        dehydrate: function () {
            return (spec.dehydrate || stateIdentity)(this.state);
        },
        rehydrate: function (state) {
            this.state = (spec.rehydrate || stateIdentity)(state);
        }
    });

    function replaceReducers(reducers) {
        spec.reducers = reducers || {};
        // Allow a single reducer function
        if (spec.reducer) {
            spec.reducers = {
                'default': spec.reducer
            };
        }
        // Create a handler proxy for each reducer so that the store can
        // still be lazy instantiated by dispatchr.
        Object.keys(spec.reducers).forEach(function eachReducer(eventName) {
            var reducer = spec.reducers[eventName];
            if (!ReducerStore.handlers[eventName]) {
                ReducerStore.handlers[eventName] = function (payload, dispatchedEventName) {
                    if (__DEV__) {
                        if (!spec.reducers[eventName]) {
                            // Calling a reducer that has been removed should be
                            // non-fatal, but warning may help with bugs.
                            console.warn(eventName + ' reducer on ' + spec.storeName +
                                ' has been removed.');
                            return;
                        }
                    }
                    var startingState = this.state;
                    this.state = spec.reducers[eventName](this.state, payload, dispatchedEventName);
                    if (this.state !== startingState) {
                        this.emitChange();
                    }
                };
            }
        });
    }
    ReducerStore.replaceReducer = replaceReducers;
    ReducerStore.replaceReducers = replaceReducers;

    ReducerStore.replaceGetters = function replaceGetters(getters) {
        spec.getters = getters || {};
        Object.keys(spec.getters).forEach(function (methodName) {
            if (!ReducerStore.prototype[methodName]) {
                ReducerStore.prototype[methodName] = function () {
                    if (__DEV__) {
                        if (!spec.getters[methodName]) {
                            // Calling a method that has been removed would be
                            // fatal, so let's throw a more useful error than
                            // "undefined is not a function"
                            throw new Error(methodName + ' on ' + storeName +
                                ' has been removed but was still called.');
                        }
                    }
                    var state = this.state;
                    var args = [state].concat(Array.prototype.slice.call(arguments));
                    return spec.getters[methodName].apply(null, args);
                };
            }
        });
    };

    ReducerStore.replaceSpec = function replaceSpec(spec) {
        spec = spec || {};
        ReducerStore.replaceReducers(spec.reducers);
        ReducerStore.replaceGetters(spec.getters);
    };

    ReducerStore.replaceSpec(spec);

    return ReducerStore;
};


/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


module.exports = {
    BaseStore: __webpack_require__(13),
    createStore: __webpack_require__(50)
};


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var Fluxible = __webpack_require__(90);
Fluxible.Fluxible = __webpack_require__(90);

module.exports = Fluxible;


/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var debug = __webpack_require__(91)('Fluxible:Context');
var isPromise = __webpack_require__(57);
var generateUUID = __webpack_require__(225);
var callAction = __webpack_require__(224);

var __DEV__ = 'production' !== 'production';
__webpack_require__(52);

/**
 * A request or browser-session context
 * @class FluxibleContext
 * @param {Fluxible} app The Fluxible instance used to create the context
 * @constructor
 */
function FluxContext(app) {
    this._app = app;

    // To be created on demand
    this._dispatcher = null;

    // Plugins
    this._plugins = [];

    // Set up contexts
    this._actionContext = null;
    this._componentContext = null;
    this._storeContext = null;
}

var warnedOnce = false;

/**
 * Getter for the app's component. Pass through to the Fluxible instance.
 * @method getComponent
 * @returns {ReactComponent}
 */
FluxContext.prototype.getComponent = function getComponent() {
    return this._app.getComponent();
};

/**
 * Getter for store from dispatcher
 * @method getStore
 * @returns {Object}
 */
FluxContext.prototype.getStore = function getStore(store) {
    if (!this._dispatcher) {
        this._initializeDispatcher();
    }
    return this._dispatcher.getStore(store);
};

/**
 * Provides plugin mechanism for adding application level settings that are persisted
 * between server/client and also modification of the FluxibleContext
 * @method plug
 * @param {Object} plugin
 * @param {String} plugin.name Name of the plugin
 * @param {Function} [plugin.plugActionContext] Method called after action context is created to allow
 *  dynamically modifying the action context
 * @param {Function} [plugin.plugComponentContext] Method called after component context is created to
 *  allow dynamically modifying the component context
 * @param {Function} [plugin.plugStoreContext] Method called after store context is created to allow
 *  dynamically modifying the store context
 * @param {Object} [plugin.dehydrate] Method called to serialize the plugin settings to be persisted
 *  to the client
 * @param {Object} [plugin.rehydrate] Method called to rehydrate the plugin settings from the server
 */
FluxContext.prototype.plug = function (plugin) {
    if (!plugin.name) {
        throw new Error('Context plugin must have a name');
    }
    this._plugins.push(plugin);
};

/**
 * Executes an action passing an action interface to as the first parameter
 * If a promise is returned by the action, it will wait for its resolution or rejection
 * If the action has less than three parameters, the returned promise
 * will be resolved with the return value
 * If the action throws an error, the promise will be rejected with the thrown value
 * @param {Object} context The current FluxibleContext
 * @param {Object} actionContext The current action context
 * @param {Function} action An action creator function that receives actionContext, payload,
 *  and done as parameters
 * @param {Object} payload The action payload
 * @param {Function} [done] Method to be called once action execution has completed
 * @return {Promise} executeActionPromise Resolved with action result or rejected with action error
 */
function executeActionProxy(context, actionContext, action, payload, done) {
    if (__DEV__) {
        if (!action) {
            throw new Error('executeAction called with an invalid action. Action ' +
                'must be a function.');
        }
    }
    var displayName = action.displayName || action.name;
    payload = (undefined !== payload) ? payload : {};
    if (__DEV__) {
        if (context._dispatcher && context._dispatcher.currentAction) {
            var currentActionDisplayName = context._dispatcher.currentAction.displayName ||
                context._dispatcher.currentAction.name;

            console.warn('Warning: executeAction for `' + displayName + '` was called, but `' +
                currentActionDisplayName + '` is currently being dispatched. This could mean ' +
                'there are cascading updates, which should be avoided. `' + displayName +
                '` will only start after `' + currentActionDisplayName + '` is complete.');
        }
    }

    if (debug.enabled) {
        debug('Executing action ' + actionContext.stack.join('.') + ' with payload', payload);
    }
    return callAction(actionContext, action, payload, done);
}

/**
 * Proxy function for executing an action.
 * @param {Function} action An action creator function that receives actionContext, payload,
 *  and done as parameters
 * @param {Object} payload The action payload
 * @param {Function} [done] Method to be called once action execution has completed
 * @return {Promise} executeActionPromise Resolved with action result or rejected with action error
 */
FluxContext.prototype.executeAction = function executeAction(action, payload, done) {
    var subActionContext = this._createSubActionContext(this.getActionContext(), action);
    return executeActionProxy(this, subActionContext, action, payload, done);
};

/**
 * Sets up the dispatcher with access to the store context
 * @method _initializeDispatcher
 * @private
 */
FluxContext.prototype._initializeDispatcher = function initializeDispatcher() {
    this._dispatcher = this._app.createDispatcherInstance(this.getStoreContext());
};

/**
 * Creates a subActionContext with new stack and rootID based on the action
 * that will be executed.
 * @private
 * @method _createSubActionContext
 * @param {Object} parentActionContext The action context that the stack should
 *      extend from
 * @param {Function} action The action to be executed to get the name from
 * @returns {Object}
 */
FluxContext.prototype._createSubActionContext = function createSubActionContext(parentActionContext, action) {
    var displayName = action.displayName || action.name;
    /*
     * We store the action's stack array on the `stack` property
     * of the actionContext interface.
     * You can access this in your actions with `context.stack`.
     * Use the `displayName` property on your actions for better
     * action tracing when your code gets minified in prod.
     * One action can execute multiple actions, so we need to create a shallow
     * clone with a new stack & new id every time a newActionContext is created.
     */
    var newActionContext = Object.assign({}, this.getActionContext(), {
        stack: (parentActionContext.stack || []).concat([displayName]),
        rootId: (parentActionContext.rootId) || generateUUID()
    });
    newActionContext.executeAction = newActionContext.executeAction.bind(newActionContext);
    return newActionContext;
};

/**
 * Returns the context for action controllers
 * @method getActionContext
 * @return {Object} Action context information
 */
FluxContext.prototype.getActionContext = function getActionContext() {
    var self = this;

    if (!self._actionContext) {
        if (!self._dispatcher) {
            self._initializeDispatcher();
        }

        var actionContext = {
            dispatch: self._dispatcher.dispatch.bind(self._dispatcher),
            executeAction: function executeAction (action, payload, callback) {
                // `this` will be the current action context
                var subActionContext = self._createSubActionContext(this, action);
                return executeActionProxy(self, subActionContext, action, payload, callback);
            },
            getStore: self._dispatcher.getStore.bind(self._dispatcher)
        };

        self._plugins.forEach(function pluginsEach(plugin) {
            var actionContextPlugin = plugin.plugActionContext;
            if (actionContextPlugin) {
                actionContextPlugin(actionContext, self, self._app);
            }
        });

        self._actionContext = actionContext;
    }

    return self._actionContext;
};

/**
 * Returns the context for action controllers
 * @method getComponentContext
 * @return {Object} Component context information
 */
FluxContext.prototype.getComponentContext = function getComponentContext() {
    if (this._componentContext) {
        return this._componentContext;
    }
    var self = this;
    if (!self._dispatcher) {
        self._initializeDispatcher();
    }

    var componentContext = {
        getStore: this._dispatcher.getStore.bind(this._dispatcher),
        // Prevents components from directly handling the callback for an action
        executeAction: function componentExecuteAction(action, payload, done) {
            if (done) {
                if (__DEV__) {
                    console.warn('When calling executeAction from a component,' +
                        'a callback isn\'t allowed. See our docs for more info:' +
                        'http://fluxible.io/api/components.html#component-context');
                }
            }
            self.executeAction(action, payload)
            ['catch'](function actionHandlerWrapper(err) {
                return self.executeAction(self._app._componentActionErrorHandler, {
                    actionName: action.displayName || action.name,
                    err: err
                });
            })
            ['catch'](function unhandledError(err) {
                setImmediate(function () {
                    throw err;
                });
            });
        }
    };

    self._plugins.forEach(function pluginsEach(plugin) {
        var componentPlugin = plugin.plugComponentContext;
        if (componentPlugin) {
            componentPlugin(componentContext, self, self._app);
        }
    });

    self._componentContext = componentContext;
    return self._componentContext;
};

/**
 * Returns the context for stores
 * @method getStoreContext
 * @return {Object} Store context information
 */
FluxContext.prototype.getStoreContext = function getStoreContext() {
    if (this._storeContext) {
        return this._storeContext;
    }
    var self = this;
    var storeContext = {};

    self._plugins.forEach(function pluginsEach(plugin) {
        var storeContextPlugin = plugin.plugStoreContext;
        if (storeContextPlugin) {
            storeContextPlugin(storeContext, self, self._app);
        }
    });

    self._storeContext = storeContext;
    return self._storeContext;
};

/**
 * Returns a serializable context state
 * @method dehydrate
 * @return {Object} See rehydrate method for properties
 */
FluxContext.prototype.dehydrate = function dehydrate() {
    var self = this;
    var state = {
        dispatcher: (this._dispatcher && this._dispatcher.dehydrate()) || {},
        plugins: {}
    };

    self._plugins.forEach(function pluginsEach(plugin) {
        if ('function' === typeof plugin.dehydrate) {
            // Use a namespace for storing plugin state and provide access to the application
            state.plugins[plugin.name] = plugin.dehydrate(self);
        }
    });

    return state;
};

/**
 * Rehydrates the context state
 * @method rehydrate
 * @param {Object} obj Configuration
 * @param {Object} obj.plugins Dehydrated context plugin state
 * @param {Object} obj.dispatcher Dehydrated dispatcher state
 */
FluxContext.prototype.rehydrate = function rehydrate(obj) {
    var self = this;
    if (__DEV__) {
        if (typeof obj !== 'object') {
            throw new Error('`rehydrate` called with a non-object. Ensure ' +
                'that the parameter passed to rehydrate is a state object ' +
                'produced by a dehydrate call.');
        }
    }
    obj.plugins = obj.plugins || {};
    var pluginTasks = self._plugins.filter(function (plugin) {
        return 'function' === typeof plugin.rehydrate
            && obj.plugins[plugin.name];
    }).map(function (plugin) {
        return new Promise(function (resolve, reject) {
            var result = plugin.rehydrate(obj.plugins[plugin.name], function (err) {
                if (err) {
                    reject(err);
                } else {
                    resolve();
                }
            });
            if (isPromise(result)) {
                result.then(resolve, reject);
            } else if (plugin.rehydrate.length < 2) {
                resolve();
            }
        });
    });

    return Promise.all(pluginTasks).then(function rehydratePluginTasks() {
        self._dispatcher = self._app.createDispatcherInstance(self.getStoreContext());
        self._dispatcher.rehydrate(obj.dispatcher || {});
        return self;
    });
};

module.exports = FluxContext;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42).setImmediate))

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(223);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 223:
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
/* global Promise */

var isPromise = __webpack_require__(57);
__webpack_require__(52);

/**
 * Call an action supporting Promise expectations on invocation.
 *
 * If done callback supplied, that indicates non-Promise invocation expectation,
 * otherwise, Promise invocation.
 */
function callAction (actionContext, action, payload, done) {
    var executeActionPromise = new Promise(function (resolve, reject) {
        setImmediate(function () {
            try {
                var syncResult = action(actionContext, payload, function (err, result) {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(result);
                    }
                });
                if (isPromise(syncResult)) {
                    syncResult.then(resolve, reject);
                } else if (action.length < 3) {
                    resolve(syncResult);
                }
            } catch (e) {
                reject(e);
            }
        });
    });

    if (done) {
        executeActionPromise
            .then(function(result) {
                // Ensures that errors in callback are not swallowed by promise
                setImmediate(done, null, result);
            }, function (err) {
                // Ensures that errors in callback are not swallowed by promise
                setImmediate(done, err);
            });
    }

    return executeActionPromise;
}

module.exports = callAction;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42).setImmediate))

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


/*
 * Generate a GUID for keeping track of a
 * transaction of actions and dispatches.
 * Reference: https://github.com/facebook/react/blob/a48ffb04dcfe4d6f832207618a8b39e3034bd413/src/renderers/dom/server/ServerReactRootIndex.js
 */
var GLOBAL_UUID_MAX = Math.pow(2, 53);

module.exports = function generateUUID () {
    return Math.ceil(Math.random() * GLOBAL_UUID_MAX);
}


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

// Backbone.Events
// ---------------

// A module that can be mixed in to *any object* in order to provide it with
// custom events. You may bind with `on` or remove with `off` callback
// functions to an event; `trigger`-ing an event fires all callbacks in
// succession.
//
//     var object = {};
//     _.extend(object, Backbone.Events);
//     object.on('expand', function(){ alert('expanded'); });
//     object.trigger('expand');
//

var array = [];
var push = array.push;
var slice = array.slice;
var splice = array.splice;

var _ = __webpack_require__(227);

var Events = module.exports.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }
      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeningTo = this._listeningTo;
      if (!listeningTo) return this;
      var remove = !name && !callback;
      if (!callback && typeof name === 'object') callback = this;
      if (obj) (listeningTo = {})[obj._listenId] = obj;
      for (var id in listeningTo) {
        obj = listeningTo[id];
        obj.off(name, callback, this);
        if (remove || _.isEmpty(obj._events)) delete this._listeningTo[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeningTo = this._listeningTo || (this._listeningTo = {});
      var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
      listeningTo[id] = obj;
      if (!callback && typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

//Events.extend = require('backbone-helpers').extend;

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ContactUIStore = __webpack_require__(98);
var ContactMessageStore = __webpack_require__(99);
var UserToUserMessageStore = __webpack_require__(128);
var ContactGaStore = __webpack_require__(113);
var ContactTransactionStore = __webpack_require__(107);

/**
 * Registers the contact stores with the specified component.
 * @param App {Fluxible} A top level component that will be connected to the stores.
 * @param options {Object}
 * @param options.isStorefront {boolean} true if function is being called on dealer storefront
 */
module.exports = function (App) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    App.registerStore(ContactUIStore);
    App.registerStore(ContactMessageStore);
    App.registerStore(ContactGaStore);
    if (options.isUserToUser) {
        App.registerStore(UserToUserMessageStore);
    }
    if (!options.isStorefront) {
        App.registerStore(ContactTransactionStore);
    }
    return App;
};

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 7/17/15.
 */



var NavBarItemStore = __webpack_require__(143);
var NavBarUIStateStore = __webpack_require__(141);
var SearchStore = __webpack_require__(144);
var NavBarHamburgerStateStore = __webpack_require__(142);
var CartStore = __webpack_require__(108);
var CartCopyStore = __webpack_require__(232);

/**
 * Registers the nav bar stores with the specified component.
 * @param App {Fluxible} A top level component that will be connected to the stores.
 */
module.exports = function (App) {
  App.registerStore(NavBarItemStore);
  App.registerStore(NavBarUIStateStore);
  App.registerStore(SearchStore);
  App.registerStore(NavBarHamburgerStateStore);
  App.registerStore(CartStore);
  App.registerStore(CartCopyStore);

  return App;
};

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 8/24/15.
 */



var Fluxible = __webpack_require__(220);

/**
 * Creates a new Fluxible object and registers the specified stores with it.
 * @param stores
 * @returns {Fluxible|exports|module.exports} The created Fluxible object
 * @constructor
 */
function AppFactory() {
  var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var app = new Fluxible();

  stores.forEach(function (store) {
    app.registerStore(store);
  });

  return app;
}

module.exports = AppFactory;

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var connectToNavBar = __webpack_require__(229);
var connectToContact = __webpack_require__(228);

var _require = __webpack_require__(95),
    createReducerStore = _require.createReducerStore;

var appFactory = __webpack_require__(230);

var RegionalInfoStore = __webpack_require__(321);
var UserStore = createReducerStore(__webpack_require__(114));
var PortfolioStore = __webpack_require__(297);
var ContactDealerStore = createReducerStore(__webpack_require__(137));

var StickyAlertTopStore = __webpack_require__(324);
var CalloutStore = __webpack_require__(300);

/**
 * Setups Fluxible App for use on the server and client.
 *
 * Registers the stores needed to communicate with the global nav bar and
 * registers RegionalInfoStore needed to communicate with global user auth modal,
 *
 * @param {Array} [stores=[]] - Array of stores to register onto App
 * @param {Object} [options={}]
 * @param {boolean} [options.connectToNavBar=true] - If true, register Nav Bar stores with the app
 * @returns {Object} - Fluxible App
 */
function appSetup() {
    var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var App = appFactory(stores);

    if (options.connectToNavBar) {
        App = connectToNavBar(App);
    }
    if (options.connectToContact) {
        App = connectToContact(App, options.contactOptions);
    }

    App.registerStore(RegionalInfoStore);
    App.registerStore(UserStore);
    App.registerStore(PortfolioStore);
    App.registerStore(ContactDealerStore);

    App.registerStore(StickyAlertTopStore);

    App.registerStore(CalloutStore);

    return App;
}

module.exports = appSetup;

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var SV = __webpack_require__(18);

var CartCopyStore = function (_BaseStore) {
    _inherits(CartCopyStore, _BaseStore);

    function CartCopyStore(dispatcher) {
        _classCallCheck(this, CartCopyStore);

        var _this = _possibleConstructorReturn(this, (CartCopyStore.__proto__ || Object.getPrototypeOf(CartCopyStore)).call(this, dispatcher));

        _this._cartCopy = SV.get('cartData.cartCopy') || {};
        _this._cartText = SV.get('settings.globalCartCopy.cartBottomText');
        return _this;
    }

    _createClass(CartCopyStore, [{
        key: 'getCartText',
        value: function getCartText() {
            return this._cartText;
        }
    }, {
        key: 'getSoldItemText',
        value: function getSoldItemText() {
            return this._cartCopy.soldItem || '';
        }
    }]);

    return CartCopyStore;
}(BaseStore);

CartCopyStore.storeName = 'CartCopyStore';

module.exports = CartCopyStore;

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var Attachment = __webpack_require__(171);
var Clump = __webpack_require__(22);
var endpoints = __webpack_require__(6);
var bunsen = __webpack_require__(21);
var _ = __webpack_require__(0);
var result = __webpack_require__(69);
var $ = __webpack_require__(5);

module.exports = Backbone.Collection.extend({
    model: Attachment,
    initialize: function initialize(models, options) {
        var _this = this;

        var firstAttachmentAdded;
        var _attachmentAdded2;
        options = $.extend({
            uploadType: 'message_center',
            directory: undefined,
            maxCombinedAttachmentSize: undefined,
            uploadOnAdd: true,
            saveOptions: undefined
        }, options);
        this._maxCombinedAttachmentSize = options.maxCombinedAttachmentSize;
        this._saveOptions = options.saveOptions;
        this.on({
            add: function add(attachment) {
                _this._uploadingAttachment = true;
                _this.gotDirectory.done($.proxy(attachment, 'set', 'dir'));
                if (options.uploadOnAdd) {
                    _this.gotDirectory.done(bunsen.gandalf($.proxy(attachment, 'save', null, _this._saveOptions)));
                }
            },
            remove: function remove(attachment) {
                attachment.destroy({
                    success: function success() {
                        return result(attachment.lastSave, 'abort');
                    }
                });
            }
        });
        if (options.directory) {
            this.gotDirectory = $.Deferred().resolve(options.directory);
            return;
        }
        // make request for the upload directory after the first model has been added
        firstAttachmentAdded = $.Deferred();
        _attachmentAdded2 = function _attachmentAdded(addedAttachment) {
            if (!addedAttachment.isNew()) {
                return;
            }
            this.off('add', _attachmentAdded2);
            firstAttachmentAdded.resolve();
        };
        this.on('add', _attachmentAdded2, this);
        this.gotDirectory = firstAttachmentAdded.then($.proxy(this, '_fetchDirectory', options.uploadType));
    },
    comparator: function comparator(modelA, modelB) {
        if (!this._uploadingAttachment) {
            return modelA.get('attachmentType').localeCompare(modelB.get('attachmentType'));
        }
    },
    hasRoomFor: function hasRoomFor(bytes) {
        if (undefined === this._maxCombinedAttachmentSize) {
            return true;
        }
        return bytes < this._maxCombinedAttachmentSize - this.getTotalSize();
    },
    getTotalSize: function getTotalSize() {
        return _.reduce(this.pluck('fileSize'), function (memo, num) {
            return memo + num;
        }, 0);
    },
    sync: function sync() {
        var _this2 = this;

        var unsavedAttachments = _.filter(this.models, function (attachment) {
            return !attachment.lastSave || attachment.lastSave.state() === "rejected";
        });
        if (0 === this.length) {
            return $.Deferred().resolve();
        }
        return this.gotDirectory.then(function (directory) {
            _.invoke(unsavedAttachments, 'set', 'dir', directory);
            _.invoke(unsavedAttachments, 'save', null, _this2._saveOptions);
            return $.when.apply($, _.pluck(_this2.models, 'lastSave'));
        });
    },
    _fetchDirectory: function _fetchDirectory(uploadType) {
        var endpointUpload = uploadType === 'itemImage' ? endpoints.itemImageUpload : endpoints.cmsUpload;

        return Clump.ajax({
            type: 'POST',
            url: endpointUpload(uploadType) + "?" + $.param($.extend({
                cleanup: 'N',
                execute: 'N'
            }, bunsen.getToken()))
        }).then(function (data) {
            return data.result.fileUpload.dir;
        });
    }
});

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var Address = __webpack_require__(32);
var moment = __webpack_require__(30);

module.exports = Backbone.AssociatedModel.extend({

    relations: [{
        key: 'sellerDetails',
        relatedModel: Backbone.AssociatedModel.extend(),
        type: Backbone.One
    }, {
        key: 'address',
        relatedModel: Address,
        type: Backbone.One
    }],

    getRegDateFormatted: function getRegDateFormatted() {
        var regDateMomentObj = moment(this.get('buyerRegistrationDate'));
        return regDateMomentObj.format((regDateMomentObj.year() === moment().year() ? 'MMMM, ' : '') + 'YYYY');
    },
    isFollowingSeller: function isFollowingSeller() {
        return this.get('sellerDetails.followingSeller') === 'Y';
    },
    isVerifiedPaymentInformation: function isVerifiedPaymentInformation() {
        return this.get('verifiedPaymentInformation') === 'Y';
    },
    isActiveBuyer: function isActiveBuyer() {
        return this.get('activeBuyer') === 'Y';
    },
    isTrade: function isTrade() {
        return this.get('tradeBuyer') === 'Y';
    }
});

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var SoaModel = __webpack_require__(2);
var InvoiceSummary = module.exports = SoaModel.extend();

var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var Invoice = __webpack_require__(81);

module.exports = root.bunsen.InvoiceSummary = InvoiceSummary;

_.extend(InvoiceSummary.prototype, {
    relations: SoaModel.createRelations([{
        type: Backbone.One,
        key: 'dealerCurrentInvoice',
        relatedModel: Invoice
    }, {
        type: Backbone.Many,
        key: 'dealerDeltasInvoices',
        relatedModel: Invoice
    }, {
        type: Backbone.One,
        key: 'dealerOriginalInvoice',
        relatedModel: Invoice
    }])
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Transaction = __webpack_require__(20);
var Party = __webpack_require__(8);
var FinancialAmount = __webpack_require__(10);
var extendCompose = __webpack_require__(43);
var PrivateTransaction = extendCompose.call(Transaction, {});

/**
 * this is an extension of the transaction model intended to facilitate
 * the creation of buyer or seller initiated negotiation 2.0 transactions
 */
PrivateTransaction.extendSelf({

    defaults__: {
        offers: [{
            quantity: '1',
            forCompleteLot: true,
            amountPerItem: {}
        }]
    },

    initialize__: function initialize__() {
        this._offer = this.get('offers[0]');
    },
    prepareToSaveBuyer: function prepareToSaveBuyer() {
        var seller = this.get('seller');
        if (seller) {
            this._offer.set('counterParty', new Party({
                role: Party.ROLE_SELLER,
                id: seller.id
            }));
        }
        var buyer = this.get('buyer');
        if (buyer) {
            this._offer.set('initiatingParty', new Party({
                role: Party.ROLE_BUYER,
                id: buyer.id
            }));
            // use buyer preference currency for buyer initiated transactions
            this._offer.set('amountPerItem.currency', buyer.get('profile.currency') || FinancialAmount.CURRENCY_USD);
        }
        var item = this.get('item');
        if (item) {
            this.set('currencyConversionRateEvent', item.get('pricing.totalAmount.conversionRateEvent'));
        }
    },
    prepareToSaveSeller: function prepareToSaveSeller() {
        var seller = this.get('seller');
        if (seller) {
            this._offer.set('initiatingParty', new Party({
                role: Party.ROLE_SELLER,
                id: seller.id
            }));
        }
        var buyer = this.get('buyer');
        if (buyer) {
            this._offer.set('counterParty', new Party({
                role: Party.ROLE_BUYER,
                id: buyer.id
            }));
        }
        var item = this.get('item');
        if (item) {
            var amount = item.get('pricing.totalAmount');
            this.set('currencyConversionRateEvent', amount.get('conversionRateEvent'));
            this._offer.set('amountPerItem.currency', amount.get('currency'));
        }
    }
});

module.exports = PrivateTransaction;

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Rob Richard
 * Date: 5/6/14
 * Time: 12:07 PM
 */



var _ = __webpack_require__(0);
var Transaction = __webpack_require__(20);
var PaymentAuthorization = __webpack_require__(24);

var _require = __webpack_require__(201),
    momentLocales = _require.momentLocales;

var Offer = __webpack_require__(25);

module.exports = {
    isAccepted: function isAccepted() {
        return this.getMostRecentOffer().isAccepted();
    },
    isAwaitingManualReview: function isAwaitingManualReview() {
        var summary = this.get('summary');
        var checkoutPaymentAuthorization = summary && summary.get('checkoutPaymentAuthorization');
        return checkoutPaymentAuthorization && checkoutPaymentAuthorization.get('status') === PaymentAuthorization.STATUS_PENDING_ADMIN_APPROVAL;
    },
    isPrivateOffer: function isPrivateOffer() {
        var offer = this.getFirstOffer();
        return offer && offer.isDealerInitiatedOffer();
    },
    isPreCheckout: function isPreCheckout() {
        return this.get('summary.checkoutPaymentAuthorization') ? false : true;
    },
    hasSingleOffer: function hasSingleOffer() {
        var offers = this.get('offers');
        return offers && offers.length === 1;
    },
    hasMultipleOffers: function hasMultipleOffers() {
        var offers = this.get('offers');
        return offers && offers.length > 1;
    },
    hasTradeBuyer: function hasTradeBuyer() {
        return this.get('tradeBuyer') === 'Y';
    },
    buyerCanAcceptPrivateOffer: function buyerCanAcceptPrivateOffer() {
        if (!this.isPrivateOffer()) {
            return false;
        }
        if (this.get('status') !== Transaction.STATUS_NEGOTIATING) {
            return false;
        }
        if (_.result(this.getMostRecentOffer(), 'isExpired')) {
            return false;
        }
        if (this.get('summary.checkoutPaymentAuthorization')) {
            return false;
        }
        return true;
    },
    // orders marked as sold from the omt do not get status=CANCELED
    isPrivateOfferCanceled: function isPrivateOfferCanceled() {
        if (this.isCanceled()) {
            return true;
        }
        if (this.isPending() || this.get('status') === Transaction.STATUS_CLOSED) {
            return false;
        }
        return _.result(this.get('item'), 'isItemSold');
    },
    isReadyForBalanceDue: function isReadyForBalanceDue() {
        var paymentRequiredQuote = this.getPaymentRequiredQuote();
        return !!(this.isInProgress() && (paymentRequiredQuote || this.hasBuyerOrderMod()));
    },
    isNegotiable: function isNegotiable() {
        return this.get('transactionType') === Transaction.TYPE_NEGOTIABLE;
    },
    isPreAuthNegotiation: function isPreAuthNegotiation() {
        return this.get('transactionType') === Transaction.TYPE_PRE_AUTH_NEGOTIATION;
    },
    isBuyerInitiatedPreAuth: function isBuyerInitiatedPreAuth() {
        var firstOffer = this.getFirstOffer();
        return this.isPreAuthNegotiation() && firstOffer && firstOffer.isBuyerInitiatedOffer();
    },
    isInProgress: function isInProgress() {
        var inProgressStatuses = [Transaction.STATUS_NEGOTIATING];
        return _.contains(inProgressStatuses, this.get('status'));
    },
    isPending: function isPending() {
        var inPendingStatuses = [Transaction.STATUS_PENDING];
        return _.contains(inPendingStatuses, this.get('status'));
    },
    isConfirmed: function isConfirmed() {
        var confirmedStatuses = [Transaction.STATUS_PENDING, Transaction.STATUS_CLOSED];
        return _.contains(confirmedStatuses, this.get('status'));
    },
    isClosed: function isClosed() {
        return this.get('status') === Transaction.STATUS_CLOSED;
    },
    isCanceled: function isCanceled() {
        var canceledStates = [Transaction.STATUS_NOT_AVAILABLE, Transaction.STATUS_CANCELED];
        return _.contains(canceledStates, this.get('status'));
    },
    isPreConfirmation: function isPreConfirmation() {
        return !this.isPreCheckout() && this.isInProgress();
    },
    isNotApproved: function isNotApproved() {
        var cancellationReasons = [Transaction.CANCELLATION_REASON_FRAUD, Transaction.CANCELLATION_REASON_CANCELED_BEFORE_APPROVED];

        if (this.isAwaitingManualReview()) {
            return true;
        }

        if (_.contains(cancellationReasons, this.get('cancellationReason'))) {
            return true;
        }

        return false;
    },
    isReadyToMarkDealerPaid: function isReadyToMarkDealerPaid() {
        var paymentAuth = this.getOfferPaymentAuthorization();
        var hasPaymentAuthorization = paymentAuth && paymentAuth.isCaptured();
        var isPending = this.isPending();
        var canceled = this.isCanceled();
        var dealerDisbursement = this.getDealerDisbursement();

        return hasPaymentAuthorization && !canceled && isPending && dealerDisbursement && dealerDisbursement.isNewStatus();
    },
    canComputeAdjustments: function canComputeAdjustments() {
        return !!this.getMostRecentOffer().get('quantity');
    },
    isPendingPaymentDeclined: function isPendingPaymentDeclined() {
        var paymentAuth = this.getOfferPaymentAuthorization();
        if (paymentAuth) {
            return paymentAuth.hasPaymentDeclined();
        } else {
            return false;
        }
    },
    getOfferDetails: function getOfferDetails() {
        var mostRecentOffer = void 0;
        var offerAmounts = void 0;
        var offerExpDateTxt = void 0;

        if (!this) {
            return {};
        }
        mostRecentOffer = this.getMostRecentOffer();
        if (!mostRecentOffer) {
            return {};
        }

        if (mostRecentOffer.get('expirationDate') && this._needExpDate()) {
            offerExpDateTxt = momentLocales.inlineDatesAdverb(mostRecentOffer.get('expirationDate')).fromNow();
        }
        offerAmounts = mostRecentOffer.get('totalAmount');
        return {
            offer: mostRecentOffer,
            offerAmounts: offerAmounts, offerExpDateTxt: offerExpDateTxt
        };
    },
    _needExpDate: function _needExpDate() {
        var mostRecentOffer = this.getMostRecentOffer();
        if (!this.isPreAuthNegotiation() || this.isCanceled()) {
            return false;
        }
        if (mostRecentOffer.isSubmitted()) {
            return true;
        }
        if (mostRecentOffer.offerDisplayStatus({ transaction: this }) === Offer.DisplayOfferStatus.dealerAccepted) {
            return true;
        }
        return false;
    },
    _getCounteredOffers: function _getCounteredOffers() {
        return this.get('offers').where({ status: Offer.STATUS_COUNTERED });
    },
    isMostRecentlyDealerCountered: function isMostRecentlyDealerCountered() {
        return _.chain(this._getCounteredOffers()).last().result('isBuyerInitiatedOffer').value();
    },
    isMostRecentlyBuyerCountered: function isMostRecentlyBuyerCountered() {
        return _.chain(this._getCounteredOffers()).last().result('isDealerInitiatedOffer').value();
    },
    isBuyerOfferWithReserve: function isBuyerOfferWithReserve() {
        // currently, this method is the same as isNegotiable and only checks if the transaction type is negotiable
        // created this method in case the isNegotiable method gets updated above to include other transaction types
        return this.get('transactionType') === Transaction.TYPE_NEGOTIABLE;
    },
    isFullPriceOrder: function isFullPriceOrder() {
        // in the 5.48 BE ecom release, all reserve-less offers will have a new type
        // the only tx of type non-negotiable will be full-priced orders
        return this.get('transactionType') === Transaction.TYPE_NON_NEGOTIABLE;
    },
    isBuyerInitiatedTx: function isBuyerInitiatedTx() {
        return _.result(this.getFirstOffer(), 'isBuyerInitiatedOffer');
    }
};

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var Message = __webpack_require__(73);
var Backbone = __webpack_require__(3);
var endpoints = __webpack_require__(6);
var extendCompose = __webpack_require__(43);
var Item = __webpack_require__(34);
var MessageRecipient = __webpack_require__(72);
var ConversationMember = __webpack_require__(68);
var Party = __webpack_require__(8);
var ContactDealerMessage = module.exports = extendCompose.call(Message, {});

ContactDealerMessage.extendSelf({
    url: endpoints.messageNewConversation,

    defaults__: {
        from: {
            displayName: '',
            discloseEmail: 'N'
        }
    },

    relations__: function relations__(relations) {
        return relations.concat([{
            type: Backbone.One,
            key: 'item',
            relatedModel: Item,
            saveJSONFields: ['id', 'apiType']
        }]);
    },
    initialize: function initialize(data, options) {
        options = _.extend({
            item: undefined,
            seller: undefined,
            isNetPrice: false
        }, options);
        this._isNetPrice = options.isNetPrice;
        if (options.item) {
            this.setItem(options.item);
        } else if (options.seller) {
            this.setSeller(options.seller);
        }
        if (options.fromUser) {
            this.setFromUser(options.fromUser);
        }
        this.setAction(Message.MC_ACTIONS[this._isNetPrice ? 'netPrice' : 'contactDealer']);
    },
    setItem: function setItem(item) {
        this.set({
            context: this._isNetPrice ? ContactDealerMessage.context.itemNetPrice : ContactDealerMessage.context.item,
            item: item
        });
        this.setToSeller(item.get('seller'));
    },
    setSeller: function setSeller(seller) {
        this.set('context', ContactDealerMessage.context.seller);
        this.setToSeller(seller);
    },
    setFromUser: function setFromUser(user) {
        this.set('from', new ConversationMember({
            user: user.pick('id'),
            displayName: [user.get('profile.firstName') || '', user.get('profile.lastName') || ''].join(' ').trim(),
            userEmail: user.get('profile.email'),
            userType: Party.ROLE_BUYER
        }));
    },
    setToSeller: function setToSeller(seller) {
        this.set('recipients', [new MessageRecipient({
            recipientDetails: new ConversationMember({
                user: seller.pick('id'),
                displayName: seller.get('sellerProfile.company'),
                userEmail: seller.get('sellerProfile.email'),
                userType: Party.ROLE_SELLER
            })
        })]);
    },
    getFirstRecipientName: function getFirstRecipientName() {
        return this.get('recipients[0].recipientDetails.displayName');
    }
});

Object.assign(ContactDealerMessage, {
    context: {
        item: 'CONTACT_SELLER_PDP',
        itemNetPrice: 'CONTACT_SELLER_NET_PRICE',
        seller: 'CONTACT_SELLER_STOREFRONT'
    }
});

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RegexRule = __webpack_require__(85);
var RegexFieldValidation = __webpack_require__(122);
var FinancialAmount = __webpack_require__(10);
var regexRules = __webpack_require__(118);
var pick = __webpack_require__(67);

/**
 * @class LocalizedCurrencyValidation
 * @extends RegexFieldValidation
 */
var LocalizedCurrencyValidation = module.exports = RegexFieldValidation.extend({
    initialize: function initialize(options) {
        options = options || {};
        var isEur = options.currency === FinancialAmount.CURRENCY_EUR;
        this.regex = isEur ? regexRules.currencyStringEur : regexRules.currencyString;
        this.rule = new RegexRule(pick(this, 'regex', 'noMatch', 'message'));
        if (typeof options.getModelValueForField === 'function') {
            this.getModelValueForField = options.getModelValueForField;
        }
        LocalizedCurrencyValidation.__super__.initialize.call(this, options);
    }
});

/***/ }),

/***/ 2398:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Rob/Shad
 * Date: 8/16/13
 */



var SoaModel = __webpack_require__(2);
var PaymentAuthorization = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

module.exports = root.bunsen.PaymentAuthorization = PaymentAuthorization;

var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var transitionMixin = __webpack_require__(19);
var endpoints = __webpack_require__(6);
var Anchor = __webpack_require__(12);
var PaymentMethod = __webpack_require__(56);
var FinancialAmount = __webpack_require__(10);
var financialAmountMixin = __webpack_require__(48);
var PaymentProviderResponse = __webpack_require__(176);
var Review = __webpack_require__(82);

__webpack_require__(79);

_.extend(PaymentAuthorization, {
    STATUS_NEW: 'NEW',
    STATUS_AWAITING_FRAUD_SCORE: 'AWAITING_FRAUD_SCORE',
    STATUS_AWAITING_PROVIDER_RESPONSE: 'AWAITING_PROVIDER_RESPONSE',
    STATUS_PENDING_ADMIN_APPROVAL: 'PENDING_ADMIN_APPROVAL',
    STATUS_FRAUDULENT: 'FRAUDULENT',
    STATUS_AUTHORIZED: 'AUTHORIZED',
    STATUS_CAPTURED: 'CAPTURED',
    STATUS_DENIED_DATA_VALIDATION: 'DENIED_DATA_VALIDATION',
    STATUS_DENIED_PROCESSOR_ERROR: 'DENIED_PROCESSOR_ERROR',
    TIMEOUT_TRANSITION: 60000,
    PROGRESS_TRANSITION_ATTEMPTING: 'paymentAuthTransitionAttempting',
    PROGRESS_FETCHING: 'paymentAuthFetching',
    getActiveStatuses: function () {
        return [
            PaymentAuthorization.STATUS_PENDING_ADMIN_APPROVAL,
            PaymentAuthorization.STATUS_FRAUDULENT,
            PaymentAuthorization.STATUS_AUTHORIZED,
            PaymentAuthorization.STATUS_CAPTURED
        ];
    },
    getTransitioningStatuses: function () {
        return [
            PaymentAuthorization.STATUS_AWAITING_PROVIDER_RESPONSE
        ];
    },
    getDeniedStatuses: function () {
        return [
            PaymentAuthorization.STATUS_DENIED_DATA_VALIDATION,
            PaymentAuthorization.STATUS_FRAUDULENT,
            PaymentAuthorization.STATUS_DENIED_PROCESSOR_ERROR
        ];
    },
    newOfferPaymentAuthorization: function () {
        return new PaymentAuthorization({
            anchor: {
                sourceType: Anchor.TYPE_OFFER
            }
        });
    },
    newShipmentQuotePaymentAuthorization: function (shipmentQuote) {
        return new PaymentAuthorization({
            anchor: {
                sourceType: Anchor.TYPE_SHIPMENT_QUOTE,
                sourceId: shipmentQuote.id
            }
        });
    }
});

_.extend(PaymentAuthorization.prototype, {
    idAttribute: "id",
    initialize: function () {
        // set in here to work around backbone bug where url get set from parent
        this.url = function () {
            return endpoints.paymentAuthorization(this.get(this.idAttribute));
        };
    },
    relations : function () {
        return [
            {
                type: Backbone.One,
                key: 'paymentMethod',
                relatedModel: PaymentMethod,
                saveJSONFields : [
                    'apiType',
                    'id',
                    'token',
                    'nonce',
                    'cardHolderName',
                    'cardExpiryMonth',
                    'cardExpiryYear',
                    'maskedCardNumber',
                    'billingAddress',
                    'accountHolderName',
                    'confirmationNumber',
                    'transactionNumber',
                    'referenceNumber',
                    'paymentAuthorizationId'
                ]
            },
            {
                type : Backbone.One,
                key : 'transaction',
                relatedModel: SoaModel,
                saveJSONFields : ['id']
            },
            {
                type: Backbone.One,
                key: 'anchor',
                relatedModel: Anchor
            },
            {
                type: Backbone.Many,
                key: 'anchors',
                relatedModel: Anchor
            },
            {
                type: Backbone.One,
                key: 'amount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.One,
                key: 'authorizationAmount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.One,
                key: 'capturedAmount',
                relatedModel: FinancialAmount
            },
            {
                type: Backbone.Many,
                key: 'paymentProviderResponses',
                relatedModel: PaymentProviderResponse
            },
            {
                type: Backbone.Many,
                key: 'reviews',
                relatedModel: Review
            }
        ];
    },
    /**
     * Return true if the transaction is "active", means it has already been processed
     * and linked to an offer/shipmentQuote
     * @return {Boolean}
     */
    isActive: function () {
        return _.contains(PaymentAuthorization.getActiveStatuses(), this.get('status'));
    },
    isReadyForProcessing: function () {
        return this.get('status') === PaymentAuthorization.STATUS_NEW;
    },
    isAuthorized: function () {
        return this.get('status') === PaymentAuthorization.STATUS_AUTHORIZED;
    },
    isCaptured: function () {
        return this.get('status') === PaymentAuthorization.STATUS_CAPTURED;
    },
    /**
     * Return true if the transaction is "current", meaning it is actively being
     * used for checkout or balance due. Status NEW or no ID
     * and linked to an offer/shipmentQuote
     * @return {Boolean}
     */

    isCurrentCheckout: function () {
        return this.get('status') === PaymentAuthorization.STATUS_NEW || this.isNew();
    },
    /**
     * Return true if the transaction is "current", for balance due
     * and linked to a shipmentQuote
     * @return {Boolean}
     */

    isCurrentBalanceDue: function () {
        return this.isNew();
    },
    /**
     * Returns true if the payment auth has been staged by ecom and is ready
     * to be posted to braintree
     * @returns {Boolean}
     */
    isStagedPaymentAuth: function () {
        return this.has('paymentProviderStagingArgument');
    },
    isDenied: function () {
        return _.contains(PaymentAuthorization.getDeniedStatuses(), this.get('status'));
    },
    isCheckoutPaymentAuthorization: function () {
        return this.get('anchor.sourceType') === Anchor.TYPE_OFFER;
    },
    isOfferPaymentAuthorization: function () {
        return this.isCheckoutPaymentAuthorization();
    },
    isBalanceDuePaymentAuthorization: function () {
        return this.get('anchor.sourceType') === Anchor.TYPE_SHIPMENT_QUOTE;
    },
    isShippingPaymentAuthorization: function () {
        return this.isBalanceDuePaymentAuthorization();
    },
    isWireTransfer: function () {
        return this.get('paymentMethod').isWireTransfer();
    },
    getBraintreeIdReserve: function () {
        return this.get('paymentProviderTransactionId');
    },
    getAmount: function (currency) {
        return this._getFinancialAmount('amount', currency);
    },
    getCapturedAmount: function (currency) {
        return this._getFinancialAmount('capturedAmount', currency);
    },
    getAuthorizationAmount: function (currency) {
        return this._getFinancialAmount('authorizationAmount', currency);
    },
    getCardType: function () {
        var paymentMethod = this.get('paymentMethod');
        var maskedCardNumber = paymentMethod && paymentMethod.get('maskedCardNumber');
        return maskedCardNumber && $.payment.cardType(maskedCardNumber);
    },
    autoCapture: function () {
        this.set('autoCapture', 'Y');
        return this.updateAndTransition(PaymentAuthorization.STATUS_CAPTURED);
    },
    hasAutoCaptureFailed: function () {
        var responses = this.get('paymentProviderResponses');
        if (!responses) {
            return false;
        }
        return responses.some(function (model) {
            return model.isVaultTransaction() && !model.isSuccess();
        });
    },
    hasPaymentDeclined: function() {
        return !!this.getPaymentReview();
    },
    getPaymentReview: function () {
        var reviews = this.get('reviews');
        if (!reviews) {
            return false;
        }

        return reviews.find(function(review) {
            return review.isPending() && review.isPaymentDeclined();
        });
    },
    getFraudReview: function () {
        var reviews = this.get('reviews');
        if (!reviews) {
            return false;
        }

        return reviews.find(function(review) {
            return review.isPending() && review.isFraud();
        });

    }
}, transitionMixin, financialAmountMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 240:
/***/ (function(module, exports) {

/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is in `cache` mimicking the return signature of
 * `_.indexOf` by returning `0` if the value is found, else `-1`.
 *
 * @private
 * @param {Object} cache The cache to search.
 * @param {*} value The value to search for.
 * @returns {number} Returns `0` if `value` is found, else `-1`.
 */
function cacheIndexOf(cache, value) {
  var data = cache.data,
      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

  return result ? 0 : -1;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = cacheIndexOf;


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var getNative = __webpack_require__(327);

/** Native method references. */
var Set = getNative(global, 'Set');

/* Native method references for those with the same name as other `lodash` methods. */
var nativeCreate = getNative(Object, 'create');

/**
 *
 * Creates a cache object to store unique values.
 *
 * @private
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var length = values ? values.length : 0;

  this.data = { 'hash': nativeCreate(null), 'set': new Set };
  while (length--) {
    this.push(values[length]);
  }
}

/**
 * Adds `value` to the cache.
 *
 * @private
 * @name push
 * @memberOf SetCache
 * @param {*} value The value to cache.
 */
function cachePush(value) {
  var data = this.data;
  if (typeof value == 'string' || isObject(value)) {
    data.set.add(value);
  } else {
    data.hash[value] = true;
  }
}

/**
 * Creates a `Set` cache object to optimize linear searches of large arrays.
 *
 * @private
 * @param {Array} [values] The values to cache.
 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
 */
function createCache(values) {
  return (nativeCreate && Set) ? new SetCache(values) : null;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

// Add functions to the `Set` cache.
SetCache.prototype.push = cachePush;

module.exports = createCache;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 242:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an object that inherits from the `prototype` object. If a
 * `properties` object is given, its own enumerable string keyed properties
 * are assigned to the created object.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Object
 * @param {Object} prototype The object to inherit from.
 * @param {Object} [properties] The properties to assign to the object.
 * @returns {Object} Returns the new object.
 * @example
 *
 * function Shape() {
 *   this.x = 0;
 *   this.y = 0;
 * }
 *
 * function Circle() {
 *   Shape.call(this);
 * }
 *
 * Circle.prototype = _.create(Shape.prototype, {
 *   'constructor': Circle
 * });
 *
 * var circle = new Circle;
 * circle instanceof Circle;
 * // => true
 *
 * circle instanceof Shape;
 * // => true
 */
function create(prototype, properties) {
  var result = baseCreate(prototype);
  return properties ? baseAssign(result, properties) : result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = create;


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 4.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseFor = __webpack_require__(130),
    keys = __webpack_require__(245);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite property
 * assignments of previous values.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  result[value] = key;
}, constant(identity));

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var object = { 'user': 'fred' };
 * var getter = _.constant(object);
 *
 * getter() === object;
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument given to it.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = invert;


/***/ }),

/***/ 2448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(39);

var User = __webpack_require__(15);
var enabler = __webpack_require__(64);
var abExperiments = __webpack_require__(500);

var _require = __webpack_require__(2177),
    ResponsiveHero = _require.ResponsiveHero,
    ResponsiveCollection = _require.ResponsiveCollection;

var personalizationHelpers = __webpack_require__(3650);
var introductionHelper = __webpack_require__(3384);
var tradeWelcomeMessageHelper = __webpack_require__(765);
var tracking = __webpack_require__(1139);

exports.init = function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var data = options.data,
        context = options.context;


    tracking.init({ data: data });

    // Hero carousel
    if (data.heroItems) {
        var flattenItems = data.heroItems.map(function (a) {
            return a.items;
        }).reduce(function (a, b) {
            return a.concat(b);
        }, []);

        ReactDOM.render(React.createElement(ResponsiveHero, {
            items: flattenItems
        }), document.querySelector('.js-hero-carousel'));
    }

    // Collections carousel
    if (data.collectionItems) {
        ReactDOM.render(React.createElement(ResponsiveCollection, {
            items: data.collectionItems
        }), document.querySelector('.js-collections-carousel'));
    }

    // Personalization
    var personalizationCarouselContainer = document.querySelector('.js-personalization-container');
    var carouselOptions = {
        context: context,
        container: personalizationCarouselContainer
    };

    if (personalizationCarouselContainer) {
        if (abExperiments.homePageRecommendations) {
            abExperiments.homePageRecommendations.then(function () {
                personalizationHelpers.render(Object.assign({
                    dataKeys: [personalizationHelpers.ATTRIBUTE_KEY, personalizationHelpers.CATEGORY_KEY],
                    categoryLevels: 3
                }, carouselOptions));
            }).catch(function () {
                personalizationHelpers.render(carouselOptions);
            });

            setTimeout(function () {
                abExperiments.homePageRecommendations.reject();
            }, 800);
        } else {
            personalizationHelpers.render(carouselOptions);
        }

        User.getCurrentUser().once('login:change', function () {
            return personalizationHelpers.render(carouselOptions);
        });
    }

    // Trade welcome message
    tradeWelcomeMessageHelper.initWelcomeMessage(options.context);

    // Initialize introduction banner
    introductionHelper.init({
        context: options.context,
        isEnabled: enabler.isEnabled('brand_introduction')
    });
};

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    result++;
  }
  return result;
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

module.exports = size;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var root = __webpack_require__(282);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = Symbol ? symbolProto.toString : undefined;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (value == null) {
    return '';
  }
  if (isSymbol(value)) {
    return Symbol ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Generates a unique ID. If `prefix` is provided the ID is appended to it.
 *
 * @static
 * @memberOf _
 * @category Util
 * @param {string} [prefix] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var isArray = __webpack_require__(65);

/**
 * Creates an object composed from arrays of property names and values. Provide
 * either a single two dimensional array, e.g. `[[key1, value1], [key2, value2]]`
 * or two arrays, one of property names and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @alias object
 * @category Array
 * @param {Array} props The property names.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['fred', 'barney'], [30, 40]);
 * // => { 'fred': 30, 'barney': 40 }
 */
function zipObject(props, values) {
  var index = -1,
      length = props ? props.length : 0,
      result = {};

  if (length && !values && !isArray(props[0])) {
    values = [];
  }
  while (++index < length) {
    var key = props[index];
    if (values) {
      result[key] = values[index];
    } else if (key) {
      result[key[0]] = key[1];
    }
  }
  return result;
}

module.exports = zipObject;


/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var TemplateView; // required after export is defined to avoid circular dependency
var result = __webpack_require__(251);
var assign = __webpack_require__(250);
var View = __webpack_require__(93).View;
var normalizeToView = module.exports = function (options) {
    if (!global.HTMLElement) {
        throw new Error('normalize-to-view expects global.HTMLElement');
    }
    // TODO: test this
    var view;
    var constructorOptions;
    var defaultParentElement;
    var newContent;
    var useDefaultParentElement;
    if (undefined === options.content && !options.Constructor) {
        throw new Error("normalizeToView requires options.Constructor if options.content is missing");
    }
    options = assign({
        defaultParentElement: undefined,
        defaultContext: undefined,
        defaultTemplateVars: undefined,
        content: undefined,
        Constructor: TemplateView
    }, options);
    if (false === options.content) {
        return false;
    }
    if (options.content && options.content.jquery) {
        options.content = options.content.get(0);
        view = new View({el: options.content});
    }
    // content can't be jQuery below this line
    if (options.content instanceof global.HTMLElement) {
        view = new View({el: options.content});
    }
    if (options.content && options.content.hasOwnProperty('el')) { // assume it's a backbone-style view if it has an `el` property
        view = options.content;
    }
    if (options.content instanceof Function) {
        defaultParentElement = undefined;
        if (options.defaultParentElement) {
            defaultParentElement = options.defaultParentElement;
        }
        newContent = options.content.call(options.defaultContext, defaultParentElement);
        if (!newContent) {
            return newContent;
        }
        view = normalizeToView(assign({}, options, {content: newContent}));
    }
    if (!view && options.Constructor) {
        constructorOptions = options.content;
        useDefaultParentElement = true;
        if (options.Constructor && result(options.Constructor.prototype.template, 'useInnerElement')) {
            useDefaultParentElement = false;
        }
        if (result(constructorOptions, 'useInnerElement')) {
            useDefaultParentElement = false;
        }
        if (useDefaultParentElement) {
            constructorOptions = assign({el: options.defaultParentElement}, constructorOptions);
        }
        if (
            options.Constructor.prototype.templateVars === TemplateView.prototype.templateVars &&
            !constructorOptions.templateVars && !constructorOptions.model
        ) {
            constructorOptions = assign({templateVars: options.defaultTemplateVars}, constructorOptions);
        }
        view = new options.Constructor(constructorOptions);
    }
    return view;
};
TemplateView = __webpack_require__(77);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: ronald
 * Date: 1/7/13
 * Time: 7:10 PM
 */


var qs = __webpack_require__(41);
var SoaModel = __webpack_require__(2);
var Offer = SoaModel.extend({}, {
    DisplayOfferStatus: {
        expired: 'expired',
        canceledNoLongerInterested: 'canceledNoLongerInterested',
        canceledPassed: 'canceledPassed',
        canceledOther: 'canceledOther',
        dealerCountered: 'dealerCountered',
        buyerCountered: 'buyerCountered',
        newBuyerOfferWithoutReserve: 'newBuyerOfferWithoutReserve',
        newBuyerOfferWithReserve: 'newBuyerOfferWithReserve',
        newDealerOffer: 'newDealerOffer',
        dealerAccepted: 'dealerAccepted',
        newOrder: 'newOrder',
        newOrderManualReview: 'newOrderManualReview',
        requestedOffer: 'requestedOffer'
    },
    STATUS_AMENDED: 'AMENDED',
    STATUS_SUBMITTED: 'SUBMITTED',
    STATUS_ACCEPTED: 'ACCEPTED',
    STATUS_COUNTERED: 'COUNTERED',
    STATUS_EXPIRED: 'EXPIRED',
    STATUS_NEW: 'NEW',
    STATUS_CANCELED: 'CANCELED',
    STATUS_REQUESTED: 'REQUESTED'
});
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

// Attaching to bunsen until bOMT and checkout are commonJS
module.exports = root.bunsen.Offer = Offer;

var SoaCollection = __webpack_require__(9);
var endpoints = __webpack_require__(6);
var AdjustmentList = __webpack_require__(55);
var Transaction = __webpack_require__(20);
var Notes = __webpack_require__(23);
var Note = __webpack_require__(33);
var Party = __webpack_require__(8);
var Anchor = __webpack_require__(12);
var PaymentAuthorization = __webpack_require__(24);
var Backbone = __webpack_require__(3);
var transitionMixin = __webpack_require__(19);
var financialAmountMixin = __webpack_require__(48);
var Clump = __webpack_require__(22);
var Period = __webpack_require__(117);
var $ = __webpack_require__(5);
var _ = __webpack_require__(0);
var FinancialAmount = __webpack_require__(10);
var Action = __webpack_require__(51);
var uri = __webpack_require__(138);

_.extend(Offer.prototype, {
    offerDisplayStatus: function offerDisplayStatus(options) {
        options = _.defaults({}, options, {
            transaction: this.get('transaction')
        });
        var _options = options,
            transaction = _options.transaction;


        if (transaction.isCanceled()) {
            switch (transaction.get('cancellationReason')) {
                case Transaction.CANCELLATION_REASON_BUYER_NO_LONGER_INTERESTED_PRE_CHECKOUT:
                    return Offer.DisplayOfferStatus.canceledNoLongerInterested;
                case Transaction.CANCELLATION_REASON_BUYER_PASSED_ON_OFFER_PRE_CHECKOUT:
                    return Offer.DisplayOfferStatus.canceledPassed;
                case Transaction.CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_DEALER_INACTION:
                case Transaction.CANCELLATION_REASON_OFFER_EXPIRED_PRE_CHECKOUT_BUYER_INACTION:
                    return Offer.DisplayOfferStatus.expired;
                default:
                    return Offer.DisplayOfferStatus.canceledOther;
            }
        }
        if (transaction.isAwaitingManualReview()) {
            return Offer.DisplayOfferStatus.newOrderManualReview;
        }
        if (transaction.isFullPriceOrder()) {
            return Offer.DisplayOfferStatus.newOrder;
        }
        if (transaction.isBuyerOfferWithReserve()) {
            return Offer.DisplayOfferStatus.newBuyerOfferWithReserve;
        }
        switch (this.get('status')) {
            case Offer.STATUS_SUBMITTED:
                // countered offers
                if (transaction.isMostRecentlyDealerCountered()) {
                    return Offer.DisplayOfferStatus.dealerCountered;
                } else if (transaction.isMostRecentlyBuyerCountered()) {
                    return Offer.DisplayOfferStatus.buyerCountered;
                    // new offers
                } else if (this.isBuyerInitiatedOffer()) {
                    return Offer.DisplayOfferStatus.newBuyerOfferWithoutReserve;
                } else {
                    return Offer.DisplayOfferStatus.newDealerOffer;
                }
            case Offer.STATUS_ACCEPTED:
                if (transaction.hasAction(Action.CODE_BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER)) {
                    return Offer.DisplayOfferStatus.dealerAccepted;
                } else {
                    return Offer.DisplayOfferStatus.newOrder;
                }
            case Offer.STATUS_REQUESTED:
                return Offer.DisplayOfferStatus.requestedOffer;
        }
    },
    isUserComesFromAmpPage: function isUserComesFromAmpPage() {
        var params = qs.parse(document.location.search.substr(1));
        return _.has(params, 'userComesFromAmp') && params.userComesFromAmp === 'true';
    },
    redirectToCheckout: function redirectToCheckout() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _options2 = options,
            item = _options2.item;


        if (!item) {
            throw new Error('options.item required for redirectToCheckout');
        }

        options = Object.assign({
            offerAmount: this.get('amountPerItem.amount'),
            offerCurrency: this.get('amountPerItem.currency'),
            quantity: this.get('quantity'),
            chkIncludeOffer: true
        }, options);

        if (this.isUserComesFromAmpPage()) {
            options.userComesFromAmp = true;
        }

        // we are not passing the item itself
        delete options.item;

        var params = qs.stringify(options);
        var url = '/checkout' + item.getPDPURL(false) + '?' + params;

        uri.redirect({ url: url });
    },

    /**
     * @deprecated since .COM version 56.
     * We don't ever want to POST to checkout any more. We should always use a GET with query params.
     * Use offer.redirectToCheckout instead.
     */
    postToCheckout: function postToCheckout(options) {
        console.warn("Calling deprecated function! Use redirectToCheckout instead.");
        this.redirectToCheckout(options);
    },
    idAttribute: "id",
    /**
     * @memberof bunsen.Offer
     * @returns {string}
     */
    url: function url() {
        return endpoints.offer(this.get(this.idAttribute));
    },
    defaults: {
        amountPerItem: {},
        subTotalAmount: {},
        quantity: 1,
        notes: [],
        transaction: {}
    },
    relations: function relations() {
        return [{
            type: Backbone.One,
            key: 'item',
            relatedModel: SoaModel,
            collectionType: SoaCollection
        }, {
            type: Backbone.One,
            key: 'transaction',
            relatedModel: Transaction,
            saveJSONFields: ['id']
        }, {
            type: Backbone.One,
            key: 'adjustments',
            relatedModel: AdjustmentList,
            collectionType: SoaCollection
        }, {
            type: Backbone.Many,
            key: 'notes',
            collectionType: Notes
        }, {
            type: Backbone.One,
            key: 'paymentAuthorization',
            relatedModel: PaymentAuthorization,
            collectionType: SoaCollection
        }, {
            type: Backbone.One,
            key: 'initiatingParty',
            relatedModel: Party
        }, {
            type: Backbone.One,
            key: 'counterParty',
            relatedModel: Party
        }, {
            type: Backbone.One,
            key: 'amountPerItem',
            relatedModel: FinancialAmount
        }, {
            type: Backbone.One,
            key: 'subTotalAmount',
            relatedModel: FinancialAmount
        }, {
            type: Backbone.One,
            key: 'totalAmount',
            relatedModel: FinancialAmount
        }, {
            type: Backbone.One,
            key: 'expirationPeriod',
            relatedModel: Period
        }];
    },
    getQuantity: function getQuantity() {
        return Number(this.get('quantity'));
    },
    getSellerId: function getSellerId() {
        if (this.isDealerInitiatedOffer()) {
            return this.get('initiatingParty').id;
        } else {
            return this.get('counterParty').id;
        }
    },
    getInitiatingPartyRole: function getInitiatingPartyRole() {
        return this.get('initiatingParty').getRole();
    },
    getCounterPartyRole: function getCounterPartyRole() {
        return this.get('counterParty').getRole();
    },
    isBuyerInitiatedOffer: function isBuyerInitiatedOffer() {
        return this.get('initiatingParty').isBuyer();
    },
    isDealerInitiatedOffer: function isDealerInitiatedOffer() {
        return this.get('initiatingParty').isSeller();
    },
    isAccepted: function isAccepted() {
        return Offer.STATUS_ACCEPTED === this.get('status');
    },
    isSubmitted: function isSubmitted() {
        return this.get('status') === Offer.STATUS_SUBMITTED;
    },
    isExpired: function isExpired() {
        return this.get('status') === Offer.STATUS_EXPIRED;
    },
    isNewStatus: function isNewStatus() {
        return this.get('status') === Offer.STATUS_NEW;
    },
    isCanceled: function isCanceled() {
        return this.get('status') === Offer.STATUS_CANCELED;
    },
    isRequested: function isRequested() {
        return this.get('status') === Offer.STATUS_REQUESTED;
    },
    getTaxAmount: function getTaxAmount(currency) {
        var adjustments = this.get('adjustments');
        if (adjustments) {
            return adjustments.getMerchTaxTotal(currency);
        }
        return 0;
    },
    hasTax: function hasTax() {
        return this.getTaxAmount(FinancialAmount.CURRENCY_USD) > 0;
    },
    /**
     * Creates a new empty counter offer from this offer,
     * (same item, roles reversed, amounts emptied)
     */
    newCounterOffer: function newCounterOffer() {
        var offer = new Offer({
            transaction: {
                id: this.get('transaction.id')
            },
            quantity: this.get('quantity'),
            counterParty: {
                id: this.get('initiatingParty.id'),
                role: this.getInitiatingPartyRole()
            },
            initiatingParty: {
                id: this.get('counterParty.id'),
                role: this.getCounterPartyRole()
            },
            amountPerItem: this.get('amountPerItem').toJSON(),
            subTotalAmount: {
                amount: this.get('amountPerItem.amount') * this.get('quantity'),
                currency: this.get('amountPerItem.currency')
            }
        });
        return offer;
    },
    newAmendedOffer: function newAmendedOffer() {
        var offer = this.clone();
        _.each(['id', 'status', 'createdDate', 'expirationDate', 'expiredDate', 'modifiedDate'], offer.unset.bind(offer));
        return offer;
    },
    accept: function accept(passedOptions) {
        return this.transition(Offer.STATUS_ACCEPTED, passedOptions);
    },
    counter: function counter(counterOffer, passedOptions) {
        var options = passedOptions || {};
        _.extend(options, {
            queries: counterOffer._getCounterOfferQueryParams()
        });
        return this.transition(Offer.STATUS_COUNTERED, options);
    },
    _getCounterOfferQueryParams: function _getCounterOfferQueryParams() {
        return {
            counterOfferAmount: this.get('amountPerItem.amount'),
            counterOfferCurrency: this.get('amountPerItem.currency')
        };
    },
    _actOnOffer: function _actOnOffer(role, counterOffer, passedOptions) {
        var options = void 0;
        var dynaOptions = void 0;
        var clump = new Clump();
        var saves = void 0;

        if (!!passedOptions && passedOptions.noteContent) {
            dynaOptions = {
                "open": "___",
                "close": "___",
                "params": {
                    counterOfferId: {
                        clumpElement: "counterOffer",
                        expression: "$.result.counterOfferId"
                    }
                }
            };
        }

        // If no counter offer, accept this offer
        if (!counterOffer) {
            return this.accept();
        }

        options = _.extend({}, passedOptions || {}, {
            counterOffer: counterOffer,
            noteRole: role
        });
        saves = this.clumpCounterOfferNote(clump, options);
        clump.run({ dynaOptions: dynaOptions });
        return $.when.apply($, saves);
    },
    /**
     * Accepts or counters an offer, will add note to counter
     * @param [counterOffer] - will accept the offer if this is null
     * @param [passedOptions]
     * @returns {*}
     */
    dealerActOnOffer: function dealerActOnOffer(counterOffer, passedOptions) {
        return this._actOnOffer(Party.ROLE_SELLER, counterOffer, passedOptions);
    },
    buyerActOnOffer: function buyerActOnOffer(counterOffer, passedOptions) {
        return this._actOnOffer(Party.ROLE_BUYER, counterOffer, passedOptions);
    },
    /**
     * Pass in a clump instance and it will counter the offer and create the note on it.
     * Add more stuff with the same clump and run it later.
     * @param clump
     * @param passedOptions
     * @returns {Array}
     */
    clumpCounterOfferNote: function clumpCounterOfferNote(clump, passedOptions) {
        var note = void 0;
        var saves = [];
        var options = passedOptions || {};
        saves.push(this.counter(options.counterOffer, {
            clump: clump,
            clumpName: 'counterOffer'
        }));

        if (options.noteContent) {
            note = options.counterOffer.newBuyerSellerNote({
                content: options.noteContent,
                role: options.noteRole
            });
            note.setAnchorId('OFFER', "___counterOfferId___");
            saves.push(note.save(null, { clump: clump }));
        }
        return saves;
    },
    newBuyerSellerNote: function newBuyerSellerNote(passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            type: Note.TYPE_BUYER_SELLER
        });
        return this.newNote(options);
    },
    newNote: function newNote(passedOptions) {
        var options = _.defaults(passedOptions, {
            anchors: [{
                sourceId: this.get('transaction').id,
                sourceType: Anchor.TYPE_TRANSACTION
            }, {
                sourceId: this.getSellerId(),
                sourceType: Anchor.TYPE_SELLER
            }, {
                sourceId: this.id,
                sourceType: Anchor.TYPE_OFFER
            }]
        });
        return this.get('notes').newNote(options);
    },
    addNewNote: function addNewNote(noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },
    getAmountPerItem: function getAmountPerItem(currency) {
        return this._getFinancialAmount('amountPerItem', currency);
    },
    getAcceptedDate: function getAcceptedDate() {
        var unixDate = this.get('acceptedDate');
        var acceptedDate = new Date(unixDate);
        return acceptedDate.getMonth() + 1 + '-' + acceptedDate.getFullYear();
    }
}, transitionMixin, financialAmountMixin);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    object = undefined;
    length = 1;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

module.exports = result;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),

/***/ 253:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _([1, 2]).forEach(function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, typeof iteratee == 'function' ? iteratee : identity);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forEach;


/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = baseRest(function(object, props) {
  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
});

module.exports = pick;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    object = undefined;
    length = 1;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

module.exports = result;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    stringTag = '[object String]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetPrototype = Object.getPrototypeOf,
    nativeKeys = Object.keys;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
  // that are composed entirely of index properties, return `false` for
  // `hasOwnProperty` checks of them.
  return hasOwnProperty.call(object, key) ||
    (typeof object == 'object' && key in object && getPrototype(object) === null);
}

/**
 * The base implementation of `_.keys` which doesn't skip the constructor
 * property of prototypes or treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  return nativeKeys(Object(object));
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a
 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
 * Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Gets the `[[Prototype]]` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {null|Object} Returns the `[[Prototype]]`.
 */
function getPrototype(value) {
  return nativeGetPrototype(Object(value));
}

/**
 * Creates an array of index keys for `object` values of arrays,
 * `arguments` objects, and strings, otherwise `null` is returned.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array|null} Returns index keys, else `null`.
 */
function indexKeys(object) {
  var length = object ? object.length : undefined;
  if (isLength(length) &&
      (isArray(object) || isString(object) || isArguments(object))) {
    return baseTimes(length, String);
  }
  return null;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  var isProto = isPrototype(object);
  if (!(isProto || isArrayLike(object))) {
    return baseKeys(object);
  }
  var indexes = indexKeys(object),
      skipIndexes = !!indexes,
      result = indexes || [],
      length = result.length;

  for (var key in object) {
    if (baseHas(object, key) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
        !(isProto && key == 'constructor')) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseEach;


/***/ }),

/***/ 258:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),

/***/ 259:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _([1, 2]).forEach(function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, typeof iteratee == 'function' ? iteratee : identity);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = forEach;


/***/ }),

/***/ 260:
/***/ (function(module, exports) {

/**
 * lodash 4.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 4.2.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var baseEach = __webpack_require__(257),
    baseIteratee = __webpack_require__(309);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty('length');

/**
 * Creates an array of values by running each element in `collection` through
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `curry`, `curryRight`, `drop`, `dropRight`, `every`, `fill`,
 * `invert`, `parseInt`, `random`, `range`, `rangeRight`, `slice`, `some`,
 * `sortBy`, `take`, `takeRight`, `template`, `trim`, `trimEnd`, `trimStart`,
 * and `words`
 *
 * @static
 * @memberOf _
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type {Function}
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(getLength(value)) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array and weak map constructors,
  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

module.exports = map;


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for comparison styles. */
var UNORDERED_COMPARE_FLAG = 1,
    PARTIAL_COMPARE_FLAG = 2;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, customizer, bitmask, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = arrayTag,
      othTag = arrayTag;

  if (!objIsArr) {
    objTag = getTag(object);
    objTag = objTag == argsTag ? objectTag : objTag;
  }
  if (!othIsArr) {
    othTag = getTag(other);
    othTag = othTag == argsTag ? objectTag : othTag;
  }
  var objIsObj = objTag == objectTag && !isHostObject(object),
      othIsObj = othTag == objectTag && !isHostObject(other),
      isSameTag = objTag == othTag;

  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
  }
  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!seen.has(othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
              return seen.add(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, customizer, bitmask, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= UNORDERED_COMPARE_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
      objProps = keys(object),
      objLength = objProps.length,
      othProps = keys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = isKey(path, object) ? [path] : castPath(path);

  var result,
      index = -1,
      length = path.length;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result) {
    return result;
  }
  var length = object ? object.length : 0;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    result[key] = iteratee(value, key, object);
  });
  return result;
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = mapValues;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(70)(module)))

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    object = undefined;
    length = 1;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

module.exports = result;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 264:
/***/ (function(module, exports) {


exports = module.exports = trim;

function trim(str){
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function(str){
  return str.replace(/^\s*/, '');
};

exports.right = function(str){
  return str.replace(/\s*$/, '');
};


/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
  // Moderately fast, high quality
  var _rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(_rnds8);
    return _rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  _rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return _rnds;
  };
}

module.exports = rng;


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var _rng = __webpack_require__(265);

// Maps for number <-> hex string conversion
var _byteToHex = [];
var _hexToByte = {};
for (var i = 0; i < 256; i++) {
  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
  _hexToByte[_byteToHex[i]] = i;
}

// **`parse()` - Parse a UUID into it's component bytes**
function parse(s, buf, offset) {
  var i = (buf && offset) || 0, ii = 0;

  buf = buf || [];
  s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
    if (ii < 16) { // Don't overflow!
      buf[i + ii++] = _hexToByte[oct];
    }
  });

  // Zero out remaining bytes if string was short
  while (ii < 16) {
    buf[i + ii++] = 0;
  }

  return buf;
}

// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
function unparse(buf, offset) {
  var i = offset || 0, bth = _byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = _rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; n++) {
    b[i + n] = node[n];
  }

  return buf ? buf : unparse(b);
}

// **`v4()` - Generate random UUID**

// See https://github.com/broofa/node-uuid for API details
function v4(options, buf, offset) {
  // Deprecated - 'format' argument, as supported in v1.2
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || _rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ii++) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || unparse(rnds);
}

// Export public API
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
uuid.parse = parse;
uuid.unparse = unparse;

module.exports = uuid;


/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46).Buffer))

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>
	Doctype: "doctype",

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};


/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

var Parser = __webpack_require__(350),
    DomHandler = __webpack_require__(424);

function defineProp(name, value){
	delete module.exports[name];
	module.exports[name] = value;
	return value;
}

module.exports = {
	Parser: Parser,
	Tokenizer: __webpack_require__(351),
	ElementType: __webpack_require__(270),
	DomHandler: DomHandler,
	get FeedHandler(){
		return defineProp("FeedHandler", __webpack_require__(421));
	},
	get Stream(){
		return defineProp("Stream", __webpack_require__(423));
	},
	get WritableStream(){
		return defineProp("WritableStream", __webpack_require__(352));
	},
	get ProxyHandler(){
		return defineProp("ProxyHandler", __webpack_require__(422));
	},
	get DomUtils(){
		return defineProp("DomUtils", __webpack_require__(426));
	},
	get CollectingHandler(){
		return defineProp("CollectingHandler", __webpack_require__(420));
	},
	// For legacy support
	DefaultHandler: DomHandler,
	get RssHandler(){
		return defineProp("RssHandler", this.FeedHandler);
	},
	//helper methods
	parseDOM: function(data, options){
		var handler = new DomHandler(options);
		new Parser(handler, options).end(data);
		return handler.dom;
	},
	parseFeed: function(feed, options){
		var handler = new module.exports.FeedHandler(options);
		new Parser(handler, options).end(feed);
		return handler.dom;
	},
	createDomStream: function(cb, options, elementCb){
		var handler = new DomHandler(cb, options, elementCb);
		return new Parser(handler, options);
	},
	// List of all events that the parser emits
	EVENTS: { /* Format: eventname: number of arguments */
		attribute: 2,
		cdatastart: 0,
		cdataend: 0,
		text: 1,
		processinginstruction: 2,
		comment: 1,
		commentend: 0,
		closetag: 1,
		opentag: 2,
		opentagname: 1,
		error: 1,
		end: 0
	}
};


/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(71),
    noop = _require.noop;

// Type of touch.
// NOTE: Currently doesn't distinguish touch types greater than 2. If needed we can add TRIPE, QUADRUPLE, etc.


var TOUCH_TYPE_SINGLE = 'single';
var TOUCH_TYPE_DOUBLE = 'double';
var TOUCH_TYPE_MANY = 'many';

/**
 * Utility class To handle multi-touch detection. Pass an element in and it allow you to attach handlers for multi-touch.
 * Instances need to be destroyed when tracking is no longer needed.
 *
 * @param  {Object}  options.el Element to track.
 * @param  {Function}  [options.onSingleTouchStart] Callback to fire on single touch start.
 * @param  {Function}  [options.onSingleTouchMove] Callback to fire on single touch move.
 * @param  {Function}  [options.onSingleTouchEnd] Callback to fire on single touch end.
 * @param  {Function}  [options.onDoubleTouchStart] Callback to fire on double touch start.
 * @param  {Function}  [options.onDoubleTouchMove] Callback to fire on double touch move.
 * @param  {Function}  [options.onDoubleTouchEnd] Callback to fire on double touch end.
 * @param  {Function}  [options.onManyTouchStart] Callback to fire on many touch start.
 * @param  {Function}  [options.onManyTouchMove] Callback to fire on many touch move.
 * @param  {Function}  [options.onManyTouchEnd] Callback to fire on many touch end.
 */

var MultiTouchDetector = function () {
    function MultiTouchDetector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el,
            _ref$onSingleTouchSta = _ref.onSingleTouchStart,
            onSingleTouchStart = _ref$onSingleTouchSta === undefined ? noop : _ref$onSingleTouchSta,
            _ref$onSingleTouchMov = _ref.onSingleTouchMove,
            onSingleTouchMove = _ref$onSingleTouchMov === undefined ? noop : _ref$onSingleTouchMov,
            _ref$onSingleTouchEnd = _ref.onSingleTouchEnd,
            onSingleTouchEnd = _ref$onSingleTouchEnd === undefined ? noop : _ref$onSingleTouchEnd,
            _ref$onDoubleTouchSta = _ref.onDoubleTouchStart,
            onDoubleTouchStart = _ref$onDoubleTouchSta === undefined ? noop : _ref$onDoubleTouchSta,
            _ref$onDoubleTouchMov = _ref.onDoubleTouchMove,
            onDoubleTouchMove = _ref$onDoubleTouchMov === undefined ? noop : _ref$onDoubleTouchMov,
            _ref$onDoubleTouchEnd = _ref.onDoubleTouchEnd,
            onDoubleTouchEnd = _ref$onDoubleTouchEnd === undefined ? noop : _ref$onDoubleTouchEnd,
            _ref$onManyTouchStart = _ref.onManyTouchStart,
            onManyTouchStart = _ref$onManyTouchStart === undefined ? noop : _ref$onManyTouchStart,
            _ref$onManyTouchMove = _ref.onManyTouchMove,
            onManyTouchMove = _ref$onManyTouchMove === undefined ? noop : _ref$onManyTouchMove,
            _ref$onManyTouchEnd = _ref.onManyTouchEnd,
            onManyTouchEnd = _ref$onManyTouchEnd === undefined ? noop : _ref$onManyTouchEnd;

        _classCallCheck(this, MultiTouchDetector);

        if (!el) {
            throw new Error('Must pass `el` to MultiTouchDetector');
        }

        Object.assign(this, {
            _type: null,
            _el: el,
            _onSingleTouchStart: onSingleTouchStart,
            _onSingleTouchMove: onSingleTouchMove,
            _onSingleTouchEnd: onSingleTouchEnd,
            _onDoubleTouchStart: onDoubleTouchStart,
            _onDoubleTouchMove: onDoubleTouchMove,
            _onDoubleTouchEnd: onDoubleTouchEnd,
            _onManyTouchStart: onManyTouchStart,
            _onManyTouchMove: onManyTouchMove,
            _onManyTouchEnd: onManyTouchEnd,
            _onTouchStart: this._onTouchStart.bind(this),
            _onTouchMove: this._onTouchMove.bind(this),
            _onTouchEnd: this._onTouchEnd.bind(this)
        });

        this._el.addEventListener('touchstart', this._onTouchStart);
        this._el.addEventListener('touchmove', this._onTouchMove);
        this._el.addEventListener('touchend', this._onTouchEnd);
    }

    _createClass(MultiTouchDetector, [{
        key: 'destroy',
        value: function destroy() {
            this._el.removeEventListener('touchstart', this._onTouchStart);
            this._el.removeEventListener('touchmove', this._onTouchMove);
            this._el.removeEventListener('touchend', this._onTouchEnd);
        }
    }, {
        key: '_onTouchStart',
        value: function _onTouchStart(e) {
            var touches = e.touches;

            // If we've gone to many touch...

            if (touches.length > 2) {
                // if we were on double, end it.
                this._conditionalEndDouble(e);

                // if we were on single, end it.
                this._conditionalEndSingle(e);

                // if we're not already on many, go to many.
                this._conditionalStartMany(e);
                return;
            }

            // If we've gone to double...
            if (touches.length === 2) {
                // if we were on single, end it.
                this._conditionalEndSingle(e);

                // go to double.
                this._conditionalStartDouble(e);
                return;
            }

            // If we've gone to single...
            // go go to single.
            this._conditionalStartSingle(e);
        }
    }, {
        key: '_onTouchMove',
        value: function _onTouchMove(e) {
            if (this.isMany()) {
                this._onManyTouchMove(e);
                return;
            }

            if (this.isDouble()) {
                this._onDoubleTouchMove(e);
                return;
            }

            if (this.isSingle()) {
                this._onSingleTouchMove(e);
            }
        }
    }, {
        key: '_onTouchEnd',
        value: function _onTouchEnd(e) {
            var touches = e.touches;

            // If we're still on many touch, we'll just ignore the change.

            if (touches.length > 2) {
                return;
            }

            // If we've gone down to only 2 touches...
            if (touches.length === 2) {
                // if we were on many, end it.
                this._conditionalEndMany(e);

                // restart double.
                this._conditionalStartDouble(e);
                return;
            }

            // If we've gone down to 1 touch...
            if (touches.length === 1) {
                // if we were on many, end it.
                this._conditionalEndMany(e);

                // if we were on double, end it.
                this._conditionalEndDouble(e);

                // restart single.
                this._conditionalStartSingle(e);
                return;
            }

            // If we've removed all touches...
            // if we were on many, end it.
            this._conditionalEndMany(e);

            // if we were on double, end it.
            this._conditionalEndDouble(e);

            // if we were on single, end it.
            this._conditionalEndSingle(e);
            this._type = null;
        }
    }, {
        key: 'isSingle',
        value: function isSingle() {
            return this._type === TOUCH_TYPE_SINGLE;
        }
    }, {
        key: 'isDouble',
        value: function isDouble() {
            return this._type === TOUCH_TYPE_DOUBLE;
        }
    }, {
        key: 'isMany',
        value: function isMany() {
            return this._type === TOUCH_TYPE_MANY;
        }
    }, {
        key: '_conditionalEndSingle',
        value: function _conditionalEndSingle(e) {
            if (this.isSingle()) {
                this._onSingleTouchEnd(e);
            }
        }
    }, {
        key: '_conditionalEndDouble',
        value: function _conditionalEndDouble(e) {
            if (this.isDouble()) {
                this._onDoubleTouchEnd(e);
            }
        }
    }, {
        key: '_conditionalEndMany',
        value: function _conditionalEndMany(e) {
            if (this.isMany()) {
                this._onManyTouchEnd(e);
            }
        }
    }, {
        key: '_conditionalStartSingle',
        value: function _conditionalStartSingle(e) {
            if (!this.isSingle()) {
                this._type = TOUCH_TYPE_SINGLE;
                this._onSingleTouchStart(e);
            }
        }
    }, {
        key: '_conditionalStartDouble',
        value: function _conditionalStartDouble(e) {
            if (!this.isDouble()) {
                this._type = TOUCH_TYPE_DOUBLE;
                this._onDoubleTouchStart(e);
            }
        }
    }, {
        key: '_conditionalStartMany',
        value: function _conditionalStartMany(e) {
            if (!this.isMany()) {
                this._type = TOUCH_TYPE_MANY;
                this._onManyTouchStart(e);
            }
        }
    }]);

    return MultiTouchDetector;
}();

module.exports = MultiTouchDetector;

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(342);


/***/ }),

/***/ 276:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(277).EventEmitter;
var inherits = __webpack_require__(59);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(443);
Stream.Writable = __webpack_require__(445);
Stream.Duplex = __webpack_require__(441);
Stream.Transform = __webpack_require__(444);
Stream.PassThrough = __webpack_require__(442);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(486);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

module.exports = {
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),

/***/ 2981:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"isHidden":"Introduction-style__isHidden__2ayIj","wrapper":"Introduction-style__wrapper__1H9Km","container":"Introduction-style__container__2aOwJ","header":"Introduction-style__header__2XbT-","subheader":"Introduction-style__subheader__2zDZ2","modal":"Introduction-style__modal__3ON_d","modalWrapper":"Introduction-style__modalWrapper__EYZDv Introduction-style__wrapper__1H9Km","close":"Introduction-style__close__38cJj","modalHeader":"Introduction-style__modalHeader__5Y8G5","modalSubheader":"Introduction-style__modalSubheader__2692X","modalLogo":"Introduction-style__modalLogo__39EKX","modalHighlights":"Introduction-style__modalHighlights__sebfD","item":"Introduction-style__item__3Ts7p","itemIcon":"Introduction-style__itemIcon__1hJRt","itemTitle":"Introduction-style__itemTitle__2sLfV","itemText":"Introduction-style__itemText__1qMtb"};

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Component = React.Component;

var sanitizeHtml = __webpack_require__(480);
var HtmlEntities = __webpack_require__(477).AllHtmlEntities;

var DEFAULT_ALLOWED_TAGS = ['br', 'a'];
var DEFAULT_ALLOWED_ATTRIBUTES = {
    a: ['href', 'target', 'rel', 'title']
};

/**
 * Sanitizes user input HTML. See documentation for `sanitize-html` for more infotmation.
 * Also allows optionally decoding HTML entities.
 */

var SanitizeHtml = function (_Component) {
    _inherits(SanitizeHtml, _Component);

    function SanitizeHtml() {
        _classCallCheck(this, SanitizeHtml);

        return _possibleConstructorReturn(this, (SanitizeHtml.__proto__ || Object.getPrototypeOf(SanitizeHtml)).apply(this, arguments));
    }

    _createClass(SanitizeHtml, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                content = _props.content,
                decodeEntities = _props.decodeEntities,
                allowedTags = _props.allowedTags,
                allowedAttributes = _props.allowedAttributes,
                other = _objectWithoutProperties(_props, ['content', 'decodeEntities', 'allowedTags', 'allowedAttributes']);

            var _content = String(content);

            if (decodeEntities) {
                _content = new HtmlEntities().decode(content);
            }

            // assign this._content for testing purposes only
            this._content = _content = sanitizeHtml(_content, {
                allowedTags: allowedTags,
                allowedAttributes: allowedAttributes
            });

            return React.createElement('span', _extends({}, other, {
                dangerouslySetInnerHTML: { __html: _content } }));
        }
    }]);

    return SanitizeHtml;
}(Component);

SanitizeHtml.propTypes = {
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    decodeEntities: PropTypes.bool,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    allowedTags: PropTypes.arrayOf(PropTypes.string),
    allowedAttributes: PropTypes.object
};

SanitizeHtml.defaultProps = {
    decodeEntities: false,
    content: '',
    allowedTags: DEFAULT_ALLOWED_TAGS,
    allowedAttributes: DEFAULT_ALLOWED_ATTRIBUTES
};

module.exports = SanitizeHtml;

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Buffer = __webpack_require__(46).Buffer;

var isBufferEncoding = Buffer.isEncoding
  || function(encoding) {
       switch (encoding && encoding.toLowerCase()) {
         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
         default: return false;
       }
     }


function assertEncoding(encoding) {
  if (encoding && !isBufferEncoding(encoding)) {
    throw new Error('Unknown encoding: ' + encoding);
  }
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
var StringDecoder = exports.StringDecoder = function(encoding) {
  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
  assertEncoding(encoding);
  switch (this.encoding) {
    case 'utf8':
      // CESU-8 represents each of Surrogate Pair by 3-bytes
      this.surrogateSize = 3;
      break;
    case 'ucs2':
    case 'utf16le':
      // UTF-16 represents each of Surrogate Pair by 2-bytes
      this.surrogateSize = 2;
      this.detectIncompleteChar = utf16DetectIncompleteChar;
      break;
    case 'base64':
      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
      this.surrogateSize = 3;
      this.detectIncompleteChar = base64DetectIncompleteChar;
      break;
    default:
      this.write = passThroughWrite;
      return;
  }

  // Enough space to store all bytes of a single character. UTF-8 needs 4
  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
  this.charBuffer = new Buffer(6);
  // Number of bytes received for the current incomplete multi-byte character.
  this.charReceived = 0;
  // Number of bytes expected for the current incomplete multi-byte character.
  this.charLength = 0;
};


// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
  var charStr = '';
  // if our last write ended with an incomplete multibyte character
  while (this.charLength) {
    // determine how many remaining bytes this buffer has to offer for this char
    var available = (buffer.length >= this.charLength - this.charReceived) ?
        this.charLength - this.charReceived :
        buffer.length;

    // add the new bytes to the char buffer
    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    this.charReceived += available;

    if (this.charReceived < this.charLength) {
      // still not enough chars in this buffer? wait for more ...
      return '';
    }

    // remove bytes belonging to the current character from the buffer
    buffer = buffer.slice(available, buffer.length);

    // get the character that was split
    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    var charCode = charStr.charCodeAt(charStr.length - 1);
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      this.charLength += this.surrogateSize;
      charStr = '';
      continue;
    }
    this.charReceived = this.charLength = 0;

    // if there are no more bytes in this buffer, just emit our char
    if (buffer.length === 0) {
      return charStr;
    }
    break;
  }

  // determine and set charLength / charReceived
  this.detectIncompleteChar(buffer);

  var end = buffer.length;
  if (this.charLength) {
    // buffer the incomplete character bytes we got
    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    end -= this.charReceived;
  }

  charStr += buffer.toString(this.encoding, 0, end);

  var end = charStr.length - 1;
  var charCode = charStr.charCodeAt(end);
  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    var size = this.surrogateSize;
    this.charLength += size;
    this.charReceived += size;
    this.charBuffer.copy(this.charBuffer, size, 0, size);
    buffer.copy(this.charBuffer, 0, 0, size);
    return charStr.substring(0, end);
  }

  // or just emit the charStr
  return charStr;
};

// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
  // determine how many bytes we have to check at the end of this buffer
  var i = (buffer.length >= 3) ? 3 : buffer.length;

  // Figure out if one of the last i bytes of our buffer announces an
  // incomplete char.
  for (; i > 0; i--) {
    var c = buffer[buffer.length - i];

    // See http://en.wikipedia.org/wiki/UTF-8#Description

    // 110XXXXX
    if (i == 1 && c >> 5 == 0x06) {
      this.charLength = 2;
      break;
    }

    // 1110XXXX
    if (i <= 2 && c >> 4 == 0x0E) {
      this.charLength = 3;
      break;
    }

    // 11110XXX
    if (i <= 3 && c >> 3 == 0x1E) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = i;
};

StringDecoder.prototype.end = function(buffer) {
  var res = '';
  if (buffer && buffer.length)
    res = this.write(buffer);

  if (this.charReceived) {
    var cr = this.charReceived;
    var buf = this.charBuffer;
    var enc = this.encoding;
    res += buf.slice(0, cr).toString(enc);
  }

  return res;
};

function passThroughWrite(buffer) {
  return buffer.toString(this.encoding);
}

function utf16DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 2;
  this.charLength = this.charReceived ? 2 : 0;
}

function base64DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 3;
  this.charLength = this.charReceived ? 3 : 0;
}


/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(101);

/*<replacement>*/
var util = __webpack_require__(269);
util.inherits = __webpack_require__(59);
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er) {
      done(stream, er);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

function done(stream, er) {
  if (er) return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/*<replacement>*/
var processNextTick = __webpack_require__(302);
/*</replacement>*/

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

/*<replacement>*/
var Buffer = __webpack_require__(46).Buffer;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(269);
util.inherits = __webpack_require__(59);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(439)
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = __webpack_require__(281);
  } catch (_) {} finally {
    if (!Stream) Stream = __webpack_require__(277).EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = __webpack_require__(46).Buffer;

util.inherits(Writable, Stream);

function nop() {}

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

var Duplex;
function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(101);

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // create the two objects needed to store the corked requests
  // they are not a linked list, as no new elements are inserted in there
  this.corkedRequestsFree = new CorkedRequest(this);
  this.corkedRequestsFree.next = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function writableStateGetBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
    });
  } catch (_) {}
})();

var Duplex;
function Writable(options) {
  Duplex = Duplex || __webpack_require__(101);

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe. Not readable.'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;

  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    var er = new TypeError('Invalid non-string/buffer chunk');
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = new Buffer(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) processNextTick(cb, er);else cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
        afterWrite(stream, state, finished, cb);
      }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    while (entry) {
      buffer[count] = entry;
      entry = entry.next;
      count += 1;
    }

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    state.corkedRequestsFree = holder.next;
    holder.next = null;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else {
      prefinish(stream, state);
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function (err) {
    var entry = _this.entry;
    _this.entry = null;
    while (entry) {
      var cb = entry.callback;
      state.pendingcb--;
      cb(err);
      entry = entry.next;
    }
    if (state.corkedRequestsFree) {
      state.corkedRequestsFree.next = _this;
    } else {
      state.corkedRequestsFree = _this;
    }
  };
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47), __webpack_require__(42).setImmediate))

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    createEnum: __webpack_require__(457),
    instanceOfEnum: __webpack_require__(458)
};

/***/ }),

/***/ 3066:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"overlay":"personalizationOverlayStyle__overlay__jvYAQ","isFlipped":"personalizationOverlayStyle__isFlipped__2vyjL","overlayArrow":"personalizationOverlayStyle__overlayArrow__x2hb5"};

/***/ }),

/***/ 3383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var classNames = __webpack_require__(16);
var CloseIcon = __webpack_require__(280);
var LogoNoRegIcon = __webpack_require__(786);
var StorefrontIcon = __webpack_require__(1674);
var MessageIcon = __webpack_require__(1667);
var CartIcon = __webpack_require__(1656);
var ContextComponent = __webpack_require__(61);

var style = __webpack_require__(2981);
var copy = __webpack_require__(2017);

var _require = __webpack_require__(283),
    localStorage = _require.localStorage;

var Modal = __webpack_require__(635);
var introductionTracking = __webpack_require__(2144);

var ICONS = {
    storefront: StorefrontIcon,
    message: MessageIcon,
    cart: CartIcon
};

var Introduction = function (_ContextComponent) {
    _inherits(Introduction, _ContextComponent);

    function Introduction(props) {
        _classCallCheck(this, Introduction);

        var _this = _possibleConstructorReturn(this, (Introduction.__proto__ || Object.getPrototypeOf(Introduction)).call(this, props));

        _this.state = {
            isVisibleBanner: true,
            isVisibleModal: false
        };

        _this._modalOpen = _this._modalOpen.bind(_this);
        _this._modalClose = _this._modalClose.bind(_this);
        return _this;
    }

    _createClass(Introduction, [{
        key: '_modalOpen',
        value: function _modalOpen() {
            this.setState({ isVisibleModal: true });
            this.setState({ isVisibleBanner: false });

            localStorage.setItem('dibsIntroduction', true);

            this.context.executeAction(introductionTracking.trackEcommerceClick);
        }
    }, {
        key: '_modalClose',
        value: function _modalClose() {
            this.setState({ isVisibleModal: false });
        }
    }, {
        key: '_getIcon',
        value: function _getIcon(iconKey) {
            return ICONS[iconKey] || null;
        }
    }, {
        key: '_renderHighlights',
        value: function _renderHighlights() {
            var _this2 = this;

            return copy.modal.highlights.map(function (item) {
                var Icon = _this2._getIcon(item.icon);
                return React.createElement(
                    'div',
                    { className: style.item + ' colLg4 colMd4 colXs12', key: 'highlights-' + item.icon },
                    React.createElement(Icon, { className: style.itemIcon }),
                    React.createElement(
                        'div',
                        { className: style.itemTitle },
                        item.title
                    ),
                    React.createElement(
                        'div',
                        { className: style.itemText },
                        item.text
                    )
                );
            });
        }
    }, {
        key: '_getModalContent',
        value: function _getModalContent() {
            return React.createElement(
                'div',
                { className: 'containerFluid boxSizingWrapper' },
                React.createElement(
                    'div',
                    { className: style.modalWrapper + ' rowFlex colLg12 colMd12', style: { backgroundImage: 'url(' + copy.modal.background + ')' } },
                    React.createElement(
                        'span',
                        { onClick: this._modalClose },
                        React.createElement(CloseIcon, { className: style.close })
                    ),
                    React.createElement(
                        'div',
                        { className: style.container + ' colMdCenter' },
                        React.createElement(LogoNoRegIcon, { className: style.modalLogo }),
                        React.createElement(
                            'div',
                            { className: style.modalHeader },
                            copy.modal.header
                        ),
                        React.createElement(
                            'div',
                            { className: style.modalSubheader },
                            copy.modal.subheader
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { className: style.modalHighlights + ' rowFlex' },
                    this._renderHighlights()
                )
            );
        }
    }, {
        key: '_getBannerContent',
        value: function _getBannerContent() {
            var bannerClass = classNames(style.wrapper, _defineProperty({}, style.isHidden, !this.state.isVisibleBanner));
            var containerClass = classNames(style.container, {
                'isAnimatedContainer': this.state.isVisibleBanner
            });

            return React.createElement(
                'div',
                { className: bannerClass, style: { backgroundImage: 'url(' + copy.background + ')' } },
                React.createElement(
                    'div',
                    { className: containerClass },
                    React.createElement(
                        'div',
                        { className: style.header },
                        copy.header
                    ),
                    React.createElement(
                        'div',
                        { className: style.subheader },
                        copy.subheader
                    ),
                    React.createElement(
                        'button',
                        { className: 'button button-primary button-medium', onClick: this._modalOpen },
                        copy.cta
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var isVisibleModal = this.state.isVisibleModal;

            return React.createElement(
                'div',
                null,
                this._getBannerContent(),
                React.createElement(
                    Modal,
                    { isOpen: isVisibleModal, className: style.modal },
                    this._getModalContent()
                )
            );
        }
    }]);

    return Introduction;
}(ContextComponent);

module.exports = Introduction;

/***/ }),

/***/ 3384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(39);
var root = __webpack_require__(100);
var provideContext = __webpack_require__(288);
var VisitCountModel = __webpack_require__(1461);

var _require = __webpack_require__(283),
    localStorage = _require.localStorage;

var Introduction = provideContext(__webpack_require__(3383));
var introductionTracking = __webpack_require__(2144);

var sessionLimit = 3;

var introductionHelper = {

    /**
     * init introduction banner
     */
    init: function init() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var context = payload.context,
            isEnabled = payload.isEnabled;

        var visitCountModel = new VisitCountModel();
        var sessionCount = visitCountModel.get('session');

        if (isEnabled && sessionCount <= sessionLimit) {
            this._initIntroduction({ context: context });
        }
    },


    /**
     * shows introduction banner for 3 sessions
     */
    _initIntroduction: function _initIntroduction() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var context = payload.context;

        var banner = root.document.querySelectorAll('.js-introduction-container')[0];
        var dibsIntroduction = !localStorage.getItem('dibsIntroduction');

        if (banner && dibsIntroduction) {
            ReactDOM.render(React.createElement(Introduction, { context: context.getComponentContext() }), banner);

            context.executeAction(introductionTracking.trackBannerEcommerce);
        }
    }
};

module.exports = introductionHelper;

/***/ }),

/***/ 3385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    category: {
        click: 'promo interaction'
    },
    actions: {
        click: 'brand intro welcome banner'
    },
    labels: {
        click: 'welcome modal displayed'
    },
    ecommerce: {
        id: 'brand-intro-welcome-banner',
        name: 'Brand Intro Welcome Banner',
        creative: 'welcome-'
    }
};

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(71),
    noop = _require.noop;

/**
 * Base class for carousel "view-models". Defines the interface that derived classes must implement. It is expected that
 * wrapper carousels will be implemented that actually construct the model and pass it into the base carousel. The
 * `onMount` method should be called in the base carousel's `componentDidMount` lifecycle callback and `destroy` should
 * be called in the `componentWillUnmount` lifecycle callback. Derived classes should be aware that the `_el` property
 * will not be available the first time the style transformation methods are called so they should provide a default
 * style that does not depend on the el.
 * @class BaseModel
 */


var BaseModel = function () {
  function BaseModel() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$onStateChange = _ref.onStateChange,
        onStateChange = _ref$onStateChange === undefined ? noop : _ref$onStateChange;

    _classCallCheck(this, BaseModel);

    Object.assign(this, {
      _el: null,
      _onStateChange: onStateChange,
      _state: {}
    });
  }

  /**
   * Pass in the DOM element to manage. This should be a raw DOM element and not a React or jQuery object. The reason
   * the element cannot be passed into the constructor is that initial construction is meant to take place outside of
   * the base carousel but the element is only accessible after construction, once the base carousel has been rendered
   * for the first time. It is possible the "view-model" doesn't need to do anything with the element in which case
   * the `_el` property can be ignored.
   * @param  {Object} el DOM element to manage.
   */


  _createClass(BaseModel, [{
    key: 'onMount',
    value: function onMount(el) {
      if (!el) {
        throw new Error('Must pass `el` to carousel model on mount.');
      }

      this._el = el;
      this._afterMount();
    }

    /**
     * Call the state change callback with the current state.
     * @private
     */

  }, {
    key: '_updateState',
    value: function _updateState() {
      this._onStateChange(this._state);
    }

    /**
     * Return the current state.
     * @return {[type]} [description]
     */

  }, {
    key: 'getState',
    value: function getState() {
      return this._state;
    }

    /**
     * Do any cleanup necessary to avoid memory leaks, e.g. removing event listeners from the passed in element.
     * @abstract
     */

  }, {
    key: 'destroy',
    value: function destroy() {}

    /**
     * Modify the styles object for the carousel `ul`. This gets called before a re-render of the carousel.
     * @param  {Object} style Style object to mutate for the carousel `el`.
     * @abstract
     */

  }, {
    key: 'transformListStyle',
    value: function transformListStyle(style) {} // eslint-disable-line no-unused-vars

    /**
     * Modify the styles object for the carousel item `li`s. This gets called before a re-render of the carousel.
     * @param  {Object} style Style object to mutate for each carousel item `li`.
     * @param  {Number} i The index of the item.
     * @abstract
     */

  }, {
    key: 'transformItemStyle',
    value: function transformItemStyle(style, i) {} // eslint-disable-line no-unused-vars

    /**
     * Custom logic after an element is passed in `onMount`, e.g. adding event listeners on the element.
     * @abstract
     * @private
     */

  }, {
    key: '_afterMount',
    value: function _afterMount() {}
  }]);

  return BaseModel;
}();

module.exports = BaseModel;

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-arrow-left'].join(' '), 'data-tn': 'arrow-left', viewBox: '-8.5 0 32 32' },
                React.createElement('path', { d: 'M14,32c-0.3,0-0.6-0.1-0.8-0.3l-13-15c-0.3-0.4-0.3-0.9,0-1.3l13-15c0.4-0.4,1-0.5,1.4-0.1 c0.4,0.4,0.5,1,0.1,1.4L2.3,16l12.4,14.3c0.4,0.4,0.3,1-0.1,1.4C14.4,31.9,14.2,32,14,32z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint react/no-did-update-set-state: 0 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var classNames = __webpack_require__(2);
	var lodashDebounce = __webpack_require__(3);
	var styles = __webpack_require__(4);
	
	var oppositeDirections = {
	    top: 'bottom',
	    bottom: 'top',
	    left: 'right',
	    right: 'left'
	};
	
	function getWindowBounds() {
	    return {
	        top: 0,
	        left: 0,
	        right: window.innerWidth,
	        bottom: window.innerHeight
	    };
	}
	
	function getHalfDimensions(element) {
	    return function (type) {
	        if (element.width && type === 'width') {
	            return element.width / 2;
	        }
	        if (element.height && type === 'height') {
	            return element.height / 2;
	        }
	        return 0;
	    };
	}
	
	var Tooltip = function (_React$Component) {
	    _inherits(Tooltip, _React$Component);
	
	    function Tooltip(props) {
	        _classCallCheck(this, Tooltip);
	
	        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	        _this.state = {
	            top: 0,
	            left: 0,
	            moved: false,
	            flippedFrom: null,
	            tooltipDirection: props.tooltipDirection,
	            isVisible: props.isVisible
	        };
	        return _this;
	    }
	
	    _createClass(Tooltip, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.state.isVisible) {
	                this._adjustPosition();
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (!this.props.isVisible && nextProps.isVisible) {
	                this.setState({
	                    tooltipDirection: nextProps.tooltipDirection || this.state.tooltipDirection
	                });
	            }
	
	            this.setState({
	                isVisible: nextProps.isVisible
	            });
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var _state = this.state,
	                isVisible = _state.isVisible,
	                moved = _state.moved;
	            var debounce = this.props.debounce;
	
	            var adjustPositionDebounced = lodashDebounce(this._adjustPosition, debounce).bind(this);
	            var shouldAdjust = isVisible && !moved;
	
	            if (shouldAdjust && debounce) {
	                adjustPositionDebounced();
	            } else if (shouldAdjust) {
	                this._adjustPosition();
	            } else if (!isVisible && moved) {
	                // make sure the position gets adjusted next time the tooltip is opened
	                this.setState({
	                    moved: false,
	                    flippedFrom: null
	                });
	            }
	        }
	    }, {
	        key: '_getInitialTooltipPosition',
	        value: function _getInitialTooltipPosition(elementRect, tooltipDirection, rootRect) {
	            var _props = this.props,
	                hasTriangle = _props.hasTriangle,
	                triangleSize = _props.triangleSize;
	
	            var triangleSpacing = hasTriangle ? triangleSize : triangleSize / 2;
	
	            var elementDimensions = getHalfDimensions(elementRect);
	            var rootDimensions = getHalfDimensions(rootRect);
	
	            var elementHalfWidth = elementDimensions('width');
	            var elementHalfHeight = elementDimensions('height');
	            var rootHalfWidth = rootDimensions('width');
	            var rootHalfHeight = rootDimensions('height');
	
	            var left = -1 * elementHalfWidth + rootHalfWidth;
	            var top = -1 * elementHalfHeight + rootHalfHeight;
	            var triangleLeft = elementHalfWidth - triangleSpacing;
	            var triangleTop = elementHalfHeight - triangleSize / 2;
	            var spacing = triangleSpacing + 3;
	
	            var positions = {
	                top: {
	                    top: -1 * (elementRect.height + spacing),
	                    left: left,
	                    triangleLeft: triangleLeft
	                },
	                bottom: {
	                    top: rootRect.height + spacing,
	                    left: left,
	                    triangleLeft: triangleLeft
	                },
	                left: {
	                    top: top,
	                    left: -1 * (elementRect.width + spacing),
	                    triangleTop: triangleTop
	                },
	                right: {
	                    top: top,
	                    left: rootRect.width + spacing,
	                    triangleTop: triangleTop
	                }
	            };
	
	            return positions[tooltipDirection];
	        }
	    }, {
	        key: '_getElementsPositions',
	        value: function _getElementsPositions() {
	            return {
	                elementRect: this._tooltip.childNodes[0].getBoundingClientRect(),
	                rootRect: this._tooltip.parentNode.getBoundingClientRect()
	            };
	        }
	
	        /**
	         * Adjusts the position of the tooltip element so that it's centered if possible. If it can't be centered because
	         * it would go offscreen, then offset the position so the whole tooltip is still displayed onscreen.
	         * @param  {Object} elementRect A rectangle indicating the dimensions of the tooltip element
	         */
	
	    }, {
	        key: '_adjustPosition',
	        value: function _adjustPosition() {
	            var _this2 = this;
	
	            if (!this.state.isVisible) {
	                return;
	            }
	
	            var _getElementsPositions2 = this._getElementsPositions(),
	                elementRect = _getElementsPositions2.elementRect,
	                rootRect = _getElementsPositions2.rootRect;
	
	            var tooltipDirection = this.state.tooltipDirection;
	            var _props2 = this.props,
	                thresholds = _props2.positionThresholds,
	                triangleSize = _props2.triangleSize;
	
	            var position = this._getInitialTooltipPosition(elementRect, tooltipDirection, rootRect);
	
	            // determine the area against which we are going to check the thresholds
	            var bounds = this.props.getBounds();
	            var overflowTop = rootRect.top - Math.abs(position.top) - bounds.top;
	            var overflowBottom = bounds.bottom - (rootRect.top + Math.abs(position.top) + elementRect.height);
	            var overflowLeft = rootRect.left + position.left - bounds.left;
	            var overflowRight = bounds.right - (rootRect.left + (position.left + elementRect.width));
	
	            var determineThresholds = {
	                top: function top() {
	                    return overflowTop;
	                },
	                bottom: function bottom() {
	                    return overflowBottom;
	                },
	                left: function left() {
	                    return overflowLeft;
	                },
	                right: function right() {
	                    return overflowRight;
	                }
	            };
	
	            var adjustHorizontal = function adjustHorizontal() {
	                var thresholdsLeft = overflowLeft - thresholds.left;
	                var thresholdsRight = overflowRight - thresholds.right;
	
	                if (overflowLeft < thresholds.left) {
	                    position.left -= thresholdsLeft;
	                    position.triangleLeft += thresholdsLeft;
	                    _this2.props.onThresholdPassed();
	                }
	
	                if (overflowRight < thresholds.right) {
	                    position.left += thresholdsRight;
	                    position.triangleLeft -= thresholdsRight;
	                    _this2.props.onThresholdPassed();
	                }
	            };
	
	            var adjustVertical = function adjustVertical() {
	                var thresholdsTop = overflowTop - thresholds.top;
	                var thresholdsBottom = overflowBottom + elementRect.height / 2;
	                var triangleHalfSize = triangleSize / 2;
	                var overflowTriangleTop = elementRect.height - triangleHalfSize - triangleSize;
	
	                if (overflowTop < thresholds.top) {
	                    position.top -= thresholdsTop;
	                    position.triangleTop += thresholdsTop;
	                    _this2.props.onThresholdPassed();
	                }
	
	                if (thresholdsBottom < thresholds.bottom) {
	                    position.top += thresholdsBottom + thresholds.bottom;
	                    position.triangleTop -= thresholdsBottom + thresholds.bottom;
	                    _this2.props.onThresholdPassed();
	                }
	
	                if (position.triangleTop <= 0) {
	                    position.triangleTop = triangleHalfSize;
	                } else if (position.triangleTop > overflowTriangleTop) {
	                    position.triangleTop = overflowTriangleTop;
	                }
	            };
	
	            var changeDirection = function changeDirection(direction) {
	                var oldState = tooltipDirection;
	                _this2.setState({
	                    tooltipDirection: direction,
	                    moved: false,
	                    flippedFrom: oldState
	                });
	                _this2.props.onThresholdPassed();
	            };
	
	            /*
	                This has the effect that if the tooltip doesn't fit on both the top and the bottom, we default to
	                displaying it on the top as per the spec
	             */
	            var canFlip = function canFlip() {
	                // if the previous tooltip direction was 'top' (i.e. it's on the bottom now), we can still flip back to the top
	                return !_this2.props.lockDirection && (!_this2.state.flippedFrom || _this2.state.flippedFrom === 'top');
	            };
	
	            var changeDirectionIfNecessary = function changeDirectionIfNecessary(changed, direction) {
	                if (!changed && canFlip() && tooltipDirection === direction) {
	                    var overflow = determineThresholds[direction]();
	                    if (overflow < thresholds[direction]) {
	                        changeDirection(oppositeDirections[direction]);
	                        changed = true;
	                    }
	                }
	                return changed;
	            };
	
	            var verticalOrientations = ['top', 'bottom'];
	            var horizontalOrientations = ['left', 'right'];
	
	            /*
	                If the tooltip is displayed on the top or bottom, adjust the horizontal position so it's all displayed inside
	                the window and flip it from top->bottom or vice-versa if necessary
	             */
	            if (verticalOrientations.indexOf(tooltipDirection) >= 0) {
	                adjustHorizontal();
	                if (verticalOrientations.reduce(changeDirectionIfNecessary, false)) {
	                    return;
	                }
	            }
	
	            /*
	                If the tooltip is displayed on the left or right flip it from left->right or vice-versa if necessary
	             */
	            if (horizontalOrientations.indexOf(tooltipDirection) >= 0) {
	                adjustVertical();
	                if (horizontalOrientations.reduce(changeDirectionIfNecessary, false)) {
	                    return;
	                }
	            }
	
	            this.setState(_extends({
	                moved: true
	            }, position));
	        }
	
	        /**
	         * Renders the tooltip contents if this.state.isVisible is true
	         * @param  {Object} style         The style of the tooltip container
	         */
	
	    }, {
	        key: '_renderContents',
	        value: function _renderContents(containerStyle) {
	            var _props3 = this.props,
	                className = _props3.className,
	                children = _props3.children,
	                hasTriangle = _props3.hasTriangle,
	                hasClose = _props3.hasClose,
	                containerClass = _props3.containerClass,
	                onClick = _props3.onClick;
	            var tooltipDirection = this.state.tooltipDirection;
	
	            var tooltipClass = classNames(styles[tooltipDirection], styles.container, className);
	            var tooltipInnerClass = classNames(styles.inner, containerClass);
	
	            return React.createElement(
	                'div',
	                { className: tooltipClass, style: containerStyle, onClick: onClick },
	                React.createElement(
	                    'div',
	                    { className: tooltipInnerClass },
	                    children
	                ),
	                hasTriangle ? this._renderTriangle(tooltipDirection) : null,
	                hasClose ? this._renderClose() : null
	            );
	        }
	
	        /**
	         * Renders the tooltip triangle if this.props.hasTriangle is true
	         */
	
	    }, {
	        key: '_renderTriangle',
	        value: function _renderTriangle(direction) {
	            var _props4 = this.props,
	                triangleSize = _props4.triangleSize,
	                triangleClass = _props4.triangleClass;
	            var _state2 = this.state,
	                left = _state2.triangleLeft,
	                top = _state2.triangleTop;
	
	            var triangleClassName = classNames(styles.triangle, triangleClass);
	            var triangleDirectionPosition = -1 * triangleSize;
	
	            var triangleStyle = {
	                top: {
	                    left: left,
	                    bottom: triangleDirectionPosition + 1
	                },
	                bottom: {
	                    left: left,
	                    top: triangleDirectionPosition + 1
	                },
	                left: {
	                    top: top,
	                    right: triangleDirectionPosition - 4
	                },
	                right: {
	                    top: top,
	                    left: triangleDirectionPosition - 4
	                }
	            };
	
	            return React.createElement(
	                'svg',
	                { className: triangleClassName, style: triangleStyle[direction], width: triangleSize * 2, height: triangleSize, viewBox: '0 0 20 10' },
	                React.createElement('polygon', { points: '9.65217424 0 19.3043485 9.25000032 0 9.25000032' }),
	                React.createElement('polygon', { className: styles.triangleStroke, strokeLinecap: 'square', points: '9.65723177 0.421508695 9.66228432 0.416666667 9.6572594 0.421535177 18.4448983 8.84302248 18.3478314 8.84165446 9.65723177 0.42156195 0.966632149 8.84165446 0.869565217 8.84302248 9.65720414 0.421535177 9.65217922 0.416666667' })
	            );
	        }
	
	        /**
	         * Renders the tooltip close if this.props.hasClose is true
	         */
	
	    }, {
	        key: '_renderClose',
	        value: function _renderClose() {
	            var _props5 = this.props,
	                closeClass = _props5.closeClass,
	                onCloseClick = _props5.onCloseClick;
	
	            var closeClassName = classNames(styles.close, closeClass);
	
	            return React.createElement(
	                'a',
	                { href: '#0', onClick: onCloseClick },
	                React.createElement(
	                    'svg',
	                    { className: closeClassName, viewBox: '0 0 25 25' },
	                    React.createElement('path', { d: 'M13.7001992,12.5 L24.7011952,23.500996 C25.0348606,23.8346614 25.0348606,24.37251 24.7011952,24.7011952 C24.3675299,25.0298805 23.8296813,25.0348606 23.500996,24.7011952 L12.5,13.7001992 L1.49900398,24.7011952 C1.16533865,25.0348606 0.62749004,25.0348606 0.298804781,24.7011952 C-0.0298804781,24.3675299 -0.0348605578,23.8296813 0.298804781,23.500996 L11.2998008,12.5 L0.298804781,1.49900398 C-0.0348605578,1.16533865 -0.0348605578,0.62749004 0.298804781,0.298804781 C0.63247012,-0.0298804781 1.17031873,-0.0348605578 1.49900398,0.298804781 L12.5,11.2998008 L23.500996,0.298804781 C23.8346614,-0.0348605578 24.37251,-0.0348605578 24.7011952,0.298804781 C25.0298805,0.63247012 25.0348606,1.17031873 24.7011952,1.49900398 L13.7001992,12.5 L13.7001992,12.5 Z' })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _state3 = this.state,
	                top = _state3.top,
	                left = _state3.left;
	
	            var containerStyle = { top: top, left: left };
	
	            return React.createElement(
	                'div',
	                { ref: function ref(tooltip) {
	                        _this3._tooltip = tooltip;
	                    } },
	                this.state.isVisible ? this._renderContents(containerStyle) : null
	            );
	        }
	    }]);
	
	    return Tooltip;
	}(React.Component);
	
	Tooltip.propTypes = {
	    children: React.PropTypes.node,
	    tooltipDirection: React.PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
	    lockDirection: React.PropTypes.bool,
	
	    isVisible: React.PropTypes.bool,
	    hasTriangle: React.PropTypes.bool,
	    hasClose: React.PropTypes.bool,
	
	    className: React.PropTypes.string,
	    containerClass: React.PropTypes.string,
	    triangleClass: React.PropTypes.string,
	    closeClass: React.PropTypes.string,
	
	    debounce: React.PropTypes.number,
	    triangleSize: React.PropTypes.number,
	    positionThresholds: React.PropTypes.shape({
	        top: React.PropTypes.number,
	        bottom: React.PropTypes.number,
	        left: React.PropTypes.number,
	        right: React.PropTypes.number
	    }),
	
	    onClick: React.PropTypes.func,
	    onCloseClick: React.PropTypes.func,
	    onThresholdPassed: React.PropTypes.func,
	    getBounds: React.PropTypes.func
	};
	
	Tooltip.defaultProps = {
	    className: '',
	    containerClass: styles.defaultStyle,
	    triangleClass: styles.defaultTriangle,
	    debounce: 0,
	    triangleSize: 10,
	    tooltipDirection: 'top',
	    lockDirection: false,
	    positionThresholds: {
	        top: 10,
	        bottom: 10,
	        left: 10,
	        right: 10
	    },
	    onClick: function onClick() {},
	    onCloseClick: function onCloseClick() {},
	    onThresholdPassed: function onThresholdPassed() {},
	    getBounds: getWindowBounds,
	    hasTriangle: true,
	    hasClose: false
	};
	
	module.exports = Tooltip;

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(1);

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __webpack_require__(111);

/***/ },
/* 4 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"defaultStyle":"Tooltip__defaultStyle___2PHGC","defaultClose":"Tooltip__defaultClose___3C4eQ","defaultTriangle":"Tooltip__defaultTriangle___2yE9C","container":"Tooltip__container___1iGSw","inner":"Tooltip__inner___34nOg","svg":"Tooltip__svg___1D5qj","close":"Tooltip__close___39mNB Tooltip__svg___1D5qj","triangle":"Tooltip__triangle___XBkZH Tooltip__svg___1D5qj","triangleStroke":"Tooltip__triangleStroke___1qO6p","top":"Tooltip__top___3PYiq","left":"Tooltip__left___2ocL0","right":"Tooltip__right___1Jius"};

/***/ }
/******/ ]);
//# sourceMappingURL=Tooltip.js.map

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pageChangeTypeEnum = __webpack_require__(455);

/**
 * Helper to set the transform property. Sets any vendor prefixes necessary.
 * @param {Object} style      The style object to mutate.
 * @param {String} transform CSS string to add vendor prefixes to.
 */
function setTransformStyle(style, transform) {
    style.transform = transform;
    style.WebkitTransform = transform;
}

/**
 * Helper to set the transition property. Sets any vendor prefixes necessary.
 * @param {Object} style      The style object to mutate.
 * @param {String} transition CSS string to add vendor prefixes to.
 */
function setTransitionStyle(style, transition) {
    style.transition = transition;
    style.WebkitTransition = '-webkit-' + transition;
}

/**
 * Simple helper to set the width of items.
 * @param {[type]} style [description]
 * @param {[type]} width [description]
 */
function setWidthStyle(style, width) {
    // Need both min and max width for this to work consistently.
    style.minWidth = width + '%';
    style.maxWidth = width + '%';
}

/**
 * Calculate the total number of pages in a paged carousel.
 * @param  {Number} itemCount    Total number of items in the carousel.
 * @param  {Number} itemsPerPage Items to display per page.
 * @return {Number}
 */
function getTotalPages(itemCount, itemsPerPage) {
    return Math.ceil(itemCount / Math.floor(itemsPerPage));
}

/**
 * Get the default width pf items in a paged carousel.
 * @param  {Number} itemsPerPage Items to display per page.
 * @return {Number}
 */
function getPagedItemWidth(itemsPerPage) {
    return 100 / itemsPerPage;
}

/**
 * Get the width of each item when the last on is going to be partially hidden. The `numerator` and `denominator`
 * indicate how much of the last item should be hidden.  So calling `getScrollableItemWidth(2, 1, 3)` indicatedsthat 2
 * items will be shown and the second one will be one third hidden.
 * @param  {Number} numItems The number of items to display on the page.
 * @param  {Number} numerator The numerator of the portion to hide.
 * @param  {Number} denominator The denominator of the portion to hide.
 * @return {Number}
 */
function getScrollableItemWidth(numItems, numerator, denominator) {
    return 100 / (numItems - numerator / denominator);
}

/**
 * Calculate the default position of a paged carousel based on the current page.
 * @param {Number} page         The current page.
 * @return {Number}
 */
function getPagedOffset(page) {
    return -100 * page;
}

module.exports = {
    pageChangeTypeEnum: pageChangeTypeEnum,
    setTransformStyle: setTransformStyle,
    setTransitionStyle: setTransitionStyle,
    setWidthStyle: setWidthStyle,
    getTotalPages: getTotalPages,
    getPagedItemWidth: getPagedItemWidth,
    getScrollableItemWidth: getScrollableItemWidth,
    getPagedOffset: getPagedOffset
};

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Abreve": "Ă",
	"abreve": "ă",
	"ac": "∾",
	"acd": "∿",
	"acE": "∾̳",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"Acy": "А",
	"acy": "а",
	"AElig": "Æ",
	"aelig": "æ",
	"af": "⁡",
	"Afr": "𝔄",
	"afr": "𝔞",
	"Agrave": "À",
	"agrave": "à",
	"alefsym": "ℵ",
	"aleph": "ℵ",
	"Alpha": "Α",
	"alpha": "α",
	"Amacr": "Ā",
	"amacr": "ā",
	"amalg": "⨿",
	"amp": "&",
	"AMP": "&",
	"andand": "⩕",
	"And": "⩓",
	"and": "∧",
	"andd": "⩜",
	"andslope": "⩘",
	"andv": "⩚",
	"ang": "∠",
	"ange": "⦤",
	"angle": "∠",
	"angmsdaa": "⦨",
	"angmsdab": "⦩",
	"angmsdac": "⦪",
	"angmsdad": "⦫",
	"angmsdae": "⦬",
	"angmsdaf": "⦭",
	"angmsdag": "⦮",
	"angmsdah": "⦯",
	"angmsd": "∡",
	"angrt": "∟",
	"angrtvb": "⊾",
	"angrtvbd": "⦝",
	"angsph": "∢",
	"angst": "Å",
	"angzarr": "⍼",
	"Aogon": "Ą",
	"aogon": "ą",
	"Aopf": "𝔸",
	"aopf": "𝕒",
	"apacir": "⩯",
	"ap": "≈",
	"apE": "⩰",
	"ape": "≊",
	"apid": "≋",
	"apos": "'",
	"ApplyFunction": "⁡",
	"approx": "≈",
	"approxeq": "≊",
	"Aring": "Å",
	"aring": "å",
	"Ascr": "𝒜",
	"ascr": "𝒶",
	"Assign": "≔",
	"ast": "*",
	"asymp": "≈",
	"asympeq": "≍",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"awconint": "∳",
	"awint": "⨑",
	"backcong": "≌",
	"backepsilon": "϶",
	"backprime": "‵",
	"backsim": "∽",
	"backsimeq": "⋍",
	"Backslash": "∖",
	"Barv": "⫧",
	"barvee": "⊽",
	"barwed": "⌅",
	"Barwed": "⌆",
	"barwedge": "⌅",
	"bbrk": "⎵",
	"bbrktbrk": "⎶",
	"bcong": "≌",
	"Bcy": "Б",
	"bcy": "б",
	"bdquo": "„",
	"becaus": "∵",
	"because": "∵",
	"Because": "∵",
	"bemptyv": "⦰",
	"bepsi": "϶",
	"bernou": "ℬ",
	"Bernoullis": "ℬ",
	"Beta": "Β",
	"beta": "β",
	"beth": "ℶ",
	"between": "≬",
	"Bfr": "𝔅",
	"bfr": "𝔟",
	"bigcap": "⋂",
	"bigcirc": "◯",
	"bigcup": "⋃",
	"bigodot": "⨀",
	"bigoplus": "⨁",
	"bigotimes": "⨂",
	"bigsqcup": "⨆",
	"bigstar": "★",
	"bigtriangledown": "▽",
	"bigtriangleup": "△",
	"biguplus": "⨄",
	"bigvee": "⋁",
	"bigwedge": "⋀",
	"bkarow": "⤍",
	"blacklozenge": "⧫",
	"blacksquare": "▪",
	"blacktriangle": "▴",
	"blacktriangledown": "▾",
	"blacktriangleleft": "◂",
	"blacktriangleright": "▸",
	"blank": "␣",
	"blk12": "▒",
	"blk14": "░",
	"blk34": "▓",
	"block": "█",
	"bne": "=⃥",
	"bnequiv": "≡⃥",
	"bNot": "⫭",
	"bnot": "⌐",
	"Bopf": "𝔹",
	"bopf": "𝕓",
	"bot": "⊥",
	"bottom": "⊥",
	"bowtie": "⋈",
	"boxbox": "⧉",
	"boxdl": "┐",
	"boxdL": "╕",
	"boxDl": "╖",
	"boxDL": "╗",
	"boxdr": "┌",
	"boxdR": "╒",
	"boxDr": "╓",
	"boxDR": "╔",
	"boxh": "─",
	"boxH": "═",
	"boxhd": "┬",
	"boxHd": "╤",
	"boxhD": "╥",
	"boxHD": "╦",
	"boxhu": "┴",
	"boxHu": "╧",
	"boxhU": "╨",
	"boxHU": "╩",
	"boxminus": "⊟",
	"boxplus": "⊞",
	"boxtimes": "⊠",
	"boxul": "┘",
	"boxuL": "╛",
	"boxUl": "╜",
	"boxUL": "╝",
	"boxur": "└",
	"boxuR": "╘",
	"boxUr": "╙",
	"boxUR": "╚",
	"boxv": "│",
	"boxV": "║",
	"boxvh": "┼",
	"boxvH": "╪",
	"boxVh": "╫",
	"boxVH": "╬",
	"boxvl": "┤",
	"boxvL": "╡",
	"boxVl": "╢",
	"boxVL": "╣",
	"boxvr": "├",
	"boxvR": "╞",
	"boxVr": "╟",
	"boxVR": "╠",
	"bprime": "‵",
	"breve": "˘",
	"Breve": "˘",
	"brvbar": "¦",
	"bscr": "𝒷",
	"Bscr": "ℬ",
	"bsemi": "⁏",
	"bsim": "∽",
	"bsime": "⋍",
	"bsolb": "⧅",
	"bsol": "\\",
	"bsolhsub": "⟈",
	"bull": "•",
	"bullet": "•",
	"bump": "≎",
	"bumpE": "⪮",
	"bumpe": "≏",
	"Bumpeq": "≎",
	"bumpeq": "≏",
	"Cacute": "Ć",
	"cacute": "ć",
	"capand": "⩄",
	"capbrcup": "⩉",
	"capcap": "⩋",
	"cap": "∩",
	"Cap": "⋒",
	"capcup": "⩇",
	"capdot": "⩀",
	"CapitalDifferentialD": "ⅅ",
	"caps": "∩︀",
	"caret": "⁁",
	"caron": "ˇ",
	"Cayleys": "ℭ",
	"ccaps": "⩍",
	"Ccaron": "Č",
	"ccaron": "č",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"Ccirc": "Ĉ",
	"ccirc": "ĉ",
	"Cconint": "∰",
	"ccups": "⩌",
	"ccupssm": "⩐",
	"Cdot": "Ċ",
	"cdot": "ċ",
	"cedil": "¸",
	"Cedilla": "¸",
	"cemptyv": "⦲",
	"cent": "¢",
	"centerdot": "·",
	"CenterDot": "·",
	"cfr": "𝔠",
	"Cfr": "ℭ",
	"CHcy": "Ч",
	"chcy": "ч",
	"check": "✓",
	"checkmark": "✓",
	"Chi": "Χ",
	"chi": "χ",
	"circ": "ˆ",
	"circeq": "≗",
	"circlearrowleft": "↺",
	"circlearrowright": "↻",
	"circledast": "⊛",
	"circledcirc": "⊚",
	"circleddash": "⊝",
	"CircleDot": "⊙",
	"circledR": "®",
	"circledS": "Ⓢ",
	"CircleMinus": "⊖",
	"CirclePlus": "⊕",
	"CircleTimes": "⊗",
	"cir": "○",
	"cirE": "⧃",
	"cire": "≗",
	"cirfnint": "⨐",
	"cirmid": "⫯",
	"cirscir": "⧂",
	"ClockwiseContourIntegral": "∲",
	"CloseCurlyDoubleQuote": "”",
	"CloseCurlyQuote": "’",
	"clubs": "♣",
	"clubsuit": "♣",
	"colon": ":",
	"Colon": "∷",
	"Colone": "⩴",
	"colone": "≔",
	"coloneq": "≔",
	"comma": ",",
	"commat": "@",
	"comp": "∁",
	"compfn": "∘",
	"complement": "∁",
	"complexes": "ℂ",
	"cong": "≅",
	"congdot": "⩭",
	"Congruent": "≡",
	"conint": "∮",
	"Conint": "∯",
	"ContourIntegral": "∮",
	"copf": "𝕔",
	"Copf": "ℂ",
	"coprod": "∐",
	"Coproduct": "∐",
	"copy": "©",
	"COPY": "©",
	"copysr": "℗",
	"CounterClockwiseContourIntegral": "∳",
	"crarr": "↵",
	"cross": "✗",
	"Cross": "⨯",
	"Cscr": "𝒞",
	"cscr": "𝒸",
	"csub": "⫏",
	"csube": "⫑",
	"csup": "⫐",
	"csupe": "⫒",
	"ctdot": "⋯",
	"cudarrl": "⤸",
	"cudarrr": "⤵",
	"cuepr": "⋞",
	"cuesc": "⋟",
	"cularr": "↶",
	"cularrp": "⤽",
	"cupbrcap": "⩈",
	"cupcap": "⩆",
	"CupCap": "≍",
	"cup": "∪",
	"Cup": "⋓",
	"cupcup": "⩊",
	"cupdot": "⊍",
	"cupor": "⩅",
	"cups": "∪︀",
	"curarr": "↷",
	"curarrm": "⤼",
	"curlyeqprec": "⋞",
	"curlyeqsucc": "⋟",
	"curlyvee": "⋎",
	"curlywedge": "⋏",
	"curren": "¤",
	"curvearrowleft": "↶",
	"curvearrowright": "↷",
	"cuvee": "⋎",
	"cuwed": "⋏",
	"cwconint": "∲",
	"cwint": "∱",
	"cylcty": "⌭",
	"dagger": "†",
	"Dagger": "‡",
	"daleth": "ℸ",
	"darr": "↓",
	"Darr": "↡",
	"dArr": "⇓",
	"dash": "‐",
	"Dashv": "⫤",
	"dashv": "⊣",
	"dbkarow": "⤏",
	"dblac": "˝",
	"Dcaron": "Ď",
	"dcaron": "ď",
	"Dcy": "Д",
	"dcy": "д",
	"ddagger": "‡",
	"ddarr": "⇊",
	"DD": "ⅅ",
	"dd": "ⅆ",
	"DDotrahd": "⤑",
	"ddotseq": "⩷",
	"deg": "°",
	"Del": "∇",
	"Delta": "Δ",
	"delta": "δ",
	"demptyv": "⦱",
	"dfisht": "⥿",
	"Dfr": "𝔇",
	"dfr": "𝔡",
	"dHar": "⥥",
	"dharl": "⇃",
	"dharr": "⇂",
	"DiacriticalAcute": "´",
	"DiacriticalDot": "˙",
	"DiacriticalDoubleAcute": "˝",
	"DiacriticalGrave": "`",
	"DiacriticalTilde": "˜",
	"diam": "⋄",
	"diamond": "⋄",
	"Diamond": "⋄",
	"diamondsuit": "♦",
	"diams": "♦",
	"die": "¨",
	"DifferentialD": "ⅆ",
	"digamma": "ϝ",
	"disin": "⋲",
	"div": "÷",
	"divide": "÷",
	"divideontimes": "⋇",
	"divonx": "⋇",
	"DJcy": "Ђ",
	"djcy": "ђ",
	"dlcorn": "⌞",
	"dlcrop": "⌍",
	"dollar": "$",
	"Dopf": "𝔻",
	"dopf": "𝕕",
	"Dot": "¨",
	"dot": "˙",
	"DotDot": "⃜",
	"doteq": "≐",
	"doteqdot": "≑",
	"DotEqual": "≐",
	"dotminus": "∸",
	"dotplus": "∔",
	"dotsquare": "⊡",
	"doublebarwedge": "⌆",
	"DoubleContourIntegral": "∯",
	"DoubleDot": "¨",
	"DoubleDownArrow": "⇓",
	"DoubleLeftArrow": "⇐",
	"DoubleLeftRightArrow": "⇔",
	"DoubleLeftTee": "⫤",
	"DoubleLongLeftArrow": "⟸",
	"DoubleLongLeftRightArrow": "⟺",
	"DoubleLongRightArrow": "⟹",
	"DoubleRightArrow": "⇒",
	"DoubleRightTee": "⊨",
	"DoubleUpArrow": "⇑",
	"DoubleUpDownArrow": "⇕",
	"DoubleVerticalBar": "∥",
	"DownArrowBar": "⤓",
	"downarrow": "↓",
	"DownArrow": "↓",
	"Downarrow": "⇓",
	"DownArrowUpArrow": "⇵",
	"DownBreve": "̑",
	"downdownarrows": "⇊",
	"downharpoonleft": "⇃",
	"downharpoonright": "⇂",
	"DownLeftRightVector": "⥐",
	"DownLeftTeeVector": "⥞",
	"DownLeftVectorBar": "⥖",
	"DownLeftVector": "↽",
	"DownRightTeeVector": "⥟",
	"DownRightVectorBar": "⥗",
	"DownRightVector": "⇁",
	"DownTeeArrow": "↧",
	"DownTee": "⊤",
	"drbkarow": "⤐",
	"drcorn": "⌟",
	"drcrop": "⌌",
	"Dscr": "𝒟",
	"dscr": "𝒹",
	"DScy": "Ѕ",
	"dscy": "ѕ",
	"dsol": "⧶",
	"Dstrok": "Đ",
	"dstrok": "đ",
	"dtdot": "⋱",
	"dtri": "▿",
	"dtrif": "▾",
	"duarr": "⇵",
	"duhar": "⥯",
	"dwangle": "⦦",
	"DZcy": "Џ",
	"dzcy": "џ",
	"dzigrarr": "⟿",
	"Eacute": "É",
	"eacute": "é",
	"easter": "⩮",
	"Ecaron": "Ě",
	"ecaron": "ě",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"ecir": "≖",
	"ecolon": "≕",
	"Ecy": "Э",
	"ecy": "э",
	"eDDot": "⩷",
	"Edot": "Ė",
	"edot": "ė",
	"eDot": "≑",
	"ee": "ⅇ",
	"efDot": "≒",
	"Efr": "𝔈",
	"efr": "𝔢",
	"eg": "⪚",
	"Egrave": "È",
	"egrave": "è",
	"egs": "⪖",
	"egsdot": "⪘",
	"el": "⪙",
	"Element": "∈",
	"elinters": "⏧",
	"ell": "ℓ",
	"els": "⪕",
	"elsdot": "⪗",
	"Emacr": "Ē",
	"emacr": "ē",
	"empty": "∅",
	"emptyset": "∅",
	"EmptySmallSquare": "◻",
	"emptyv": "∅",
	"EmptyVerySmallSquare": "▫",
	"emsp13": " ",
	"emsp14": " ",
	"emsp": " ",
	"ENG": "Ŋ",
	"eng": "ŋ",
	"ensp": " ",
	"Eogon": "Ę",
	"eogon": "ę",
	"Eopf": "𝔼",
	"eopf": "𝕖",
	"epar": "⋕",
	"eparsl": "⧣",
	"eplus": "⩱",
	"epsi": "ε",
	"Epsilon": "Ε",
	"epsilon": "ε",
	"epsiv": "ϵ",
	"eqcirc": "≖",
	"eqcolon": "≕",
	"eqsim": "≂",
	"eqslantgtr": "⪖",
	"eqslantless": "⪕",
	"Equal": "⩵",
	"equals": "=",
	"EqualTilde": "≂",
	"equest": "≟",
	"Equilibrium": "⇌",
	"equiv": "≡",
	"equivDD": "⩸",
	"eqvparsl": "⧥",
	"erarr": "⥱",
	"erDot": "≓",
	"escr": "ℯ",
	"Escr": "ℰ",
	"esdot": "≐",
	"Esim": "⩳",
	"esim": "≂",
	"Eta": "Η",
	"eta": "η",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"euro": "€",
	"excl": "!",
	"exist": "∃",
	"Exists": "∃",
	"expectation": "ℰ",
	"exponentiale": "ⅇ",
	"ExponentialE": "ⅇ",
	"fallingdotseq": "≒",
	"Fcy": "Ф",
	"fcy": "ф",
	"female": "♀",
	"ffilig": "ﬃ",
	"fflig": "ﬀ",
	"ffllig": "ﬄ",
	"Ffr": "𝔉",
	"ffr": "𝔣",
	"filig": "ﬁ",
	"FilledSmallSquare": "◼",
	"FilledVerySmallSquare": "▪",
	"fjlig": "fj",
	"flat": "♭",
	"fllig": "ﬂ",
	"fltns": "▱",
	"fnof": "ƒ",
	"Fopf": "𝔽",
	"fopf": "𝕗",
	"forall": "∀",
	"ForAll": "∀",
	"fork": "⋔",
	"forkv": "⫙",
	"Fouriertrf": "ℱ",
	"fpartint": "⨍",
	"frac12": "½",
	"frac13": "⅓",
	"frac14": "¼",
	"frac15": "⅕",
	"frac16": "⅙",
	"frac18": "⅛",
	"frac23": "⅔",
	"frac25": "⅖",
	"frac34": "¾",
	"frac35": "⅗",
	"frac38": "⅜",
	"frac45": "⅘",
	"frac56": "⅚",
	"frac58": "⅝",
	"frac78": "⅞",
	"frasl": "⁄",
	"frown": "⌢",
	"fscr": "𝒻",
	"Fscr": "ℱ",
	"gacute": "ǵ",
	"Gamma": "Γ",
	"gamma": "γ",
	"Gammad": "Ϝ",
	"gammad": "ϝ",
	"gap": "⪆",
	"Gbreve": "Ğ",
	"gbreve": "ğ",
	"Gcedil": "Ģ",
	"Gcirc": "Ĝ",
	"gcirc": "ĝ",
	"Gcy": "Г",
	"gcy": "г",
	"Gdot": "Ġ",
	"gdot": "ġ",
	"ge": "≥",
	"gE": "≧",
	"gEl": "⪌",
	"gel": "⋛",
	"geq": "≥",
	"geqq": "≧",
	"geqslant": "⩾",
	"gescc": "⪩",
	"ges": "⩾",
	"gesdot": "⪀",
	"gesdoto": "⪂",
	"gesdotol": "⪄",
	"gesl": "⋛︀",
	"gesles": "⪔",
	"Gfr": "𝔊",
	"gfr": "𝔤",
	"gg": "≫",
	"Gg": "⋙",
	"ggg": "⋙",
	"gimel": "ℷ",
	"GJcy": "Ѓ",
	"gjcy": "ѓ",
	"gla": "⪥",
	"gl": "≷",
	"glE": "⪒",
	"glj": "⪤",
	"gnap": "⪊",
	"gnapprox": "⪊",
	"gne": "⪈",
	"gnE": "≩",
	"gneq": "⪈",
	"gneqq": "≩",
	"gnsim": "⋧",
	"Gopf": "𝔾",
	"gopf": "𝕘",
	"grave": "`",
	"GreaterEqual": "≥",
	"GreaterEqualLess": "⋛",
	"GreaterFullEqual": "≧",
	"GreaterGreater": "⪢",
	"GreaterLess": "≷",
	"GreaterSlantEqual": "⩾",
	"GreaterTilde": "≳",
	"Gscr": "𝒢",
	"gscr": "ℊ",
	"gsim": "≳",
	"gsime": "⪎",
	"gsiml": "⪐",
	"gtcc": "⪧",
	"gtcir": "⩺",
	"gt": ">",
	"GT": ">",
	"Gt": "≫",
	"gtdot": "⋗",
	"gtlPar": "⦕",
	"gtquest": "⩼",
	"gtrapprox": "⪆",
	"gtrarr": "⥸",
	"gtrdot": "⋗",
	"gtreqless": "⋛",
	"gtreqqless": "⪌",
	"gtrless": "≷",
	"gtrsim": "≳",
	"gvertneqq": "≩︀",
	"gvnE": "≩︀",
	"Hacek": "ˇ",
	"hairsp": " ",
	"half": "½",
	"hamilt": "ℋ",
	"HARDcy": "Ъ",
	"hardcy": "ъ",
	"harrcir": "⥈",
	"harr": "↔",
	"hArr": "⇔",
	"harrw": "↭",
	"Hat": "^",
	"hbar": "ℏ",
	"Hcirc": "Ĥ",
	"hcirc": "ĥ",
	"hearts": "♥",
	"heartsuit": "♥",
	"hellip": "…",
	"hercon": "⊹",
	"hfr": "𝔥",
	"Hfr": "ℌ",
	"HilbertSpace": "ℋ",
	"hksearow": "⤥",
	"hkswarow": "⤦",
	"hoarr": "⇿",
	"homtht": "∻",
	"hookleftarrow": "↩",
	"hookrightarrow": "↪",
	"hopf": "𝕙",
	"Hopf": "ℍ",
	"horbar": "―",
	"HorizontalLine": "─",
	"hscr": "𝒽",
	"Hscr": "ℋ",
	"hslash": "ℏ",
	"Hstrok": "Ħ",
	"hstrok": "ħ",
	"HumpDownHump": "≎",
	"HumpEqual": "≏",
	"hybull": "⁃",
	"hyphen": "‐",
	"Iacute": "Í",
	"iacute": "í",
	"ic": "⁣",
	"Icirc": "Î",
	"icirc": "î",
	"Icy": "И",
	"icy": "и",
	"Idot": "İ",
	"IEcy": "Е",
	"iecy": "е",
	"iexcl": "¡",
	"iff": "⇔",
	"ifr": "𝔦",
	"Ifr": "ℑ",
	"Igrave": "Ì",
	"igrave": "ì",
	"ii": "ⅈ",
	"iiiint": "⨌",
	"iiint": "∭",
	"iinfin": "⧜",
	"iiota": "℩",
	"IJlig": "Ĳ",
	"ijlig": "ĳ",
	"Imacr": "Ī",
	"imacr": "ī",
	"image": "ℑ",
	"ImaginaryI": "ⅈ",
	"imagline": "ℐ",
	"imagpart": "ℑ",
	"imath": "ı",
	"Im": "ℑ",
	"imof": "⊷",
	"imped": "Ƶ",
	"Implies": "⇒",
	"incare": "℅",
	"in": "∈",
	"infin": "∞",
	"infintie": "⧝",
	"inodot": "ı",
	"intcal": "⊺",
	"int": "∫",
	"Int": "∬",
	"integers": "ℤ",
	"Integral": "∫",
	"intercal": "⊺",
	"Intersection": "⋂",
	"intlarhk": "⨗",
	"intprod": "⨼",
	"InvisibleComma": "⁣",
	"InvisibleTimes": "⁢",
	"IOcy": "Ё",
	"iocy": "ё",
	"Iogon": "Į",
	"iogon": "į",
	"Iopf": "𝕀",
	"iopf": "𝕚",
	"Iota": "Ι",
	"iota": "ι",
	"iprod": "⨼",
	"iquest": "¿",
	"iscr": "𝒾",
	"Iscr": "ℐ",
	"isin": "∈",
	"isindot": "⋵",
	"isinE": "⋹",
	"isins": "⋴",
	"isinsv": "⋳",
	"isinv": "∈",
	"it": "⁢",
	"Itilde": "Ĩ",
	"itilde": "ĩ",
	"Iukcy": "І",
	"iukcy": "і",
	"Iuml": "Ï",
	"iuml": "ï",
	"Jcirc": "Ĵ",
	"jcirc": "ĵ",
	"Jcy": "Й",
	"jcy": "й",
	"Jfr": "𝔍",
	"jfr": "𝔧",
	"jmath": "ȷ",
	"Jopf": "𝕁",
	"jopf": "𝕛",
	"Jscr": "𝒥",
	"jscr": "𝒿",
	"Jsercy": "Ј",
	"jsercy": "ј",
	"Jukcy": "Є",
	"jukcy": "є",
	"Kappa": "Κ",
	"kappa": "κ",
	"kappav": "ϰ",
	"Kcedil": "Ķ",
	"kcedil": "ķ",
	"Kcy": "К",
	"kcy": "к",
	"Kfr": "𝔎",
	"kfr": "𝔨",
	"kgreen": "ĸ",
	"KHcy": "Х",
	"khcy": "х",
	"KJcy": "Ќ",
	"kjcy": "ќ",
	"Kopf": "𝕂",
	"kopf": "𝕜",
	"Kscr": "𝒦",
	"kscr": "𝓀",
	"lAarr": "⇚",
	"Lacute": "Ĺ",
	"lacute": "ĺ",
	"laemptyv": "⦴",
	"lagran": "ℒ",
	"Lambda": "Λ",
	"lambda": "λ",
	"lang": "⟨",
	"Lang": "⟪",
	"langd": "⦑",
	"langle": "⟨",
	"lap": "⪅",
	"Laplacetrf": "ℒ",
	"laquo": "«",
	"larrb": "⇤",
	"larrbfs": "⤟",
	"larr": "←",
	"Larr": "↞",
	"lArr": "⇐",
	"larrfs": "⤝",
	"larrhk": "↩",
	"larrlp": "↫",
	"larrpl": "⤹",
	"larrsim": "⥳",
	"larrtl": "↢",
	"latail": "⤙",
	"lAtail": "⤛",
	"lat": "⪫",
	"late": "⪭",
	"lates": "⪭︀",
	"lbarr": "⤌",
	"lBarr": "⤎",
	"lbbrk": "❲",
	"lbrace": "{",
	"lbrack": "[",
	"lbrke": "⦋",
	"lbrksld": "⦏",
	"lbrkslu": "⦍",
	"Lcaron": "Ľ",
	"lcaron": "ľ",
	"Lcedil": "Ļ",
	"lcedil": "ļ",
	"lceil": "⌈",
	"lcub": "{",
	"Lcy": "Л",
	"lcy": "л",
	"ldca": "⤶",
	"ldquo": "“",
	"ldquor": "„",
	"ldrdhar": "⥧",
	"ldrushar": "⥋",
	"ldsh": "↲",
	"le": "≤",
	"lE": "≦",
	"LeftAngleBracket": "⟨",
	"LeftArrowBar": "⇤",
	"leftarrow": "←",
	"LeftArrow": "←",
	"Leftarrow": "⇐",
	"LeftArrowRightArrow": "⇆",
	"leftarrowtail": "↢",
	"LeftCeiling": "⌈",
	"LeftDoubleBracket": "⟦",
	"LeftDownTeeVector": "⥡",
	"LeftDownVectorBar": "⥙",
	"LeftDownVector": "⇃",
	"LeftFloor": "⌊",
	"leftharpoondown": "↽",
	"leftharpoonup": "↼",
	"leftleftarrows": "⇇",
	"leftrightarrow": "↔",
	"LeftRightArrow": "↔",
	"Leftrightarrow": "⇔",
	"leftrightarrows": "⇆",
	"leftrightharpoons": "⇋",
	"leftrightsquigarrow": "↭",
	"LeftRightVector": "⥎",
	"LeftTeeArrow": "↤",
	"LeftTee": "⊣",
	"LeftTeeVector": "⥚",
	"leftthreetimes": "⋋",
	"LeftTriangleBar": "⧏",
	"LeftTriangle": "⊲",
	"LeftTriangleEqual": "⊴",
	"LeftUpDownVector": "⥑",
	"LeftUpTeeVector": "⥠",
	"LeftUpVectorBar": "⥘",
	"LeftUpVector": "↿",
	"LeftVectorBar": "⥒",
	"LeftVector": "↼",
	"lEg": "⪋",
	"leg": "⋚",
	"leq": "≤",
	"leqq": "≦",
	"leqslant": "⩽",
	"lescc": "⪨",
	"les": "⩽",
	"lesdot": "⩿",
	"lesdoto": "⪁",
	"lesdotor": "⪃",
	"lesg": "⋚︀",
	"lesges": "⪓",
	"lessapprox": "⪅",
	"lessdot": "⋖",
	"lesseqgtr": "⋚",
	"lesseqqgtr": "⪋",
	"LessEqualGreater": "⋚",
	"LessFullEqual": "≦",
	"LessGreater": "≶",
	"lessgtr": "≶",
	"LessLess": "⪡",
	"lesssim": "≲",
	"LessSlantEqual": "⩽",
	"LessTilde": "≲",
	"lfisht": "⥼",
	"lfloor": "⌊",
	"Lfr": "𝔏",
	"lfr": "𝔩",
	"lg": "≶",
	"lgE": "⪑",
	"lHar": "⥢",
	"lhard": "↽",
	"lharu": "↼",
	"lharul": "⥪",
	"lhblk": "▄",
	"LJcy": "Љ",
	"ljcy": "љ",
	"llarr": "⇇",
	"ll": "≪",
	"Ll": "⋘",
	"llcorner": "⌞",
	"Lleftarrow": "⇚",
	"llhard": "⥫",
	"lltri": "◺",
	"Lmidot": "Ŀ",
	"lmidot": "ŀ",
	"lmoustache": "⎰",
	"lmoust": "⎰",
	"lnap": "⪉",
	"lnapprox": "⪉",
	"lne": "⪇",
	"lnE": "≨",
	"lneq": "⪇",
	"lneqq": "≨",
	"lnsim": "⋦",
	"loang": "⟬",
	"loarr": "⇽",
	"lobrk": "⟦",
	"longleftarrow": "⟵",
	"LongLeftArrow": "⟵",
	"Longleftarrow": "⟸",
	"longleftrightarrow": "⟷",
	"LongLeftRightArrow": "⟷",
	"Longleftrightarrow": "⟺",
	"longmapsto": "⟼",
	"longrightarrow": "⟶",
	"LongRightArrow": "⟶",
	"Longrightarrow": "⟹",
	"looparrowleft": "↫",
	"looparrowright": "↬",
	"lopar": "⦅",
	"Lopf": "𝕃",
	"lopf": "𝕝",
	"loplus": "⨭",
	"lotimes": "⨴",
	"lowast": "∗",
	"lowbar": "_",
	"LowerLeftArrow": "↙",
	"LowerRightArrow": "↘",
	"loz": "◊",
	"lozenge": "◊",
	"lozf": "⧫",
	"lpar": "(",
	"lparlt": "⦓",
	"lrarr": "⇆",
	"lrcorner": "⌟",
	"lrhar": "⇋",
	"lrhard": "⥭",
	"lrm": "‎",
	"lrtri": "⊿",
	"lsaquo": "‹",
	"lscr": "𝓁",
	"Lscr": "ℒ",
	"lsh": "↰",
	"Lsh": "↰",
	"lsim": "≲",
	"lsime": "⪍",
	"lsimg": "⪏",
	"lsqb": "[",
	"lsquo": "‘",
	"lsquor": "‚",
	"Lstrok": "Ł",
	"lstrok": "ł",
	"ltcc": "⪦",
	"ltcir": "⩹",
	"lt": "<",
	"LT": "<",
	"Lt": "≪",
	"ltdot": "⋖",
	"lthree": "⋋",
	"ltimes": "⋉",
	"ltlarr": "⥶",
	"ltquest": "⩻",
	"ltri": "◃",
	"ltrie": "⊴",
	"ltrif": "◂",
	"ltrPar": "⦖",
	"lurdshar": "⥊",
	"luruhar": "⥦",
	"lvertneqq": "≨︀",
	"lvnE": "≨︀",
	"macr": "¯",
	"male": "♂",
	"malt": "✠",
	"maltese": "✠",
	"Map": "⤅",
	"map": "↦",
	"mapsto": "↦",
	"mapstodown": "↧",
	"mapstoleft": "↤",
	"mapstoup": "↥",
	"marker": "▮",
	"mcomma": "⨩",
	"Mcy": "М",
	"mcy": "м",
	"mdash": "—",
	"mDDot": "∺",
	"measuredangle": "∡",
	"MediumSpace": " ",
	"Mellintrf": "ℳ",
	"Mfr": "𝔐",
	"mfr": "𝔪",
	"mho": "℧",
	"micro": "µ",
	"midast": "*",
	"midcir": "⫰",
	"mid": "∣",
	"middot": "·",
	"minusb": "⊟",
	"minus": "−",
	"minusd": "∸",
	"minusdu": "⨪",
	"MinusPlus": "∓",
	"mlcp": "⫛",
	"mldr": "…",
	"mnplus": "∓",
	"models": "⊧",
	"Mopf": "𝕄",
	"mopf": "𝕞",
	"mp": "∓",
	"mscr": "𝓂",
	"Mscr": "ℳ",
	"mstpos": "∾",
	"Mu": "Μ",
	"mu": "μ",
	"multimap": "⊸",
	"mumap": "⊸",
	"nabla": "∇",
	"Nacute": "Ń",
	"nacute": "ń",
	"nang": "∠⃒",
	"nap": "≉",
	"napE": "⩰̸",
	"napid": "≋̸",
	"napos": "ŉ",
	"napprox": "≉",
	"natural": "♮",
	"naturals": "ℕ",
	"natur": "♮",
	"nbsp": " ",
	"nbump": "≎̸",
	"nbumpe": "≏̸",
	"ncap": "⩃",
	"Ncaron": "Ň",
	"ncaron": "ň",
	"Ncedil": "Ņ",
	"ncedil": "ņ",
	"ncong": "≇",
	"ncongdot": "⩭̸",
	"ncup": "⩂",
	"Ncy": "Н",
	"ncy": "н",
	"ndash": "–",
	"nearhk": "⤤",
	"nearr": "↗",
	"neArr": "⇗",
	"nearrow": "↗",
	"ne": "≠",
	"nedot": "≐̸",
	"NegativeMediumSpace": "​",
	"NegativeThickSpace": "​",
	"NegativeThinSpace": "​",
	"NegativeVeryThinSpace": "​",
	"nequiv": "≢",
	"nesear": "⤨",
	"nesim": "≂̸",
	"NestedGreaterGreater": "≫",
	"NestedLessLess": "≪",
	"NewLine": "\n",
	"nexist": "∄",
	"nexists": "∄",
	"Nfr": "𝔑",
	"nfr": "𝔫",
	"ngE": "≧̸",
	"nge": "≱",
	"ngeq": "≱",
	"ngeqq": "≧̸",
	"ngeqslant": "⩾̸",
	"nges": "⩾̸",
	"nGg": "⋙̸",
	"ngsim": "≵",
	"nGt": "≫⃒",
	"ngt": "≯",
	"ngtr": "≯",
	"nGtv": "≫̸",
	"nharr": "↮",
	"nhArr": "⇎",
	"nhpar": "⫲",
	"ni": "∋",
	"nis": "⋼",
	"nisd": "⋺",
	"niv": "∋",
	"NJcy": "Њ",
	"njcy": "њ",
	"nlarr": "↚",
	"nlArr": "⇍",
	"nldr": "‥",
	"nlE": "≦̸",
	"nle": "≰",
	"nleftarrow": "↚",
	"nLeftarrow": "⇍",
	"nleftrightarrow": "↮",
	"nLeftrightarrow": "⇎",
	"nleq": "≰",
	"nleqq": "≦̸",
	"nleqslant": "⩽̸",
	"nles": "⩽̸",
	"nless": "≮",
	"nLl": "⋘̸",
	"nlsim": "≴",
	"nLt": "≪⃒",
	"nlt": "≮",
	"nltri": "⋪",
	"nltrie": "⋬",
	"nLtv": "≪̸",
	"nmid": "∤",
	"NoBreak": "⁠",
	"NonBreakingSpace": " ",
	"nopf": "𝕟",
	"Nopf": "ℕ",
	"Not": "⫬",
	"not": "¬",
	"NotCongruent": "≢",
	"NotCupCap": "≭",
	"NotDoubleVerticalBar": "∦",
	"NotElement": "∉",
	"NotEqual": "≠",
	"NotEqualTilde": "≂̸",
	"NotExists": "∄",
	"NotGreater": "≯",
	"NotGreaterEqual": "≱",
	"NotGreaterFullEqual": "≧̸",
	"NotGreaterGreater": "≫̸",
	"NotGreaterLess": "≹",
	"NotGreaterSlantEqual": "⩾̸",
	"NotGreaterTilde": "≵",
	"NotHumpDownHump": "≎̸",
	"NotHumpEqual": "≏̸",
	"notin": "∉",
	"notindot": "⋵̸",
	"notinE": "⋹̸",
	"notinva": "∉",
	"notinvb": "⋷",
	"notinvc": "⋶",
	"NotLeftTriangleBar": "⧏̸",
	"NotLeftTriangle": "⋪",
	"NotLeftTriangleEqual": "⋬",
	"NotLess": "≮",
	"NotLessEqual": "≰",
	"NotLessGreater": "≸",
	"NotLessLess": "≪̸",
	"NotLessSlantEqual": "⩽̸",
	"NotLessTilde": "≴",
	"NotNestedGreaterGreater": "⪢̸",
	"NotNestedLessLess": "⪡̸",
	"notni": "∌",
	"notniva": "∌",
	"notnivb": "⋾",
	"notnivc": "⋽",
	"NotPrecedes": "⊀",
	"NotPrecedesEqual": "⪯̸",
	"NotPrecedesSlantEqual": "⋠",
	"NotReverseElement": "∌",
	"NotRightTriangleBar": "⧐̸",
	"NotRightTriangle": "⋫",
	"NotRightTriangleEqual": "⋭",
	"NotSquareSubset": "⊏̸",
	"NotSquareSubsetEqual": "⋢",
	"NotSquareSuperset": "⊐̸",
	"NotSquareSupersetEqual": "⋣",
	"NotSubset": "⊂⃒",
	"NotSubsetEqual": "⊈",
	"NotSucceeds": "⊁",
	"NotSucceedsEqual": "⪰̸",
	"NotSucceedsSlantEqual": "⋡",
	"NotSucceedsTilde": "≿̸",
	"NotSuperset": "⊃⃒",
	"NotSupersetEqual": "⊉",
	"NotTilde": "≁",
	"NotTildeEqual": "≄",
	"NotTildeFullEqual": "≇",
	"NotTildeTilde": "≉",
	"NotVerticalBar": "∤",
	"nparallel": "∦",
	"npar": "∦",
	"nparsl": "⫽⃥",
	"npart": "∂̸",
	"npolint": "⨔",
	"npr": "⊀",
	"nprcue": "⋠",
	"nprec": "⊀",
	"npreceq": "⪯̸",
	"npre": "⪯̸",
	"nrarrc": "⤳̸",
	"nrarr": "↛",
	"nrArr": "⇏",
	"nrarrw": "↝̸",
	"nrightarrow": "↛",
	"nRightarrow": "⇏",
	"nrtri": "⋫",
	"nrtrie": "⋭",
	"nsc": "⊁",
	"nsccue": "⋡",
	"nsce": "⪰̸",
	"Nscr": "𝒩",
	"nscr": "𝓃",
	"nshortmid": "∤",
	"nshortparallel": "∦",
	"nsim": "≁",
	"nsime": "≄",
	"nsimeq": "≄",
	"nsmid": "∤",
	"nspar": "∦",
	"nsqsube": "⋢",
	"nsqsupe": "⋣",
	"nsub": "⊄",
	"nsubE": "⫅̸",
	"nsube": "⊈",
	"nsubset": "⊂⃒",
	"nsubseteq": "⊈",
	"nsubseteqq": "⫅̸",
	"nsucc": "⊁",
	"nsucceq": "⪰̸",
	"nsup": "⊅",
	"nsupE": "⫆̸",
	"nsupe": "⊉",
	"nsupset": "⊃⃒",
	"nsupseteq": "⊉",
	"nsupseteqq": "⫆̸",
	"ntgl": "≹",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"ntlg": "≸",
	"ntriangleleft": "⋪",
	"ntrianglelefteq": "⋬",
	"ntriangleright": "⋫",
	"ntrianglerighteq": "⋭",
	"Nu": "Ν",
	"nu": "ν",
	"num": "#",
	"numero": "№",
	"numsp": " ",
	"nvap": "≍⃒",
	"nvdash": "⊬",
	"nvDash": "⊭",
	"nVdash": "⊮",
	"nVDash": "⊯",
	"nvge": "≥⃒",
	"nvgt": ">⃒",
	"nvHarr": "⤄",
	"nvinfin": "⧞",
	"nvlArr": "⤂",
	"nvle": "≤⃒",
	"nvlt": "<⃒",
	"nvltrie": "⊴⃒",
	"nvrArr": "⤃",
	"nvrtrie": "⊵⃒",
	"nvsim": "∼⃒",
	"nwarhk": "⤣",
	"nwarr": "↖",
	"nwArr": "⇖",
	"nwarrow": "↖",
	"nwnear": "⤧",
	"Oacute": "Ó",
	"oacute": "ó",
	"oast": "⊛",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"ocir": "⊚",
	"Ocy": "О",
	"ocy": "о",
	"odash": "⊝",
	"Odblac": "Ő",
	"odblac": "ő",
	"odiv": "⨸",
	"odot": "⊙",
	"odsold": "⦼",
	"OElig": "Œ",
	"oelig": "œ",
	"ofcir": "⦿",
	"Ofr": "𝔒",
	"ofr": "𝔬",
	"ogon": "˛",
	"Ograve": "Ò",
	"ograve": "ò",
	"ogt": "⧁",
	"ohbar": "⦵",
	"ohm": "Ω",
	"oint": "∮",
	"olarr": "↺",
	"olcir": "⦾",
	"olcross": "⦻",
	"oline": "‾",
	"olt": "⧀",
	"Omacr": "Ō",
	"omacr": "ō",
	"Omega": "Ω",
	"omega": "ω",
	"Omicron": "Ο",
	"omicron": "ο",
	"omid": "⦶",
	"ominus": "⊖",
	"Oopf": "𝕆",
	"oopf": "𝕠",
	"opar": "⦷",
	"OpenCurlyDoubleQuote": "“",
	"OpenCurlyQuote": "‘",
	"operp": "⦹",
	"oplus": "⊕",
	"orarr": "↻",
	"Or": "⩔",
	"or": "∨",
	"ord": "⩝",
	"order": "ℴ",
	"orderof": "ℴ",
	"ordf": "ª",
	"ordm": "º",
	"origof": "⊶",
	"oror": "⩖",
	"orslope": "⩗",
	"orv": "⩛",
	"oS": "Ⓢ",
	"Oscr": "𝒪",
	"oscr": "ℴ",
	"Oslash": "Ø",
	"oslash": "ø",
	"osol": "⊘",
	"Otilde": "Õ",
	"otilde": "õ",
	"otimesas": "⨶",
	"Otimes": "⨷",
	"otimes": "⊗",
	"Ouml": "Ö",
	"ouml": "ö",
	"ovbar": "⌽",
	"OverBar": "‾",
	"OverBrace": "⏞",
	"OverBracket": "⎴",
	"OverParenthesis": "⏜",
	"para": "¶",
	"parallel": "∥",
	"par": "∥",
	"parsim": "⫳",
	"parsl": "⫽",
	"part": "∂",
	"PartialD": "∂",
	"Pcy": "П",
	"pcy": "п",
	"percnt": "%",
	"period": ".",
	"permil": "‰",
	"perp": "⊥",
	"pertenk": "‱",
	"Pfr": "𝔓",
	"pfr": "𝔭",
	"Phi": "Φ",
	"phi": "φ",
	"phiv": "ϕ",
	"phmmat": "ℳ",
	"phone": "☎",
	"Pi": "Π",
	"pi": "π",
	"pitchfork": "⋔",
	"piv": "ϖ",
	"planck": "ℏ",
	"planckh": "ℎ",
	"plankv": "ℏ",
	"plusacir": "⨣",
	"plusb": "⊞",
	"pluscir": "⨢",
	"plus": "+",
	"plusdo": "∔",
	"plusdu": "⨥",
	"pluse": "⩲",
	"PlusMinus": "±",
	"plusmn": "±",
	"plussim": "⨦",
	"plustwo": "⨧",
	"pm": "±",
	"Poincareplane": "ℌ",
	"pointint": "⨕",
	"popf": "𝕡",
	"Popf": "ℙ",
	"pound": "£",
	"prap": "⪷",
	"Pr": "⪻",
	"pr": "≺",
	"prcue": "≼",
	"precapprox": "⪷",
	"prec": "≺",
	"preccurlyeq": "≼",
	"Precedes": "≺",
	"PrecedesEqual": "⪯",
	"PrecedesSlantEqual": "≼",
	"PrecedesTilde": "≾",
	"preceq": "⪯",
	"precnapprox": "⪹",
	"precneqq": "⪵",
	"precnsim": "⋨",
	"pre": "⪯",
	"prE": "⪳",
	"precsim": "≾",
	"prime": "′",
	"Prime": "″",
	"primes": "ℙ",
	"prnap": "⪹",
	"prnE": "⪵",
	"prnsim": "⋨",
	"prod": "∏",
	"Product": "∏",
	"profalar": "⌮",
	"profline": "⌒",
	"profsurf": "⌓",
	"prop": "∝",
	"Proportional": "∝",
	"Proportion": "∷",
	"propto": "∝",
	"prsim": "≾",
	"prurel": "⊰",
	"Pscr": "𝒫",
	"pscr": "𝓅",
	"Psi": "Ψ",
	"psi": "ψ",
	"puncsp": " ",
	"Qfr": "𝔔",
	"qfr": "𝔮",
	"qint": "⨌",
	"qopf": "𝕢",
	"Qopf": "ℚ",
	"qprime": "⁗",
	"Qscr": "𝒬",
	"qscr": "𝓆",
	"quaternions": "ℍ",
	"quatint": "⨖",
	"quest": "?",
	"questeq": "≟",
	"quot": "\"",
	"QUOT": "\"",
	"rAarr": "⇛",
	"race": "∽̱",
	"Racute": "Ŕ",
	"racute": "ŕ",
	"radic": "√",
	"raemptyv": "⦳",
	"rang": "⟩",
	"Rang": "⟫",
	"rangd": "⦒",
	"range": "⦥",
	"rangle": "⟩",
	"raquo": "»",
	"rarrap": "⥵",
	"rarrb": "⇥",
	"rarrbfs": "⤠",
	"rarrc": "⤳",
	"rarr": "→",
	"Rarr": "↠",
	"rArr": "⇒",
	"rarrfs": "⤞",
	"rarrhk": "↪",
	"rarrlp": "↬",
	"rarrpl": "⥅",
	"rarrsim": "⥴",
	"Rarrtl": "⤖",
	"rarrtl": "↣",
	"rarrw": "↝",
	"ratail": "⤚",
	"rAtail": "⤜",
	"ratio": "∶",
	"rationals": "ℚ",
	"rbarr": "⤍",
	"rBarr": "⤏",
	"RBarr": "⤐",
	"rbbrk": "❳",
	"rbrace": "}",
	"rbrack": "]",
	"rbrke": "⦌",
	"rbrksld": "⦎",
	"rbrkslu": "⦐",
	"Rcaron": "Ř",
	"rcaron": "ř",
	"Rcedil": "Ŗ",
	"rcedil": "ŗ",
	"rceil": "⌉",
	"rcub": "}",
	"Rcy": "Р",
	"rcy": "р",
	"rdca": "⤷",
	"rdldhar": "⥩",
	"rdquo": "”",
	"rdquor": "”",
	"rdsh": "↳",
	"real": "ℜ",
	"realine": "ℛ",
	"realpart": "ℜ",
	"reals": "ℝ",
	"Re": "ℜ",
	"rect": "▭",
	"reg": "®",
	"REG": "®",
	"ReverseElement": "∋",
	"ReverseEquilibrium": "⇋",
	"ReverseUpEquilibrium": "⥯",
	"rfisht": "⥽",
	"rfloor": "⌋",
	"rfr": "𝔯",
	"Rfr": "ℜ",
	"rHar": "⥤",
	"rhard": "⇁",
	"rharu": "⇀",
	"rharul": "⥬",
	"Rho": "Ρ",
	"rho": "ρ",
	"rhov": "ϱ",
	"RightAngleBracket": "⟩",
	"RightArrowBar": "⇥",
	"rightarrow": "→",
	"RightArrow": "→",
	"Rightarrow": "⇒",
	"RightArrowLeftArrow": "⇄",
	"rightarrowtail": "↣",
	"RightCeiling": "⌉",
	"RightDoubleBracket": "⟧",
	"RightDownTeeVector": "⥝",
	"RightDownVectorBar": "⥕",
	"RightDownVector": "⇂",
	"RightFloor": "⌋",
	"rightharpoondown": "⇁",
	"rightharpoonup": "⇀",
	"rightleftarrows": "⇄",
	"rightleftharpoons": "⇌",
	"rightrightarrows": "⇉",
	"rightsquigarrow": "↝",
	"RightTeeArrow": "↦",
	"RightTee": "⊢",
	"RightTeeVector": "⥛",
	"rightthreetimes": "⋌",
	"RightTriangleBar": "⧐",
	"RightTriangle": "⊳",
	"RightTriangleEqual": "⊵",
	"RightUpDownVector": "⥏",
	"RightUpTeeVector": "⥜",
	"RightUpVectorBar": "⥔",
	"RightUpVector": "↾",
	"RightVectorBar": "⥓",
	"RightVector": "⇀",
	"ring": "˚",
	"risingdotseq": "≓",
	"rlarr": "⇄",
	"rlhar": "⇌",
	"rlm": "‏",
	"rmoustache": "⎱",
	"rmoust": "⎱",
	"rnmid": "⫮",
	"roang": "⟭",
	"roarr": "⇾",
	"robrk": "⟧",
	"ropar": "⦆",
	"ropf": "𝕣",
	"Ropf": "ℝ",
	"roplus": "⨮",
	"rotimes": "⨵",
	"RoundImplies": "⥰",
	"rpar": ")",
	"rpargt": "⦔",
	"rppolint": "⨒",
	"rrarr": "⇉",
	"Rrightarrow": "⇛",
	"rsaquo": "›",
	"rscr": "𝓇",
	"Rscr": "ℛ",
	"rsh": "↱",
	"Rsh": "↱",
	"rsqb": "]",
	"rsquo": "’",
	"rsquor": "’",
	"rthree": "⋌",
	"rtimes": "⋊",
	"rtri": "▹",
	"rtrie": "⊵",
	"rtrif": "▸",
	"rtriltri": "⧎",
	"RuleDelayed": "⧴",
	"ruluhar": "⥨",
	"rx": "℞",
	"Sacute": "Ś",
	"sacute": "ś",
	"sbquo": "‚",
	"scap": "⪸",
	"Scaron": "Š",
	"scaron": "š",
	"Sc": "⪼",
	"sc": "≻",
	"sccue": "≽",
	"sce": "⪰",
	"scE": "⪴",
	"Scedil": "Ş",
	"scedil": "ş",
	"Scirc": "Ŝ",
	"scirc": "ŝ",
	"scnap": "⪺",
	"scnE": "⪶",
	"scnsim": "⋩",
	"scpolint": "⨓",
	"scsim": "≿",
	"Scy": "С",
	"scy": "с",
	"sdotb": "⊡",
	"sdot": "⋅",
	"sdote": "⩦",
	"searhk": "⤥",
	"searr": "↘",
	"seArr": "⇘",
	"searrow": "↘",
	"sect": "§",
	"semi": ";",
	"seswar": "⤩",
	"setminus": "∖",
	"setmn": "∖",
	"sext": "✶",
	"Sfr": "𝔖",
	"sfr": "𝔰",
	"sfrown": "⌢",
	"sharp": "♯",
	"SHCHcy": "Щ",
	"shchcy": "щ",
	"SHcy": "Ш",
	"shcy": "ш",
	"ShortDownArrow": "↓",
	"ShortLeftArrow": "←",
	"shortmid": "∣",
	"shortparallel": "∥",
	"ShortRightArrow": "→",
	"ShortUpArrow": "↑",
	"shy": "­",
	"Sigma": "Σ",
	"sigma": "σ",
	"sigmaf": "ς",
	"sigmav": "ς",
	"sim": "∼",
	"simdot": "⩪",
	"sime": "≃",
	"simeq": "≃",
	"simg": "⪞",
	"simgE": "⪠",
	"siml": "⪝",
	"simlE": "⪟",
	"simne": "≆",
	"simplus": "⨤",
	"simrarr": "⥲",
	"slarr": "←",
	"SmallCircle": "∘",
	"smallsetminus": "∖",
	"smashp": "⨳",
	"smeparsl": "⧤",
	"smid": "∣",
	"smile": "⌣",
	"smt": "⪪",
	"smte": "⪬",
	"smtes": "⪬︀",
	"SOFTcy": "Ь",
	"softcy": "ь",
	"solbar": "⌿",
	"solb": "⧄",
	"sol": "/",
	"Sopf": "𝕊",
	"sopf": "𝕤",
	"spades": "♠",
	"spadesuit": "♠",
	"spar": "∥",
	"sqcap": "⊓",
	"sqcaps": "⊓︀",
	"sqcup": "⊔",
	"sqcups": "⊔︀",
	"Sqrt": "√",
	"sqsub": "⊏",
	"sqsube": "⊑",
	"sqsubset": "⊏",
	"sqsubseteq": "⊑",
	"sqsup": "⊐",
	"sqsupe": "⊒",
	"sqsupset": "⊐",
	"sqsupseteq": "⊒",
	"square": "□",
	"Square": "□",
	"SquareIntersection": "⊓",
	"SquareSubset": "⊏",
	"SquareSubsetEqual": "⊑",
	"SquareSuperset": "⊐",
	"SquareSupersetEqual": "⊒",
	"SquareUnion": "⊔",
	"squarf": "▪",
	"squ": "□",
	"squf": "▪",
	"srarr": "→",
	"Sscr": "𝒮",
	"sscr": "𝓈",
	"ssetmn": "∖",
	"ssmile": "⌣",
	"sstarf": "⋆",
	"Star": "⋆",
	"star": "☆",
	"starf": "★",
	"straightepsilon": "ϵ",
	"straightphi": "ϕ",
	"strns": "¯",
	"sub": "⊂",
	"Sub": "⋐",
	"subdot": "⪽",
	"subE": "⫅",
	"sube": "⊆",
	"subedot": "⫃",
	"submult": "⫁",
	"subnE": "⫋",
	"subne": "⊊",
	"subplus": "⪿",
	"subrarr": "⥹",
	"subset": "⊂",
	"Subset": "⋐",
	"subseteq": "⊆",
	"subseteqq": "⫅",
	"SubsetEqual": "⊆",
	"subsetneq": "⊊",
	"subsetneqq": "⫋",
	"subsim": "⫇",
	"subsub": "⫕",
	"subsup": "⫓",
	"succapprox": "⪸",
	"succ": "≻",
	"succcurlyeq": "≽",
	"Succeeds": "≻",
	"SucceedsEqual": "⪰",
	"SucceedsSlantEqual": "≽",
	"SucceedsTilde": "≿",
	"succeq": "⪰",
	"succnapprox": "⪺",
	"succneqq": "⪶",
	"succnsim": "⋩",
	"succsim": "≿",
	"SuchThat": "∋",
	"sum": "∑",
	"Sum": "∑",
	"sung": "♪",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"sup": "⊃",
	"Sup": "⋑",
	"supdot": "⪾",
	"supdsub": "⫘",
	"supE": "⫆",
	"supe": "⊇",
	"supedot": "⫄",
	"Superset": "⊃",
	"SupersetEqual": "⊇",
	"suphsol": "⟉",
	"suphsub": "⫗",
	"suplarr": "⥻",
	"supmult": "⫂",
	"supnE": "⫌",
	"supne": "⊋",
	"supplus": "⫀",
	"supset": "⊃",
	"Supset": "⋑",
	"supseteq": "⊇",
	"supseteqq": "⫆",
	"supsetneq": "⊋",
	"supsetneqq": "⫌",
	"supsim": "⫈",
	"supsub": "⫔",
	"supsup": "⫖",
	"swarhk": "⤦",
	"swarr": "↙",
	"swArr": "⇙",
	"swarrow": "↙",
	"swnwar": "⤪",
	"szlig": "ß",
	"Tab": "\t",
	"target": "⌖",
	"Tau": "Τ",
	"tau": "τ",
	"tbrk": "⎴",
	"Tcaron": "Ť",
	"tcaron": "ť",
	"Tcedil": "Ţ",
	"tcedil": "ţ",
	"Tcy": "Т",
	"tcy": "т",
	"tdot": "⃛",
	"telrec": "⌕",
	"Tfr": "𝔗",
	"tfr": "𝔱",
	"there4": "∴",
	"therefore": "∴",
	"Therefore": "∴",
	"Theta": "Θ",
	"theta": "θ",
	"thetasym": "ϑ",
	"thetav": "ϑ",
	"thickapprox": "≈",
	"thicksim": "∼",
	"ThickSpace": "  ",
	"ThinSpace": " ",
	"thinsp": " ",
	"thkap": "≈",
	"thksim": "∼",
	"THORN": "Þ",
	"thorn": "þ",
	"tilde": "˜",
	"Tilde": "∼",
	"TildeEqual": "≃",
	"TildeFullEqual": "≅",
	"TildeTilde": "≈",
	"timesbar": "⨱",
	"timesb": "⊠",
	"times": "×",
	"timesd": "⨰",
	"tint": "∭",
	"toea": "⤨",
	"topbot": "⌶",
	"topcir": "⫱",
	"top": "⊤",
	"Topf": "𝕋",
	"topf": "𝕥",
	"topfork": "⫚",
	"tosa": "⤩",
	"tprime": "‴",
	"trade": "™",
	"TRADE": "™",
	"triangle": "▵",
	"triangledown": "▿",
	"triangleleft": "◃",
	"trianglelefteq": "⊴",
	"triangleq": "≜",
	"triangleright": "▹",
	"trianglerighteq": "⊵",
	"tridot": "◬",
	"trie": "≜",
	"triminus": "⨺",
	"TripleDot": "⃛",
	"triplus": "⨹",
	"trisb": "⧍",
	"tritime": "⨻",
	"trpezium": "⏢",
	"Tscr": "𝒯",
	"tscr": "𝓉",
	"TScy": "Ц",
	"tscy": "ц",
	"TSHcy": "Ћ",
	"tshcy": "ћ",
	"Tstrok": "Ŧ",
	"tstrok": "ŧ",
	"twixt": "≬",
	"twoheadleftarrow": "↞",
	"twoheadrightarrow": "↠",
	"Uacute": "Ú",
	"uacute": "ú",
	"uarr": "↑",
	"Uarr": "↟",
	"uArr": "⇑",
	"Uarrocir": "⥉",
	"Ubrcy": "Ў",
	"ubrcy": "ў",
	"Ubreve": "Ŭ",
	"ubreve": "ŭ",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ucy": "У",
	"ucy": "у",
	"udarr": "⇅",
	"Udblac": "Ű",
	"udblac": "ű",
	"udhar": "⥮",
	"ufisht": "⥾",
	"Ufr": "𝔘",
	"ufr": "𝔲",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uHar": "⥣",
	"uharl": "↿",
	"uharr": "↾",
	"uhblk": "▀",
	"ulcorn": "⌜",
	"ulcorner": "⌜",
	"ulcrop": "⌏",
	"ultri": "◸",
	"Umacr": "Ū",
	"umacr": "ū",
	"uml": "¨",
	"UnderBar": "_",
	"UnderBrace": "⏟",
	"UnderBracket": "⎵",
	"UnderParenthesis": "⏝",
	"Union": "⋃",
	"UnionPlus": "⊎",
	"Uogon": "Ų",
	"uogon": "ų",
	"Uopf": "𝕌",
	"uopf": "𝕦",
	"UpArrowBar": "⤒",
	"uparrow": "↑",
	"UpArrow": "↑",
	"Uparrow": "⇑",
	"UpArrowDownArrow": "⇅",
	"updownarrow": "↕",
	"UpDownArrow": "↕",
	"Updownarrow": "⇕",
	"UpEquilibrium": "⥮",
	"upharpoonleft": "↿",
	"upharpoonright": "↾",
	"uplus": "⊎",
	"UpperLeftArrow": "↖",
	"UpperRightArrow": "↗",
	"upsi": "υ",
	"Upsi": "ϒ",
	"upsih": "ϒ",
	"Upsilon": "Υ",
	"upsilon": "υ",
	"UpTeeArrow": "↥",
	"UpTee": "⊥",
	"upuparrows": "⇈",
	"urcorn": "⌝",
	"urcorner": "⌝",
	"urcrop": "⌎",
	"Uring": "Ů",
	"uring": "ů",
	"urtri": "◹",
	"Uscr": "𝒰",
	"uscr": "𝓊",
	"utdot": "⋰",
	"Utilde": "Ũ",
	"utilde": "ũ",
	"utri": "▵",
	"utrif": "▴",
	"uuarr": "⇈",
	"Uuml": "Ü",
	"uuml": "ü",
	"uwangle": "⦧",
	"vangrt": "⦜",
	"varepsilon": "ϵ",
	"varkappa": "ϰ",
	"varnothing": "∅",
	"varphi": "ϕ",
	"varpi": "ϖ",
	"varpropto": "∝",
	"varr": "↕",
	"vArr": "⇕",
	"varrho": "ϱ",
	"varsigma": "ς",
	"varsubsetneq": "⊊︀",
	"varsubsetneqq": "⫋︀",
	"varsupsetneq": "⊋︀",
	"varsupsetneqq": "⫌︀",
	"vartheta": "ϑ",
	"vartriangleleft": "⊲",
	"vartriangleright": "⊳",
	"vBar": "⫨",
	"Vbar": "⫫",
	"vBarv": "⫩",
	"Vcy": "В",
	"vcy": "в",
	"vdash": "⊢",
	"vDash": "⊨",
	"Vdash": "⊩",
	"VDash": "⊫",
	"Vdashl": "⫦",
	"veebar": "⊻",
	"vee": "∨",
	"Vee": "⋁",
	"veeeq": "≚",
	"vellip": "⋮",
	"verbar": "|",
	"Verbar": "‖",
	"vert": "|",
	"Vert": "‖",
	"VerticalBar": "∣",
	"VerticalLine": "|",
	"VerticalSeparator": "❘",
	"VerticalTilde": "≀",
	"VeryThinSpace": " ",
	"Vfr": "𝔙",
	"vfr": "𝔳",
	"vltri": "⊲",
	"vnsub": "⊂⃒",
	"vnsup": "⊃⃒",
	"Vopf": "𝕍",
	"vopf": "𝕧",
	"vprop": "∝",
	"vrtri": "⊳",
	"Vscr": "𝒱",
	"vscr": "𝓋",
	"vsubnE": "⫋︀",
	"vsubne": "⊊︀",
	"vsupnE": "⫌︀",
	"vsupne": "⊋︀",
	"Vvdash": "⊪",
	"vzigzag": "⦚",
	"Wcirc": "Ŵ",
	"wcirc": "ŵ",
	"wedbar": "⩟",
	"wedge": "∧",
	"Wedge": "⋀",
	"wedgeq": "≙",
	"weierp": "℘",
	"Wfr": "𝔚",
	"wfr": "𝔴",
	"Wopf": "𝕎",
	"wopf": "𝕨",
	"wp": "℘",
	"wr": "≀",
	"wreath": "≀",
	"Wscr": "𝒲",
	"wscr": "𝓌",
	"xcap": "⋂",
	"xcirc": "◯",
	"xcup": "⋃",
	"xdtri": "▽",
	"Xfr": "𝔛",
	"xfr": "𝔵",
	"xharr": "⟷",
	"xhArr": "⟺",
	"Xi": "Ξ",
	"xi": "ξ",
	"xlarr": "⟵",
	"xlArr": "⟸",
	"xmap": "⟼",
	"xnis": "⋻",
	"xodot": "⨀",
	"Xopf": "𝕏",
	"xopf": "𝕩",
	"xoplus": "⨁",
	"xotime": "⨂",
	"xrarr": "⟶",
	"xrArr": "⟹",
	"Xscr": "𝒳",
	"xscr": "𝓍",
	"xsqcup": "⨆",
	"xuplus": "⨄",
	"xutri": "△",
	"xvee": "⋁",
	"xwedge": "⋀",
	"Yacute": "Ý",
	"yacute": "ý",
	"YAcy": "Я",
	"yacy": "я",
	"Ycirc": "Ŷ",
	"ycirc": "ŷ",
	"Ycy": "Ы",
	"ycy": "ы",
	"yen": "¥",
	"Yfr": "𝔜",
	"yfr": "𝔶",
	"YIcy": "Ї",
	"yicy": "ї",
	"Yopf": "𝕐",
	"yopf": "𝕪",
	"Yscr": "𝒴",
	"yscr": "𝓎",
	"YUcy": "Ю",
	"yucy": "ю",
	"yuml": "ÿ",
	"Yuml": "Ÿ",
	"Zacute": "Ź",
	"zacute": "ź",
	"Zcaron": "Ž",
	"zcaron": "ž",
	"Zcy": "З",
	"zcy": "з",
	"Zdot": "Ż",
	"zdot": "ż",
	"zeetrf": "ℨ",
	"ZeroWidthSpace": "​",
	"Zeta": "Ζ",
	"zeta": "ζ",
	"zfr": "𝔷",
	"Zfr": "ℨ",
	"ZHcy": "Ж",
	"zhcy": "ж",
	"zigrarr": "⇝",
	"zopf": "𝕫",
	"Zopf": "ℤ",
	"Zscr": "𝒵",
	"zscr": "𝓏",
	"zwj": "‍",
	"zwnj": "‌"
};

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by john on 7/20/15.
 */



module.exports = {
    NAV: {
        'ACTIVE_GROUP_CHANGED': 'globalNav:activeGroupChanged',
        'ITEMS_ADDED': 'globalNav:itemsAdded',
        'ITEMS_REMOVED': 'globalNav:itemsRemoved',
        'TOGGLE_MENU': 'globalNav:toggleMenu',
        'TOGGLE_SEARCH': 'globalNav:toggleSearch',
        'NAVIGATED': 'globalNav:navigated',
        'RECEIVED_LIST_DATA': 'globalNav:receivedListData'
    },
    SEARCH: {
        'SEARCH_TERM_CHANGED': 'SEARCH_TERM_CHANGED',
        'SEARCH_RESULT_RETURNED': 'SEARCH_RESULT_RETURNED'
    },
    CART: {
        'cart:updated': 'cart:updated'
    },
    HAMBURGER: {
        'UPDATE_LOGIN': 'hamburgerMenu:updateLogin',
        'UPDATE_USER_INITIALS': 'hamburgerMenu:updateUserInitials',
        'UPDATE_USER_STATES': 'hamburgerMenu:updateUserStates'
    }
};


/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

var Tokenizer = __webpack_require__(351);

/*
	Options:

	xmlMode: Disables the special behavior for script/style tags (false by default)
	lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
	lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
*/

/*
	Callbacks:

	oncdataend,
	oncdatastart,
	onclosetag,
	oncomment,
	oncommentend,
	onerror,
	onopentag,
	onprocessinginstruction,
	onreset,
	ontext
*/

var formTags = {
	input: true,
	option: true,
	optgroup: true,
	select: true,
	button: true,
	datalist: true,
	textarea: true
};

var openImpliesClose = {
	tr      : { tr:true, th:true, td:true },
	th      : { th:true },
	td      : { thead:true, th:true, td:true },
	body    : { head:true, link:true, script:true },
	li      : { li:true },
	p       : { p:true },
	h1      : { p:true },
	h2      : { p:true },
	h3      : { p:true },
	h4      : { p:true },
	h5      : { p:true },
	h6      : { p:true },
	select  : formTags,
	input   : formTags,
	output  : formTags,
	button  : formTags,
	datalist: formTags,
	textarea: formTags,
	option  : { option:true },
	optgroup: { optgroup:true }
};

var voidElements = {
	__proto__: null,
	area: true,
	base: true,
	basefont: true,
	br: true,
	col: true,
	command: true,
	embed: true,
	frame: true,
	hr: true,
	img: true,
	input: true,
	isindex: true,
	keygen: true,
	link: true,
	meta: true,
	param: true,
	source: true,
	track: true,
	wbr: true,

	//common self closing svg elements
	path: true,
	circle: true,
	ellipse: true,
	line: true,
	rect: true,
	use: true,
	stop: true,
	polyline: true,
	polygon: true
};

var re_nameEnd = /\s|\//;

function Parser(cbs, options){
	this._options = options || {};
	this._cbs = cbs || {};

	this._tagname = "";
	this._attribname = "";
	this._attribvalue = "";
	this._attribs = null;
	this._stack = [];

	this.startIndex = 0;
	this.endIndex = null;

	this._lowerCaseTagNames = "lowerCaseTags" in this._options ?
									!!this._options.lowerCaseTags :
									!this._options.xmlMode;
	this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ?
									!!this._options.lowerCaseAttributeNames :
									!this._options.xmlMode;

	if(this._options.Tokenizer) {
		Tokenizer = this._options.Tokenizer;
	}
	this._tokenizer = new Tokenizer(this._options, this);

	if(this._cbs.onparserinit) this._cbs.onparserinit(this);
}

__webpack_require__(59)(Parser, __webpack_require__(277).EventEmitter);

Parser.prototype._updatePosition = function(initialOffset){
	if(this.endIndex === null){
		if(this._tokenizer._sectionStart <= initialOffset){
			this.startIndex = 0;
		} else {
			this.startIndex = this._tokenizer._sectionStart - initialOffset;
		}
	}
	else this.startIndex = this.endIndex + 1;
	this.endIndex = this._tokenizer.getAbsoluteIndex();
};

//Tokenizer event handlers
Parser.prototype.ontext = function(data){
	this._updatePosition(1);
	this.endIndex--;

	if(this._cbs.ontext) this._cbs.ontext(data);
};

Parser.prototype.onopentagname = function(name){
	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	this._tagname = name;

	if(!this._options.xmlMode && name in openImpliesClose) {
		for(
			var el;
			(el = this._stack[this._stack.length - 1]) in openImpliesClose[name];
			this.onclosetag(el)
		);
	}

	if(this._options.xmlMode || !(name in voidElements)){
		this._stack.push(name);
	}

	if(this._cbs.onopentagname) this._cbs.onopentagname(name);
	if(this._cbs.onopentag) this._attribs = {};
};

Parser.prototype.onopentagend = function(){
	this._updatePosition(1);

	if(this._attribs){
		if(this._cbs.onopentag) this._cbs.onopentag(this._tagname, this._attribs);
		this._attribs = null;
	}

	if(!this._options.xmlMode && this._cbs.onclosetag && this._tagname in voidElements){
		this._cbs.onclosetag(this._tagname);
	}

	this._tagname = "";
};

Parser.prototype.onclosetag = function(name){
	this._updatePosition(1);

	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	if(this._stack.length && (!(name in voidElements) || this._options.xmlMode)){
		var pos = this._stack.lastIndexOf(name);
		if(pos !== -1){
			if(this._cbs.onclosetag){
				pos = this._stack.length - pos;
				while(pos--) this._cbs.onclosetag(this._stack.pop());
			}
			else this._stack.length = pos;
		} else if(name === "p" && !this._options.xmlMode){
			this.onopentagname(name);
			this._closeCurrentTag();
		}
	} else if(!this._options.xmlMode && (name === "br" || name === "p")){
		this.onopentagname(name);
		this._closeCurrentTag();
	}
};

Parser.prototype.onselfclosingtag = function(){
	if(this._options.xmlMode || this._options.recognizeSelfClosing){
		this._closeCurrentTag();
	} else {
		this.onopentagend();
	}
};

Parser.prototype._closeCurrentTag = function(){
	var name = this._tagname;

	this.onopentagend();

	//self-closing tags will be on the top of the stack
	//(cheaper check than in onclosetag)
	if(this._stack[this._stack.length - 1] === name){
		if(this._cbs.onclosetag){
			this._cbs.onclosetag(name);
		}
		this._stack.pop();
	}
};

Parser.prototype.onattribname = function(name){
	if(this._lowerCaseAttributeNames){
		name = name.toLowerCase();
	}
	this._attribname = name;
};

Parser.prototype.onattribdata = function(value){
	this._attribvalue += value;
};

Parser.prototype.onattribend = function(){
	if(this._cbs.onattribute) this._cbs.onattribute(this._attribname, this._attribvalue);
	if(
		this._attribs &&
		!Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
	){
		this._attribs[this._attribname] = this._attribvalue;
	}
	this._attribname = "";
	this._attribvalue = "";
};

Parser.prototype._getInstructionName = function(value){
	var idx = value.search(re_nameEnd),
	    name = idx < 0 ? value : value.substr(0, idx);

	if(this._lowerCaseTagNames){
		name = name.toLowerCase();
	}

	return name;
};

Parser.prototype.ondeclaration = function(value){
	if(this._cbs.onprocessinginstruction){
		var name = this._getInstructionName(value);
		this._cbs.onprocessinginstruction("!" + name, "!" + value);
	}
};

Parser.prototype.onprocessinginstruction = function(value){
	if(this._cbs.onprocessinginstruction){
		var name = this._getInstructionName(value);
		this._cbs.onprocessinginstruction("?" + name, "?" + value);
	}
};

Parser.prototype.oncomment = function(value){
	this._updatePosition(4);

	if(this._cbs.oncomment) this._cbs.oncomment(value);
	if(this._cbs.oncommentend) this._cbs.oncommentend();
};

Parser.prototype.oncdata = function(value){
	this._updatePosition(1);

	if(this._options.xmlMode || this._options.recognizeCDATA){
		if(this._cbs.oncdatastart) this._cbs.oncdatastart();
		if(this._cbs.ontext) this._cbs.ontext(value);
		if(this._cbs.oncdataend) this._cbs.oncdataend();
	} else {
		this.oncomment("[CDATA[" + value + "]]");
	}
};

Parser.prototype.onerror = function(err){
	if(this._cbs.onerror) this._cbs.onerror(err);
};

Parser.prototype.onend = function(){
	if(this._cbs.onclosetag){
		for(
			var i = this._stack.length;
			i > 0;
			this._cbs.onclosetag(this._stack[--i])
		);
	}
	if(this._cbs.onend) this._cbs.onend();
};


//Resets the parser to a blank state, ready to parse a new HTML document
Parser.prototype.reset = function(){
	if(this._cbs.onreset) this._cbs.onreset();
	this._tokenizer.reset();

	this._tagname = "";
	this._attribname = "";
	this._attribs = null;
	this._stack = [];

	if(this._cbs.onparserinit) this._cbs.onparserinit(this);
};

//Parses a complete HTML document and pushes it to the handler
Parser.prototype.parseComplete = function(data){
	this.reset();
	this.end(data);
};

Parser.prototype.write = function(chunk){
	this._tokenizer.write(chunk);
};

Parser.prototype.end = function(chunk){
	this._tokenizer.end(chunk);
};

Parser.prototype.pause = function(){
	this._tokenizer.pause();
};

Parser.prototype.resume = function(){
	this._tokenizer.resume();
};

//alias for backwards compat
Parser.prototype.parseChunk = Parser.prototype.write;
Parser.prototype.done = Parser.prototype.end;

module.exports = Parser;


/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

module.exports = Tokenizer;

var decodeCodePoint = __webpack_require__(433),
    entityMap = __webpack_require__(435),
    legacyMap = __webpack_require__(436),
    xmlMap    = __webpack_require__(437),

    i = 0,

    TEXT                      = i++,
    BEFORE_TAG_NAME           = i++, //after <
    IN_TAG_NAME               = i++,
    IN_SELF_CLOSING_TAG       = i++,
    BEFORE_CLOSING_TAG_NAME   = i++,
    IN_CLOSING_TAG_NAME       = i++,
    AFTER_CLOSING_TAG_NAME    = i++,

    //attributes
    BEFORE_ATTRIBUTE_NAME     = i++,
    IN_ATTRIBUTE_NAME         = i++,
    AFTER_ATTRIBUTE_NAME      = i++,
    BEFORE_ATTRIBUTE_VALUE    = i++,
    IN_ATTRIBUTE_VALUE_DQ     = i++, // "
    IN_ATTRIBUTE_VALUE_SQ     = i++, // '
    IN_ATTRIBUTE_VALUE_NQ     = i++,

    //declarations
    BEFORE_DECLARATION        = i++, // !
    IN_DECLARATION            = i++,

    //processing instructions
    IN_PROCESSING_INSTRUCTION = i++, // ?

    //comments
    BEFORE_COMMENT            = i++,
    IN_COMMENT                = i++,
    AFTER_COMMENT_1           = i++,
    AFTER_COMMENT_2           = i++,

    //cdata
    BEFORE_CDATA_1            = i++, // [
    BEFORE_CDATA_2            = i++, // C
    BEFORE_CDATA_3            = i++, // D
    BEFORE_CDATA_4            = i++, // A
    BEFORE_CDATA_5            = i++, // T
    BEFORE_CDATA_6            = i++, // A
    IN_CDATA                  = i++, // [
    AFTER_CDATA_1             = i++, // ]
    AFTER_CDATA_2             = i++, // ]

    //special tags
    BEFORE_SPECIAL            = i++, //S
    BEFORE_SPECIAL_END        = i++,   //S

    BEFORE_SCRIPT_1           = i++, //C
    BEFORE_SCRIPT_2           = i++, //R
    BEFORE_SCRIPT_3           = i++, //I
    BEFORE_SCRIPT_4           = i++, //P
    BEFORE_SCRIPT_5           = i++, //T
    AFTER_SCRIPT_1            = i++, //C
    AFTER_SCRIPT_2            = i++, //R
    AFTER_SCRIPT_3            = i++, //I
    AFTER_SCRIPT_4            = i++, //P
    AFTER_SCRIPT_5            = i++, //T

    BEFORE_STYLE_1            = i++, //T
    BEFORE_STYLE_2            = i++, //Y
    BEFORE_STYLE_3            = i++, //L
    BEFORE_STYLE_4            = i++, //E
    AFTER_STYLE_1             = i++, //T
    AFTER_STYLE_2             = i++, //Y
    AFTER_STYLE_3             = i++, //L
    AFTER_STYLE_4             = i++, //E

    BEFORE_ENTITY             = i++, //&
    BEFORE_NUMERIC_ENTITY     = i++, //#
    IN_NAMED_ENTITY           = i++,
    IN_NUMERIC_ENTITY         = i++,
    IN_HEX_ENTITY             = i++, //X

    j = 0,

    SPECIAL_NONE              = j++,
    SPECIAL_SCRIPT            = j++,
    SPECIAL_STYLE             = j++;

function whitespace(c){
	return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
}

function characterState(char, SUCCESS){
	return function(c){
		if(c === char) this._state = SUCCESS;
	};
}

function ifElseState(upper, SUCCESS, FAILURE){
	var lower = upper.toLowerCase();

	if(upper === lower){
		return function(c){
			if(c === lower){
				this._state = SUCCESS;
			} else {
				this._state = FAILURE;
				this._index--;
			}
		};
	} else {
		return function(c){
			if(c === lower || c === upper){
				this._state = SUCCESS;
			} else {
				this._state = FAILURE;
				this._index--;
			}
		};
	}
}

function consumeSpecialNameChar(upper, NEXT_STATE){
	var lower = upper.toLowerCase();

	return function(c){
		if(c === lower || c === upper){
			this._state = NEXT_STATE;
		} else {
			this._state = IN_TAG_NAME;
			this._index--; //consume the token again
		}
	};
}

function Tokenizer(options, cbs){
	this._state = TEXT;
	this._buffer = "";
	this._sectionStart = 0;
	this._index = 0;
	this._bufferOffset = 0; //chars removed from _buffer
	this._baseState = TEXT;
	this._special = SPECIAL_NONE;
	this._cbs = cbs;
	this._running = true;
	this._ended = false;
	this._xmlMode = !!(options && options.xmlMode);
	this._decodeEntities = !!(options && options.decodeEntities);
}

Tokenizer.prototype._stateText = function(c){
	if(c === "<"){
		if(this._index > this._sectionStart){
			this._cbs.ontext(this._getSection());
		}
		this._state = BEFORE_TAG_NAME;
		this._sectionStart = this._index;
	} else if(this._decodeEntities && this._special === SPECIAL_NONE && c === "&"){
		if(this._index > this._sectionStart){
			this._cbs.ontext(this._getSection());
		}
		this._baseState = TEXT;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeTagName = function(c){
	if(c === "/"){
		this._state = BEFORE_CLOSING_TAG_NAME;
	} else if(c === "<"){
		this._cbs.ontext(this._getSection());
		this._sectionStart = this._index;
	} else if(c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
		this._state = TEXT;
	} else if(c === "!"){
		this._state = BEFORE_DECLARATION;
		this._sectionStart = this._index + 1;
	} else if(c === "?"){
		this._state = IN_PROCESSING_INSTRUCTION;
		this._sectionStart = this._index + 1;
	} else {
		this._state = (!this._xmlMode && (c === "s" || c === "S")) ?
						BEFORE_SPECIAL : IN_TAG_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInTagName = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._emitToken("onopentagname");
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateBeforeCloseingTagName = function(c){
	if(whitespace(c));
	else if(c === ">"){
		this._state = TEXT;
	} else if(this._special !== SPECIAL_NONE){
		if(c === "s" || c === "S"){
			this._state = BEFORE_SPECIAL_END;
		} else {
			this._state = TEXT;
			this._index--;
		}
	} else {
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInCloseingTagName = function(c){
	if(c === ">" || whitespace(c)){
		this._emitToken("onclosetag");
		this._state = AFTER_CLOSING_TAG_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateAfterCloseingTagName = function(c){
	//skip everything until ">"
	if(c === ">"){
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateBeforeAttributeName = function(c){
	if(c === ">"){
		this._cbs.onopentagend();
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c === "/"){
		this._state = IN_SELF_CLOSING_TAG;
	} else if(!whitespace(c)){
		this._state = IN_ATTRIBUTE_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInSelfClosingTag = function(c){
	if(c === ">"){
		this._cbs.onselfclosingtag();
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(!whitespace(c)){
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateInAttributeName = function(c){
	if(c === "=" || c === "/" || c === ">" || whitespace(c)){
		this._cbs.onattribname(this._getSection());
		this._sectionStart = -1;
		this._state = AFTER_ATTRIBUTE_NAME;
		this._index--;
	}
};

Tokenizer.prototype._stateAfterAttributeName = function(c){
	if(c === "="){
		this._state = BEFORE_ATTRIBUTE_VALUE;
	} else if(c === "/" || c === ">"){
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	} else if(!whitespace(c)){
		this._cbs.onattribend();
		this._state = IN_ATTRIBUTE_NAME;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeAttributeValue = function(c){
	if(c === "\""){
		this._state = IN_ATTRIBUTE_VALUE_DQ;
		this._sectionStart = this._index + 1;
	} else if(c === "'"){
		this._state = IN_ATTRIBUTE_VALUE_SQ;
		this._sectionStart = this._index + 1;
	} else if(!whitespace(c)){
		this._state = IN_ATTRIBUTE_VALUE_NQ;
		this._sectionStart = this._index;
		this._index--; //reconsume token
	}
};

Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c){
	if(c === "\""){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c){
	if(c === "'"){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c){
	if(whitespace(c) || c === ">"){
		this._emitToken("onattribdata");
		this._cbs.onattribend();
		this._state = BEFORE_ATTRIBUTE_NAME;
		this._index--;
	} else if(this._decodeEntities && c === "&"){
		this._emitToken("onattribdata");
		this._baseState = this._state;
		this._state = BEFORE_ENTITY;
		this._sectionStart = this._index;
	}
};

Tokenizer.prototype._stateBeforeDeclaration = function(c){
	this._state = c === "[" ? BEFORE_CDATA_1 :
					c === "-" ? BEFORE_COMMENT :
						IN_DECLARATION;
};

Tokenizer.prototype._stateInDeclaration = function(c){
	if(c === ">"){
		this._cbs.ondeclaration(this._getSection());
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateInProcessingInstruction = function(c){
	if(c === ">"){
		this._cbs.onprocessinginstruction(this._getSection());
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	}
};

Tokenizer.prototype._stateBeforeComment = function(c){
	if(c === "-"){
		this._state = IN_COMMENT;
		this._sectionStart = this._index + 1;
	} else {
		this._state = IN_DECLARATION;
	}
};

Tokenizer.prototype._stateInComment = function(c){
	if(c === "-") this._state = AFTER_COMMENT_1;
};

Tokenizer.prototype._stateAfterComment1 = function(c){
	if(c === "-"){
		this._state = AFTER_COMMENT_2;
	} else {
		this._state = IN_COMMENT;
	}
};

Tokenizer.prototype._stateAfterComment2 = function(c){
	if(c === ">"){
		//remove 2 trailing chars
		this._cbs.oncomment(this._buffer.substring(this._sectionStart, this._index - 2));
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c !== "-"){
		this._state = IN_COMMENT;
	}
	// else: stay in AFTER_COMMENT_2 (`--->`)
};

Tokenizer.prototype._stateBeforeCdata1 = ifElseState("C", BEFORE_CDATA_2, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata2 = ifElseState("D", BEFORE_CDATA_3, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata3 = ifElseState("A", BEFORE_CDATA_4, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata4 = ifElseState("T", BEFORE_CDATA_5, IN_DECLARATION);
Tokenizer.prototype._stateBeforeCdata5 = ifElseState("A", BEFORE_CDATA_6, IN_DECLARATION);

Tokenizer.prototype._stateBeforeCdata6 = function(c){
	if(c === "["){
		this._state = IN_CDATA;
		this._sectionStart = this._index + 1;
	} else {
		this._state = IN_DECLARATION;
		this._index--;
	}
};

Tokenizer.prototype._stateInCdata = function(c){
	if(c === "]") this._state = AFTER_CDATA_1;
};

Tokenizer.prototype._stateAfterCdata1 = characterState("]", AFTER_CDATA_2);

Tokenizer.prototype._stateAfterCdata2 = function(c){
	if(c === ">"){
		//remove 2 trailing chars
		this._cbs.oncdata(this._buffer.substring(this._sectionStart, this._index - 2));
		this._state = TEXT;
		this._sectionStart = this._index + 1;
	} else if(c !== "]") {
		this._state = IN_CDATA;
	}
	//else: stay in AFTER_CDATA_2 (`]]]>`)
};

Tokenizer.prototype._stateBeforeSpecial = function(c){
	if(c === "c" || c === "C"){
		this._state = BEFORE_SCRIPT_1;
	} else if(c === "t" || c === "T"){
		this._state = BEFORE_STYLE_1;
	} else {
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	}
};

Tokenizer.prototype._stateBeforeSpecialEnd = function(c){
	if(this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")){
		this._state = AFTER_SCRIPT_1;
	} else if(this._special === SPECIAL_STYLE && (c === "t" || c === "T")){
		this._state = AFTER_STYLE_1;
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar("R", BEFORE_SCRIPT_2);
Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar("I", BEFORE_SCRIPT_3);
Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar("P", BEFORE_SCRIPT_4);
Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar("T", BEFORE_SCRIPT_5);

Tokenizer.prototype._stateBeforeScript5 = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._special = SPECIAL_SCRIPT;
	}
	this._state = IN_TAG_NAME;
	this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);

Tokenizer.prototype._stateAfterScript5 = function(c){
	if(c === ">" || whitespace(c)){
		this._special = SPECIAL_NONE;
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index - 6;
		this._index--; //reconsume the token
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar("Y", BEFORE_STYLE_2);
Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar("L", BEFORE_STYLE_3);
Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar("E", BEFORE_STYLE_4);

Tokenizer.prototype._stateBeforeStyle4 = function(c){
	if(c === "/" || c === ">" || whitespace(c)){
		this._special = SPECIAL_STYLE;
	}
	this._state = IN_TAG_NAME;
	this._index--; //consume the token again
};

Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);

Tokenizer.prototype._stateAfterStyle4 = function(c){
	if(c === ">" || whitespace(c)){
		this._special = SPECIAL_NONE;
		this._state = IN_CLOSING_TAG_NAME;
		this._sectionStart = this._index - 5;
		this._index--; //reconsume the token
	}
	else this._state = TEXT;
};

Tokenizer.prototype._stateBeforeEntity = ifElseState("#", BEFORE_NUMERIC_ENTITY, IN_NAMED_ENTITY);
Tokenizer.prototype._stateBeforeNumericEntity = ifElseState("X", IN_HEX_ENTITY, IN_NUMERIC_ENTITY);

//for entities terminated with a semicolon
Tokenizer.prototype._parseNamedEntityStrict = function(){
	//offset = 1
	if(this._sectionStart + 1 < this._index){
		var entity = this._buffer.substring(this._sectionStart + 1, this._index),
		    map = this._xmlMode ? xmlMap : entityMap;

		if(map.hasOwnProperty(entity)){
			this._emitPartial(map[entity]);
			this._sectionStart = this._index + 1;
		}
	}
};


//parses legacy entities (without trailing semicolon)
Tokenizer.prototype._parseLegacyEntity = function(){
	var start = this._sectionStart + 1,
	    limit = this._index - start;

	if(limit > 6) limit = 6; //the max length of legacy entities is 6

	while(limit >= 2){ //the min length of legacy entities is 2
		var entity = this._buffer.substr(start, limit);

		if(legacyMap.hasOwnProperty(entity)){
			this._emitPartial(legacyMap[entity]);
			this._sectionStart += limit + 1;
			return;
		} else {
			limit--;
		}
	}
};

Tokenizer.prototype._stateInNamedEntity = function(c){
	if(c === ";"){
		this._parseNamedEntityStrict();
		if(this._sectionStart + 1 < this._index && !this._xmlMode){
			this._parseLegacyEntity();
		}
		this._state = this._baseState;
	} else if((c < "a" || c > "z") && (c < "A" || c > "Z") && (c < "0" || c > "9")){
		if(this._xmlMode);
		else if(this._sectionStart + 1 === this._index);
		else if(this._baseState !== TEXT){
			if(c !== "="){
				this._parseNamedEntityStrict();
			}
		} else {
			this._parseLegacyEntity();
		}

		this._state = this._baseState;
		this._index--;
	}
};

Tokenizer.prototype._decodeNumericEntity = function(offset, base){
	var sectionStart = this._sectionStart + offset;

	if(sectionStart !== this._index){
		//parse entity
		var entity = this._buffer.substring(sectionStart, this._index);
		var parsed = parseInt(entity, base);

		this._emitPartial(decodeCodePoint(parsed));
		this._sectionStart = this._index;
	} else {
		this._sectionStart--;
	}

	this._state = this._baseState;
};

Tokenizer.prototype._stateInNumericEntity = function(c){
	if(c === ";"){
		this._decodeNumericEntity(2, 10);
		this._sectionStart++;
	} else if(c < "0" || c > "9"){
		if(!this._xmlMode){
			this._decodeNumericEntity(2, 10);
		} else {
			this._state = this._baseState;
		}
		this._index--;
	}
};

Tokenizer.prototype._stateInHexEntity = function(c){
	if(c === ";"){
		this._decodeNumericEntity(3, 16);
		this._sectionStart++;
	} else if((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")){
		if(!this._xmlMode){
			this._decodeNumericEntity(3, 16);
		} else {
			this._state = this._baseState;
		}
		this._index--;
	}
};

Tokenizer.prototype._cleanup = function (){
	if(this._sectionStart < 0){
		this._buffer = "";
		this._bufferOffset += this._index;
		this._index = 0;
	} else if(this._running){
		if(this._state === TEXT){
			if(this._sectionStart !== this._index){
				this._cbs.ontext(this._buffer.substr(this._sectionStart));
			}
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else if(this._sectionStart === this._index){
			//the section just started
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else {
			//remove everything unnecessary
			this._buffer = this._buffer.substr(this._sectionStart);
			this._index -= this._sectionStart;
			this._bufferOffset += this._sectionStart;
		}

		this._sectionStart = 0;
	}
};

//TODO make events conditional
Tokenizer.prototype.write = function(chunk){
	if(this._ended) this._cbs.onerror(Error(".write() after done!"));

	this._buffer += chunk;
	this._parse();
};

Tokenizer.prototype._parse = function(){
	while(this._index < this._buffer.length && this._running){
		var c = this._buffer.charAt(this._index);
		if(this._state === TEXT) {
			this._stateText(c);
		} else if(this._state === BEFORE_TAG_NAME){
			this._stateBeforeTagName(c);
		} else if(this._state === IN_TAG_NAME) {
			this._stateInTagName(c);
		} else if(this._state === BEFORE_CLOSING_TAG_NAME){
			this._stateBeforeCloseingTagName(c);
		} else if(this._state === IN_CLOSING_TAG_NAME){
			this._stateInCloseingTagName(c);
		} else if(this._state === AFTER_CLOSING_TAG_NAME){
			this._stateAfterCloseingTagName(c);
		} else if(this._state === IN_SELF_CLOSING_TAG){
			this._stateInSelfClosingTag(c);
		}

		/*
		*	attributes
		*/
		else if(this._state === BEFORE_ATTRIBUTE_NAME){
			this._stateBeforeAttributeName(c);
		} else if(this._state === IN_ATTRIBUTE_NAME){
			this._stateInAttributeName(c);
		} else if(this._state === AFTER_ATTRIBUTE_NAME){
			this._stateAfterAttributeName(c);
		} else if(this._state === BEFORE_ATTRIBUTE_VALUE){
			this._stateBeforeAttributeValue(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_DQ){
			this._stateInAttributeValueDoubleQuotes(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_SQ){
			this._stateInAttributeValueSingleQuotes(c);
		} else if(this._state === IN_ATTRIBUTE_VALUE_NQ){
			this._stateInAttributeValueNoQuotes(c);
		}

		/*
		*	declarations
		*/
		else if(this._state === BEFORE_DECLARATION){
			this._stateBeforeDeclaration(c);
		} else if(this._state === IN_DECLARATION){
			this._stateInDeclaration(c);
		}

		/*
		*	processing instructions
		*/
		else if(this._state === IN_PROCESSING_INSTRUCTION){
			this._stateInProcessingInstruction(c);
		}

		/*
		*	comments
		*/
		else if(this._state === BEFORE_COMMENT){
			this._stateBeforeComment(c);
		} else if(this._state === IN_COMMENT){
			this._stateInComment(c);
		} else if(this._state === AFTER_COMMENT_1){
			this._stateAfterComment1(c);
		} else if(this._state === AFTER_COMMENT_2){
			this._stateAfterComment2(c);
		}

		/*
		*	cdata
		*/
		else if(this._state === BEFORE_CDATA_1){
			this._stateBeforeCdata1(c);
		} else if(this._state === BEFORE_CDATA_2){
			this._stateBeforeCdata2(c);
		} else if(this._state === BEFORE_CDATA_3){
			this._stateBeforeCdata3(c);
		} else if(this._state === BEFORE_CDATA_4){
			this._stateBeforeCdata4(c);
		} else if(this._state === BEFORE_CDATA_5){
			this._stateBeforeCdata5(c);
		} else if(this._state === BEFORE_CDATA_6){
			this._stateBeforeCdata6(c);
		} else if(this._state === IN_CDATA){
			this._stateInCdata(c);
		} else if(this._state === AFTER_CDATA_1){
			this._stateAfterCdata1(c);
		} else if(this._state === AFTER_CDATA_2){
			this._stateAfterCdata2(c);
		}

		/*
		* special tags
		*/
		else if(this._state === BEFORE_SPECIAL){
			this._stateBeforeSpecial(c);
		} else if(this._state === BEFORE_SPECIAL_END){
			this._stateBeforeSpecialEnd(c);
		}

		/*
		* script
		*/
		else if(this._state === BEFORE_SCRIPT_1){
			this._stateBeforeScript1(c);
		} else if(this._state === BEFORE_SCRIPT_2){
			this._stateBeforeScript2(c);
		} else if(this._state === BEFORE_SCRIPT_3){
			this._stateBeforeScript3(c);
		} else if(this._state === BEFORE_SCRIPT_4){
			this._stateBeforeScript4(c);
		} else if(this._state === BEFORE_SCRIPT_5){
			this._stateBeforeScript5(c);
		}

		else if(this._state === AFTER_SCRIPT_1){
			this._stateAfterScript1(c);
		} else if(this._state === AFTER_SCRIPT_2){
			this._stateAfterScript2(c);
		} else if(this._state === AFTER_SCRIPT_3){
			this._stateAfterScript3(c);
		} else if(this._state === AFTER_SCRIPT_4){
			this._stateAfterScript4(c);
		} else if(this._state === AFTER_SCRIPT_5){
			this._stateAfterScript5(c);
		}

		/*
		* style
		*/
		else if(this._state === BEFORE_STYLE_1){
			this._stateBeforeStyle1(c);
		} else if(this._state === BEFORE_STYLE_2){
			this._stateBeforeStyle2(c);
		} else if(this._state === BEFORE_STYLE_3){
			this._stateBeforeStyle3(c);
		} else if(this._state === BEFORE_STYLE_4){
			this._stateBeforeStyle4(c);
		}

		else if(this._state === AFTER_STYLE_1){
			this._stateAfterStyle1(c);
		} else if(this._state === AFTER_STYLE_2){
			this._stateAfterStyle2(c);
		} else if(this._state === AFTER_STYLE_3){
			this._stateAfterStyle3(c);
		} else if(this._state === AFTER_STYLE_4){
			this._stateAfterStyle4(c);
		}

		/*
		* entities
		*/
		else if(this._state === BEFORE_ENTITY){
			this._stateBeforeEntity(c);
		} else if(this._state === BEFORE_NUMERIC_ENTITY){
			this._stateBeforeNumericEntity(c);
		} else if(this._state === IN_NAMED_ENTITY){
			this._stateInNamedEntity(c);
		} else if(this._state === IN_NUMERIC_ENTITY){
			this._stateInNumericEntity(c);
		} else if(this._state === IN_HEX_ENTITY){
			this._stateInHexEntity(c);
		}

		else {
			this._cbs.onerror(Error("unknown _state"), this._state);
		}

		this._index++;
	}

	this._cleanup();
};

Tokenizer.prototype.pause = function(){
	this._running = false;
};
Tokenizer.prototype.resume = function(){
	this._running = true;

	if(this._index < this._buffer.length){
		this._parse();
	}
	if(this._ended){
		this._finish();
	}
};

Tokenizer.prototype.end = function(chunk){
	if(this._ended) this._cbs.onerror(Error(".end() after done!"));
	if(chunk) this.write(chunk);

	this._ended = true;

	if(this._running) this._finish();
};

Tokenizer.prototype._finish = function(){
	//if there is remaining data, emit it in a reasonable way
	if(this._sectionStart < this._index){
		this._handleTrailingData();
	}

	this._cbs.onend();
};

Tokenizer.prototype._handleTrailingData = function(){
	var data = this._buffer.substr(this._sectionStart);

	if(this._state === IN_CDATA || this._state === AFTER_CDATA_1 || this._state === AFTER_CDATA_2){
		this._cbs.oncdata(data);
	} else if(this._state === IN_COMMENT || this._state === AFTER_COMMENT_1 || this._state === AFTER_COMMENT_2){
		this._cbs.oncomment(data);
	} else if(this._state === IN_NAMED_ENTITY && !this._xmlMode){
		this._parseLegacyEntity();
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(this._state === IN_NUMERIC_ENTITY && !this._xmlMode){
		this._decodeNumericEntity(2, 10);
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(this._state === IN_HEX_ENTITY && !this._xmlMode){
		this._decodeNumericEntity(3, 16);
		if(this._sectionStart < this._index){
			this._state = this._baseState;
			this._handleTrailingData();
		}
	} else if(
		this._state !== IN_TAG_NAME &&
		this._state !== BEFORE_ATTRIBUTE_NAME &&
		this._state !== BEFORE_ATTRIBUTE_VALUE &&
		this._state !== AFTER_ATTRIBUTE_NAME &&
		this._state !== IN_ATTRIBUTE_NAME &&
		this._state !== IN_ATTRIBUTE_VALUE_SQ &&
		this._state !== IN_ATTRIBUTE_VALUE_DQ &&
		this._state !== IN_ATTRIBUTE_VALUE_NQ &&
		this._state !== IN_CLOSING_TAG_NAME
	){
		this._cbs.ontext(data);
	}
	//else, ignore remaining data
	//TODO add a way to remove current tag
};

Tokenizer.prototype.reset = function(){
	Tokenizer.call(this, {xmlMode: this._xmlMode, decodeEntities: this._decodeEntities}, this._cbs);
};

Tokenizer.prototype.getAbsoluteIndex = function(){
	return this._bufferOffset + this._index;
};

Tokenizer.prototype._getSection = function(){
	return this._buffer.substring(this._sectionStart, this._index);
};

Tokenizer.prototype._emitToken = function(name){
	this._cbs[name](this._getSection());
	this._sectionStart = -1;
};

Tokenizer.prototype._emitPartial = function(value){
	if(this._baseState !== TEXT){
		this._cbs.onattribdata(value); //TODO implement the new event
	} else {
		this._cbs.ontext(value);
	}
};


/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(350),
    WritableStream = __webpack_require__(281).Writable || __webpack_require__(447).Writable,
    StringDecoder = __webpack_require__(303).StringDecoder,
    Buffer = __webpack_require__(46).Buffer;

function Stream(cbs, options){
	var parser = this._parser = new Parser(cbs, options);
	var decoder = this._decoder = new StringDecoder();

	WritableStream.call(this, {decodeStrings: false});

	this.once("finish", function(){
		parser.end(decoder.end());
	});
}

__webpack_require__(59)(Stream, WritableStream);

WritableStream.prototype._write = function(chunk, encoding, cb){
	if(chunk instanceof Buffer) chunk = this._decoder.write(chunk);
	this._parser.write(chunk);
	cb();
};

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

// This object will be used as the prototype for Nodes when creating a
// DOM-Level-1-compliant structure.
var NodePrototype = module.exports = {
	get firstChild() {
		var children = this.children;
		return children && children[0] || null;
	},
	get lastChild() {
		var children = this.children;
		return children && children[children.length - 1] || null;
	},
	get nodeType() {
		return nodeTypes[this.type] || nodeTypes.element;
	}
};

var domLvl1 = {
	tagName: "name",
	childNodes: "children",
	parentNode: "parent",
	previousSibling: "prev",
	nextSibling: "next",
	nodeValue: "data"
};

var nodeTypes = {
	element: 1,
	text: 3,
	cdata: 4,
	comment: 8
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(NodePrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(304);

/*<replacement>*/
var util = __webpack_require__(269);
util.inherits = __webpack_require__(59);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

module.exports = Readable;

/*<replacement>*/
var processNextTick = __webpack_require__(302);
/*</replacement>*/

/*<replacement>*/
var isArray = __webpack_require__(440);
/*</replacement>*/

/*<replacement>*/
var Buffer = __webpack_require__(46).Buffer;
/*</replacement>*/

Readable.ReadableState = ReadableState;

var EE = __webpack_require__(277);

/*<replacement>*/
var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = __webpack_require__(281);
  } catch (_) {} finally {
    if (!Stream) Stream = __webpack_require__(277).EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = __webpack_require__(46).Buffer;

/*<replacement>*/
var util = __webpack_require__(269);
util.inherits = __webpack_require__(59);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(448);
var debug = undefined;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var StringDecoder;

util.inherits(Readable, Stream);

var Duplex;
function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(101);

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  this.buffer = [];
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(303).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

var Duplex;
function Readable(options) {
  Duplex = Duplex || __webpack_require__(101);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options && typeof options.read === 'function') this._read = options.read;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;

  if (!state.objectMode && typeof chunk === 'string') {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = new Buffer(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var e = new Error('stream.unshift() after end event');
      stream.emit('error', e);
    } else {
      var skipAdd;
      if (state.decoder && !addToFront && !encoding) {
        chunk = state.decoder.write(chunk);
        skipAdd = !state.objectMode && chunk.length === 0;
      }

      if (!addToFront) state.reading = false;

      // Don't add to the buffer if we've decoded to an empty string chunk and
      // we're not in object mode
      if (!skipAdd) {
        // if we want the data now, just emit it.
        if (state.flowing && state.length === 0 && !state.sync) {
          stream.emit('data', chunk);
          stream.read(0);
        } else {
          // update the buffer info.
          state.length += state.objectMode ? 1 : chunk.length;
          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

          if (state.needReadable) emitReadable(stream);
        }
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(303).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

function howMuchToRead(n, state) {
  if (state.length === 0 && state.ended) return 0;

  if (state.objectMode) return n === 0 ? 0 : 1;

  if (n === null || isNaN(n)) {
    // only flow one buffer at a time
    if (state.flowing && state.buffer.length) return state.buffer[0].length;else return state.length;
  }

  if (n <= 0) return 0;

  // If we're asking for more than the target buffer level,
  // then raise the water mark.  Bump up to the next highest
  // power of 2, to prevent increasing it excessively in tiny
  // amounts.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);

  // don't have that much.  return null, unless we've ended.
  if (n > state.length) {
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    } else {
      return state.length;
    }
  }

  return n;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  var state = this._readableState;
  var nOrig = n;

  if (typeof n !== 'number' || n > 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  }

  if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
  }

  // If _read pushed data synchronously, then `reading` will be false,
  // and we need to re-evaluate how much data we can return to the user.
  if (doRead && !state.reading) n = howMuchToRead(nOrig, state);

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  }

  state.length -= n;

  // If we have nothing in the buffer, then we want to know
  // as soon as we *do* get something into the buffer.
  if (state.length === 0 && !state.ended) state.needReadable = true;

  // If we tried to read() past the EOF, then emit end on the next tick.
  if (nOrig !== n && state.ended && state.length === 0) endReadable(this);

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    if (false === ret) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      if (state.pipesCount === 1 && state.pipes[0] === dest && src.listenerCount('data') === 1 && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }
  // This is a brutally ugly hack to make sure that our error handler
  // is attached before any userland ones.  NEVER DO THIS.
  if (!dest._events || !dest._events.error) dest.on('error', onerror);else if (isArray(dest._events.error)) dest._events.error.unshift(onerror);else dest._events.error = [onerror, dest._events.error];

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var _i = 0; _i < len; _i++) {
      dests[_i].emit('unpipe', this);
    }return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1) return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  // If listening to data, and it has not explicitly been paused,
  // then call resume to start the flow of data on the next tick.
  if (ev === 'data' && false !== this._readableState.flowing) {
    this.resume();
  }

  if (ev === 'readable' && !this._readableState.endEmitted) {
    var state = this._readableState;
    if (!state.readableListening) {
      state.readableListening = true;
      state.emittedReadable = false;
      state.needReadable = true;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  if (state.flowing) {
    do {
      var chunk = stream.read();
    } while (null !== chunk && state.flowing);
  }
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function (ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
function fromList(n, state) {
  var list = state.buffer;
  var length = state.length;
  var stringMode = !!state.decoder;
  var objectMode = !!state.objectMode;
  var ret;

  // nothing in the list, definitely empty.
  if (list.length === 0) return null;

  if (length === 0) ret = null;else if (objectMode) ret = list.shift();else if (!n || n >= length) {
    // read it all, truncate the array.
    if (stringMode) ret = list.join('');else if (list.length === 1) ret = list[0];else ret = Buffer.concat(list, length);
    list.length = 0;
  } else {
    // read just some of it.
    if (n < list[0].length) {
      // just take a part of the first list item.
      // slice is the same for buffers and strings.
      var buf = list[0];
      ret = buf.slice(0, n);
      list[0] = buf.slice(n);
    } else if (n === list[0].length) {
      // first list is a perfect match
      ret = list.shift();
    } else {
      // complex case.
      // we have enough to cover it, but it spans past the first buffer.
      if (stringMode) ret = '';else ret = new Buffer(n);

      var c = 0;
      for (var i = 0, l = list.length; i < l && c < n; i++) {
        var buf = list[0];
        var cpy = Math.min(n - c, buf.length);

        if (stringMode) ret += buf.slice(0, cpy);else buf.copy(ret, c, 0, cpy);

        if (cpy < buf.length) list[0] = buf.slice(cpy);else list.shift();

        c += cpy;
      }
    }
  }

  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('endReadable called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(44))(368);

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Shad
 * Date: 8/13/13
 */


var ShipmentQuote = __webpack_require__(74);

var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};
var TransactionShipmentQuote = module.exports = bunsen.TransactionShipmentQuote = ShipmentQuote.extend();

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var endpoints = __webpack_require__(6);
var SoaModel = __webpack_require__(2);
var AdjustmentList = __webpack_require__(55);
var Notes = __webpack_require__(23);
var Note = __webpack_require__(33);
var Party = __webpack_require__(8);
var Anchor = __webpack_require__(12);
var transitionMixin = __webpack_require__(19);
var assert = __webpack_require__(31);

_.extend(TransactionShipmentQuote, {
    STATUS_NEW: 'NEW',
    STATUS_SUBMITTED: 'SUBMITTED',
    STATUS_DEALER_REJECTED: 'DEALER_REJECTED',
    STATUS_DEALER_ACCEPTED: 'DEALER_ACCEPTED',
    STATUS_BUYER_ACCEPTED: 'BUYER_ACCEPTED',
    STATUS_PAYMENT_REQUIRED: 'PAYMENT_REQUIRED',
    STATUS_ACCEPTED: 'ACCEPTED',
    STATUS_CANCELED: 'CANCELED'
});

_.extend(TransactionShipmentQuote.prototype, {
    idAttribute: "id",
    anchorType: Anchor.TYPE_SHIPMENT_QUOTE,

    defaults: _.extend({}, ShipmentQuote.prototype.defaults, {
        notes: [],
        complimentaryShipping: 'N'
    }),

    initialize: function () {

        TransactionShipmentQuote.__super__.initialize.apply(this, arguments);
        this.url = function () {
            return endpoints.ecomShipmentQuote(this.id);
        };
    },
    relations: function () {
        // Get the parent's relations and add ecom specific relations.
        var relations = _.result(ShipmentQuote.prototype, 'relations').slice(0);
        relations.push(SoaModel.createRelations([
            {
                type : Backbone.One,
                key : 'adjustments',
                relatedModel : AdjustmentList
            },
            {
                type: Backbone.Many,
                key: 'notes',
                collectionType: Notes,
                omitFromSave: true
            },
            {
                type: Backbone.One,
                key: 'anchor',
                relatedModel: SoaModel
            }
        ]));
        return _.flatten(relations);
    },
    getTransactionId: function () {
        if (this.get('anchor.sourceType') === 'TRANSACTION') {
            return this.get('anchor.sourceId');
        }
    },

    wasAcceptedByDealer: function () {
        var statuses = ['DEALER_ACCEPTED', 'PAYMENT_REQUIRED', 'BUYER_ACCEPTED'];
        return _.contains(statuses, this.get('status'));
    },
    wasAcceptedByBuyer: function () {
        return this.get('status') === TransactionShipmentQuote.STATUS_BUYER_ACCEPTED;
    },
    wasAcceptedForAccounting: function () {
        return this.isAccountingQuote() && this.get('status') === TransactionShipmentQuote.STATUS_ACCEPTED;
    },
    isQuoteRequest: function () {
        return this.get('status') === TransactionShipmentQuote.STATUS_NEW;
    },
    isQuoteSubmitted: function () {
        return this.get('status') === TransactionShipmentQuote.STATUS_SUBMITTED;
    },
    isActive: function () {
        var statuses = [TransactionShipmentQuote.STATUS_CANCELED, TransactionShipmentQuote.STATUS_DEALER_REJECTED];
        return !_.contains(statuses, this.get('status'));
    },
    isActiveAccountingQuote: function () {
        return this.isAccountingQuote() && this.get('status') !== TransactionShipmentQuote.STATUS_DEALER_REJECTED && this.get('status') !== TransactionShipmentQuote.STATUS_CANCELED;
    },
    isRejectedAccountingQuote: function () {
        return this.isAccountingQuote() && this.get('status') === TransactionShipmentQuote.STATUS_DEALER_REJECTED;
    },
    getSellerId: function () {
        // TODO: This is probably not reliable if used outside of a transaction.
        return this.collection.parents[0].get('seller').id;
    },
    isComplimentary: function () {
        return this.get('complimentaryShipping') === 'Y';
    },
    isFreeToBuyer: function () {
        return !this.hasCostGreaterThanZero() || this.isComplimentary();

    },
    getTaxAmount: function (currency) {
        var adjustments = this.get('adjustments');
        if (adjustments) {
            return adjustments.getShippingTaxTotal(currency);
        }
        return 0;
    },
    newNote: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            anchors: [
                {
                    sourceId : this.getTransactionId(),
                    sourceType : Anchor.TYPE_TRANSACTION
                },
                {
                    sourceId: this.id,
                    sourceType: Anchor.TYPE_SHIPMENT_QUOTE
                },
                {
                    sourceId: this.getSellerId(),
                    sourceType: Anchor.TYPE_SELLER
                }
            ]
        });
        return this.get('notes').newNote(options);
    },
    addNewNote : function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },
    newBuyerSellerNote: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            type: Note.TYPE_BUYER_SELLER
        });
        return this.newNote(options);
    },
    getLastNote: function () {
        var notes = this.get('notes');
        return notes ? notes.last() : null;
    },
    setComplimentaryIfFree: function () {
        if (!this.hasCostGreaterThanZero()) {
            this.set('complimentaryShipping', 'Y');
        }
    },
    /**
     * Accept/Counter offer while creating shipment quote with note
     * @param {Offer} offer
     * @param {Offer} counterOffer
     * @param {object} [passedOptions]
     */
    dealerSubmitWithOffer: function (offer, counterOffer, passedOptions) {
        this.setComplimentaryIfFree();
        return this.dealerTransitionWithOfferNote(null, offer, counterOffer, passedOptions);
    },
    /**
     * Accept/Counter offer while accepting shipment quote with note
     * @param {Offer} offer
     * @param {Offer} counterOffer
     * @param {object} [passedOptions]
     * @returns {$.Deferred.promise}
     */
    dealerAcceptWithOffer: function (offer, counterOffer, passedOptions) {
        var options = _.extend({
            transitionFunction: 'updateAndTransition'
        }, passedOptions);
        this.setComplimentaryIfFree();
        return this.dealerTransitionWithOfferNote(
            TransactionShipmentQuote.STATUS_DEALER_ACCEPTED,
            offer,
            counterOffer,
            options
        );
    },
    updateAccountingQuote: function (clump) {
        assert(this.isAccountingQuote(), 'quote must be an accounting quote');
        return this.save(null, { clump: clump });
    },
    /**
     * @param {Clump} [clump]
     * @returns {$.Deferred.promise}
     */
    acceptAccountingQuote: function (clump) {
        assert(this.isAccountingQuote(), 'quote must be an accounting quote');
        return this.updateAndTransition(TransactionShipmentQuote.STATUS_ACCEPTED, { clump: clump });
    },

    /**
     * @param {Clump} [clump]
     * @returns {$.Deferred.promise}
     */
    rejectAccountingQuoteForDealer: function (clump) {
        assert(this.isAccountingQuote(), 'quote must be an accounting quote');
        return this.transition(TransactionShipmentQuote.STATUS_DEALER_REJECTED, { clump: clump });
    },

    /**
     * Save this quote model instance as a 'submitted' 1stdibs quote
     * to the logistics service, which will then be displayed to the
     * dealer for approval.
     * @param {object} [passedOptions]
     * @returns {$.Deferred.promise}
     */
    provide1stdibsQuote: function (passedOptions) {
        var options = _.extend({
            noteRole: Party.ROLE_INTERNAL,
            noteType: Note.TYPE_SELLER_ADMIN,
            transitionFunction: 'updateAndTransition'
        }, passedOptions);
        this.setComplimentaryIfFree();
        return this.transitionWithNote(TransactionShipmentQuote.STATUS_SUBMITTED, options);
    },
    saveModifiedQuote: function (passedOptions) {
        var options = _.extend({
            noteRole: Party.ROLE_INTERNAL,
            noteType: Note.TYPE_SELLER_ADMIN,
            transitionFunction: 'update'
        }, passedOptions);
        this.setComplimentaryIfFree();
        return this.transitionWithNote(null, options);
    },

    /**
     * Saves the shipmentQuote with notes on them, have to use temporary SoaModel
     * as currently notes are omitted from the save on this model
     * @returns {*|$.Deferred.promise}
     */
    saveWithNotes: function () {
        var soaModel = new SoaModel(this.toJSON());
        soaModel.url = endpoints.ecomShipmentQuote(this.id);
        return soaModel.save();
    }

}, transitionMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function square(number) {
    return Math.pow(number, 2);
}

function hypotenuse(x, y) {
    return Math.sqrt(square(x) + square(y));
}

function absDistance(number1, number2) {
    return Math.abs(number1 - number2);
}

function getTouchDistance(position1, position2) {
    var x1 = position1.x,
        y1 = position1.y;
    var x2 = position2.x,
        y2 = position2.y;


    return hypotenuse(absDistance(x1, x2), absDistance(y1, y2));
}

function touchToCoordinates(target, touch) {
    return {
        x: touch.pageX - target.offsetLeft,
        y: touch.pageY - target.offsetTop
    };
}

module.exports = {
    square: square,
    hypotenuse: hypotenuse,
    absDistance: absDistance,
    getTouchDistance: getTouchDistance,
    touchToCoordinates: touchToCoordinates
};

/***/ }),

/***/ 363:
/***/ (function(module, exports) {

var ENTITIES = [['Aacute', [193]], ['aacute', [225]], ['Abreve', [258]], ['abreve', [259]], ['ac', [8766]], ['acd', [8767]], ['acE', [8766, 819]], ['Acirc', [194]], ['acirc', [226]], ['acute', [180]], ['Acy', [1040]], ['acy', [1072]], ['AElig', [198]], ['aelig', [230]], ['af', [8289]], ['Afr', [120068]], ['afr', [120094]], ['Agrave', [192]], ['agrave', [224]], ['alefsym', [8501]], ['aleph', [8501]], ['Alpha', [913]], ['alpha', [945]], ['Amacr', [256]], ['amacr', [257]], ['amalg', [10815]], ['amp', [38]], ['AMP', [38]], ['andand', [10837]], ['And', [10835]], ['and', [8743]], ['andd', [10844]], ['andslope', [10840]], ['andv', [10842]], ['ang', [8736]], ['ange', [10660]], ['angle', [8736]], ['angmsdaa', [10664]], ['angmsdab', [10665]], ['angmsdac', [10666]], ['angmsdad', [10667]], ['angmsdae', [10668]], ['angmsdaf', [10669]], ['angmsdag', [10670]], ['angmsdah', [10671]], ['angmsd', [8737]], ['angrt', [8735]], ['angrtvb', [8894]], ['angrtvbd', [10653]], ['angsph', [8738]], ['angst', [197]], ['angzarr', [9084]], ['Aogon', [260]], ['aogon', [261]], ['Aopf', [120120]], ['aopf', [120146]], ['apacir', [10863]], ['ap', [8776]], ['apE', [10864]], ['ape', [8778]], ['apid', [8779]], ['apos', [39]], ['ApplyFunction', [8289]], ['approx', [8776]], ['approxeq', [8778]], ['Aring', [197]], ['aring', [229]], ['Ascr', [119964]], ['ascr', [119990]], ['Assign', [8788]], ['ast', [42]], ['asymp', [8776]], ['asympeq', [8781]], ['Atilde', [195]], ['atilde', [227]], ['Auml', [196]], ['auml', [228]], ['awconint', [8755]], ['awint', [10769]], ['backcong', [8780]], ['backepsilon', [1014]], ['backprime', [8245]], ['backsim', [8765]], ['backsimeq', [8909]], ['Backslash', [8726]], ['Barv', [10983]], ['barvee', [8893]], ['barwed', [8965]], ['Barwed', [8966]], ['barwedge', [8965]], ['bbrk', [9141]], ['bbrktbrk', [9142]], ['bcong', [8780]], ['Bcy', [1041]], ['bcy', [1073]], ['bdquo', [8222]], ['becaus', [8757]], ['because', [8757]], ['Because', [8757]], ['bemptyv', [10672]], ['bepsi', [1014]], ['bernou', [8492]], ['Bernoullis', [8492]], ['Beta', [914]], ['beta', [946]], ['beth', [8502]], ['between', [8812]], ['Bfr', [120069]], ['bfr', [120095]], ['bigcap', [8898]], ['bigcirc', [9711]], ['bigcup', [8899]], ['bigodot', [10752]], ['bigoplus', [10753]], ['bigotimes', [10754]], ['bigsqcup', [10758]], ['bigstar', [9733]], ['bigtriangledown', [9661]], ['bigtriangleup', [9651]], ['biguplus', [10756]], ['bigvee', [8897]], ['bigwedge', [8896]], ['bkarow', [10509]], ['blacklozenge', [10731]], ['blacksquare', [9642]], ['blacktriangle', [9652]], ['blacktriangledown', [9662]], ['blacktriangleleft', [9666]], ['blacktriangleright', [9656]], ['blank', [9251]], ['blk12', [9618]], ['blk14', [9617]], ['blk34', [9619]], ['block', [9608]], ['bne', [61, 8421]], ['bnequiv', [8801, 8421]], ['bNot', [10989]], ['bnot', [8976]], ['Bopf', [120121]], ['bopf', [120147]], ['bot', [8869]], ['bottom', [8869]], ['bowtie', [8904]], ['boxbox', [10697]], ['boxdl', [9488]], ['boxdL', [9557]], ['boxDl', [9558]], ['boxDL', [9559]], ['boxdr', [9484]], ['boxdR', [9554]], ['boxDr', [9555]], ['boxDR', [9556]], ['boxh', [9472]], ['boxH', [9552]], ['boxhd', [9516]], ['boxHd', [9572]], ['boxhD', [9573]], ['boxHD', [9574]], ['boxhu', [9524]], ['boxHu', [9575]], ['boxhU', [9576]], ['boxHU', [9577]], ['boxminus', [8863]], ['boxplus', [8862]], ['boxtimes', [8864]], ['boxul', [9496]], ['boxuL', [9563]], ['boxUl', [9564]], ['boxUL', [9565]], ['boxur', [9492]], ['boxuR', [9560]], ['boxUr', [9561]], ['boxUR', [9562]], ['boxv', [9474]], ['boxV', [9553]], ['boxvh', [9532]], ['boxvH', [9578]], ['boxVh', [9579]], ['boxVH', [9580]], ['boxvl', [9508]], ['boxvL', [9569]], ['boxVl', [9570]], ['boxVL', [9571]], ['boxvr', [9500]], ['boxvR', [9566]], ['boxVr', [9567]], ['boxVR', [9568]], ['bprime', [8245]], ['breve', [728]], ['Breve', [728]], ['brvbar', [166]], ['bscr', [119991]], ['Bscr', [8492]], ['bsemi', [8271]], ['bsim', [8765]], ['bsime', [8909]], ['bsolb', [10693]], ['bsol', [92]], ['bsolhsub', [10184]], ['bull', [8226]], ['bullet', [8226]], ['bump', [8782]], ['bumpE', [10926]], ['bumpe', [8783]], ['Bumpeq', [8782]], ['bumpeq', [8783]], ['Cacute', [262]], ['cacute', [263]], ['capand', [10820]], ['capbrcup', [10825]], ['capcap', [10827]], ['cap', [8745]], ['Cap', [8914]], ['capcup', [10823]], ['capdot', [10816]], ['CapitalDifferentialD', [8517]], ['caps', [8745, 65024]], ['caret', [8257]], ['caron', [711]], ['Cayleys', [8493]], ['ccaps', [10829]], ['Ccaron', [268]], ['ccaron', [269]], ['Ccedil', [199]], ['ccedil', [231]], ['Ccirc', [264]], ['ccirc', [265]], ['Cconint', [8752]], ['ccups', [10828]], ['ccupssm', [10832]], ['Cdot', [266]], ['cdot', [267]], ['cedil', [184]], ['Cedilla', [184]], ['cemptyv', [10674]], ['cent', [162]], ['centerdot', [183]], ['CenterDot', [183]], ['cfr', [120096]], ['Cfr', [8493]], ['CHcy', [1063]], ['chcy', [1095]], ['check', [10003]], ['checkmark', [10003]], ['Chi', [935]], ['chi', [967]], ['circ', [710]], ['circeq', [8791]], ['circlearrowleft', [8634]], ['circlearrowright', [8635]], ['circledast', [8859]], ['circledcirc', [8858]], ['circleddash', [8861]], ['CircleDot', [8857]], ['circledR', [174]], ['circledS', [9416]], ['CircleMinus', [8854]], ['CirclePlus', [8853]], ['CircleTimes', [8855]], ['cir', [9675]], ['cirE', [10691]], ['cire', [8791]], ['cirfnint', [10768]], ['cirmid', [10991]], ['cirscir', [10690]], ['ClockwiseContourIntegral', [8754]], ['CloseCurlyDoubleQuote', [8221]], ['CloseCurlyQuote', [8217]], ['clubs', [9827]], ['clubsuit', [9827]], ['colon', [58]], ['Colon', [8759]], ['Colone', [10868]], ['colone', [8788]], ['coloneq', [8788]], ['comma', [44]], ['commat', [64]], ['comp', [8705]], ['compfn', [8728]], ['complement', [8705]], ['complexes', [8450]], ['cong', [8773]], ['congdot', [10861]], ['Congruent', [8801]], ['conint', [8750]], ['Conint', [8751]], ['ContourIntegral', [8750]], ['copf', [120148]], ['Copf', [8450]], ['coprod', [8720]], ['Coproduct', [8720]], ['copy', [169]], ['COPY', [169]], ['copysr', [8471]], ['CounterClockwiseContourIntegral', [8755]], ['crarr', [8629]], ['cross', [10007]], ['Cross', [10799]], ['Cscr', [119966]], ['cscr', [119992]], ['csub', [10959]], ['csube', [10961]], ['csup', [10960]], ['csupe', [10962]], ['ctdot', [8943]], ['cudarrl', [10552]], ['cudarrr', [10549]], ['cuepr', [8926]], ['cuesc', [8927]], ['cularr', [8630]], ['cularrp', [10557]], ['cupbrcap', [10824]], ['cupcap', [10822]], ['CupCap', [8781]], ['cup', [8746]], ['Cup', [8915]], ['cupcup', [10826]], ['cupdot', [8845]], ['cupor', [10821]], ['cups', [8746, 65024]], ['curarr', [8631]], ['curarrm', [10556]], ['curlyeqprec', [8926]], ['curlyeqsucc', [8927]], ['curlyvee', [8910]], ['curlywedge', [8911]], ['curren', [164]], ['curvearrowleft', [8630]], ['curvearrowright', [8631]], ['cuvee', [8910]], ['cuwed', [8911]], ['cwconint', [8754]], ['cwint', [8753]], ['cylcty', [9005]], ['dagger', [8224]], ['Dagger', [8225]], ['daleth', [8504]], ['darr', [8595]], ['Darr', [8609]], ['dArr', [8659]], ['dash', [8208]], ['Dashv', [10980]], ['dashv', [8867]], ['dbkarow', [10511]], ['dblac', [733]], ['Dcaron', [270]], ['dcaron', [271]], ['Dcy', [1044]], ['dcy', [1076]], ['ddagger', [8225]], ['ddarr', [8650]], ['DD', [8517]], ['dd', [8518]], ['DDotrahd', [10513]], ['ddotseq', [10871]], ['deg', [176]], ['Del', [8711]], ['Delta', [916]], ['delta', [948]], ['demptyv', [10673]], ['dfisht', [10623]], ['Dfr', [120071]], ['dfr', [120097]], ['dHar', [10597]], ['dharl', [8643]], ['dharr', [8642]], ['DiacriticalAcute', [180]], ['DiacriticalDot', [729]], ['DiacriticalDoubleAcute', [733]], ['DiacriticalGrave', [96]], ['DiacriticalTilde', [732]], ['diam', [8900]], ['diamond', [8900]], ['Diamond', [8900]], ['diamondsuit', [9830]], ['diams', [9830]], ['die', [168]], ['DifferentialD', [8518]], ['digamma', [989]], ['disin', [8946]], ['div', [247]], ['divide', [247]], ['divideontimes', [8903]], ['divonx', [8903]], ['DJcy', [1026]], ['djcy', [1106]], ['dlcorn', [8990]], ['dlcrop', [8973]], ['dollar', [36]], ['Dopf', [120123]], ['dopf', [120149]], ['Dot', [168]], ['dot', [729]], ['DotDot', [8412]], ['doteq', [8784]], ['doteqdot', [8785]], ['DotEqual', [8784]], ['dotminus', [8760]], ['dotplus', [8724]], ['dotsquare', [8865]], ['doublebarwedge', [8966]], ['DoubleContourIntegral', [8751]], ['DoubleDot', [168]], ['DoubleDownArrow', [8659]], ['DoubleLeftArrow', [8656]], ['DoubleLeftRightArrow', [8660]], ['DoubleLeftTee', [10980]], ['DoubleLongLeftArrow', [10232]], ['DoubleLongLeftRightArrow', [10234]], ['DoubleLongRightArrow', [10233]], ['DoubleRightArrow', [8658]], ['DoubleRightTee', [8872]], ['DoubleUpArrow', [8657]], ['DoubleUpDownArrow', [8661]], ['DoubleVerticalBar', [8741]], ['DownArrowBar', [10515]], ['downarrow', [8595]], ['DownArrow', [8595]], ['Downarrow', [8659]], ['DownArrowUpArrow', [8693]], ['DownBreve', [785]], ['downdownarrows', [8650]], ['downharpoonleft', [8643]], ['downharpoonright', [8642]], ['DownLeftRightVector', [10576]], ['DownLeftTeeVector', [10590]], ['DownLeftVectorBar', [10582]], ['DownLeftVector', [8637]], ['DownRightTeeVector', [10591]], ['DownRightVectorBar', [10583]], ['DownRightVector', [8641]], ['DownTeeArrow', [8615]], ['DownTee', [8868]], ['drbkarow', [10512]], ['drcorn', [8991]], ['drcrop', [8972]], ['Dscr', [119967]], ['dscr', [119993]], ['DScy', [1029]], ['dscy', [1109]], ['dsol', [10742]], ['Dstrok', [272]], ['dstrok', [273]], ['dtdot', [8945]], ['dtri', [9663]], ['dtrif', [9662]], ['duarr', [8693]], ['duhar', [10607]], ['dwangle', [10662]], ['DZcy', [1039]], ['dzcy', [1119]], ['dzigrarr', [10239]], ['Eacute', [201]], ['eacute', [233]], ['easter', [10862]], ['Ecaron', [282]], ['ecaron', [283]], ['Ecirc', [202]], ['ecirc', [234]], ['ecir', [8790]], ['ecolon', [8789]], ['Ecy', [1069]], ['ecy', [1101]], ['eDDot', [10871]], ['Edot', [278]], ['edot', [279]], ['eDot', [8785]], ['ee', [8519]], ['efDot', [8786]], ['Efr', [120072]], ['efr', [120098]], ['eg', [10906]], ['Egrave', [200]], ['egrave', [232]], ['egs', [10902]], ['egsdot', [10904]], ['el', [10905]], ['Element', [8712]], ['elinters', [9191]], ['ell', [8467]], ['els', [10901]], ['elsdot', [10903]], ['Emacr', [274]], ['emacr', [275]], ['empty', [8709]], ['emptyset', [8709]], ['EmptySmallSquare', [9723]], ['emptyv', [8709]], ['EmptyVerySmallSquare', [9643]], ['emsp13', [8196]], ['emsp14', [8197]], ['emsp', [8195]], ['ENG', [330]], ['eng', [331]], ['ensp', [8194]], ['Eogon', [280]], ['eogon', [281]], ['Eopf', [120124]], ['eopf', [120150]], ['epar', [8917]], ['eparsl', [10723]], ['eplus', [10865]], ['epsi', [949]], ['Epsilon', [917]], ['epsilon', [949]], ['epsiv', [1013]], ['eqcirc', [8790]], ['eqcolon', [8789]], ['eqsim', [8770]], ['eqslantgtr', [10902]], ['eqslantless', [10901]], ['Equal', [10869]], ['equals', [61]], ['EqualTilde', [8770]], ['equest', [8799]], ['Equilibrium', [8652]], ['equiv', [8801]], ['equivDD', [10872]], ['eqvparsl', [10725]], ['erarr', [10609]], ['erDot', [8787]], ['escr', [8495]], ['Escr', [8496]], ['esdot', [8784]], ['Esim', [10867]], ['esim', [8770]], ['Eta', [919]], ['eta', [951]], ['ETH', [208]], ['eth', [240]], ['Euml', [203]], ['euml', [235]], ['euro', [8364]], ['excl', [33]], ['exist', [8707]], ['Exists', [8707]], ['expectation', [8496]], ['exponentiale', [8519]], ['ExponentialE', [8519]], ['fallingdotseq', [8786]], ['Fcy', [1060]], ['fcy', [1092]], ['female', [9792]], ['ffilig', [64259]], ['fflig', [64256]], ['ffllig', [64260]], ['Ffr', [120073]], ['ffr', [120099]], ['filig', [64257]], ['FilledSmallSquare', [9724]], ['FilledVerySmallSquare', [9642]], ['fjlig', [102, 106]], ['flat', [9837]], ['fllig', [64258]], ['fltns', [9649]], ['fnof', [402]], ['Fopf', [120125]], ['fopf', [120151]], ['forall', [8704]], ['ForAll', [8704]], ['fork', [8916]], ['forkv', [10969]], ['Fouriertrf', [8497]], ['fpartint', [10765]], ['frac12', [189]], ['frac13', [8531]], ['frac14', [188]], ['frac15', [8533]], ['frac16', [8537]], ['frac18', [8539]], ['frac23', [8532]], ['frac25', [8534]], ['frac34', [190]], ['frac35', [8535]], ['frac38', [8540]], ['frac45', [8536]], ['frac56', [8538]], ['frac58', [8541]], ['frac78', [8542]], ['frasl', [8260]], ['frown', [8994]], ['fscr', [119995]], ['Fscr', [8497]], ['gacute', [501]], ['Gamma', [915]], ['gamma', [947]], ['Gammad', [988]], ['gammad', [989]], ['gap', [10886]], ['Gbreve', [286]], ['gbreve', [287]], ['Gcedil', [290]], ['Gcirc', [284]], ['gcirc', [285]], ['Gcy', [1043]], ['gcy', [1075]], ['Gdot', [288]], ['gdot', [289]], ['ge', [8805]], ['gE', [8807]], ['gEl', [10892]], ['gel', [8923]], ['geq', [8805]], ['geqq', [8807]], ['geqslant', [10878]], ['gescc', [10921]], ['ges', [10878]], ['gesdot', [10880]], ['gesdoto', [10882]], ['gesdotol', [10884]], ['gesl', [8923, 65024]], ['gesles', [10900]], ['Gfr', [120074]], ['gfr', [120100]], ['gg', [8811]], ['Gg', [8921]], ['ggg', [8921]], ['gimel', [8503]], ['GJcy', [1027]], ['gjcy', [1107]], ['gla', [10917]], ['gl', [8823]], ['glE', [10898]], ['glj', [10916]], ['gnap', [10890]], ['gnapprox', [10890]], ['gne', [10888]], ['gnE', [8809]], ['gneq', [10888]], ['gneqq', [8809]], ['gnsim', [8935]], ['Gopf', [120126]], ['gopf', [120152]], ['grave', [96]], ['GreaterEqual', [8805]], ['GreaterEqualLess', [8923]], ['GreaterFullEqual', [8807]], ['GreaterGreater', [10914]], ['GreaterLess', [8823]], ['GreaterSlantEqual', [10878]], ['GreaterTilde', [8819]], ['Gscr', [119970]], ['gscr', [8458]], ['gsim', [8819]], ['gsime', [10894]], ['gsiml', [10896]], ['gtcc', [10919]], ['gtcir', [10874]], ['gt', [62]], ['GT', [62]], ['Gt', [8811]], ['gtdot', [8919]], ['gtlPar', [10645]], ['gtquest', [10876]], ['gtrapprox', [10886]], ['gtrarr', [10616]], ['gtrdot', [8919]], ['gtreqless', [8923]], ['gtreqqless', [10892]], ['gtrless', [8823]], ['gtrsim', [8819]], ['gvertneqq', [8809, 65024]], ['gvnE', [8809, 65024]], ['Hacek', [711]], ['hairsp', [8202]], ['half', [189]], ['hamilt', [8459]], ['HARDcy', [1066]], ['hardcy', [1098]], ['harrcir', [10568]], ['harr', [8596]], ['hArr', [8660]], ['harrw', [8621]], ['Hat', [94]], ['hbar', [8463]], ['Hcirc', [292]], ['hcirc', [293]], ['hearts', [9829]], ['heartsuit', [9829]], ['hellip', [8230]], ['hercon', [8889]], ['hfr', [120101]], ['Hfr', [8460]], ['HilbertSpace', [8459]], ['hksearow', [10533]], ['hkswarow', [10534]], ['hoarr', [8703]], ['homtht', [8763]], ['hookleftarrow', [8617]], ['hookrightarrow', [8618]], ['hopf', [120153]], ['Hopf', [8461]], ['horbar', [8213]], ['HorizontalLine', [9472]], ['hscr', [119997]], ['Hscr', [8459]], ['hslash', [8463]], ['Hstrok', [294]], ['hstrok', [295]], ['HumpDownHump', [8782]], ['HumpEqual', [8783]], ['hybull', [8259]], ['hyphen', [8208]], ['Iacute', [205]], ['iacute', [237]], ['ic', [8291]], ['Icirc', [206]], ['icirc', [238]], ['Icy', [1048]], ['icy', [1080]], ['Idot', [304]], ['IEcy', [1045]], ['iecy', [1077]], ['iexcl', [161]], ['iff', [8660]], ['ifr', [120102]], ['Ifr', [8465]], ['Igrave', [204]], ['igrave', [236]], ['ii', [8520]], ['iiiint', [10764]], ['iiint', [8749]], ['iinfin', [10716]], ['iiota', [8489]], ['IJlig', [306]], ['ijlig', [307]], ['Imacr', [298]], ['imacr', [299]], ['image', [8465]], ['ImaginaryI', [8520]], ['imagline', [8464]], ['imagpart', [8465]], ['imath', [305]], ['Im', [8465]], ['imof', [8887]], ['imped', [437]], ['Implies', [8658]], ['incare', [8453]], ['in', [8712]], ['infin', [8734]], ['infintie', [10717]], ['inodot', [305]], ['intcal', [8890]], ['int', [8747]], ['Int', [8748]], ['integers', [8484]], ['Integral', [8747]], ['intercal', [8890]], ['Intersection', [8898]], ['intlarhk', [10775]], ['intprod', [10812]], ['InvisibleComma', [8291]], ['InvisibleTimes', [8290]], ['IOcy', [1025]], ['iocy', [1105]], ['Iogon', [302]], ['iogon', [303]], ['Iopf', [120128]], ['iopf', [120154]], ['Iota', [921]], ['iota', [953]], ['iprod', [10812]], ['iquest', [191]], ['iscr', [119998]], ['Iscr', [8464]], ['isin', [8712]], ['isindot', [8949]], ['isinE', [8953]], ['isins', [8948]], ['isinsv', [8947]], ['isinv', [8712]], ['it', [8290]], ['Itilde', [296]], ['itilde', [297]], ['Iukcy', [1030]], ['iukcy', [1110]], ['Iuml', [207]], ['iuml', [239]], ['Jcirc', [308]], ['jcirc', [309]], ['Jcy', [1049]], ['jcy', [1081]], ['Jfr', [120077]], ['jfr', [120103]], ['jmath', [567]], ['Jopf', [120129]], ['jopf', [120155]], ['Jscr', [119973]], ['jscr', [119999]], ['Jsercy', [1032]], ['jsercy', [1112]], ['Jukcy', [1028]], ['jukcy', [1108]], ['Kappa', [922]], ['kappa', [954]], ['kappav', [1008]], ['Kcedil', [310]], ['kcedil', [311]], ['Kcy', [1050]], ['kcy', [1082]], ['Kfr', [120078]], ['kfr', [120104]], ['kgreen', [312]], ['KHcy', [1061]], ['khcy', [1093]], ['KJcy', [1036]], ['kjcy', [1116]], ['Kopf', [120130]], ['kopf', [120156]], ['Kscr', [119974]], ['kscr', [120000]], ['lAarr', [8666]], ['Lacute', [313]], ['lacute', [314]], ['laemptyv', [10676]], ['lagran', [8466]], ['Lambda', [923]], ['lambda', [955]], ['lang', [10216]], ['Lang', [10218]], ['langd', [10641]], ['langle', [10216]], ['lap', [10885]], ['Laplacetrf', [8466]], ['laquo', [171]], ['larrb', [8676]], ['larrbfs', [10527]], ['larr', [8592]], ['Larr', [8606]], ['lArr', [8656]], ['larrfs', [10525]], ['larrhk', [8617]], ['larrlp', [8619]], ['larrpl', [10553]], ['larrsim', [10611]], ['larrtl', [8610]], ['latail', [10521]], ['lAtail', [10523]], ['lat', [10923]], ['late', [10925]], ['lates', [10925, 65024]], ['lbarr', [10508]], ['lBarr', [10510]], ['lbbrk', [10098]], ['lbrace', [123]], ['lbrack', [91]], ['lbrke', [10635]], ['lbrksld', [10639]], ['lbrkslu', [10637]], ['Lcaron', [317]], ['lcaron', [318]], ['Lcedil', [315]], ['lcedil', [316]], ['lceil', [8968]], ['lcub', [123]], ['Lcy', [1051]], ['lcy', [1083]], ['ldca', [10550]], ['ldquo', [8220]], ['ldquor', [8222]], ['ldrdhar', [10599]], ['ldrushar', [10571]], ['ldsh', [8626]], ['le', [8804]], ['lE', [8806]], ['LeftAngleBracket', [10216]], ['LeftArrowBar', [8676]], ['leftarrow', [8592]], ['LeftArrow', [8592]], ['Leftarrow', [8656]], ['LeftArrowRightArrow', [8646]], ['leftarrowtail', [8610]], ['LeftCeiling', [8968]], ['LeftDoubleBracket', [10214]], ['LeftDownTeeVector', [10593]], ['LeftDownVectorBar', [10585]], ['LeftDownVector', [8643]], ['LeftFloor', [8970]], ['leftharpoondown', [8637]], ['leftharpoonup', [8636]], ['leftleftarrows', [8647]], ['leftrightarrow', [8596]], ['LeftRightArrow', [8596]], ['Leftrightarrow', [8660]], ['leftrightarrows', [8646]], ['leftrightharpoons', [8651]], ['leftrightsquigarrow', [8621]], ['LeftRightVector', [10574]], ['LeftTeeArrow', [8612]], ['LeftTee', [8867]], ['LeftTeeVector', [10586]], ['leftthreetimes', [8907]], ['LeftTriangleBar', [10703]], ['LeftTriangle', [8882]], ['LeftTriangleEqual', [8884]], ['LeftUpDownVector', [10577]], ['LeftUpTeeVector', [10592]], ['LeftUpVectorBar', [10584]], ['LeftUpVector', [8639]], ['LeftVectorBar', [10578]], ['LeftVector', [8636]], ['lEg', [10891]], ['leg', [8922]], ['leq', [8804]], ['leqq', [8806]], ['leqslant', [10877]], ['lescc', [10920]], ['les', [10877]], ['lesdot', [10879]], ['lesdoto', [10881]], ['lesdotor', [10883]], ['lesg', [8922, 65024]], ['lesges', [10899]], ['lessapprox', [10885]], ['lessdot', [8918]], ['lesseqgtr', [8922]], ['lesseqqgtr', [10891]], ['LessEqualGreater', [8922]], ['LessFullEqual', [8806]], ['LessGreater', [8822]], ['lessgtr', [8822]], ['LessLess', [10913]], ['lesssim', [8818]], ['LessSlantEqual', [10877]], ['LessTilde', [8818]], ['lfisht', [10620]], ['lfloor', [8970]], ['Lfr', [120079]], ['lfr', [120105]], ['lg', [8822]], ['lgE', [10897]], ['lHar', [10594]], ['lhard', [8637]], ['lharu', [8636]], ['lharul', [10602]], ['lhblk', [9604]], ['LJcy', [1033]], ['ljcy', [1113]], ['llarr', [8647]], ['ll', [8810]], ['Ll', [8920]], ['llcorner', [8990]], ['Lleftarrow', [8666]], ['llhard', [10603]], ['lltri', [9722]], ['Lmidot', [319]], ['lmidot', [320]], ['lmoustache', [9136]], ['lmoust', [9136]], ['lnap', [10889]], ['lnapprox', [10889]], ['lne', [10887]], ['lnE', [8808]], ['lneq', [10887]], ['lneqq', [8808]], ['lnsim', [8934]], ['loang', [10220]], ['loarr', [8701]], ['lobrk', [10214]], ['longleftarrow', [10229]], ['LongLeftArrow', [10229]], ['Longleftarrow', [10232]], ['longleftrightarrow', [10231]], ['LongLeftRightArrow', [10231]], ['Longleftrightarrow', [10234]], ['longmapsto', [10236]], ['longrightarrow', [10230]], ['LongRightArrow', [10230]], ['Longrightarrow', [10233]], ['looparrowleft', [8619]], ['looparrowright', [8620]], ['lopar', [10629]], ['Lopf', [120131]], ['lopf', [120157]], ['loplus', [10797]], ['lotimes', [10804]], ['lowast', [8727]], ['lowbar', [95]], ['LowerLeftArrow', [8601]], ['LowerRightArrow', [8600]], ['loz', [9674]], ['lozenge', [9674]], ['lozf', [10731]], ['lpar', [40]], ['lparlt', [10643]], ['lrarr', [8646]], ['lrcorner', [8991]], ['lrhar', [8651]], ['lrhard', [10605]], ['lrm', [8206]], ['lrtri', [8895]], ['lsaquo', [8249]], ['lscr', [120001]], ['Lscr', [8466]], ['lsh', [8624]], ['Lsh', [8624]], ['lsim', [8818]], ['lsime', [10893]], ['lsimg', [10895]], ['lsqb', [91]], ['lsquo', [8216]], ['lsquor', [8218]], ['Lstrok', [321]], ['lstrok', [322]], ['ltcc', [10918]], ['ltcir', [10873]], ['lt', [60]], ['LT', [60]], ['Lt', [8810]], ['ltdot', [8918]], ['lthree', [8907]], ['ltimes', [8905]], ['ltlarr', [10614]], ['ltquest', [10875]], ['ltri', [9667]], ['ltrie', [8884]], ['ltrif', [9666]], ['ltrPar', [10646]], ['lurdshar', [10570]], ['luruhar', [10598]], ['lvertneqq', [8808, 65024]], ['lvnE', [8808, 65024]], ['macr', [175]], ['male', [9794]], ['malt', [10016]], ['maltese', [10016]], ['Map', [10501]], ['map', [8614]], ['mapsto', [8614]], ['mapstodown', [8615]], ['mapstoleft', [8612]], ['mapstoup', [8613]], ['marker', [9646]], ['mcomma', [10793]], ['Mcy', [1052]], ['mcy', [1084]], ['mdash', [8212]], ['mDDot', [8762]], ['measuredangle', [8737]], ['MediumSpace', [8287]], ['Mellintrf', [8499]], ['Mfr', [120080]], ['mfr', [120106]], ['mho', [8487]], ['micro', [181]], ['midast', [42]], ['midcir', [10992]], ['mid', [8739]], ['middot', [183]], ['minusb', [8863]], ['minus', [8722]], ['minusd', [8760]], ['minusdu', [10794]], ['MinusPlus', [8723]], ['mlcp', [10971]], ['mldr', [8230]], ['mnplus', [8723]], ['models', [8871]], ['Mopf', [120132]], ['mopf', [120158]], ['mp', [8723]], ['mscr', [120002]], ['Mscr', [8499]], ['mstpos', [8766]], ['Mu', [924]], ['mu', [956]], ['multimap', [8888]], ['mumap', [8888]], ['nabla', [8711]], ['Nacute', [323]], ['nacute', [324]], ['nang', [8736, 8402]], ['nap', [8777]], ['napE', [10864, 824]], ['napid', [8779, 824]], ['napos', [329]], ['napprox', [8777]], ['natural', [9838]], ['naturals', [8469]], ['natur', [9838]], ['nbsp', [160]], ['nbump', [8782, 824]], ['nbumpe', [8783, 824]], ['ncap', [10819]], ['Ncaron', [327]], ['ncaron', [328]], ['Ncedil', [325]], ['ncedil', [326]], ['ncong', [8775]], ['ncongdot', [10861, 824]], ['ncup', [10818]], ['Ncy', [1053]], ['ncy', [1085]], ['ndash', [8211]], ['nearhk', [10532]], ['nearr', [8599]], ['neArr', [8663]], ['nearrow', [8599]], ['ne', [8800]], ['nedot', [8784, 824]], ['NegativeMediumSpace', [8203]], ['NegativeThickSpace', [8203]], ['NegativeThinSpace', [8203]], ['NegativeVeryThinSpace', [8203]], ['nequiv', [8802]], ['nesear', [10536]], ['nesim', [8770, 824]], ['NestedGreaterGreater', [8811]], ['NestedLessLess', [8810]], ['nexist', [8708]], ['nexists', [8708]], ['Nfr', [120081]], ['nfr', [120107]], ['ngE', [8807, 824]], ['nge', [8817]], ['ngeq', [8817]], ['ngeqq', [8807, 824]], ['ngeqslant', [10878, 824]], ['nges', [10878, 824]], ['nGg', [8921, 824]], ['ngsim', [8821]], ['nGt', [8811, 8402]], ['ngt', [8815]], ['ngtr', [8815]], ['nGtv', [8811, 824]], ['nharr', [8622]], ['nhArr', [8654]], ['nhpar', [10994]], ['ni', [8715]], ['nis', [8956]], ['nisd', [8954]], ['niv', [8715]], ['NJcy', [1034]], ['njcy', [1114]], ['nlarr', [8602]], ['nlArr', [8653]], ['nldr', [8229]], ['nlE', [8806, 824]], ['nle', [8816]], ['nleftarrow', [8602]], ['nLeftarrow', [8653]], ['nleftrightarrow', [8622]], ['nLeftrightarrow', [8654]], ['nleq', [8816]], ['nleqq', [8806, 824]], ['nleqslant', [10877, 824]], ['nles', [10877, 824]], ['nless', [8814]], ['nLl', [8920, 824]], ['nlsim', [8820]], ['nLt', [8810, 8402]], ['nlt', [8814]], ['nltri', [8938]], ['nltrie', [8940]], ['nLtv', [8810, 824]], ['nmid', [8740]], ['NoBreak', [8288]], ['NonBreakingSpace', [160]], ['nopf', [120159]], ['Nopf', [8469]], ['Not', [10988]], ['not', [172]], ['NotCongruent', [8802]], ['NotCupCap', [8813]], ['NotDoubleVerticalBar', [8742]], ['NotElement', [8713]], ['NotEqual', [8800]], ['NotEqualTilde', [8770, 824]], ['NotExists', [8708]], ['NotGreater', [8815]], ['NotGreaterEqual', [8817]], ['NotGreaterFullEqual', [8807, 824]], ['NotGreaterGreater', [8811, 824]], ['NotGreaterLess', [8825]], ['NotGreaterSlantEqual', [10878, 824]], ['NotGreaterTilde', [8821]], ['NotHumpDownHump', [8782, 824]], ['NotHumpEqual', [8783, 824]], ['notin', [8713]], ['notindot', [8949, 824]], ['notinE', [8953, 824]], ['notinva', [8713]], ['notinvb', [8951]], ['notinvc', [8950]], ['NotLeftTriangleBar', [10703, 824]], ['NotLeftTriangle', [8938]], ['NotLeftTriangleEqual', [8940]], ['NotLess', [8814]], ['NotLessEqual', [8816]], ['NotLessGreater', [8824]], ['NotLessLess', [8810, 824]], ['NotLessSlantEqual', [10877, 824]], ['NotLessTilde', [8820]], ['NotNestedGreaterGreater', [10914, 824]], ['NotNestedLessLess', [10913, 824]], ['notni', [8716]], ['notniva', [8716]], ['notnivb', [8958]], ['notnivc', [8957]], ['NotPrecedes', [8832]], ['NotPrecedesEqual', [10927, 824]], ['NotPrecedesSlantEqual', [8928]], ['NotReverseElement', [8716]], ['NotRightTriangleBar', [10704, 824]], ['NotRightTriangle', [8939]], ['NotRightTriangleEqual', [8941]], ['NotSquareSubset', [8847, 824]], ['NotSquareSubsetEqual', [8930]], ['NotSquareSuperset', [8848, 824]], ['NotSquareSupersetEqual', [8931]], ['NotSubset', [8834, 8402]], ['NotSubsetEqual', [8840]], ['NotSucceeds', [8833]], ['NotSucceedsEqual', [10928, 824]], ['NotSucceedsSlantEqual', [8929]], ['NotSucceedsTilde', [8831, 824]], ['NotSuperset', [8835, 8402]], ['NotSupersetEqual', [8841]], ['NotTilde', [8769]], ['NotTildeEqual', [8772]], ['NotTildeFullEqual', [8775]], ['NotTildeTilde', [8777]], ['NotVerticalBar', [8740]], ['nparallel', [8742]], ['npar', [8742]], ['nparsl', [11005, 8421]], ['npart', [8706, 824]], ['npolint', [10772]], ['npr', [8832]], ['nprcue', [8928]], ['nprec', [8832]], ['npreceq', [10927, 824]], ['npre', [10927, 824]], ['nrarrc', [10547, 824]], ['nrarr', [8603]], ['nrArr', [8655]], ['nrarrw', [8605, 824]], ['nrightarrow', [8603]], ['nRightarrow', [8655]], ['nrtri', [8939]], ['nrtrie', [8941]], ['nsc', [8833]], ['nsccue', [8929]], ['nsce', [10928, 824]], ['Nscr', [119977]], ['nscr', [120003]], ['nshortmid', [8740]], ['nshortparallel', [8742]], ['nsim', [8769]], ['nsime', [8772]], ['nsimeq', [8772]], ['nsmid', [8740]], ['nspar', [8742]], ['nsqsube', [8930]], ['nsqsupe', [8931]], ['nsub', [8836]], ['nsubE', [10949, 824]], ['nsube', [8840]], ['nsubset', [8834, 8402]], ['nsubseteq', [8840]], ['nsubseteqq', [10949, 824]], ['nsucc', [8833]], ['nsucceq', [10928, 824]], ['nsup', [8837]], ['nsupE', [10950, 824]], ['nsupe', [8841]], ['nsupset', [8835, 8402]], ['nsupseteq', [8841]], ['nsupseteqq', [10950, 824]], ['ntgl', [8825]], ['Ntilde', [209]], ['ntilde', [241]], ['ntlg', [8824]], ['ntriangleleft', [8938]], ['ntrianglelefteq', [8940]], ['ntriangleright', [8939]], ['ntrianglerighteq', [8941]], ['Nu', [925]], ['nu', [957]], ['num', [35]], ['numero', [8470]], ['numsp', [8199]], ['nvap', [8781, 8402]], ['nvdash', [8876]], ['nvDash', [8877]], ['nVdash', [8878]], ['nVDash', [8879]], ['nvge', [8805, 8402]], ['nvgt', [62, 8402]], ['nvHarr', [10500]], ['nvinfin', [10718]], ['nvlArr', [10498]], ['nvle', [8804, 8402]], ['nvlt', [60, 8402]], ['nvltrie', [8884, 8402]], ['nvrArr', [10499]], ['nvrtrie', [8885, 8402]], ['nvsim', [8764, 8402]], ['nwarhk', [10531]], ['nwarr', [8598]], ['nwArr', [8662]], ['nwarrow', [8598]], ['nwnear', [10535]], ['Oacute', [211]], ['oacute', [243]], ['oast', [8859]], ['Ocirc', [212]], ['ocirc', [244]], ['ocir', [8858]], ['Ocy', [1054]], ['ocy', [1086]], ['odash', [8861]], ['Odblac', [336]], ['odblac', [337]], ['odiv', [10808]], ['odot', [8857]], ['odsold', [10684]], ['OElig', [338]], ['oelig', [339]], ['ofcir', [10687]], ['Ofr', [120082]], ['ofr', [120108]], ['ogon', [731]], ['Ograve', [210]], ['ograve', [242]], ['ogt', [10689]], ['ohbar', [10677]], ['ohm', [937]], ['oint', [8750]], ['olarr', [8634]], ['olcir', [10686]], ['olcross', [10683]], ['oline', [8254]], ['olt', [10688]], ['Omacr', [332]], ['omacr', [333]], ['Omega', [937]], ['omega', [969]], ['Omicron', [927]], ['omicron', [959]], ['omid', [10678]], ['ominus', [8854]], ['Oopf', [120134]], ['oopf', [120160]], ['opar', [10679]], ['OpenCurlyDoubleQuote', [8220]], ['OpenCurlyQuote', [8216]], ['operp', [10681]], ['oplus', [8853]], ['orarr', [8635]], ['Or', [10836]], ['or', [8744]], ['ord', [10845]], ['order', [8500]], ['orderof', [8500]], ['ordf', [170]], ['ordm', [186]], ['origof', [8886]], ['oror', [10838]], ['orslope', [10839]], ['orv', [10843]], ['oS', [9416]], ['Oscr', [119978]], ['oscr', [8500]], ['Oslash', [216]], ['oslash', [248]], ['osol', [8856]], ['Otilde', [213]], ['otilde', [245]], ['otimesas', [10806]], ['Otimes', [10807]], ['otimes', [8855]], ['Ouml', [214]], ['ouml', [246]], ['ovbar', [9021]], ['OverBar', [8254]], ['OverBrace', [9182]], ['OverBracket', [9140]], ['OverParenthesis', [9180]], ['para', [182]], ['parallel', [8741]], ['par', [8741]], ['parsim', [10995]], ['parsl', [11005]], ['part', [8706]], ['PartialD', [8706]], ['Pcy', [1055]], ['pcy', [1087]], ['percnt', [37]], ['period', [46]], ['permil', [8240]], ['perp', [8869]], ['pertenk', [8241]], ['Pfr', [120083]], ['pfr', [120109]], ['Phi', [934]], ['phi', [966]], ['phiv', [981]], ['phmmat', [8499]], ['phone', [9742]], ['Pi', [928]], ['pi', [960]], ['pitchfork', [8916]], ['piv', [982]], ['planck', [8463]], ['planckh', [8462]], ['plankv', [8463]], ['plusacir', [10787]], ['plusb', [8862]], ['pluscir', [10786]], ['plus', [43]], ['plusdo', [8724]], ['plusdu', [10789]], ['pluse', [10866]], ['PlusMinus', [177]], ['plusmn', [177]], ['plussim', [10790]], ['plustwo', [10791]], ['pm', [177]], ['Poincareplane', [8460]], ['pointint', [10773]], ['popf', [120161]], ['Popf', [8473]], ['pound', [163]], ['prap', [10935]], ['Pr', [10939]], ['pr', [8826]], ['prcue', [8828]], ['precapprox', [10935]], ['prec', [8826]], ['preccurlyeq', [8828]], ['Precedes', [8826]], ['PrecedesEqual', [10927]], ['PrecedesSlantEqual', [8828]], ['PrecedesTilde', [8830]], ['preceq', [10927]], ['precnapprox', [10937]], ['precneqq', [10933]], ['precnsim', [8936]], ['pre', [10927]], ['prE', [10931]], ['precsim', [8830]], ['prime', [8242]], ['Prime', [8243]], ['primes', [8473]], ['prnap', [10937]], ['prnE', [10933]], ['prnsim', [8936]], ['prod', [8719]], ['Product', [8719]], ['profalar', [9006]], ['profline', [8978]], ['profsurf', [8979]], ['prop', [8733]], ['Proportional', [8733]], ['Proportion', [8759]], ['propto', [8733]], ['prsim', [8830]], ['prurel', [8880]], ['Pscr', [119979]], ['pscr', [120005]], ['Psi', [936]], ['psi', [968]], ['puncsp', [8200]], ['Qfr', [120084]], ['qfr', [120110]], ['qint', [10764]], ['qopf', [120162]], ['Qopf', [8474]], ['qprime', [8279]], ['Qscr', [119980]], ['qscr', [120006]], ['quaternions', [8461]], ['quatint', [10774]], ['quest', [63]], ['questeq', [8799]], ['quot', [34]], ['QUOT', [34]], ['rAarr', [8667]], ['race', [8765, 817]], ['Racute', [340]], ['racute', [341]], ['radic', [8730]], ['raemptyv', [10675]], ['rang', [10217]], ['Rang', [10219]], ['rangd', [10642]], ['range', [10661]], ['rangle', [10217]], ['raquo', [187]], ['rarrap', [10613]], ['rarrb', [8677]], ['rarrbfs', [10528]], ['rarrc', [10547]], ['rarr', [8594]], ['Rarr', [8608]], ['rArr', [8658]], ['rarrfs', [10526]], ['rarrhk', [8618]], ['rarrlp', [8620]], ['rarrpl', [10565]], ['rarrsim', [10612]], ['Rarrtl', [10518]], ['rarrtl', [8611]], ['rarrw', [8605]], ['ratail', [10522]], ['rAtail', [10524]], ['ratio', [8758]], ['rationals', [8474]], ['rbarr', [10509]], ['rBarr', [10511]], ['RBarr', [10512]], ['rbbrk', [10099]], ['rbrace', [125]], ['rbrack', [93]], ['rbrke', [10636]], ['rbrksld', [10638]], ['rbrkslu', [10640]], ['Rcaron', [344]], ['rcaron', [345]], ['Rcedil', [342]], ['rcedil', [343]], ['rceil', [8969]], ['rcub', [125]], ['Rcy', [1056]], ['rcy', [1088]], ['rdca', [10551]], ['rdldhar', [10601]], ['rdquo', [8221]], ['rdquor', [8221]], ['rdsh', [8627]], ['real', [8476]], ['realine', [8475]], ['realpart', [8476]], ['reals', [8477]], ['Re', [8476]], ['rect', [9645]], ['reg', [174]], ['REG', [174]], ['ReverseElement', [8715]], ['ReverseEquilibrium', [8651]], ['ReverseUpEquilibrium', [10607]], ['rfisht', [10621]], ['rfloor', [8971]], ['rfr', [120111]], ['Rfr', [8476]], ['rHar', [10596]], ['rhard', [8641]], ['rharu', [8640]], ['rharul', [10604]], ['Rho', [929]], ['rho', [961]], ['rhov', [1009]], ['RightAngleBracket', [10217]], ['RightArrowBar', [8677]], ['rightarrow', [8594]], ['RightArrow', [8594]], ['Rightarrow', [8658]], ['RightArrowLeftArrow', [8644]], ['rightarrowtail', [8611]], ['RightCeiling', [8969]], ['RightDoubleBracket', [10215]], ['RightDownTeeVector', [10589]], ['RightDownVectorBar', [10581]], ['RightDownVector', [8642]], ['RightFloor', [8971]], ['rightharpoondown', [8641]], ['rightharpoonup', [8640]], ['rightleftarrows', [8644]], ['rightleftharpoons', [8652]], ['rightrightarrows', [8649]], ['rightsquigarrow', [8605]], ['RightTeeArrow', [8614]], ['RightTee', [8866]], ['RightTeeVector', [10587]], ['rightthreetimes', [8908]], ['RightTriangleBar', [10704]], ['RightTriangle', [8883]], ['RightTriangleEqual', [8885]], ['RightUpDownVector', [10575]], ['RightUpTeeVector', [10588]], ['RightUpVectorBar', [10580]], ['RightUpVector', [8638]], ['RightVectorBar', [10579]], ['RightVector', [8640]], ['ring', [730]], ['risingdotseq', [8787]], ['rlarr', [8644]], ['rlhar', [8652]], ['rlm', [8207]], ['rmoustache', [9137]], ['rmoust', [9137]], ['rnmid', [10990]], ['roang', [10221]], ['roarr', [8702]], ['robrk', [10215]], ['ropar', [10630]], ['ropf', [120163]], ['Ropf', [8477]], ['roplus', [10798]], ['rotimes', [10805]], ['RoundImplies', [10608]], ['rpar', [41]], ['rpargt', [10644]], ['rppolint', [10770]], ['rrarr', [8649]], ['Rrightarrow', [8667]], ['rsaquo', [8250]], ['rscr', [120007]], ['Rscr', [8475]], ['rsh', [8625]], ['Rsh', [8625]], ['rsqb', [93]], ['rsquo', [8217]], ['rsquor', [8217]], ['rthree', [8908]], ['rtimes', [8906]], ['rtri', [9657]], ['rtrie', [8885]], ['rtrif', [9656]], ['rtriltri', [10702]], ['RuleDelayed', [10740]], ['ruluhar', [10600]], ['rx', [8478]], ['Sacute', [346]], ['sacute', [347]], ['sbquo', [8218]], ['scap', [10936]], ['Scaron', [352]], ['scaron', [353]], ['Sc', [10940]], ['sc', [8827]], ['sccue', [8829]], ['sce', [10928]], ['scE', [10932]], ['Scedil', [350]], ['scedil', [351]], ['Scirc', [348]], ['scirc', [349]], ['scnap', [10938]], ['scnE', [10934]], ['scnsim', [8937]], ['scpolint', [10771]], ['scsim', [8831]], ['Scy', [1057]], ['scy', [1089]], ['sdotb', [8865]], ['sdot', [8901]], ['sdote', [10854]], ['searhk', [10533]], ['searr', [8600]], ['seArr', [8664]], ['searrow', [8600]], ['sect', [167]], ['semi', [59]], ['seswar', [10537]], ['setminus', [8726]], ['setmn', [8726]], ['sext', [10038]], ['Sfr', [120086]], ['sfr', [120112]], ['sfrown', [8994]], ['sharp', [9839]], ['SHCHcy', [1065]], ['shchcy', [1097]], ['SHcy', [1064]], ['shcy', [1096]], ['ShortDownArrow', [8595]], ['ShortLeftArrow', [8592]], ['shortmid', [8739]], ['shortparallel', [8741]], ['ShortRightArrow', [8594]], ['ShortUpArrow', [8593]], ['shy', [173]], ['Sigma', [931]], ['sigma', [963]], ['sigmaf', [962]], ['sigmav', [962]], ['sim', [8764]], ['simdot', [10858]], ['sime', [8771]], ['simeq', [8771]], ['simg', [10910]], ['simgE', [10912]], ['siml', [10909]], ['simlE', [10911]], ['simne', [8774]], ['simplus', [10788]], ['simrarr', [10610]], ['slarr', [8592]], ['SmallCircle', [8728]], ['smallsetminus', [8726]], ['smashp', [10803]], ['smeparsl', [10724]], ['smid', [8739]], ['smile', [8995]], ['smt', [10922]], ['smte', [10924]], ['smtes', [10924, 65024]], ['SOFTcy', [1068]], ['softcy', [1100]], ['solbar', [9023]], ['solb', [10692]], ['sol', [47]], ['Sopf', [120138]], ['sopf', [120164]], ['spades', [9824]], ['spadesuit', [9824]], ['spar', [8741]], ['sqcap', [8851]], ['sqcaps', [8851, 65024]], ['sqcup', [8852]], ['sqcups', [8852, 65024]], ['Sqrt', [8730]], ['sqsub', [8847]], ['sqsube', [8849]], ['sqsubset', [8847]], ['sqsubseteq', [8849]], ['sqsup', [8848]], ['sqsupe', [8850]], ['sqsupset', [8848]], ['sqsupseteq', [8850]], ['square', [9633]], ['Square', [9633]], ['SquareIntersection', [8851]], ['SquareSubset', [8847]], ['SquareSubsetEqual', [8849]], ['SquareSuperset', [8848]], ['SquareSupersetEqual', [8850]], ['SquareUnion', [8852]], ['squarf', [9642]], ['squ', [9633]], ['squf', [9642]], ['srarr', [8594]], ['Sscr', [119982]], ['sscr', [120008]], ['ssetmn', [8726]], ['ssmile', [8995]], ['sstarf', [8902]], ['Star', [8902]], ['star', [9734]], ['starf', [9733]], ['straightepsilon', [1013]], ['straightphi', [981]], ['strns', [175]], ['sub', [8834]], ['Sub', [8912]], ['subdot', [10941]], ['subE', [10949]], ['sube', [8838]], ['subedot', [10947]], ['submult', [10945]], ['subnE', [10955]], ['subne', [8842]], ['subplus', [10943]], ['subrarr', [10617]], ['subset', [8834]], ['Subset', [8912]], ['subseteq', [8838]], ['subseteqq', [10949]], ['SubsetEqual', [8838]], ['subsetneq', [8842]], ['subsetneqq', [10955]], ['subsim', [10951]], ['subsub', [10965]], ['subsup', [10963]], ['succapprox', [10936]], ['succ', [8827]], ['succcurlyeq', [8829]], ['Succeeds', [8827]], ['SucceedsEqual', [10928]], ['SucceedsSlantEqual', [8829]], ['SucceedsTilde', [8831]], ['succeq', [10928]], ['succnapprox', [10938]], ['succneqq', [10934]], ['succnsim', [8937]], ['succsim', [8831]], ['SuchThat', [8715]], ['sum', [8721]], ['Sum', [8721]], ['sung', [9834]], ['sup1', [185]], ['sup2', [178]], ['sup3', [179]], ['sup', [8835]], ['Sup', [8913]], ['supdot', [10942]], ['supdsub', [10968]], ['supE', [10950]], ['supe', [8839]], ['supedot', [10948]], ['Superset', [8835]], ['SupersetEqual', [8839]], ['suphsol', [10185]], ['suphsub', [10967]], ['suplarr', [10619]], ['supmult', [10946]], ['supnE', [10956]], ['supne', [8843]], ['supplus', [10944]], ['supset', [8835]], ['Supset', [8913]], ['supseteq', [8839]], ['supseteqq', [10950]], ['supsetneq', [8843]], ['supsetneqq', [10956]], ['supsim', [10952]], ['supsub', [10964]], ['supsup', [10966]], ['swarhk', [10534]], ['swarr', [8601]], ['swArr', [8665]], ['swarrow', [8601]], ['swnwar', [10538]], ['szlig', [223]], ['Tab', [9]], ['target', [8982]], ['Tau', [932]], ['tau', [964]], ['tbrk', [9140]], ['Tcaron', [356]], ['tcaron', [357]], ['Tcedil', [354]], ['tcedil', [355]], ['Tcy', [1058]], ['tcy', [1090]], ['tdot', [8411]], ['telrec', [8981]], ['Tfr', [120087]], ['tfr', [120113]], ['there4', [8756]], ['therefore', [8756]], ['Therefore', [8756]], ['Theta', [920]], ['theta', [952]], ['thetasym', [977]], ['thetav', [977]], ['thickapprox', [8776]], ['thicksim', [8764]], ['ThickSpace', [8287, 8202]], ['ThinSpace', [8201]], ['thinsp', [8201]], ['thkap', [8776]], ['thksim', [8764]], ['THORN', [222]], ['thorn', [254]], ['tilde', [732]], ['Tilde', [8764]], ['TildeEqual', [8771]], ['TildeFullEqual', [8773]], ['TildeTilde', [8776]], ['timesbar', [10801]], ['timesb', [8864]], ['times', [215]], ['timesd', [10800]], ['tint', [8749]], ['toea', [10536]], ['topbot', [9014]], ['topcir', [10993]], ['top', [8868]], ['Topf', [120139]], ['topf', [120165]], ['topfork', [10970]], ['tosa', [10537]], ['tprime', [8244]], ['trade', [8482]], ['TRADE', [8482]], ['triangle', [9653]], ['triangledown', [9663]], ['triangleleft', [9667]], ['trianglelefteq', [8884]], ['triangleq', [8796]], ['triangleright', [9657]], ['trianglerighteq', [8885]], ['tridot', [9708]], ['trie', [8796]], ['triminus', [10810]], ['TripleDot', [8411]], ['triplus', [10809]], ['trisb', [10701]], ['tritime', [10811]], ['trpezium', [9186]], ['Tscr', [119983]], ['tscr', [120009]], ['TScy', [1062]], ['tscy', [1094]], ['TSHcy', [1035]], ['tshcy', [1115]], ['Tstrok', [358]], ['tstrok', [359]], ['twixt', [8812]], ['twoheadleftarrow', [8606]], ['twoheadrightarrow', [8608]], ['Uacute', [218]], ['uacute', [250]], ['uarr', [8593]], ['Uarr', [8607]], ['uArr', [8657]], ['Uarrocir', [10569]], ['Ubrcy', [1038]], ['ubrcy', [1118]], ['Ubreve', [364]], ['ubreve', [365]], ['Ucirc', [219]], ['ucirc', [251]], ['Ucy', [1059]], ['ucy', [1091]], ['udarr', [8645]], ['Udblac', [368]], ['udblac', [369]], ['udhar', [10606]], ['ufisht', [10622]], ['Ufr', [120088]], ['ufr', [120114]], ['Ugrave', [217]], ['ugrave', [249]], ['uHar', [10595]], ['uharl', [8639]], ['uharr', [8638]], ['uhblk', [9600]], ['ulcorn', [8988]], ['ulcorner', [8988]], ['ulcrop', [8975]], ['ultri', [9720]], ['Umacr', [362]], ['umacr', [363]], ['uml', [168]], ['UnderBar', [95]], ['UnderBrace', [9183]], ['UnderBracket', [9141]], ['UnderParenthesis', [9181]], ['Union', [8899]], ['UnionPlus', [8846]], ['Uogon', [370]], ['uogon', [371]], ['Uopf', [120140]], ['uopf', [120166]], ['UpArrowBar', [10514]], ['uparrow', [8593]], ['UpArrow', [8593]], ['Uparrow', [8657]], ['UpArrowDownArrow', [8645]], ['updownarrow', [8597]], ['UpDownArrow', [8597]], ['Updownarrow', [8661]], ['UpEquilibrium', [10606]], ['upharpoonleft', [8639]], ['upharpoonright', [8638]], ['uplus', [8846]], ['UpperLeftArrow', [8598]], ['UpperRightArrow', [8599]], ['upsi', [965]], ['Upsi', [978]], ['upsih', [978]], ['Upsilon', [933]], ['upsilon', [965]], ['UpTeeArrow', [8613]], ['UpTee', [8869]], ['upuparrows', [8648]], ['urcorn', [8989]], ['urcorner', [8989]], ['urcrop', [8974]], ['Uring', [366]], ['uring', [367]], ['urtri', [9721]], ['Uscr', [119984]], ['uscr', [120010]], ['utdot', [8944]], ['Utilde', [360]], ['utilde', [361]], ['utri', [9653]], ['utrif', [9652]], ['uuarr', [8648]], ['Uuml', [220]], ['uuml', [252]], ['uwangle', [10663]], ['vangrt', [10652]], ['varepsilon', [1013]], ['varkappa', [1008]], ['varnothing', [8709]], ['varphi', [981]], ['varpi', [982]], ['varpropto', [8733]], ['varr', [8597]], ['vArr', [8661]], ['varrho', [1009]], ['varsigma', [962]], ['varsubsetneq', [8842, 65024]], ['varsubsetneqq', [10955, 65024]], ['varsupsetneq', [8843, 65024]], ['varsupsetneqq', [10956, 65024]], ['vartheta', [977]], ['vartriangleleft', [8882]], ['vartriangleright', [8883]], ['vBar', [10984]], ['Vbar', [10987]], ['vBarv', [10985]], ['Vcy', [1042]], ['vcy', [1074]], ['vdash', [8866]], ['vDash', [8872]], ['Vdash', [8873]], ['VDash', [8875]], ['Vdashl', [10982]], ['veebar', [8891]], ['vee', [8744]], ['Vee', [8897]], ['veeeq', [8794]], ['vellip', [8942]], ['verbar', [124]], ['Verbar', [8214]], ['vert', [124]], ['Vert', [8214]], ['VerticalBar', [8739]], ['VerticalLine', [124]], ['VerticalSeparator', [10072]], ['VerticalTilde', [8768]], ['VeryThinSpace', [8202]], ['Vfr', [120089]], ['vfr', [120115]], ['vltri', [8882]], ['vnsub', [8834, 8402]], ['vnsup', [8835, 8402]], ['Vopf', [120141]], ['vopf', [120167]], ['vprop', [8733]], ['vrtri', [8883]], ['Vscr', [119985]], ['vscr', [120011]], ['vsubnE', [10955, 65024]], ['vsubne', [8842, 65024]], ['vsupnE', [10956, 65024]], ['vsupne', [8843, 65024]], ['Vvdash', [8874]], ['vzigzag', [10650]], ['Wcirc', [372]], ['wcirc', [373]], ['wedbar', [10847]], ['wedge', [8743]], ['Wedge', [8896]], ['wedgeq', [8793]], ['weierp', [8472]], ['Wfr', [120090]], ['wfr', [120116]], ['Wopf', [120142]], ['wopf', [120168]], ['wp', [8472]], ['wr', [8768]], ['wreath', [8768]], ['Wscr', [119986]], ['wscr', [120012]], ['xcap', [8898]], ['xcirc', [9711]], ['xcup', [8899]], ['xdtri', [9661]], ['Xfr', [120091]], ['xfr', [120117]], ['xharr', [10231]], ['xhArr', [10234]], ['Xi', [926]], ['xi', [958]], ['xlarr', [10229]], ['xlArr', [10232]], ['xmap', [10236]], ['xnis', [8955]], ['xodot', [10752]], ['Xopf', [120143]], ['xopf', [120169]], ['xoplus', [10753]], ['xotime', [10754]], ['xrarr', [10230]], ['xrArr', [10233]], ['Xscr', [119987]], ['xscr', [120013]], ['xsqcup', [10758]], ['xuplus', [10756]], ['xutri', [9651]], ['xvee', [8897]], ['xwedge', [8896]], ['Yacute', [221]], ['yacute', [253]], ['YAcy', [1071]], ['yacy', [1103]], ['Ycirc', [374]], ['ycirc', [375]], ['Ycy', [1067]], ['ycy', [1099]], ['yen', [165]], ['Yfr', [120092]], ['yfr', [120118]], ['YIcy', [1031]], ['yicy', [1111]], ['Yopf', [120144]], ['yopf', [120170]], ['Yscr', [119988]], ['yscr', [120014]], ['YUcy', [1070]], ['yucy', [1102]], ['yuml', [255]], ['Yuml', [376]], ['Zacute', [377]], ['zacute', [378]], ['Zcaron', [381]], ['zcaron', [382]], ['Zcy', [1047]], ['zcy', [1079]], ['Zdot', [379]], ['zdot', [380]], ['zeetrf', [8488]], ['ZeroWidthSpace', [8203]], ['Zeta', [918]], ['zeta', [950]], ['zfr', [120119]], ['Zfr', [8488]], ['ZHcy', [1046]], ['zhcy', [1078]], ['zigrarr', [8669]], ['zopf', [120171]], ['Zopf', [8484]], ['Zscr', [119989]], ['zscr', [120015]], ['zwj', [8205]], ['zwnj', [8204]]];

var alphaIndex = {};
var charIndex = {};

createIndexes(alphaIndex, charIndex);

/**
 * @constructor
 */
function Html5Entities() {}

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.decode = function(str) {
    if (str.length === 0) {
        return '';
    }
    return str.replace(/&(#?[\w\d]+);?/g, function(s, entity) {
        var char;
        if (entity.charAt(0) === "#") {
            var code = entity.charAt(1) === 'x' ?
                parseInt(entity.substr(2).toLowerCase(), 16) :
                parseInt(entity.substr(1));

            if (!(isNaN(code) || code < -32768 || code > 65535)) {
                char = String.fromCharCode(code);
            }
        } else {
            char = alphaIndex[entity];
        }
        return char || s;
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.encode = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var charInfo = charIndex[str.charCodeAt(i)];
        if (charInfo) {
            var alpha = charInfo[str.charCodeAt(i + 1)];
            if (alpha) {
                i++;
            } else {
                alpha = charInfo[''];
            }
            if (alpha) {
                result += "&" + alpha + ";";
                i++;
                continue;
            }
        }
        result += str.charAt(i);
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.encodeNonUTF = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        var charInfo = charIndex[c];
        if (charInfo) {
            var alpha = charInfo[str.charCodeAt(i + 1)];
            if (alpha) {
                i++;
            } else {
                alpha = charInfo[''];
            }
            if (alpha) {
                result += "&" + alpha + ";";
                i++;
                continue;
            }
        }
        if (c < 32 || c > 126) {
            result += '&#' + c + ';';
        } else {
            result += str.charAt(i);
        }
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html5Entities.prototype.encodeNonASCII = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        if (c <= 255) {
            result += str[i++];
            continue;
        }
        result += '&#' + c + ';';
        i++
    }
    return result;
};

/**
 * @param {Object} alphaIndex Passed by reference.
 * @param {Object} charIndex Passed by reference.
 */
function createIndexes(alphaIndex, charIndex) {
    var i = ENTITIES.length;
    var _results = [];
    while (i--) {
        var e = ENTITIES[i];
        var alpha = e[0];
        var chars = e[1];
        var chr = chars[0];
        var addChar = (chr < 32 || chr > 126) || chr === 62 || chr === 60 || chr === 38 || chr === 34 || chr === 39;
        var charInfo;
        if (addChar) {
            charInfo = charIndex[chr] = charIndex[chr] || {};
        }
        if (chars[1]) {
            var chr2 = chars[1];
            alphaIndex[alpha] = String.fromCharCode(chr) + String.fromCharCode(chr2);
            _results.push(addChar && (charInfo[chr2] = alpha));
        } else {
            alphaIndex[alpha] = String.fromCharCode(chr);
            _results.push(addChar && (charInfo[''] = alpha));
        }
    }
}

module.exports = Html5Entities;


/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomByte = __webpack_require__(485);

function encode(lookup, number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = encode;


/***/ }),

/***/ 3643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CollectionsItem$prop;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);

var PropTypes = __webpack_require__(7);

function CollectionsItem(props) {
    var _props$item = props.item,
        title = _props$item.title,
        url = _props$item.url,
        image = _props$item.image;
    var index = props.index;


    return React.createElement(
        'a',
        { className: 'collections-carousel-item-link', href: url, 'data-index': index, onClick: function onClick() {
                return props.onClick(props.item, index);
            } },
        React.createElement(
            'div',
            { className: 'collections-carousel-item-image-wrapper' },
            React.createElement('img', { className: 'collections-carousel-item-image is-centered', src: image, alt: title })
        ),
        React.createElement(
            'span',
            { className: 'collections-carousel-item-title' },
            title
        )
    );
}

CollectionsItem.propTypes = (_CollectionsItem$prop = {
    index: PropTypes.number,
    item: PropTypes.object
}, _defineProperty(_CollectionsItem$prop, 'item', PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.string
})), _defineProperty(_CollectionsItem$prop, 'onClick', PropTypes.func), _CollectionsItem$prop);

module.exports = CollectionsItem;

/***/ }),

/***/ 3644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var SanitizeHtml = __webpack_require__(301);

function HeroItem(props) {
    var _props$item = props.item,
        title = _props$item.title,
        url = _props$item.url,
        image = _props$item.image;

    var index = props.index;

    return React.createElement(
        'a',
        { className: 'hero-carousel-item', href: url, 'data-index': index, onClick: function onClick() {
                return props.onClick(props.item, index);
            } },
        React.createElement(
            'div',
            { className: 'hero-carousel-item-image-wrapper' },
            React.createElement('img', { className: 'hero-carousel-item-image is-centered', src: image, alt: title })
        ),
        React.createElement(
            'span',
            { className: 'hero-carousel-item-title' },
            React.createElement(SanitizeHtml, { content: title, allowedTags: ['i'] })
        )
    );
}

HeroItem.propTypes = {
    index: PropTypes.number,
    item: PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string,
        image: PropTypes.string
    }),
    onClick: PropTypes.func
};

module.exports = HeroItem;

/***/ }),

/***/ 3645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var css = __webpack_require__(3066);
var ArrowSvgRight = __webpack_require__(356);
var classnames = __webpack_require__(16);

function PersonalizationSliderOverlay(props) {

    var containerClass = classnames(props.additionalClassName, css.overlay, _defineProperty({}, css.isFlipped, props.isLeft));

    return React.createElement(
        'div',
        { className: containerClass, onClick: props.onClick },
        React.createElement(ArrowSvgRight, { className: css.overlayArrow })
    );
}

PersonalizationSliderOverlay.propTypes = {
    additionalClassName: PropTypes.string,
    isLeft: PropTypes.bool,
    onClick: PropTypes.func
};

PersonalizationSliderOverlay.defaultProps = {
    onClick: function onClick() {}
};

module.exports = PersonalizationSliderOverlay;

/***/ }),

/***/ 3646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var get = __webpack_require__(14);
var css = __webpack_require__(1486);
var PersonalizationPanelItem = __webpack_require__(3647);
var PersonalizationPanelMainItem = __webpack_require__(3648);

var _require = __webpack_require__(1139),
    getPersonalizationVariant = _require.getPersonalizationVariant;

// TODO: Update how recommendation & trending data is handled GROWTH-1906


function normalizeTitle(personalizationData) {
    var categoryTitle = get(personalizationData, 'recommendable.properties.displayName') || get(personalizationData, 'recommendable.name') || personalizationData.displayName;
    var associatedCategory = get(personalizationData, 'associatedCategory.name');

    if (associatedCategory) {
        categoryTitle = categoryTitle + ' ' + associatedCategory;
    }

    return categoryTitle;
}

function OtherItems(_ref) {
    var items = _ref.items,
        variant = _ref.variant,
        categoryUrl = _ref.categoryUrl;

    if (!items.length) {
        return null;
    }

    return React.createElement(
        'div',
        { className: 'colXs12 colXl6 ' + css.flexItem },
        React.createElement(
            'div',
            { className: 'rowFlex ' + css.smallItemListContainer },
            items.map(function (item, index) {
                return React.createElement(PersonalizationPanelItem, {
                    key: item.id,
                    item: item,
                    index: index + 1,
                    variant: variant,
                    categoryUrl: categoryUrl
                });
            })
        )
    );
}

OtherItems.propTypes = {
    items: PropTypes.array,
    variant: PropTypes.string,
    categoryUrl: PropTypes.string
};

function PersonalizationPanel(props) {
    var _props$item$items = _toArray(props.item.items),
        item = _props$item$items[0],
        otherItems = _props$item$items.slice(1);

    var categoryTitle = normalizeTitle(props.item);
    var categoryUrl = props.item.url;
    var trackingVariant = getPersonalizationVariant(props.item);
    var mainItemProps = {
        isMobile: props.isMobile,
        variant: trackingVariant,
        item: item,
        categoryTitle: categoryTitle,
        categoryUrl: categoryUrl
    };

    if (!item) {
        return null;
    }

    return React.createElement(
        'div',
        { className: 'rowFlex ' + css.itemPageContainer },
        React.createElement(PersonalizationPanelMainItem, mainItemProps),
        React.createElement(OtherItems, { items: otherItems, variant: trackingVariant, categoryUrl: categoryUrl })
    );
}

PersonalizationPanel.propTypes = {
    item: PropTypes.object,
    isMobile: PropTypes.bool
};

module.exports = PersonalizationPanel;

/***/ }),

/***/ 3647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var get = __webpack_require__(14);
var css = __webpack_require__(1486);
var MediaQuery = __webpack_require__(387);
var strings = __webpack_require__(378);

var _require = __webpack_require__(371),
    queries = _require.queries;

var tracking = __webpack_require__(1139);

function onItemClick(item, trackingObj) {
    tracking.trackPersonalizationPromoClick();
    tracking.trackPersonalizationItemClick(item, trackingObj);
}

function PersonalizationPanelItem(props) {
    var url = get(props.item, 'pdpUrls[0]');
    var image = get(props.item, 'images[0].thumb');
    var shortTitle = strings.clampWithEllipsis(props.item.title, 45);
    var trackingObj = {
        variant: props.variant,
        category: props.categoryUrl,
        position: props.index
    };

    return React.createElement(
        'a',
        { key: props.item.id, href: url, onClick: function onClick() {
                return onItemClick(props.item, trackingObj);
            }, className: 'colXs4 colXl5 ' + css.smallItemWrapper },
        React.createElement(
            'div',
            { className: css.itemContainer },
            React.createElement('img', { alt: props.item.title, className: css.smallItemImage, src: image })
        ),
        React.createElement(
            MediaQuery,
            { query: [queries.md, queries.lg, queries.xl] },
            React.createElement(
                'div',
                { className: css.itemTitle },
                shortTitle
            )
        )
    );
}

PersonalizationPanelItem.propTypes = {
    item: PropTypes.object.isRequired,
    variant: PropTypes.string.isRequired,
    categoryUrl: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired
};

module.exports = PersonalizationPanelItem;

/***/ }),

/***/ 3648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var get = __webpack_require__(14);
var classnames = __webpack_require__(16);
var css = __webpack_require__(1486);
var copy = __webpack_require__(2027);
var tracking = __webpack_require__(1139);

function onItemClick(item, trackingObj) {
    tracking.trackPersonalizationPromoClick();
    tracking.trackPersonalizationItemClick(item, trackingObj);
}

function viewAllClick(variant) {
    tracking.trackPersonalizationPromoClick();
    tracking.trackPersonalizationViewAll(variant);
}

function PersonalizationPanelMainItem(props) {
    var itemUrl = get(props.item, 'pdpUrls[0]');
    var image = get(props.item, 'images[0].medium');
    var viewAllClass = classnames(css.viewAll, {
        'button-medium button-naked': props.isMobile
    });
    var trackingObj = {
        variant: props.variant,
        category: props.categoryUrl,
        position: 0
    };

    return React.createElement(
        'div',
        { className: 'colXs12 colXl6 ' + css.flexItem },
        React.createElement(
            'div',
            { className: css.itemContainer + ' ' + css.isMain },
            React.createElement(
                'div',
                { className: 'h1 ' + css.categoryTitle },
                props.categoryTitle
            ),
            React.createElement(
                'a',
                { className: css.mainImageContainer, href: itemUrl, onClick: function onClick() {
                        return onItemClick(props.item, trackingObj);
                    } },
                React.createElement('img', { alt: props.item.title, className: css.mainItemImage, src: image })
            ),
            React.createElement(
                'a',
                { href: props.categoryUrl, className: viewAllClass, onClick: function onClick() {
                        return viewAllClick(props.variant);
                    } },
                copy.viewAll
            )
        )
    );
}

PersonalizationPanelMainItem.propTypes = {
    item: PropTypes.object.isRequired,
    categoryUrl: PropTypes.string.isRequired,
    categoryTitle: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired,
    isMobile: PropTypes.bool
};

module.exports = PersonalizationPanelMainItem;

/***/ }),

/***/ 3649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var mobileCheck = __webpack_require__(284);
var MediaQuery = __webpack_require__(387);

var _require = __webpack_require__(371),
    queries = _require.queries;

var css = __webpack_require__(1486);
var ContextComponent = __webpack_require__(61);
var classnames = __webpack_require__(16);
var PersonalizationOverlay = __webpack_require__(3645);
var copy = __webpack_require__(2027);
var HomepageCarousel = __webpack_require__(2176);
var tracking = __webpack_require__(1139);
var PersonalizationPanel = __webpack_require__(3646);

var Personalization = function (_ContextComponent) {
    _inherits(Personalization, _ContextComponent);

    function Personalization() {
        _classCallCheck(this, Personalization);

        var _this = _possibleConstructorReturn(this, (Personalization.__proto__ || Object.getPrototypeOf(Personalization)).call(this));

        _this.state = {
            currentRecIndex: 0
        };

        _this.onRightOverlayClick = _this.onRightOverlayClick.bind(_this);
        _this.onLeftOverlayClick = _this.onLeftOverlayClick.bind(_this);
        return _this;
    }

    _createClass(Personalization, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            tracking.trackPersonalizationMount();
        }
    }, {
        key: 'onRightOverlayClick',
        value: function onRightOverlayClick() {
            // We need to check if Ref is not null, since we're using mediaQueries
            // and multiple instances of the carousel with the same props.
            if (this.carouselRef) {
                this.carouselRef._model.nextPage();
                tracking.trackPersonalizationPromoClick();
            }
        }
    }, {
        key: 'onLeftOverlayClick',
        value: function onLeftOverlayClick() {
            if (this.carouselRef) {
                this.carouselRef._model.previousPage();
                tracking.trackPersonalizationPromoClick();
            }
        }

        /**
         * Cuts the number of carousel items to 4 for the mobile screen.
         *
         * @param {array} models - personalizations.
         * @returns {array} - personalizations with only first 4 items sliced.
         */

    }, {
        key: 'filterItemsForMobile',
        value: function filterItemsForMobile(models) {
            return models.map(function (personalization) {
                return _extends({}, personalization, {
                    items: personalization.items.slice(0, 4)
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var props = this.props,
                state = this.state;

            var modelsWithItems = props.models.filter(function (model) {
                return model.items.length;
            });
            var leftOverlay = void 0;
            var rightOverlay = void 0;

            if (!modelsWithItems.length) {
                return null;
            }

            var variant = tracking.getPersonalizationVariant(modelsWithItems[0]);

            var leftOverlayClass = classnames({
                'is-hidden': state.currentRecIndex === 0
            });

            var rightOverlayClass = classnames({
                'is-hidden': state.currentRecIndex === modelsWithItems.length - 1
            });

            var carouselData = {
                carouselRef: function carouselRef(carousel) {
                    _this2.carouselRef = carousel;
                },
                useDotsNav: true,
                transitionEffect: 'slide',
                onPageChange: function onPageChange(index) {
                    _this2.setState({
                        currentRecIndex: index
                    });
                },
                classNames: {
                    list: css.carouselListContainer,
                    dotControls: css.carouselDotControls,
                    item: classnames(css.carouselItem, _defineProperty({}, css.isMobile, props.isMobile)),
                    dot: 'hero-carousel-dot',
                    wrapper: css.carouselWrapper,
                    dotCarouselWrapper: css.dotCarouselWrapper
                },
                onDotClick: function onDotClick() {
                    tracking.trackPersonalizationDotClick(variant);
                    tracking.trackPersonalizationPromoClick();
                },
                onImpression: tracking.trackPersonalizationImpression,
                customTransformItemStyle: function customTransformItemStyle(index) {
                    return {
                        opacity: this._state.page === index ? 1 : 0.3
                    };
                }
            };

            leftOverlay = React.createElement(PersonalizationOverlay, {
                additionalClassName: leftOverlayClass,
                isLeft: true,
                onClick: this.onLeftOverlayClick
            });

            rightOverlay = React.createElement(PersonalizationOverlay, {
                additionalClassName: rightOverlayClass,
                onClick: this.onRightOverlayClick
            });

            return React.createElement(
                'div',
                { className: 'module-has-no-header' },
                React.createElement(
                    'div',
                    { className: 'personalization-banner' },
                    React.createElement(
                        'div',
                        { className: 'whiteout-page-width rowFlex' },
                        React.createElement(
                            'div',
                            { className: css.container + ' colXl9 colXs12' },
                            leftOverlay,
                            React.createElement(
                                'div',
                                { className: 'h1 center-text personalization-banner-header' },
                                copy.title
                            ),
                            React.createElement(
                                MediaQuery,
                                { query: [queries.xs, queries.sm, queries.md] },
                                React.createElement(
                                    HomepageCarousel,
                                    _extends({ items: this.filterItemsForMobile(modelsWithItems), itemsPerPage: 1.2 }, carouselData, { isMobile: true }),
                                    React.createElement(PersonalizationPanel, { isMobile: true })
                                )
                            ),
                            React.createElement(
                                MediaQuery,
                                { query: queries.lg },
                                React.createElement(
                                    HomepageCarousel,
                                    _extends({ items: this.filterItemsForMobile(modelsWithItems), itemWidth: 80 }, carouselData, { isMobile: true, isCentered: true }),
                                    React.createElement(PersonalizationPanel, { isMobile: true })
                                )
                            ),
                            React.createElement(
                                MediaQuery,
                                { query: queries.xl },
                                React.createElement(
                                    HomepageCarousel,
                                    _extends({ items: modelsWithItems }, carouselData),
                                    React.createElement(PersonalizationPanel, null)
                                )
                            ),
                            rightOverlay
                        )
                    )
                )
            );
        }
    }]);

    return Personalization;
}(ContextComponent);

Personalization.propTypes = {
    models: PropTypes.array.isRequired
};

Personalization.defaultProps = {
    isMobile: mobileCheck.any()
};

module.exports = Personalization;

/***/ }),

/***/ 3650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(39);
var connectToStores = __webpack_require__(290);
var provideContext = __webpack_require__(288);

var User = __webpack_require__(15);
var recommendationsActions = __webpack_require__(893);
var trendingActions = __webpack_require__(1830);
var RecommendationsStore = __webpack_require__(666);
var TrendingStore = __webpack_require__(1105);

var _require = __webpack_require__(2177),
    Personalization = _require.Personalization;

var _require2 = __webpack_require__(1138),
    TRENDING_ACTIONS = _require2.ACTIONS;

var _require3 = __webpack_require__(597),
    RECOMMENDATIONS_ACTIONS = _require3.ACTIONS;

var ITEMS_PER_PAGE = 5;
var ITEMS_TO_FETCH = 10;

function getCarouselData(keys, fluxStore, context) {
    var store = context.getStore(fluxStore);

    return {
        models: store.getCollectionsFiltered(keys, ITEMS_PER_PAGE)
    };
}

function renderCarousel(_ref) {
    var container = _ref.container,
        context = _ref.context,
        connector = _ref.connector,
        stores = _ref.stores,
        tracking = _ref.tracking;

    var component = provideContext(connectToStores(Personalization, stores, connector));

    ReactDOM.render(React.createElement(component, {
        context: context.getComponentContext(),
        tracking: tracking
    }), container);
}

var personalizationHelpers = {
    CATEGORY_KEY: 'homepageSliderCategory',
    ATTRIBUTE_KEY: 'homepageSliderAttribute',
    TRENDING_KEY: 'homepageSliderTrending',

    render: function render(options) {
        var _this = this;

        var context = options.context,
            container = options.container,
            _options$dataKeys = options.dataKeys,
            dataKeys = _options$dataKeys === undefined ? [this.CATEGORY_KEY, this.ATTRIBUTE_KEY] : _options$dataKeys,
            _options$categoryLeve = options.categoryLevels,
            categoryLevels = _options$categoryLeve === undefined ? 1 : _options$categoryLeve;


        if (!User.loggedIn()) {
            return Promise.resolve(true);
        }

        return Promise.all([context.executeAction(recommendationsActions.fetchByCategory, {
            collectionKey: this.CATEGORY_KEY,
            pageSize: 2,
            itemsPageSize: ITEMS_TO_FETCH,
            fields: RECOMMENDATIONS_ACTIONS.FIELDS.IMAGES
        }), context.executeAction(recommendationsActions.fetchByAttribute, {
            collectionKey: this.ATTRIBUTE_KEY,
            pageSize: 2,
            itemsPageSize: ITEMS_TO_FETCH,
            fields: RECOMMENDATIONS_ACTIONS.FIELDS.IMAGES,
            categoryLevels: categoryLevels
        })]).then(function () {
            var data = getCarouselData(dataKeys, RecommendationsStore, context);

            if (data.models.length) {
                return {
                    connector: getCarouselData.bind(_this, dataKeys, RecommendationsStore),
                    stores: [RecommendationsStore],
                    container: container,
                    context: context
                };
            } else {
                return context.executeAction(trendingActions.fetchByCategory, {
                    collectionKey: _this.TRENDING_KEY,
                    pageSize: 4,
                    itemsPageSize: ITEMS_PER_PAGE,
                    fields: TRENDING_ACTIONS.FIELDS.IMAGES
                }).then(function () {
                    return {
                        connector: getCarouselData.bind(_this, [_this.TRENDING_KEY], TrendingStore),
                        stores: [TrendingStore],
                        container: container,
                        context: context
                    };
                });
            }
        }).then(function (payload) {
            return renderCarousel(payload);
        });
    }
};

module.exports = personalizationHelpers;

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Module dependencies.
 */

try {
  var query = __webpack_require__(86);
} catch (err) {
  var query = __webpack_require__(86);
}

var Element = __webpack_require__(92).Element;
var proto = Element && Element.prototype || {};
var vendor = proto.matches
  || proto.matchesSelector
  || proto.webkitMatchesSelector
  || proto.mozMatchesSelector
  || proto.msMatchesSelector
  || proto.oMatchesSelector;

module.exports = match;

/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function match(el, selector) {
  if (!el || el.nodeType !== 1) return false;
  if (vendor) return vendor.call(el, selector);
  var nodes = query.all(selector, el.parentNode);
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i] == el) return true;
  }
  return false;
}


/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);
var BaseModel = __webpack_require__(339);

/**
 * Base carousel view component. "Concrete" carousel views should not extend from this class but should instead wrap it.
 * The model should be initialized in the "child" classes in the `componentWillMount` lifecycle callback.
 * @class
 */

var BaseCarousel = function (_React$Component) {
    _inherits(BaseCarousel, _React$Component);

    function BaseCarousel() {
        _classCallCheck(this, BaseCarousel);

        return _possibleConstructorReturn(this, (BaseCarousel.__proto__ || Object.getPrototypeOf(BaseCarousel)).apply(this, arguments));
    }

    _createClass(BaseCarousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Pass the `el` to the view-model
            this.props.model.onMount(this.refs.list);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // Do any view-model cleanup.
            this.props.model.destroy();
        }

        /**
         * Wraps the passed in children in an `li` so we can apply additional styles to the items.
         * @return {Array}
         */

    }, {
        key: '_getChildren',
        value: function _getChildren() {
            var _this2 = this;

            return React.Children.map(this.props.children, function (child, i) {
                var _props = _this2.props,
                    model = _props.model,
                    _props$classNames = _props.classNames,
                    classNames = _props$classNames === undefined ? {} : _props$classNames;

                var style = {};
                var className = classnames('base-carousel-item', _defineProperty({}, classNames.item, classNames.item));

                // Get any item styles specified by the view-model.
                model.transformItemStyle(style, i);

                return React.createElement(
                    'li',
                    { style: style, className: className },
                    child
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                model = _props2.model,
                _props2$classNames = _props2.classNames,
                classNames = _props2$classNames === undefined ? {} : _props2$classNames;

            var style = {};
            var className = classnames('base-carousel-list', _defineProperty({}, classNames.list, classNames.list));

            // Get any styles specified by the view-model.
            model.transformListStyle(style);

            return React.createElement(
                'ul',
                { ref: 'list', style: style, className: className },
                this._getChildren()
            );
        }
    }]);

    return BaseCarousel;
}(React.Component);

BaseCarousel.propTypes = {
    // View model derived from `BaseModel`
    model: PropTypes.instanceOf(BaseModel).isRequired,
    children: PropTypes.node,
    classNames: PropTypes.shape({
        // className to add to the `ul`
        list: PropTypes.string,
        // className to add to each item's `li`
        item: PropTypes.string
    })
};

module.exports = BaseCarousel;

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);

function normalizeQueries(queries) {
    if (typeof queries === 'string') {
        return queries;
    }

    return queries.join(', ');
}

/**
 * Component that only renders its children if the passed-in media query is currently met. This allows you to, for
 * example, define different layouts on mobile and desktop. The `query` props is a simple media query string. Pre-
 * defined queries for screen size can be found in `global/core/commonjs/screenSize`. Each `MediaQuery` can only
 * have one direct child or an error will be thrown.
 *
 * Example:
 * const {queries} = require('global/core/commonjs/screenSize');
 *
 * ...
 *
 * render() {
 *     const props = this.props;
 *
 *     return (
 *         <div className="layout-container">
 *             <MediaQuery query={queries.mobile}>
 *                 <LayoutMobile {...props} />
 *             </MediaQuery>
 *             <MediaQuery query={queries.tablet}>
 *                 <LayoutTablet {...props} />
 *             </MediaQuery>
 *             <MediaQuery query={queries.desktop}>
 *                 <LayoutDesktop {...props} />
 *             </MediaQuery>
 *         </div>
 *     );
 * }
 *
 * The following will exclude desktop from displaying the layout element:
 *
 * render() {
 *      return (
 *          <div className="layout-container">
 *              <MediaQuery query={queries.desktop} exclude={true}>
 *                  <LayoutNonDesktop {...props} />
 *              </MediaQuery>
 *          </div>
 *      );
 * }
 *
 */

var MediaQuery = function (_React$Component) {
    _inherits(MediaQuery, _React$Component);

    function MediaQuery(props) {
        _classCallCheck(this, MediaQuery);

        var _this = _possibleConstructorReturn(this, (MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call(this, props));

        _this.state = {
            matches: false
        };

        _this._update = _this._update.bind(_this);
        return _this;
    }

    _createClass(MediaQuery, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._setQuery(normalizeQueries(this.props.query));
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this._setQuery(normalizeQueries(nextProps.query));
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._mql.removeListener(this._update);
        }
    }, {
        key: '_setQuery',
        value: function _setQuery(query) {
            if (this._mql) {
                this._mql.removeListener(this._update);
            }

            var mql = this._mql = window.matchMedia(query);

            this._update(mql);
            mql.addListener(this._update);
        }
    }, {
        key: '_update',
        value: function _update(mql) {
            var matches = this.props.exclude ? !mql.matches : mql.matches;

            if (this.state.matches === matches) {
                return;
            }

            this.setState({ matches: matches });
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.matches) {
                return null;
            }

            return React.Children.only(this.props.children);
        }
    }]);

    return MediaQuery;
}(React.Component);

MediaQuery.propTypes = {
    query: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    children: PropTypes.object.isRequired,
    exclude: PropTypes.bool
};

MediaQuery.defaultProps = {
    query: ''
};

module.exports = MediaQuery;

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Builds a new instance of the constructor from the given key, with additional arguments passed to the contructor.
// @param {string} key - the key that was associated with the constructor in a prior call to register
var registryStack = [];
var newsy = module.exports = function (key) {
    if (!getRegistry()[key]) {
        throw new Error(key + " is not a registered constructor");
    }
    if (getRegistry()[key].unsatisfiedDependencies) {
        throw new Error(key + " has unmet dependencies: " + Object.keys(getRegistry()[key].unsatisfiedDependencies).join(", "));
    }
    return getRegistry()[key].build(Array.prototype.splice.call(arguments, 1));
};
var getRegistry = newsy.getRegistry = function () {
    return global.__newsyRegistry__;
};
var setRegistry = newsy.setRegistry = function (registry) {
    global.__newsyRegistry__ = registry;
};
setRegistry(global.__newsyRegistry__ || {});
// saves the current registry onto the private registryStack, and exposes a new registry. Only useful for testing
newsy.newRegistry = function () {
    registryStack.push(getRegistry());
    setRegistry({});
};

// pops the top of registryStack onto the current registry, replacing what was already there.
newsy.restoreRegistry = function () {
    setRegistry(registryStack.pop());
};

// Registers a new constructor to be associated with a key.
// @param {String} key - key with with the constructor will be associated
// @param {Constructor} constructor - constructor that will be assocaited with the key
newsy.register = function (constructor, key) {
    var dependencyIndex;
    var dependencyKey;
    var registration;
    var i;
    if (constructor instanceof Array) {
        for (i = 0; i < constructor.length; ++i) {
            newsy.register(constructor[i]);
        }
        return;
    }
    if (!constructor.newsy && !key) {
        throw new Error("constructor does not have a 'newsy' property and no key was provided to newsy.register");
    }
    if (!key && "string" === typeof constructor.newsy) {
        key = constructor.newsy;
    } else if (!key && constructor.newsy.name) {
        key = constructor.newsy.name;
    }
    if (!key) {
        throw new Error("constructor does not have a newsy name. Specify it as static.newsy or static.newsy.name, or as the second argument to newsy.register");
    }
    registration = getRegistry()[key] = {
        build: function (args) {
            function F() {
                return constructor.apply(this, args);
            }
            F.prototype = constructor.prototype;
            return new F();
        },
        originalConstructor: constructor,
        unsatisfiedDependencies: undefined
    };
    // build a truth map of the current unmet dependencies
    if (constructor.newsy && constructor.newsy.builds) {
        for (dependencyIndex = 0; dependencyIndex < constructor.newsy.builds.length; ++dependencyIndex) {
            dependencyKey = constructor.newsy.builds[dependencyIndex];
            if (!getRegistry()[dependencyKey]) {
                if (!registration.unsatisfiedDependencies) {
                    registration.unsatisfiedDependencies = {};
                }
                // declare dependencyKey to be a dependency of key
                registration.unsatisfiedDependencies[dependencyKey] = true;
            }
        }
    }
    if (!registration.unsatisfiedDependencies) {
        newsy._dependencySatisfied(key);
    }
    return constructor;
};

newsy.getConstructor = function (options) {
    var Constructor;
    if ("string" === typeof options) {
        options = {key: options};
    }
    if (!options.key) {
        throw new Error('constructor key required for getConstructor');
    }
    Constructor = getRegistry()[options.key];
    Constructor = (Constructor && Constructor.originalConstructor) || options.defaultConstructor;
    if (!Constructor) {
        throw new Error("No constructor for key " + options.key);
    }
    return Constructor;
};

// declares a dependency as fully satisfied, and proparages the change through the entire dependency graph
newsy._dependencySatisfied = function (key) {
    var anyAreTrue;
    var registryKey;
    var dependencyKey;
    var newUnsatisfiedDependencies;
    var oldUnsatisfiedDependencies;
    // iterate through all the registered constructors
    for (registryKey in getRegistry()) {
        if (getRegistry().hasOwnProperty(registryKey)) {
            if (!getRegistry()[registryKey].unsatisfiedDependencies) {
                // registryKey has no unsatisfied dependencies to begin with
                continue;
            }
            if (!getRegistry()[registryKey].unsatisfiedDependencies[key]) {
                // key was not a dependency of registryKey to begin with
                continue;
            }
            // remove key as a dependency of registryKey
            getRegistry()[registryKey].unsatisfiedDependencies[key] = false;
            newUnsatisfiedDependencies = {};
            oldUnsatisfiedDependencies = getRegistry()[registryKey].unsatisfiedDependencies;
            anyAreTrue = false;
            for (dependencyKey in oldUnsatisfiedDependencies) {
                if (oldUnsatisfiedDependencies.hasOwnProperty(dependencyKey)) {
                    if (oldUnsatisfiedDependencies[dependencyKey]) {
                        newUnsatisfiedDependencies[dependencyKey] = true;
                        anyAreTrue = true;
                    }
                }
            }
            // if none of the dependencies are true, adjust the entire depenency graph to reflect this
            if (anyAreTrue) {
                // registryKey still has unsatisfied dependencies
                getRegistry()[registryKey].unsatisfiedDependencies = newUnsatisfiedDependencies;
                continue;
            }
            getRegistry()[registryKey].unsatisfiedDependencies = undefined;
            // all of registryKey's dependencies have been satisfied, so everything that depends on it can now remove registryKey as a dependency
            newsy._dependencySatisfied(registryKey);
        }
    }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Utility classes for detecting specific touch actions.
// This module can be moved to a separate repo.



module.exports = {
    MultiTouchDetector: __webpack_require__(273),
    DoubleTapDetector: __webpack_require__(473),
    PanDetector: __webpack_require__(474),
    SwipeDetector: __webpack_require__(464),
    PinchDetector: __webpack_require__(475)
};

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  return (/input|select|textarea|button|object/.test(nodeName) ?
    !element.disabled :
    "a" === nodeName ?
      element.href || isTabIndexNotNaN :
      isTabIndexNotNaN) && visible(element);
}

function hidden(el) {
  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
    el.style.display === 'none';
}

function visible(element) {
  while (element) {
    if (element === document.body) break;
    if (hidden(element)) return false;
    element = element.parentNode;
  }
  return true;
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
    return tabbable(el);
  });
}

module.exports = findTabbableDescendants;



/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);
var shortid = __webpack_require__(465);

var styles = __webpack_require__(517);

/**
 * Represents a wrapper with dots navigation for carousels.
 * @class
 */

var DotCarousel = function (_React$Component) {
    _inherits(DotCarousel, _React$Component);

    function DotCarousel() {
        _classCallCheck(this, DotCarousel);

        return _possibleConstructorReturn(this, (DotCarousel.__proto__ || Object.getPrototypeOf(DotCarousel)).apply(this, arguments));
    }

    _createClass(DotCarousel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // If auto prop is set to true, the carousel with switch pages automatically.
            if (this.props.auto) {
                this._run();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.auto) {
                clearInterval(this._timer);
            }
        }

        /**
         * Method used to create the dots for carousel pagination.
         *
         * @param {function} callback - optional callback.
         * @returns {object} - dots JSX.
         */

    }, {
        key: '_createDots',
        value: function _createDots(callback) {
            var model = this.props.model;


            if (model.canPaginate()) {
                var totalPages = model.getTotalPages();
                var active = model.getState().page;
                var dots = [];
                // TODO: Remove this and adjust default styles?
                var dotControlsClass = classnames(styles.dotControls, this.props.classNames.dotControls);

                for (var index = 0; index < totalPages; index++) {
                    var classes = ['' + styles.dot];

                    if (index === active) {
                        classes.push('' + styles.current);
                    }

                    dots.push(this._createDot(index, classes, callback));
                }

                return React.createElement(
                    'ul',
                    { className: dotControlsClass },
                    dots
                );
            } else {
                return null;
            }
        }

        /**
         * Method used to create an individual dot for dotted pagination.
         *
         * @param {int} - index, unique key for each dot.
         * @param {array} - array of classes to be applied to the dot.
         * @returns {object} - JSX of a dot.
         */

    }, {
        key: '_createDot',
        value: function _createDot(index, classes, callback) {
            var _classnames,
                _this2 = this;

            var dot = this.props.classNames.dot;

            var dotClassName = styles[this.props.dotsColorType];
            var dotClassNames = classnames((_classnames = {}, _defineProperty(_classnames, dotClassName, dotClassName), _defineProperty(_classnames, dot, dot), _classnames));

            return React.createElement(
                'li',
                { key: shortid.generate(), className: styles.dotWrapper },
                React.createElement(
                    'span',
                    {
                        className: classes.join(' ') + ' ' + dotClassNames,
                        key: index,
                        onClick: function onClick() {
                            return _this2._onDotClick(index, callback);
                        }
                    },
                    index
                )
            );
        }
    }, {
        key: '_onDotClick',
        value: function _onDotClick(index, callback) {
            var _props = this.props,
                onDotClick = _props.onDotClick,
                model = _props.model;


            this.props.setPage(index, model, callback);
            onDotClick(index);
        }

        /**
         * Method used to start the automatic carousel run.
         */

    }, {
        key: '_run',
        value: function _run() {
            var _this3 = this;

            var _props$model = this.props.model,
                itemsPerPage = _props$model._itemsPerPage,
                totalItems = _props$model._itemCount,
                state = _props$model._state;


            var auto = function auto() {
                _this3._timer = setInterval(function () {
                    var page = state.page;
                    var totalPages = totalItems / itemsPerPage;
                    var nextPage = page + 1;
                    if (nextPage >= totalPages) {
                        nextPage = 0;
                    }
                    _this3.props.setPage(nextPage, _this3.props.model);
                }, _this3.props.autoDuration);
            };

            this.restartInterval = function () {
                clearInterval(_this3._timer);
                auto();
            };
            auto();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                createCarousel = _props2.createCarousel,
                classNames = _props2.classNames,
                dotsPosition = _props2.dotsPosition,
                auto = _props2.auto;


            var dotCarouselWrapperProps = {
                className: classnames(styles.dotCarouselWrapper, classNames.dotCarouselWrapper || ''),
                'data-tn': auto ? 'auto-dots' : ''
            };

            var dotsPositionClass = classnames({
                'float-r': dotsPosition === 'right',
                'float-l': dotsPosition === 'left'
            });

            return React.createElement(
                'div',
                dotCarouselWrapperProps,
                React.createElement(
                    'div',
                    { className: 'arrow-carousel-wrapper' },
                    createCarousel()
                ),
                React.createElement(
                    'div',
                    { className: dotsPositionClass },
                    auto ? this._createDots(this.restartInterval) : this._createDots()
                ),
                React.createElement('div', { className: styles.clear })
            );
        }
    }]);

    return DotCarousel;
}(React.Component);

DotCarousel.propTypes = {
    model: PropTypes.object.isRequired,
    onDotClick: PropTypes.func,
    dotsColorType: PropTypes.oneOf(['buyer', 'trade']),
    dotsPosition: PropTypes.oneOf(['left', 'right']),
    createCarousel: PropTypes.func,
    setPage: PropTypes.func,
    classNames: PropTypes.object,
    auto: PropTypes.bool,
    autoDuration: PropTypes.number
};

DotCarousel.defaultProps = {
    auto: false
};

module.exports = DotCarousel;

/***/ }),

/***/ 411:
/***/ (function(module, exports, __webpack_require__) {

/*
  Module dependencies
*/
var ElementType = __webpack_require__(412);
var entities = __webpack_require__(413);

/*
  Boolean Attributes
*/
var booleanAttributes = {
  __proto__: null,
  allowfullscreen: true,
  async: true,
  autofocus: true,
  autoplay: true,
  checked: true,
  controls: true,
  default: true,
  defer: true,
  disabled: true,
  hidden: true,
  ismap: true,
  loop: true,
  multiple: true,
  muted: true,
  open: true,
  readonly: true,
  required: true,
  reversed: true,
  scoped: true,
  seamless: true,
  selected: true,
  typemustmatch: true
};

var unencodedElements = {
  __proto__: null,
  style: true,
  script: true,
  xmp: true,
  iframe: true,
  noembed: true,
  noframes: true,
  plaintext: true,
  noscript: true
};

/*
  Format attributes
*/
function formatAttrs(attributes, opts) {
  if (!attributes) return;

  var output = '',
      value;

  // Loop through the attributes
  for (var key in attributes) {
    value = attributes[key];
    if (output) {
      output += ' ';
    }

    if (!value && booleanAttributes[key]) {
      output += key;
    } else {
      output += key + '="' + (opts.decodeEntities ? entities.encodeXML(value) : value) + '"';
    }
  }

  return output;
}

/*
  Self-enclosing tags (stolen from node-htmlparser)
*/
var singleTag = {
  __proto__: null,
  area: true,
  base: true,
  basefont: true,
  br: true,
  col: true,
  command: true,
  embed: true,
  frame: true,
  hr: true,
  img: true,
  input: true,
  isindex: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true,
};


var render = module.exports = function(dom, opts) {
  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
  opts = opts || {};

  var output = '';

  for(var i = 0; i < dom.length; i++){
    var elem = dom[i];

    if (elem.type === 'root')
      output += render(elem.children, opts);
    else if (ElementType.isTag(elem))
      output += renderTag(elem, opts);
    else if (elem.type === ElementType.Directive)
      output += renderDirective(elem);
    else if (elem.type === ElementType.Comment)
      output += renderComment(elem);
    else if (elem.type === ElementType.CDATA)
      output += renderCdata(elem);
    else
      output += renderText(elem, opts);
  }

  return output;
};

function renderTag(elem, opts) {
  // Handle SVG
  if (elem.name === "svg") opts = {decodeEntities: opts.decodeEntities, xmlMode: true};

  var tag = '<' + elem.name,
      attribs = formatAttrs(elem.attribs, opts);

  if (attribs) {
    tag += ' ' + attribs;
  }

  if (
    opts.xmlMode
    && (!elem.children || elem.children.length === 0)
  ) {
    tag += '/>';
  } else {
    tag += '>';
    if (elem.children) {
      tag += render(elem.children, opts);
    }

    if (!singleTag[elem.name] || opts.xmlMode) {
      tag += '</' + elem.name + '>';
    }
  }

  return tag;
}

function renderDirective(elem) {
  return '<' + elem.data + '>';
}

function renderText(elem, opts) {
  var data = elem.data || '';

  // if entities weren't decoded, no need to encode them back
  if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
    data = entities.encodeXML(data);
  }

  return data;
}

function renderCdata(elem) {
  return '<![CDATA[' + elem.children[0].data + ']]>';
}

function renderComment(elem) {
  return '<!--' + elem.data + '-->';
}


/***/ }),

/***/ 412:
/***/ (function(module, exports) {

//Types of elements found in the DOM
module.exports = {
	Text: "text", //Text
	Directive: "directive", //<? ... ?>
	Comment: "comment", //<!-- ... -->
	Script: "script", //<script> tags
	Style: "style", //<style> tags
	Tag: "tag", //Any tag
	CDATA: "cdata", //<![CDATA[ ... ]]>

	isTag: function(elem){
		return elem.type === "tag" || elem.type === "script" || elem.type === "style";
	}
};

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

var encode = __webpack_require__(416),
    decode = __webpack_require__(414);

exports.decode = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
};

exports.decodeStrict = function(data, level){
	return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
};

exports.encode = function(data, level){
	return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
};

exports.encodeXML = encode.XML;

exports.encodeHTML4 =
exports.encodeHTML5 =
exports.encodeHTML  = encode.HTML;

exports.decodeXML =
exports.decodeXMLStrict = decode.XML;

exports.decodeHTML4 =
exports.decodeHTML5 =
exports.decodeHTML = decode.HTML;

exports.decodeHTML4Strict =
exports.decodeHTML5Strict =
exports.decodeHTMLStrict = decode.HTMLStrict;

exports.escape = encode.escape;


/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

var entityMap = __webpack_require__(348),
    legacyMap = __webpack_require__(418),
    xmlMap    = __webpack_require__(349),
    decodeCodePoint = __webpack_require__(415);

var decodeXMLStrict  = getStrictDecoder(xmlMap),
    decodeHTMLStrict = getStrictDecoder(entityMap);

function getStrictDecoder(map){
	var keys = Object.keys(map).join("|"),
	    replace = getReplacer(map);

	keys += "|#[xX][\\da-fA-F]+|#\\d+";

	var re = new RegExp("&(?:" + keys + ");", "g");

	return function(str){
		return String(str).replace(re, replace);
	};
}

var decodeHTML = (function(){
	var legacy = Object.keys(legacyMap)
		.sort(sorter);

	var keys = Object.keys(entityMap)
		.sort(sorter);

	for(var i = 0, j = 0; i < keys.length; i++){
		if(legacy[j] === keys[i]){
			keys[i] += ";?";
			j++;
		} else {
			keys[i] += ";";
		}
	}

	var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
	    replace = getReplacer(entityMap);

	function replacer(str){
		if(str.substr(-1) !== ";") str += ";";
		return replace(str);
	}

	//TODO consider creating a merged map
	return function(str){
		return String(str).replace(re, replacer);
	};
}());

function sorter(a, b){
	return a < b ? 1 : -1;
}

function getReplacer(map){
	return function replace(str){
		if(str.charAt(1) === "#"){
			if(str.charAt(2) === "X" || str.charAt(2) === "x"){
				return decodeCodePoint(parseInt(str.substr(3), 16));
			}
			return decodeCodePoint(parseInt(str.substr(2), 10));
		}
		return map[str.slice(1, -1)];
	};
}

module.exports = {
	XML: decodeXMLStrict,
	HTML: decodeHTML,
	HTMLStrict: decodeHTMLStrict
};

/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(417);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

var inverseXML = getInverseObj(__webpack_require__(349)),
    xmlReplacer = getInverseReplacer(inverseXML);

exports.XML = getInverse(inverseXML, xmlReplacer);

var inverseHTML = getInverseObj(__webpack_require__(348)),
    htmlReplacer = getInverseReplacer(inverseHTML);

exports.HTML = getInverse(inverseHTML, htmlReplacer);

function getInverseObj(obj){
	return Object.keys(obj).sort().reduce(function(inverse, name){
		inverse[obj[name]] = "&" + name + ";";
		return inverse;
	}, {});
}

function getInverseReplacer(inverse){
	var single = [],
	    multiple = [];

	Object.keys(inverse).forEach(function(k){
		if(k.length === 1){
			single.push("\\" + k);
		} else {
			multiple.push(k);
		}
	});

	//TODO add ranges
	multiple.unshift("[" + single.join("") + "]");

	return new RegExp(multiple.join("|"), "g");
}

var re_nonASCII = /[^\0-\x7F]/g,
    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

function singleCharReplacer(c){
	return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
}

function astralReplacer(c){
	// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	var high = c.charCodeAt(0);
	var low  = c.charCodeAt(1);
	var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
	return "&#x" + codePoint.toString(16).toUpperCase() + ";";
}

function getInverse(inverse, re){
	function func(name){
		return inverse[name];
	}

	return function(data){
		return data
				.replace(re, func)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	};
}

var re_xmlChars = getInverseReplacer(inverseXML);

function escapeXML(data){
	return data
			.replace(re_xmlChars, singleCharReplacer)
			.replace(re_astralSymbols, astralReplacer)
			.replace(re_nonASCII, singleCharReplacer);
}

exports.escape = escapeXML;


/***/ }),

/***/ 417:
/***/ (function(module, exports) {

module.exports = {
	"0": 65533,
	"128": 8364,
	"130": 8218,
	"131": 402,
	"132": 8222,
	"133": 8230,
	"134": 8224,
	"135": 8225,
	"136": 710,
	"137": 8240,
	"138": 352,
	"139": 8249,
	"140": 338,
	"142": 381,
	"145": 8216,
	"146": 8217,
	"147": 8220,
	"148": 8221,
	"149": 8226,
	"150": 8211,
	"151": 8212,
	"152": 732,
	"153": 8482,
	"154": 353,
	"155": 8250,
	"156": 339,
	"158": 382,
	"159": 376
};

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"AElig": "Æ",
	"aelig": "æ",
	"Agrave": "À",
	"agrave": "à",
	"amp": "&",
	"AMP": "&",
	"Aring": "Å",
	"aring": "å",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"brvbar": "¦",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"cedil": "¸",
	"cent": "¢",
	"copy": "©",
	"COPY": "©",
	"curren": "¤",
	"deg": "°",
	"divide": "÷",
	"Eacute": "É",
	"eacute": "é",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"Egrave": "È",
	"egrave": "è",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"frac12": "½",
	"frac14": "¼",
	"frac34": "¾",
	"gt": ">",
	"GT": ">",
	"Iacute": "Í",
	"iacute": "í",
	"Icirc": "Î",
	"icirc": "î",
	"iexcl": "¡",
	"Igrave": "Ì",
	"igrave": "ì",
	"iquest": "¿",
	"Iuml": "Ï",
	"iuml": "ï",
	"laquo": "«",
	"lt": "<",
	"LT": "<",
	"macr": "¯",
	"micro": "µ",
	"middot": "·",
	"nbsp": " ",
	"not": "¬",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"Oacute": "Ó",
	"oacute": "ó",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"Ograve": "Ò",
	"ograve": "ò",
	"ordf": "ª",
	"ordm": "º",
	"Oslash": "Ø",
	"oslash": "ø",
	"Otilde": "Õ",
	"otilde": "õ",
	"Ouml": "Ö",
	"ouml": "ö",
	"para": "¶",
	"plusmn": "±",
	"pound": "£",
	"quot": "\"",
	"QUOT": "\"",
	"raquo": "»",
	"reg": "®",
	"REG": "®",
	"sect": "§",
	"shy": "­",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"szlig": "ß",
	"THORN": "Þ",
	"thorn": "þ",
	"times": "×",
	"Uacute": "Ú",
	"uacute": "ú",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uml": "¨",
	"Uuml": "Ü",
	"uuml": "ü",
	"Yacute": "Ý",
	"yacute": "ý",
	"yen": "¥",
	"yuml": "ÿ"
};

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(52);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

module.exports = CollectingHandler;

function CollectingHandler(cbs){
	this._cbs = cbs || {};
	this.events = [];
}

var EVENTS = __webpack_require__(271).EVENTS;
Object.keys(EVENTS).forEach(function(name){
	if(EVENTS[name] === 0){
		name = "on" + name;
		CollectingHandler.prototype[name] = function(){
			this.events.push([name]);
			if(this._cbs[name]) this._cbs[name]();
		};
	} else if(EVENTS[name] === 1){
		name = "on" + name;
		CollectingHandler.prototype[name] = function(a){
			this.events.push([name, a]);
			if(this._cbs[name]) this._cbs[name](a);
		};
	} else if(EVENTS[name] === 2){
		name = "on" + name;
		CollectingHandler.prototype[name] = function(a, b){
			this.events.push([name, a, b]);
			if(this._cbs[name]) this._cbs[name](a, b);
		};
	} else {
		throw Error("wrong number of arguments");
	}
});

CollectingHandler.prototype.onreset = function(){
	this.events = [];
	if(this._cbs.onreset) this._cbs.onreset();
};

CollectingHandler.prototype.restart = function(){
	if(this._cbs.onreset) this._cbs.onreset();

	for(var i = 0, len = this.events.length; i < len; i++){
		if(this._cbs[this.events[i][0]]){

			var num = this.events[i].length;

			if(num === 1){
				this._cbs[this.events[i][0]]();
			} else if(num === 2){
				this._cbs[this.events[i][0]](this.events[i][1]);
			} else {
				this._cbs[this.events[i][0]](this.events[i][1], this.events[i][2]);
			}
		}
	}
};


/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

var index = __webpack_require__(271),
    DomHandler = index.DomHandler,
    DomUtils = index.DomUtils;

//TODO: make this a streamable handler
function FeedHandler(callback, options){
	this.init(callback, options);
}

__webpack_require__(59)(FeedHandler, DomHandler);

FeedHandler.prototype.init = DomHandler;

function getElements(what, where){
	return DomUtils.getElementsByTagName(what, where, true);
}
function getOneElement(what, where){
	return DomUtils.getElementsByTagName(what, where, true, 1)[0];
}
function fetch(what, where, recurse){
	return DomUtils.getText(
		DomUtils.getElementsByTagName(what, where, recurse, 1)
	).trim();
}

function addConditionally(obj, prop, what, where, recurse){
	var tmp = fetch(what, where, recurse);
	if(tmp) obj[prop] = tmp;
}

var isValidFeed = function(value){
	return value === "rss" || value === "feed" || value === "rdf:RDF";
};

FeedHandler.prototype.onend = function(){
	var feed = {},
	    feedRoot = getOneElement(isValidFeed, this.dom),
	    tmp, childs;

	if(feedRoot){
		if(feedRoot.name === "feed"){
			childs = feedRoot.children;

			feed.type = "atom";
			addConditionally(feed, "id", "id", childs);
			addConditionally(feed, "title", "title", childs);
			if((tmp = getOneElement("link", childs)) && (tmp = tmp.attribs) && (tmp = tmp.href)) feed.link = tmp;
			addConditionally(feed, "description", "subtitle", childs);
			if((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
			addConditionally(feed, "author", "email", childs, true);

			feed.items = getElements("entry", childs).map(function(item){
				var entry = {}, tmp;

				item = item.children;

				addConditionally(entry, "id", "id", item);
				addConditionally(entry, "title", "title", item);
				if((tmp = getOneElement("link", item)) && (tmp = tmp.attribs) && (tmp = tmp.href)) entry.link = tmp;
				if((tmp = fetch("summary", item) || fetch("content", item))) entry.description = tmp;
				if((tmp = fetch("updated", item))) entry.pubDate = new Date(tmp);
				return entry;
			});
		} else {
			childs = getOneElement("channel", feedRoot.children).children;

			feed.type = feedRoot.name.substr(0, 3);
			feed.id = "";
			addConditionally(feed, "title", "title", childs);
			addConditionally(feed, "link", "link", childs);
			addConditionally(feed, "description", "description", childs);
			if((tmp = fetch("lastBuildDate", childs))) feed.updated = new Date(tmp);
			addConditionally(feed, "author", "managingEditor", childs, true);

			feed.items = getElements("item", feedRoot.children).map(function(item){
				var entry = {}, tmp;

				item = item.children;

				addConditionally(entry, "id", "guid", item);
				addConditionally(entry, "title", "title", item);
				addConditionally(entry, "link", "link", item);
				addConditionally(entry, "description", "description", item);
				if((tmp = fetch("pubDate", item))) entry.pubDate = new Date(tmp);
				return entry;
			});
		}
	}
	this.dom = feed;
	DomHandler.prototype._handleCallback.call(
		this, feedRoot ? null : Error("couldn't find root of feed")
	);
};

module.exports = FeedHandler;


/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

module.exports = ProxyHandler;

function ProxyHandler(cbs){
	this._cbs = cbs || {};
}

var EVENTS = __webpack_require__(271).EVENTS;
Object.keys(EVENTS).forEach(function(name){
	if(EVENTS[name] === 0){
		name = "on" + name;
		ProxyHandler.prototype[name] = function(){
			if(this._cbs[name]) this._cbs[name]();
		};
	} else if(EVENTS[name] === 1){
		name = "on" + name;
		ProxyHandler.prototype[name] = function(a){
			if(this._cbs[name]) this._cbs[name](a);
		};
	} else if(EVENTS[name] === 2){
		name = "on" + name;
		ProxyHandler.prototype[name] = function(a, b){
			if(this._cbs[name]) this._cbs[name](a, b);
		};
	} else {
		throw Error("wrong number of arguments");
	}
});

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

module.exports = Stream;

var Parser = __webpack_require__(352);

function Stream(options){
	Parser.call(this, new Cbs(this), options);
}

__webpack_require__(59)(Stream, Parser);

Stream.prototype.readable = true;

function Cbs(scope){
	this.scope = scope;
}

var EVENTS = __webpack_require__(271).EVENTS;

Object.keys(EVENTS).forEach(function(name){
	if(EVENTS[name] === 0){
		Cbs.prototype["on" + name] = function(){
			this.scope.emit(name);
		};
	} else if(EVENTS[name] === 1){
		Cbs.prototype["on" + name] = function(a){
			this.scope.emit(name, a);
		};
	} else if(EVENTS[name] === 2){
		Cbs.prototype["on" + name] = function(a, b){
			this.scope.emit(name, a, b);
		};
	} else {
		throw Error("wrong number of arguments!");
	}
});

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(270);

var re_whitespace = /\s+/g;
var NodePrototype = __webpack_require__(353);
var ElementPrototype = __webpack_require__(425);

function DomHandler(callback, options, elementCB){
	if(typeof callback === "object"){
		elementCB = options;
		options = callback;
		callback = null;
	} else if(typeof options === "function"){
		elementCB = options;
		options = defaultOpts;
	}
	this._callback = callback;
	this._options = options || defaultOpts;
	this._elementCB = elementCB;
	this.dom = [];
	this._done = false;
	this._tagStack = [];
	this._parser = this._parser || null;
}

//default options
var defaultOpts = {
	normalizeWhitespace: false, //Replace all whitespace with single spaces
	withStartIndices: false, //Add startIndex properties to nodes
	withEndIndices: false, //Add endIndex properties to nodes
};

DomHandler.prototype.onparserinit = function(parser){
	this._parser = parser;
};

//Resets the handler back to starting state
DomHandler.prototype.onreset = function(){
	DomHandler.call(this, this._callback, this._options, this._elementCB);
};

//Signals the handler that parsing is done
DomHandler.prototype.onend = function(){
	if(this._done) return;
	this._done = true;
	this._parser = null;
	this._handleCallback(null);
};

DomHandler.prototype._handleCallback =
DomHandler.prototype.onerror = function(error){
	if(typeof this._callback === "function"){
		this._callback(error, this.dom);
	} else {
		if(error) throw error;
	}
};

DomHandler.prototype.onclosetag = function(){
	//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
	
	var elem = this._tagStack.pop();

	if(this._options.withEndIndices){
		elem.endIndex = this._parser.endIndex;
	}

	if(this._elementCB) this._elementCB(elem);
};

DomHandler.prototype._createDomElement = function(properties){
	if (!this._options.withDomLvl1) return properties;

	var element;
	if (properties.type === "tag") {
		element = Object.create(ElementPrototype);
	} else {
		element = Object.create(NodePrototype);
	}

	for (var key in properties) {
		if (properties.hasOwnProperty(key)) {
			element[key] = properties[key];
		}
	}

	return element;
};

DomHandler.prototype._addDomElement = function(element){
	var parent = this._tagStack[this._tagStack.length - 1];
	var siblings = parent ? parent.children : this.dom;
	var previousSibling = siblings[siblings.length - 1];

	element.next = null;

	if(this._options.withStartIndices){
		element.startIndex = this._parser.startIndex;
	}
	if(this._options.withEndIndices){
		element.endIndex = this._parser.endIndex;
	}

	if(previousSibling){
		element.prev = previousSibling;
		previousSibling.next = element;
	} else {
		element.prev = null;
	}

	siblings.push(element);
	element.parent = parent || null;
};

DomHandler.prototype.onopentag = function(name, attribs){
	var properties = {
		type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
		name: name,
		attribs: attribs,
		children: []
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);

	this._tagStack.push(element);
};

DomHandler.prototype.ontext = function(data){
	//the ignoreWhitespace is officially dropped, but for now,
	//it's an alias for normalizeWhitespace
	var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;

	var lastTag;

	if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
		if(normalize){
			lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
		} else {
			lastTag.data += data;
		}
	} else {
		if(
			this._tagStack.length &&
			(lastTag = this._tagStack[this._tagStack.length - 1]) &&
			(lastTag = lastTag.children[lastTag.children.length - 1]) &&
			lastTag.type === ElementType.Text
		){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(normalize){
				data = data.replace(re_whitespace, " ");
			}

			var element = this._createDomElement({
				data: data,
				type: ElementType.Text
			});

			this._addDomElement(element);
		}
	}
};

DomHandler.prototype.oncomment = function(data){
	var lastTag = this._tagStack[this._tagStack.length - 1];

	if(lastTag && lastTag.type === ElementType.Comment){
		lastTag.data += data;
		return;
	}

	var properties = {
		data: data,
		type: ElementType.Comment
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncdatastart = function(){
	var properties = {
		children: [{
			data: "",
			type: ElementType.Text
		}],
		type: ElementType.CDATA
	};

	var element = this._createDomElement(properties);

	this._addDomElement(element);
	this._tagStack.push(element);
};

DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
	this._tagStack.pop();
};

DomHandler.prototype.onprocessinginstruction = function(name, data){
	var element = this._createDomElement({
		name: name,
		data: data,
		type: ElementType.Directive
	});

	this._addDomElement(element);
};

module.exports = DomHandler;


/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

// DOM-Level-1-compliant structure
var NodePrototype = __webpack_require__(353);
var ElementPrototype = module.exports = Object.create(NodePrototype);

var domLvl1 = {
	tagName: "name"
};

Object.keys(domLvl1).forEach(function(key) {
	var shorthand = domLvl1[key];
	Object.defineProperty(ElementPrototype, key, {
		get: function() {
			return this[shorthand] || null;
		},
		set: function(val) {
			this[shorthand] = val;
			return val;
		}
	});
});


/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

var DomUtils = module.exports;

[
	__webpack_require__(431),
	__webpack_require__(432),
	__webpack_require__(429),
	__webpack_require__(430),
	__webpack_require__(428),
	__webpack_require__(427)
].forEach(function(ext){
	Object.keys(ext).forEach(function(key){
		DomUtils[key] = ext[key].bind(DomUtils);
	});
});


/***/ }),

/***/ 427:
/***/ (function(module, exports) {

// removeSubsets
// Given an array of nodes, remove any member that is contained by another.
exports.removeSubsets = function(nodes) {
	var idx = nodes.length, node, ancestor, replace;

	// Check if each node (or one of its ancestors) is already contained in the
	// array.
	while (--idx > -1) {
		node = ancestor = nodes[idx];

		// Temporarily remove the node under consideration
		nodes[idx] = null;
		replace = true;

		while (ancestor) {
			if (nodes.indexOf(ancestor) > -1) {
				replace = false;
				nodes.splice(idx, 1);
				break;
			}
			ancestor = ancestor.parent;
		}

		// If the node has been found to be unique, re-insert it.
		if (replace) {
			nodes[idx] = node;
		}
	}

	return nodes;
};

// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
var POSITION = {
	DISCONNECTED: 1,
	PRECEDING: 2,
	FOLLOWING: 4,
	CONTAINS: 8,
	CONTAINED_BY: 16
};

// Compare the position of one node against another node in any other document.
// The return value is a bitmask with the following values:
//
// document order:
// > There is an ordering, document order, defined on all the nodes in the
// > document corresponding to the order in which the first character of the
// > XML representation of each node occurs in the XML representation of the
// > document after expansion of general entities. Thus, the document element
// > node will be the first node. Element nodes occur before their children.
// > Thus, document order orders element nodes in order of the occurrence of
// > their start-tag in the XML (after expansion of entities). The attribute
// > nodes of an element occur after the element and before its children. The
// > relative order of attribute nodes is implementation-dependent./
// Source:
// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
//
// @argument {Node} nodaA The first node to use in the comparison
// @argument {Node} nodeB The second node to use in the comparison
//
// @return {Number} A bitmask describing the input nodes' relative position.
//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
//         a description of these values.
var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
	var aParents = [];
	var bParents = [];
	var current, sharedParent, siblings, aSibling, bSibling, idx;

	if (nodeA === nodeB) {
		return 0;
	}

	current = nodeA;
	while (current) {
		aParents.unshift(current);
		current = current.parent;
	}
	current = nodeB;
	while (current) {
		bParents.unshift(current);
		current = current.parent;
	}

	idx = 0;
	while (aParents[idx] === bParents[idx]) {
		idx++;
	}

	if (idx === 0) {
		return POSITION.DISCONNECTED;
	}

	sharedParent = aParents[idx - 1];
	siblings = sharedParent.children;
	aSibling = aParents[idx];
	bSibling = bParents[idx];

	if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
		if (sharedParent === nodeB) {
			return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
		}
		return POSITION.FOLLOWING;
	} else {
		if (sharedParent === nodeA) {
			return POSITION.PRECEDING | POSITION.CONTAINS;
		}
		return POSITION.PRECEDING;
	}
};

// Sort an array of nodes based on their relative position in the document and
// remove any duplicate nodes. If the array contains nodes that do not belong
// to the same document, sort order is unspecified.
//
// @argument {Array} nodes Array of DOM nodes
//
// @returns {Array} collection of unique nodes, sorted in document order
exports.uniqueSort = function(nodes) {
	var idx = nodes.length, node, position;

	nodes = nodes.slice();

	while (--idx > -1) {
		node = nodes[idx];
		position = nodes.indexOf(node);
		if (position > -1 && position < idx) {
			nodes.splice(idx, 1);
		}
	}
	nodes.sort(function(a, b) {
		var relative = comparePos(a, b);
		if (relative & POSITION.PRECEDING) {
			return -1;
		} else if (relative & POSITION.FOLLOWING) {
			return 1;
		}
		return 0;
	});

	return nodes;
};


/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(270);
var isTag = exports.isTag = ElementType.isTag;

exports.testElement = function(options, element){
	for(var key in options){
		if(!options.hasOwnProperty(key));
		else if(key === "tag_name"){
			if(!isTag(element) || !options.tag_name(element.name)){
				return false;
			}
		} else if(key === "tag_type"){
			if(!options.tag_type(element.type)) return false;
		} else if(key === "tag_contains"){
			if(isTag(element) || !options.tag_contains(element.data)){
				return false;
			}
		} else if(!element.attribs || !options[key](element.attribs[key])){
			return false;
		}
	}
	return true;
};

var Checks = {
	tag_name: function(name){
		if(typeof name === "function"){
			return function(elem){ return isTag(elem) && name(elem.name); };
		} else if(name === "*"){
			return isTag;
		} else {
			return function(elem){ return isTag(elem) && elem.name === name; };
		}
	},
	tag_type: function(type){
		if(typeof type === "function"){
			return function(elem){ return type(elem.type); };
		} else {
			return function(elem){ return elem.type === type; };
		}
	},
	tag_contains: function(data){
		if(typeof data === "function"){
			return function(elem){ return !isTag(elem) && data(elem.data); };
		} else {
			return function(elem){ return !isTag(elem) && elem.data === data; };
		}
	}
};

function getAttribCheck(attrib, value){
	if(typeof value === "function"){
		return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
	} else {
		return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
	}
}

function combineFuncs(a, b){
	return function(elem){
		return a(elem) || b(elem);
	};
}

exports.getElements = function(options, element, recurse, limit){
	var funcs = Object.keys(options).map(function(key){
		var value = options[key];
		return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
	});

	return funcs.length === 0 ? [] : this.filter(
		funcs.reduce(combineFuncs),
		element, recurse, limit
	);
};

exports.getElementById = function(id, element, recurse){
	if(!Array.isArray(element)) element = [element];
	return this.findOne(getAttribCheck("id", id), element, recurse !== false);
};

exports.getElementsByTagName = function(name, element, recurse, limit){
	return this.filter(Checks.tag_name(name), element, recurse, limit);
};

exports.getElementsByTagType = function(type, element, recurse, limit){
	return this.filter(Checks.tag_type(type), element, recurse, limit);
};


/***/ }),

/***/ 429:
/***/ (function(module, exports) {

exports.removeElement = function(elem){
	if(elem.prev) elem.prev.next = elem.next;
	if(elem.next) elem.next.prev = elem.prev;

	if(elem.parent){
		var childs = elem.parent.children;
		childs.splice(childs.lastIndexOf(elem), 1);
	}
};

exports.replaceElement = function(elem, replacement){
	var prev = replacement.prev = elem.prev;
	if(prev){
		prev.next = replacement;
	}

	var next = replacement.next = elem.next;
	if(next){
		next.prev = replacement;
	}

	var parent = replacement.parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs[childs.lastIndexOf(elem)] = replacement;
	}
};

exports.appendChild = function(elem, child){
	child.parent = elem;

	if(elem.children.push(child) !== 1){
		var sibling = elem.children[elem.children.length - 2];
		sibling.next = child;
		child.prev = sibling;
		child.next = null;
	}
};

exports.append = function(elem, next){
	var parent = elem.parent,
		currNext = elem.next;

	next.next = currNext;
	next.prev = elem;
	elem.next = next;
	next.parent = parent;

	if(currNext){
		currNext.prev = next;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(currNext), 0, next);
		}
	} else if(parent){
		parent.children.push(next);
	}
};

exports.prepend = function(elem, prev){
	var parent = elem.parent;
	if(parent){
		var childs = parent.children;
		childs.splice(childs.lastIndexOf(elem), 0, prev);
	}

	if(elem.prev){
		elem.prev.next = prev;
	}
	
	prev.parent = parent;
	prev.prev = elem.prev;
	prev.next = elem;
	elem.prev = prev;
};




/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

var isTag = __webpack_require__(270).isTag;

module.exports = {
	filter: filter,
	find: find,
	findOneChild: findOneChild,
	findOne: findOne,
	existsOne: existsOne,
	findAll: findAll
};

function filter(test, element, recurse, limit){
	if(!Array.isArray(element)) element = [element];

	if(typeof limit !== "number" || !isFinite(limit)){
		limit = Infinity;
	}
	return find(test, element, recurse !== false, limit);
}

function find(test, elems, recurse, limit){
	var result = [], childs;

	for(var i = 0, j = elems.length; i < j; i++){
		if(test(elems[i])){
			result.push(elems[i]);
			if(--limit <= 0) break;
		}

		childs = elems[i].children;
		if(recurse && childs && childs.length > 0){
			childs = find(test, childs, recurse, limit);
			result = result.concat(childs);
			limit -= childs.length;
			if(limit <= 0) break;
		}
	}

	return result;
}

function findOneChild(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(test(elems[i])) return elems[i];
	}

	return null;
}

function findOne(test, elems){
	var elem = null;

	for(var i = 0, l = elems.length; i < l && !elem; i++){
		if(!isTag(elems[i])){
			continue;
		} else if(test(elems[i])){
			elem = elems[i];
		} else if(elems[i].children.length > 0){
			elem = findOne(test, elems[i].children);
		}
	}

	return elem;
}

function existsOne(test, elems){
	for(var i = 0, l = elems.length; i < l; i++){
		if(
			isTag(elems[i]) && (
				test(elems[i]) || (
					elems[i].children.length > 0 &&
					existsOne(test, elems[i].children)
				)
			)
		){
			return true;
		}
	}

	return false;
}

function findAll(test, rootElems){
	var result = [];
	var stack = [rootElems];
	while(stack.length){
		var elems = stack.pop();
		for(var i = 0, j = elems.length; i < j; i++){
			if(!isTag(elems[i])) continue;
			if(test(elems[i])) result.push(elems[i]);
		}
		while(j-- > 0){
			if(elems[j].children && elems[j].children.length > 0){
				stack.push(elems[j].children);
			}
		}
	}
	return result;
}


/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

var ElementType = __webpack_require__(270),
    getOuterHTML = __webpack_require__(411),
    isTag = ElementType.isTag;

module.exports = {
	getInnerHTML: getInnerHTML,
	getOuterHTML: getOuterHTML,
	getText: getText
};

function getInnerHTML(elem, opts){
	return elem.children ? elem.children.map(function(elem){
		return getOuterHTML(elem, opts);
	}).join("") : "";
}

function getText(elem){
	if(Array.isArray(elem)) return elem.map(getText).join("");
	if(isTag(elem)) return elem.name === "br" ? "\n" : getText(elem.children);
	if(elem.type === ElementType.CDATA) return getText(elem.children);
	if(elem.type === ElementType.Text) return elem.data;
	return "";
}


/***/ }),

/***/ 4318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base = __webpack_require__(2448);
var createEntryPointContext = __webpack_require__(94);
var SV = __webpack_require__(18);

var context = createEntryPointContext([__webpack_require__(666), __webpack_require__(1105), __webpack_require__(571)]);

__webpack_require__(2398);

base.init({
    context: context,
    data: SV.get('data')
});

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

var getChildren = exports.getChildren = function(elem){
	return elem.children;
};

var getParent = exports.getParent = function(elem){
	return elem.parent;
};

exports.getSiblings = function(elem){
	var parent = getParent(elem);
	return parent ? getChildren(parent) : [elem];
};

exports.getAttributeValue = function(elem, name){
	return elem.attribs && elem.attribs[name];
};

exports.hasAttrib = function(elem, name){
	return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
};

exports.getName = function(elem){
	return elem.name;
};


/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

var decodeMap = __webpack_require__(434);

module.exports = decodeCodePoint;

// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
function decodeCodePoint(codePoint){

	if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
		return "\uFFFD";
	}

	if(codePoint in decodeMap){
		codePoint = decodeMap[codePoint];
	}

	var output = "";

	if(codePoint > 0xFFFF){
		codePoint -= 0x10000;
		output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
		codePoint = 0xDC00 | codePoint & 0x3FF;
	}

	output += String.fromCharCode(codePoint);
	return output;
}


/***/ }),

/***/ 434:
/***/ (function(module, exports) {

module.exports = {
	"0": 65533,
	"128": 8364,
	"130": 8218,
	"131": 402,
	"132": 8222,
	"133": 8230,
	"134": 8224,
	"135": 8225,
	"136": 710,
	"137": 8240,
	"138": 352,
	"139": 8249,
	"140": 338,
	"142": 381,
	"145": 8216,
	"146": 8217,
	"147": 8220,
	"148": 8221,
	"149": 8226,
	"150": 8211,
	"151": 8212,
	"152": 732,
	"153": 8482,
	"154": 353,
	"155": 8250,
	"156": 339,
	"158": 382,
	"159": 376
};

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Abreve": "Ă",
	"abreve": "ă",
	"ac": "∾",
	"acd": "∿",
	"acE": "∾̳",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"Acy": "А",
	"acy": "а",
	"AElig": "Æ",
	"aelig": "æ",
	"af": "⁡",
	"Afr": "𝔄",
	"afr": "𝔞",
	"Agrave": "À",
	"agrave": "à",
	"alefsym": "ℵ",
	"aleph": "ℵ",
	"Alpha": "Α",
	"alpha": "α",
	"Amacr": "Ā",
	"amacr": "ā",
	"amalg": "⨿",
	"amp": "&",
	"AMP": "&",
	"andand": "⩕",
	"And": "⩓",
	"and": "∧",
	"andd": "⩜",
	"andslope": "⩘",
	"andv": "⩚",
	"ang": "∠",
	"ange": "⦤",
	"angle": "∠",
	"angmsdaa": "⦨",
	"angmsdab": "⦩",
	"angmsdac": "⦪",
	"angmsdad": "⦫",
	"angmsdae": "⦬",
	"angmsdaf": "⦭",
	"angmsdag": "⦮",
	"angmsdah": "⦯",
	"angmsd": "∡",
	"angrt": "∟",
	"angrtvb": "⊾",
	"angrtvbd": "⦝",
	"angsph": "∢",
	"angst": "Å",
	"angzarr": "⍼",
	"Aogon": "Ą",
	"aogon": "ą",
	"Aopf": "𝔸",
	"aopf": "𝕒",
	"apacir": "⩯",
	"ap": "≈",
	"apE": "⩰",
	"ape": "≊",
	"apid": "≋",
	"apos": "'",
	"ApplyFunction": "⁡",
	"approx": "≈",
	"approxeq": "≊",
	"Aring": "Å",
	"aring": "å",
	"Ascr": "𝒜",
	"ascr": "𝒶",
	"Assign": "≔",
	"ast": "*",
	"asymp": "≈",
	"asympeq": "≍",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"awconint": "∳",
	"awint": "⨑",
	"backcong": "≌",
	"backepsilon": "϶",
	"backprime": "‵",
	"backsim": "∽",
	"backsimeq": "⋍",
	"Backslash": "∖",
	"Barv": "⫧",
	"barvee": "⊽",
	"barwed": "⌅",
	"Barwed": "⌆",
	"barwedge": "⌅",
	"bbrk": "⎵",
	"bbrktbrk": "⎶",
	"bcong": "≌",
	"Bcy": "Б",
	"bcy": "б",
	"bdquo": "„",
	"becaus": "∵",
	"because": "∵",
	"Because": "∵",
	"bemptyv": "⦰",
	"bepsi": "϶",
	"bernou": "ℬ",
	"Bernoullis": "ℬ",
	"Beta": "Β",
	"beta": "β",
	"beth": "ℶ",
	"between": "≬",
	"Bfr": "𝔅",
	"bfr": "𝔟",
	"bigcap": "⋂",
	"bigcirc": "◯",
	"bigcup": "⋃",
	"bigodot": "⨀",
	"bigoplus": "⨁",
	"bigotimes": "⨂",
	"bigsqcup": "⨆",
	"bigstar": "★",
	"bigtriangledown": "▽",
	"bigtriangleup": "△",
	"biguplus": "⨄",
	"bigvee": "⋁",
	"bigwedge": "⋀",
	"bkarow": "⤍",
	"blacklozenge": "⧫",
	"blacksquare": "▪",
	"blacktriangle": "▴",
	"blacktriangledown": "▾",
	"blacktriangleleft": "◂",
	"blacktriangleright": "▸",
	"blank": "␣",
	"blk12": "▒",
	"blk14": "░",
	"blk34": "▓",
	"block": "█",
	"bne": "=⃥",
	"bnequiv": "≡⃥",
	"bNot": "⫭",
	"bnot": "⌐",
	"Bopf": "𝔹",
	"bopf": "𝕓",
	"bot": "⊥",
	"bottom": "⊥",
	"bowtie": "⋈",
	"boxbox": "⧉",
	"boxdl": "┐",
	"boxdL": "╕",
	"boxDl": "╖",
	"boxDL": "╗",
	"boxdr": "┌",
	"boxdR": "╒",
	"boxDr": "╓",
	"boxDR": "╔",
	"boxh": "─",
	"boxH": "═",
	"boxhd": "┬",
	"boxHd": "╤",
	"boxhD": "╥",
	"boxHD": "╦",
	"boxhu": "┴",
	"boxHu": "╧",
	"boxhU": "╨",
	"boxHU": "╩",
	"boxminus": "⊟",
	"boxplus": "⊞",
	"boxtimes": "⊠",
	"boxul": "┘",
	"boxuL": "╛",
	"boxUl": "╜",
	"boxUL": "╝",
	"boxur": "└",
	"boxuR": "╘",
	"boxUr": "╙",
	"boxUR": "╚",
	"boxv": "│",
	"boxV": "║",
	"boxvh": "┼",
	"boxvH": "╪",
	"boxVh": "╫",
	"boxVH": "╬",
	"boxvl": "┤",
	"boxvL": "╡",
	"boxVl": "╢",
	"boxVL": "╣",
	"boxvr": "├",
	"boxvR": "╞",
	"boxVr": "╟",
	"boxVR": "╠",
	"bprime": "‵",
	"breve": "˘",
	"Breve": "˘",
	"brvbar": "¦",
	"bscr": "𝒷",
	"Bscr": "ℬ",
	"bsemi": "⁏",
	"bsim": "∽",
	"bsime": "⋍",
	"bsolb": "⧅",
	"bsol": "\\",
	"bsolhsub": "⟈",
	"bull": "•",
	"bullet": "•",
	"bump": "≎",
	"bumpE": "⪮",
	"bumpe": "≏",
	"Bumpeq": "≎",
	"bumpeq": "≏",
	"Cacute": "Ć",
	"cacute": "ć",
	"capand": "⩄",
	"capbrcup": "⩉",
	"capcap": "⩋",
	"cap": "∩",
	"Cap": "⋒",
	"capcup": "⩇",
	"capdot": "⩀",
	"CapitalDifferentialD": "ⅅ",
	"caps": "∩︀",
	"caret": "⁁",
	"caron": "ˇ",
	"Cayleys": "ℭ",
	"ccaps": "⩍",
	"Ccaron": "Č",
	"ccaron": "č",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"Ccirc": "Ĉ",
	"ccirc": "ĉ",
	"Cconint": "∰",
	"ccups": "⩌",
	"ccupssm": "⩐",
	"Cdot": "Ċ",
	"cdot": "ċ",
	"cedil": "¸",
	"Cedilla": "¸",
	"cemptyv": "⦲",
	"cent": "¢",
	"centerdot": "·",
	"CenterDot": "·",
	"cfr": "𝔠",
	"Cfr": "ℭ",
	"CHcy": "Ч",
	"chcy": "ч",
	"check": "✓",
	"checkmark": "✓",
	"Chi": "Χ",
	"chi": "χ",
	"circ": "ˆ",
	"circeq": "≗",
	"circlearrowleft": "↺",
	"circlearrowright": "↻",
	"circledast": "⊛",
	"circledcirc": "⊚",
	"circleddash": "⊝",
	"CircleDot": "⊙",
	"circledR": "®",
	"circledS": "Ⓢ",
	"CircleMinus": "⊖",
	"CirclePlus": "⊕",
	"CircleTimes": "⊗",
	"cir": "○",
	"cirE": "⧃",
	"cire": "≗",
	"cirfnint": "⨐",
	"cirmid": "⫯",
	"cirscir": "⧂",
	"ClockwiseContourIntegral": "∲",
	"CloseCurlyDoubleQuote": "”",
	"CloseCurlyQuote": "’",
	"clubs": "♣",
	"clubsuit": "♣",
	"colon": ":",
	"Colon": "∷",
	"Colone": "⩴",
	"colone": "≔",
	"coloneq": "≔",
	"comma": ",",
	"commat": "@",
	"comp": "∁",
	"compfn": "∘",
	"complement": "∁",
	"complexes": "ℂ",
	"cong": "≅",
	"congdot": "⩭",
	"Congruent": "≡",
	"conint": "∮",
	"Conint": "∯",
	"ContourIntegral": "∮",
	"copf": "𝕔",
	"Copf": "ℂ",
	"coprod": "∐",
	"Coproduct": "∐",
	"copy": "©",
	"COPY": "©",
	"copysr": "℗",
	"CounterClockwiseContourIntegral": "∳",
	"crarr": "↵",
	"cross": "✗",
	"Cross": "⨯",
	"Cscr": "𝒞",
	"cscr": "𝒸",
	"csub": "⫏",
	"csube": "⫑",
	"csup": "⫐",
	"csupe": "⫒",
	"ctdot": "⋯",
	"cudarrl": "⤸",
	"cudarrr": "⤵",
	"cuepr": "⋞",
	"cuesc": "⋟",
	"cularr": "↶",
	"cularrp": "⤽",
	"cupbrcap": "⩈",
	"cupcap": "⩆",
	"CupCap": "≍",
	"cup": "∪",
	"Cup": "⋓",
	"cupcup": "⩊",
	"cupdot": "⊍",
	"cupor": "⩅",
	"cups": "∪︀",
	"curarr": "↷",
	"curarrm": "⤼",
	"curlyeqprec": "⋞",
	"curlyeqsucc": "⋟",
	"curlyvee": "⋎",
	"curlywedge": "⋏",
	"curren": "¤",
	"curvearrowleft": "↶",
	"curvearrowright": "↷",
	"cuvee": "⋎",
	"cuwed": "⋏",
	"cwconint": "∲",
	"cwint": "∱",
	"cylcty": "⌭",
	"dagger": "†",
	"Dagger": "‡",
	"daleth": "ℸ",
	"darr": "↓",
	"Darr": "↡",
	"dArr": "⇓",
	"dash": "‐",
	"Dashv": "⫤",
	"dashv": "⊣",
	"dbkarow": "⤏",
	"dblac": "˝",
	"Dcaron": "Ď",
	"dcaron": "ď",
	"Dcy": "Д",
	"dcy": "д",
	"ddagger": "‡",
	"ddarr": "⇊",
	"DD": "ⅅ",
	"dd": "ⅆ",
	"DDotrahd": "⤑",
	"ddotseq": "⩷",
	"deg": "°",
	"Del": "∇",
	"Delta": "Δ",
	"delta": "δ",
	"demptyv": "⦱",
	"dfisht": "⥿",
	"Dfr": "𝔇",
	"dfr": "𝔡",
	"dHar": "⥥",
	"dharl": "⇃",
	"dharr": "⇂",
	"DiacriticalAcute": "´",
	"DiacriticalDot": "˙",
	"DiacriticalDoubleAcute": "˝",
	"DiacriticalGrave": "`",
	"DiacriticalTilde": "˜",
	"diam": "⋄",
	"diamond": "⋄",
	"Diamond": "⋄",
	"diamondsuit": "♦",
	"diams": "♦",
	"die": "¨",
	"DifferentialD": "ⅆ",
	"digamma": "ϝ",
	"disin": "⋲",
	"div": "÷",
	"divide": "÷",
	"divideontimes": "⋇",
	"divonx": "⋇",
	"DJcy": "Ђ",
	"djcy": "ђ",
	"dlcorn": "⌞",
	"dlcrop": "⌍",
	"dollar": "$",
	"Dopf": "𝔻",
	"dopf": "𝕕",
	"Dot": "¨",
	"dot": "˙",
	"DotDot": "⃜",
	"doteq": "≐",
	"doteqdot": "≑",
	"DotEqual": "≐",
	"dotminus": "∸",
	"dotplus": "∔",
	"dotsquare": "⊡",
	"doublebarwedge": "⌆",
	"DoubleContourIntegral": "∯",
	"DoubleDot": "¨",
	"DoubleDownArrow": "⇓",
	"DoubleLeftArrow": "⇐",
	"DoubleLeftRightArrow": "⇔",
	"DoubleLeftTee": "⫤",
	"DoubleLongLeftArrow": "⟸",
	"DoubleLongLeftRightArrow": "⟺",
	"DoubleLongRightArrow": "⟹",
	"DoubleRightArrow": "⇒",
	"DoubleRightTee": "⊨",
	"DoubleUpArrow": "⇑",
	"DoubleUpDownArrow": "⇕",
	"DoubleVerticalBar": "∥",
	"DownArrowBar": "⤓",
	"downarrow": "↓",
	"DownArrow": "↓",
	"Downarrow": "⇓",
	"DownArrowUpArrow": "⇵",
	"DownBreve": "̑",
	"downdownarrows": "⇊",
	"downharpoonleft": "⇃",
	"downharpoonright": "⇂",
	"DownLeftRightVector": "⥐",
	"DownLeftTeeVector": "⥞",
	"DownLeftVectorBar": "⥖",
	"DownLeftVector": "↽",
	"DownRightTeeVector": "⥟",
	"DownRightVectorBar": "⥗",
	"DownRightVector": "⇁",
	"DownTeeArrow": "↧",
	"DownTee": "⊤",
	"drbkarow": "⤐",
	"drcorn": "⌟",
	"drcrop": "⌌",
	"Dscr": "𝒟",
	"dscr": "𝒹",
	"DScy": "Ѕ",
	"dscy": "ѕ",
	"dsol": "⧶",
	"Dstrok": "Đ",
	"dstrok": "đ",
	"dtdot": "⋱",
	"dtri": "▿",
	"dtrif": "▾",
	"duarr": "⇵",
	"duhar": "⥯",
	"dwangle": "⦦",
	"DZcy": "Џ",
	"dzcy": "џ",
	"dzigrarr": "⟿",
	"Eacute": "É",
	"eacute": "é",
	"easter": "⩮",
	"Ecaron": "Ě",
	"ecaron": "ě",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"ecir": "≖",
	"ecolon": "≕",
	"Ecy": "Э",
	"ecy": "э",
	"eDDot": "⩷",
	"Edot": "Ė",
	"edot": "ė",
	"eDot": "≑",
	"ee": "ⅇ",
	"efDot": "≒",
	"Efr": "𝔈",
	"efr": "𝔢",
	"eg": "⪚",
	"Egrave": "È",
	"egrave": "è",
	"egs": "⪖",
	"egsdot": "⪘",
	"el": "⪙",
	"Element": "∈",
	"elinters": "⏧",
	"ell": "ℓ",
	"els": "⪕",
	"elsdot": "⪗",
	"Emacr": "Ē",
	"emacr": "ē",
	"empty": "∅",
	"emptyset": "∅",
	"EmptySmallSquare": "◻",
	"emptyv": "∅",
	"EmptyVerySmallSquare": "▫",
	"emsp13": " ",
	"emsp14": " ",
	"emsp": " ",
	"ENG": "Ŋ",
	"eng": "ŋ",
	"ensp": " ",
	"Eogon": "Ę",
	"eogon": "ę",
	"Eopf": "𝔼",
	"eopf": "𝕖",
	"epar": "⋕",
	"eparsl": "⧣",
	"eplus": "⩱",
	"epsi": "ε",
	"Epsilon": "Ε",
	"epsilon": "ε",
	"epsiv": "ϵ",
	"eqcirc": "≖",
	"eqcolon": "≕",
	"eqsim": "≂",
	"eqslantgtr": "⪖",
	"eqslantless": "⪕",
	"Equal": "⩵",
	"equals": "=",
	"EqualTilde": "≂",
	"equest": "≟",
	"Equilibrium": "⇌",
	"equiv": "≡",
	"equivDD": "⩸",
	"eqvparsl": "⧥",
	"erarr": "⥱",
	"erDot": "≓",
	"escr": "ℯ",
	"Escr": "ℰ",
	"esdot": "≐",
	"Esim": "⩳",
	"esim": "≂",
	"Eta": "Η",
	"eta": "η",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"euro": "€",
	"excl": "!",
	"exist": "∃",
	"Exists": "∃",
	"expectation": "ℰ",
	"exponentiale": "ⅇ",
	"ExponentialE": "ⅇ",
	"fallingdotseq": "≒",
	"Fcy": "Ф",
	"fcy": "ф",
	"female": "♀",
	"ffilig": "ﬃ",
	"fflig": "ﬀ",
	"ffllig": "ﬄ",
	"Ffr": "𝔉",
	"ffr": "𝔣",
	"filig": "ﬁ",
	"FilledSmallSquare": "◼",
	"FilledVerySmallSquare": "▪",
	"fjlig": "fj",
	"flat": "♭",
	"fllig": "ﬂ",
	"fltns": "▱",
	"fnof": "ƒ",
	"Fopf": "𝔽",
	"fopf": "𝕗",
	"forall": "∀",
	"ForAll": "∀",
	"fork": "⋔",
	"forkv": "⫙",
	"Fouriertrf": "ℱ",
	"fpartint": "⨍",
	"frac12": "½",
	"frac13": "⅓",
	"frac14": "¼",
	"frac15": "⅕",
	"frac16": "⅙",
	"frac18": "⅛",
	"frac23": "⅔",
	"frac25": "⅖",
	"frac34": "¾",
	"frac35": "⅗",
	"frac38": "⅜",
	"frac45": "⅘",
	"frac56": "⅚",
	"frac58": "⅝",
	"frac78": "⅞",
	"frasl": "⁄",
	"frown": "⌢",
	"fscr": "𝒻",
	"Fscr": "ℱ",
	"gacute": "ǵ",
	"Gamma": "Γ",
	"gamma": "γ",
	"Gammad": "Ϝ",
	"gammad": "ϝ",
	"gap": "⪆",
	"Gbreve": "Ğ",
	"gbreve": "ğ",
	"Gcedil": "Ģ",
	"Gcirc": "Ĝ",
	"gcirc": "ĝ",
	"Gcy": "Г",
	"gcy": "г",
	"Gdot": "Ġ",
	"gdot": "ġ",
	"ge": "≥",
	"gE": "≧",
	"gEl": "⪌",
	"gel": "⋛",
	"geq": "≥",
	"geqq": "≧",
	"geqslant": "⩾",
	"gescc": "⪩",
	"ges": "⩾",
	"gesdot": "⪀",
	"gesdoto": "⪂",
	"gesdotol": "⪄",
	"gesl": "⋛︀",
	"gesles": "⪔",
	"Gfr": "𝔊",
	"gfr": "𝔤",
	"gg": "≫",
	"Gg": "⋙",
	"ggg": "⋙",
	"gimel": "ℷ",
	"GJcy": "Ѓ",
	"gjcy": "ѓ",
	"gla": "⪥",
	"gl": "≷",
	"glE": "⪒",
	"glj": "⪤",
	"gnap": "⪊",
	"gnapprox": "⪊",
	"gne": "⪈",
	"gnE": "≩",
	"gneq": "⪈",
	"gneqq": "≩",
	"gnsim": "⋧",
	"Gopf": "𝔾",
	"gopf": "𝕘",
	"grave": "`",
	"GreaterEqual": "≥",
	"GreaterEqualLess": "⋛",
	"GreaterFullEqual": "≧",
	"GreaterGreater": "⪢",
	"GreaterLess": "≷",
	"GreaterSlantEqual": "⩾",
	"GreaterTilde": "≳",
	"Gscr": "𝒢",
	"gscr": "ℊ",
	"gsim": "≳",
	"gsime": "⪎",
	"gsiml": "⪐",
	"gtcc": "⪧",
	"gtcir": "⩺",
	"gt": ">",
	"GT": ">",
	"Gt": "≫",
	"gtdot": "⋗",
	"gtlPar": "⦕",
	"gtquest": "⩼",
	"gtrapprox": "⪆",
	"gtrarr": "⥸",
	"gtrdot": "⋗",
	"gtreqless": "⋛",
	"gtreqqless": "⪌",
	"gtrless": "≷",
	"gtrsim": "≳",
	"gvertneqq": "≩︀",
	"gvnE": "≩︀",
	"Hacek": "ˇ",
	"hairsp": " ",
	"half": "½",
	"hamilt": "ℋ",
	"HARDcy": "Ъ",
	"hardcy": "ъ",
	"harrcir": "⥈",
	"harr": "↔",
	"hArr": "⇔",
	"harrw": "↭",
	"Hat": "^",
	"hbar": "ℏ",
	"Hcirc": "Ĥ",
	"hcirc": "ĥ",
	"hearts": "♥",
	"heartsuit": "♥",
	"hellip": "…",
	"hercon": "⊹",
	"hfr": "𝔥",
	"Hfr": "ℌ",
	"HilbertSpace": "ℋ",
	"hksearow": "⤥",
	"hkswarow": "⤦",
	"hoarr": "⇿",
	"homtht": "∻",
	"hookleftarrow": "↩",
	"hookrightarrow": "↪",
	"hopf": "𝕙",
	"Hopf": "ℍ",
	"horbar": "―",
	"HorizontalLine": "─",
	"hscr": "𝒽",
	"Hscr": "ℋ",
	"hslash": "ℏ",
	"Hstrok": "Ħ",
	"hstrok": "ħ",
	"HumpDownHump": "≎",
	"HumpEqual": "≏",
	"hybull": "⁃",
	"hyphen": "‐",
	"Iacute": "Í",
	"iacute": "í",
	"ic": "⁣",
	"Icirc": "Î",
	"icirc": "î",
	"Icy": "И",
	"icy": "и",
	"Idot": "İ",
	"IEcy": "Е",
	"iecy": "е",
	"iexcl": "¡",
	"iff": "⇔",
	"ifr": "𝔦",
	"Ifr": "ℑ",
	"Igrave": "Ì",
	"igrave": "ì",
	"ii": "ⅈ",
	"iiiint": "⨌",
	"iiint": "∭",
	"iinfin": "⧜",
	"iiota": "℩",
	"IJlig": "Ĳ",
	"ijlig": "ĳ",
	"Imacr": "Ī",
	"imacr": "ī",
	"image": "ℑ",
	"ImaginaryI": "ⅈ",
	"imagline": "ℐ",
	"imagpart": "ℑ",
	"imath": "ı",
	"Im": "ℑ",
	"imof": "⊷",
	"imped": "Ƶ",
	"Implies": "⇒",
	"incare": "℅",
	"in": "∈",
	"infin": "∞",
	"infintie": "⧝",
	"inodot": "ı",
	"intcal": "⊺",
	"int": "∫",
	"Int": "∬",
	"integers": "ℤ",
	"Integral": "∫",
	"intercal": "⊺",
	"Intersection": "⋂",
	"intlarhk": "⨗",
	"intprod": "⨼",
	"InvisibleComma": "⁣",
	"InvisibleTimes": "⁢",
	"IOcy": "Ё",
	"iocy": "ё",
	"Iogon": "Į",
	"iogon": "į",
	"Iopf": "𝕀",
	"iopf": "𝕚",
	"Iota": "Ι",
	"iota": "ι",
	"iprod": "⨼",
	"iquest": "¿",
	"iscr": "𝒾",
	"Iscr": "ℐ",
	"isin": "∈",
	"isindot": "⋵",
	"isinE": "⋹",
	"isins": "⋴",
	"isinsv": "⋳",
	"isinv": "∈",
	"it": "⁢",
	"Itilde": "Ĩ",
	"itilde": "ĩ",
	"Iukcy": "І",
	"iukcy": "і",
	"Iuml": "Ï",
	"iuml": "ï",
	"Jcirc": "Ĵ",
	"jcirc": "ĵ",
	"Jcy": "Й",
	"jcy": "й",
	"Jfr": "𝔍",
	"jfr": "𝔧",
	"jmath": "ȷ",
	"Jopf": "𝕁",
	"jopf": "𝕛",
	"Jscr": "𝒥",
	"jscr": "𝒿",
	"Jsercy": "Ј",
	"jsercy": "ј",
	"Jukcy": "Є",
	"jukcy": "є",
	"Kappa": "Κ",
	"kappa": "κ",
	"kappav": "ϰ",
	"Kcedil": "Ķ",
	"kcedil": "ķ",
	"Kcy": "К",
	"kcy": "к",
	"Kfr": "𝔎",
	"kfr": "𝔨",
	"kgreen": "ĸ",
	"KHcy": "Х",
	"khcy": "х",
	"KJcy": "Ќ",
	"kjcy": "ќ",
	"Kopf": "𝕂",
	"kopf": "𝕜",
	"Kscr": "𝒦",
	"kscr": "𝓀",
	"lAarr": "⇚",
	"Lacute": "Ĺ",
	"lacute": "ĺ",
	"laemptyv": "⦴",
	"lagran": "ℒ",
	"Lambda": "Λ",
	"lambda": "λ",
	"lang": "⟨",
	"Lang": "⟪",
	"langd": "⦑",
	"langle": "⟨",
	"lap": "⪅",
	"Laplacetrf": "ℒ",
	"laquo": "«",
	"larrb": "⇤",
	"larrbfs": "⤟",
	"larr": "←",
	"Larr": "↞",
	"lArr": "⇐",
	"larrfs": "⤝",
	"larrhk": "↩",
	"larrlp": "↫",
	"larrpl": "⤹",
	"larrsim": "⥳",
	"larrtl": "↢",
	"latail": "⤙",
	"lAtail": "⤛",
	"lat": "⪫",
	"late": "⪭",
	"lates": "⪭︀",
	"lbarr": "⤌",
	"lBarr": "⤎",
	"lbbrk": "❲",
	"lbrace": "{",
	"lbrack": "[",
	"lbrke": "⦋",
	"lbrksld": "⦏",
	"lbrkslu": "⦍",
	"Lcaron": "Ľ",
	"lcaron": "ľ",
	"Lcedil": "Ļ",
	"lcedil": "ļ",
	"lceil": "⌈",
	"lcub": "{",
	"Lcy": "Л",
	"lcy": "л",
	"ldca": "⤶",
	"ldquo": "“",
	"ldquor": "„",
	"ldrdhar": "⥧",
	"ldrushar": "⥋",
	"ldsh": "↲",
	"le": "≤",
	"lE": "≦",
	"LeftAngleBracket": "⟨",
	"LeftArrowBar": "⇤",
	"leftarrow": "←",
	"LeftArrow": "←",
	"Leftarrow": "⇐",
	"LeftArrowRightArrow": "⇆",
	"leftarrowtail": "↢",
	"LeftCeiling": "⌈",
	"LeftDoubleBracket": "⟦",
	"LeftDownTeeVector": "⥡",
	"LeftDownVectorBar": "⥙",
	"LeftDownVector": "⇃",
	"LeftFloor": "⌊",
	"leftharpoondown": "↽",
	"leftharpoonup": "↼",
	"leftleftarrows": "⇇",
	"leftrightarrow": "↔",
	"LeftRightArrow": "↔",
	"Leftrightarrow": "⇔",
	"leftrightarrows": "⇆",
	"leftrightharpoons": "⇋",
	"leftrightsquigarrow": "↭",
	"LeftRightVector": "⥎",
	"LeftTeeArrow": "↤",
	"LeftTee": "⊣",
	"LeftTeeVector": "⥚",
	"leftthreetimes": "⋋",
	"LeftTriangleBar": "⧏",
	"LeftTriangle": "⊲",
	"LeftTriangleEqual": "⊴",
	"LeftUpDownVector": "⥑",
	"LeftUpTeeVector": "⥠",
	"LeftUpVectorBar": "⥘",
	"LeftUpVector": "↿",
	"LeftVectorBar": "⥒",
	"LeftVector": "↼",
	"lEg": "⪋",
	"leg": "⋚",
	"leq": "≤",
	"leqq": "≦",
	"leqslant": "⩽",
	"lescc": "⪨",
	"les": "⩽",
	"lesdot": "⩿",
	"lesdoto": "⪁",
	"lesdotor": "⪃",
	"lesg": "⋚︀",
	"lesges": "⪓",
	"lessapprox": "⪅",
	"lessdot": "⋖",
	"lesseqgtr": "⋚",
	"lesseqqgtr": "⪋",
	"LessEqualGreater": "⋚",
	"LessFullEqual": "≦",
	"LessGreater": "≶",
	"lessgtr": "≶",
	"LessLess": "⪡",
	"lesssim": "≲",
	"LessSlantEqual": "⩽",
	"LessTilde": "≲",
	"lfisht": "⥼",
	"lfloor": "⌊",
	"Lfr": "𝔏",
	"lfr": "𝔩",
	"lg": "≶",
	"lgE": "⪑",
	"lHar": "⥢",
	"lhard": "↽",
	"lharu": "↼",
	"lharul": "⥪",
	"lhblk": "▄",
	"LJcy": "Љ",
	"ljcy": "љ",
	"llarr": "⇇",
	"ll": "≪",
	"Ll": "⋘",
	"llcorner": "⌞",
	"Lleftarrow": "⇚",
	"llhard": "⥫",
	"lltri": "◺",
	"Lmidot": "Ŀ",
	"lmidot": "ŀ",
	"lmoustache": "⎰",
	"lmoust": "⎰",
	"lnap": "⪉",
	"lnapprox": "⪉",
	"lne": "⪇",
	"lnE": "≨",
	"lneq": "⪇",
	"lneqq": "≨",
	"lnsim": "⋦",
	"loang": "⟬",
	"loarr": "⇽",
	"lobrk": "⟦",
	"longleftarrow": "⟵",
	"LongLeftArrow": "⟵",
	"Longleftarrow": "⟸",
	"longleftrightarrow": "⟷",
	"LongLeftRightArrow": "⟷",
	"Longleftrightarrow": "⟺",
	"longmapsto": "⟼",
	"longrightarrow": "⟶",
	"LongRightArrow": "⟶",
	"Longrightarrow": "⟹",
	"looparrowleft": "↫",
	"looparrowright": "↬",
	"lopar": "⦅",
	"Lopf": "𝕃",
	"lopf": "𝕝",
	"loplus": "⨭",
	"lotimes": "⨴",
	"lowast": "∗",
	"lowbar": "_",
	"LowerLeftArrow": "↙",
	"LowerRightArrow": "↘",
	"loz": "◊",
	"lozenge": "◊",
	"lozf": "⧫",
	"lpar": "(",
	"lparlt": "⦓",
	"lrarr": "⇆",
	"lrcorner": "⌟",
	"lrhar": "⇋",
	"lrhard": "⥭",
	"lrm": "‎",
	"lrtri": "⊿",
	"lsaquo": "‹",
	"lscr": "𝓁",
	"Lscr": "ℒ",
	"lsh": "↰",
	"Lsh": "↰",
	"lsim": "≲",
	"lsime": "⪍",
	"lsimg": "⪏",
	"lsqb": "[",
	"lsquo": "‘",
	"lsquor": "‚",
	"Lstrok": "Ł",
	"lstrok": "ł",
	"ltcc": "⪦",
	"ltcir": "⩹",
	"lt": "<",
	"LT": "<",
	"Lt": "≪",
	"ltdot": "⋖",
	"lthree": "⋋",
	"ltimes": "⋉",
	"ltlarr": "⥶",
	"ltquest": "⩻",
	"ltri": "◃",
	"ltrie": "⊴",
	"ltrif": "◂",
	"ltrPar": "⦖",
	"lurdshar": "⥊",
	"luruhar": "⥦",
	"lvertneqq": "≨︀",
	"lvnE": "≨︀",
	"macr": "¯",
	"male": "♂",
	"malt": "✠",
	"maltese": "✠",
	"Map": "⤅",
	"map": "↦",
	"mapsto": "↦",
	"mapstodown": "↧",
	"mapstoleft": "↤",
	"mapstoup": "↥",
	"marker": "▮",
	"mcomma": "⨩",
	"Mcy": "М",
	"mcy": "м",
	"mdash": "—",
	"mDDot": "∺",
	"measuredangle": "∡",
	"MediumSpace": " ",
	"Mellintrf": "ℳ",
	"Mfr": "𝔐",
	"mfr": "𝔪",
	"mho": "℧",
	"micro": "µ",
	"midast": "*",
	"midcir": "⫰",
	"mid": "∣",
	"middot": "·",
	"minusb": "⊟",
	"minus": "−",
	"minusd": "∸",
	"minusdu": "⨪",
	"MinusPlus": "∓",
	"mlcp": "⫛",
	"mldr": "…",
	"mnplus": "∓",
	"models": "⊧",
	"Mopf": "𝕄",
	"mopf": "𝕞",
	"mp": "∓",
	"mscr": "𝓂",
	"Mscr": "ℳ",
	"mstpos": "∾",
	"Mu": "Μ",
	"mu": "μ",
	"multimap": "⊸",
	"mumap": "⊸",
	"nabla": "∇",
	"Nacute": "Ń",
	"nacute": "ń",
	"nang": "∠⃒",
	"nap": "≉",
	"napE": "⩰̸",
	"napid": "≋̸",
	"napos": "ŉ",
	"napprox": "≉",
	"natural": "♮",
	"naturals": "ℕ",
	"natur": "♮",
	"nbsp": " ",
	"nbump": "≎̸",
	"nbumpe": "≏̸",
	"ncap": "⩃",
	"Ncaron": "Ň",
	"ncaron": "ň",
	"Ncedil": "Ņ",
	"ncedil": "ņ",
	"ncong": "≇",
	"ncongdot": "⩭̸",
	"ncup": "⩂",
	"Ncy": "Н",
	"ncy": "н",
	"ndash": "–",
	"nearhk": "⤤",
	"nearr": "↗",
	"neArr": "⇗",
	"nearrow": "↗",
	"ne": "≠",
	"nedot": "≐̸",
	"NegativeMediumSpace": "​",
	"NegativeThickSpace": "​",
	"NegativeThinSpace": "​",
	"NegativeVeryThinSpace": "​",
	"nequiv": "≢",
	"nesear": "⤨",
	"nesim": "≂̸",
	"NestedGreaterGreater": "≫",
	"NestedLessLess": "≪",
	"NewLine": "\n",
	"nexist": "∄",
	"nexists": "∄",
	"Nfr": "𝔑",
	"nfr": "𝔫",
	"ngE": "≧̸",
	"nge": "≱",
	"ngeq": "≱",
	"ngeqq": "≧̸",
	"ngeqslant": "⩾̸",
	"nges": "⩾̸",
	"nGg": "⋙̸",
	"ngsim": "≵",
	"nGt": "≫⃒",
	"ngt": "≯",
	"ngtr": "≯",
	"nGtv": "≫̸",
	"nharr": "↮",
	"nhArr": "⇎",
	"nhpar": "⫲",
	"ni": "∋",
	"nis": "⋼",
	"nisd": "⋺",
	"niv": "∋",
	"NJcy": "Њ",
	"njcy": "њ",
	"nlarr": "↚",
	"nlArr": "⇍",
	"nldr": "‥",
	"nlE": "≦̸",
	"nle": "≰",
	"nleftarrow": "↚",
	"nLeftarrow": "⇍",
	"nleftrightarrow": "↮",
	"nLeftrightarrow": "⇎",
	"nleq": "≰",
	"nleqq": "≦̸",
	"nleqslant": "⩽̸",
	"nles": "⩽̸",
	"nless": "≮",
	"nLl": "⋘̸",
	"nlsim": "≴",
	"nLt": "≪⃒",
	"nlt": "≮",
	"nltri": "⋪",
	"nltrie": "⋬",
	"nLtv": "≪̸",
	"nmid": "∤",
	"NoBreak": "⁠",
	"NonBreakingSpace": " ",
	"nopf": "𝕟",
	"Nopf": "ℕ",
	"Not": "⫬",
	"not": "¬",
	"NotCongruent": "≢",
	"NotCupCap": "≭",
	"NotDoubleVerticalBar": "∦",
	"NotElement": "∉",
	"NotEqual": "≠",
	"NotEqualTilde": "≂̸",
	"NotExists": "∄",
	"NotGreater": "≯",
	"NotGreaterEqual": "≱",
	"NotGreaterFullEqual": "≧̸",
	"NotGreaterGreater": "≫̸",
	"NotGreaterLess": "≹",
	"NotGreaterSlantEqual": "⩾̸",
	"NotGreaterTilde": "≵",
	"NotHumpDownHump": "≎̸",
	"NotHumpEqual": "≏̸",
	"notin": "∉",
	"notindot": "⋵̸",
	"notinE": "⋹̸",
	"notinva": "∉",
	"notinvb": "⋷",
	"notinvc": "⋶",
	"NotLeftTriangleBar": "⧏̸",
	"NotLeftTriangle": "⋪",
	"NotLeftTriangleEqual": "⋬",
	"NotLess": "≮",
	"NotLessEqual": "≰",
	"NotLessGreater": "≸",
	"NotLessLess": "≪̸",
	"NotLessSlantEqual": "⩽̸",
	"NotLessTilde": "≴",
	"NotNestedGreaterGreater": "⪢̸",
	"NotNestedLessLess": "⪡̸",
	"notni": "∌",
	"notniva": "∌",
	"notnivb": "⋾",
	"notnivc": "⋽",
	"NotPrecedes": "⊀",
	"NotPrecedesEqual": "⪯̸",
	"NotPrecedesSlantEqual": "⋠",
	"NotReverseElement": "∌",
	"NotRightTriangleBar": "⧐̸",
	"NotRightTriangle": "⋫",
	"NotRightTriangleEqual": "⋭",
	"NotSquareSubset": "⊏̸",
	"NotSquareSubsetEqual": "⋢",
	"NotSquareSuperset": "⊐̸",
	"NotSquareSupersetEqual": "⋣",
	"NotSubset": "⊂⃒",
	"NotSubsetEqual": "⊈",
	"NotSucceeds": "⊁",
	"NotSucceedsEqual": "⪰̸",
	"NotSucceedsSlantEqual": "⋡",
	"NotSucceedsTilde": "≿̸",
	"NotSuperset": "⊃⃒",
	"NotSupersetEqual": "⊉",
	"NotTilde": "≁",
	"NotTildeEqual": "≄",
	"NotTildeFullEqual": "≇",
	"NotTildeTilde": "≉",
	"NotVerticalBar": "∤",
	"nparallel": "∦",
	"npar": "∦",
	"nparsl": "⫽⃥",
	"npart": "∂̸",
	"npolint": "⨔",
	"npr": "⊀",
	"nprcue": "⋠",
	"nprec": "⊀",
	"npreceq": "⪯̸",
	"npre": "⪯̸",
	"nrarrc": "⤳̸",
	"nrarr": "↛",
	"nrArr": "⇏",
	"nrarrw": "↝̸",
	"nrightarrow": "↛",
	"nRightarrow": "⇏",
	"nrtri": "⋫",
	"nrtrie": "⋭",
	"nsc": "⊁",
	"nsccue": "⋡",
	"nsce": "⪰̸",
	"Nscr": "𝒩",
	"nscr": "𝓃",
	"nshortmid": "∤",
	"nshortparallel": "∦",
	"nsim": "≁",
	"nsime": "≄",
	"nsimeq": "≄",
	"nsmid": "∤",
	"nspar": "∦",
	"nsqsube": "⋢",
	"nsqsupe": "⋣",
	"nsub": "⊄",
	"nsubE": "⫅̸",
	"nsube": "⊈",
	"nsubset": "⊂⃒",
	"nsubseteq": "⊈",
	"nsubseteqq": "⫅̸",
	"nsucc": "⊁",
	"nsucceq": "⪰̸",
	"nsup": "⊅",
	"nsupE": "⫆̸",
	"nsupe": "⊉",
	"nsupset": "⊃⃒",
	"nsupseteq": "⊉",
	"nsupseteqq": "⫆̸",
	"ntgl": "≹",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"ntlg": "≸",
	"ntriangleleft": "⋪",
	"ntrianglelefteq": "⋬",
	"ntriangleright": "⋫",
	"ntrianglerighteq": "⋭",
	"Nu": "Ν",
	"nu": "ν",
	"num": "#",
	"numero": "№",
	"numsp": " ",
	"nvap": "≍⃒",
	"nvdash": "⊬",
	"nvDash": "⊭",
	"nVdash": "⊮",
	"nVDash": "⊯",
	"nvge": "≥⃒",
	"nvgt": ">⃒",
	"nvHarr": "⤄",
	"nvinfin": "⧞",
	"nvlArr": "⤂",
	"nvle": "≤⃒",
	"nvlt": "<⃒",
	"nvltrie": "⊴⃒",
	"nvrArr": "⤃",
	"nvrtrie": "⊵⃒",
	"nvsim": "∼⃒",
	"nwarhk": "⤣",
	"nwarr": "↖",
	"nwArr": "⇖",
	"nwarrow": "↖",
	"nwnear": "⤧",
	"Oacute": "Ó",
	"oacute": "ó",
	"oast": "⊛",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"ocir": "⊚",
	"Ocy": "О",
	"ocy": "о",
	"odash": "⊝",
	"Odblac": "Ő",
	"odblac": "ő",
	"odiv": "⨸",
	"odot": "⊙",
	"odsold": "⦼",
	"OElig": "Œ",
	"oelig": "œ",
	"ofcir": "⦿",
	"Ofr": "𝔒",
	"ofr": "𝔬",
	"ogon": "˛",
	"Ograve": "Ò",
	"ograve": "ò",
	"ogt": "⧁",
	"ohbar": "⦵",
	"ohm": "Ω",
	"oint": "∮",
	"olarr": "↺",
	"olcir": "⦾",
	"olcross": "⦻",
	"oline": "‾",
	"olt": "⧀",
	"Omacr": "Ō",
	"omacr": "ō",
	"Omega": "Ω",
	"omega": "ω",
	"Omicron": "Ο",
	"omicron": "ο",
	"omid": "⦶",
	"ominus": "⊖",
	"Oopf": "𝕆",
	"oopf": "𝕠",
	"opar": "⦷",
	"OpenCurlyDoubleQuote": "“",
	"OpenCurlyQuote": "‘",
	"operp": "⦹",
	"oplus": "⊕",
	"orarr": "↻",
	"Or": "⩔",
	"or": "∨",
	"ord": "⩝",
	"order": "ℴ",
	"orderof": "ℴ",
	"ordf": "ª",
	"ordm": "º",
	"origof": "⊶",
	"oror": "⩖",
	"orslope": "⩗",
	"orv": "⩛",
	"oS": "Ⓢ",
	"Oscr": "𝒪",
	"oscr": "ℴ",
	"Oslash": "Ø",
	"oslash": "ø",
	"osol": "⊘",
	"Otilde": "Õ",
	"otilde": "õ",
	"otimesas": "⨶",
	"Otimes": "⨷",
	"otimes": "⊗",
	"Ouml": "Ö",
	"ouml": "ö",
	"ovbar": "⌽",
	"OverBar": "‾",
	"OverBrace": "⏞",
	"OverBracket": "⎴",
	"OverParenthesis": "⏜",
	"para": "¶",
	"parallel": "∥",
	"par": "∥",
	"parsim": "⫳",
	"parsl": "⫽",
	"part": "∂",
	"PartialD": "∂",
	"Pcy": "П",
	"pcy": "п",
	"percnt": "%",
	"period": ".",
	"permil": "‰",
	"perp": "⊥",
	"pertenk": "‱",
	"Pfr": "𝔓",
	"pfr": "𝔭",
	"Phi": "Φ",
	"phi": "φ",
	"phiv": "ϕ",
	"phmmat": "ℳ",
	"phone": "☎",
	"Pi": "Π",
	"pi": "π",
	"pitchfork": "⋔",
	"piv": "ϖ",
	"planck": "ℏ",
	"planckh": "ℎ",
	"plankv": "ℏ",
	"plusacir": "⨣",
	"plusb": "⊞",
	"pluscir": "⨢",
	"plus": "+",
	"plusdo": "∔",
	"plusdu": "⨥",
	"pluse": "⩲",
	"PlusMinus": "±",
	"plusmn": "±",
	"plussim": "⨦",
	"plustwo": "⨧",
	"pm": "±",
	"Poincareplane": "ℌ",
	"pointint": "⨕",
	"popf": "𝕡",
	"Popf": "ℙ",
	"pound": "£",
	"prap": "⪷",
	"Pr": "⪻",
	"pr": "≺",
	"prcue": "≼",
	"precapprox": "⪷",
	"prec": "≺",
	"preccurlyeq": "≼",
	"Precedes": "≺",
	"PrecedesEqual": "⪯",
	"PrecedesSlantEqual": "≼",
	"PrecedesTilde": "≾",
	"preceq": "⪯",
	"precnapprox": "⪹",
	"precneqq": "⪵",
	"precnsim": "⋨",
	"pre": "⪯",
	"prE": "⪳",
	"precsim": "≾",
	"prime": "′",
	"Prime": "″",
	"primes": "ℙ",
	"prnap": "⪹",
	"prnE": "⪵",
	"prnsim": "⋨",
	"prod": "∏",
	"Product": "∏",
	"profalar": "⌮",
	"profline": "⌒",
	"profsurf": "⌓",
	"prop": "∝",
	"Proportional": "∝",
	"Proportion": "∷",
	"propto": "∝",
	"prsim": "≾",
	"prurel": "⊰",
	"Pscr": "𝒫",
	"pscr": "𝓅",
	"Psi": "Ψ",
	"psi": "ψ",
	"puncsp": " ",
	"Qfr": "𝔔",
	"qfr": "𝔮",
	"qint": "⨌",
	"qopf": "𝕢",
	"Qopf": "ℚ",
	"qprime": "⁗",
	"Qscr": "𝒬",
	"qscr": "𝓆",
	"quaternions": "ℍ",
	"quatint": "⨖",
	"quest": "?",
	"questeq": "≟",
	"quot": "\"",
	"QUOT": "\"",
	"rAarr": "⇛",
	"race": "∽̱",
	"Racute": "Ŕ",
	"racute": "ŕ",
	"radic": "√",
	"raemptyv": "⦳",
	"rang": "⟩",
	"Rang": "⟫",
	"rangd": "⦒",
	"range": "⦥",
	"rangle": "⟩",
	"raquo": "»",
	"rarrap": "⥵",
	"rarrb": "⇥",
	"rarrbfs": "⤠",
	"rarrc": "⤳",
	"rarr": "→",
	"Rarr": "↠",
	"rArr": "⇒",
	"rarrfs": "⤞",
	"rarrhk": "↪",
	"rarrlp": "↬",
	"rarrpl": "⥅",
	"rarrsim": "⥴",
	"Rarrtl": "⤖",
	"rarrtl": "↣",
	"rarrw": "↝",
	"ratail": "⤚",
	"rAtail": "⤜",
	"ratio": "∶",
	"rationals": "ℚ",
	"rbarr": "⤍",
	"rBarr": "⤏",
	"RBarr": "⤐",
	"rbbrk": "❳",
	"rbrace": "}",
	"rbrack": "]",
	"rbrke": "⦌",
	"rbrksld": "⦎",
	"rbrkslu": "⦐",
	"Rcaron": "Ř",
	"rcaron": "ř",
	"Rcedil": "Ŗ",
	"rcedil": "ŗ",
	"rceil": "⌉",
	"rcub": "}",
	"Rcy": "Р",
	"rcy": "р",
	"rdca": "⤷",
	"rdldhar": "⥩",
	"rdquo": "”",
	"rdquor": "”",
	"rdsh": "↳",
	"real": "ℜ",
	"realine": "ℛ",
	"realpart": "ℜ",
	"reals": "ℝ",
	"Re": "ℜ",
	"rect": "▭",
	"reg": "®",
	"REG": "®",
	"ReverseElement": "∋",
	"ReverseEquilibrium": "⇋",
	"ReverseUpEquilibrium": "⥯",
	"rfisht": "⥽",
	"rfloor": "⌋",
	"rfr": "𝔯",
	"Rfr": "ℜ",
	"rHar": "⥤",
	"rhard": "⇁",
	"rharu": "⇀",
	"rharul": "⥬",
	"Rho": "Ρ",
	"rho": "ρ",
	"rhov": "ϱ",
	"RightAngleBracket": "⟩",
	"RightArrowBar": "⇥",
	"rightarrow": "→",
	"RightArrow": "→",
	"Rightarrow": "⇒",
	"RightArrowLeftArrow": "⇄",
	"rightarrowtail": "↣",
	"RightCeiling": "⌉",
	"RightDoubleBracket": "⟧",
	"RightDownTeeVector": "⥝",
	"RightDownVectorBar": "⥕",
	"RightDownVector": "⇂",
	"RightFloor": "⌋",
	"rightharpoondown": "⇁",
	"rightharpoonup": "⇀",
	"rightleftarrows": "⇄",
	"rightleftharpoons": "⇌",
	"rightrightarrows": "⇉",
	"rightsquigarrow": "↝",
	"RightTeeArrow": "↦",
	"RightTee": "⊢",
	"RightTeeVector": "⥛",
	"rightthreetimes": "⋌",
	"RightTriangleBar": "⧐",
	"RightTriangle": "⊳",
	"RightTriangleEqual": "⊵",
	"RightUpDownVector": "⥏",
	"RightUpTeeVector": "⥜",
	"RightUpVectorBar": "⥔",
	"RightUpVector": "↾",
	"RightVectorBar": "⥓",
	"RightVector": "⇀",
	"ring": "˚",
	"risingdotseq": "≓",
	"rlarr": "⇄",
	"rlhar": "⇌",
	"rlm": "‏",
	"rmoustache": "⎱",
	"rmoust": "⎱",
	"rnmid": "⫮",
	"roang": "⟭",
	"roarr": "⇾",
	"robrk": "⟧",
	"ropar": "⦆",
	"ropf": "𝕣",
	"Ropf": "ℝ",
	"roplus": "⨮",
	"rotimes": "⨵",
	"RoundImplies": "⥰",
	"rpar": ")",
	"rpargt": "⦔",
	"rppolint": "⨒",
	"rrarr": "⇉",
	"Rrightarrow": "⇛",
	"rsaquo": "›",
	"rscr": "𝓇",
	"Rscr": "ℛ",
	"rsh": "↱",
	"Rsh": "↱",
	"rsqb": "]",
	"rsquo": "’",
	"rsquor": "’",
	"rthree": "⋌",
	"rtimes": "⋊",
	"rtri": "▹",
	"rtrie": "⊵",
	"rtrif": "▸",
	"rtriltri": "⧎",
	"RuleDelayed": "⧴",
	"ruluhar": "⥨",
	"rx": "℞",
	"Sacute": "Ś",
	"sacute": "ś",
	"sbquo": "‚",
	"scap": "⪸",
	"Scaron": "Š",
	"scaron": "š",
	"Sc": "⪼",
	"sc": "≻",
	"sccue": "≽",
	"sce": "⪰",
	"scE": "⪴",
	"Scedil": "Ş",
	"scedil": "ş",
	"Scirc": "Ŝ",
	"scirc": "ŝ",
	"scnap": "⪺",
	"scnE": "⪶",
	"scnsim": "⋩",
	"scpolint": "⨓",
	"scsim": "≿",
	"Scy": "С",
	"scy": "с",
	"sdotb": "⊡",
	"sdot": "⋅",
	"sdote": "⩦",
	"searhk": "⤥",
	"searr": "↘",
	"seArr": "⇘",
	"searrow": "↘",
	"sect": "§",
	"semi": ";",
	"seswar": "⤩",
	"setminus": "∖",
	"setmn": "∖",
	"sext": "✶",
	"Sfr": "𝔖",
	"sfr": "𝔰",
	"sfrown": "⌢",
	"sharp": "♯",
	"SHCHcy": "Щ",
	"shchcy": "щ",
	"SHcy": "Ш",
	"shcy": "ш",
	"ShortDownArrow": "↓",
	"ShortLeftArrow": "←",
	"shortmid": "∣",
	"shortparallel": "∥",
	"ShortRightArrow": "→",
	"ShortUpArrow": "↑",
	"shy": "­",
	"Sigma": "Σ",
	"sigma": "σ",
	"sigmaf": "ς",
	"sigmav": "ς",
	"sim": "∼",
	"simdot": "⩪",
	"sime": "≃",
	"simeq": "≃",
	"simg": "⪞",
	"simgE": "⪠",
	"siml": "⪝",
	"simlE": "⪟",
	"simne": "≆",
	"simplus": "⨤",
	"simrarr": "⥲",
	"slarr": "←",
	"SmallCircle": "∘",
	"smallsetminus": "∖",
	"smashp": "⨳",
	"smeparsl": "⧤",
	"smid": "∣",
	"smile": "⌣",
	"smt": "⪪",
	"smte": "⪬",
	"smtes": "⪬︀",
	"SOFTcy": "Ь",
	"softcy": "ь",
	"solbar": "⌿",
	"solb": "⧄",
	"sol": "/",
	"Sopf": "𝕊",
	"sopf": "𝕤",
	"spades": "♠",
	"spadesuit": "♠",
	"spar": "∥",
	"sqcap": "⊓",
	"sqcaps": "⊓︀",
	"sqcup": "⊔",
	"sqcups": "⊔︀",
	"Sqrt": "√",
	"sqsub": "⊏",
	"sqsube": "⊑",
	"sqsubset": "⊏",
	"sqsubseteq": "⊑",
	"sqsup": "⊐",
	"sqsupe": "⊒",
	"sqsupset": "⊐",
	"sqsupseteq": "⊒",
	"square": "□",
	"Square": "□",
	"SquareIntersection": "⊓",
	"SquareSubset": "⊏",
	"SquareSubsetEqual": "⊑",
	"SquareSuperset": "⊐",
	"SquareSupersetEqual": "⊒",
	"SquareUnion": "⊔",
	"squarf": "▪",
	"squ": "□",
	"squf": "▪",
	"srarr": "→",
	"Sscr": "𝒮",
	"sscr": "𝓈",
	"ssetmn": "∖",
	"ssmile": "⌣",
	"sstarf": "⋆",
	"Star": "⋆",
	"star": "☆",
	"starf": "★",
	"straightepsilon": "ϵ",
	"straightphi": "ϕ",
	"strns": "¯",
	"sub": "⊂",
	"Sub": "⋐",
	"subdot": "⪽",
	"subE": "⫅",
	"sube": "⊆",
	"subedot": "⫃",
	"submult": "⫁",
	"subnE": "⫋",
	"subne": "⊊",
	"subplus": "⪿",
	"subrarr": "⥹",
	"subset": "⊂",
	"Subset": "⋐",
	"subseteq": "⊆",
	"subseteqq": "⫅",
	"SubsetEqual": "⊆",
	"subsetneq": "⊊",
	"subsetneqq": "⫋",
	"subsim": "⫇",
	"subsub": "⫕",
	"subsup": "⫓",
	"succapprox": "⪸",
	"succ": "≻",
	"succcurlyeq": "≽",
	"Succeeds": "≻",
	"SucceedsEqual": "⪰",
	"SucceedsSlantEqual": "≽",
	"SucceedsTilde": "≿",
	"succeq": "⪰",
	"succnapprox": "⪺",
	"succneqq": "⪶",
	"succnsim": "⋩",
	"succsim": "≿",
	"SuchThat": "∋",
	"sum": "∑",
	"Sum": "∑",
	"sung": "♪",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"sup": "⊃",
	"Sup": "⋑",
	"supdot": "⪾",
	"supdsub": "⫘",
	"supE": "⫆",
	"supe": "⊇",
	"supedot": "⫄",
	"Superset": "⊃",
	"SupersetEqual": "⊇",
	"suphsol": "⟉",
	"suphsub": "⫗",
	"suplarr": "⥻",
	"supmult": "⫂",
	"supnE": "⫌",
	"supne": "⊋",
	"supplus": "⫀",
	"supset": "⊃",
	"Supset": "⋑",
	"supseteq": "⊇",
	"supseteqq": "⫆",
	"supsetneq": "⊋",
	"supsetneqq": "⫌",
	"supsim": "⫈",
	"supsub": "⫔",
	"supsup": "⫖",
	"swarhk": "⤦",
	"swarr": "↙",
	"swArr": "⇙",
	"swarrow": "↙",
	"swnwar": "⤪",
	"szlig": "ß",
	"Tab": "\t",
	"target": "⌖",
	"Tau": "Τ",
	"tau": "τ",
	"tbrk": "⎴",
	"Tcaron": "Ť",
	"tcaron": "ť",
	"Tcedil": "Ţ",
	"tcedil": "ţ",
	"Tcy": "Т",
	"tcy": "т",
	"tdot": "⃛",
	"telrec": "⌕",
	"Tfr": "𝔗",
	"tfr": "𝔱",
	"there4": "∴",
	"therefore": "∴",
	"Therefore": "∴",
	"Theta": "Θ",
	"theta": "θ",
	"thetasym": "ϑ",
	"thetav": "ϑ",
	"thickapprox": "≈",
	"thicksim": "∼",
	"ThickSpace": "  ",
	"ThinSpace": " ",
	"thinsp": " ",
	"thkap": "≈",
	"thksim": "∼",
	"THORN": "Þ",
	"thorn": "þ",
	"tilde": "˜",
	"Tilde": "∼",
	"TildeEqual": "≃",
	"TildeFullEqual": "≅",
	"TildeTilde": "≈",
	"timesbar": "⨱",
	"timesb": "⊠",
	"times": "×",
	"timesd": "⨰",
	"tint": "∭",
	"toea": "⤨",
	"topbot": "⌶",
	"topcir": "⫱",
	"top": "⊤",
	"Topf": "𝕋",
	"topf": "𝕥",
	"topfork": "⫚",
	"tosa": "⤩",
	"tprime": "‴",
	"trade": "™",
	"TRADE": "™",
	"triangle": "▵",
	"triangledown": "▿",
	"triangleleft": "◃",
	"trianglelefteq": "⊴",
	"triangleq": "≜",
	"triangleright": "▹",
	"trianglerighteq": "⊵",
	"tridot": "◬",
	"trie": "≜",
	"triminus": "⨺",
	"TripleDot": "⃛",
	"triplus": "⨹",
	"trisb": "⧍",
	"tritime": "⨻",
	"trpezium": "⏢",
	"Tscr": "𝒯",
	"tscr": "𝓉",
	"TScy": "Ц",
	"tscy": "ц",
	"TSHcy": "Ћ",
	"tshcy": "ћ",
	"Tstrok": "Ŧ",
	"tstrok": "ŧ",
	"twixt": "≬",
	"twoheadleftarrow": "↞",
	"twoheadrightarrow": "↠",
	"Uacute": "Ú",
	"uacute": "ú",
	"uarr": "↑",
	"Uarr": "↟",
	"uArr": "⇑",
	"Uarrocir": "⥉",
	"Ubrcy": "Ў",
	"ubrcy": "ў",
	"Ubreve": "Ŭ",
	"ubreve": "ŭ",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ucy": "У",
	"ucy": "у",
	"udarr": "⇅",
	"Udblac": "Ű",
	"udblac": "ű",
	"udhar": "⥮",
	"ufisht": "⥾",
	"Ufr": "𝔘",
	"ufr": "𝔲",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uHar": "⥣",
	"uharl": "↿",
	"uharr": "↾",
	"uhblk": "▀",
	"ulcorn": "⌜",
	"ulcorner": "⌜",
	"ulcrop": "⌏",
	"ultri": "◸",
	"Umacr": "Ū",
	"umacr": "ū",
	"uml": "¨",
	"UnderBar": "_",
	"UnderBrace": "⏟",
	"UnderBracket": "⎵",
	"UnderParenthesis": "⏝",
	"Union": "⋃",
	"UnionPlus": "⊎",
	"Uogon": "Ų",
	"uogon": "ų",
	"Uopf": "𝕌",
	"uopf": "𝕦",
	"UpArrowBar": "⤒",
	"uparrow": "↑",
	"UpArrow": "↑",
	"Uparrow": "⇑",
	"UpArrowDownArrow": "⇅",
	"updownarrow": "↕",
	"UpDownArrow": "↕",
	"Updownarrow": "⇕",
	"UpEquilibrium": "⥮",
	"upharpoonleft": "↿",
	"upharpoonright": "↾",
	"uplus": "⊎",
	"UpperLeftArrow": "↖",
	"UpperRightArrow": "↗",
	"upsi": "υ",
	"Upsi": "ϒ",
	"upsih": "ϒ",
	"Upsilon": "Υ",
	"upsilon": "υ",
	"UpTeeArrow": "↥",
	"UpTee": "⊥",
	"upuparrows": "⇈",
	"urcorn": "⌝",
	"urcorner": "⌝",
	"urcrop": "⌎",
	"Uring": "Ů",
	"uring": "ů",
	"urtri": "◹",
	"Uscr": "𝒰",
	"uscr": "𝓊",
	"utdot": "⋰",
	"Utilde": "Ũ",
	"utilde": "ũ",
	"utri": "▵",
	"utrif": "▴",
	"uuarr": "⇈",
	"Uuml": "Ü",
	"uuml": "ü",
	"uwangle": "⦧",
	"vangrt": "⦜",
	"varepsilon": "ϵ",
	"varkappa": "ϰ",
	"varnothing": "∅",
	"varphi": "ϕ",
	"varpi": "ϖ",
	"varpropto": "∝",
	"varr": "↕",
	"vArr": "⇕",
	"varrho": "ϱ",
	"varsigma": "ς",
	"varsubsetneq": "⊊︀",
	"varsubsetneqq": "⫋︀",
	"varsupsetneq": "⊋︀",
	"varsupsetneqq": "⫌︀",
	"vartheta": "ϑ",
	"vartriangleleft": "⊲",
	"vartriangleright": "⊳",
	"vBar": "⫨",
	"Vbar": "⫫",
	"vBarv": "⫩",
	"Vcy": "В",
	"vcy": "в",
	"vdash": "⊢",
	"vDash": "⊨",
	"Vdash": "⊩",
	"VDash": "⊫",
	"Vdashl": "⫦",
	"veebar": "⊻",
	"vee": "∨",
	"Vee": "⋁",
	"veeeq": "≚",
	"vellip": "⋮",
	"verbar": "|",
	"Verbar": "‖",
	"vert": "|",
	"Vert": "‖",
	"VerticalBar": "∣",
	"VerticalLine": "|",
	"VerticalSeparator": "❘",
	"VerticalTilde": "≀",
	"VeryThinSpace": " ",
	"Vfr": "𝔙",
	"vfr": "𝔳",
	"vltri": "⊲",
	"vnsub": "⊂⃒",
	"vnsup": "⊃⃒",
	"Vopf": "𝕍",
	"vopf": "𝕧",
	"vprop": "∝",
	"vrtri": "⊳",
	"Vscr": "𝒱",
	"vscr": "𝓋",
	"vsubnE": "⫋︀",
	"vsubne": "⊊︀",
	"vsupnE": "⫌︀",
	"vsupne": "⊋︀",
	"Vvdash": "⊪",
	"vzigzag": "⦚",
	"Wcirc": "Ŵ",
	"wcirc": "ŵ",
	"wedbar": "⩟",
	"wedge": "∧",
	"Wedge": "⋀",
	"wedgeq": "≙",
	"weierp": "℘",
	"Wfr": "𝔚",
	"wfr": "𝔴",
	"Wopf": "𝕎",
	"wopf": "𝕨",
	"wp": "℘",
	"wr": "≀",
	"wreath": "≀",
	"Wscr": "𝒲",
	"wscr": "𝓌",
	"xcap": "⋂",
	"xcirc": "◯",
	"xcup": "⋃",
	"xdtri": "▽",
	"Xfr": "𝔛",
	"xfr": "𝔵",
	"xharr": "⟷",
	"xhArr": "⟺",
	"Xi": "Ξ",
	"xi": "ξ",
	"xlarr": "⟵",
	"xlArr": "⟸",
	"xmap": "⟼",
	"xnis": "⋻",
	"xodot": "⨀",
	"Xopf": "𝕏",
	"xopf": "𝕩",
	"xoplus": "⨁",
	"xotime": "⨂",
	"xrarr": "⟶",
	"xrArr": "⟹",
	"Xscr": "𝒳",
	"xscr": "𝓍",
	"xsqcup": "⨆",
	"xuplus": "⨄",
	"xutri": "△",
	"xvee": "⋁",
	"xwedge": "⋀",
	"Yacute": "Ý",
	"yacute": "ý",
	"YAcy": "Я",
	"yacy": "я",
	"Ycirc": "Ŷ",
	"ycirc": "ŷ",
	"Ycy": "Ы",
	"ycy": "ы",
	"yen": "¥",
	"Yfr": "𝔜",
	"yfr": "𝔶",
	"YIcy": "Ї",
	"yicy": "ї",
	"Yopf": "𝕐",
	"yopf": "𝕪",
	"Yscr": "𝒴",
	"yscr": "𝓎",
	"YUcy": "Ю",
	"yucy": "ю",
	"yuml": "ÿ",
	"Yuml": "Ÿ",
	"Zacute": "Ź",
	"zacute": "ź",
	"Zcaron": "Ž",
	"zcaron": "ž",
	"Zcy": "З",
	"zcy": "з",
	"Zdot": "Ż",
	"zdot": "ż",
	"zeetrf": "ℨ",
	"ZeroWidthSpace": "​",
	"Zeta": "Ζ",
	"zeta": "ζ",
	"zfr": "𝔷",
	"Zfr": "ℨ",
	"ZHcy": "Ж",
	"zhcy": "ж",
	"zigrarr": "⇝",
	"zopf": "𝕫",
	"Zopf": "ℤ",
	"Zscr": "𝒵",
	"zscr": "𝓏",
	"zwj": "‍",
	"zwnj": "‌"
};

/***/ }),

/***/ 436:
/***/ (function(module, exports) {

module.exports = {
	"Aacute": "Á",
	"aacute": "á",
	"Acirc": "Â",
	"acirc": "â",
	"acute": "´",
	"AElig": "Æ",
	"aelig": "æ",
	"Agrave": "À",
	"agrave": "à",
	"amp": "&",
	"AMP": "&",
	"Aring": "Å",
	"aring": "å",
	"Atilde": "Ã",
	"atilde": "ã",
	"Auml": "Ä",
	"auml": "ä",
	"brvbar": "¦",
	"Ccedil": "Ç",
	"ccedil": "ç",
	"cedil": "¸",
	"cent": "¢",
	"copy": "©",
	"COPY": "©",
	"curren": "¤",
	"deg": "°",
	"divide": "÷",
	"Eacute": "É",
	"eacute": "é",
	"Ecirc": "Ê",
	"ecirc": "ê",
	"Egrave": "È",
	"egrave": "è",
	"ETH": "Ð",
	"eth": "ð",
	"Euml": "Ë",
	"euml": "ë",
	"frac12": "½",
	"frac14": "¼",
	"frac34": "¾",
	"gt": ">",
	"GT": ">",
	"Iacute": "Í",
	"iacute": "í",
	"Icirc": "Î",
	"icirc": "î",
	"iexcl": "¡",
	"Igrave": "Ì",
	"igrave": "ì",
	"iquest": "¿",
	"Iuml": "Ï",
	"iuml": "ï",
	"laquo": "«",
	"lt": "<",
	"LT": "<",
	"macr": "¯",
	"micro": "µ",
	"middot": "·",
	"nbsp": " ",
	"not": "¬",
	"Ntilde": "Ñ",
	"ntilde": "ñ",
	"Oacute": "Ó",
	"oacute": "ó",
	"Ocirc": "Ô",
	"ocirc": "ô",
	"Ograve": "Ò",
	"ograve": "ò",
	"ordf": "ª",
	"ordm": "º",
	"Oslash": "Ø",
	"oslash": "ø",
	"Otilde": "Õ",
	"otilde": "õ",
	"Ouml": "Ö",
	"ouml": "ö",
	"para": "¶",
	"plusmn": "±",
	"pound": "£",
	"quot": "\"",
	"QUOT": "\"",
	"raquo": "»",
	"reg": "®",
	"REG": "®",
	"sect": "§",
	"shy": "­",
	"sup1": "¹",
	"sup2": "²",
	"sup3": "³",
	"szlig": "ß",
	"THORN": "Þ",
	"thorn": "þ",
	"times": "×",
	"Uacute": "Ú",
	"uacute": "ú",
	"Ucirc": "Û",
	"ucirc": "û",
	"Ugrave": "Ù",
	"ugrave": "ù",
	"uml": "¨",
	"Uuml": "Ü",
	"uuml": "ü",
	"Yacute": "Ý",
	"yacute": "ý",
	"yen": "¥",
	"yuml": "ÿ"
};

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

module.exports = function (string) {
  return string.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&")
}


/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 440:
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(101)


/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(354)


/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

var Stream = (function (){
  try {
    return __webpack_require__(281); // hack to fix a circular dependency issue when used with browserify
  } catch(_){}
}());
exports = module.exports = __webpack_require__(355);
exports.Stream = Stream || exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(305);
exports.Duplex = __webpack_require__(101);
exports.Transform = __webpack_require__(304);
exports.PassThrough = __webpack_require__(354);


/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(304)


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(305)


/***/ }),

/***/ 446:
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),

/***/ 447:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(451), __esModule: true };

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);

// ---------------------------------------------------
// Module Definition

/**
 * @class FieldRule
 *
 * Base pseudoclass for validated field rules. Contains
 * an 'outputSchema' method that outputs an object used
 * by the {@link Validator} class. You extend this
 * class and define a 'validate' method (returning a
 * boolean) to tell the Validator class if the
 * field violates this Rule or not.
 * @param {object} [options]
 * @param {boolean} [options.noMatch] Overrides property of the same name
 * @param {string} [options.message] Overrides property of the same name
 * @param {string} [options.messageBody="is invalid"] Overrides property of the same name
 *
 * @property {string} message
 *      A message for to display if {@link Validator}
 *      determines a field's value to be false for this
 *      rule
 * @property {boolean} noMatch
 *      If the inverse of this rule's result should be
 *      used to determine if a validation error occurred or
 *      not. For example: if the rule's validate method
 *      returns 'true', which would normally pass validation,
 *      it would be considered an error if noMatch is true.
 * @property {string} messageBody
 *      If defined and the parent {@link FieldValidation}
 *      has a fieldDisplayName defined, than they will be combined
 *      to create a 'message'. This is a assuming a message is
 *      not defined. If a custom message option is provided, then
 *      messageBody will be ignored
 * @property {string} defaultMessage
 *      If no 'message' exists and one cannot be constructed
 *      from the 'messageBody', then the 'defaultMessage'
 *      wold be used for this field.
 *
 */
var FieldRule = module.exports = function () {
    this.initialize.apply(this, arguments);
};

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(FieldRule.prototype, {

    messageBody: "is invalid",

    initialize: function (options) {
        options = options || {};
        this.validate = options.validate || this.validate;
        this.noMatch = _.isBoolean(options.noMatch) ? options.noMatch : this.noMatch;
        this.setMessage(!_.isUndefined(options.message) ? options.message : this.message);
        this.setMessageBody(!_.isUndefined(options.messageBody) ? options.messageBody : this.messageBody);
    },

    /**
     * Set the error message for this rule
     * should the validation not pass
     * @param message
     * @returns {FieldRule}
     */
    setMessage: function (message) {
        this.message = message;
        return this;
    },

    /**
     * @param messageBody
     * @returns {FieldRule}
     */
    setMessageBody: function (messageBody) {
        this.messageBody = messageBody;
        this.defaultMessage = 'This field ' + messageBody;
        return this;
    },

    /**
     * @param {FieldValidation} parentValidation
     * @returns {FieldRule}
     */
    setParentValidation: function (parentValidation) {
        this._parentValidation = parentValidation;
        return this;
    },

    /**
     * @returns {FieldValidation}
     */
    getParentValidation: function () {
        return this._parentValidation;
    },

    ///**
    // * Default message function
    // * @returns {string}
    // */
    //message: function () {
    //    var messageBody = _.result(this, 'messageBody');
    //    var parentValidation = this.getParentValidation();
    //    if (parentValidation && parentValidation.fieldDisplayName && messageBody) {
    //        return FieldRule.createMessageWithBody(parentValidation.fieldDisplayName, messageBody);
    //    }
    //    return _.result(this, 'defaultMessage') || 'This field is invalid';
    //},

    /**
     * Override in extension. Gets invoked by {@link Validator}
     * @param {Backbone.Model} model
     * @param {*} value
     * @param {string} fieldName
     * @returns {boolean}
     */
    validate: function (model, value, fieldName, required) {}, //eslint-disable-line

    /**
     * Output the {@link Validator} config json
     * for this rule
     * @returns {object}
     */
    outputSchema: function () {
        var self = this;
        return {
            noMatch: self.noMatch,
            message: self.message,
            validator: function (value, fieldName, required) {
                if (required !== !!required) { // if required isn't a bool (undefined, null, whatever) then default to true
                    required = true;
                }
                return self.validate(this, value, fieldName, required); // "this" is the model in this context
            }
        };
    }
}, Backbone.Events);

// ---------------------------------------------------
// Define Module Static Properties

_.extend(FieldRule, {
    /**
     * @function
     * @param {object} instanceProperties
     * @param {object} staticProperties
     * @returns {function} New constructor function
     */
    extend: Backbone.Model.extend, // Give this pseudoclass the ability to be extended,

    /**
     * @param {string} fieldDisplayName
     * @param {string} messageBody
     * @returns {string}
     */
    createMessageWithBody: function (fieldDisplayName, messageBody) {
        return '"' + fieldDisplayName + '" field ' + messageBody;
    }

});


/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(452);
module.exports = __webpack_require__(460).f('hasInstance');

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject       = __webpack_require__(568)
  , getPrototypeOf = __webpack_require__(357)
  , HAS_INSTANCE   = __webpack_require__(585)('hasInstance')
  , FunctionProto  = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(599).f(FunctionProto, HAS_INSTANCE, {value: function(O){
  if(typeof this != 'function' || !isObject(O))return false;
  if(!isObject(this.prototype))return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
  return false;
}});

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(306),
    createEnum = _require.createEnum;

/**
 * Enum class representing a "type" of a carousel page change. Mostly useful for GA tracking purposes.
 */


module.exports = createEnum('next', 'previous', 'jump');

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Rip off logic used internally by React.PropTypes to create chainable/requirable prop type validators. The React
// team has not agreed to expose this so we'll need to maintain it ourselves. Some minor changes made to the
// implementation that shouldn't affect its operation.



var ANONYMOUS = '<<anonymous>>';

/**
 * Pass in a custom React prop types validation function to create a wrapped version of that validator that allows
 * marking it as required.
 *
 * See https://facebook.github.io/react/docs/reusable-components.html for some more information on custom validators.
 * @param  {Function} validate The validation function to wrap.
 * @return {Function}          Wrapped validator.
 */
function createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        var prop = props[propName];


        if (prop === null || prop === undefined) {
            if (isRequired) {
                return new Error('Required ' + location + ' `' + propFullName + '` was not specified in `' + componentName + '`');
            } else {
                return null;
            }
        } else {
            return validate(props, propName, componentName, location, propFullName);
        }
    }

    // Create a required and non-required version of the validator
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
}

module.exports = createChainableTypeChecker;

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Need to manually require the babel runtime component for customizing instanceof.
// In native ES2015 this would be done with the "well-known" symbol `Symbol.hasInstance`

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var hasInstance = __webpack_require__(449).default;

/**
 * Uppercase the first letter of the passed in string.
 * @param  {String} str String to capitalize
 * @return {String}
 */
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
}

/**
 * Generate an enum type with the passed in variants. Enums will get a match method, a method for getting the raw
 * type name as a string a method for getting any contained data, and identity functions for every variant. An example
 * illustrates how this works:
 *
 * Here each variant wraps a class. When matching on the variant, the inner data is returned and can be manipulated.
 * const deviceTypeEnum = createEnum({
 *     mobile(...args) {
 *         return new Mobile(...args);
 *     },
 *     tablet(...args) {
 *         return new Tablet(...args);
 *     },
 *     desktop(...args) {
 *         return new Desktop(...args);
 *     }
 * });
 *
 * const instance = deviceTypeEnum.mobile();
 *
 * instance.isMobile() // true
 * instance.isTablet() // false
 * instance.isDesktop() // false
 * instance.variant() // 'mobile'
 * instance.data() // instance of class Mobile
 *
 * const test = instance.match({
 *     mobile: (inner) => inner,
 *     tablet: (inner) => inner,
 *     desktop: (inner) => inner
 * });
 *
 * console.log(test) // instance of class Mobile
 *
 * @param  {String} ...types List of enum variants.
 * @return {Enum}
 */
function createEnum() {
    for (var _len = arguments.length, variants = Array(_len), _key = 0; _key < _len; _key++) {
        variants[_key] = arguments[_key];
    }

    // Allow passing a list of variants instead of an object if we don't need to hold any data.
    if (_typeof(variants[0]) === 'object') {
        variants = variants[0];
    } else {
        variants = variants.reduce(function (acc, variant) {
            if (typeof variant !== 'string') {
                throw new Error('If not passing a config object to createEnum, all arguments must be strings.');
            }

            acc[variant] = function () {
                return null;
            };
            return acc;
        }, {});
    }

    // Brand the newly create enum "class" so instance of differentiates between different enums.
    // Symbols are guaranteed to be unique so there is no way to spoof this.
    var brand = Symbol();
    var keys = Object.keys(variants);

    var EnumClass = function () {
        function EnumClass(variant, data) {
            _classCallCheck(this, EnumClass);

            this.variant = variant;
            this.data = data;
            this[brand] = true;
        }

        // Matching function to avoid lots of if/else blocks using the identity methods directly.


        _createClass(EnumClass, [{
            key: 'match',
            value: function match(config) {
                var matcher = config[this.variant];

                // If a matching function is passed in, pass through the wrapped data.
                if (matcher) {
                    return matcher(this.data);
                }
            }
        }]);

        return EnumClass;
    }();

    // Add an "isVariant" method for each variant.
    keys.forEach(function (variant) {
        EnumClass.prototype['is' + capitalize(variant)] = function () {
            return this.variant === variant;
        };
    });

    // Freeze the object so it can't be tampered with.
    Object.freeze(EnumClass.prototype);
    return Object.freeze(keys.reduce(function (acc, variant) {
        // Add the variant construction functions.
        acc[variant] = function () {
            var _variants;

            return Object.freeze(new EnumClass(variant, (_variants = variants)[variant].apply(_variants, arguments)));
        };;
        return acc;
    }, _defineProperty({}, hasInstance, function (value) {
        return value[brand] || false;
    })));
}

module.exports = createEnum;

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createChainableTypeChecker = __webpack_require__(456);

/**
 * Currently React's instanceOf PropTypes checker does not work with ES2015 customized instanceof checks. This is a
 * custom propType validator that will allow a component to check if a prop is an instance of a particular enum type.
 *
 * Example:
 * const myEnum = createEnum('one', 'two');
 * const enumInstance = myEnum.one();
 *
 * class MyReactComponent { ... }
 * MyReactComponent.propTypes = {
 *     enumProp: instanceOfEnum(myEnum).isRequired,
 *     moreEnums: PropTypes.arrayOf(instanceOfEnum(myEnum)).isRequired
 * }
 *
 * @param  {Enum} enumType The enum "class" to check for.
 * @return {Function}          A React prop types validation function for that enum.
 */
function instanceOfEnum(enumType) {
    // Make this prop type requireable with `isRequired`
    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
        // Prop is guaranteed to be defined at this point so no need to check for it.
        if (!(props[propName] instanceof enumType)) {
            // React requires custom validators to `return` an error and not `throw`
            return new Error('Must pass an enum instance of correct type to ' + location + ' `' + propFullName + '` in `' + componentName + '`');
        } else {
            return null;
        }
    });
}

module.exports = instanceOfEnum;

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(115)
var ieee754 = __webpack_require__(119)
var isArray = __webpack_require__(116)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(44))(162);

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(71),
    noop = _require.noop;

var MultiTouchDetector = __webpack_require__(273);

var _require2 = __webpack_require__(306),
    createEnum = _require2.createEnum;

var math = __webpack_require__(472);

/**
 * Enum class representing a swipe direction.
 */
var swipeDirectionEnum = createEnum('left', 'right', 'up', 'down');

var quadarantDirectionMap = [swipeDirectionEnum.right, swipeDirectionEnum.up, swipeDirectionEnum.left, swipeDirectionEnum.down];

/**
 * Utility to detect the direction of the swipe.
 * @param {Array} - Array consisting of the touch coordinates [x, y]
 * @return {Object} - Enum class
 */
function swipeDirection(distance) {
    var quadrant = math.getQuadrant(math.getPointAngle(distance[0], distance[1]) + 45);
    return quadarantDirectionMap[quadrant]();
}

/**
 * Utility class To handle swipe detection. Pass an element in and get notified on a swipe on that element. Instances
 * need to be destroyed when tracking is no longer needed.
 *
 * @param  {Object}  options.el Element to track.
 * @param  {Function}  [options.onPartialSwipe] Callback to fire on initial panning. Allows you to get distance panned.
 * @param  {Function}  [options.onSwipeSuccess] Callback to fire on successful swipe. Callback is passed the swipe direction.
 * @param  {Function}  [options.onSwipeFailure] Callback to fire on failed swipe.
 */

var SwipeDetector = function () {
    function SwipeDetector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el,
            _ref$onPartialSwipe = _ref.onPartialSwipe,
            onPartialSwipe = _ref$onPartialSwipe === undefined ? noop : _ref$onPartialSwipe,
            _ref$onSwipeSuccess = _ref.onSwipeSuccess,
            onSwipeSuccess = _ref$onSwipeSuccess === undefined ? noop : _ref$onSwipeSuccess,
            _ref$onSwipeFailure = _ref.onSwipeFailure,
            onSwipeFailure = _ref$onSwipeFailure === undefined ? noop : _ref$onSwipeFailure;

        _classCallCheck(this, SwipeDetector);

        if (!el) {
            throw new Error('Must pass `el` to SwipeDetector');
        }

        Object.assign(this, {
            _distance: [null, null],
            _initialPosition: [null, null],
            _initialTime: null,
            _el: el,
            _onPartialSwipe: onPartialSwipe,
            _onSwipeSuccess: onSwipeSuccess,
            _onSwipeFailure: onSwipeFailure,
            _multiTouchDetector: new MultiTouchDetector({
                onSingleTouchStart: this._onSingleTouchStart.bind(this),
                onSingleTouchMove: this._onSingleTouchMove.bind(this),
                onSingleTouchEnd: this._onSingleTouchEnd.bind(this),
                el: el
            })
        });
    }

    _createClass(SwipeDetector, [{
        key: '_onSingleTouchStart',
        value: function _onSingleTouchStart(e) {
            // Get the initial position and time so we can do a difference on them later.
            this._initialPosition = [e.touches[0].clientX, e.touches[0].clientY];
            this._initialTime = Date.now();
        }
    }, {
        key: '_onSingleTouchMove',
        value: function _onSingleTouchMove(e) {
            this._distance = [e.touches[0].clientX - this._initialPosition[0], e.touches[0].clientY - this._initialPosition[1]];

            var direction = swipeDirection(this._distance);

            /**
             * We don't wanna messup the scrolling experience so we only call preventDefault when
             * swiping horizontaly.
             */
            if (direction.isRight() || direction.isLeft()) {
                e.preventDefault();
            }

            this._onPartialSwipe(this._distance, direction);
        }
    }, {
        key: '_onSingleTouchEnd',
        value: function _onSingleTouchEnd() {
            if (this._shouldRegisterSwipe()) {
                // Determine swipe direction based on sign of distance.
                this._onSwipeSuccess(swipeDirection(this._distance));
            } else {
                this._onSwipeFailure();
            }

            this._distance = [0, 0];
        }
    }, {
        key: '_shouldRegisterSwipe',
        value: function _shouldRegisterSwipe() {
            var _this = this;

            var totalTime = Date.now() - this._initialTime;
            var absoluteDistance = void 0;

            return this._distance.some(function (distance) {
                absoluteDistance = Math.abs(distance);

                // Register a swipe if:
                // slide duration is less than 250ms and if slide distance is greater than 20px
                // OR if slide distance is greater than half the width of the element.
                return absoluteDistance > _this._el.clientWidth / 2 || absoluteDistance > 20 && totalTime < 250;
            });
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this._multiTouchDetector.destroy();
        }
    }]);

    return SwipeDetector;
}();

module.exports = SwipeDetector;

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(483);


/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    /**
     * Calculates the angle for a given cartesian coordinate.
     * @method getPointAngle
     * @param  {Number} x - Point position on the X axis
     * @param  {Number} y - Point position on the Y axis
     * @return {Number} - Angle in degrees
     */
    getPointAngle: function getPointAngle(x, y) {
        var angle = Math.atan2(y, x) * (180 / Math.PI);

        if (angle < 0) {
            angle += 360;
        }

        return angle;
    },

    /**
     * Calculates the quadrant for a give angle.
     * @method getQuadrant
     * @param  {Number} angle - Angle in degrees from 0 to 360
     * @return {Number} - Quadrant from 0 to 3
     */
    getQuadrant: function getQuadrant(angle) {
        return Math.floor(angle / 90 % 4);
    }
};

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(71),
    noop = _require.noop;

var _require2 = __webpack_require__(362),
    getTouchDistance = _require2.getTouchDistance,
    touchToCoordinates = _require2.touchToCoordinates;

var MultiTouchDetector = __webpack_require__(273);

var _require3 = __webpack_require__(306),
    createEnum = _require3.createEnum;

/**
 * Grab relevant state data from the passed in event.
 * @param  {Object} e Event
 * @return {Object}   State data
 */


function stateFromTouch(e) {
    var changedTouches = e.changedTouches,
        target = e.target;


    return {
        time: Date.now(),
        position: touchToCoordinates(target, changedTouches[0])
    };
}

// Maximum pixel distance of second tap from first tap.
var THRESHOLD_DISTANCE = 30;
// Maximum time in ms of second tap from first tap.
var THRESHOLD_TIME = 500;
// Maximum time in ms that a touch will count as a tap.
var THRESHOLD_HOLD_TIME = 100;

// State machine for keeping track of how many valid taps have occurred.
var stateEnum = createEnum({
    // Initial state before any taps
    ready: function ready() {},
    // One successful tap
    first: function first(data) {
        return data;
    },
    // Two successful taps
    second: function second(data) {
        return data;
    }
});

/**
 * Detect two quick, sequential taps on the given DOM element.
 *
 * @param {Object} options.el The DOM element.
 * @param {Function} [options.onDoubleTap] Callback to fire after a successful double tap.
 */

var DoubleTapDetector = function () {
    function DoubleTapDetector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el,
            _ref$onDoubleTap = _ref.onDoubleTap,
            onDoubleTap = _ref$onDoubleTap === undefined ? noop : _ref$onDoubleTap;

        _classCallCheck(this, DoubleTapDetector);

        if (!el) {
            throw new Error('Must pass `el` to DoubleTapDetector');
        }

        Object.assign(this, {
            _el: el,
            _onDoubleTap: onDoubleTap,
            _multiTouchDetector: new MultiTouchDetector({
                onSingleTouchStart: this._onSingleTouchStart.bind(this),
                onSingleTouchEnd: this._onSingleTouchEnd.bind(this),
                el: el
            })
        });

        // Set the initial state
        this._resetState();
    }

    _createClass(DoubleTapDetector, [{
        key: '_onSingleTouchStart',
        value: function _onSingleTouchStart(e) {
            var _this = this;

            var data = stateFromTouch(e);

            // transition to the next state after a tap
            this._state.match({
                ready: function ready() {
                    _this._state = stateEnum.first(data);
                    return _this._state;
                },
                first: function first() {
                    _this._state = stateEnum.second(data);
                    return _this._state;
                }
                // No need to handle "second" state here
            });
        }
    }, {
        key: '_onSingleTouchEnd',
        value: function _onSingleTouchEnd(e) {
            var _this2 = this;

            var endData = stateFromTouch(e);

            // Attempt to transition to the next state if the tap passes validation
            this._state.match({
                // No need to handle "ready" state here
                first: function first(data) {
                    return _this2._tryNextState(endData, data, function (newData) {
                        return _this2._handleFirstTap(newData);
                    });
                },
                second: function second(data) {
                    return _this2._tryNextState(endData, data, function (newData) {
                        return _this2._handleSecondTap(newData);
                    });
                }
            });
        }
    }, {
        key: '_resetState',
        value: function _resetState() {
            if (this._timer) {
                clearTimeout(this._timer);
            }

            this._timer = null;
            this._initialPosition = null;
            this._state = stateEnum.ready();
        }

        /**
         * Validate a tap after it ends and call the passed in callback if it passes.
         * @param  {Object}   endData   Data from previous tap
         * @param  {Object}   newData     Data from current tap
         * @param  {Function} callback  Callback to fire on successfuly validation
         */

    }, {
        key: '_tryNextState',
        value: function _tryNextState(endData, _ref2, callback) {
            var time = _ref2.time,
                position = _ref2.position;

            // Criteria for a successful tap:
            // The touch must not have been held for longer than THRESHOLD_HOLD_TIME
            // The touch must not have moved farther than THRESHOLD_DISTANCE
            if (endData.time - time > THRESHOLD_HOLD_TIME || getTouchDistance(endData.position, position) > THRESHOLD_DISTANCE) {
                this._resetState();
            } else {
                callback(endData);
            }
        }
    }, {
        key: '_handleFirstTap',
        value: function _handleFirstTap(data) {
            var _this3 = this;

            // Create a timer that expires if a second tap does not happen before THRESHOLD_TIME
            this._initialPosition = data.position;
            this._timer = setTimeout(function () {
                // If the timer finishes then start over because we didn't get a second tap in time.
                _this3._resetState();
            }, THRESHOLD_TIME);
        }
    }, {
        key: '_handleSecondTap',
        value: function _handleSecondTap(data) {
            var position = data.position;

            // Check if the second tap was within THRESHOLD_DISTANCE of the first tap

            if (getTouchDistance(position, this._initialPosition) > THRESHOLD_DISTANCE) {
                this._resetState();
            } else {
                this._onDoubleTap(position.x, position.y);
            }
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            clearTimeout(this._timer);
            this._multiTouchDetector.destroy();
        }
    }]);

    return DoubleTapDetector;
}();

module.exports = DoubleTapDetector;

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(71),
    noop = _require.noop;

var MultiTouchDetector = __webpack_require__(273);

/**
 * Detect a "pan" (drag) on the given DOM element.
 * @param {Object} options.el The DOM element.
 * @param {Function} [options.onPan] Callback to fire on drag.
 */

var PanDetector = function () {
    function PanDetector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el,
            _ref$onPan = _ref.onPan,
            onPan = _ref$onPan === undefined ? noop : _ref$onPan;

        _classCallCheck(this, PanDetector);

        if (!el) {
            throw new Error('Must pass `el` to PanDetector');
        }

        Object.assign(this, {
            _previousX: null,
            _previousY: null,
            _el: el,
            _onPan: onPan,
            _multiTouchDetector: new MultiTouchDetector({
                onSingleTouchStart: this._onSingleTouchStart.bind(this),
                onSingleTouchMove: this._onSingleTouchMove.bind(this),
                el: el
            })
        });
    }

    _createClass(PanDetector, [{
        key: '_onSingleTouchStart',
        value: function _onSingleTouchStart(e) {
            var _e$touches$ = e.touches[0],
                clientX = _e$touches$.clientX,
                clientY = _e$touches$.clientY;

            // Get the initial position and time so we can do a difference on them later.

            this._previousX = clientX;
            this._previousY = clientY;
        }
    }, {
        key: '_onSingleTouchMove',
        value: function _onSingleTouchMove(e) {
            e.preventDefault();

            var _e$touches$2 = e.touches[0],
                clientX = _e$touches$2.clientX,
                clientY = _e$touches$2.clientY;

            // Pass the distance dragged to the callback

            this._onPan(clientX - this._previousX, clientY - this._previousY);

            this._previousX = clientX;
            this._previousY = clientY;
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this._multiTouchDetector.destroy();
        }
    }]);

    return PanDetector;
}();

module.exports = PanDetector;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(71),
    noop = _require.noop;

var _require2 = __webpack_require__(362),
    getTouchDistance = _require2.getTouchDistance,
    touchToCoordinates = _require2.touchToCoordinates;

var MultiTouchDetector = __webpack_require__(273);

function distanceFromTouches(e) {
    var target = e.target,
        touches = e.touches;


    return getTouchDistance(touchToCoordinates(target, touches[0]), touchToCoordinates(target, touches[1]));
}

/**
 * Detect a pinch on the given DOM element.
 * @param {Object} options.el The DOM element.
 * @param {Function} [options.onZoomIn] Callback to fire on zooming in.
 * @param {Function} [options.onZoomOut] Callback to fire on zooming out.
 */

var PinchDetector = function () {
    function PinchDetector() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            el = _ref.el,
            _ref$onZoomIn = _ref.onZoomIn,
            onZoomIn = _ref$onZoomIn === undefined ? noop : _ref$onZoomIn,
            _ref$onZoomOut = _ref.onZoomOut,
            onZoomOut = _ref$onZoomOut === undefined ? noop : _ref$onZoomOut;

        _classCallCheck(this, PinchDetector);

        if (!el) {
            throw new Error('Must pass `el` to PinchDetector');
        }

        Object.assign(this, {
            _previousDistance: null,
            _el: el,
            _onZoomIn: onZoomIn,
            _onZoomOut: onZoomOut,
            _multiTouchDetector: new MultiTouchDetector({
                onDoubleTouchStart: this._onDoubleTouchStart.bind(this),
                onDoubleTouchMove: this._onDoubleTouchMove.bind(this),
                el: el
            })
        });
    }

    _createClass(PinchDetector, [{
        key: '_onDoubleTouchStart',
        value: function _onDoubleTouchStart(e) {
            // Get the initial position and time so we can do a difference on them later.
            this._previousDistance = distanceFromTouches(e);
        }
    }, {
        key: '_onDoubleTouchMove',
        value: function _onDoubleTouchMove(e) {
            e.preventDefault();

            var distance = distanceFromTouches(e);
            var change = this._previousDistance - distance;
            var absChange = Math.abs(change);

            // Check if this is a zoom in or a zoom out based on the sign of the change and fire the appropriate callback.
            if (change < 0) {
                this._onZoomIn(absChange);
            } else {
                this._onZoomOut(absChange);
            }

            this._previousDistance = distance;
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            this._multiTouchDetector.destroy();
        }
    }]);

    return PinchDetector;
}();

module.exports = PinchDetector;

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  XmlEntities: __webpack_require__(479),
  Html4Entities: __webpack_require__(478),
  Html5Entities: __webpack_require__(363),
  AllHtmlEntities: __webpack_require__(363)
};


/***/ }),

/***/ 478:
/***/ (function(module, exports) {

var HTML_ALPHA = ['apos', 'nbsp', 'iexcl', 'cent', 'pound', 'curren', 'yen', 'brvbar', 'sect', 'uml', 'copy', 'ordf', 'laquo', 'not', 'shy', 'reg', 'macr', 'deg', 'plusmn', 'sup2', 'sup3', 'acute', 'micro', 'para', 'middot', 'cedil', 'sup1', 'ordm', 'raquo', 'frac14', 'frac12', 'frac34', 'iquest', 'Agrave', 'Aacute', 'Acirc', 'Atilde', 'Auml', 'Aring', 'Aelig', 'Ccedil', 'Egrave', 'Eacute', 'Ecirc', 'Euml', 'Igrave', 'Iacute', 'Icirc', 'Iuml', 'ETH', 'Ntilde', 'Ograve', 'Oacute', 'Ocirc', 'Otilde', 'Ouml', 'times', 'Oslash', 'Ugrave', 'Uacute', 'Ucirc', 'Uuml', 'Yacute', 'THORN', 'szlig', 'agrave', 'aacute', 'acirc', 'atilde', 'auml', 'aring', 'aelig', 'ccedil', 'egrave', 'eacute', 'ecirc', 'euml', 'igrave', 'iacute', 'icirc', 'iuml', 'eth', 'ntilde', 'ograve', 'oacute', 'ocirc', 'otilde', 'ouml', 'divide', 'Oslash', 'ugrave', 'uacute', 'ucirc', 'uuml', 'yacute', 'thorn', 'yuml', 'quot', 'amp', 'lt', 'gt', 'oelig', 'oelig', 'scaron', 'scaron', 'yuml', 'circ', 'tilde', 'ensp', 'emsp', 'thinsp', 'zwnj', 'zwj', 'lrm', 'rlm', 'ndash', 'mdash', 'lsquo', 'rsquo', 'sbquo', 'ldquo', 'rdquo', 'bdquo', 'dagger', 'dagger', 'permil', 'lsaquo', 'rsaquo', 'euro', 'fnof', 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'eta', 'theta', 'iota', 'kappa', 'lambda', 'mu', 'nu', 'xi', 'omicron', 'pi', 'rho', 'sigma', 'tau', 'upsilon', 'phi', 'chi', 'psi', 'omega', 'alpha', 'beta', 'gamma', 'delta', 'epsilon', 'zeta', 'eta', 'theta', 'iota', 'kappa', 'lambda', 'mu', 'nu', 'xi', 'omicron', 'pi', 'rho', 'sigmaf', 'sigma', 'tau', 'upsilon', 'phi', 'chi', 'psi', 'omega', 'thetasym', 'upsih', 'piv', 'bull', 'hellip', 'prime', 'prime', 'oline', 'frasl', 'weierp', 'image', 'real', 'trade', 'alefsym', 'larr', 'uarr', 'rarr', 'darr', 'harr', 'crarr', 'larr', 'uarr', 'rarr', 'darr', 'harr', 'forall', 'part', 'exist', 'empty', 'nabla', 'isin', 'notin', 'ni', 'prod', 'sum', 'minus', 'lowast', 'radic', 'prop', 'infin', 'ang', 'and', 'or', 'cap', 'cup', 'int', 'there4', 'sim', 'cong', 'asymp', 'ne', 'equiv', 'le', 'ge', 'sub', 'sup', 'nsub', 'sube', 'supe', 'oplus', 'otimes', 'perp', 'sdot', 'lceil', 'rceil', 'lfloor', 'rfloor', 'lang', 'rang', 'loz', 'spades', 'clubs', 'hearts', 'diams'];
var HTML_CODES = [39, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 34, 38, 60, 62, 338, 339, 352, 353, 376, 710, 732, 8194, 8195, 8201, 8204, 8205, 8206, 8207, 8211, 8212, 8216, 8217, 8218, 8220, 8221, 8222, 8224, 8225, 8240, 8249, 8250, 8364, 402, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 977, 978, 982, 8226, 8230, 8242, 8243, 8254, 8260, 8472, 8465, 8476, 8482, 8501, 8592, 8593, 8594, 8595, 8596, 8629, 8656, 8657, 8658, 8659, 8660, 8704, 8706, 8707, 8709, 8711, 8712, 8713, 8715, 8719, 8721, 8722, 8727, 8730, 8733, 8734, 8736, 8743, 8744, 8745, 8746, 8747, 8756, 8764, 8773, 8776, 8800, 8801, 8804, 8805, 8834, 8835, 8836, 8838, 8839, 8853, 8855, 8869, 8901, 8968, 8969, 8970, 8971, 9001, 9002, 9674, 9824, 9827, 9829, 9830];

var alphaIndex = {};
var numIndex = {};

var i = 0;
var length = HTML_ALPHA.length;
while (i < length) {
    var a = HTML_ALPHA[i];
    var c = HTML_CODES[i];
    alphaIndex[a] = String.fromCharCode(c);
    numIndex[c] = a;
    i++;
}

/**
 * @constructor
 */
function Html4Entities() {}

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.decode = function(str) {
    if (str.length === 0) {
        return '';
    }
    return str.replace(/&(#?[\w\d]+);?/g, function(s, entity) {
        var chr;
        if (entity.charAt(0) === "#") {
            var code = entity.charAt(1).toLowerCase() === 'x' ?
                parseInt(entity.substr(2), 16) :
                parseInt(entity.substr(1));

            if (!(isNaN(code) || code < -32768 || code > 65535)) {
                chr = String.fromCharCode(code);
            }
        } else {
            chr = alphaIndex[entity];
        }
        return chr || s;
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encode = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var alpha = numIndex[str.charCodeAt(i)];
        result += alpha ? "&" + alpha + ";" : str.charAt(i);
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encodeNonUTF = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var cc = str.charCodeAt(i);
        var alpha = numIndex[cc];
        if (alpha) {
            result += "&" + alpha + ";";
        } else if (cc < 32 || cc > 126) {
            result += "&#" + cc + ";";
        } else {
            result += str.charAt(i);
        }
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
Html4Entities.prototype.encodeNonASCII = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        if (c <= 255) {
            result += str[i++];
            continue;
        }
        result += '&#' + c + ';';
        i++;
    }
    return result;
};

module.exports = Html4Entities;


/***/ }),

/***/ 479:
/***/ (function(module, exports) {

var ALPHA_INDEX = {
    '&lt': '<',
    '&gt': '>',
    '&quot': '"',
    '&apos': '\'',
    '&amp': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': '\'',
    '&amp;': '&'
};

var CHAR_INDEX = {
    60: 'lt',
    62: 'gt',
    34: 'quot',
    39: 'apos',
    38: 'amp'
};

var CHAR_S_INDEX = {
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&apos;',
    '&': '&amp;'
};

/**
 * @constructor
 */
function XmlEntities() {}

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.encode = function(str) {
    if (str.length === 0) {
        return '';
    }
    return str.replace(/<|>|"|'|&/g, function(s) {
        return CHAR_S_INDEX[s];
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.decode = function(str) {
    if (str.length === 0) {
        return '';
    }
    return str.replace(/&#?[0-9a-zA-Z]+;?/g, function(s) {
        if (s.charAt(1) === '#') {
            var code = s.charAt(2).toLowerCase() === 'x' ?
                parseInt(s.substr(3), 16) :
                parseInt(s.substr(2));

            if (isNaN(code) || code < -32768 || code > 65535) {
                return '';
            }
            return String.fromCharCode(code);
        }
        return ALPHA_INDEX[s] || s;
    });
};

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.encodeNonUTF = function(str) {
    var strLength = str.length;
    if (strLength === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLength) {
        var c = str.charCodeAt(i);
        var alpha = CHAR_INDEX[c];
        if (alpha) {
            result += "&" + alpha + ";";
            i++;
            continue;
        }
        if (c < 32 || c > 126) {
            result += '&#' + c + ';';
        } else {
            result += str.charAt(i);
        }
        i++;
    }
    return result;
};

/**
 * @param {String} str
 * @returns {String}
 */
XmlEntities.prototype.encodeNonASCII = function(str) {
    var strLenght = str.length;
    if (strLenght === 0) {
        return '';
    }
    var result = '';
    var i = 0;
    while (i < strLenght) {
        var c = str.charCodeAt(i);
        if (c <= 255) {
            result += str[i++];
            continue;
        }
        result += '&#' + c + ';';
        i++;
    }
    return result;
};

module.exports = XmlEntities;


/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

var htmlparser = __webpack_require__(271);
var extend = __webpack_require__(446);
var quoteRegexp = __webpack_require__(438);

function each(obj, cb) {
  if (obj) Object.keys(obj).forEach(function (key) {
    cb(obj[key], key);
  });
}

// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function has(obj, key) {
  return ({}).hasOwnProperty.call(obj, key);
}

module.exports = sanitizeHtml;

// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105

function sanitizeHtml(html, options, _recursing) {
  var result = '';

  function Frame(tag, attribs) {
    var that = this;
    this.tag = tag;
    this.attribs = attribs || {};
    this.tagPosition = result.length;
    this.text = ''; // Node inner text

    this.updateParentNodeText = function() {
      if (stack.length) {
          var parentFrame = stack[stack.length - 1];
          parentFrame.text += that.text;
      }
    };
  }

  if (!options) {
    options = sanitizeHtml.defaults;
    options.parser = htmlParserDefaults;
  } else {
    options = extend(sanitizeHtml.defaults, options);
    if (options.parser) {
      options.parser = extend(htmlParserDefaults, options.parser);
    } else {
      options.parser = htmlParserDefaults;
    }
  }

  // Tags that contain something other than HTML, or where discarding
  // the text when the tag is disallowed makes sense for other reasons.
  // If we are not allowing these tags, we should drop their content too.
  // For other tags you would drop the tag but keep its content.
  var nonTextTagsArray = options.nonTextTags || [ 'script', 'style', 'textarea' ];
  var allowedAttributesMap;
  var allowedAttributesGlobMap;
  if(options.allowedAttributes) {
    allowedAttributesMap = {};
    allowedAttributesGlobMap = {};
    each(options.allowedAttributes, function(attributes, tag) {
      allowedAttributesMap[tag] = [];
      var globRegex = [];
      attributes.forEach(function(name) {
        if(name.indexOf('*') >= 0) {
          globRegex.push(quoteRegexp(name).replace(/\\\*/g, '.*'));
        } else {
          allowedAttributesMap[tag].push(name);
        }
      });
      allowedAttributesGlobMap[tag] = new RegExp('^(' + globRegex.join('|') + ')$');
    });
  }
  var allowedClassesMap = {};
  each(options.allowedClasses, function(classes, tag) {
    // Implicitly allows the class attribute
    if(allowedAttributesMap) {
      if (!has(allowedAttributesMap, tag)) {
        allowedAttributesMap[tag] = [];
      }
      allowedAttributesMap[tag].push('class');
    }

    allowedClassesMap[tag] = classes;
  });

  var transformTagsMap = {};
  var transformTagsAll;
  each(options.transformTags, function(transform, tag) {
    var transFun;
    if (typeof transform === 'function') {
      transFun = transform;
    } else if (typeof transform === "string") {
      transFun = sanitizeHtml.simpleTransform(transform);
    }
    if (tag === '*') {
      transformTagsAll = transFun;
    } else {
      transformTagsMap[tag] = transFun;
    }
  });

  var depth = 0;
  var stack = [];
  var skipMap = {};
  var transformMap = {};
  var skipText = false;
  var skipTextDepth = 0;

  var parser = new htmlparser.Parser({
    onopentag: function(name, attribs) {
      if (skipText) {
        skipTextDepth++;
        return;
      }
      var frame = new Frame(name, attribs);
      stack.push(frame);

      var skip = false;
      var transformedTag;
      if (has(transformTagsMap, name)) {
        transformedTag = transformTagsMap[name](name, attribs);

        frame.attribs = attribs = transformedTag.attribs;

        if (transformedTag.text !== undefined) {
          frame.innerText = transformedTag.text;
        }

        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }
      if (transformTagsAll) {
        transformedTag = transformTagsAll(name, attribs);

        frame.attribs = attribs = transformedTag.attribs;
        if (name !== transformedTag.tagName) {
          frame.name = name = transformedTag.tagName;
          transformMap[depth] = transformedTag.tagName;
        }
      }

      if (options.allowedTags && options.allowedTags.indexOf(name) === -1) {
        skip = true;
        if (nonTextTagsArray.indexOf(name) !== -1) {
          skipText = true;
          skipTextDepth = 1;
        }
        skipMap[depth] = true;
      }
      depth++;
      if (skip) {
        // We want the contents but not this tag
        return;
      }
      result += '<' + name;
      if (!allowedAttributesMap || has(allowedAttributesMap, name) || allowedAttributesMap['*']) {
        each(attribs, function(value, a) {
          if (!allowedAttributesMap ||
              (has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 ) ||
              (allowedAttributesMap['*'] && allowedAttributesMap['*'].indexOf(a) !== -1 ) ||
              (has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a)) ||
              (allowedAttributesGlobMap['*'] && allowedAttributesGlobMap['*'].test(a))) {
            if ((a === 'href') || (a === 'src')) {
              if (naughtyHref(name, value)) {
                delete frame.attribs[a];
                return;
              }
            }
            if (a === 'class') {
              value = filterClasses(value, allowedClassesMap[name]);
              if (!value.length) {
                delete frame.attribs[a];
                return;
              }
            }
            result += ' ' + a;
            if (value.length) {
              result += '="' + escapeHtml(value) + '"';
            }
          } else {
            delete frame.attribs[a];
          }
        });
      }
      if (options.selfClosing.indexOf(name) !== -1) {
        result += " />";
      } else {
        result += ">";
      }
    },
    ontext: function(text) {
      if (skipText) {
        return;
      }
      var lastFrame = stack[stack.length-1];
      var tag;

      if (lastFrame) {
        tag = lastFrame.tag;
        // If inner text was set by transform function then let's use it
        text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
      }

      if ((tag === 'script') || (tag === 'style')) {
        // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
        // script tags is, by definition, game over for XSS protection, so if that's
        // your concern, don't allow them. The same is essentially true for style tags
        // which have their own collection of XSS vectors.
        result += text;
      } else {
        var escaped = escapeHtml(text);
        if (options.textFilter) {
          result += options.textFilter(escaped);
        } else {
          result += escaped;
        }
      }
      if (stack.length) {
           var frame = stack[stack.length - 1];
           frame.text += text;
      }
    },
    onclosetag: function(name) {

      if (skipText) {
        skipTextDepth--;
        if (!skipTextDepth) {
          skipText = false;
        } else {
          return;
        }
      }

      var frame = stack.pop();
      if (!frame) {
        // Do not crash on bad markup
        return;
      }
      skipText = false;
      depth--;
      if (skipMap[depth]) {
        delete skipMap[depth];
        frame.updateParentNodeText();
        return;
      }

      if (transformMap[depth]) {
        name = transformMap[depth];
        delete transformMap[depth];
      }

      if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
         result = result.substr(0, frame.tagPosition);
         return;
      }

      frame.updateParentNodeText();

      if (options.selfClosing.indexOf(name) !== -1) {
         // Already output />
         return;
      }

      result += "</" + name + ">";
    }
  }, options.parser);
  parser.write(html);
  parser.end();

  return result;

  function escapeHtml(s) {
    if (typeof(s) !== 'string') {
      s = s + '';
    }
    return s.replace(/\&/g, '&amp;').replace(/</g, '&lt;').replace(/\>/g, '&gt;').replace(/\"/g, '&quot;');
  }

  function naughtyHref(name, href) {
    // Browsers ignore character codes of 32 (space) and below in a surprising
    // number of situations. Start reading here:
    // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
    href = href.replace(/[\x00-\x20]+/g, '');
    // Clobber any comments in URLs, which the browser might
    // interpret inside an XML data island, allowing
    // a javascript: URL to be snuck through
    href = href.replace(/<\!\-\-.*?\-\-\>/g, '');
    // Case insensitive so we don't get faked out by JAVASCRIPT #1
    var matches = href.match(/^([a-zA-Z]+)\:/);
    if (!matches) {
      // No scheme = no way to inject js (right?)
      return false;
    }
    var scheme = matches[1].toLowerCase();

    if (has(options.allowedSchemesByTag, name)) {
      return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
    }

    return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
  }

  function filterClasses(classes, allowed) {
    if (!allowed) {
      // The class attribute is allowed without filtering on this tag
      return classes;
    }
    classes = classes.split(/\s+/);
    return classes.filter(function(clss) {
      return allowed.indexOf(clss) !== -1;
    }).join(' ');
  }
}

// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish

var htmlParserDefaults = {
  decodeEntities: true
};
sanitizeHtml.defaults = {
  allowedTags: [ 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
    'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
    'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre' ],
  allowedAttributes: {
    a: [ 'href', 'name', 'target' ],
    // We don't currently allow img itself by default, but this
    // would make sense if we did
    img: [ 'src' ]
  },
  // Lots of these won't come up by default because we don't allow them
  selfClosing: [ 'img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta' ],
  // URL schemes we permit
  allowedSchemes: [ 'http', 'https', 'ftp', 'mailto' ],
  allowedSchemesByTag: {}
};

sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
  merge = (merge === undefined) ? true : merge;
  newAttribs = newAttribs || {};

  return function(tagName, attribs) {
    var attrib;
    if (merge) {
      for (attrib in newAttribs) {
        attribs[attrib] = newAttribs[attrib];
      }
    } else {
      attribs = newAttribs;
    }

    return {
      tagName: newTagName,
      attribs: attribs
    };
  };
};


/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encode = __webpack_require__(364);
var alphabet = __webpack_require__(287);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {

    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + encode(alphabet.lookup, version);
    str = str + encode(alphabet.lookup, clusterWorkerId);
    if (counter > 0) {
        str = str + encode(alphabet.lookup, counter);
    }
    str = str + encode(alphabet.lookup, seconds);

    return str;
}

module.exports = build;


/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(287);

/**
 * Decode the id to get the version and worker
 * Mainly for debugging and testing.
 * @param id - the shortid-generated id.
 */
function decode(id) {
    var characters = alphabet.shuffled();
    return {
        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
    };
}

module.exports = decode;


/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(287);
var encode = __webpack_require__(364);
var decode = __webpack_require__(482);
var build = __webpack_require__(481);
var isValid = __webpack_require__(484);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(487) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.decode = decode;
module.exports.isValid = isValid;


/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(287);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var characters = alphabet.characters();
    var len = id.length;
    for(var i = 0; i < len;i++) {
        if (characters.indexOf(id[i]) === -1) {
            return false;
        }
    }
    return true;
}

module.exports = isShortId;


/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

function randomByte() {
    if (!crypto || !crypto.getRandomValues) {
        return Math.floor(Math.random() * 256) & 0x30;
    }
    var dest = new Uint8Array(1);
    crypto.getRandomValues(dest);
    return dest[0] & 0x30;
}

module.exports = randomByte;


/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// globalDataLogger is for dumping forensic data to rollbar when something bad happens

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var clone = __webpack_require__(126);
var log = __webpack_require__(296);
var logger = module.exports = {
    reset: function reset() {
        logger._eventLog = [];
    },
    event: function event(obj) {
        logger._eventLog = logger._eventLog || [];
        if ('object' === (typeof obj === 'undefined' ? 'undefined' : _typeof(obj))) {
            obj = clone(obj);
        }
        logger._eventLog.push(obj);
    },
    stringify: function stringify() {
        return window.JSON.stringify(logger._eventLog);
    },
    flush: function flush() {
        if (0 === logger._eventLog.length) {
            return;
        }
        log.remote.error(window.JSON.stringify(logger._eventLog));
        logger.reset();
    }
};

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


module.exports = __webpack_require__(145);


/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var _ = __webpack_require__(0);
var SoaModel = __webpack_require__(2);
var Action = SoaModel.extend();

_.extend(Action.prototype, {
    isCode : function (code) {
        return this.get('code') === code;
    }
});


//constants
_.extend(Action, {
    CODE_ADMIN_APPROVES_AUTH_REVIEW: "ADMIN_APPROVES_AUTH_REVIEW",
    CODE_ADMIN_PROVIDES_FIRSTDIBS_QUOTE: "ADMIN_PROVIDES_FIRSTDIBS_QUOTE",
    CODE_ADMIN_PROVIDE_ACCOUNTING_QUOTE: "ADMIN_PROVIDE_ACCOUNTING_QUOTE",
    CODE_ADMIN_MARK_SHIPPED: "ADMIN_MARK_SHIPPED",
    CODE_ADMIN_MARK_DELIVERED: "ADMIN_MARK_DELIVERED",
    CODE_ADMIN_CORRECT_SHIPPING: "ADMIN_CORRECT_SHIPPING",
    CODE_ADMIN_WIRE_TRANSFER_DETAILS: "ADMIN_WIRE_TRANSFER_DETAILS",
    CODE_ADMIN_WIRE_TRANSFER_CAPTURE: "ADMIN_WIRE_TRANSFER_CAPTURE",
    CODE_ADMIN_CHECK_DETAILS: "ADMIN_CHECK_DETAILS",
    CODE_ADMIN_CHECK_CAPTURE: "ADMIN_CHECK_CAPTURE",
    CODE_ADMIN_MANUAL_CAPTURE: "ADMIN_MANUAL_CAPTURE",
    CODE_ADMIN_REFUND_CAPTURE: "ADMIN_REFUND_CAPTURE",
    CODE_ADMIN_MODIFY_SHIPMENT_QUOTE: "ADMIN_MODIFY_SHIPMENT_QUOTE",
    CODE_ADMIN_MODIFY_ORDER: "ADMIN_MODIFY_ORDER",
    CODE_ADMIN_ADD_BUYER_PMT_AUTH: "ADMIN_ADD_BUYER_PMT_AUTH",
    CODE_ADMIN_ADD_DEALER_PMT_AUTH: "ADMIN_ADD_DEALER_PMT_AUTH",
    CODE_ADMIN_BUYER_REAUTH_PMT: "BUYER_REAUTH_PMT",

    CODE_DEALER_COUNTER_OFFER_PRE_CHECKOUT: "DEALER_COUNTER_OFFER_PRE_CHECKOUT",
    CODE_DEALER_ACCEPT_OFFER_PRE_CHECKOUT: "DEALER_ACCEPT_OFFER_PRE_CHECKOUT",
    CODE_DEALER_AMEND_OFFER_PRE_CHECKOUT: "DEALER_AMEND_OFFER_PRE_CHECKOUT",

    CODE_DEALER_MARK_ITEM_NOT_AVAILABLE: "DEALER_MARK_ITEM_NOT_AVAILABLE",
    CODE_DEALER_REQUEST_FIRSTDIBS_QUOTE: "DEALER_REQUEST_FIRSTDIBS_QUOTE",
    CODE_DEALER_PROVIDE_QUOTE: "DEALER_PROVIDE_QUOTE",
    CODE_DEALER_REVIEW_FIRSTDIBS_QUOTE: "DEALER_REVIEW_FIRSTDIBS_QUOTE",
    CODE_DEALER_ACCEPT_OFFER: "DEALER_ACCEPT_OFFER",
    CODE_DEALER_COUNTER_OFFER: "DEALER_COUNTER_OFFER",
    CODE_DEALER_MARK_SHIPPED: "DEALER_MARK_SHIPPED",
    CODE_DEALER_MARK_READY_FOR_PICKUP: "DEALER_MARK_READY_FOR_PICKUP",

    // will be removed when N2.0 is released
    CODE_BUYER_CHECKOUT_OFFER: "BUYER_CHECKOUT_OFFER",

    CODE_BUYER_ACCEPT_OFFER: "BUYER_ACCEPT_OFFER",
    CODE_BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER: "BUYER_CHECKOUT_SUBMITTED_DEALER_OFFER",
    CODE_BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER: "BUYER_CHECKOUT_ACCEPTED_BUYER_OFFER",
    CODE_BUYER_PASS_OFFER_PRE_CHECKOUT: "BUYER_PASS_OFFER_PRE_CHECKOUT",
    CODE_BUYER_COUNTER_OFFER_PRE_CHECKOUT: "BUYER_COUNTER_OFFER_PRE_CHECKOUT",
    CODE_BUYER_NOT_INTERESTED_OFFER_PRE_CHECKOUT: "BUYER_NOT_INTERESTED_OFFER_PRE_CHECKOUT",
    CODE_BUYER_COUNTER_OFFER: "BUYER_COUNTER_OFFER",
    CODE_BUYER_BALANCE_DUE: "BUYER_BALANCE_DUE",
    CODE_BUYER_MARK_SHIPPED: "BUYER_MARK_SHIPPED",
    CODE_BUYER_SUBMIT_INVOICE: "BUYER_SUBMIT_INVOICE"
});

module.exports = Action;


/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(548);



/***/ }),

/***/ 517:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dotControls":"arrowStyles__dotControls__16md7","dotWrapper":"arrowStyles__dotWrapper__3Of_L","dot":"arrowStyles__dot__3EdFv","current":"arrowStyles__current__1a1Fl","buyer":"arrowStyles__buyer__1YKvO","trade":"arrowStyles__trade__1nWCr","dotCarouselWrapper":"arrowStyles__dotCarouselWrapper__62_SD","clear":"arrowStyles__clear__39TNC"};

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classnames = __webpack_require__(16);
var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var inViewport = __webpack_require__(640);
var scrollIntoView = __webpack_require__(598);
var SanitizeHtml = __webpack_require__(301);
var ContextComponent = __webpack_require__(61);
var ArrowRightIcon = __webpack_require__(356);
var style = __webpack_require__(675);

var Tooltip = __webpack_require__(275);
__webpack_require__(276);

var tradeTourActions = __webpack_require__(753);

var Tour = function (_ContextComponent) {
    _inherits(Tour, _ContextComponent);

    function Tour(props) {
        _classCallCheck(this, Tour);

        var _this = _possibleConstructorReturn(this, (Tour.__proto__ || Object.getPrototypeOf(Tour)).call(this, props));

        _this.onClose = _this.onClose.bind(_this);
        _this.onCtaClick = _this.onCtaClick.bind(_this);

        var isOpen = props.isTourOpen && props.step === props.currentStep;

        _this.state = {
            isOpen: isOpen,
            isVisible: isOpen
        };
        return _this;
    }

    _createClass(Tour, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var isOpen = this.state.isOpen;


            if (isOpen) {
                this.onOpen();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var step = nextProps.step,
                currentStep = nextProps.currentStep,
                isTourOpen = nextProps.isTourOpen;


            if (isTourOpen && step === currentStep) {
                this.setState({ isOpen: true });
                this._showTour();
            } else {
                this.setState({ isVisible: false });
                this._closeTour();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!prevState.isOpen && this.state.isOpen) {
                this.onOpen();
            }
        }
    }, {
        key: 'onOpen',
        value: function onOpen() {
            var _props = this.props,
                type = _props.type,
                subType = _props.subType,
                step = _props.step,
                onOpen = _props.onOpen;

            onOpen({ type: type, subType: subType, step: step });
        }
    }, {
        key: '_notInView',
        value: function _notInView() {
            return this._tourStep && !inViewport(this._tourStep);
        }
    }, {
        key: '_showTour',
        value: function _showTour() {
            var _this2 = this;

            var duration = this.props.duration;

            var timeout = 0;

            if (this._notInView()) {
                scrollIntoView(this._tourStep, { time: duration });
                timeout = duration;
            }

            this._clearTimeouts();
            this._timeout = setTimeout(function () {
                return _this2.setState({ isVisible: true });
            }, timeout);
        }
    }, {
        key: '_closeTour',
        value: function _closeTour() {
            var _this3 = this;

            var duration = this.props.duration;

            this._clearTimeouts();
            this._timeout = setTimeout(function () {
                return _this3.setState({ isOpen: false });
            }, duration ? 200 : 0);
        }
    }, {
        key: '_clearTimeouts',
        value: function _clearTimeouts() {
            clearTimeout(this._timeout);
        }
    }, {
        key: 'onClose',
        value: function onClose(event) {
            event.preventDefault();
            var _props2 = this.props,
                type = _props2.type,
                subType = _props2.subType,
                step = _props2.step,
                onClose = _props2.onClose;

            this.context.executeAction(tradeTourActions.closeTour, { type: type });
            onClose({ type: type, subType: subType, step: step });
        }
    }, {
        key: 'onCtaClick',
        value: function onCtaClick(event) {
            event.preventDefault();

            var _props3 = this.props,
                type = _props3.type,
                subType = _props3.subType,
                step = _props3.step,
                totalSteps = _props3.totalSteps,
                onCtaClick = _props3.onCtaClick;

            var action = void 0;

            if (step === totalSteps) {
                action = tradeTourActions.closeTour;
            } else {
                action = tradeTourActions.increaseStep;
            }

            this.context.executeAction(action, { type: type });
            onCtaClick({ type: type, subType: subType, step: step });
        }
    }, {
        key: 'getSvgArrow',
        value: function getSvgArrow(hasNext) {
            if (hasNext) {
                return React.createElement(ArrowRightIcon, { className: 'button-icon' });
            }

            return null;
        }
    }, {
        key: 'getCancel',
        value: function getCancel(copy) {
            if (copy.cancel) {
                return React.createElement(
                    'a',
                    { className: style.cancel, onClick: this.onClose, href: '#0' },
                    copy.cancel
                );
            }

            return null;
        }
    }, {
        key: 'getCopy',
        value: function getCopy() {
            var _props4 = this.props,
                step = _props4.step,
                copy = _props4.copy,
                subType = _props4.subType;

            var stepCopy = copy['step' + step];

            return stepCopy && stepCopy[subType] || stepCopy || {};
        }
    }, {
        key: 'getHeader',
        value: function getHeader(copy) {
            if (copy.header) {
                return React.createElement(
                    'div',
                    { className: style.header },
                    React.createElement(SanitizeHtml, { content: copy.header })
                );
            }

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _state = this.state,
                isOpen = _state.isOpen,
                isVisible = _state.isVisible;
            var _props5 = this.props,
                step = _props5.step,
                totalSteps = _props5.totalSteps,
                className = _props5.className,
                duration = _props5.duration,
                type = _props5.type,
                dataTn = _props5.dataTn;

            var copy = this.getCopy();
            var hasNext = step < totalSteps;
            var ctaClassName = classnames('button-primary button-small', style.cta, {
                'has-icon-right': hasNext
            });
            var tooltipClassName = classnames(style.tooltip, _defineProperty({}, style.visible, isVisible));

            var ctaWrapperClass = classnames(style.ctaWrapper, _defineProperty({}, style.hasCancel, copy.cancel));

            return React.createElement(
                'span',
                {
                    ref: function ref(tourStep) {
                        _this4._tourStep = tourStep;
                    },
                    className: style.wrapper + ' ' + className,
                    'data-tn': 'tour-' + dataTn
                },
                this.props.children,
                React.createElement(
                    Tooltip,
                    {
                        isVisible: isOpen,
                        'data-tn': 'tour-tooltip-' + type,
                        className: tooltipClassName,
                        containerClass: style.container,
                        tooltipDirection: 'left',
                        hasClose: true,
                        debounce: this._notInView() ? duration : 0,
                        closeClass: style.close,
                        onCloseClick: this.onClose
                    },
                    this.getHeader(copy),
                    React.createElement(
                        'div',
                        { className: style.step },
                        React.createElement(SanitizeHtml, { content: copy.step })
                    ),
                    React.createElement(
                        'div',
                        { className: style.content },
                        React.createElement(SanitizeHtml, { content: copy.content })
                    ),
                    React.createElement(
                        'div',
                        { className: ctaWrapperClass },
                        this.getCancel(copy),
                        React.createElement(
                            'a',
                            { className: ctaClassName, onClick: this.onCtaClick, href: '#0' },
                            copy.cta,
                            this.getSvgArrow(hasNext)
                        )
                    )
                )
            );
        }
    }]);

    return Tour;
}(ContextComponent);

Tour.propTypes = {
    copy: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    step: PropTypes.number.isRequired,
    isTourOpen: PropTypes.bool.isRequired,
    currentStep: PropTypes.number.isRequired,
    totalSteps: PropTypes.number.isRequired,
    duration: PropTypes.number,

    className: PropTypes.string,
    children: PropTypes.node,

    dataTn: PropTypes.string.isRequired,

    onCtaClick: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

Tour.defaultProps = {
    className: '',
    duration: 1000,
    onCtaClick: function onCtaClick() {},
    onOpen: function onOpen() {},
    onClose: function onClose() {}
};

module.exports = Tour;

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(47)))

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tracking = __webpack_require__(27);
var SV = __webpack_require__(18);
var get = __webpack_require__(14);

function getSVTrackingData(query, subType) {
    return SV.get(query + '.' + subType) || SV.get(query);
}

function track(_ref) {
    var type = _ref.type,
        subType = _ref.subType,
        step = _ref.step,
        trackAction = _ref.action;

    var _ref2 = getSVTrackingData('tourCopy.' + type + '.tracking', subType) || {},
        category = _ref2.category,
        action = _ref2.action;

    var label = get(getSVTrackingData('tourCopy.' + type + '.step' + step, subType), 'tracking.' + trackAction);

    if (category && action && label) {
        tracking.trackEvent({ category: category, action: action, label: label });
    }
}

var tourTracking = {
    trackOpen: function trackOpen(payload) {
        var action = 'open';
        track(Object.assign({ action: action }, payload));
    },
    trackClose: function trackClose(payload) {
        var action = 'close';
        track(Object.assign({ action: action }, payload));
    },
    trackCta: function trackCta(payload) {
        var action = 'cta';
        track(Object.assign({ action: action }, payload));
    },
    trackComplete: function trackComplete(payload) {
        var action = 'complete';
        track(Object.assign({ action: action }, payload));
    }
};

module.exports = tourTracking;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PortfolioItemModel = __webpack_require__(295);
var endpoints = __webpack_require__(6);

module.exports = PortfolioItemModel.extend({

    url: function () {
        return endpoints.cartPortfolioAddItem(this.get('item.id'));
    },

    defaults: {
        loggedOut: false,
        createdDate: '',
        item: {}
    }

});



/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-arrow-up'].join(' '), 'data-tn': 'arrow-up', viewBox: '0 -8.5 32 32' },
                React.createElement('path', { d: 'M0,14c0-0.3,0.1-0.6,0.3-0.8l15-13c0.4-0.3,0.9-0.3,1.3,0l15,13c0.4,0.4,0.5,1,0.1,1.4 c-0.4,0.4-1,0.5-1.4,0.1L16,2.3L1.7,14.7c-0.4,0.4-1,0.3-1.4-0.1C0.1,14.4,0,14.2,0,14z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org 

var _ = __webpack_require__(154);

// Helpers
// -------

// Helper function to correctly set up the prototype chain, for subclasses.
// Similar to `goog.inherits`, but uses a hash of prototype properties and
// class properties to be extended.
var extend = module.exports.extend = function(protoProps, staticProps) {

  var parent = this;
  var child;

  // The constructor function for the new subclass is either defined by you
  // (the "constructor" property in your `extend` definition), or defaulted
  // by us to simply call the parent's constructor.
  if (protoProps && _.has(protoProps, 'constructor')) {
    child = protoProps.constructor;
  } else {
    child = function(){ return parent.apply(this, arguments); };
  }

  // Add static properties to the constructor function, if supplied.
  _.extend(child, parent, staticProps);

  // Set the prototype chain to inherit from `parent`, without calling
  // `parent`'s constructor function.
  var Surrogate = function(){ this.constructor = child; };
  Surrogate.prototype = parent.prototype;
  child.prototype = new Surrogate();

  // Add prototype properties (instance properties) to the subclass,
  // if supplied.
  if (protoProps) _.extend(child.prototype, protoProps);

  // Set a convenience property in case the parent's prototype is needed
  // later.
  child.__super__ = parent.prototype;

  return child;

};

var urlError = module.exports.urlError = function() {
  throw new Error('A "url" property or function must be specified');
};

// Wrap an optional error callback with a fallback error event.
var wrapError = module.exports.wrapError = function (model, options) {
  var error = options.error;
  options.error = function(resp) {
    if (error) error(model, resp, options);
    model.trigger('error', model, resp, options);
  };
};

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(400),
    SwipeDetector = _require.SwipeDetector;

var BaseModel = __webpack_require__(339);

var _require2 = __webpack_require__(345),
    setTransformStyle = _require2.setTransformStyle,
    setTransitionStyle = _require2.setTransitionStyle,
    getTotalPages = _require2.getTotalPages,
    getPagedItemWidth = _require2.getPagedItemWidth,
    pageChangeTypeEnum = _require2.pageChangeTypeEnum,
    setWidthStyle = _require2.setWidthStyle;

var _require3 = __webpack_require__(71),
    noop = _require3.noop;

// The transition effect to use when the swipe occurs.


var TRANSITION = 'transform 250ms ease';
// The amount to slow down the dragging effect by when the user reaches the end of the list.
var SLOW_DOWN_FACTOR = 2.5;

function normalizePage(page, totalPages) {
    // If the requested page is less than 0, only go to the first page.
    if (page < 0) {
        page = 0;
    }

    // If the requested page is greater than the last page, only go to the last page.
    if (page >= totalPages) {
        page = totalPages - 1;
    }

    return page;
}

/**
 * View-model for carousels that are swiped through on a touch device.
 * @class
 */

var SwipeModel = function (_BaseModel) {
    _inherits(SwipeModel, _BaseModel);

    function SwipeModel() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            itemsPerPage = _ref.itemsPerPage,
            itemWidth = _ref.itemWidth,
            itemCount = _ref.itemCount,
            isCentered = _ref.isCentered,
            _ref$onPageChange = _ref.onPageChange,
            onPageChange = _ref$onPageChange === undefined ? noop : _ref$onPageChange,
            _ref$startingPage = _ref.startingPage,
            startingPage = _ref$startingPage === undefined ? 0 : _ref$startingPage,
            onStateChange = _ref.onStateChange;

        _classCallCheck(this, SwipeModel);

        var _this = _possibleConstructorReturn(this, (SwipeModel.__proto__ || Object.getPrototypeOf(SwipeModel)).call(this, { onStateChange: onStateChange }));

        var totalPages = getTotalPages(itemCount, itemsPerPage);

        Object.assign(_this, {
            _itemsPerPage: itemsPerPage,
            _itemCount: itemCount,
            _totalPages: totalPages,
            _onPageChange: onPageChange,
            _isCentered: isCentered,
            // Calculate the width of each item.
            _width: itemWidth || getPagedItemWidth(itemsPerPage),
            _swipeDetector: null,
            _state: {
                page: normalizePage(startingPage, totalPages),
                // Track the position of the items when dragging through the list.
                offset: 0,
                // Track whether we should use the transition effect during a given render.
                transition: true,
                disabled: false
            }
        });
        return _this;
    }

    _createClass(SwipeModel, [{
        key: 'enableSwipe',
        value: function enableSwipe() {
            this._state.disabled = false;
        }
    }, {
        key: 'disableSwipe',
        value: function disableSwipe() {
            this._state.disabled = true;
        }

        /**
         * Implement the `_afterMount` method from the `BaseModel`.
         */

    }, {
        key: '_afterMount',
        value: function _afterMount() {
            // Add swipe handlers.
            this._swipeDetector = new SwipeDetector({
                onPartialSwipe: this._updateOffset.bind(this),
                onSwipeSuccess: this._swipe.bind(this),
                onSwipeFailure: this._resetOffset.bind(this),
                el: this._el
            });
        }

        /**
         * Implement the `destroy` method from the `BaseModel`.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            // The swipe detector adds event listeners so we need to destroy it to prevent memory leaks.
            this._swipeDetector.destroy();
        }

        /**
         * The `_offset` is used to track the "panning" that happens when the user drags the carousel before the full swipe occurs
         *
         * @returns {object}
         */

    }, {
        key: '_getTransformValue',
        value: function _getTransformValue() {
            var fullContainerWidth = 100; // 100% - swipe carousel uses percentages for animations
            var percentage = -this._width * Math.floor(this._itemsPerPage) * this._state.page;

            // isCentered determines whether the carousel items are centered or aligned left
            // when itemWidth prop is set to less than 100
            if (this._isCentered) {
                percentage += (fullContainerWidth - this._width) / 2;
            }

            // Last page
            if (this._isLastPage() && this._itemsPerPage !== 1) {
                percentage = -this._width * this._itemCount + fullContainerWidth;
            }

            return percentage + '% + ' + this._state.offset + 'px';
        }

        /**
         * Implement the `transformListStyle` method from the `BaseModel`.
         */

    }, {
        key: 'transformListStyle',
        value: function transformListStyle(style) {
            var transformValue = this._getTransformValue();

            setTransformStyle(style, 'translateX(calc(' + transformValue + '))');

            // When the user is just "panning" we don't want to have a transition effect.
            if (this._state.transition) {
                setTransitionStyle(style, TRANSITION);
            }
        }

        /**
         * Implement the `transformItemStyle` method from the `BaseModel`.
         */

    }, {
        key: 'transformItemStyle',
        value: function transformItemStyle(style) {
            setWidthStyle(style, this._width);
        }

        /**
         * Update the position of the carousels in response to "drag/pan" by the user.
         * @param {Array} touchCords Array consisting of the touch coordinates [x, y], passed from the `SwipeDetector`.
         * @param {SwipeDirectionType} direction The swipe direction.
         */

    }, {
        key: '_updateOffset',
        value: function _updateOffset(touchCords, direction) {
            // We don't wanna move the carousel when the user is swiping vertically
            if (this._state.disabled || direction.isUp() || direction.isDown()) {
                return;
            }

            var xOffset = touchCords[0];

            if (this._isLastPage() && direction.isLeft() || this._isFirstPage() && direction.isRight()) {
                // If we've reached either end of the list, slow down the dragging effect to indicate to the user that they
                // can't continue.
                xOffset = xOffset / SLOW_DOWN_FACTOR;
            }

            this._state.transition = false;
            this._state.offset = xOffset;
            this._onStateChange();
        }

        /**
         * Call in response to a complete swipe.
         * @param  {SwipeDirectionType} direction The swipe direction.
         */

    }, {
        key: '_swipe',
        value: function _swipe(direction) {
            if (this._state.disabled) {
                return;
            }

            if (direction.isLeft()) {
                this._nextPage();
            } else if (direction.isRight()) {
                this._previousPage();
            }
        }

        /**
         * Unset the "drag" offset and go back to the initial page position.
         */

    }, {
        key: '_resetOffset',
        value: function _resetOffset() {
            if (this._state.disabled) {
                return;
            }

            this._state.transition = true;
            this._state.offset = 0;

            this._updateState();
        }

        /**
         * Set the new page. Handles bounds issues by going staying on either the first or last page.
         * @param {Number} page The page to go to.
         * @param {PageChangeType} type The type of the page change.
         */

    }, {
        key: '_setPage',
        value: function _setPage(page, type) {
            page = normalizePage(page, this._totalPages);

            // Only update if the page actually changed.
            if (page !== this._state.page) {
                this._state.transition = true;
                this._state.offset = 0;
                var previous = this._state.page;
                this._state.page = page;
                this._onPageChange(page, type, previous);
                this._updateState();
            }
        }

        /**
         * Return the total number of pages.
         * @return {Number}
         */

    }, {
        key: 'getTotalPages',
        value: function getTotalPages() {
            return this._totalPages;
        }

        /**
         * Go to the specified page.
         */

    }, {
        key: 'jumpToPage',
        value: function jumpToPage(page) {
            this._setPage(page, pageChangeTypeEnum.jump());
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: 'canPaginate',
        value: function canPaginate() {
            return this.getTotalPages() > 1;
        }

        /**
         * Go to the next page.
         */

    }, {
        key: '_nextPage',
        value: function _nextPage() {
            // If we are already on the last page, just stay there.
            if (this._isLastPage()) {
                this._resetOffset();
                return;
            }

            this._setPage(this._state.page + 1, pageChangeTypeEnum.next());
        }

        /**
         * Go to the previous page.
         */

    }, {
        key: '_previousPage',
        value: function _previousPage() {
            // If we are already on the first page, just stay there.
            if (this._isFirstPage()) {
                this._resetOffset();
                return;
            }

            this._setPage(this._state.page - 1, pageChangeTypeEnum.previous());
        }

        /**
         * Check if we are currently on the first page.
         * @return {Boolean}
         */

    }, {
        key: '_isFirstPage',
        value: function _isFirstPage() {
            return this._state.page === 0;
        }

        /**
         * Check if we are currently on the last page.
         * @return {Boolean}
         */

    }, {
        key: '_isLastPage',
        value: function _isLastPage() {
            return this._state.page === this._totalPages - 1;
        }
    }]);

    return SwipeModel;
}(BaseModel);

module.exports = SwipeModel;

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);

var _require = __webpack_require__(71),
    noop = _require.noop;

var SwipeModel = __webpack_require__(545);
var BaseCarousel = __webpack_require__(370);
var DotCarousel = __webpack_require__(406);

/**
 * Represents a carousel with that the user can swipe through on a touch device.
 * @class
 */

var SwipeCarousel = function (_React$Component) {
    _inherits(SwipeCarousel, _React$Component);

    function SwipeCarousel(props) {
        _classCallCheck(this, SwipeCarousel);

        // Dummy state. State is held in the `_model` but this is necessary to force a re-render when the model updates.
        var _this = _possibleConstructorReturn(this, (SwipeCarousel.__proto__ || Object.getPrototypeOf(SwipeCarousel)).call(this, props));

        _this.state = {
            modelState: {}
        };
        return _this;
    }

    _createClass(SwipeCarousel, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            this._model = new SwipeModel({
                itemsPerPage: this.props.itemsPerPage,
                itemWidth: this.props.itemWidth,
                isCentered: this.props.isCentered,
                itemCount: React.Children.count(this.props.children),
                onPageChange: this.props.onPageChange,
                startingPage: this.props.startingPage,
                // Force a re-render if the model changes.
                onStateChange: function onStateChange(modelState) {
                    return _this2.setState({ modelState: modelState });
                }
            });

            // Set the initial model state. This is probably unnecessary but put here to avoid issues if state gets used
            // in `render` in the future.
            this.setState({ modelState: this._model.getState() });
        }

        /**
         * Imperatively set the page from outside the component, e.g. if the state of this carousel needs to be kept
         * constistent with another carousel.
         *
         * @param {number} page - The page to set.
         * @param {object} model - Model to update, needed for components where this method gets passed.
         * @param {function} callback
        */

    }, {
        key: 'setPage',
        value: function setPage(page) {
            var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._model;
            var callback = arguments[2];

            // Update the model which will in turn trigger an update to the view state and force a re-render.
            if (callback) {
                callback();
            }

            model.jumpToPage(page);
        }
    }, {
        key: 'enableSwipe',
        value: function enableSwipe() {
            this._model.enableSwipe();
        }
    }, {
        key: 'disableSwipe',
        value: function disableSwipe() {
            this._model.disableSwipe();
        }

        /**
         * Method to create a basic carousel which then can be shown or wrapped by other components.
         *
         * @returns {object} - JSX of a carousel.
         */

    }, {
        key: '_createCarousel',
        value: function _createCarousel() {
            var _classnames, _classnames2, _classnames3;

            var _props$classNames = this.props.classNames,
                wrapper = _props$classNames.wrapper,
                list = _props$classNames.list,
                item = _props$classNames.item;


            var wrapperClass = classnames((_classnames = {}, _defineProperty(_classnames, 'swipe-carousel-wrapper', true), _defineProperty(_classnames, wrapper, wrapper), _classnames));
            var listClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, 'swipe-carousel-list', true), _defineProperty(_classnames2, list, list), _classnames2));
            var itemClass = classnames((_classnames3 = {}, _defineProperty(_classnames3, 'swipe-carousel-item', true), _defineProperty(_classnames3, item, item), _classnames3));

            return React.createElement(
                'div',
                { className: wrapperClass },
                React.createElement(
                    BaseCarousel,
                    { model: this._model, classNames: { list: listClass, item: itemClass } },
                    this.props.children
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (this.props.useDotsNav) {
                return React.createElement(DotCarousel, {
                    classNames: this.props.classNames,
                    createCarousel: function createCarousel() {
                        return _this3._createCarousel();
                    },
                    setPage: this.setPage,
                    model: this._model,
                    onDotClick: this.props.onDotClick,
                    dotsColorType: this.props.dotsColorType
                });
            }

            return this._createCarousel();
        }
    }]);

    return SwipeCarousel;
}(React.Component);

SwipeCarousel.propTypes = {
    onPageChange: PropTypes.func,
    startingPage: PropTypes.number,
    // Change the number of items to display per carousel page.
    itemsPerPage: PropTypes.number,
    itemWidth: PropTypes.number,
    isCentered: PropTypes.bool,
    classNames: PropTypes.object,
    children: PropTypes.node,
    useDotsNav: PropTypes.bool,
    dotsColorType: PropTypes.oneOf(['buyer', 'trade']),
    onDotClick: PropTypes.func.isRequired
};

SwipeCarousel.defaultProps = {
    itemsPerPage: 1,
    onPageChange: noop,
    onDotClick: noop,
    startingPage: 0,
    classNames: {}
};

module.exports = SwipeCarousel;

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(39);
var ExecutionEnvironment = __webpack_require__(542);
var ModalPortal = React.createFactory(__webpack_require__(549));
var ariaAppHider = __webpack_require__(550);
var elementClass = __webpack_require__(379);
var renderSubtreeIntoContainer = __webpack_require__(39).unstable_renderSubtreeIntoContainer;
var Assign = __webpack_require__(60);

var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};

var Modal = React.createClass({

  displayName: 'Modal',
  statics: {
    setAppElement: function(element) {
        AppElement = ariaAppHider.setElement(element);
    },
    injectCSS: function() {
      "production" !== 'production'
        && console.warn('React-Modal: injectCSS has been deprecated ' +
                        'and no longer has any effect. It will be removed in a later version');
    }
  },

  propTypes: {
    isOpen: React.PropTypes.bool.isRequired,
    style: React.PropTypes.shape({
      content: React.PropTypes.object,
      overlay: React.PropTypes.object
    }),
    appElement: React.PropTypes.instanceOf(SafeHTMLElement),
    onAfterOpen: React.PropTypes.func,
    onRequestClose: React.PropTypes.func,
    closeTimeoutMS: React.PropTypes.number,
    ariaHideApp: React.PropTypes.bool,
    shouldCloseOnOverlayClick: React.PropTypes.bool
  },

  getDefaultProps: function () {
    return {
      isOpen: false,
      ariaHideApp: true,
      closeTimeoutMS: 0,
      shouldCloseOnOverlayClick: true
    };
  },

  componentDidMount: function() {
    this.node = document.createElement('div');
    this.node.className = 'ReactModalPortal';
    document.body.appendChild(this.node);
    this.renderPortal(this.props);
  },

  componentWillReceiveProps: function(newProps) {
    this.renderPortal(newProps);
  },

  componentWillUnmount: function() {
    ReactDOM.unmountComponentAtNode(this.node);
    document.body.removeChild(this.node);
    elementClass(document.body).remove('ReactModal__Body--open');
  },

  renderPortal: function(props) {
    if (props.isOpen) {
      elementClass(document.body).add('ReactModal__Body--open');
    } else {
      elementClass(document.body).remove('ReactModal__Body--open');
    }

    if (props.ariaHideApp) {
      ariaAppHider.toggle(props.isOpen, props.appElement);
    }

    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
  },

  render: function () {
    return React.DOM.noscript();
  }
});

Modal.defaultStyles = {
  overlay: {
    position        : 'fixed',
    top             : 0,
    left            : 0,
    right           : 0,
    bottom          : 0,
    backgroundColor : 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position                : 'absolute',
    top                     : '40px',
    left                    : '40px',
    right                   : '40px',
    bottom                  : '40px',
    border                  : '1px solid #ccc',
    background              : '#fff',
    overflow                : 'auto',
    WebkitOverflowScrolling : 'touch',
    borderRadius            : '4px',
    outline                 : 'none',
    padding                 : '20px'
  }
}

module.exports = Modal


/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(1);
var div = React.DOM.div;
var focusManager = __webpack_require__(551);
var scopeTab = __webpack_require__(552);
var Assign = __webpack_require__(60);

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: {
    base: 'ReactModal__Overlay',
    afterOpen: 'ReactModal__Overlay--after-open',
    beforeClose: 'ReactModal__Overlay--before-close'
  },
  content: {
    base: 'ReactModal__Content',
    afterOpen: 'ReactModal__Content--after-open',
    beforeClose: 'ReactModal__Content--before-close'
  }
};

var ModalPortal = module.exports = React.createClass({

  displayName: 'ModalPortal',

  getDefaultProps: function() {
    return {
      style: {
        overlay: {},
        content: {}
      }
    };
  },

  getInitialState: function() {
    return {
      afterOpen: false,
      beforeClose: false
    };
  },

  componentDidMount: function() {
    // Focus needs to be set when mounting and already open
    if (this.props.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    }
  },

  componentWillUnmount: function() {
    clearTimeout(this.closeTimer);
  },

  componentWillReceiveProps: function(newProps) {
    // Focus only needs to be set once when the modal is being opened
    if (!this.props.isOpen && newProps.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    } else if (this.props.isOpen && !newProps.isOpen) {
      this.close();
    }
  },

  componentDidUpdate: function () {
    if (this.focusAfterRender) {
      this.focusContent();
      this.setFocusAfterRender(false);
    }
  },

  setFocusAfterRender: function (focus) {
    this.focusAfterRender = focus;
  },

  open: function() {
    focusManager.setupScopedFocus(this.node);
    focusManager.markForFocusLater();
    this.setState({isOpen: true}, function() {
      this.setState({afterOpen: true});

      if (this.props.isOpen && this.props.onAfterOpen) {
        this.props.onAfterOpen();
      }
    }.bind(this));
  },

  close: function() {
    if (!this.ownerHandlesClose())
      return;
    if (this.props.closeTimeoutMS > 0)
      this.closeWithTimeout();
    else
      this.closeWithoutTimeout();
  },

  focusContent: function() {
    this.refs.content.focus();
  },

  closeWithTimeout: function() {
    this.setState({beforeClose: true}, function() {
      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
    }.bind(this));
  },

  closeWithoutTimeout: function() {
    this.setState({
      afterOpen: false,
      beforeClose: false
    }, this.afterClose);
  },

  afterClose: function() {
    focusManager.returnFocus();
    focusManager.teardownScopedFocus();
  },

  handleKeyDown: function(event) {
    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
    if (event.keyCode == 27 /*esc*/) {
      event.preventDefault();
      this.requestClose(event);
    }
  },

  handleOverlayClick: function(event) {
    var node = event.target

    while (node) {
      if (node === this.refs.content) return
      node = node.parentNode
    }

    if (this.props.shouldCloseOnOverlayClick) {
      if (this.ownerHandlesClose())
        this.requestClose(event);
      else
        this.focusContent();
    }
  },

  requestClose: function(event) {
    if (this.ownerHandlesClose())
      this.props.onRequestClose(event);
  },

  ownerHandlesClose: function() {
    return this.props.onRequestClose;
  },

  shouldBeClosed: function() {
    return !this.props.isOpen && !this.state.beforeClose;
  },

  buildClassName: function(which, additional) {
    var className = CLASS_NAMES[which].base;
    if (this.state.afterOpen)
      className += ' '+CLASS_NAMES[which].afterOpen;
    if (this.state.beforeClose)
      className += ' '+CLASS_NAMES[which].beforeClose;
    return additional ? className + ' ' + additional : className;
  },

  render: function() {
    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;

    return this.shouldBeClosed() ? div() : (
      div({
        ref: "overlay",
        className: this.buildClassName('overlay', this.props.overlayClassName),
        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
        onClick: this.handleOverlayClick
      },
        div({
          ref: "content",
          style: Assign({}, contentStyles, this.props.style.content || {}),
          className: this.buildClassName('content', this.props.className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown
        },
          this.props.children
        )
      )
    );
  }
});


/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 9/4/13
 */

var SoaModel = __webpack_require__(2);
var AdjustmentList = SoaModel.extend();

module.exports = AdjustmentList;

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var Adjustment = __webpack_require__(132);
var getAdjustmentsTotalByfn;
var getAdjustmentsByFn;


getAdjustmentsTotalByfn = function (fn, currency) {
    return _.reduce(getAdjustmentsByFn.call(this, fn), function (memo, adjustment) {
        return memo + (parseFloat(adjustment.getTotalAmount(currency)) || 0);
    }, 0, this);
};

getAdjustmentsByFn = function (fn) {
    if (!this.get('documents')) {
        return [];
    }
    return this.get('documents').filter(function (adjustment) {
        return adjustment[fn]();
    });
};
/**
 * @class AdjustmentList
 * @extends SoaModel
 * @property {array} relations
 *      @property relations.type {Backbone.One}
 *      @property relations.key {string}- "item"
 *      @property relations.relatedModel {Backbone.Model}
 *      @property relations.collectionType {Backbone.Models}
 */
_.extend(AdjustmentList.prototype, {
    relations: [{
        type: Backbone.Many,
        key: 'documents',
        relatedModel: Adjustment
    }],
    getMerchTaxTotal: _.partial(getAdjustmentsTotalByfn, 'isMerchTaxAdjustment'),
    getShippingTaxTotal: _.partial(getAdjustmentsTotalByfn, 'isShippingTaxAdjustment'),
    getCommissionTotal: _.partial(getAdjustmentsTotalByfn, 'isCommissionAdjustment'),
    getProcessingFeeTotal: _.partial(getAdjustmentsTotalByfn, 'isProcessingFeeAdjustment'),
    getListingCreditTotal: _.partial(getAdjustmentsTotalByfn, 'isListingCreditAdjustment'),
    getComplimentaryShippingTotal: _.partial(getAdjustmentsTotalByfn, 'isComplimentaryShipping'),
    getDealerChargeTotal: _.partial(getAdjustmentsTotalByfn, 'isDealerCharge'),
    getPromotionTotal: _.partial(getAdjustmentsTotalByfn, 'isPromotionAdjustment'),
    hasPromotion: function () {
        return !!getAdjustmentsByFn.call(this, 'isPromotionAdjustment').length;
    },
    getListingCreditAdjustment: function () {
        return getAdjustmentsByFn.call(this, 'isListingCreditAdjustment')[0];
    }
});


/***/ }),

/***/ 550:
/***/ (function(module, exports) {

var _element = typeof document !== 'undefined' ? document.body : null;

function setElement(element) {
  if (typeof element === 'string') {
    var el = document.querySelectorAll(element);
    element = 'length' in el ? el[0] : el;
  }
  _element = element || _element;
  return _element;
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || _element).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || _element).removeAttribute('aria-hidden');
}

function toggle(shouldHide, appElement) {
  if (shouldHide)
    hide(appElement);
  else
    show(appElement);
}

function validateElement(appElement) {
  if (!appElement && !_element)
    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
}

function resetForTesting() {
  _element = document.body;
}

exports.toggle = toggle;
exports.setElement = setElement;
exports.show = show;
exports.hide = hide;
exports.resetForTesting = resetForTesting;


/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(405);
var modalElement = null;
var focusLaterElement = null;
var needToFocus = false;

function handleBlur(event) {
  needToFocus = true;
}

function handleFocus(event) {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation 
    // is that the document.body gets focus, and then we focus our element right 
    // after, seems fine.
    setTimeout(function() {
      if (modalElement.contains(document.activeElement))
        return;
      var el = (findTabbable(modalElement)[0] || modalElement);
      el.focus();
    }, 0);
  }
}

exports.markForFocusLater = function() {
  focusLaterElement = document.activeElement;
};

exports.returnFocus = function() {
  try {
    focusLaterElement.focus();
  }
  catch (e) {
    console.warn('You tried to return focus to '+focusLaterElement+' but it is not in the DOM anymore');
  }
  focusLaterElement = null;
};

exports.setupScopedFocus = function(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
};

exports.teardownScopedFocus = function() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
};




/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(405);

module.exports = function(node, event) {
  var tabbable = findTabbable(node);
  if (!tabbable.length) {
      event.preventDefault();
      return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = (
    finalTabbable === document.activeElement ||
    // handle immediate shift+tab after opening with mouse
    node === document.activeElement
  );
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
};


/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: Shad
 * Date: 8/19/13
 */

var SoaModel = __webpack_require__(2);

var paymentMethodFactory = SoaModel.extend({
    constructor: function (data, options) {
        // declared down here for circular dependency reasons
        var WireTransfer = __webpack_require__(192);
        var Check = __webpack_require__(185);
        var CreditToUserAccount = __webpack_require__(187);
        var Discount = __webpack_require__(189);
        var DirectPayment = __webpack_require__(188);
        var Cash = __webpack_require__(184);
        var ACH = __webpack_require__(182);
        var NotAvailable = __webpack_require__(190);
        var CreditCard = __webpack_require__(186);
        var PayPalAccount = __webpack_require__(191);
        var ApplePay = __webpack_require__(183);

        switch (data.paymentMethodType) {
            case 'WIRE_TRANSFER':
                return new WireTransfer(data, options);
            case 'CHECK':
                return new Check(data, options);
            case 'CREDIT_TO_USER_ACCOUNT':
                return new CreditToUserAccount(data, options);
            case 'DISCOUNT':
                return new Discount(data, options);
            case 'DIRECT_PAYMENT':
                return new DirectPayment(data, options);
            case 'CASH':
                return new Cash(data, options);
            case 'ACH':
                return new ACH(data, options);
            case 'NOT_AVAILABLE':
                return new NotAvailable(data, options);
            case 'PAYPAL_ACCOUNT':
                return new PayPalAccount(data, options);
            case 'CREDIT_CARD':
                return new CreditCard(data, options);
            case 'APPLE_PAY':
                return new ApplePay(data, options);
            default:
                return new CreditCard(data, options);
        }
    }
});

module.exports = paymentMethodFactory;


/***/ }),

/***/ 57:
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),

/***/ 571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);

var TradeMessageStore = function (_BaseStore) {
    _inherits(TradeMessageStore, _BaseStore);

    function TradeMessageStore(dispatcher) {
        _classCallCheck(this, TradeMessageStore);

        var _this = _possibleConstructorReturn(this, (TradeMessageStore.__proto__ || Object.getPrototypeOf(TradeMessageStore)).call(this, dispatcher));

        _this._state = {
            messageVisible: false
        };
        return _this;
    }

    _createClass(TradeMessageStore, [{
        key: 'onMessageToggle',
        value: function onMessageToggle(isVisible) {
            this._state.messageVisible = isVisible;
            this.emitChange();
        }
    }, {
        key: 'canShowMessage',
        value: function canShowMessage() {
            return this._state.messageVisible;
        }
    }, {
        key: 'isLoaded',
        value: function isLoaded() {
            return this._state.isLoaded;
        }
    }]);

    return TradeMessageStore;
}(BaseStore);

TradeMessageStore.storeName = 'TradeMessageStore';

TradeMessageStore.handlers = {
    'message:trade:toggle': 'onMessageToggle'
};

module.exports = TradeMessageStore;

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var arrayEach = __webpack_require__(325),
    baseEach = __webpack_require__(308),
    bindCallback = __webpack_require__(124),
    isArray = __webpack_require__(65);

/**
 * Creates a function for `_.forEach` or `_.forEachRight`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over an array.
 * @param {Function} eachFunc The function to iterate over a collection.
 * @returns {Function} Returns the new each function.
 */
function createForEach(arrayFunc, eachFunc) {
  return function(collection, iteratee, thisArg) {
    return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
      ? arrayFunc(collection, iteratee)
      : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
  };
}

/**
 * Iterates over elements of `collection` invoking `iteratee` for each element.
 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
 * (value, index|key, collection). Iteratee functions may exit iteration early
 * by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length" property
 * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
 * may be used for object iteration.
 *
 * @static
 * @memberOf _
 * @alias each
 * @category Collection
 * @param {Array|Object|string} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [thisArg] The `this` binding of `iteratee`.
 * @returns {Array|Object|string} Returns `collection`.
 * @example
 *
 * _([1, 2]).forEach(function(n) {
 *   console.log(n);
 * }).value();
 * // => logs each value from left to right and returns the array
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
 *   console.log(n, key);
 * });
 * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
 */
var forEach = createForEach(arrayEach, baseEach);

module.exports = forEach;


/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var classnames = __webpack_require__(16);

var _require = __webpack_require__(71),
    noop = _require.noop;

var PageModel = __webpack_require__(636);
var BaseCarousel = __webpack_require__(370);
var ArrowCarouselComponent = __webpack_require__(637);
var DotCarousel = __webpack_require__(406);

/**
 * Represents a carousel with arrows for paging through the list.
 * @class
 */

var ArrowCarousel = function (_React$Component) {
    _inherits(ArrowCarousel, _React$Component);

    function ArrowCarousel(props) {
        _classCallCheck(this, ArrowCarousel);

        // Todo refactor model logic into a store
        var _this = _possibleConstructorReturn(this, (ArrowCarousel.__proto__ || Object.getPrototypeOf(ArrowCarousel)).call(this, props));

        _this._model = new PageModel({
            itemsPerPage: props.itemsPerPage,
            itemCount: React.Children.count(props.children),
            onPageChange: props.onPageChange,
            startingPage: props.startingPage,
            transitionEffect: props.transitionEffect,
            // Force a re-render if the model changes.
            onStateChange: function onStateChange(modelState) {
                return _this.setState({ modelState: modelState });
            },
            customTransformItemStyle: props.customTransformItemStyle
        });

        //// Set the initial model state. This is probably unnecessary but put here to avoid issues if state gets used
        //// in `render` in the future.
        _this.state = {
            modelState: _this._model.getState()
        };

        _this._onLeftArrowClick = _this._onLeftArrowClick.bind(_this);
        _this._onRightArrowClick = _this._onRightArrowClick.bind(_this);
        return _this;
    }

    /**
     * Imperatively set the page from outside the component, e.g. if the state of this carousel needs to be kept
     * constistent with another carousel.
     *
     * @param {number} page - The page to set.
     * @param {object} model - Model to update, needed for components where this method gets passed.
     * @param {function} callback
    */


    _createClass(ArrowCarousel, [{
        key: 'setPage',
        value: function setPage(page) {
            var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._model;
            var callback = arguments[2];

            // Update the model which will in turn trigger an update to the view state and force a re-render.
            if (callback) {
                callback();
            }

            model.jumpToPage(page);
        }

        /**
         * Method to handle the left carousel arrow click.
         */

    }, {
        key: '_onLeftArrowClick',
        value: function _onLeftArrowClick() {
            var onLeftArrowClick = this.props.onLeftArrowClick;


            this._model.previousPage();

            if (onLeftArrowClick) {
                onLeftArrowClick(this._model.getState().page);
            }
        }

        /**
         * Method to handle the right carousel arrow click.
         */

    }, {
        key: '_onRightArrowClick',
        value: function _onRightArrowClick() {
            var onRightArrowClick = this.props.onRightArrowClick;


            this._model.nextPage();

            if (onRightArrowClick) {
                onRightArrowClick(this._model.getState().page);
            }
        }

        /**
         * Method to create a basic carousel which then can be shown or wrapped by other components.
         *
         * @returns {object} - JSX of a carousel.
         */

    }, {
        key: '_createCarousel',
        value: function _createCarousel() {
            return React.createElement(
                BaseCarousel,
                { model: this._model, classNames: { list: this._listClass, item: this._itemClass } },
                this.props.children
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _this2 = this;

            var _props = this.props,
                _props$classNames = _props.classNames,
                list = _props$classNames.list,
                item = _props$classNames.item,
                auto = _props.auto,
                useDotsNav = _props.useDotsNav;

            var canPaginate = this._model.canPaginate();

            this._listClass = classnames((_classnames = {}, _defineProperty(_classnames, 'arrow-carousel-list', true), _defineProperty(_classnames, list, list), _classnames));
            this._itemClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, 'arrow-carousel-item', true), _defineProperty(_classnames2, item, item), _classnames2));

            if (auto || useDotsNav) {
                return React.createElement(DotCarousel, {
                    model: this._model,
                    classNames: this.props.classNames,
                    createCarousel: function createCarousel() {
                        return _this2._createCarousel();
                    },
                    setPage: this.setPage,
                    autoDuration: this.props.autoDuration,
                    dotsPosition: this.props.dotsPosition,
                    dotsColorType: this.props.dotsColorType,
                    onDotClick: this.props.onDotClick,
                    auto: auto
                });
            }

            return React.createElement(ArrowCarouselComponent, {
                showArrows: canPaginate,
                createCarousel: function createCarousel() {
                    return _this2._createCarousel();
                },
                onLeftArrowClick: function onLeftArrowClick() {
                    return _this2._onLeftArrowClick();
                },
                onRightArrowClick: function onRightArrowClick() {
                    return _this2._onRightArrowClick();
                },
                classNames: this.props.classNames
            });
        }
    }]);

    return ArrowCarousel;
}(React.Component);

ArrowCarousel.propTypes = {
    onPageChange: PropTypes.func,
    // Change the number of items to display per carousel page.
    itemsPerPage: PropTypes.number,
    startingPage: PropTypes.number,
    transitionEffect: PropTypes.string,
    classNames: PropTypes.object,
    children: PropTypes.node,
    useDotsNav: PropTypes.bool,
    auto: PropTypes.bool,
    autoDuration: PropTypes.number,
    dotsColorType: PropTypes.oneOf(['buyer', 'trade']),
    dotsPosition: PropTypes.oneOf(['left', 'right']),
    onDotClick: PropTypes.func.isRequired,
    onLeftArrowClick: PropTypes.func,
    onRightArrowClick: PropTypes.func,
    customTransformItemStyle: PropTypes.func
};

ArrowCarousel.defaultProps = {
    autoDuration: 5000,
    itemsPerPage: 1,
    onPageChange: noop,
    onDotClick: noop,
    startingPage: 0,
    classNames: {},
    auto: false
};

module.exports = ArrowCarousel;

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ACTIONS: {
        TYPE: {
            CATEGORY: 'CATEGORY',
            ATTRIBUTE: 'ATTRIBUTE'
        },
        FIELDS: {
            IMAGES: 'IMAGES'
        }
    },
    STORE: {
        FETCH_SUCCESS: 'recommendations:fetch:success',
        FETCH_ERROR: 'recommendations:fetch:error'
    }
};

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

var raf = __webpack_require__(685),
    COMPLETE = 'complete',
    CANCELED = 'canceled';

function setElementScroll(element, x, y){
    if(element === window){
        element.scrollTo(x, y);
    }else{
        element.scrollLeft = x;
        element.scrollTop = y;
    }
}

function getTargetScrollLocation(target, parent, align){
    var targetPosition = target.getBoundingClientRect(),
        parentPosition,
        x,
        y,
        differenceX,
        differenceY,
        leftAlign = align && align.left != null ? align.left : 0.5,
        topAlign = align && align.top != null ? align.top : 0.5,
        leftScalar = leftAlign,
        topScalar = topAlign;

    if(parent === window){
        x = targetPosition.left + window.scrollX - window.innerWidth * leftScalar + Math.min(targetPosition.width, window.innerWidth) * leftScalar;
        y = targetPosition.top + window.scrollY - window.innerHeight * topScalar + Math.min(targetPosition.height, window.innerHeight) * topScalar;
        x = Math.max(Math.min(x, document.body.scrollWidth - window.innerWidth * leftScalar), 0);
        y = Math.max(Math.min(y, document.body.scrollHeight- window.innerHeight * topScalar), 0);
        differenceX = x - window.scrollX;
        differenceY = y - window.scrollY;
    }else{
        parentPosition = parent.getBoundingClientRect();
        var offsetTop = targetPosition.top - (parentPosition.top - parent.scrollTop);
        var offsetLeft = targetPosition.left - (parentPosition.left - parent.scrollLeft);
        x = offsetLeft + (targetPosition.width * leftScalar) - parent.clientWidth * leftScalar;
        y = offsetTop + (targetPosition.height * topScalar) - parent.clientHeight * topScalar;
        x = Math.max(Math.min(x, parent.scrollWidth - parent.clientWidth), 0);
        y = Math.max(Math.min(y, parent.scrollHeight - parent.clientHeight), 0);
        differenceX = x - parent.scrollLeft;
        differenceY = y - parent.scrollTop;
    }

    return {
        x: x,
        y: y,
        differenceX: differenceX,
        differenceY: differenceY
    };
}

function animate(parent){
    raf(function(){
        var scrollSettings = parent._scrollSettings;
        if(!scrollSettings){
            return;
        }

        var location = getTargetScrollLocation(scrollSettings.target, parent, scrollSettings.align),
            time = Date.now() - scrollSettings.startTime,
            timeValue = Math.min(1 / scrollSettings.time * time, 1);

        if(
            time > scrollSettings.time + 20 ||
            (Math.abs(location.differenceY) <= 1 && Math.abs(location.differenceX) <= 1)
        ){
            setElementScroll(parent, location.x, location.y);
            parent._scrollSettings = null;
            return scrollSettings.end(COMPLETE);
        }

        var valueX = timeValue,
            valueY = timeValue;

        setElementScroll(parent,
            location.x - location.differenceX * Math.pow(1 - valueX, valueX / 2),
            location.y - location.differenceY * Math.pow(1 - valueY, valueY / 2)
        );

        animate(parent);
    });
}

function transitionScrollTo(target, parent, settings, callback){
    var idle = !parent._scrollSettings;

    if(parent._scrollSettings){
        parent._scrollSettings.end(CANCELED);
    }

    function end(endType){
        parent._scrollSettings = null;
        callback(endType);
        parent.removeEventListener('touchstart', end);
    }

    parent._scrollSettings = {
        startTime: Date.now(),
        target: target,
        time: settings.time,
        ease: settings.ease,
        align: settings.align,
        end: end
    };
    parent.addEventListener('touchstart', end.bind(null, CANCELED));

    if(idle){
        animate(parent);
    }
}

module.exports = function(target, settings, callback){
    if(!target){
        return;
    }

    if(typeof settings === 'function'){
        callback = settings;
        settings = null;
    }

    if(!settings){
        settings = {};
    }

    settings.time = settings.time || 1000;
    settings.ease = settings.ease || function(v){return v;};

    var parent = target.parentElement,
        parents = 0;

    function done(endType){
        parents--;
        if(!parents){
            callback && callback(endType);
        }
    }

    while(parent){
        if(
            settings.validTarget ? settings.validTarget(parent, parents) : true &&
            parent === window ||
            (
                parent.scrollHeight !== parent.clientHeight ||
                parent.scrollWidth !== parent.clientWidth
            ) &&
            getComputedStyle(parent).overflow !== 'hidden'
        ){
            parents++;
            transitionScrollTo(target, parent, settings, done);
        }

        parent = parent.parentElement;

        if(!parent){
            return;
        }

        if(parent.tagName === 'BODY'){
            parent = window;
        }
    }
};

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constats = __webpack_require__(279);
var currencies = constats.currencies;
var currencySymbols = constats.symbols;
var abbreviations = constats.abbreviations;

/**
 * A more forgiving parseFloat
 * This is useful when consuming user-input
 * @param {number|string} number Either a formatted string (3,000) or integer (3000)
 * @returns {Number}
 */
exports.parseFloat = function dibsParsFloat(number) {
    return parseFloat(String(number).replace(/[^\d\.e-]/ig, '')) || 0;
};

/**
 * Round to the given precision
 * @param {number|string} number @see Number.parseFloat#number
 * @param {number} digits
 * @returns {number}
 */
exports.round = function round(number, digits) {
    var powed = Math.pow(10, digits);
    return Math.round(exports.parseFloat(number) * powed) / powed;
};

/**
 * Similar to PHP's number_format
 * @param number
 * @param {number} significantDigits The decimal place to round and fix a number to, Defaults to 0
 * @param {String} thousandsSeparator Defaults to ,
 * @param {String} decimalMark Defaults to .
 */
exports.format = function format(number, significantDigits, thousandsSeparator, decimalMark) {
    var suffix = '';
    var isNegative = number < 0;
    var bits;
    var i;

    if (isNegative) {
        number = number * -1;
    }

    significantDigits = significantDigits > -1 ? significantDigits : 0;
    thousandsSeparator = thousandsSeparator === undefined ? ',' : thousandsSeparator;
    decimalMark = decimalMark === undefined ? '.' : decimalMark;
    number = exports.round(number, significantDigits).toFixed(significantDigits);
    if (thousandsSeparator && number.match(/^\d{4}/)) {
        if (significantDigits) {
            suffix = number.substr(number.indexOf('.'));
            number = number.split('.')[0];
        }
        bits = number.split('');
        i = bits.length - 3;
        while (i > 0) {
            bits.splice(i, 0, thousandsSeparator);
            i -= 3;
        }
        number = bits.concat(suffix).join('');
    }
    if (decimalMark !== '.' && significantDigits) {
        number = number.replace(/\.(\d+)$/, decimalMark + '$1');
    }

    if (isNegative) {
        number = '-' + number;
    }

    return number;
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.abbreviation] Wheter to include an abbreviation or not
 * @param {boolean} [options.includeCurrencySymbol] Wheter to include a currency symbol or not
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {object}
 */
exports.localizedCashFormatObj = function (number, options) {
    options = Object.assign({
        includeCurrencySymbol: true
    }, options);
    var decimalsToShow = options.showDecimal === false ?  0 : 2;
    var thousandsSeparator = options.thousandsSeparator || ',';
    var decimalMark = options.decimalMark || '.';
    var currencySymbol = options.currencySymbol || '$';
    var abbreviation = options.abbreviation || '';
    var sign = '';

    number = exports.format(number, decimalsToShow, thousandsSeparator, decimalMark);
    currencySymbol = options.includeCurrencySymbol ? currencySymbol : '';

    // if it's negative we need to put the negative sign in front
    if (number.indexOf('-') !== -1) {
        sign = '-';
        number = number.replace('-', '');
    }

    return {
        sign: sign,
        currencySymbol: currencySymbol,
        number: number,
        abbreviation: abbreviation
    };
};

/**
 *
 * @param {number} number The number to format
 * @param {object} [options] Formatting options
 * @param {boolean} [options.showDecimal] Show a decimal or not. Defaults to true
 * @param {string} [options.thousandsSeparator] What separates the thousands? Defaults to comma ","
 * @param {string} [options.decimalMark] What separates decimals? Defaults to period "."
 * @param {string} [options.abbreviation] Wheter to include an abbreviation or not
 * @param {boolean} [options.includeCurrencySymbol] Wheter to include a currency symbol or not
 * @param {string} [options.currencySymbol] Which currency symbol to use. Defaults to USD "$"
 * @returns {string}
 */
exports.localizedCashFormat = function (number, options) {
    var localizedObject = exports.localizedCashFormatObj(number, options);
    var localizedNumber = localizedObject.number;
    var currencySymbol = localizedObject.currencySymbol;
    var abbreviation = localizedObject.abbreviation;
    var sign = localizedObject.sign;

    // if it's negative we need to put the negative sign in front
    if (sign) {
        sign = sign + ' ';
    }

    if (abbreviation.length) {
        abbreviation = ' ' + abbreviation;
    }

    if (options.formatNegativeAmount && sign) {
        return '(' + currencySymbol + localizedNumber + abbreviation + ')';
    }

    return sign + currencySymbol + localizedNumber + abbreviation;
};

/**
 * Converts a string containing numbers to an integer
 * @param  {string} amount
 * @return {number}
 */
exports.currencyToInteger = function (amount) {
    // Match all numbers and - sign
    var regexp = /-?[0-9]*/g;
    if (typeof amount === 'number') {
        return amount;
    } else if (typeof amount === 'string') {
        return parseInt(amount.match(regexp).join(''), 10);
    } else {
        return NaN;
    }
};

/**
 * Used internaly for intelligentFormat
 * @param  {number} The number to format
 * @param  {string}
 * @param  {object} passedOptions
 * @return {object}
 */
exports.getFormatOptions = function (amount, currency, passedOptions) {
    var options;
    var num = exports.parseFloat(amount);
    var currencyUppercase = (currency + '').toUpperCase();
    options = {
        // Only if there are decimals do we show them
        showDecimal : Math.ceil(num) !== Math.floor(num),
        thousandsSeparator : ',',
        decimalMark : '.',
        currencySymbol : currencySymbols.USD,
        abbreviation: abbreviations[currencyUppercase],
        formatNegativeAmount: false
    };

    switch (currencyUppercase) {
        case currencies.CURRENCY_GBP:
        case currencySymbols.GBP:
            options.currencySymbol = currencySymbols.GBP;
            break;
        case currencies.CURRENCY_CHF:
        case currencySymbols.CHF:
            options.includeCurrencySymbol = false;
            break;
        case currencies.CURRENCY_EUR:
        case currencySymbols.EUR:
            options.thousandsSeparator = '.';
            options.decimalMark = ',';
            options.currencySymbol = currencySymbols.EUR;
            break;
    }

    return Object.assign(options, passedOptions);
};


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var Component = React.Component;

var ReactModal = __webpack_require__(511);
var animationFrame = __webpack_require__(896);
var root = __webpack_require__(100);

/**
 * Wrapper class for the `react-modal` component.
 */

var Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal(props) {
        _classCallCheck(this, Modal);

        var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

        var isOpen = props.isOpen,
            onRequestClose = props.onRequestClose;


        _this._onRequestClose = _this._onRequestClose.bind(_this, onRequestClose);
        _this.state = { opaque: !!isOpen };
        return _this;
    }

    _createClass(Modal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var nextIsOpen = _ref.isOpen;
            var isOpen = this.props.isOpen;

            // Allow opening/closing via a prop.

            if (nextIsOpen && !isOpen) {
                this._handleOpen();
                return;
            }

            if (!nextIsOpen && isOpen) {
                this._handleClose();
                return;
            }
        }
    }, {
        key: '_onRequestClose',
        value: function _onRequestClose(callback) {
            if (this.props.canClose) {
                callback();
            }
        }
    }, {
        key: '_handleOpen',
        value: function _handleOpen() {
            var _this2 = this;

            // Fade in on open.
            animationFrame(function () {
                return _this2.setState({ opaque: true });
            });
            this._addBodyClass();
        }
    }, {
        key: '_handleClose',
        value: function _handleClose() {
            var _this3 = this;

            // Fade out on close.
            animationFrame(function () {
                return _this3.setState({ opaque: false });
            });
            this._removeBodyClass();
        }
    }, {
        key: '_addBodyClass',
        value: function _addBodyClass() {
            if (this.props.addBodyClass) {
                root.document.getElementsByTagName('body')[0].classList.add('dibsModal__Body--open');
            }
        }
    }, {
        key: '_removeBodyClass',
        value: function _removeBodyClass() {
            if (this.props.addBodyClass) {
                root.document.getElementsByTagName('body')[0].classList.remove('dibsModal__Body--open');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                transitionDuration = _props.transitionDuration,
                children = _props.children,
                extraStyle = _props.style;
            var opaque = this.state.opaque;


            var style = {
                content: Object.assign({
                    opacity: opaque ? 1 : 0,
                    transition: 'opacity ' + transitionDuration + 'ms linear'
                }, extraStyle.content),
                overlay: Object.assign({
                    zIndex: 1000
                }, extraStyle.overlay)
            };

            return React.createElement(
                ReactModal,
                _extends({}, this.props, { onRequestClose: this._onRequestClose, closeTimeoutMS: transitionDuration, style: style }),
                children
            );
        }
    }]);

    return Modal;
}(Component);

Modal.propTypes = {
    isOpen: PropTypes.bool,
    addBodyClass: PropTypes.bool,
    transitionDuration: PropTypes.number,
    children: PropTypes.node,
    canClose: PropTypes.bool,
    style: PropTypes.shape({
        content: PropTypes.object,
        overlay: PropTypes.object
    })
};

Modal.defaultProps = {
    isOpen: false,
    addBodyClass: true,
    transitionDuration: 250,
    canClose: true,
    style: {},
    onRequestClose: function onRequestClose() {}
};

module.exports = Modal;

/***/ }),

/***/ 636:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(345),
    setTransformStyle = _require.setTransformStyle,
    setTransitionStyle = _require.setTransitionStyle,
    getTotalPages = _require.getTotalPages,
    getPagedItemWidth = _require.getPagedItemWidth,
    pageChangeTypeEnum = _require.pageChangeTypeEnum,
    setWidthStyle = _require.setWidthStyle;

var _require2 = __webpack_require__(71),
    noop = _require2.noop;

var BaseModel = __webpack_require__(339);
var root = __webpack_require__(100);

var DEFAULT_TRANSITION_DURATION = 250;
var TRANSITION_EFFECT_FADE = 'fade';
var TRANSITION_EFFECT_SLIDE = 'slide';

function normalizePage(page, totalPages) {
    // If the requested page is lower than 0, just go to the last page.
    if (page < 0) {
        page = totalPages - 1;
    }

    // If the requested page is higher than the total number of pages, just go to the first page.
    if (page >= totalPages) {
        page = 0;
    }

    return page;
}

/**
 * View-model for carousels that are paged through.
 * @class
 */

var PageModel = function (_BaseModel) {
    _inherits(PageModel, _BaseModel);

    function PageModel() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            itemsPerPage = _ref.itemsPerPage,
            itemCount = _ref.itemCount,
            _ref$transitionEffect = _ref.transitionEffect,
            transitionEffect = _ref$transitionEffect === undefined ? TRANSITION_EFFECT_FADE : _ref$transitionEffect,
            _ref$transitionDurati = _ref.transitionDuration,
            transitionDuration = _ref$transitionDurati === undefined ? DEFAULT_TRANSITION_DURATION : _ref$transitionDurati,
            _ref$startingPage = _ref.startingPage,
            startingPage = _ref$startingPage === undefined ? 0 : _ref$startingPage,
            _ref$onPageChange = _ref.onPageChange,
            onPageChange = _ref$onPageChange === undefined ? noop : _ref$onPageChange,
            onStateChange = _ref.onStateChange,
            _ref$customTransformI = _ref.customTransformItemStyle,
            customTransformItemStyle = _ref$customTransformI === undefined ? noop : _ref$customTransformI;

        _classCallCheck(this, PageModel);

        var _this = _possibleConstructorReturn(this, (PageModel.__proto__ || Object.getPrototypeOf(PageModel)).call(this, { onStateChange: onStateChange }));

        if ([TRANSITION_EFFECT_FADE, TRANSITION_EFFECT_SLIDE].indexOf(transitionEffect) === -1) {
            throw new Error('Transition type must be "' + TRANSITION_EFFECT_FADE + '" or "' + TRANSITION_EFFECT_SLIDE + '"');
        }

        var totalPages = getTotalPages(itemCount, itemsPerPage);

        Object.assign(_this, {
            _itemsPerPage: itemsPerPage,
            _itemCount: itemCount,
            _totalPages: totalPages,
            _transitionEffect: transitionEffect,
            _transitionDuration: transitionDuration,
            _onPageChange: onPageChange,
            _handleContainerChange: _this._handleContainerChange.bind(_this),
            customTransformItemStyle: customTransformItemStyle.bind(_this),
            // Calculate the width of each item.
            _width: getPagedItemWidth(itemsPerPage),
            _state: {
                page: normalizePage(startingPage, totalPages),
                containerWidth: 0
            }
        });
        return _this;
    }

    /**
     * Set the page and handle and bounds issues by going to either the first or last page.
     * @param {Number} page The page to go to.
     * @param {PageChangeType} type The type of the page change.
     */


    _createClass(PageModel, [{
        key: '_setPage',
        value: function _setPage(page, type) {
            page = normalizePage(page, this._totalPages);

            // Only update if the page has actually changed.
            if (page !== this._state.page) {
                // TODO: We might want to add a `setState` method on the `BaseModel` like in React that handles calling the
                // `updateState` method so we don't have to remember to do it.
                var previous = this._state.page;
                this._state.page = page;
                this._onPageChange(page, type, previous);
                this._updateState();
            }
        }

        /**
         * Implement the `_afterMount` method from the `BaseModel`.
         */

    }, {
        key: '_afterMount',
        value: function _afterMount() {
            // Since the position of the items depends on the carousel container width, we want to update them
            // when the window size changes.
            root.addEventListener('resize', this._handleContainerChange);
            // Update carousel items after the component mounts.
            this._handleContainerChange();
        }

        /**
         * Implement the `destroy` method from the `BaseModel`.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            root.removeEventListener('resize', this._handleContainerChange);
        }

        /**
         * Go to the specified page.
         */

    }, {
        key: 'jumpToPage',
        value: function jumpToPage(page) {
            this._setPage(page, pageChangeTypeEnum.jump());
        }

        /**
         * Go to the next page.
         */

    }, {
        key: 'nextPage',
        value: function nextPage() {
            this._setPage(this._state.page + 1, pageChangeTypeEnum.next());
        }

        /**
         * Go to the previous page
         */

    }, {
        key: 'previousPage',
        value: function previousPage() {
            this._setPage(this._state.page - 1, pageChangeTypeEnum.previous());
        }
    }, {
        key: 'calculateStyleValues',
        value: function calculateStyleValues(i) {
            var transition = '';
            var opacity = '';

            var _itemsPerPage = this._itemsPerPage,
                _state = this._state,
                _width = this._width,
                _transitionDuration = this._transitionDuration,
                _transitionEffect = this._transitionEffect;
            var page = _state.page;

            var containerWidth = this._getContainerWidth();

            transition = _transitionDuration + 'ms linear';

            if (_transitionEffect === TRANSITION_EFFECT_FADE) {
                transition = 'opacity ' + transition;

                var startIndex = page * _itemsPerPage;
                var endIndex = startIndex + _itemsPerPage;
                opacity = 0;

                if (i >= startIndex && i < endIndex) {
                    opacity = 1;
                }
            } else if (_transitionEffect === TRANSITION_EFFECT_SLIDE) {
                transition = 'transform ' + transition;
            }

            return {
                widthValue: _width,
                transformValue: this._getTransformValue(containerWidth),
                transition: transition,
                opacity: opacity
            };
        }

        /**
         * Implement the `transformItemStyle` method from the `BaseModel`.
         * @param  {Object} style
         */

    }, {
        key: 'transformItemStyle',
        value: function transformItemStyle(style, i) {
            var containerWidth = this._getContainerWidth();

            // Sometimes the container might be mounted but invisible. We can't really know when it becomes visible,
            // so we update the width when there's interaction with the arrows.
            if (!containerWidth && this._el) {
                this._updateContainerWidth();
            }

            var styleResult = Object.assign(this.calculateStyleValues(i), this.customTransformItemStyle(i));

            setTransformStyle(style, 'translateX(' + styleResult.transformValue + 'px)');
            setWidthStyle(style, styleResult.widthValue);
            setTransitionStyle(style, styleResult.transition);
            style.opacity = styleResult.opacity;
        }

        /**
         * Return the total number of pages.
         * @return {Number}
         */

    }, {
        key: 'getTotalPages',
        value: function getTotalPages() {
            return this._totalPages;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: 'canPaginate',
        value: function canPaginate() {
            return this.getTotalPages() > 1;
        }

        /**
         * @return {Number}
         */

    }, {
        key: '_getContainerWidth',
        value: function _getContainerWidth() {
            return this._state.containerWidth;
        }

        /**
         * @return {Number}
         */

    }, {
        key: '_getTransformValue',
        value: function _getTransformValue(containerWidth) {
            var transformValue = -containerWidth * this._state.page;

            // Last page
            if (this.getTotalPages() === this._state.page + 1 && this._itemsPerPage !== 1) {
                var itemsInLastPage = this._itemCount - this._itemsPerPage * this._state.page;

                // Need to adjust transform width if don't have full row at the end
                if (itemsInLastPage < this._itemsPerPage && this._transitionEffect === TRANSITION_EFFECT_SLIDE) {
                    transformValue += containerWidth / this._itemsPerPage * (this._itemsPerPage - itemsInLastPage);
                }
            }

            return transformValue;
        }

        /**
         * Updates the container width.
         */

    }, {
        key: '_updateContainerWidth',
        value: function _updateContainerWidth() {
            var _el$getBoundingClient = this._el.getBoundingClientRect(),
                containerWidth = _el$getBoundingClient.width;

            this._state.containerWidth = containerWidth;
        }

        /**
         * Handles carousel container width changes.
         */

    }, {
        key: '_handleContainerChange',
        value: function _handleContainerChange() {
            this._updateContainerWidth();
            // We want to temporary disable transitions.
            var savedTransitionDuration = this._transitionDuration;

            this._transitionDuration = '0';
            // Trigger to re-render the carousel.
            this._updateState();
            // Re-enable transitions.
            this._transitionDuration = savedTransitionDuration;
        }
    }]);

    return PageModel;
}(BaseModel);

module.exports = PageModel;

/***/ }),

/***/ 637:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ArrowSvgRight = __webpack_require__(356);
var ArrowSvgLeft = __webpack_require__(341);

var upperFirst = function upperFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

var Arrow = function Arrow(props) {
    var onClick = props.onClick,
        direction = props.direction,
        classNames = props.classNames;


    var arrowWrapperClass = classNames['arrowWrapper' + upperFirst(direction)] || 'arrow-carousel-arrow-wrapper-' + direction;
    var arrowClass = classNames['arrow' + upperFirst(direction)] || 'arrow-carousel-arrow-' + direction;
    var ArrowDirection = direction === 'right' ? ArrowSvgRight : ArrowSvgLeft;

    return React.createElement(
        'span',
        { className: arrowWrapperClass, onClick: onClick },
        React.createElement(ArrowDirection, { className: arrowClass })
    );
};

Arrow.propTypes = {
    onClick: PropTypes.func,
    direction: PropTypes.string,
    classNames: PropTypes.object
};

Arrow.defaultProps = {
    classNames: {}
};

var ArrowCarouselComponent = function ArrowCarouselComponent(props) {
    var showArrows = props.showArrows,
        onLeftArrowClick = props.onLeftArrowClick,
        onRightArrowClick = props.onRightArrowClick,
        createCarousel = props.createCarousel,
        classNames = props.classNames;

    return React.createElement(
        'div',
        { className: classNames.arrowCarouselWrapper || 'arrow-carousel-wrapper' },
        showArrows ? React.createElement(Arrow, { direction: 'left', onClick: onLeftArrowClick, classNames: classNames }) : null,
        createCarousel(),
        showArrows ? React.createElement(Arrow, { direction: 'right', onClick: onRightArrowClick, classNames: classNames }) : null
    );
};

ArrowCarouselComponent.displayName = 'ArrowCarouselComponent';

ArrowCarouselComponent.propTypes = {
    createCarousel: PropTypes.func,
    onLeftArrowClick: PropTypes.func,
    onRightArrowClick: PropTypes.func,
    classNames: PropTypes.object,
    showArrows: PropTypes.bool
};

ArrowCarouselComponent.defaultProps = {
    classNames: {}
};

module.exports = ArrowCarouselComponent;

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = inViewport;

var instances = [];
var supportsMutationObserver = typeof global.MutationObserver === 'function';

function inViewport(elt, params, cb) {
  var opts = {
    container: global.document.body,
    offset: 0
  };

  if (params === undefined || typeof params === 'function') {
    cb = params;
    params = {};
  }

  var container = opts.container = params.container || opts.container;
  var offset = opts.offset = params.offset || opts.offset;

  for (var i = 0; i < instances.length; i++) {
    if (instances[i].container === container) {
      return instances[i].isInViewport(elt, offset, cb);
    }
  }

  return instances[
    instances.push(createInViewport(container)) - 1
  ].isInViewport(elt, offset, cb);
}

function addEvent(el, type, fn) {
  if (el.attachEvent) {
    el.attachEvent('on' + type, fn);
  } else {
    el.addEventListener(type, fn, false);
  }
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);

    function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }
  };
}

// https://github.com/jquery/sizzle/blob/3136f48b90e3edc84cbaaa6f6f7734ef03775a07/sizzle.js#L708
var contains = function() {
  if (!global.document) {
    return true;
  }
  return global.document.documentElement.compareDocumentPosition ?
    function (a, b) {
      return !!(a.compareDocumentPosition(b) & 16);
    } :
    global.document.documentElement.contains ?
      function (a, b) {
        return a !== b && ( a.contains ? a.contains(b) : false );
      } :
      function (a, b) {
        while (b = b.parentNode) {
          if (b === a) {
            return true;
          }
        }
        return false;
      };
}

function createInViewport(container) {
  var watches = createWatches();

  var scrollContainer = container === global.document.body ? global : container;
  var debouncedCheck = debounce(watches.checkAll(watchInViewport), 15);

  addEvent(scrollContainer, 'scroll', debouncedCheck);

  if (scrollContainer === global) {
    addEvent(global, 'resize', debouncedCheck);
  }

  if (supportsMutationObserver) {
    observeDOM(watches, container, debouncedCheck);
  }

  // failsafe check, every 200ms we check for visible images
  // usecase: a hidden parent containing eleements
  // when the parent becomes visible, we have no event that the children
  // became visible
  setInterval(debouncedCheck, 150);

  function isInViewport(elt, offset, cb) {
    if (!cb) {
      return isVisible(elt, offset);
    }

    var remote = createRemote(elt, offset, cb);
    remote.watch();
    return remote;
  }

  function createRemote(elt, offset, cb) {
    function watch() {
      watches.add(elt, offset, cb);
    }

    function dispose() {
      watches.remove(elt);
    }

    return {
      watch: watch,
      dispose: dispose
    };
  }

  function watchInViewport(elt, offset, cb) {
    if (isVisible(elt, offset)) {
      watches.remove(elt);
      cb(elt);
    }
  }

  function isVisible(elt, offset) {
    if (!contains(global.document.documentElement, elt) || !contains(global.document.documentElement, container)) {
      return false;
    }

    // Check if the element is visible
    // https://github.com/jquery/jquery/blob/740e190223d19a114d5373758127285d14d6b71e/src/css/hiddenVisibleSelectors.js
    if (!elt.offsetWidth || !elt.offsetHeight) {
      return false;
    }

    var eltRect = elt.getBoundingClientRect();
    var viewport = {};

    if (container === global.document.body) {
      viewport = {
        top: -offset,
        left: -offset,
        right: global.document.documentElement.clientWidth + offset,
        bottom: global.document.documentElement.clientHeight + offset
      };
    } else {
      var containerRect = container.getBoundingClientRect();
      viewport = {
        top: containerRect.top - offset,
        left: containerRect.left - offset,
        right: containerRect.right + offset,
        bottom: containerRect.bottom + offset
      };
    }

    // The element must overlap with the visible part of the viewport
    var visible =
      (
        eltRect.right >= viewport.left &&
        eltRect.left <= viewport.right &&
        eltRect.bottom >= viewport.top &&
        eltRect.top <= viewport.bottom
      );

    return visible;
  }

  return {
    container: container,
    isInViewport: isInViewport
  };
}

function createWatches() {
  var watches = [];

  function add(elt, offset, cb) {
    if (!isWatched(elt)) {
      watches.push([elt, offset, cb]);
    }
  }

  function remove(elt) {
    var pos = indexOf(elt);
    if (pos !== -1) {
      watches.splice(pos, 1);
    }
  }

  function indexOf(elt) {
    for (var i = watches.length - 1; i >= 0; i--) {
      if (watches[i][0] === elt) {
        return i;
      }
    }
    return -1;
  }

  function isWatched(elt) {
    return indexOf(elt) !== -1;
  }

  function checkAll(cb) {
    return function () {
      for (var i = watches.length - 1; i >= 0; i--) {
        cb.apply(this, watches[i]);
      }
    };
  }

  return {
    add: add,
    remove: remove,
    isWatched: isWatched,
    checkAll: checkAll
  };
}

function observeDOM(watches, container, cb) {
  var observer = new MutationObserver(watch);
  var filter = Array.prototype.filter;
  var concat = Array.prototype.concat;

  observer.observe(container, {
    childList: true,
    subtree: true,
    // changes like style/width/height/display will be catched
    attributes: true
  });

  function watch(mutations) {
    // some new DOM nodes where previously watched
    // we should check their positions
    if (mutations.some(knownNodes) === true) {
      setTimeout(cb, 0);
    }
  }

  function knownNodes(mutation) {
    var nodes = concat.call([],
      Array.prototype.slice.call(mutation.addedNodes),
      mutation.target
    );
    return filter.call(nodes, watches.isWatched).length > 0;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var compact = __webpack_require__(1146);
var findNameSpace = __webpack_require__(289);

var _require = __webpack_require__(597),
    STORE = _require.STORE;

var _require2 = __webpack_require__(807),
    filterCollectionUniqueItems = _require2.filterCollectionUniqueItems;

var RecommendationsStore = function (_BaseStore) {
    _inherits(RecommendationsStore, _BaseStore);

    function RecommendationsStore(dispatcher) {
        _classCallCheck(this, RecommendationsStore);

        var _this = _possibleConstructorReturn(this, (RecommendationsStore.__proto__ || Object.getPrototypeOf(RecommendationsStore)).call(this, dispatcher));

        _this._collections = {};
        return _this;
    }

    _createClass(RecommendationsStore, [{
        key: 'getCollection',
        value: function getCollection(collectionKey) {
            return this._collections[collectionKey];
        }

        /**
         * Returns an array of filtered collections containing unique items.
         *
         * @param {array} collectionKeys - an array of Backbone collection keys.
         * @param {number} itemsPerPage - number of unique items to filter out.
         * @returns {array}
         */

    }, {
        key: 'getCollectionsFiltered',
        value: function getCollectionsFiltered(collectionKeys, itemsPerPage) {
            var _this2 = this;

            var collections = collectionKeys.map(function (key) {
                var collection = _this2.getCollection(key);
                return collection && collection.toJSON();
            });
            var flatCollections = compact(Array.prototype.concat.apply([], collections));

            return filterCollectionUniqueItems(flatCollections, itemsPerPage);
        }
    }, {
        key: 'getRecommendation',
        value: function getRecommendation(collectionKey) {
            var rank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var collection = this._collections[collectionKey];

            if (collection) {
                return collection.findWhere({ rank: rank }) || collection.first();
            }

            return undefined;
        }

        /**
         * Returns recommendations title and url
         */

    }, {
        key: 'getRecommendations',
        value: function getRecommendations(collectionKey) {
            var _this3 = this;

            var collection = this._collections[collectionKey];

            if (collection) {
                return collection.map(function (recommendation) {
                    return {
                        title: _this3._getTitle(recommendation),
                        url: recommendation.get('url')
                    };
                });
            }

            return [];
        }
    }, {
        key: 'getItems',
        value: function getItems(collectionKey) {
            var rank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var recommendation = this.getRecommendation(collectionKey, rank);

            if (recommendation) {
                return recommendation.get('items').toJSON();
            }

            return [];
        }
    }, {
        key: 'getUrl',
        value: function getUrl(collectionKey) {
            var rank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var recommendation = this.getRecommendation(collectionKey, rank);

            if (recommendation) {
                return recommendation.get('url');
            }

            return '';
        }
    }, {
        key: 'getType',
        value: function getType(collectionKey) {
            var rank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var recommendation = this.getRecommendation(collectionKey, rank);

            if (recommendation) {
                return recommendation.get('recommendationType');
            }

            return '';
        }

        /**
         * Returns a recommendation title to be displayed on personalization carousels
         */

    }, {
        key: 'getTitle',
        value: function getTitle(collectionKey) {
            var rank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var recommendation = this.getRecommendation(collectionKey, rank);

            return this._getTitle(recommendation);
        }
    }, {
        key: '_getTitle',
        value: function _getTitle(recommendation) {
            var recommendable = recommendation && recommendation.get('recommendable');
            var result = '';

            if (recommendable) {
                var associatedCategory = recommendation.get('associatedCategory');
                var title = findNameSpace('properties.displayName', recommendable) || findNameSpace('name', recommendable);
                result = title;

                // If it's an attribute recommendation append L1 to the title
                if (associatedCategory) {
                    var name = associatedCategory.name;

                    result += ' ' + name;
                }
            }

            return result;
        }
    }, {
        key: '_handleFetchSuccess',
        value: function _handleFetchSuccess() {
            var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var collectionKey = payload.collectionKey,
                collection = payload.collection;


            if (collectionKey) {
                this._collections[collectionKey] = collection;
                this.emitChange();
            }
        }
    }]);

    return RecommendationsStore;
}(BaseStore);

;

RecommendationsStore.storeName = 'RecommendationsStore';

RecommendationsStore.handlers = _defineProperty({}, STORE.FETCH_SUCCESS, '_handleFetchSuccess');

module.exports = RecommendationsStore;

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"tour__wrapper__3rNuG","container":"tour__container__1c0MW","close":"tour__close__De8B-","header":"tour__header__XVXZf","step":"tour__step__26kRd","content":"tour__content__3h9Uu","ctaWrapper":"tour__ctaWrapper__2fenk","hasCancel":"tour__hasCancel__3vwKD","cta":"tour__cta__Os-6R","cancel":"tour__cancel__3ysuO","tooltip":"tour__tooltip__WeOHX","visible":"tour__visible__1AzzO"};

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SoaModel = __webpack_require__(2);
var ConversationMember = module.exports = SoaModel.extend();
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var bunsen = __webpack_require__(21);
var User = __webpack_require__(28);
var Party = __webpack_require__(8);
var newsy = __webpack_require__(40);
var endpoints = __webpack_require__(6);
var userType = {
    external: 'EXTERNAL',
    seller: 'SELLER',
    buyer: 'BUYER'
};
var globalDataLogger = __webpack_require__(49);
var copyText = __webpack_require__(38)();
_.extend(ConversationMember, {
    userType: userType,
    newsy: 'ConversationMember',
    getMe : function (options) {
        var meInTheConversation;
        options = _.extend({
            userId: undefined,
            masquerade: false,
            masqueradeUserId: undefined,
            conversation: undefined
        }, options);
        meInTheConversation = newsy('ConversationMember', {
            conversation: {id: options.conversation.id}
        });
        // TODO: move this tricky masquerade logic into the entry file
        if (options.masquerade && options.masqueradeUserId) {
            globalDataLogger.event({'gotMeFromMasquerade': options.masqueradeUserId});
            meInTheConversation.set('user.id', options.masqueradeUserId);
        } else {
            globalDataLogger.event({'gotMeFromGotCurrentUser': options.userId});
            if (!options.userId) {
                throw new Error('expected options.userId in ConversationMember.getMe');
            }
            meInTheConversation.set('user.id', options.userId);
        }
        if (options.userType) {
            meInTheConversation.set('userType', options.userType);
        }
        return meInTheConversation;
    }
});
_.extend(ConversationMember.prototype, {
    url: _.compose(endpoints.conversationMembers, bunsen.getOn('id')),
    parse : function () {
        var data = ConversationMember.__super__.parse.apply(this, arguments);
        if (undefined === data.members) {
            return data; // we probably didn't get the data from endpoints.conversationMembers
        }
        if (data.members.length !== 1) {
            return data; // we don't know what to do with multiple members
        }
        return data.members[0].member;
    },
    defaults : {
        user: {},
        // conversation: {}, // messes with contact dealer
        userType: Party.ROLE_BUYER
    },
    relations : [{
        key : 'user',
        relatedModel: User,
        type : Backbone.One,
        saveJSONFields : ['id']
    }],
    getDisplayName: function () {
        var displayName = this.get('displayName');
        if ('string' === typeof displayName) {
            displayName = displayName.trim();
        }
        if (!displayName) {
            switch (this.get('userType')) {
                case userType.seller:
                    displayName = copyText.get('1stdibs dealer');
                    break;
                case userType.buyer:
                    displayName = copyText.get('1stdibs customer');
                    break;
                case userType.external:
                default:
                    displayName = copyText.get('3rd party');
                    break;
            }
        }
        return displayName;
    },
    isExternal: function () {
        return ConversationMember.userType.external === this.get('userType');
    },
    isDiscloseEmail: function () {
        return this.get('discloseEmail') === 'Y';
    },
    setDiscloseEmail: function (discloseEmail) {
        this.set('discloseEmail', discloseEmail ? 'Y' : 'N');
    },
    isOriginal: function () {
        return this.get('isOriginal') === 'Y';
    }
});


/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(686)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function() {
  root.requestAnimationFrame = raf
  root.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: hella
 * Date: 3/30/14
 * Time: 2:50 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */



var browserCheck = __webpack_require__(491);

module.exports = {
    timer: {
        count: 0,
        interval: 1000,
        fn: null
    },
    ie: {
        lessThan10: browserCheck.ie8() || browserCheck.ie9(),
        isIE9: browserCheck.ie9(),
        isIE8: browserCheck.ie8()
    },
    noop: function () { },
    disallowAction: function (e) {
        if (e) {
            e.preventDefault();
        }
        return false;
    },
    ieRedirect: function (url) {
        if (url) {
            global.location.href = url;
        }
    },
    goBack: function () {
        // this needs to be fixed to look at the document.referrer
        if (global.history && global.history.length > 1) {
            global.history.back();
        } else {
            this.ieRedirect(global.location.pathname);
        }
        return false;
    }
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var newsy = __webpack_require__(40);
module.exports = SoaModel.extend({
    defaults: {
        recipientType: 'TO',
        readMessage: 'N'
    },
    relations: [
        {
            key: 'recipientDetails',
            relatedModel : newsy.getConstructor.bind(newsy, 'ConversationMember'),
            type: Backbone.One
        }
    ]
}, {
    newsy: {
        builds: ['ConversationMember'],
        name: 'MessageRecipient'
    }
});


/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-account-filled'].join(' '), 'data-tn': 'account-filled', viewBox: '0 0 500 500' },
                React.createElement('path', { d: 'M278.088764,500 C190.723711,500 100.959616,499.78903 11.3954418,499.367089 L0,499.367089 L0.799680128,487.552743 C1.19952019,480.801688 4.9980008,421.940928 14.3942423,399.78903 C15.9936026,395.780591 26.1895242,370.886076 51.9792083,361.181435 L130.747701,327.637131 L163.934426,312.236287 C164.534186,312.025316 179.128349,305.696203 183.126749,287.341772 C183.526589,284.599156 183.326669,280.801688 182.926829,279.746835 C181.127549,276.160338 181.127549,276.160338 176.729308,270.886076 L176.529388,270.675105 C175.129948,268.987342 143.942423,229.957806 136.745302,173.628692 C136.345462,170.886076 132.546981,144.092827 136.145542,112.447257 C141.143543,67.5105485 158.336665,34.3881857 186.12555,16.6666667 C187.32507,15.8227848 213.714514,0 251.09956,0 C272.890844,0 294.082367,5.48523207 314.07437,16.0337553 C321.271491,19.4092827 381.847261,51.0548523 365.253898,175.316456 C364.854058,179.324895 358.656537,228.691983 325.669732,270.675105 C324.870052,271.518987 324.070372,272.57384 323.070772,273.839662 C321.471411,275.738397 319.272291,278.059072 318.072771,280.168776 C317.872851,281.223629 317.473011,283.966245 318.472611,287.130802 L318.672531,287.763713 L318.872451,288.607595 C319.072371,289.029536 322.271092,304.219409 341.463415,313.080169 L384.446222,333.544304 L447.820872,360.337553 C449.220312,360.970464 487.005198,376.793249 495.001999,429.324895 L495.201919,430.379747 L500,499.578059 L488.604558,499.578059 C487.604958,499.367089 407.836865,500 278.088764,500 L278.088764,500 Z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/***
 * options.conversation {Conversation Model} (required) - conversation to which this message will be posted
 * options.attachmentPingInterval {number} - how often to ping for processing attachments (in milliseconds)
 */
var SoaModel = __webpack_require__(2);
var extendCompose = __webpack_require__(43);
module.exports = extendCompose.call(SoaModel);
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var Anchor = __webpack_require__(12);
var Action = __webpack_require__(51);
var MessageRecipient = __webpack_require__(72);
var AttachmentList = __webpack_require__(233);
var Offer = __webpack_require__(25);
var ConversationMember = __webpack_require__(68);
var copyText = __webpack_require__(38)();
var defaultAttachmentPingInterval = 2000;
var Message = module.exports;
var globalDataLogger = __webpack_require__(49);
var Deferred = __webpack_require__(29).Deferred;

copyText = copyText.extend({
    noRecipients : "Your message has no recipients",
    emptyMessage : "Your message is empty"
});
module.exports.extendSelf({
    initialize : function (attributes, options) {
        this._conversation = options.conversation;
        this.options = _.extend({
            attachmentPollTimeout: 60000,
            attachmentPingInterval: defaultAttachmentPingInterval
        }, options);
        this._conversationMemberConstructor = this.options.conversationMemberConstructor || ConversationMember;
        if (this.options.action) {
            this.setAction(this.options.action);
        }
        this.on('change:viewState', this.startPollingIfAppropriate);
        this.startPollingIfAppropriate();
        return this.options;
    },
    startPollingIfAppropriate: function () {
        var viewState = this.get('viewState');
        if (viewState && 'expanded' !== viewState) {
            return;
        }
        this.off('change:viewState', this.startPollingIfAppropriate);
        this.gotAllAttachments = this.pollForAttachments();
        _.delay(function () {
            clearTimeout(this._pollforAttachmentsTimeout);
        }.bind(this), this.options.attachmentPollTimeout);
    },
    parse : function () {
        var data = Message.__super__.parse.apply(this, arguments);
        if ("string" === typeof data.isLatestMessageSender) {
            data.isLatestMessageSender = data.isLatestMessageSender === 'Y';
        }
        return data;
    },
    pollForAttachments: function () {
        var fetchOptions = {
            data: { fields: 'attachment'}
        };

        if (!this.get('attachmentCount')) {
            return Deferred().resolve();
        }
        if (!this.areAttachmentsProcessing()) {
            return Deferred().resolve();
        }
        return this.fetch(fetchOptions).then(function () {
            var pollComplete = Deferred();
            clearTimeout(this._pollforAttachmentsTimeout);
            this._pollforAttachmentsTimeout = _.delay(function () {
                this.pollForAttachments()
                    .fail(pollComplete.reject.bind(pollComplete))
                    .done(pollComplete.resolve.bind(pollComplete));
            }.bind(this), this.options.attachmentPingInterval);
            return pollComplete;
        }.bind(this));
    },
    areAttachmentsProcessing: function () {
        return !!this.get('attachments').where({processed: 'N'}).length;
    },
    idAttribute : 'id',
    url : function () {
        var conversation;
        if (this.id) {
            return endpoints.messageGET({message: this.id});
        }
        conversation = this.get('from.conversation');
        if (conversation && conversation.id) {
            return endpoints.messagePOST({conversation: conversation.id});
        }
        return endpoints.messageNewConversation();
        // TODO: throw error instead of returning messageNewConversation once contact dealer uses new ContactDealerMessage model
        //throw new Error("from.conversation.id must be set in order to create a message");
    },
    defaults : {
        attachments : [],
        recipients : []
    },
    relations: function () {
        return [
            {
                key : 'from',
                relatedModel : this._conversationMemberConstructor,
                type : Backbone.One
            },
            {
                key : 'recipients',
                relatedModel : MessageRecipient,
                type : Backbone.Many
            },
            {
                key: 'attachments',
                collectionType : AttachmentList,
                type: Backbone.Many
            },
            {
                key : 'emailDataMap',
                relatedModel : SoaModel,
                type : Backbone.One
            },
            {
                key : 'anchors',
                relatedModel : Anchor,
                type : Backbone.Many
            },
            {
                key: 'offer',
                relatedModel: Offer,
                type: Backbone.One,
                saveJSONFields: ['id', 'transaction']
            }, {
                type: Backbone.One,
                key: 'action',
                relatedModel: Action
            }
        ];
    },
    _conversationMemberConstructor: ConversationMember,
    validateMessageBody: function () {
        var trimmedBody = this.get('textBody') ? this.get('textBody').trim() : '';
        if (this.get('offer')) {
            return;
        }
        if (!trimmedBody) {
            return copyText.get('emptyMessage');
        }
    },
    validate: function () {
        if (this.get('recipients') && this.get('recipients').length === 0) {
            return copyText.get('noRecipients');
        }
        return this.validateMessageBody();
    },
    // prepare the message for a POST by infering any conspicuously missing required properties from the current running context
    preparedForPost : function (options) {
        options = _.extend({
            userId: undefined,
            masquerade: false
        }, options);
        var from = this.get('from');
        var meInTheconversation;
        if (!from) {
            meInTheconversation = this._conversationMemberConstructor.getMe(_.extend({
                userId: options.userId,
                conversation: this._conversation
            }, _.pick(options, 'masquerade')));
            this.set('from', meInTheconversation);
            from = meInTheconversation;
        }
        if (this.get('message')) {
            globalDataLogger.event({
                "detected message-in-a-message in Message.prototype.preparedForPost" : this.toJSON()
            });
        }
        var myUserId = from.get('user.id');
        var originalMembersThatArentMe = _.compact(this._conversation.get('members').map(function (member) {
            var memberUserId = member.get("user.id");
            if (memberUserId === myUserId) {
                return;
            }
            if (!memberUserId) {
                return;
            }
            if ('Y' !== member.get('isOriginal')) {
                return;
            }
            var recipientDetails = member.pick(
                'id',
                'userType' // only because this is set incorrectly in the MessageRecipient default
            );
            recipientDetails.user = {id: memberUserId};
            return new MessageRecipient({recipientDetails: recipientDetails});
        }));
        if (0 === originalMembersThatArentMe.length) {
            console.warn("message has no recipients");
        }
        this.get('recipients').add(originalMembersThatArentMe);
        this.set('subject', options.subject || _.chain(this._conversation.get('messages').pluck('subject')).compact().last().value());
        return Deferred().resolve(); // TODO: consider running the code from this method in initialize since it no longer runs asynchronously
    },
    flag: function (options) {
        options.messageId = this.get('id');
        return (new SoaModel()).save(options, { url: endpoints.flagMessage });
    },
    setAction: function (mcAction) {
        this.set('action', new Action({ name: mcAction }));
    },
    getConversation: function () {
        return this._conversation;
    },
    suppressEmails: function () {
        this.set('sendNotification', 'N');
    }
});

Object.assign(Message, {
    ReviewStatus: {
        open: 'OPEN',
        monitoring: 'MONITORING',
        inProgress: 'IN_PROGRESS',
        closed: 'CLOSED'
    },
    MC_ACTIONS: {
        contactDealer: 'CONTACT_DEALER',
        netPrice: 'NET_PRICE_REQUEST',
        mcReply: 'MC_REPLY',
        privateOffer: 'PRIVATE_OFFER',
        netPriceOffer: 'NET_PRICE_OFFER'
    }
});


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var checkProps = __webpack_require__(168);
var FieldRule = __webpack_require__(45);
var assert = __webpack_require__(31);

// ---------------------------------------------------
// Module Definition

/**
 * @class FieldValidation
 *
 * @param {object} options
 * @param {string} options.field Overrides property of the same name
 * @param {string} [options.fieldDisplayName] Overrides property of the same name
 * @param {boolean|function} [options.required=undefined] Overrides property of the same name
 * @param {function} [options.required] Overrides property of the same name
 * @param {object|FieldRule} [options.rule] Overrides property of the same name
 * @param {string} [options.ruleName] Overrides property of the same name
 * @param {object} [options.additionalRules]
 *      If you have multiple rules, use this option to pass in
 *      to the field schema.
 *
 * @property {string} field The path of the field relative to the validated root model
 * @property {string} fieldDisplayName
 *      A version of the field name that can be displayed to the user. This will be
 *      combined with a generic 'messageBody' property of a rule to create an
 *      error message to show the user. If a 'message' property is defined, that will
 *      override the automatic generation of a message with the fieldDisplayName and
 *      the messageBody
 * @property {boolean|function} required
 *      A boolean or function returning a boolean. Defaults to 'undefined'.
 * @property {boolean} autoRun
 *      Automatically run the validation when the {@link Validator} 'validate' method is called.
 * @property {object|FieldRule} rule
 *      A correctly formatted rule schema object or a FieldRule instance. Defaults to undefined.
 *      This field can be used if there is only one rule needed for a field. Otherwise you can
 *      specify all rules with 'additionalRules' option or the 'setRule' methods.
 * @property {string} ruleName
 *      A name to describe the rule. Defaults to the value of the 'field' property.
 * @property {string} ruleName
 *      A name to describe the rule. Defaults to the value of the 'field' property.
 */
var FieldValidation = module.exports = function () {
    this._rules = {};
    this.initialize.apply(this, arguments);
};

// ---------------------------------------------------
// Define Module Instance Properties

_.extend(FieldValidation.prototype, {

    autoRun: true,

    requiredMessageBody: 'is required',

    /**
     * @protected
     * Override in extension. Passed options that
     * were passed to the constructor.
     */
    initialize: function (options) {
        options = options || {};
        var self = this;

        // The path of the field from the root model
        self.field = options.field || self.field;

        // The display value of the field
        self.fieldDisplayName = options.fieldDisplayName || self.fieldDisplayName;

        // A boolean or function returning a boolean that says if the field is required to have a value or not
        self.required = !_.isUndefined(options.required) ? options.required : self.required;

        // A callback function that overrides 'required'. Instead of a callback function with the context
        // being the root model, the callback context is the FieldValidation instance and the arguments
        // are model, fieldValue, field
        self.required = !_.isUndefined(options.required) ? options.required : self.required;

        // Automatically run the validation when Rule.validate is called. True by default
        self.autoRun = !_.isUndefined(options.autoRun) ? options.autoRun : self.autoRun;

        // If you have only one rule, you can set it with this property
        self.rule = options.rule || self.rule;

        // The name of the default rule, which will default to the field name
        self.ruleName = options.ruleName || self.ruleName || self.field;

        // If the user passed rules as an option
        if (options.additionalRules) {
            self.setRulesWithMap(options.additionalRules);
        }

        // Sets the main rule using the 'rule' and 'ruleName' properties
        self.setupDefaultRule();

        // set the message for required errors if provided
        self.requiredMessage = options.requiredMessage || self.requiredMessage;
        self.setupDefaultRequiredMessage();
    },

    /**
     * @param {string} name
     * @param {object|FieldRule} rule
     * @returns {FieldValidation}
     */
    setRuleByName: function (name, rule) {
        this._rules[name] = rule;
        assert(rule instanceof FieldRule || typeof rule === 'object', 'rule must be an instance Rule or be an object');
        if (rule instanceof FieldRule && !rule.getParentValidation()) {
            rule.setParentValidation(this);
        }
        return this;
    },

    /**
     * Get a rule for a particular name
     * @param {string} name
     * @returns {object|FieldRule}
     */
    getRuleByName: function (name) {
        return this._rules[name];
    },

    /**
     * @param {object} map
     * @returns {FieldValidation}
     */
    setRulesWithMap: function (map) {
        var name;
        for (name in map) {
            if (map.hasOwnProperty(name)) {
                this.setRuleByName(name, map[name]);
            }
        }
        return this;
    },

    /**
     * @param {boolean} required
     * @returns {FieldValidation}
     */
    setRequired: function (required) {
        this.required = required;
        return this;
    },

    /**
     * @param {boolean} autoRun
     * @returns {FieldValidation}
     */
    setAutoRun: function (autoRun) {
        this.autoRun = autoRun;
        return this;
    },

    /**
     * @protected
     * @returns {FieldValidation}
     */
    setupDefaultRule: function () {
        if (this.rule) {
            this.setRuleByName(this.ruleName, this.rule);
        }
        return this;
    },

    /**
     * @param {string} name
     * @param {string} message
     * @returns {FieldValidation}
     */
    setMessageForRule: function (name, message) {
        var rule = this.getRuleByName(name);
        console.assert(rule, 'Rule for name "' + name + '" doesn\'t exist, so a message cannot be set');
        rule.setMessage(message);
        return this;
    },

    /**
     * @returns {string}
     */
    getMessageForRequired: function () {
        return this.requiredMessage;
    },

    /**
     * @param {string} message
     * @returns {FieldValidation}
     */
    setRequiredMessage: function (message) {
        this.requiredMessage = message;
        return this;
    },

    /**
     * @protected
     * @returns {FieldValidation}
     */
    setupDefaultRequiredMessage: function () {
        if (this.requiredMessage) {
            this.setRequiredMessage(_.result(this, 'requiredMessage'));
        } else if (this.fieldDisplayName) {
            this.setRequiredMessage(this.createMessageWithBody(this.requiredMessageBody));
        }
        return this;
    },

    /**
     * @param {string} name Rule name
     * @returns {string}
     */
    getMessageForRule: function (name) {
        var rule = this.getRuleByName(name);
        return rule ? _.result(rule, 'message') : null;
    },

    /**
     * Invoked by {@link Validator} in order
     * to determine if this field has a real
     * value or not (aka not empty string, null
     * or undefined)
     * @param {Backbone.Model} model
     * @param {*} val
     * @returns {boolean}
     */
    hasRealValue: function (model, val) {
        return (parseInt(val, 10) === 0 || !!val);
    },

    /**
     * Invoked by the {@link Validator} class
     * to get the value of the field for a model
     * @param {Backbone.Model} model
     * @param {string} fieldName
     * @returns {*}
     */
    getModelValueForField: function (model, fieldName) {
        return model.get(fieldName);
    },

    /**
     * Return a messageBody for a rule if it is defined
     * @param {string} name
     * @returns {string}
     */
    getMessageBodyForRule: function (name) {
        var rule = this.getRuleByName(name);
        return rule ?  _.result(rule, 'messageBody') : null;
    },

    /**
     * Get a default message for a rule if
     * the rule is defined.
     * @param {string} name
     * @returns {string}
     */
    getDefaultMessageForRule: function (name) {
        var rule = this.getRuleByName(name);
        return rule ?  _.result(rule, 'defaultMessage') : null;
    },

    /**
     * Given the fieldDisplay name and a standard
     * validation error message body, returns a
     * display message for the user.
     * @param {string} messageBody
     * @returns {string}
     */
    createMessageWithBody: function (messageBody) {
        return FieldValidation.createMessage(this.fieldDisplayName, messageBody);
    },

    /**
     * Creates a formatted schema object for
     * the @{link Validator} instance.
     * @returns {object}
     */
    outputSchema: function () {

        var schema = {
            field: this.field,
            required: _.isFunction(this.required) ? _.bind(this.required, this) : this.required,
            autoRun: this.autoRun,
            messages: {},
            rules: this._rules ? {} : null
        };

        if (this.required) {
            schema.messages.required = this.getMessageForRequired();
        }

        _.each(this._rules, function (rule, name) {

            var message;
            var messageBody;

            schema.rules[name] = (_.isFunction(rule.outputSchema)) ? rule.outputSchema() : rule;

            message = this.getMessageForRule(name);
            messageBody = this.getMessageBodyForRule(name);

            if (!message && this.fieldDisplayName && messageBody) {
                message = this.createMessageWithBody(messageBody);
            }

            // If there is no message, use a default message for the rule if it is invalid
            schema.messages[name] = message || this.getDefaultMessageForRule(name);

        }, this);

        checkProps({
            field: 'string',
            required: ['boolean', 'function'],
            autoRun: 'boolean',
            messages: 'object',
            rules: 'object'
        }, schema);

        return schema;
    }

}, Backbone.Events);

// ---------------------------------------------------
// Define Module Static Properties

_.extend(FieldValidation, {

    /**
     * @function
     * @param {object} instanceProperties
     * @param {object} staticProperties
     * @returns {function} New constructor function
     */
    extend: Backbone.Model.extend,

    /**
     * @param {string} fieldDisplayName
     * @param {string} messageBody
     * @returns {string}
     */
    createMessage: function (fieldDisplayName, messageBody) {
        return "\"" + fieldDisplayName + "\" field " + messageBody;
    }

});

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: hella
 * Date: 5/17/14
 * Time: 3:38 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

var root = "undefined" === typeof global ? window : global;
var $ = __webpack_require__(5);
var LocalStorage;
var SessionStorage;
var initializedSessionStorage;

function Storage() {
    this.data = {};
}

Storage.prototype = {
    _storage: {},
    _supported: false,

    init: function (storage) {
        this._storage = storage || root.localStorage;
        this._supported = this.isSupported();
        return this;
    },

    isSupported: function () {
        try {
            // FINDING-1393 - trying this first fixes private mode browsing in safari
            // https://github.com/marcuswestin/store.js/issues/42
            this._storage.setItem("dibsy", "");
            this._storage.removeItem("dibsy");
            return true;
        } catch (e) {
            return false;
        }
    },

    /**
     * Sets whether or not local/session storage is supported
     * @param {boolean} supported
     */
    setSupported: function (supported) {
        this._supported = supported;
    },

    getItems: function () {
        if (!this._supported) {
            return "localStorage is not supported";
        }
        return this._storage;
    },

    showAllItems: function () {
        var values = this._storage;
        var key;
        var p;
        var val;
        if (!this._supported) {
            if ($.cookie) {
                values = $.cookie(); // retrieves all cookies, but as an object not array
                for (p in values) {
                    if (values.hasOwnProperty(p)) {
                        key = p;
                        val = this.getItem(key);
                    }
                }
                return this;
            }
        }
        var len = this._storage.length;
        var i = 0;
        for (i; i < len; i++) {
            key = this._storage.key(i);
            val = this.getItem(key);
        }
        return this;
    },
    /**
     * Set storage value by the key
     *
     * @param key - {string}
     * @param value - {mixed}
     * @returns {Storage}
     */
    setItem: function (key, value) {
        switch (typeof value) {
            case 'object':
                value = JSON.stringify(value);
                break;
            default:
                value += '';
        }

        if (!this._supported) {
            this.data[key] = value;
            if ($.cookie) {
                $.cookie(key, value, {path: '/'});
            }
        } else {
            try {
                this._storage.setItem(key, value);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    },
    /**
     * Get storage value by the key
     *
     * @param key - {string}
     * @returns {mixed}
     */
    getItem: function (key) {
        var value;

        if (!key) {
            return false;
        }
        if (!this._supported) {
            if ($.cookie) {
                value = $.cookie(key);
                if (value === null && this.data[key]) {
                    value = this.data[key];
                }
            } else {
                value = this.data[key];
            }
        } else {
            value = this._storage[key];
        }

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },
    /**
     * Delete storage by the key
     *
     * @param key - {string}
     * @returns {Storage}
     */
    deleteItem: function (key) {
        if (!this._supported) {
            delete this.data[key];
            if ($.cookie) {
                $.removeCookie(key, {path: '/'});
            }
        } else {
            try {
                this._storage.removeItem(key);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    }
};

LocalStorage = new Storage();
SessionStorage = new Storage();

initializedSessionStorage = SessionStorage.init(root.sessionStorage);

module.exports = {
    localStorage: LocalStorage.init(),
    sessionStorage: initializedSessionStorage
};


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(1);
var ReactDOM = __webpack_require__(39);

var _require = __webpack_require__(136),
    provideContext = _require.provideContext,
    connectToStores = _require.connectToStores;

var User = __webpack_require__(15);
var TradeWelcomeMessage = __webpack_require__(805);
var TradeMessageStore = __webpack_require__(571);
var UserStore = __webpack_require__(114);

module.exports = {
    initWelcomeMessage: function initWelcomeMessage(context) {
        var userStore = context.getStore(UserStore);
        this.onUserStoreChange = this.onUserStoreChange.bind(this, context);
        userStore.addChangeListener(this.onUserStoreChange);
    },
    onUserStoreChange: function onUserStoreChange(context) {
        var tradeMessageStore = context.getStore(TradeMessageStore);
        var userStore = context.getStore(UserStore);
        var tradeSalesRep = userStore.getTradeSalesRep();

        if (tradeMessageStore.canShowMessage && tradeSalesRep) {
            this.renderMessage(context);
            userStore.removeChangeListener(this.onUserStoreChange);
        }
    },
    renderMessage: function renderMessage(context) {
        var tradeMessageStore = context.getStore(TradeMessageStore);
        var userStore = context.getStore(UserStore);
        var tradeSalesRep = userStore.getTradeSalesRep();

        var currentUser = User.getCurrentUser();
        var element = document.createElement('div');
        document.body.appendChild(element);

        var component = provideContext(connectToStores(TradeWelcomeMessage, [TradeMessageStore], function () {
            return {
                tradeSalesRep: tradeSalesRep,
                userFirstName: currentUser.get('profile.firstName'),
                isVisible: tradeMessageStore.canShowMessage()
            };
        }));

        ReactDOM.render(React.createElement(component, {
            context: context.getComponentContext()
        }), element);
    }
};

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var result = __webpack_require__(263);
var assign = __webpack_require__(258);
var map = __webpack_require__(261);
var forEach = __webpack_require__(259);
var isArray = __webpack_require__(260);
var isFunction = __webpack_require__(102);
var mapValues = __webpack_require__(262);
var composeClassNames = __webpack_require__(104);
var matches = __webpack_require__(37);
var View = __webpack_require__(93).View;
var TemplateView = module.exports = __webpack_require__(214).withMiddleware({
    afterPrototype: function (parentPrototype, childPrototypeBefore, childPrototypeAfter) {
        if (!childPrototypeAfter.template) {
            return childPrototypeAfter;
        }
        var newLocalClassNames;
        if (childPrototypeAfter.template.local__) {
            newLocalClassNames = composeClassNames(
                childPrototypeAfter.template.local,
                childPrototypeAfter.template.local__
            );
        } else if (childPrototypeAfter.template.__local) {
            newLocalClassNames = composeClassNames(
                childPrototypeAfter.template.__local,
                childPrototypeAfter.template.local
            );
        } else {
            return undefined;
        }
        assign(childPrototypeAfter,
            {
                template: assign({},
                    childPrototypeAfter.template,
                    {
                        local: newLocalClassNames
                    }
                )
            }
        );
    }
}).call(View, {});
var normalizeToView = __webpack_require__(249); // must come after TemplateView is defined in order to resolve circular dependency

var prototype = {
    templateVars: function () {
        return this.model ? this.model.toJSON() : {};
    },
    getSubElement : function (subViewKey) {
        var subSelector = "[data-append=" + subViewKey + "]";
        var subs = this.$(subSelector);
        if (matches(this.el, subSelector)) {
            subs = subs.concat([this.el]);
        }
        return subs[0];
    },
    getSubView : function (subViewKey) {
        return this._subs[subViewKey];
    },
    initialize: function (options) {
        var scope;
        var useInnerElement;
        var local;
        var renderedTemplate;
        options = options || {};
        scope = options.scope || this.scope || {};
        this.templateVars = options.templateVars || this.templateVars;
        this.template = options.template || this.template;
        if (!isFunction(this.template) && this.template instanceof Object) {
            useInnerElement = this.template.useInnerElement;
            local = this.template.local;
            this.template = this.template.src;
        }
        if (undefined === useInnerElement) {
            useInnerElement = useInnerElement || options.useInnerElement;
        }
        if (this.templateVars instanceof Function) {
            this.templateVars = this.templateVars.apply(this);
        }
        if (scope instanceof Function) {
            scope = scope.apply(this);
        }
        if (!this.template) {
            throw new Error("no template provided to template view");
        }
        if (local) {
            this.templateVars = assign({local: local}, this.templateVars);
        }
        renderedTemplate = this.template(this.templateVars);
        if (undefined === renderedTemplate) {
            renderedTemplate = "";
        }
        var innerElBuilder = document.createElement('div');
        innerElBuilder.innerHTML = renderedTemplate.trim();
        var innerEls = Array.prototype.slice.call(innerElBuilder.childNodes);
        if (useInnerElement) {
            if (innerEls.length !== 1) {
                throw new Error("useInnerElement requires template with a single root element. There are " + innerEls.length);
            }
            this.setElement(innerEls[0]);
        } else {
            innerEls.forEach(this.el.appendChild.bind(this.el));
        }
        this._subs = mapValues(scope, function (subViews, appendKey) {
            var el = this.getSubElement(appendKey);
            var wasArray = true;
            if (!el) {
                return undefined; // couldn't identify a subview parent
            }
            if (!isArray(subViews)) {
                subViews = [subViews];
                wasArray = false;
            }
            if (!subViews) {
                return undefined;
            }
            subViews = map(subViews, function (subView, i) {
                var innerEl = el;
                if (wasArray) {
                    innerEl = document.createElement(el.tagName);
                    innerEl.setAttribute('data-template-view-child', i);
                    el.appendChild(innerEl);
                }
                subView = normalizeToView({
                    defaultContext: this,
                    defaultParentElement: innerEl,
                    defaultTemplateVars: this.templateVars,
                    content: subView,
                    Constructor: this.defaultConstructor
                });
                if (false === subView) {
                    // TODO: test this
                    innerEl.parentNode.removeChild(innerEl);
                }
                if (!subView) {
                    return undefined;
                }
                if (innerEl !== subView.el) {
                    innerEl.appendChild(subView.el);
                }
                return subView;
            }.bind(this));
            if (!wasArray) {
                subViews = subViews[0];
            }
            if (this.subViewAppended) {
                this.subViewAppended(subViews);
            }
            if (!subViews) {
                return undefined;
            }
            return subViews;
        }.bind(this));
        return options;
    },
    render: function () {
        // overriding render so the subviews dont get blown away after initialize runs
        forEach(this._subs, function (subarray) {
            if (!isArray(subarray)) {
                subarray = [subarray];
            }
            forEach(subarray, function (sub) {
                result(sub, 'render');
            });
        });
        return this;
    }
};
TemplateView.extendSelf(assign(prototype, {
    defaultConstructor: TemplateView
}));


/***/ }),

/***/ 770:
/***/ (function(module, exports) {

module.exports = {
	"collapsed": "See a message from <span class=\"{repClass}\">{repFirstName}</span>, your trade specialist.",
	"expanded": [
		"Hi, this is {repFirstName}, your trade specialist. Please do not hesitate to reach out if I can be of assistance with anything from sourcing to pricing to shipping. I am available Monday through Friday from 9 am to 5 pm ET.",
		"Enjoy shopping!",
		"Sincerely,"
	]
};

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _ = __webpack_require__(0);
var TransactionShipmentQuote = __webpack_require__(36);
var ShipmentQuotes = __webpack_require__(316);
var Party = __webpack_require__(8);
var Anchor = __webpack_require__(12);
var ShipmentQuote = __webpack_require__(74);
var assert = __webpack_require__(31);
var TransactionShipmentQuotes;

var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};

/**
 * @class TransactionShipmentQuotes
 * @extends SoaCollection
 * @property {Offer} model {@link Offer}
 * @property {endpoints.offers} url -
 */
TransactionShipmentQuotes = root.bunsen.TransactionShipmentQuotes = ShipmentQuotes.extend({
    model: TransactionShipmentQuote,
    _newTransactionShipmentQuote: function (quoteAttrs, options) {
        var sq;
        options = _.defaults(options || {}, {
            add: true
        });
        quoteAttrs.billToRole = quoteAttrs.billToRole || quoteAttrs.authorRole;
        sq = new TransactionShipmentQuote(_.extend({
            type: ShipmentQuote.TYPE_TRANSACTION,
            pricingType: ShipmentQuote.PRICING_TYPE_COMMERCIAL,
            anchor: {
                sourceType: Anchor.TYPE_TRANSACTION,
                sourceId: this.getTransactionId()
            },
            handlingTime: {}
        }, quoteAttrs));

        if (options.add) {
            this.add(sq);
        }
        return sq;
    },
    /**
     * Returns new TransactionShipmentQuote with Dealer author/billTo
     * @param {object} [options]
     * @param {boolean} [options.add=true] Adds to collection instance
     * @returns {TransactionShipmentQuote}
     */
    newDealerTransactionShipmentQuote: function (options) {
        var quoteAttrs;
        var sq;
        assert(this.parents && this.parents[0], 'TransactionShipmentQuotes must be relation of Transaction');
        quoteAttrs = {
            author: { role: Party.ROLE_SELLER },
            billTo: { role: Party.ROLE_SELLER }
        };
        sq = this._newTransactionShipmentQuote(quoteAttrs, options);
        sq.set('serviceMethod', {});
        return sq;
    },
    /**
     * Returns new TransactionShipmentQuote with Internal author/billTo
     * @param {object} [options]
     * @param {boolean} [options.add=true] Adds to collection instance
     * @returns {TransactionShipmentQuote}
     */
    new1stdibsTransactionShipmentQuote: function (options, passedQuoteAttrs) {
        var quoteAttrs;
        assert(this.parents && this.parents[0], 'TransactionShipmentQuotes must be relation of Transaction');
        quoteAttrs = _.defaults({
            author: { role: Party.ROLE_INTERNAL },
            billTo: { role: Party.ROLE_INTERNAL }
        }, passedQuoteAttrs);
        return this._newTransactionShipmentQuote(quoteAttrs, options);
    },
    getTransactionId: function () {
        // This collection should only be a relation to a Transaction
        return this.parents[0].get('id');
    },
    _findByFunction: function (fn) {
        return this.find(function (quote) {
            return quote[fn]();
        });
    },
    _findActiveQuoteByFunction: function (fn) {
        return this.find(function (quote) {
            return quote[fn]() && quote.isActive();
        });
    },
    getPreQuote: function () {
        return this._findActiveQuoteByFunction('isPreQuote');
    },
    getDealerQuote: function () {
        return this._findActiveQuoteByFunction('isDealerBilledQuote');
    },
    get1stdibsQuote: function () {
        return this._findActiveQuoteByFunction('is1stdibsQuote');
    },
    getActiveAccountingQuote: function () {
        return this._findByFunction('isActiveAccountingQuote');
    },
    getRejectedAccountingQuote: function () {
        return this._findByFunction('isRejectedAccountingQuote');
    },
    getActiveAccountingQuoteSubTotal: function (currency) {
        var quote = this.getActiveAccountingQuote();
        if (quote) {
            return quote.getSubTotal(currency);
        }
        return null;
    },
    getActiveAccountingQuoteTotal: function (currency) {
        var quote = this.getActiveAccountingQuote();
        if (quote) {
            return quote.getTotalAmount(currency);
        }
        return null;
    },
    hasPreQuote: function () {
        return !!this.getPreQuote();
    },
    hasPreQuoteIncludingCanceled: function () {
        return !!this._findByFunction('isPreQuote');
    }
});

module.exports = TransactionShipmentQuotes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var Component = function (_React$Component) {
            _inherits(Component, _React$Component);

            function Component() {
                        _classCallCheck(this, Component);

                        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
            }

            _createClass(Component, [{
                        key: 'render',
                        value: function render() {
                                    return React.createElement(
                                                'svg',
                                                { className: [this.props.className, 'dibsvg-svg dibsvg-logo-no-reg'].join(' '), 'data-tn': 'logo-no-reg', viewBox: '0 0 100 25' },
                                                React.createElement(
                                                            'g',
                                                            null,
                                                            React.createElement('path', { d: 'M15.7,0L9.6,20.2c-0.3,1.1-0.5,1.7-0.5,2c0,0.3,0.1,0.6,0.3,0.9c0.2,0.3,0.5,0.5,0.7,0.6 c0.3,0.1,1,0.2,2.3,0.2l-0.2,0.6H0l0.2-0.6c1.2,0,2.1-0.1,2.6-0.3c0.5-0.2,0.9-0.5,1.2-0.9c0.3-0.4,0.6-1.2,1-2.5L8.5,8.2 c0.6-1.8,0.9-2.8,0.9-2.9C9.5,5,9.5,4.7,9.5,4.5C9.5,4,9.4,3.5,9,3.2C8.7,2.9,8.2,2.8,7.6,2.8c-0.3,0-0.9,0-1.8,0.1L5.7,2.2 L14.9,0H15.7z' }),
                                                            React.createElement('path', { d: 'M28.5,8.1l-0.8,5.5H27c-0.1-1.4-0.5-2.5-1.3-3.3c-0.8-0.8-1.6-1.2-2.5-1.2c-0.5,0-1,0.2-1.4,0.5 c-0.4,0.3-0.5,0.7-0.5,1.1c0,0.4,0.1,0.7,0.2,1.1c0.2,0.3,0.5,0.8,1,1.3c1.9,2,3,3.4,3.4,4.1c0.4,0.8,0.6,1.6,0.6,2.4 c0,0.9-0.2,1.8-0.7,2.6c-0.5,0.8-1.2,1.5-2.1,2c-1,0.5-1.9,0.7-3,0.7c-0.7,0-1.6-0.1-2.6-0.4c-0.7-0.2-1.2-0.3-1.5-0.3 c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.3-0.6,0.5h-0.7l0.9-5.9h0.6c0.4,1.4,0.8,2.5,1.2,3.1c0.4,0.6,0.9,1.1,1.5,1.5 c0.6,0.4,1.2,0.5,1.8,0.5c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.1-1.1-0.4-1.6c-0.3-0.5-0.9-1.3-1.9-2.4 c-1.4-1.5-2.3-2.7-2.8-3.5c-0.3-0.6-0.5-1.3-0.5-2c0-1.3,0.5-2.3,1.4-3.2c0.9-0.9,2.3-1.3,4-1.3c0.7,0,1.7,0.1,2.7,0.4 c0.5,0.1,1,0.2,1.3,0.2c0.5,0,0.8-0.2,1.1-0.6H28.5z' }),
                                                            React.createElement('path', { d: 'M40,3.8l-1.5,4.8h2l-0.6,2h-2L34.6,21c-0.2,0.6-0.3,1.1-0.3,1.5c0,0.1,0.1,0.2,0.2,0.3 c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.4-0.1,0.6-0.2c0.5-0.4,1.2-1.1,1.9-2.2l0.6,0.4c-0.8,1.4-1.7,2.5-2.7,3.1c-1,0.7-2,1-2.9,1 c-0.8,0-1.4-0.2-1.9-0.6c-0.4-0.4-0.7-0.9-0.7-1.5c0-0.7,0.2-1.6,0.5-2.6l3.1-9.6H31l0.3-1.3c1.5-0.6,2.7-1.2,3.8-1.9 c1.1-0.7,2.4-1.9,3.9-3.6H40z' }),
                                                            React.createElement('path', { d: 'M59.6,0l-6.1,19.8C53.2,21,53,21.7,53,22c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.4-0.1,0.7-0.3 c0.4-0.3,1-1,1.6-1.9l0.6,0.3c-1.7,2.9-3.5,4.4-5.6,4.4c-0.7,0-1.3-0.2-1.7-0.6c-0.4-0.4-0.6-0.8-0.6-1.4c0-0.6,0.2-1.3,0.5-2.4 l0.6-1.8c-1.5,2.6-2.8,4.3-3.9,5.2c-0.8,0.6-1.7,1-2.4,1c-0.9,0-1.7-0.4-2.3-1.1S40,22.2,40,20.8c0-1.8,0.4-3.5,1.2-5.2 c0.8-1.7,1.7-3.1,2.8-4.3c1-1.1,2-2,3-2.4c0.9-0.5,1.9-0.7,2.8-0.7c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.8,0.6,1.3,1.1l1.4-4.4 c0.4-1.1,0.5-1.9,0.5-2.4c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.2,0-0.4,0-0.7,0.1l0.2-0.7L58.5,0H59.6z M51.6,11.2 c0-0.7-0.1-1.2-0.4-1.6c-0.3-0.3-0.6-0.5-1-0.5c-0.4,0-0.8,0.2-1.3,0.6c-0.9,0.8-1.8,2.3-2.7,4.6c-0.9,2.3-1.4,4.2-1.4,5.8 c0,0.6,0.1,1,0.3,1.3c0.2,0.3,0.4,0.4,0.7,0.4c0.4,0,0.9-0.2,1.3-0.6c1-0.9,2.1-2.4,3.1-4.6C51.1,14.3,51.6,12.5,51.6,11.2z' }),
                                                            React.createElement('path', { d: 'M66,0c0.7,0,1.4,0.3,1.9,0.8c0.5,0.5,0.8,1.1,0.8,1.8c0,0.7-0.3,1.3-0.8,1.8C67.4,5,66.8,5.2,66,5.2 c-0.7,0-1.3-0.3-1.9-0.8c-0.5-0.5-0.8-1.1-0.8-1.8c0-0.7,0.3-1.3,0.8-1.8C64.7,0.3,65.3,0,66,0z M67.5,8.1l-4,12.5 c-0.2,0.7-0.3,1.2-0.3,1.4c0,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.2,0,0.4-0.1,0.6-0.3c0.5-0.5,1.2-1.3,1.9-2.5l0.6,0.4 C65,23.4,63,25,61,25c-0.8,0-1.4-0.2-1.9-0.6c-0.5-0.4-0.7-1-0.7-1.6c0-0.4,0.1-1,0.3-1.7l2.8-8.5c0.3-0.8,0.4-1.4,0.4-1.8 c0-0.3-0.1-0.5-0.4-0.7c-0.2-0.2-0.6-0.3-1-0.3c-0.2,0-0.4,0-0.7,0l0.2-0.7l6.3-1H67.5z' }),
                                                            React.createElement('path', { d: 'M80,0l-3.2,10.6c0.9-1,1.7-1.7,2.3-2c0.6-0.3,1.3-0.5,2-0.5c1.4,0,2.4,0.5,3.1,1.5c0.7,1,1,2.2,1,3.5 c0,3.2-1.1,6-3.4,8.5c-2,2.2-4.4,3.3-7,3.3c-1.9,0-4-0.6-6.1-1.7l5.6-18.6c0.3-0.9,0.4-1.5,0.4-1.9c0-0.3-0.1-0.5-0.4-0.7 c-0.4-0.3-0.9-0.4-1.6-0.3l0.2-0.7L78.9,0H80z M73,23.5c0.5,0.4,1,0.5,1.5,0.5c0.6,0,1.1-0.1,1.5-0.4c0.7-0.4,1.3-1.1,2.1-2.2 c0.7-1.1,1.3-2.3,1.8-3.8c0.5-1.5,0.7-3,0.7-4.4c0-0.8-0.2-1.5-0.5-1.9c-0.4-0.4-0.8-0.7-1.2-0.7c-0.8,0-1.5,0.4-2,1.2 c-0.4,0.5-0.8,1.7-1.3,3.4L73,23.5z' }),
                                                            React.createElement('path', { d: 'M100,8.1l-0.8,5.5h-0.7c-0.1-1.4-0.5-2.5-1.3-3.3c-0.8-0.8-1.6-1.2-2.5-1.2c-0.5,0-1,0.2-1.4,0.5 c-0.4,0.3-0.5,0.7-0.5,1.1c0,0.4,0.1,0.7,0.2,1.1c0.2,0.3,0.5,0.8,1,1.3c1.9,2,3,3.4,3.4,4.1c0.4,0.8,0.6,1.6,0.6,2.4 c0,0.9-0.2,1.8-0.7,2.6c-0.5,0.8-1.2,1.5-2.1,2c-1,0.5-1.9,0.7-3,0.7c-0.7,0-1.6-0.1-2.6-0.4c-0.7-0.2-1.2-0.3-1.5-0.3 c-0.3,0-0.5,0-0.7,0.1c-0.2,0.1-0.4,0.3-0.6,0.5h-0.7l0.9-5.9h0.6c0.4,1.4,0.8,2.5,1.2,3.1c0.4,0.6,0.9,1.1,1.5,1.5 c0.6,0.4,1.2,0.5,1.8,0.5c0.7,0,1.2-0.2,1.6-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.1-1.1-0.4-1.6c-0.3-0.5-0.9-1.3-1.9-2.4 c-1.4-1.5-2.3-2.7-2.8-3.5c-0.3-0.6-0.5-1.3-0.5-2c0-1.3,0.5-2.3,1.4-3.2c0.9-0.9,2.3-1.3,4-1.3c0.7,0,1.7,0.1,2.7,0.4 c0.5,0.1,1,0.2,1.3,0.2c0.5,0,0.8-0.2,1.1-0.6H100z' })
                                                )
                                    );
                        }
            }]);

            return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.7.1
(function() {
    var $, cardFromNumber, cardFromType, cards, defaultFormat, formatBackCardNumber, formatBackExpiry, formatCardNumber, formatExpiry, formatForwardExpiry, formatForwardSlashAndSpace, hasTextSelected, luhnCheck, reFormatCVC, reFormatCardNumber, reFormatExpiry, reFormatNumeric, restrictCVC, restrictCardNumber, restrictExpiry, restrictNumeric, safeVal, setCardType,
        __slice = [].slice,
        __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

    $ = __webpack_require__(5);;

    $.payment = {};

    $.payment.fn = {};

    $.fn.payment = function() {
        var args, method;
        method = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
        return $.payment.fn[method].apply(this, args);
    };

    defaultFormat = /(\d{1,4})/g;

    $.payment.cards = cards = [
        {
            type: 'visaelectron',
            pattern: /^4(026|17500|405|508|844|91[37])/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'maestro',
            pattern: /^(5(018|0[23]|[68])|6(39|7))/,
            format: defaultFormat,
            length: [12, 13, 14, 15, 16, 17, 18, 19],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'forbrugsforeningen',
            pattern: /^600/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'dankort',
            pattern: /^5019/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'visa',
            pattern: /^4/,
            format: defaultFormat,
            length: [13, 16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'mastercard',
            pattern: /^(5[0-5]|2[2-7])/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'amex',
            pattern: /^3[47]/,
            format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
            length: [15],
            cvcLength: [3, 4],
            luhn: true
        }, {
            type: 'dinersclub',
            pattern: /^3[0689]/,
            format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
            length: [14],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'discover',
            pattern: /^6([045]|22)/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'unionpay',
            pattern: /^(62|88)/,
            format: defaultFormat,
            length: [16, 17, 18, 19],
            cvcLength: [3],
            luhn: false
        }, {
            type: 'jcb',
            pattern: /^35/,
            format: defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }
    ];

    cardFromNumber = function(num) {
        var card, _i, _len;
        num = (num + '').replace(/\D/g, '');
        for (_i = 0, _len = cards.length; _i < _len; _i++) {
            card = cards[_i];
            if (card.pattern.test(num)) {
                return card;
            }
        }
    };

    cardFromType = function(type) {
        var card, _i, _len;
        for (_i = 0, _len = cards.length; _i < _len; _i++) {
            card = cards[_i];
            if (card.type === type) {
                return card;
            }
        }
    };

    luhnCheck = function(num) {
        var digit, digits, odd, sum, _i, _len;
        odd = true;
        sum = 0;
        digits = (num + '').split('').reverse();
        for (_i = 0, _len = digits.length; _i < _len; _i++) {
            digit = digits[_i];
            digit = parseInt(digit, 10);
            if ((odd = !odd)) {
                digit *= 2;
            }
            if (digit > 9) {
                digit -= 9;
            }
            sum += digit;
        }
        return sum % 10 === 0;
    };

    hasTextSelected = function($target) {
        var _ref;
        if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== $target.prop('selectionEnd')) {
            return true;
        }
        if ((typeof document !== "undefined" && document !== null ? (_ref = document.selection) != null ? _ref.createRange : void 0 : void 0) != null) {
            if (document.selection.createRange().text) {
                return true;
            }
        }
        return false;
    };

    safeVal = function(value, $target) {
        var cursor, error;
        try {
            cursor = $target.prop('selectionStart');
        } catch (_error) {
            error = _error;
            cursor = null;
        }
        $target.val(value);
        if (cursor !== null && $target.is(":focus")) {
            $target.prop('selectionStart', cursor);
            return $target.prop('selectionEnd', cursor);
        }
    };

    reFormatNumeric = function(e) {
        return setTimeout(function() {
            var $target, value;
            $target = $(e.currentTarget);
            value = $target.val();
            value = value.replace(/\D/g, '');
            return safeVal(value, $target);
        });
    };

    reFormatCardNumber = function(e) {
        return setTimeout(function() {
            var $target, value;
            $target = $(e.currentTarget);
            value = $target.val();
            value = $.payment.formatCardNumber(value);
            return safeVal(value, $target);
        });
    };

    formatCardNumber = function(e) {
        var $target, card, digit, length, re, upperLength, value;
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        $target = $(e.currentTarget);
        value = $target.val();
        card = cardFromNumber(value + digit);
        length = (value.replace(/\D/g, '') + digit).length;
        upperLength = 16;
        if (card) {
            upperLength = card.length[card.length.length - 1];
        }
        if (length >= upperLength) {
            return;
        }
        if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
            return;
        }
        if (card && card.type === 'amex') {
            re = /^(\d{4}|\d{4}\s\d{6})$/;
        } else {
            re = /(?:^|\s)(\d{4})$/;
        }
        if (re.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val(value + ' ' + digit);
            });
        } else if (re.test(value + digit)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val(value + digit + ' ');
            });
        }
    };

    formatBackCardNumber = function(e) {
        var $target, value;
        $target = $(e.currentTarget);
        value = $target.val();
        if (e.which !== 8) {
            return;
        }
        if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
            return;
        }
        if (/\d\s$/.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val(value.replace(/\d\s$/, ''));
            });
        } else if (/\s\d?$/.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val(value.replace(/\d$/, ''));
            });
        }
    };

    reFormatExpiry = function(e) {
        return setTimeout(function() {
            var $target, value;
            $target = $(e.currentTarget);
            value = $target.val();
            value = $.payment.formatExpiry(value);
            return safeVal(value, $target);
        });
    };

    formatExpiry = function(e) {
        var $target, digit, val;
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        $target = $(e.currentTarget);
        val = $target.val() + digit;
        if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val("0" + val + " / ");
            });
        } else if (/^\d\d$/.test(val)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val("" + val + " / ");
            });
        }
    };

    formatForwardExpiry = function(e) {
        var $target, digit, val;
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        $target = $(e.currentTarget);
        val = $target.val();
        if (/^\d\d$/.test(val)) {
            return $target.val("" + val + " / ");
        }
    };

    formatForwardSlashAndSpace = function(e) {
        var $target, val, which;
        which = String.fromCharCode(e.which);
        if (!(which === '/' || which === ' ')) {
            return;
        }
        $target = $(e.currentTarget);
        val = $target.val();
        if (/^\d$/.test(val) && val !== '0') {
            return $target.val("0" + val + " / ");
        }
    };

    formatBackExpiry = function(e) {
        var $target, value;
        $target = $(e.currentTarget);
        value = $target.val();
        if (e.which !== 8) {
            return;
        }
        if (($target.prop('selectionStart') != null) && $target.prop('selectionStart') !== value.length) {
            return;
        }
        if (/\d\s\/\s$/.test(value)) {
            e.preventDefault();
            return setTimeout(function() {
                return $target.val(value.replace(/\d\s\/\s$/, ''));
            });
        }
    };

    reFormatCVC = function(e) {
        return setTimeout(function() {
            var $target, value;
            $target = $(e.currentTarget);
            value = $target.val();
            value = value.replace(/\D/g, '').slice(0, 4);
            return safeVal(value, $target);
        });
    };

    restrictNumeric = function(e) {
        var input;
        if (e.metaKey || e.ctrlKey) {
            return true;
        }
        if (e.which === 32) {
            return false;
        }
        if (e.which === 0) {
            return true;
        }
        if (e.which < 33) {
            return true;
        }
        input = String.fromCharCode(e.which);
        return !!/[\d\s]/.test(input);
    };

    restrictCardNumber = function(e) {
        var $target, card, digit, value;
        $target = $(e.currentTarget);
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        if (hasTextSelected($target)) {
            return;
        }
        value = ($target.val() + digit).replace(/\D/g, '');
        card = cardFromNumber(value);
        if (card) {
            return value.length <= card.length[card.length.length - 1];
        } else {
            return value.length <= 16;
        }
    };

    restrictExpiry = function(e) {
        var $target, digit, value;
        $target = $(e.currentTarget);
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        if (hasTextSelected($target)) {
            return;
        }
        value = $target.val() + digit;
        value = value.replace(/\D/g, '');
        if (value.length > 6) {
            return false;
        }
    };

    restrictCVC = function(e) {
        var $target, digit, val;
        $target = $(e.currentTarget);
        digit = String.fromCharCode(e.which);
        if (!/^\d+$/.test(digit)) {
            return;
        }
        if (hasTextSelected($target)) {
            return;
        }
        val = $target.val() + digit;
        return val.length <= 4;
    };

    setCardType = function(e) {
        var $target, allTypes, card, cardType, val;
        $target = $(e.currentTarget);
        val = $target.val();
        cardType = $.payment.cardType(val) || 'unknown';
        if (!$target.hasClass(cardType)) {
            allTypes = (function() {
                var _i, _len, _results;
                _results = [];
                for (_i = 0, _len = cards.length; _i < _len; _i++) {
                    card = cards[_i];
                    _results.push(card.type);
                }
                return _results;
            })();
            $target.removeClass('unknown');
            $target.removeClass(allTypes.join(' '));
            $target.addClass(cardType);
            $target.toggleClass('identified', cardType !== 'unknown');
            return $target.trigger('payment.cardType', cardType);
        }
    };

    $.payment.fn.formatCardCVC = function() {
        this.on('keypress', restrictNumeric);
        this.on('keypress', restrictCVC);
        this.on('paste', reFormatCVC);
        this.on('change', reFormatCVC);
        this.on('input', reFormatCVC);
        return this;
    };

    $.payment.fn.formatCardExpiry = function() {
        this.on('keypress', restrictNumeric);
        this.on('keypress', restrictExpiry);
        this.on('keypress', formatExpiry);
        this.on('keypress', formatForwardSlashAndSpace);
        this.on('keypress', formatForwardExpiry);
        this.on('keydown', formatBackExpiry);
        this.on('change', reFormatExpiry);
        this.on('input', reFormatExpiry);
        return this;
    };

    $.payment.fn.formatCardNumber = function() {
        this.on('keypress', restrictNumeric);
        this.on('keypress', restrictCardNumber);
        this.on('keypress', formatCardNumber);
        this.on('keydown', formatBackCardNumber);
        this.on('keyup', setCardType);
        this.on('paste', reFormatCardNumber);
        this.on('change', reFormatCardNumber);
        this.on('input', reFormatCardNumber);
        this.on('input', setCardType);
        return this;
    };

    $.payment.fn.restrictNumeric = function() {
        this.on('keypress', restrictNumeric);
        this.on('paste', reFormatNumeric);
        this.on('change', reFormatNumeric);
        this.on('input', reFormatNumeric);
        return this;
    };

    $.payment.fn.cardExpiryVal = function() {
        return $.payment.cardExpiryVal($(this).val());
    };

    $.payment.cardExpiryVal = function(value) {
        var month, prefix, year, _ref;
        _ref = value.split(/[\s\/]+/, 2), month = _ref[0], year = _ref[1];
        if ((year != null ? year.length : void 0) === 2 && /^\d+$/.test(year)) {
            prefix = (new Date).getFullYear();
            prefix = prefix.toString().slice(0, 2);
            year = prefix + year;
        }
        month = parseInt(month, 10);
        year = parseInt(year, 10);
        return {
            month: month,
            year: year
        };
    };

    $.payment.validateCardNumber = function(num) {
        var card, _ref;
        num = (num + '').replace(/\s+|-/g, '');
        if (!/^\d+$/.test(num)) {
            return false;
        }
        card = cardFromNumber(num);
        if (!card) {
            return false;
        }
        return (_ref = num.length, __indexOf.call(card.length, _ref) >= 0) && (card.luhn === false || luhnCheck(num));
    };

    $.payment.validateCardExpiry = function(month, year) {
        var currentTime, expiry, _ref;
        if (typeof month === 'object' && 'month' in month) {
            _ref = month, month = _ref.month, year = _ref.year;
        }
        if (!(month && year)) {
            return false;
        }
        month = $.trim(month);
        year = $.trim(year);
        if (!/^\d+$/.test(month)) {
            return false;
        }
        if (!/^\d+$/.test(year)) {
            return false;
        }
        if (!((1 <= month && month <= 12))) {
            return false;
        }
        if (year.length === 2) {
            if (year < 70) {
                year = "20" + year;
            } else {
                year = "19" + year;
            }
        }
        if (year.length !== 4) {
            return false;
        }
        expiry = new Date(year, month);
        currentTime = new Date;
        expiry.setMonth(expiry.getMonth() - 1);
        expiry.setMonth(expiry.getMonth() + 1, 1);
        return expiry > currentTime;
    };

    $.payment.validateCardCVC = function(cvc, type) {
        var card, _ref;
        cvc = $.trim(cvc);
        if (!/^\d+$/.test(cvc)) {
            return false;
        }
        card = cardFromType(type);
        if (card != null) {
            return _ref = cvc.length, __indexOf.call(card.cvcLength, _ref) >= 0;
        } else {
            return cvc.length >= 3 && cvc.length <= 4;
        }
    };

    $.payment.cardType = function(num) {
        var _ref;
        if (!num) {
            return null;
        }
        return ((_ref = cardFromNumber(num)) != null ? _ref.type : void 0) || null;
    };

    $.payment.formatCardNumber = function(num) {
        var card, groups, upperLength, _ref;
        num = num.replace(/\D/g, '');
        card = cardFromNumber(num);
        if (!card) {
            return num;
        }
        upperLength = card.length[card.length.length - 1];
        num = num.slice(0, upperLength);
        if (card.format.global) {
            return (_ref = num.match(card.format)) != null ? _ref.join(' ') : void 0;
        } else {
            groups = card.format.exec(num);
            if (groups == null) {
                return;
            }
            groups.shift();
            groups = $.grep(groups, function(n) {
                return n;
            });
            return groups.join(' ');
        }
    };

    $.payment.formatExpiry = function(expiry) {
        var mon, parts, sep, year;
        parts = expiry.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/);
        if (!parts) {
            return '';
        }
        mon = parts[1] || '';
        sep = parts[2] || '';
        year = parts[3] || '';
        if (year.length > 0) {
            sep = ' / ';
        } else if (sep === ' /') {
            mon = mon.substring(0, 1);
            sep = '';
        } else if (mon.length === 2 || sep.length > 0) {
            sep = ' / ';
        } else if (mon.length === 1 && (mon !== '0' && mon !== '1')) {
            mon = "0" + mon;
            sep = ' / ';
        }
        return mon + sep + year;
    };

}).call(this);


/***/ }),

/***/ 792:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalOverlay":"tradeWelcomeMessage__modalOverlay__1OslN","modalContent":"tradeWelcomeMessage__modalContent__3ZHg2","isExpanded":"tradeWelcomeMessage__isExpanded__qzHW6","isExpandedNoName":"tradeWelcomeMessage__isExpandedNoName__1R_W9","pictureWrapper":"tradeWelcomeMessage__pictureWrapper__2d3Ep","pictureTourWrapper":"tradeWelcomeMessage__pictureTourWrapper__3ytYN","picture":"tradeWelcomeMessage__picture__6MRiB","content":"tradeWelcomeMessage__content__3c36m","collapsedContent":"tradeWelcomeMessage__collapsedContent__2uBNd tradeWelcomeMessage__content__3c36m","expandedTitle":"tradeWelcomeMessage__expandedTitle__q1pnz","paragraph":"tradeWelcomeMessage__paragraph__30xgU","iconWrapper":"tradeWelcomeMessage__iconWrapper__3N_sW","icon":"tradeWelcomeMessage__icon__2G4YV","flip":"tradeWelcomeMessage__flip__kBx5v"};

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by augustocorvalan on 7/17/15.
 */


var _ = __webpack_require__(0);
var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var AnchorMember = module.exports = SoaModel.extend();
var Anchor = __webpack_require__(12);
var SoaCollection = __webpack_require__(9);

_.extend(AnchorMember, {
    createAnchorMembers: function (sourceType, ids, note) {
        return new SoaCollection(_.map(ids, function (id) {
            if (_.isString(id)) {
                id = id.trim();
            }

            return new AnchorMember({
                'anchor': new Anchor({
                    apiType: 'anchor',
                    sourceId: id,
                    sourceType: sourceType
                }),
                note: note
            });
        }));
    }
});

_.extend(AnchorMember.prototype, {
    defaults: {
        'apiType': 'anchorListMember'
    },
    relations: SoaModel.createRelations([
        {
            key: 'anchor',
            type: Backbone.One,
            relatedModel: Anchor
        }
    ])
});


/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(1);
var PropTypes = __webpack_require__(7);
var ReactModal = __webpack_require__(511);
var tokenReplace = __webpack_require__(87);

var ContextComponent = __webpack_require__(61);
var SanitizeHtml = __webpack_require__(301);
var styles = __webpack_require__(792);
var AccountFilledIcon = __webpack_require__(725);
var ArrowUpIcon = __webpack_require__(533);
var CloseIcon = __webpack_require__(280);
var classNames = __webpack_require__(16);
var copy = __webpack_require__(770);

var tradeMessageActions = __webpack_require__(1072);
var Tour = __webpack_require__(519);
var tourTracking = __webpack_require__(520);
var tradeWelcomeMessageTracking = __webpack_require__(806);

var TradeWelcomeMessage = function (_ContextComponent) {
    _inherits(TradeWelcomeMessage, _ContextComponent);

    function TradeWelcomeMessage(props) {
        _classCallCheck(this, TradeWelcomeMessage);

        var _this = _possibleConstructorReturn(this, (TradeWelcomeMessage.__proto__ || Object.getPrototypeOf(TradeWelcomeMessage)).call(this, props));

        _this.state = {
            isExpanded: false,
            isVisible: !props.tradeTour.isTourOpen && props.isVisible
        };

        _this.toggleExpand = _this.toggleExpand.bind(_this);
        _this.onCloseClick = _this.onCloseClick.bind(_this);
        return _this;
    }

    _createClass(TradeWelcomeMessage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.state.isVisible) {
                tradeWelcomeMessageTracking.trackOpen();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var isVisible = _ref.isVisible,
                tradeTour = _ref.tradeTour;

            var isLastStep = tradeTour.currentStep === tradeTour.totalSteps;
            if (tradeTour.isTourOpen && isLastStep) {
                this.setState({ isVisible: true });
            } else if (tradeTour.isTourOpen) {
                this.setState({ isVisible: false });
            } else {
                this.setState({ isVisible: isVisible });
            }
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            if (nextState.isVisible && !this.state.isVisible) {
                tradeWelcomeMessageTracking.trackOpen();
            }
        }
    }, {
        key: 'toggleExpand',
        value: function toggleExpand() {
            var isExpanded = !this.state.isExpanded;

            this.setState({ isExpanded: isExpanded });

            if (isExpanded) {
                tradeWelcomeMessageTracking.trackExpand();
            }
        }
    }, {
        key: 'onCloseClick',
        value: function onCloseClick() {
            this.context.executeAction(tradeMessageActions.hideTradeMessage);
            tradeWelcomeMessageTracking.trackClose();
        }
    }, {
        key: 'getCollapsedContent',
        value: function getCollapsedContent() {
            var repFirstName = this.props.tradeSalesRep.firstName;

            var content = tokenReplace(copy.collapsed, {
                repFirstName: repFirstName,
                repClass: styles.collapsedName
            });
            return React.createElement(
                'div',
                { onClick: this.toggleExpand, className: styles.collapsedContent },
                React.createElement(SanitizeHtml, { content: content, allowedTags: ['span'], allowedAttributes: { span: ['class'] } })
            );
        }
    }, {
        key: 'getExpandedContent',
        value: function getExpandedContent() {
            var props = this.props;
            var tradeSalesRep = props.tradeSalesRep,
                userFirstName = props.userFirstName;
            var repFirstName = tradeSalesRep.firstName;

            var showFirstName = userFirstName ? React.createElement(
                'div',
                { className: styles.expandedTitle + ' ' + styles.paragraph },
                userFirstName + ','
            ) : null;
            var displayName = tradeSalesRep.firstName + ' ' + tradeSalesRep.lastName;
            return React.createElement(
                'div',
                { className: styles.content },
                showFirstName,
                copy.expanded.map(function (text, index) {
                    return React.createElement(
                        'div',
                        { key: index, className: styles.paragraph },
                        tokenReplace(text, { repFirstName: repFirstName })
                    );
                }),
                React.createElement(
                    'div',
                    null,
                    displayName
                ),
                React.createElement(
                    'div',
                    null,
                    tradeSalesRep.phoneNumber
                ),
                React.createElement(
                    'div',
                    null,
                    tradeSalesRep.email
                )
            );
        }
    }, {
        key: 'onOpenWelcomeMessageTour',
        value: function onOpenWelcomeMessageTour(payload) {
            tourTracking.trackOpen(payload);
            tourTracking.trackComplete(payload);
        }
    }, {
        key: 'includeTour',
        value: function includeTour() {
            var isTourOpen = this.props.tradeTour.isTourOpen;

            if (isTourOpen) {
                return React.createElement(
                    Tour,
                    _extends({ dataTn: 'welcome-message-trade', step: 6 }, this.props.tradeTour, { onOpen: this.onOpenWelcomeMessageTour }),
                    React.createElement(
                        'div',
                        { className: styles.pictureTourWrapper },
                        React.createElement(AccountFilledIcon, { className: styles.picture })
                    )
                );
            }
            return React.createElement(AccountFilledIcon, { className: styles.picture });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                isVisible = _state.isVisible,
                isExpanded = _state.isExpanded;
            var userFirstName = this.props.userFirstName;
            var overlayClassName = styles.modalOverlay;

            var expandedClassName = userFirstName ? styles.isExpanded : styles.isExpandedNoName;
            var modalClassName = classNames(styles.modalContent, _defineProperty({}, expandedClassName, isExpanded));
            var toggleClass = classNames(styles.icon, _defineProperty({}, styles.flip, isExpanded));

            return React.createElement(
                ReactModal,
                { isOpen: isVisible, overlayClassName: overlayClassName, className: modalClassName },
                React.createElement(
                    'div',
                    { className: styles.iconWrapper },
                    React.createElement(
                        'a',
                        { href: '#0', onClick: this.toggleExpand },
                        React.createElement(ArrowUpIcon, { className: toggleClass })
                    ),
                    React.createElement(
                        'a',
                        { href: '#0', onClick: this.onCloseClick },
                        React.createElement(CloseIcon, { className: styles.icon })
                    )
                ),
                isExpanded ? this.getExpandedContent() : this.getCollapsedContent(),
                React.createElement(
                    'div',
                    { className: styles.pictureWrapper },
                    this.includeTour()
                )
            );
        }
    }]);

    return TradeWelcomeMessage;
}(ContextComponent);

TradeWelcomeMessage.propTypes = {
    userFirstName: PropTypes.string,
    tradeSalesRep: PropTypes.object.isRequired,
    tradeTour: PropTypes.object,
    step: PropTypes.number
};

TradeWelcomeMessage.defaultProps = {
    tradeTour: {
        isTourOpen: false
    }
};

module.exports = TradeWelcomeMessage;

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var tracking = __webpack_require__(27);

module.exports = {
    trackOpen: function trackOpen() {
        tracking.trackEvent({
            category: 'trade program education',
            action: 'trade welcome message',
            label: 'trade welcome docked message displayed'
        });
    },
    trackClose: function trackClose() {
        tracking.trackEvent({
            category: 'trade program education',
            action: 'trade welcome message',
            label: 'trade welcome docked message closed'
        });
    },
    trackExpand: function trackExpand() {
        tracking.trackEvent({
            category: 'trade program education',
            action: 'trade welcome message',
            label: 'trade welcome docked message expanded'
        });
    }
};

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.filterCollectionUniqueItems = filterCollectionUniqueItems;
/**
 * Returns a collection with filtered unique items.
 * Items are kept unique within whole collection.
 *
 * @param {array} collection - a collection of object with items property, which is a collection too.
 * @param {number} itemCount - number of unique items to filter out.
 * @returns {array}
 */
function filterCollectionUniqueItems(collection, itemCount) {
    var seenItemIds = [];

    return collection.map(function (object) {
        var seenItemCount = 0;

        return _extends({}, object, {
            items: object.items.filter(function (item) {
                if (seenItemIds.includes(item.id) || seenItemCount >= itemCount) {
                    return false;
                } else {
                    seenItemIds.push(item.id);
                    seenItemCount++;

                    return true;
                }
            })
        });
    });
}

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Rob
 * Date: 8/19/13
 */


var SoaModel = __webpack_require__(2);
var Invoice = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;


var SoaCollection = __webpack_require__(9);
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var AdjustmentList = __webpack_require__(55);
var InvoiceItems = __webpack_require__(160);
var Party = __webpack_require__(8);
var FinancialAmount = __webpack_require__(10);
var financialAmountMixin = __webpack_require__(48);
var isType;
var getAdjustmentsTotalByFn;
var getItemsTotalByFn;

root.bunsen = root.bunsen || {};
module.exports = root.bunsen.Invoice = Invoice;

getAdjustmentsTotalByFn = function (fn, currency) {
    var adjustments = this.get('adjustments');
    if (!adjustments) {
        return null;
    }
    return adjustments[fn](currency);
};

getItemsTotalByFn = function (fn, currency) {
    var items = this.get('invoiceItems');
    if (!items) {
        return null;
    }
    return items[fn](currency);
};

isType = function (type) {
    return this.get('type') === type;
};

_.extend(Invoice, {
    STATUS_CANCELED: 'CANCELED',
    STATUS_SUBMITTED: 'SUBMITTED',
    STATUS_SETTLED: 'SETTLED',
    TYPE_BUYER: 'BUYER',
    TYPE_DEALER: 'DEALER',
    TYPE_LSP: 'LSP'
});

/**
 * @class Invoice
 * @extends SoaModel
 * @property idAttribute {string} - "id"
 */
_.extend(Invoice.prototype, {
    idAttribute: "id",
    defaults: {
        adjustments: {
            adjustments: []
        }
    },
    url : function () {
        return endpoints.invoice(this.get(this.idAttribute));
    },
    relations: [
        {
            type: Backbone.One,
            key: 'adjustments',
            relatedModel: AdjustmentList,
            collectionType: SoaCollection,
            omitFromSave: true
        },
        {
            type: Backbone.Many,
            key: 'invoiceItems',
            collectionType: InvoiceItems
        },
        {
            type: Backbone.One,
            key: 'seller',
            relatedModel: Party
        },
        {
            type: Backbone.One,
            key: 'subTotalAmount',
            relatedModel: FinancialAmount
        },
        {
            type: Backbone.One,
            key: 'totalAmount',
            relatedModel: FinancialAmount
        }
    ],
    calculateCommission: _.partial(getAdjustmentsTotalByFn, 'getCommissionTotal'),
    calculateProcessingFee: _.partial(getAdjustmentsTotalByFn, 'getProcessingFeeTotal'),
    calculateListingCredit: _.partial(getAdjustmentsTotalByFn, 'getListingCreditTotal'),
    calculateComplimentaryShipping: _.partial(getAdjustmentsTotalByFn, 'getComplimentaryShippingTotal'),
    calculatePromotion: _.partial(getAdjustmentsTotalByFn, 'getPromotionTotal'),
    calculateDealerCharge: _.partial(getAdjustmentsTotalByFn, 'getDealerChargeTotal'),

    calculateItemPriceModification: _.partial(getItemsTotalByFn, 'getItemPriceModification'),
    calculateProductCustomization: _.partial(getItemsTotalByFn, 'getProductCustomization'),
    calculateCustomerCharge: _.partial(getItemsTotalByFn, 'getCustomerCharge'),

    getListingCreditAdjustment: function () {
        var adjustmentList = this.get('adjustments');
        if (adjustmentList) {
            return adjustmentList.getListingCreditAdjustment();
        }
    },
    isDealerInvoice: _.partial(isType, Invoice.TYPE_DEALER),
    isBuyerInvoice: _.partial(isType, Invoice.TYPE_BUYER),
    isShipperInvoice: _.partial(isType, Invoice.TYPE_LSP)
}, financialAmountMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(3);
var SoaModel = __webpack_require__(2);
var Review = module.exports = SoaModel.extend();
var Notes = __webpack_require__(23);

var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var transitionMixin = __webpack_require__(19);

_.extend(Review, {
    STATUS_PENDING: 'PENDING',
    STATUS_APPROVED: 'APPROVED',
    STATUS_REJECTED: 'REJECTED',
    STATUS_CANCELED: 'CANCELED',
    TYPE_FRAUD: 'FRAUD',
    TYPE_PAYMENT_DECLINED: 'PAYMENT_DECLINED',
    TYPE_SHIPPING_REQUEST: 'SPECIAL_SHIPMENT_INSTRUCTIONS'
});

_.extend(Review.prototype, {
    defaults: {
        apiType: 'review'
    },
    url: function () {
        return endpoints.review(this.id);
    },
    getShippingRequestNote: function () {
        var notes = this.get('notes');
        if (notes) {
            return notes.find(function (note) {
                return note.get('type') === 'SPECIAL_SHIPMENT_INSTRUCTIONS';
            });
        }
    },
    isPending: function() {
        return this.get('status') === Review.STATUS_PENDING;
    },
    isFraud: function() {
        return this.get('type') === Review.TYPE_FRAUD;
    },
    isPaymentDeclined: function() {
        return this.get('type') === Review.TYPE_PAYMENT_DECLINED;
    },
    transitionToPending: function () {
        return this.transition(Review.STATUS_PENDING);
    },
    approve: function() {
        return this.transition(Review.STATUS_APPROVED);
    },
    reject: function() {
        return this.transition(Review.STATUS_REJECTED);
    },
    relations: function () {
        return SoaModel.createRelations([
            {
                type : Backbone.Many,
                key : 'notes',
                collectionType: Notes
            }
        ]);
    }
}, transitionMixin);


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * User: Shad
 * Date: 8/13/13
 */

var SoaModel = __webpack_require__(2);
var Shipment = SoaModel.extend();
var root = typeof window === 'undefined' ? global : window;
var Clump = __webpack_require__(22);
var $ = __webpack_require__(5);
root.bunsen = root.bunsen || {};

/**
 * Represents a logistics service 'Shipment'.
 *
 * @class Shipment
 * @extends SoaModel
 */
module.exports = root.bunsen.Shipment = Shipment;

var Notes = __webpack_require__(23);
var Note = __webpack_require__(33);
var Backbone = __webpack_require__(3);
var _ = __webpack_require__(0);
var endpoints = __webpack_require__(6);
var TransactionShipmentQuote = __webpack_require__(36);
var Address = __webpack_require__(32);
var ShipmentContent = __webpack_require__(180);
var ShipmentTracking = __webpack_require__(181);
var ServiceMethod = __webpack_require__(313);
var Anchor = __webpack_require__(12);
var Period = __webpack_require__(117);
var transitionMixin = __webpack_require__(19);
var periodMixin = __webpack_require__(333);
var Party = __webpack_require__(8);
var Reviews = __webpack_require__(166);

//Private Members
var carrierPatterns;

carrierPatterns = {
    UPS: /^(1Z[0-9A-Z]{16}|[0-9A-Z]{12}|T[0-9A-Z]{10}|[0-9A-Z]{9}|MI\d{6}[0-9A-Z]{1,22})$/,
    USPS: /^(94\d{20}|\d3\d{18})$/,
    FEDEX: /^\d{12,22}$/
};

//Static Properties/Methods
_.extend(Shipment, {
    TYPE_LOCAL_PICKUP : 'LOCAL_PICKUP',
    TYPE_EXTERNALLY_ARRANGED : 'EXTERNALLY_ARRANGED',
    TYPE_FIRSTDIBS_FACILITATED : 'FIRSTDIBS_FACILITATED',
    STATUS_NEW: 'NEW',
    STATUS_PENDING: 'PENDING',
    STATUS_READY_FOR_PICKUP: 'READY_FOR_PICKUP',
    STATUS_SHIPPED: 'SHIPPED',
    STATUS_DELIVERED: 'DELIVERED',
    STATUS_REGISTRATION_FAILED: 'REGISTRATION_FAILED',
    getTypes: function () {
        return [
            Shipment.TYPE_LOCAL_PICKUP,
            Shipment.TYPE_EXTERNALLY_ARRANGED,
            Shipment.TYPE_FIRSTDIBS_FACILITATED
        ];
    },
    getCarrierPatternFor: function (carrierName) {
        return carrierPatterns[carrierName];
    }
});

_.extend(Shipment.prototype, {
    idAttribute: "id",
    url : function () {
        return endpoints.shipment(this.get(this.idAttribute));
    },
    defaults: {
        notes: [],
        reviews: [],
        shippingAddress: {},
        shipmentTracking: {}
    },
    anchorType: Anchor.TYPE_SHIPMENT,
    relations: function () {
        return SoaModel.createRelations([
            {
                type: Backbone.One,
                key: 'acceptedQuote',
                relatedModel: TransactionShipmentQuote
//                saveJSONFields : ['id']
            },
            {
                type: Backbone.One,
                key: 'shippingAddress',
                relatedModel: Address
            },
            {
                type : Backbone.Many,
                key : 'notes',
                collectionType: Notes,
                omitFromSave: true
            },
            {
                type : Backbone.One,
                key : 'shipmentContent',
                relatedModel : ShipmentContent
            },
            {
                type : Backbone.One,
                key : 'shipmentTracking',
                relatedModel : ShipmentTracking
            },
            {
                type : Backbone.One,
                key : 'transaction',
                relatedModel : SoaModel,
                saveJSONFields: ['id']
            },
            {
                type : Backbone.One,
                key : 'serviceMethod',
                relatedModel : ServiceMethod
            },
            {
                type : Backbone.One,
                key : 'handlingTime',
                relatedModel : Period
            },
            {
                type : Backbone.Many,
                key : 'reviews',
                collectionType: Reviews
            }
        ]);
    },

    getShippingRequestReview: function () {
        return this.get('reviews').getShippingRequest();
    },

    getShippingRequestReviewNote: function () {
        var review =  this.getShippingRequestReview();
        if (review) {
            return review.getShippingRequestNote();
        }
    },

    getShippingRequestReviewNoteContent: function () {
        var note =  this.getShippingRequestReviewNote();
        if (note) {
            return note.get('content');
        }
    },

    /**
     * @returns {number}
     */
    getHandlingTimeDays : function () {
        return this.getPeriodInDays('handlingTime');
    },
    /**
     * @returns {string}
     */
    getDisplayHandlingTimeDays: function () {
        return this.getPeriodDisplayVal('handlingTime');
    },
    /**
     * @returns {string}
     */
    getAddresseeDisplayName: function () {
        var address = this.get('shippingAddress');
        return address ? (address.get('firstName') + ' ' + address.get('lastName')) : null;
    },
    /**
     * @returns {string}
     */
    getLastNote: function () {
        var notes = this.get('notes');
        return notes ? notes.last() : null;
    },
    /**
     * @returns {boolean}
     */
    is1stdibsFacilitated: function () {
        return this.get('shipmentType') === Shipment.TYPE_FIRSTDIBS_FACILITATED;
    },
    /**
     * @returns {Boolean}
     */
    isBuyerArrangedShipping: function () {
        var buyerArrangedShipmentTypes = [Shipment.TYPE_LOCAL_PICKUP, Shipment.TYPE_EXTERNALLY_ARRANGED];
        return _.contains(buyerArrangedShipmentTypes, this.get('shipmentType'));
    },
    /**
     * @returns {Boolean}
     */
    hasNotShipped: function () {
        var preShippedStatuses = [Shipment.STATUS_NEW, Shipment.STATUS_PENDING, Shipment.STATUS_READY_FOR_PICKUP];
        return _.contains(preShippedStatuses, this.get('status'));
    },
    /**
     * @returns {boolean}
     */
    isLocalPickup: function () {
        return this.get('shipmentType') === Shipment.TYPE_LOCAL_PICKUP;
    },
    /**
     * @returns {boolean}
     */
    isExternallyArranged: function () {
        return this.get('shipmentType') === Shipment.TYPE_EXTERNALLY_ARRANGED;
    },
    /**
     * @returns {boolean}
     */
    isStatusNew: function () {
        return this.get('status') === Shipment.STATUS_NEW;
    },
    /**
     * @returns {boolean}
     */
    isPending: function () {
        return this.get('status') === Shipment.STATUS_PENDING;
    },
    /**
     * @returns {boolean}
     */
    hasFailedAddressRegistration: function () {
        return this.get('status') === Shipment.STATUS_REGISTRATION_FAILED;
    },
    /**
     * @returns {boolean}
     */
    isReadyForPickup: function () {
        return this.get('status') === Shipment.STATUS_READY_FOR_PICKUP;
    },
    /**
     * @returns {boolean}
     */
    isShipped: function () {
        return this.get('shipmentTracking.status') === Shipment.STATUS_SHIPPED;
    },
    /**
     * @returns {boolean}
     */
    isDelivered: function () {
        return this.get('shipmentTracking.status') === Shipment.STATUS_DELIVERED;
    },
    /**
     * @returns {boolean}
     */
    hasBeenShipped: function () {
        return this.isShipped() || this.isDelivered();
    },
    /**
     * @returns {number}
     */
    getSellerId: function () {
        // TODO: This is probably not reliable if used outside of a transaction.
        return this.parents[0].get('seller').id;
    },
    getTransactionId: function () {
        // TODO: This is probably not reliable if used outside of a transaction.
        return this.parents[0].get('id');
    },

    /**
     * @returns {string}
     */
    getTrackingLabelURL: function () {
        return this.get('shipmentTracking.labelUrl');
    },

    /**
     * @returns {string}
     */
    getTrackingNumber: function () {
        return this.get('shipmentTracking.trackingNumber');
    },

    /**
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.role=INTERNAL]
     * @param {string} [passedOptions.type=ADMIN]
     * @param {string} [passedOptions.level=INFO]
     * @param {string|number} [passedOptions.creatorId] Defaults to current user id
     * @param {string} [passedOptions.content] Defaults to empty string
     * @param {object[]} [passedOptions.anchors] Defaults to empty array
     * @returns {Note}
     */
    newNote: function (passedOptions) {
        var options = _.defaults(passedOptions, {
            anchors: [
                {
                    sourceId : this.getTransactionId(),
                    sourceType : Anchor.TYPE_TRANSACTION
                },
                {
                    sourceId: this.getSellerId(),
                    sourceType : Anchor.TYPE_SELLER
                },
                {
                    sourceId: this.id,
                    sourceType: Anchor.TYPE_SHIPMENT
                }
            ]
        });
        return this.get('notes').newNote(options);
    },
    /**
     * @param {object} noteOptions {@see Shipment#newNote}
     * @param {object} syncOptions Options for SoaModel.save
     * @returns {Deferred.promise}
     */
    addNewNote : function (noteOptions, syncOptions) {
        var note = this.newNote(noteOptions);
        this.get('notes').add(note);
        return note.save(null, syncOptions);
    },
    /**
     * Accept/Counter offer while saving shipment quote in one service call
     */
    dealerCompleteNegotiation: function (offer, counterOffer, passedOptions) {
        var options = _.extend({transitionFunction: 'updateAndTransition'}, passedOptions);
        return this.dealerTransitionWithOfferNote(
            Shipment.STATUS_PENDING, offer, counterOffer, options);
    },
    /**
     * Marks a shipment as SHIPPED. Optionally takes a note to create and anchor
     * @private
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @param {string} [passedOptions.noteRole] The note role
     * @param {string} [passedOptions.noteType] The note type
     * @returns {$.Deferred.promise}
     */
    _markShipped: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true
        });
        return this.transitionWithNote(Shipment.STATUS_SHIPPED, options);
    },
    _updateShipmentAndAccountingQuote: function (accountingQuote, passedOptions) {
        var clump = new Clump();
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true,
            transitionFunction: 'update'
        });

        var quoteSave = accountingQuote.updateAccountingQuote(clump);
        var shipmentSave = this._clumpTransitionWithNote(clump, null, options);
        clump.run({ applyDynaParams: true });
        return $.when(quoteSave, shipmentSave);
    },
    /**
     * @param {TransactionShipmentQuote} accountingQuote
     * @param {object} passedOptions
     * @private
     * @returns {$.Deferred.promise}
     */
    _transitionShipmentAndAcceptAccountingQuote: function (accountingQuote, shipmentStatus, passedOptions) {
        var clump = new Clump();
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true,
            transitionFunction: 'updateAndTransition'
        });
        var quoteSave = accountingQuote.acceptAccountingQuote(clump);
        var shipmentSave = this._clumpTransitionWithNote(clump, shipmentStatus, options);
        clump.run({
            dynaOptions: {
                open: '___',
                close: '___',
                params: {
                    anchorId: {
                        clumpElement: "transition",
                        expression: "$.result.id"
                    }
                }
            }
        });
        return $.when(quoteSave, shipmentSave);
    },


    /**
     * asserts that the passed quote is actually an accounting quote and returns
     * passed options augmented with default values
     * @param accountingShipmentQuote
     * @param passedOptions
     * @returns {*}
     * @private
     */
    _getOptionsWithNoteDefaults: function (passedOptions) {
        return _.defaults(passedOptions || {}, {
            noteType: Note.TYPE_BUYER_SELLER,
            noteRole: Party.ROLE_INTERNAL,
            transitionFunction: 'updateAndTransition'
        });
    },

    _assertIsAccountingQuote: function(accountingShipmentQuote) {
        console.assert(accountingShipmentQuote instanceof TransactionShipmentQuote, 'accountingShipmentQuote must be instance of TransactionShipmentQuote');
        console.assert(accountingShipmentQuote.isAccountingQuote(), 'accountingShipmentQuote must an accounting quote');
    },
    /**
     * Use when a dealer marks a shipment as SHIPPED. Optionally create and anchor a note
     * @param passedOptions.noteContent The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    markDealerShipped: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            noteType: Note.TYPE_BUYER_SELLER,
            noteRole: Party.ROLE_SELLER,
            transitionFunction: 'updateAndTransition'
        });
        return this._markShipped(options);
    },
    markBuyerShipped: function () {
        return this.transition(Shipment.STATUS_SHIPPED);
    },
    /**
     * Use when a 1stdibs Admin marks a shipment as SHIPPED.
     * Marks the accountingShipmentQuote as 'ACCEPTED' as well.
     * Optionally create and anchor a note.
     * @param {TransactionShipmentQuote} accountingShipmentQuote The accounting shipment quote
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    mark1stdibsShipped: function (accountingShipmentQuote, passedOptions) {
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(passedOptions);
        return this._transitionShipmentAndAcceptAccountingQuote(accountingShipmentQuote, Shipment.STATUS_SHIPPED, options);
    },

    /**
     * Use when a dealer marks a shipment as SHIPPED and that
     * shipment was subsidized by 1stdibs.
     * Marks the accountingShipmentQuote as 'ACCEPTED' as well.
     * Optionally create and anchor a note.
     * @param {TransactionShipmentQuote} accountingShipmentQuote The accounting shipment quote
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    markDealerShipped1stdibsSubsidized: function (accountingShipmentQuote, passedOptions) {
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(_.extend({ noteRole: Party.ROLE_SELLER }, passedOptions));
        return this._transitionShipmentAndAcceptAccountingQuote(accountingShipmentQuote, Shipment.STATUS_SHIPPED, options);
    },
    overrideUpsLabel: function (accountingShipmentQuote, passedOptions) {
        passedOptions = passedOptions || { transitionFunction: 'update' };
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(passedOptions);
        return this._updateShipmentAndAccountingQuote(accountingShipmentQuote, options);
    },
    /**
     * Use when a 1stdibs Admin corrects shipping info after an address fails registration with easy post.
     * Marks the accountingShipmentQuote as 'ACCEPTED' and updates it as well.
     * Optionally create and anchor a note.
     * @param {TransactionShipmentQuote} accountingShipmentQuote The accounting shipment quote
     * @param {object} [passedOptions]
     * @param {string} [passedOptions.noteContent] The content to insert into the note
     * @returns {$.Deferred.promise}
     */
    enterShippingInfo: function (accountingShipmentQuote, passedOptions) {
        this._assertIsAccountingQuote(accountingShipmentQuote);
        var options = this._getOptionsWithNoteDefaults(passedOptions);
        return this._transitionShipmentAndAcceptAccountingQuote(accountingShipmentQuote, Shipment.STATUS_PENDING, options);
    },
    /**
     * Marks a shipment as READY_FOR_PICKUP. Optionally takes a note to create and anchor
     * @param passedOptions.noteContent The content to insert into the note
     * @param passedOptions.noteRole The note role
     * @param passedOptions.noteType The note type
     * @returns {$.Deferred.promise}
     */
    _markReadyForPickup: function (passedOptions) {
        var options = _.defaults(passedOptions || {}, {
            saveNoteFirst: true
        });
        return this.transitionWithNote(Shipment.STATUS_READY_FOR_PICKUP, options);
    },
    /**
     * Use when a dealer marks a shipment as READY_FOR_PICKUP. Optionally create and anchor a note
     * @param passedOptions.noteContent The content to insert into the note
     *
     * @returns {$.Deferred.promise}
     */
    markDealerReadyForPickup: function (passedOptions) {
        var options;
        var noteType;

        if (this.isBuyerArrangedShipping()) {
            noteType = Note.TYPE_BUYER_SELLER;
        } else {
            noteType = Note.TYPE_SELLER_ADMIN;
        }

        options = _.defaults(passedOptions || {}, {
            noteType: noteType,
            noteRole: Party.ROLE_SELLER
        });
        return this._markReadyForPickup(options);
    },
    /**
     * Use when a 1stdibs Admin marks a shipment as DELIVERED. Optionally create and anchor a note
     * @param passedOptions.noteContent The content to insert into the note
     *
     * @returns {$.Deferred.promise}
     */
    mark1stdibsDelivered: function (passedOptions) {
        return this.transitionWithNote(Shipment.STATUS_DELIVERED, passedOptions);
    }
}, transitionMixin, periodMixin);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by: Lior Elrom
 * Date: 7/1/15
 * Time: 2:45 PM
 */



var _ = __webpack_require__(0);
var PaymentMethod = __webpack_require__(11);

var isCardType = function (cardType) {
    return this.getCardType() === cardType;
};

module.exports = {
    isVisa: _.partial(isCardType, PaymentMethod.CARD_TYPE_VISA),
    isMaster: _.partial(isCardType, PaymentMethod.CARD_TYPE_MASTER),
    isDiscover: _.partial(isCardType, PaymentMethod.CARD_TYPE_DISCOVER),
    isAmex: _.partial(isCardType, PaymentMethod.CARD_TYPE_AMEX),

    getDisplayMaskedCard: function () {
        var lastNumbers = this.getLastNumbers();
        var maskedCardStr;
        if (lastNumbers) {
            // Amex: xxxx-xxxxxx-xxxxx
            // Visa/Discover/Master: xxxx-xxxx-xxxx-xxxx
            maskedCardStr = this.isAmex() ? 'xxxx-xxxxxx-x' : 'xxxx-xxxx-xxxx-';
            return maskedCardStr + lastNumbers;
        }
        return;
    },
    isExpired : function () {
        var cardYear = parseInt(this.get('cardExpiryYear'), 10);
        var now = new Date();
        var thisYear = parseInt(now.getFullYear(), 10);
        if (cardYear < thisYear) {
            return true;
        } else if (cardYear > thisYear) {
            return false;
        }
        return (now.getMonth() + 1 > parseInt(this.get('cardExpiryMonth'), 10));
    }
};


/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------
// Dependencies

var FieldRule = __webpack_require__(45);

// ---------------------------------------------------
// Local Vars

// ---------------------------------------------------
// Module Definition and Instance Properties

/**
 * @class RegexRule
 * @extends FieldRule
 */
var RegexRule = module.exports = FieldRule.extend({
    noMatch: false,
    initialize: function (options) {
        options = options || {};
        RegexRule.__super__.initialize.call(this, options);
        this.regex = options.regex || this.regex;
    },
    outputSchema: function () {
        return {
            validator: this.regex,
            noMatch: this.noMatch
        };
    }
});


/***/ }),

/***/ 86:
/***/ (function(module, exports) {

function one(selector, el) {
  return el.querySelector(selector);
}

exports = module.exports = function(selector, el){
  el = el || document;
  return one(selector, el);
};

exports.all = function(selector, el){
  el = el || document;
  return el.querySelectorAll(selector);
};

exports.engine = function(obj){
  if (!obj.one) throw new Error('.one callback required');
  if (!obj.all) throw new Error('.all callback required');
  one = obj.one;
  exports.all = obj.all;
  return exports;
};


/***/ }),

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var debug = __webpack_require__(89)('Dispatchr:Action');

function Action(name, payload) {
    this.name = name;
    this.payload = payload;
    this._handlers = null;
    this._isExecuting = false;
    this._isCompleted = null;
}

/**
 * Gets a name from a store
 * @method getStoreName
 * @param {String|Object} store The store name or class from which to extract
 *      the name
 * @returns {String}
 */
Action.prototype.getStoreName = function getStoreName(store) {
    if ('string' === typeof store) {
        return store;
    }
    return store.storeName;
};

/**
 * Executes all handlers for the action
 * @method execute
 * @param {Function[]} handlers A mapping of store names to handler function
 * @throws {Error} if action has already been executed
 */
Action.prototype.execute = function execute(handlers) {
    if (this._isExecuting) {
        throw new Error('Action is already dispatched');
    }
    var self = this;
    this._handlers = handlers;
    this._isExecuting = true;
    this._isCompleted = {};
    Object.keys(handlers).forEach(function handlersEach(storeName) {
        self._callHandler(storeName);
    });
};

/**
 * Calls an individual store's handler function
 * @method _callHandler
 * @param {String} storeName
 * @private
 * @throws {Error} if handler does not exist for storeName
 */
Action.prototype._callHandler = function callHandler(storeName) {
    var self = this,
        handlerFn = self._handlers[storeName];
    if (!handlerFn) {
        throw new Error(storeName + ' does not have a handler for action ' + self.name);
    }
    if (self._isCompleted[storeName]) {
        return;
    }
    self._isCompleted[storeName] = false;
    debug('executing handler for ' + storeName);
    handlerFn(self.payload, self.name);
    self._isCompleted[storeName] = true;
};

/**
 * Waits until all stores have finished handling an action and then calls
 * the callback
 * @method waitFor
 * @param {String|String[]|Constructor|Constructor[]} stores An array of stores as strings or constructors to wait for
 * @param {Function} callback Called after all stores have completed handling their actions
 * @throws {Error} if the action is not being executed
 */
Action.prototype.waitFor = function waitFor(stores, callback) {
    var self = this;
    if (!self._isExecuting) {
        throw new Error('waitFor called even though there is no action being executed!');
    }
    if (!Array.isArray(stores)) {
        stores = [stores];
    }

    debug('waiting on ' + stores.join(', '));
    stores.forEach(function storesEach(storeName) {
        storeName = self.getStoreName(storeName);
        if (self._handlers[storeName]) {
            self._callHandler(storeName);
        }
    });

    callback();
};

module.exports = Action;


/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(211);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = __webpack_require__.i({"NODE_ENV":'production'}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),

/***/ 893:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Recommendations = __webpack_require__(912);
var User = __webpack_require__(15);

var _require = __webpack_require__(597),
    ACTIONS = _require.ACTIONS,
    STORE = _require.STORE;

var recommendationsActions = {
    fetch: function fetch(actionContext, payload, done) {
        var _payload$collection = payload.collection,
            collection = _payload$collection === undefined ? new Recommendations() : _payload$collection,
            categoryLevels = payload.categoryLevels,
            categoryKeys = payload.categoryKeys,
            collectionKey = payload.collectionKey,
            _payload$pageSize = payload.pageSize,
            pageSize = _payload$pageSize === undefined ? 1 : _payload$pageSize,
            namedQuery = payload.namedQuery,
            attributes = payload.attributes,
            type = payload.type,
            query = payload.query,
            orderBy = payload.orderBy;


        collection.setParam('recommendationType', type).setParam('categoryLevels', categoryLevels).setParam('categoryKeys', categoryKeys).setParam('namedQuery', namedQuery).setParam('userIds', User.getUserId()).setParam('attributes', attributes).setParam('query', query).setParam('pageSize', pageSize).setParam('orderBy', orderBy);

        return Promise.resolve(collection.fetchWithParameters()).then(function () {
            actionContext.dispatch(STORE.FETCH_SUCCESS, { collectionKey: collectionKey, collection: collection });
            done();
        }).catch(function () {
            actionContext.dispatch(STORE.FETCH_SUCCESS);
            done();
        });
    },
    fetchByCategory: function fetchByCategory(actionContext, payload, done) {
        var _payload$categoryLeve = payload.categoryLevels,
            categoryLevels = _payload$categoryLeve === undefined ? 3 : _payload$categoryLeve,
            _payload$itemsPageSiz = payload.itemsPageSize,
            itemsPageSize = _payload$itemsPageSiz === undefined ? 30 : _payload$itemsPageSiz,
            collectionKey = payload.collectionKey,
            collection = payload.collection,
            pageSize = payload.pageSize,
            fields = payload.fields;


        var fieldsQuery = fields ? '&fields=' + fields : '';

        return actionContext.executeAction(recommendationsActions.fetch, {
            collection: collection,
            collectionKey: collectionKey,
            type: ACTIONS.TYPE.CATEGORY,
            categoryLevels: categoryLevels,
            pageSize: pageSize,
            query: 'pageSize=' + itemsPageSize + fieldsQuery + '&filterQuery=category_search:1,hideprice:N,vertical:{vertical},l2_url_label:{l2_url_label},l3_url_label:{l3_url_label},l4_url_label:{l4_url_label}&sort=releasedate desc,sort_cs_status asc,priority asc'
        }).then(function () {
            return done();
        });
    },
    fetchByAttribute: function fetchByAttribute(actionContext, payload, done) {
        var _payload$categoryLeve2 = payload.categoryLevels,
            categoryLevels = _payload$categoryLeve2 === undefined ? 3 : _payload$categoryLeve2,
            _payload$itemsPageSiz2 = payload.itemsPageSize,
            itemsPageSize = _payload$itemsPageSiz2 === undefined ? 30 : _payload$itemsPageSiz2,
            pageSize = payload.pageSize,
            collectionKey = payload.collectionKey,
            attributes = payload.attributes,
            collection = payload.collection,
            categoryKeys = payload.categoryKeys,
            _payload$fields = payload.fields,
            fields = _payload$fields === undefined ? '' : _payload$fields,
            _payload$orderBy = payload.orderBy,
            orderBy = _payload$orderBy === undefined ? 'TYPE_RANK' : _payload$orderBy;


        var fieldsQuery = fields ? '&fields=' + fields : '';

        return actionContext.executeAction(recommendationsActions.fetch, {
            collection: collection,
            collectionKey: collectionKey,
            type: ACTIONS.TYPE.ATTRIBUTE,
            attributes: attributes,
            pageSize: pageSize,
            categoryKeys: categoryKeys,
            categoryLevels: categoryLevels,
            orderBy: orderBy,
            query: 'pageSize=' + itemsPageSize + fieldsQuery + '&filterQuery=category_search:1,hideprice:N,vertical:{vertical},l2_url_label:{l2_url_label},l3_url_label:{l3_url_label},l4_url_label:{l4_url_label},attr_opt_url_label_{attribute_solr_field_suffix}:{attribute_option_url_label}&sort=releasedate desc,sort_cs_status asc,priority asc'
        }).then(function () {
            return done();
        });
    }
};

module.exports = recommendationsActions;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {/**
 * Copyright 2014, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var debug = __webpack_require__(91)('Fluxible');
var isPromise = __webpack_require__(57);
var FluxibleContext = __webpack_require__(221);
var dispatchr = __webpack_require__(208);
var __DEV__ = 'production' !== 'production';

/*
 * The default component action handler
 * @method defaultComponentActionHandler
 */
function defaultComponentActionHandler(context, payload, done) {
    if (payload.err) {
        debug('Action returned error', payload.actionName, payload.err);
        throw payload.err;
    }
    done();
}

/**
 * Provides a structured way of registering an application's configuration and
 * resources.
 * @class Fluxible
 * @param {Object} [options]
 * @param {Object} [options.component] Stores your top level React component for access using `getComponent()`
 * @param {Function} [options.componentActionErrorHandler] App level component action handler
 * @constructor
 *
 * @example
 *      var app = new Fluxible({
 *          component: require('./components/App.jsx')
 *      });
 */
function Fluxible(options) {
    debug('Fluxible instance instantiated', options);
    options = options || {};

    // Options
    this._component = options.component;
    this._componentActionErrorHandler =
        options.componentActionErrorHandler || defaultComponentActionHandler;
    this._plugins = [];

    // Initialize dependencies
    this._dispatcher = dispatchr.createDispatcher(options);
}

/**
 * Creates an isolated context for a request/session
 * @method createContext
 * @param {Object} [options]
 * @returns {FluxibleContext}
 */
Fluxible.prototype.createContext = function createContext(options) {
    var self = this;
    options = options || {};
    var context = new FluxibleContext(self);

    // Plug context with app plugins that implement plugContext method
    this._plugins.forEach(function eachPlugin(plugin) {
        if (plugin.plugContext) {
            var contextPlugin = plugin.plugContext(options, context, self) || {};
            contextPlugin.name = contextPlugin.name || plugin.name;
            context.plug(contextPlugin);
        }
    });

    return context;
};

/**
 * Creates a new dispatcher instance using the application's dispatchr class. Used by
 * FluxibleContext to create new dispatcher instance
 * @method createDispatcherInstance
 * @param {Object} contextOptions The context options to be provided to each store instance
 * @returns {Dispatcher}
 */
Fluxible.prototype.createDispatcherInstance = function createDispatcherInstance(contextOptions) {
    return this._dispatcher.createContext(contextOptions);
};

/**
 * Provides plugin mechanism for adding application level settings that are persisted
 * between server/client and also modification of the FluxibleContext
 * @method plug
 * @param {Object} plugin
 * @param {String} plugin.name Name of the plugin
 * @param {Function} plugin.plugContext Method called after context is created to allow
 *  dynamically plugging the context
 * @param {Object} [plugin.dehydrate] Method called to serialize the plugin settings to be persisted
 *  to the client
 * @param {Object} [plugin.rehydrate] Method called to rehydrate the plugin settings from the server
 */
Fluxible.prototype.plug = function (plugin) {
    if (__DEV__) {
        if (!plugin.name) {
            throw new Error('Application plugin must have a name');
        }
    }
    this._plugins.push(plugin);
};

/**
 * Provides access to a plugin instance by name
 * @method getPlugin
 * @param {String} pluginName The plugin name
 * @returns {Object}
 */
Fluxible.prototype.getPlugin = function (pluginName) {
    var plugin = null;
    this._plugins.forEach(function (p) {
        if (pluginName === p.name) {
            plugin = p;
        }
    });
    return plugin;
};

/**
 * Getter for the top level react component for the application
 * @method getComponent
 * @returns {ReactComponent}
 */
Fluxible.prototype.getComponent = function getComponent() {
    return this._component;
};

/**
 * Registers a store to the dispatcher so it can listen for actions
 * @method registerStore
 */
Fluxible.prototype.registerStore = function registerStore() {
    debug(arguments[0].storeName + ' store registered');
    this._dispatcher.registerStore.apply(this._dispatcher, arguments);
};

/**
 * Creates a serializable state of the application and a given context for sending to the client
 * @method dehydrate
 * @param {FluxibleContext} context
 * @returns {Object} Dehydrated state object
 */
Fluxible.prototype.dehydrate = function dehydrate(context) {
    debug('dehydrate', context);
    var self = this;
    var state = {
        context: context.dehydrate(),
        plugins: {}
    };

    this._plugins.forEach(function (plugin) {
        if ('function' === typeof plugin.dehydrate) {
            // Use a namespace for storing plugin state and provide access to the application
            state.plugins[plugin.name] = plugin.dehydrate(self);
        }
    });

    return state;
};

/**
 * Rehydrates the application and creates a new context with the state from the server
 * @method rehydrate
 * @param {Object} obj Raw object of dehydrated state
 * @param {Object} obj.plugins Dehydrated app plugin state
 * @param {Object} obj.context Dehydrated context state
 * @param {Function} callback
 * @async Rehydration may require more asset loading or async IO calls
 */
Fluxible.prototype.rehydrate = function rehydrate(obj, callback) {
    debug('rehydrate', obj);
    var self = this;
    if (__DEV__) {
        if (typeof obj !== 'object') {
            throw new Error('`rehydrate` called with a non-object. Ensure ' +
                'that the parameter passed to rehydrate is a state object ' +
                'produced by a dehydrate call.');
        }
    }
    obj.plugins = obj.plugins || {};
    var pluginTasks = self._plugins.filter(function (plugin) {
        return 'function' === typeof plugin.rehydrate
            && obj.plugins[plugin.name];
    }).map(function (plugin) {
        return new Promise(function (resolve, reject) {
            var result = plugin.rehydrate(obj.plugins[plugin.name], function (err) {
                if (err) {
                    reject(err);
                } else {
                    resolve();
                }
            });
            if (isPromise(result)) {
                result.then(resolve, reject);
            } else if (plugin.rehydrate.length < 2) {
                resolve();
            }
        });
    });

    var context = self.createContext();
    var rehydratePromise = Promise.all(pluginTasks).then(function rehydratePluginTasks() {
        return context.rehydrate(obj.context || {});
    });

    if (callback) {
        rehydratePromise
            .then(function (contextValue) {
                // Ensures that errors in callback are not swallowed by promise
                setImmediate(callback, null, contextValue);
            }, function (err) {
                // Ensures that errors in callback are not swallowed by promise
                setImmediate(callback, err);
            });
    }

    return rehydratePromise;
};

module.exports = Fluxible;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42).setImmediate))

/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(222);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = __webpack_require__.i({"NODE_ENV":'production'}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);

var RecommendationItem = __webpack_require__(914);
var endpoints = __webpack_require__(6);

var RecommendationItems = SoaCollection.extend({
    url: endpoints.recommendations(),
    model: RecommendationItem
});

module.exports = RecommendationItems;

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaCollection = __webpack_require__(9);

var Recommendation = __webpack_require__(913);
var endpoints = __webpack_require__(6);

var Recommendations = SoaCollection.extend({
    url: endpoints.recommendations(),
    model: Recommendation,

    TYPE_CATEGORY: 'CATEGORY',
    TYPE_ATTRIBUTE: 'ATTRIBUTE'
});

module.exports = Recommendations;

/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var endpoints = __webpack_require__(6);
var RecommendationItems = __webpack_require__(911);
var Backbone = __webpack_require__(3);

var Recommendation = SoaModel.extend({
    url: endpoints.recommendations(),

    relations: [{
        type: Backbone.Many,
        key: 'items',
        collectionType: RecommendationItems
    }]
});

module.exports = Recommendation;

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SoaModel = __webpack_require__(2);
var endpoints = __webpack_require__(6);

var RecommendationItem = SoaModel.extend({
    url: function url() {
        return endpoints.recommendations('me');
    },
    getImage: function getImage() {
        var imageName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'small';

        var images = this.get('images');

        if (images.length) {
            return images[0][imageName];
        }
    },
    getPdpUrl: function getPdpUrl() {
        var urlId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        var urls = this.get('pdpUrls');

        if (urls) {
            return urls[urlId];
        }
    },
    getTitle: function getTitle() {
        return this.get('title');
    }
});

module.exports = RecommendationItem;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function($){try{$('export default global')}catch(e){try{$('export default self')}catch(e){try{module.exports=global}catch(e){try{self.global=self}catch(e){window.global=window}}}}}(eval))
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = global;

  // assume CommonJS
  var create = __webpack_require__(242);
  var isEmpty = __webpack_require__(254);
  var uniqueId = __webpack_require__(247);
  var size = __webpack_require__(246);
  var once = __webpack_require__(328);
  var assign = __webpack_require__(252);
  var pick = __webpack_require__(255);
  var result = __webpack_require__(256);
  var isFunction = __webpack_require__(102);
  var forEach = __webpack_require__(253);
  var has = __webpack_require__(243);
  var matches = __webpack_require__(37);
  var Backbone = module.exports = {};

  // Initial Setup
  // -------------

  // Create a local reference to a common array method we'll want to use later.
  var slice = Array.prototype.slice;

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // a custom event channel. You may bind a callback to an event with `on` or
  // remove with `off`; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     assign(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`).
  var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = Object.keys(name); i < names.length ; i++) {
        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space-separated event names by delegating them individually.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        events = iteratee(events, names[i], callback, opts);
      }
    } else {
      // Finally, standard events.
      events = iteratee(events, name, callback, opts);
    }
    return events;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    return internalOn(this, name, callback, context);
  };

  // Guard the `listening` argument from the public API.
  var internalOn = function(obj, name, callback, context, listening) {
    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
      context: context,
      ctx: obj,
      listening: listening
    });

    if (listening) {
      var listeners = obj._listeners || (obj._listeners = {});
      listeners[listening.id] = listening;
    }

    return obj;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to
  // for easier unbinding later.
  Events.listenTo = function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      var thisId = this._listenId || (this._listenId = uniqueId('l'));
      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
    }

    // Bind callbacks on obj, and keep track of them on listening.
    internalOn(obj, name, callback, this, listening);
    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
    }
    return events;
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off = function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
      context: context,
      listeners: this._listeners
    });
    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening = function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : Object.keys(listeningTo);

    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
    }
    if (isEmpty(listeningTo)) this._listeningTo = void 0;

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    if (!events) return;

    var i = 0, listening;
    var context = options.context, listeners = options.listeners;

    // Delete all events listeners and "drop" events.
    if (!name && !callback && !context) {
      var ids = listeners ? Object.keys(listeners) : [];
      for (; i < ids.length; i++) {
        listening = listeners[ids[i]];
        delete listeners[listening.id];
        delete listening.listeningTo[listening.objId];
      }
      return;
    }

    var names = name ? [name] : Object.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Replace events if there are any remaining.  Otherwise, clean up.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          listening = handler.listening;
          if (listening && --listening.count === 0) {
            delete listeners[listening.id];
            delete listening.listeningTo[listening.objId];
          }
        }
      }

      // Update tail event if the list has any events.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }
    if (size(events)) return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, its listener will be removed. If multiple events
  // are passed in using the space-separated syntax, the handler will fire
  // once for each event, not once for a combination of all events.
  Events.once = function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, this.off.bind(this));
    return this.on(events, void 0, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce = function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, this.stopListening.bind(this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var callbackOnce = map[name] = once(function() {
        offer(name, callbackOnce);
        callback.apply(this, arguments);
      });
      callbackOnce._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger = function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, callback, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  assign(Backbone, Events);

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = uniqueId('view');
    this.__delegatorConfigs = [];
    assign(this, pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be set as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  assign(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      if (!this.el) {
        return [];
      }
      return slice.call(this.el.querySelectorAll(selector));
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.undelegateEvents();
      if (!this.el.parentNode) {
        return;
      }
      this.el.parentNode.removeChild(this.el);
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` reference for this view using the
    // given `el`. `el` can be an element. Subclasses can
    // override this to utilize an alternative DOM manipulation API and are only
    // required to set the `this.el` property.
    _setElement: function(el) {
      var querySelector;
      if ('string' === typeof el) {
        querySelector = el;
        el = document.querySelector(querySelector);
      }
      this.el = el;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], method.bind(this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      var delegator;
      if (!listener) {
        listener = selector;
        selector = null;
      }
      delegator = function(e) {
        if (!selector || matches(e.target, selector)) {
          return listener.apply(this, arguments);
        }
      };
      this.__delegatorConfigs.push({
        eventName: eventName,
        selector: selector,
        delegator: delegator,
        listener: listener
      });
      this.el.addEventListener(eventName, delegator);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.__delegatorConfigs.forEach(function(delegatorConfig) {
        this.el.removeEventListener(delegatorConfig.eventName, delegatorConfig.delegator);
      }.bind(this));
      this.__delegatorConfigs = [];
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      var delegatorConfigs;
      if ('string' !== typeof selector && !listener) {
        listener = selector;
        selector = null;
      }
      delegatorConfigs = this.__delegatorConfigs.filter(function(delegatorConfig) {
        if (selector && selector !== delegatorConfig.selector) {
          return false;
        }
        if (listener && listener !== delegatorConfig.listener) {
          return false;
        }
        return eventName === delegatorConfig.eventName;
      });
      delegatorConfigs.forEach(function(delegatorConfig) {
        this.el.removeEventListener(delegatorConfig.eventName, delegatorConfig.delegator);
      }.bind(this));
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // Create an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = assign({}, result(this, 'attributes'));
        if (this.id) attrs.id = result(this, 'id');
        if (this.className) attrs['class'] = result(this, 'className');
        this.setElement(this._createElement(result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      if (!this.el) {
        return;
      }
      forEach(attributes, function(value, name) {
        this.el.setAttribute(name, value);
      }.bind(this));
    }

  });

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    assign(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function and add the prototype properties.
    child.prototype = create(parent.prototype, protoProps);
    child.prototype.constructor = child;

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  View.extend = extend;

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var appSetup = __webpack_require__(231);
var ContextProvider = __webpack_require__(294);
var pick = __webpack_require__(67);
var isEmpty = __webpack_require__(268);

/**
 * Creates a Fluxible app, registers the specified stores with it,
 * and creates the context from the app, allowing the nav bar to continue initialization using that context.
 * If dehydrated state is passed in, rehydrates App and returns a promise.
 *
 * @param {Array} [stores=[]] - An array of stores that should be registered with the app.
 * @param {Object} [opt={}]
 * @param {boolean} [opt.connectToNavBar=true] - If true, register Nav Bar stores with the app
 * @param {Object} [opt.state={}] - Dehydrated state of server-side App
 * @returns {Object|Promise} - Returns Fluxible Context, or Promise that resolves to Fluxible Context
 */
function createEntryPointContext() {
    var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var options = { connectToNavBar: true, state: {}, connectToContact: false };
    var App = void 0;
    var rehydrate = void 0;
    var promise = void 0;
    var context = void 0;

    Object.assign(options, opt);

    App = appSetup(stores, pick(options, 'connectToNavBar', 'connectToContact', 'contactOptions'));
    context = App.createContext();
    rehydrate = options.state && !isEmpty(options.state);

    if (rehydrate) {
        promise = new Promise(function (resolve /*, reject*/) {

            App.rehydrate(options.state, function (error, rehydratedContext) {
                if (error) {
                    console.log('Encontered an error while rehydrating App, ' + 'but failing silently and allowing context to be set: ' + error + '\n' + error.stack);

                    // If rehydration fails fallback to context without rehydrating to prevent showing user blank page
                    rehydratedContext = context;
                }
                resolve(ContextProvider.setContext(rehydratedContext));
            });
        });
    }

    return rehydrate ? promise : ContextProvider.setContext(context);
}

module.exports = createEntryPointContext;

/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    createReducerStore: __webpack_require__(218)
};


/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(62);

/*
 * @param  {number} amount - The number to format.
 * @param  {string} currency - Accepts any currency from currencies file
 * @param  {object} passedOptions - Additional options for localizedCashFormat
 * @return {string} - Formatted price string
 */
module.exports = function intelligentFormat(amount, currency, passedOptions) {
    var options = util.getFormatOptions(amount, currency, passedOptions);
    return util.localizedCashFormat(amount, options);
};


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

/**
 * lodash 3.1.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
var arrayMap = __webpack_require__(326),
    baseDifference = __webpack_require__(123),
    baseFlatten = __webpack_require__(314),
    bindCallback = __webpack_require__(124),
    pickByArray = __webpack_require__(335),
    pickByCallback = __webpack_require__(336),
    keysIn = __webpack_require__(311),
    restParam = __webpack_require__(278);

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable properties of `object` that are not omitted.
 * Property names may be specified as individual arguments or as arrays of
 * property names. If `predicate` is provided it is invoked for each property
 * of `object` omitting the properties `predicate` returns truthy for. The
 * predicate is bound to `thisArg` and invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {Function|...(string|string[])} [predicate] The function invoked per
 *  iteration or property names to omit, specified as individual property
 *  names or arrays of property names.
 * @param {*} [thisArg] The `this` binding of `predicate`.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'user': 'fred', 'age': 40 };
 *
 * _.omit(object, 'age');
 * // => { 'user': 'fred' }
 *
 * _.omit(object, _.isNumber);
 * // => { 'user': 'fred' }
 */
var omit = restParam(function(object, props) {
  if (object == null) {
    return {};
  }
  if (typeof props[0] != 'function') {
    var props = arrayMap(baseFlatten(props), String);
    return pickByArray(object, baseDifference(keysIn(object), props));
  }
  var predicate = bindCallback(props[0], props[1], 3);
  return pickByCallback(object, function(value, key, object) {
    return !predicate(value, key, object);
  });
});

module.exports = omit;


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var FinancialAmount = __webpack_require__(10);
var Price = __webpack_require__(66);
var User = __webpack_require__(15);
var numAddCommas = __webpack_require__(127);
var tokenReplace = __webpack_require__(87);
var currencyUtil = __webpack_require__(62);
var intelligentFormat = __webpack_require__(96);
var mapValues = __webpack_require__(110);
var enabler = __webpack_require__(64);

var ContactUIStore = function (_BaseStore) {
    _inherits(ContactUIStore, _BaseStore);

    function ContactUIStore(dispatcher) {
        _classCallCheck(this, ContactUIStore);

        var _this = _possibleConstructorReturn(this, (ContactUIStore.__proto__ || Object.getPrototypeOf(ContactUIStore)).call(this, dispatcher));

        _this.state = {
            modalId: '',
            isOpened: false
        };
        _this.reset();
        return _this;
    }

    _createClass(ContactUIStore, [{
        key: 'openModal',
        value: function openModal(_ref) {
            var modalId = _ref.modalId;

            Object.assign(this.state, {
                modalId: modalId,
                isOpened: true
            });
            this.emitChange();
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            Object.assign(this.state, {
                modalId: '',
                isOpened: false,
                isServerError: false
            });
            this.emitChange();
        }
    }, {
        key: 'startLoading',
        value: function startLoading(_ref2) {
            var sendToOmtOnSuccess = _ref2.sendToOmtOnSuccess,
                itemPk = _ref2.itemPk;

            this.reset();
            Object.assign(this.state, {
                sendToOmtOnSuccess: sendToOmtOnSuccess,
                isItem: !!itemPk
            });
        }
    }, {
        key: 'startSending',
        value: function startSending() {
            this.state.isSending = true;
            this.emitChange();
        }
    }, {
        key: 'doneSending',
        value: function doneSending() {
            this.state.formSubmitted = true;
        }
    }, {
        key: 'serverError',
        value: function serverError() {
            Object.assign(this.state, {
                isServerError: true,
                isOpened: true,
                isSending: false
            });
            this.emitChange();
        }
    }, {
        key: 'showOptIn',
        value: function showOptIn() {
            this.state.isShowOptIn = true;
            this.emitChange();
        }
    }, {
        key: 'doneLoading',
        value: function doneLoading(payload) {
            var _this2 = this;

            // initialize message before updating ui
            this.dispatcher.waitFor('ContactMessageStore', function () {
                var item = payload.item,
                    seller = payload.seller,
                    user = payload.user,
                    copyText = payload.copyText;

                if (user && _this2.state.user) {
                    // we have the up-to-date profile already
                    user.set('profile', _this2.state.user.get('profile'));
                }
                Object.assign(_this2.state, {
                    copyText: copyText,
                    seller: seller,
                    user: user,
                    isLoading: false,
                    isUserInitiallyLoggedIn: !!user,
                    isUserNameSet: user && user.get('profile') && user.get('profile').getDisplayName({ defaultToEmail: false }),
                    sellerCompany: seller.get('sellerProfile.company')
                });
                if (item) {
                    var isShowOffer = item.canMakeBuyerOffer();
                    _this2.state.isShowOffer = isShowOffer;
                    if (isShowOffer) {
                        var currency = _this2.dispatcher.getStore('UserStore').getCurrency();
                        var currencySymbol = FinancialAmount.getCurrencySymbol(currency);
                        var delimiter = currency === FinancialAmount.CURRENCY_EUR ? '.' : ',';

                        // Values are numbers, prices are string representations of corresponding numbers
                        var values = [Price.TYPE_RETAIL, Price.TYPE_NET, Price.TYPE_SALE].map(function (type) {
                            // getPriceIn defaults to main price if given type's price is not defined
                            return item.getPriceByType(type) ? item.getPriceIn(type, currency) : undefined;
                        });

                        var _values = _slicedToArray(values, 3),
                            retailValue = _values[0],
                            netValue = _values[1],
                            saleValue = _values[2];

                        var _values$map = values.map(function (value) {
                            return value ? numAddCommas(value, false, delimiter) : undefined;
                        }),
                            _values$map2 = _slicedToArray(_values$map, 3),
                            retailPrice = _values$map2[0],
                            netPrice = _values$map2[1],
                            salePrice = _values$map2[2];

                        var displayPrice = void 0;
                        var priceValue = void 0;
                        var priceType = void 0;
                        var showNetPrice = netValue && item.isFurniture() && User.canRequestNetPrice() && enabler.isEnabled('enable_net_price');
                        if (saleValue) {
                            displayPrice = salePrice;
                            priceValue = saleValue;
                            priceType = Price.TYPE_SALE;
                        } else if (showNetPrice) {
                            displayPrice = netPrice;
                            priceValue = netValue;
                            priceType = Price.TYPE_NET;
                        } else {
                            displayPrice = retailPrice;
                            priceValue = retailValue;
                            priceType = Price.TYPE_RETAIL;
                        }

                        Object.assign(_this2.state, {
                            isPricePerPiece: item.canMultipleQuantityBePurchased(),
                            pieces: item.getNumberOfPieces(),
                            currency: currency,
                            currencySymbol: currencySymbol,
                            displayPrice: displayPrice,
                            priceValue: priceValue,
                            priceType: priceType
                        }, {
                            formattedRetailPrice: intelligentFormat(retailValue, currency),
                            formattedNetPrice: showNetPrice ? intelligentFormat(netValue, currency) : undefined,
                            formattedSalePrice: saleValue ? intelligentFormat(saleValue, currency) : undefined
                        });
                    }
                }
                _this2._setBaseModalHeader();
                _this2.emitChange();
            });
        }
    }, {
        key: 'doneLoadingUserToUser',
        value: function doneLoadingUserToUser(payload) {
            var user = payload.user,
                copyText = payload.copyText,
                header = payload.header;


            Object.assign(this.state, {
                copyText: copyText,
                user: user,
                modalHeader: header,
                isLoading: false,
                isUserInitiallyLoggedIn: !!user,
                isUserNameSet: user && user.get('profile') && user.get('profile').getDisplayName({ defaultToEmail: false })
            });

            this.emitChange();
        }
    }, {
        key: 'toggleOffer',
        value: function toggleOffer() {
            this._toggleField('isOfferEnabled');
            this.clearErrors();
        }
    }, {
        key: 'toggleMessage',
        value: function toggleMessage() {
            this._toggleField('isMessageEnabled');
            this.clearErrors();
        }
    }, {
        key: 'showLowBall',
        value: function showLowBall() {
            Object.assign(this.state, {
                isShowLowBallWarning: true,
                modalHeader: this.state.copyText.get('offerLowballTitle')
            });
            this.emitChange();
        }
    }, {
        key: 'hideLowBall',
        value: function hideLowBall() {
            this.state.isShowLowBallWarning = false;
            this._setBaseModalHeader();
            this.emitChange();
        }
    }, {
        key: 'hideMakeOffer',
        value: function hideMakeOffer() {
            this.state.isShowOffer = false;
            this.emitChange();
        }
    }, {
        key: 'initLowballOptions',
        value: function initLowballOptions(_ref3) {
            var offerAmount = _ref3.offerAmount;
            var _state = this.state,
                priceValue = _state.priceValue,
                currency = _state.currency,
                isPricePerPiece = _state.isPricePerPiece,
                copyText = _state.copyText;

            var fivePercent = 0.05;
            var tenPercent = 0.1;
            var priceFivePercentOff = currencyUtil.round(priceValue * (1 - fivePercent), 0);
            var priceTenPercentOff = currencyUtil.round(priceValue * (1 - tenPercent), 0);
            var perItem = isPricePerPiece ? copyText.get(' per item') : '';

            // Value is what gets set on the offer model and label is visually displayed
            this.state.lowballOptions = [{
                value: '' + priceFivePercentOff,
                label: intelligentFormat(priceFivePercentOff, currency) + perItem,
                percentOff: fivePercent * 100,
                labelSubtext: tokenReplace(copyText.get('lowballOptionAmountOff'), {
                    amountOff: intelligentFormat(priceValue - priceFivePercentOff, currency),
                    percentOff: fivePercent * 100
                })
            }, {
                value: '' + priceTenPercentOff,
                label: intelligentFormat(priceTenPercentOff, currency) + perItem,
                percentOff: tenPercent * 100,
                labelSubtext: tokenReplace(copyText.get('lowballOptionAmountOff'), {
                    amountOff: intelligentFormat(priceValue - priceTenPercentOff, currency),
                    percentOff: tenPercent * 100
                })
            }];

            if (offerAmount) {
                var offerValue = currencyUtil.parseFloat(offerAmount);
                var amountOffValue = priceValue - offerValue;
                var percentOff = amountOffValue / priceValue * 100;
                this.state.lowballOptions.push({
                    value: offerAmount,
                    label: intelligentFormat(offerValue, currency) + perItem + ' ' + copyText.get('originalOffer'),
                    percentOff: percentOff,
                    labelSubtext: tokenReplace(copyText.get('lowballOptionAmountOff'), {
                        amountOff: intelligentFormat(amountOffValue, currency),
                        percentOff: currencyUtil.format(percentOff, 0)
                    }),
                    isOriginalOffer: true
                });
            }

            this.state.lowballOptions.push({
                isOther: true,
                value: 'other',
                label: copyText.get('lowballOtherOptionLabel')
            });

            // No Lowball option is selected at first so disable submit.
            this.state.submitDisabled = true;
        }
    }, {
        key: 'setLowballOption',
        value: function setLowballOption(payload) {
            var selectedLowballOption = payload.selectedLowballOption;

            var prevLowballOption = this.state.selectedLowballOption;
            selectedLowballOption.checked = true;
            if (prevLowballOption) {
                prevLowballOption.checked = false;
                if (prevLowballOption.isOther) {
                    // if no longer "other" option, reset offer label subtext for it
                    this.setLowballOfferDiscount({ value: '' });
                }
            }
            this.state.selectedLowballOption = selectedLowballOption;
            // Lowball option definitely selected now, enable submit button
            // if it's not the "other" option which is an input
            this.state.submitDisabled = Boolean(selectedLowballOption.isOther);
            this.clearErrors();
        }
    }, {
        key: 'setLowballOfferDiscount',
        value: function setLowballOfferDiscount(payload) {
            var _state2 = this.state,
                selectedLowballOption = _state2.selectedLowballOption,
                currency = _state2.currency,
                priceValue = _state2.priceValue,
                copyText = _state2.copyText;

            if (!selectedLowballOption || selectedLowballOption && !selectedLowballOption.isOther) {
                return;
            }
            if (payload.value === '') {
                selectedLowballOption.labelSubtext = undefined;
                this.state.submitDisabled = true;
                return;
            }
            var offerValue = currencyUtil.parseFloat(payload.value);
            var amountOffValue = priceValue - offerValue;
            if (amountOffValue <= 0) {
                selectedLowballOption.percentOff = undefined;
                selectedLowballOption.labelSubtext = undefined;
            } else {
                var percentOff = amountOffValue / priceValue * 100;
                selectedLowballOption.percentOff = percentOff;
                selectedLowballOption.labelSubtext = tokenReplace(copyText.get('lowballOptionAmountOff'), {
                    amountOff: intelligentFormat(amountOffValue, currency),
                    percentOff: currencyUtil.format(percentOff, 0)
                });
            }
            this.state.submitDisabled = false;
            // Reset errors after each change
            this.clearErrors();
        }
    }, {
        key: 'startAuth',
        value: function startAuth() {
            this.state.isOpened = false;
            this.emitChange();
        }
    }, {
        key: 'doneAuth',
        value: function doneAuth(_ref4) {
            var user = _ref4.user;

            Object.assign(this.state, {
                isOpened: true,
                user: user
            });
            this.emitChange();
        }
    }, {
        key: 'clearErrors',
        value: function clearErrors() {
            this.state.errors = {};
            this.emitChange();
        }
    }, {
        key: 'validateForm',
        value: function validateForm(payload) {
            this.clearErrors();
            this.state.errors = mapValues(payload.errors, function (err) {
                return err.message;
            });
            this.emitChange();
        }
    }, {
        key: 'setChatEvents',
        value: function setChatEvents(_ref5) {
            var chatSuccessEvent = _ref5.chatSuccessEvent,
                chatAbandonEvent = _ref5.chatAbandonEvent;

            Object.assign(this.state, { chatSuccessEvent: chatSuccessEvent, chatAbandonEvent: chatAbandonEvent });
        }
    }, {
        key: 'setOptimizely',
        value: function setOptimizely(payload) {
            Object.assign(this.state, payload);
            this.emitChange();
        }
    }, {
        key: 'updateModalHeader',
        value: function updateModalHeader(headerCopy) {
            Object.assign(this.state, { modalheader: headerCopy });
            this.emitChange();
        }
    }, {
        key: 'reset',
        value: function reset() {
            Object.assign(this.state, {
                isLoading: true,
                isSending: false,
                isSendComplete: false,
                isServerError: false,
                isShowLowBallWarning: false,
                lowballOptions: [],
                selectedLowballOption: undefined,
                offerSent: false,
                isMessageEnabled: false,
                isOfferEnabled: false,
                submitDisabled: false,
                modalHeader: '',
                sellerCompany: '',
                errors: {},
                formSubmitted: false,
                chatSuccessEvent: null,
                chatAbandonEvent: null
            });
            this.emitChange();
        }
    }, {
        key: '_toggleField',
        value: function _toggleField(field) {
            this.state[field] = !this.state[field];
            this.emitChange();
        }
    }, {
        key: '_setBaseModalHeader',
        value: function _setBaseModalHeader() {
            this.state.modalHeader = tokenReplace(this.state.copyText.get('header'), {
                dealer: this.state.sellerCompany
            });
        }
    }]);

    return ContactUIStore;
}(BaseStore);

ContactUIStore.storeName = 'ContactUIStore';
ContactUIStore.handlers = {
    'contact:modal:open': 'openModal',
    'contact:modal:close': 'closeModal',
    'contact:loading:start': 'startLoading',
    'contact:loading:done': 'doneLoading',
    'contact:sending:start': 'startSending',
    'contact:sending:done': 'doneSending',
    'contact:userToUser:loading:done': 'doneLoadingUserToUser',
    'contact:serverError': 'serverError',
    'contact:showOptIn': 'showOptIn',
    'contact:offer:toggle': 'toggleOffer',
    'contact:message:toggle': 'toggleMessage',
    'contact:form:lowBall:show': 'showLowBall',
    'contact:form:lowBall:hide': 'hideLowBall',
    'contact:form:makeOffer:hide': 'hideMakeOffer',
    'contact:form:lowball:options:init': 'initLowballOptions',
    'contact:form:lowball:options:set': 'setLowballOption',
    'contact:form:lowball:options:offer': 'setLowballOfferDiscount',
    'contact:auth:start': 'startAuth',
    'contact:auth:done': 'doneAuth',
    'contact:form:validated': 'validateForm',
    'contact:chat:setEvents': 'setChatEvents',
    'contact:reset': 'reset',
    'contact:optimizely:setOptimizely': 'setOptimizely'
};

module.exports = ContactUIStore;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseStore = __webpack_require__(13);
var ContactDealerMessage = __webpack_require__(238);
var User = __webpack_require__(15);
var Price = __webpack_require__(66);
var contactHelpers = __webpack_require__(106);
var enabler = __webpack_require__(64);

var ContactMessageStore = function (_BaseStore) {
    _inherits(ContactMessageStore, _BaseStore);

    function ContactMessageStore(dispatcher) {
        _classCallCheck(this, ContactMessageStore);

        var _this = _possibleConstructorReturn(this, (ContactMessageStore.__proto__ || Object.getPrototypeOf(ContactMessageStore)).call(this, dispatcher));

        _this.reset();
        return _this;
    }

    _createClass(ContactMessageStore, [{
        key: 'reset',
        value: function reset() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.message = new ContactDealerMessage(null, options);
        }
    }, {
        key: 'doneLoading',
        value: function doneLoading(payload) {
            var user = payload.user,
                item = payload.item,
                seller = payload.seller,
                copyText = payload.copyText,
                isNetPrice = payload.isNetPrice;

            var canRequestNetPrice = false;
            this.reset({ isNetPrice: isNetPrice });
            if (user) {
                this.message.setFromUser(user);
                canRequestNetPrice = User.canRequestNetPrice();
            }
            if (item) {
                var uploadedNetPrice = item.getPriceByType(Price.TYPE_NET);
                var showingUploadedNetPrice = uploadedNetPrice && item.isFurniture() && canRequestNetPrice && enabler.isEnabled('enable_net_price');
                this.message.setItem(item);
                if (!showingUploadedNetPrice) {
                    if (copyText.get('hardcodedTextBody', { passthrough: false })) {
                        this.message.set('textBody', copyText.get('hardcodedTextBody'));
                    } else if (item.isPriceHidden()) {
                        this.message.set('textBody', copyText.get('pretextPur'));
                    }
                }
                this.message.set('subject', contactHelpers.constructItemSubject({
                    prefix: copyText.get('subjectItem'),
                    item: item
                }));
            } else if (seller) {
                this.message.setSeller(seller);
                this.message.set('subject', copyText.get('subjectDealer'));
            }
            this.emitChange();
        }
    }, {
        key: 'editField',
        value: function editField(payload) {
            this.message.set(payload.field, payload.value);
            this.emitChange();
        }
    }, {
        key: 'editOptIn',
        value: function editOptIn(payload) {
            var from = this.message.get('from');
            if (from) {
                from.setDiscloseEmail(payload.isOptIn);
            }
            this.emitChange();
        }
    }, {
        key: 'userAuth',
        value: function userAuth(payload) {
            this.message.set('from.user', payload.user);
            this.emitChange();
        }
    }, {
        key: 'prepareToSend',
        value: function prepareToSend() {
            var isUserToUser = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (!isUserToUser) {
                if (this.message.get('from.user.id')) {
                    return;
                }
                var userId = User.getUserId(true);
                if (userId) {
                    this.message.set('from.user.id', userId);
                }
            }
        }
    }]);

    return ContactMessageStore;
}(BaseStore);

ContactMessageStore.storeName = 'ContactMessageStore';
ContactMessageStore.handlers = {
    'contact:loading:start': 'reset',
    'contact:message:fieldEdited': 'editField',
    'contact:loading:done': 'doneLoading',
    'contact:optIn:edited': 'editOptIn',
    'contact:auth:done': 'userAuth',
    'contact:sending:start': 'prepareToSend'
};

module.exports = ContactMessageStore;

/***/ })

},[4318]);


// WEBPACK FOOTER //
// home.es.4d87d98b843e07c5a147.js